import React, { useEffect, useState, useMemo, useCallback, createContext, useContext, useRef, useLayoutEffect } from 'react';
import * as Coveo$1 from 'coveo-search-ui';
import { state, $$, get, DynamicFacet, DynamicHierarchicalFacet, Facet as Facet$1, init, initSearchbox, Logger as Logger$1, SearchEndpoint, AnalyticsEvents, Initialization, ComponentOptions, InitializationEvents, Component } from 'coveo-search-ui';
import { elementAttributesToProps, propsToDataAttributes } from '@tr-digital/react-rehydrate';
import moment from 'moment';
import 'moment/locale/fr.js';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import ReactDOMServer from 'react-dom/server';
import { createPortal } from 'react-dom';
import { PersonalizedRecommendations, PersonalizedRecommendationsTypes } from '@dcl-ue/personalized-recommendations';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@import url(\"https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@100;200;300;400;500;600;700;900&display=swap\");\n\n:root {\n  /* Generic */\n  --tr-coveo-font-weight-light: 300;\n  --tr-coveo-font-weight-regular: 400; /* 1 */\n  --tr-coveo-font-weight-medium: 500;\n  --tr-coveo-font-weight-bold: 700;\n  --tr-coveo-font-weight-black: 900;\n  --tr-coveo-text-decoration-none: none;\n  --tr-coveo-z-index-1: 1;\n  --tr-coveo-unset: unset;\n  --tr-coveo-bold: bold;\n  --tr-coveo-normal: normal;\n  --tr-coveo-inherit: inherit;\n  --tr-coveo-0: 0; /* for padding, margin */\n  --tr-coveo-font-family: \"Knowledge2017, Helvetica Neue, Arial\";\n  --tr-coveo-font-family-clario: \"Clario\", sans-serif;\n  --tr-coveo-font-family-S3: \"Source Sans 3\", sans-serif;\n\n  /* Colors */\n  --tr-coveo-color-tr-orange: rgb(250, 100, 0); /* =#fa6400 */\n  --tr-coveo-color-tr-orange-400: rgb(214, 64, 0); /* =#D640000 */\n  --tr-coveo-color-tr-orange-light-400: rgb(248, 234, 221); /* =#F8EADD */\n  --tr-coveo-color-tr-racing-green: rgb(18, 48, 33); /* =#123021 */\n  --tr-coveo-color-tr-default: rgb(242, 242, 242); /* =#F2F2F2 */\n  --tr-coveo-color-tr-orange-light: rgb(255, 217, 191); /* =#ffD9BF */\n  --tr-coveo-color-tr-orange-dark-shade-20: rgb(220, 67, 0); /* =#dc4300 */\n  --tr-coveo-color-tr-blue-dark: rgb(0, 93, 162); /* =#005da2 */\n  --tr-coveo-color-tr-gray-dark: rgb(64, 64, 64); /* =#404040 */\n  --tr-coveo-color-tr-gray: rgb(136, 136, 136); /* =#888 */\n  --tr-coveo-color-medium-grey:\n    rgb(\n      151,\n      151,\n      151\n    ); /* Color not in dcl-ui vars */\n\n  --tr-coveo-color-tr-gray-muted: rgb(208, 208, 208); /* =#d0d0d0 */\n  --tr-coveo-color-tr-gray-lighter: rgb(234, 234, 234); /* =#eaeaea */\n  --tr-coveo-color-tr-gray-lightest: rgb(244, 244, 244); /* =#f4f4f4 */\n  --tr-coveo-color-tr-white: rgb(255, 255, 255); /* =#fff */\n  --tr-coveo-color-tr-black-100: rgba(0, 0, 0, 1); /* =#000 alpha 100% */\n  --color-tr-gray-medium: rgb(102, 102, 102);\n  --color-tr-gray-light: rgb(175, 175, 175);\n  --tr-help-and-support-meta-tags-color: rgb(115, 115, 115); /* =#737373 */\n  --tr-coveo-color-tr-black: rgb(31, 31, 31); /* =#1f1f1f */\n  --tr-coveo-color-tr-grey: rgb(179, 179, 179); /* #b3b3b3 */\n  --tr-color-interactive-on-tab-active: rgb(0, 64, 112); /* 004070 */\n\n  /* Font sizes */\n  --tr-coveo-font-size-xxxs: calc(1rem * 14 / 16);\n  --tr-coveo-font-size-xxs: calc(1rem * 16 / 16);\n  --tr-coveo-font-size-s: calc(1rem * 21 / 16);\n  --tr-coveo-font-size-m: calc(1rem * 24 / 16);\n  --tr-coveo-font-size-l: calc(1rem * 28 / 16);\n\n  /* ResultsPerPage */\n  --tr-coveo-result-per-page-margin-top: 0.5rem;\n  --tr-coveo-result-per-page-padding-top: 1.5rem;\n  --tr-coveo-result-per-page-display: block;\n\n  /* ResultListSort */\n  --tr-coveo-result-list-sort-padding-sort-button: 0.625rem 0.6rem;\n  --tr-coveo-result-list-sort-padding-sort-option: 0.813rem 1.5rem;\n  --tr-coveo-result-list-sort-mobile-padding-sort-button: 0 0.625rem;\n\n  /* ResultListHelpAndSupport */\n  --tr-coveo-result-list-hs-width-tr-small: 1.188rem;\n\n  /* ResultList */\n  --tr-coveo-result-list-grid-gap: 1rem;\n  --tr-coveo-result-list-margin-line: 0 1.125rem;\n  --tr-coveo-result-list-line-height-medium: 1.5;\n  --tr-coveo-new-branding-result-list-line-height-medium: 125%;\n  --tr-coveo-result-list-description-gap: 0.75rem;\n\n  /* ResultListLegalScoped */\n  --margin-result-list-duration-row: 1rem 0 2.188rem;\n\n  /* ResultListStore */\n  --tr-coveo-result-list-store-line-height-x: 130%;\n  --tr-coveo-new-branding-result-list-store-line-height-x: 120%;\n  --tr-coveo-result-list-store-margin-tr-m: 0 0 0.75rem;\n  --tr-coveo-result-list-store-author-margin: 0 0.225rem 0 0.225rem;\n  --tr-coveo-result-list-store-author-margin-xs: 0 0 0.2rem;\n\n  /* CoveoTab */\n  --tr-coveo-tab-section-height: 2.5rem;\n  --tr-coveo-tab-section-selected-border-size: 0.25rem;\n  --tr-coveo-tab-section-container-left-gap: 1.5rem;\n\n  /* Pager */\n  --tr-coveo-pager-padding-item: 0.125rem;\n\n  /* NoSearchResult */\n  --tr-coveo-no-search-results-margin-top: calc(30rem / 16);\n  --tr-coveo-no-search-results-header-line-height: calc(48rem / 16);\n  --tr-coveo-no-search-results-header-font-size: calc(42rem / 16);\n  --tr-coveo-no-search-results-header-font-weight:\n    var(\n      --tr-coveo-font-weight-black\n    );\n  --tr-coveo-no-search-results-header-line-height-m: calc(34rem / 16);\n  --tr-coveo-no-search-results-header-font-size-m: calc(28rem / 16);\n  --tr-coveo-no-search-results-icon-size: calc(72rem / 16);\n  --tr-coveo-no-search-results-icon-size-m: calc(38rem / 16);\n  --tr-coveo-no-search-results-icon-margin-right: calc(20rem / 16);\n  --tr-coveo-no-search-results-tip-text-font-size: calc(18rem / 16);\n  --tr-coveo-no-search-results-tip-text-line-height: calc(26rem / 16);\n  --tr-coveo-no-search-results-heading-bottom-font-size: calc(24rem / 16);\n  --tr-coveo-no-search-results-heading-bottom-line-height: calc(28rem / 16);\n  --tr-coveo-no-search-results-heading-bottom-margin:\n    calc(30rem / 16) 0\n    calc(10rem / 16) 0;\n  --tr-coveo-no-search-results-message-red: #a00000;\n\n  /* Facet */\n  --tr-coveo-facet-padding-size-xs: 0.25rem;\n  --tr-coveo-facet-padding-size-xm: 0.813rem 0;\n  --tr-coveo-facet-padding-size-md: 0.625rem;\n  --tr-coveo-facet-margin-size-xl: 6.25rem;\n  --tr-coveo-facet-margin-facet: 0 0.625rem;\n  --tr-coveo-facet-with-size-s: 1.625rem;\n  --tr-coveo-facet-border-xl: 0.121rem;\n  --tr-coveo-facet-z-index-x: 100;\n  --tr-coveo-facet-margin: 0 34px;\n  --tr-coveo-facet-padding: 10px 34px;\n\n  /* Breadcrumb */\n  --tr-coveo-breadcrumb-filter-border-radius: calc(11.5rem / 16);\n  --tr-coveo-breadcrumb-filter-font-size: calc(12rem / 16);\n  --tr-coveo-breadcrumb-filter-font-weight: var(--tr-coveo-font-weight-medium);\n  --tr-coveo-breadcrumb-filter-line-height: calc(14rem / 16);\n  --tr-coveo-breadcrumb-filter-padding: calc(5rem / 16) calc(10rem / 16);\n  --tr-coveo-breadcrumb-label-font-size: calc(14rem / 16);\n  --tr-coveo-breadcrumb-label-line-height: calc(18rem / 16);\n  --tr-coveo-breadcrumb-row-height: calc(32rem / 16);\n  --tr-coveo-breadcrumb-row-padding: calc(6rem / 16);\n\n  /* SearchResult */\n  --tr-coveo-header-font-size: calc(32rem / 16);\n  --tr-coveo-searchresult-font-size: 1rem;\n  --tr-coveo-searchresultline-height: 1.375rem;\n  --tr-coveo-header-font-weight: 900;\n  --tr-coveo-header-line-height: calc(38rem / 16);\n  --tr-coveo-header-text-margin: 0 0 calc(8rem / 16) 0;\n  --tr-coveo-header-margin: calc(30rem / 16) 0 calc(15rem / 16) calc(10rem / 16);\n  --tr-coveo-label-font-size: calc(14rem / 16);\n  --tr-coveo-label-line-height: calc(18rem / 16);\n  --tr-coveo-filter-button-padding:\n    calc(20rem / 16) 0 calc(17rem / 16)\n    calc(15rem / 16);\n  --tr-coveo-filter-line-height: calc(22rem / 16);\n  --tr-coveo-filter-border-color: rgb(227, 227, 227);\n\n  /* SearchBox */\n  --tr-coveo-searchbox-font-size: 1rem;\n  --tr-coveo-searchbox-height-searchbox: 3.563rem;\n  --tr-coveo-searchbox-z-index-buttons: 1;\n  --tr-coveo-searchbox-z-index-buttons-expanded: 1;\n  --tr-coveo-searchbox-padding-suggestion: 0.75rem 1.125rem;\n  --tr-coveo-searchbox-arabic-site-padding: 0.75rem 0.75rem 0.75rem 3.0625rem;\n  --tr-coveo-searchbox-padding-searchbox-sticky: 1.5rem;\n  --tr-coveo-searchbox-z-index-500: 500;\n  --tr-coveo-searchbox-margin-3: 3rem;\n  --tr-coveo-searchbox-padding-1: 1rem;\n  --tr-coveo-searchbox-padding-8: 8rem;\n  --tr-coveo-searchbox-auto: auto;\n  --tr-coveo-searchbox-margin-2: 2.938rem;\n  --tr-coveo-searchbox-margin-0: 0;\n  --tr-coveo-searchbox-max-width: 50rem;\n  --tr-coveo-searchbox-dropdown-margin: 0 0.5rem 0.3rem 0;\n  --tr-coveo-searchbox-dropdown-padding: 0.625rem 1rem;\n  --tr-coveo-searchbox-dropdown-padding-mobile: 1.3rem 0.625rem;\n  --tr-coveo-searchbox-dropdown-min-width: 2.5rem;\n  --tr-coveo-searchbox-dropdown-line-height: 1.5rem;\n  --tr-coveo-searchbox-dropdown-content-min-width: 12.5rem;\n  --tr-coveo-searchbox-border-radius-0: 0;\n  --tr-coveo-searchbox-border-radius-4: 0.25rem;\n  --tr-coveo-searchbox-border-radius-8: 0.5rem;\n  --tr-coveo-searchbox-dropdown-padding-link: 0.5rem;\n  --tr-coveo-searchbox-dropdown-margin-link: 0.125rem 0;\n  --tr-coveo-searchbox-dropdown-top: 3rem;\n  --tr-coveo-searchbox-dropdown-left: 0;\n  --tr-coveo-searchbox-dropdown-z-index: 2;\n  --tr-coveo-searchbox-megamenu-padding: 0.5625rem;\n  --tr-coveo-searchbox-megamenu-margin-top: 40px;\n\n  /* SearchResultPI */\n  --tr-coveo-pi-template-margin: 0.625rem;\n  --tr-coveo-search-result-pi-font-size-title: 1.3125rem;\n  --tr-coveo-search-result-pi-short-description-font-size: 1rem;\n  --tr-coveo-search-result-pi-subcategories-font-size: 0.875rem;\n  --tr-coveo-search-result-pi-list-line-margin: 1rem 0;\n  --tr-coveo-search-result-pi-card-line-margin: 0.5rem 0 0.75rem 0;\n  --tr-coveo-search-result-card-padding: 2.5rem 1.5rem 1.5rem 1.5rem;\n  --tr-coveo-card-pi-margin: 1rem 0;\n  --tr-coveo-search-result-pi-list-button-padding: 0.5rem 1.5rem;\n  --tr-coveo-search-result-pi-card-button-padding: 0.5rem 3.15625rem;\n  --tr-coveo-search-result-pi-button-font-size: 1.1875rem;\n  --tr-coveo-search-result-pi-box-shadow: 0 0.25rem 0.75rem;\n  --tr-coveo-search-result-pi-box-shadow-hover: 0 0.5rem 1rem;\n  --tr-coveo-search-result-pi-button-line-height: 1.5rem;\n  --tr-coveo-search-result-pi-template-padding: 1.5rem;\n  --tr-coveo-search-result-pi-button-margin-top: 1.75rem;\n\n  /* SearchResultPIBadge */\n  --tr-coveo-search-result-pi-badge-font-size: 0.75rem;\n  --tr-coveo-search-result-pi-badge-padding: 0.5rem;\n  --tr-coveo-search-result-pi-badge-border-radius: 0 0 0.5rem 0.5rem;\n\n  /* HelpAndSupport Badge Component */\n  --tr-help-and-support-badge-padding: 0.25em 0.5em;\n  --tr-help-and-support-internal-use-badge-color: rgb(220, 10, 10);\n  --tr-help-and-support-internal-use-badge-background-color: rgb(255, 237, 237);\n  --tr-help-and-support-signup-required-color: rgb(0, 93, 162);\n  --tr-help-and-support-signup-required-badge-background-color:\n    rgb(\n      229,\n      244,\n      255\n    );\n\n  /* Presonalize Recommendation */\n  --tr-coveo-search-results-recommendation-head-font-size: calc(18rem / 16);\n  --tr-coveo-search-results-recommendation-font-family: \"Source Sans 3\";\n  --tr-coveo-search-results-recommendation-heading-font-size: calc(24rem / 16);\n}\n";
styleInject(css_248z);

// Only edit when no config provided
if (!global.emcmUiConfig) {
  global.emcmUiConfig = {
    styles: {
      namespace: 'tr'
    }
  };
}

var SearchPageUriEnum;
(function (SearchPageUriEnum) {
  SearchPageUriEnum["V2_ENV"] = "https://platform.cloud.coveo.com/rest/search";
  SearchPageUriEnum["EU"] = "https://platform-eu.cloud.coveo.com/rest/search";
  SearchPageUriEnum["AU"] = "https://platform-au.cloud.coveo.com/rest/search";
  SearchPageUriEnum["HIPPA"] = "https://platformhipaa.cloud.coveo.com/rest/search";
})(SearchPageUriEnum || (SearchPageUriEnum = {}));
var ApigeeEnvironmentEnum;
(function (ApigeeEnvironmentEnum) {
  ApigeeEnvironmentEnum["QA"] = "https://api-test.thomsonreuters.com/coveo/search/v1/qa/token";
  ApigeeEnvironmentEnum["UAT"] = "https://api-test.thomsonreuters.com/coveo/search/v1/uat/token";
  ApigeeEnvironmentEnum["PPE"] = "https://api-uat.thomsonreuters.com/coveo/search/v1/ppe/token";
  ApigeeEnvironmentEnum["PROD"] = "https://api.thomsonreuters.com/coveo/search/v1/token";
})(ApigeeEnvironmentEnum || (ApigeeEnvironmentEnum = {}));
var SearchAnalyticsUriEnum;
(function (SearchAnalyticsUriEnum) {
  SearchAnalyticsUriEnum["NON_HIPPA"] = "https://analytics.cloud.coveo.com/rest/ua";
  SearchAnalyticsUriEnum["HIPPA"] = "https://analytics.orghipaa.coveo.com/rest/ua/";
})(SearchAnalyticsUriEnum || (SearchAnalyticsUriEnum = {}));
var ResultCountEnum;
(function (ResultCountEnum) {
  ResultCountEnum["RIGHT_PANEL"] = "right-panel";
  ResultCountEnum["MAIN_PANEL"] = "main-panel";
})(ResultCountEnum || (ResultCountEnum = {}));
var VideoDurationType;
(function (VideoDurationType) {
  VideoDurationType["HOURS"] = "hr";
  VideoDurationType["MINUTES"] = "min";
  VideoDurationType["SECONDS"] = "sec";
})(VideoDurationType || (VideoDurationType = {}));
var VideoPlayerType;
(function (VideoPlayerType) {
  VideoPlayerType["KALTURA"] = "kalturaPlayer";
  VideoPlayerType["DEFAULT"] = "default";
})(VideoPlayerType || (VideoPlayerType = {}));
var ResultListPaletteType;
(function (ResultListPaletteType) {
  ResultListPaletteType["DEFAULT"] = "default";
  ResultListPaletteType["STORE"] = "store";
  ResultListPaletteType["HELP_AND_SUPPORT"] = "help-and-support";
  ResultListPaletteType["HELP_AND_SUPPORT_SEARCH"] = "help-and-support-search";
  ResultListPaletteType["HELP_AND_SUPPORT_VIDEO"] = "help-and-support-video";
  ResultListPaletteType["HELP_AND_SUPPORT_MIXED"] = "help-and-support-mixed";
  ResultListPaletteType["HELP_AND_SUPPORT_KALTURA_VIDEO"] = "help-and-support-kaltura-video";
  ResultListPaletteType["HELP_AND_SUPPORT_CUSTOM_PLAYER_MIXED"] = "help-and-support-custom-player-mixed";
  ResultListPaletteType["HELP_AND_SUPPORT_PDF"] = "help-and-support-pdf";
  ResultListPaletteType["LEGAL"] = "legal";
  ResultListPaletteType["LEGAL_SCOPED"] = "legal-scoped";
  ResultListPaletteType["LEGAL_SCOPED_RIGHT_IMAGE"] = "legal-scoped-right-image";
  ResultListPaletteType["LEGAL_SCOPED_CARD"] = "legal-scoped-card";
  ResultListPaletteType["INTERNATIONAL_STORE"] = "international-store";
  ResultListPaletteType["LOCATIONS"] = "locations";
  ResultListPaletteType["PRODUCT_TRAINING"] = "product-training";
  ResultListPaletteType["CARDS"] = "cards";
  ResultListPaletteType["RIGHT_IMAGE"] = "right-image";
  ResultListPaletteType["SCOPED"] = "scoped";
  ResultListPaletteType["CANADA_STORE"] = "canada-store";
  ResultListPaletteType["LIST_PI"] = "list-pi";
})(ResultListPaletteType || (ResultListPaletteType = {}));
var ResultCardPaletteType;
(function (ResultCardPaletteType) {
  ResultCardPaletteType["DEFAULT"] = "default";
  ResultCardPaletteType["CARD_PI"] = "card-pi";
})(ResultCardPaletteType || (ResultCardPaletteType = {}));
var ResultTypeEnum;
(function (ResultTypeEnum) {
  ResultTypeEnum["LIST"] = "list";
  ResultTypeEnum["CARD"] = "card";
})(ResultTypeEnum || (ResultTypeEnum = {}));
var FacetStyleType;
(function (FacetStyleType) {
  FacetStyleType["DEFAULT"] = "default";
  FacetStyleType["PLAIN"] = "plain";
})(FacetStyleType || (FacetStyleType = {}));
var FacetTypesEnum;
(function (FacetTypesEnum) {
  FacetTypesEnum["COVEO_DYNAMIC_FACET"] = "CoveoDynamicFacet";
  FacetTypesEnum["COVEO_HIERARCHICAL_FACET"] = "CoveoHierarchicalFacet";
  FacetTypesEnum["COVEO_DYNAMIC_HIERARCHICAL_FACET"] = "CoveoDynamicHierarchicalFacet";
  FacetTypesEnum["COVEO_DYNAMIC_FACET_RANGE"] = "CoveoDynamicFacetRange";
})(FacetTypesEnum || (FacetTypesEnum = {}));
var FacetModalSizeType;
(function (FacetModalSizeType) {
  FacetModalSizeType["DEFAULT"] = "default";
  FacetModalSizeType["FULL_SCREEN"] = "full screen";
})(FacetModalSizeType || (FacetModalSizeType = {}));
var SearchBoxActionType;
(function (SearchBoxActionType) {
  SearchBoxActionType["DEFAULT"] = "default";
  SearchBoxActionType["BUTTON"] = "button";
  SearchBoxActionType["ICON"] = "icon";
  SearchBoxActionType["WITHOUT_INPUT"] = "withoutInput";
  SearchBoxActionType["DARK"] = "dark";
  SearchBoxActionType["DROPDOWN"] = "dropdown";
})(SearchBoxActionType || (SearchBoxActionType = {}));
var SearchBoxAlignment;
(function (SearchBoxAlignment) {
  SearchBoxAlignment["LEFT"] = "left";
  SearchBoxAlignment["center"] = "center";
})(SearchBoxAlignment || (SearchBoxAlignment = {}));
var PagerStyleType;
(function (PagerStyleType) {
  PagerStyleType["DEFAULT"] = "default";
  PagerStyleType["MODIFIED"] = "modified";
})(PagerStyleType || (PagerStyleType = {}));
var ResultsPerPageStyleType;
(function (ResultsPerPageStyleType) {
  ResultsPerPageStyleType["DEFAULT"] = "default";
  ResultsPerPageStyleType["PLAIN"] = "plain";
})(ResultsPerPageStyleType || (ResultsPerPageStyleType = {}));
var FormatEnum;
(function (FormatEnum) {
  FormatEnum["PDF"] = "PDF";
  FormatEnum["VIDEO"] = "VIDEO";
  FormatEnum["ARTICLE"] = "ARTICLE";
})(FormatEnum || (FormatEnum = {}));
var DateFormatEnum;
(function (DateFormatEnum) {
  DateFormatEnum["SHORT"] = "short";
  DateFormatEnum["WITH_SLASH"] = "with_slash";
})(DateFormatEnum || (DateFormatEnum = {}));
var ProductTrainingFormatEnum;
(function (ProductTrainingFormatEnum) {
  ProductTrainingFormatEnum["PDF"] = "PDF";
  ProductTrainingFormatEnum["VIDEO"] = "Video";
})(ProductTrainingFormatEnum || (ProductTrainingFormatEnum = {}));
var ResultListTypeEnum;
(function (ResultListTypeEnum) {
  ResultListTypeEnum["CARD"] = "card";
  ResultListTypeEnum["LIST"] = "list";
})(ResultListTypeEnum || (ResultListTypeEnum = {}));
var SearchConstant;
(function (SearchConstant) {
  SearchConstant["VENDOR"] = "Coveo";
  SearchConstant[SearchConstant["COVEO_INIT_DELAY"] = 1000] = "COVEO_INIT_DELAY";
  SearchConstant["COVEO_SEARCHBOXES_CLASSNAME"] = "coveoSearchBox";
  SearchConstant[SearchConstant["COVEO_RESULTS"] = 10] = "COVEO_RESULTS";
  SearchConstant["ANALYTICS_SESSION_KEY"] = "ad";
  SearchConstant["COVEO_TAB_REDIRECT_KEY"] = "tabValueBeforeRedirect";
  SearchConstant["INTERNAL_SEARCH_ERROR"] = "internalSearchError";
  SearchConstant["INTEGRATED_MENU_SEARCH"] = "integratedMenuSearch";
  SearchConstant["DEFAULT_SORT_OPTION"] = "relevancy";
  SearchConstant["COVEO_SEARCH_RESULT_ID"] = "searchResult";
  SearchConstant["SEARCH_RESULTS_COMPLETE_EVENT"] = "searchResultsComplete";
  SearchConstant["DICTIONARY_ENDPOINT"] = "https://platform.cloud.coveo.com/rest/search/values/batch";
  SearchConstant["DICTIONARY_KEY"] = "FCT_DICT_DATA";
  SearchConstant[SearchConstant["MAX_VALUES"] = 1000] = "MAX_VALUES";
  // one hour
  SearchConstant[SearchConstant["EXPIRED_TIME"] = 3600000] = "EXPIRED_TIME";
  SearchConstant["TOKEN_KEY"] = "CT";
  SearchConstant["DELIMETER"] = ":";
})(SearchConstant || (SearchConstant = {}));
var CoveoAnalyticsActionsCause;
(function (CoveoAnalyticsActionsCause) {
  CoveoAnalyticsActionsCause["PAGER_NUMBER"] = "pagerNumber";
  CoveoAnalyticsActionsCause["PAGER_NEXT"] = "pagerNext";
  CoveoAnalyticsActionsCause["PAGER_PREVIOUS"] = "pagerPrevious";
  CoveoAnalyticsActionsCause["PAGER_RESIZE"] = "pagerResize";
  CoveoAnalyticsActionsCause["SEARCHBOX_SUBMIT"] = "searchboxSubmit";
  CoveoAnalyticsActionsCause["FACET_SELECT"] = "facetSelect";
  CoveoAnalyticsActionsCause["FACET_SEARCH"] = "facetSearch";
  CoveoAnalyticsActionsCause["RESULTS_SORT"] = "resultsSort";
  CoveoAnalyticsActionsCause["INTERFACE_LOAD"] = "interfaceLoad";
  CoveoAnalyticsActionsCause["INTERFACE_CHANGE"] = "interfaceChange";
  CoveoAnalyticsActionsCause["MEGAMENU_SEARCH_SUBMIT"] = "searchFromLink";
  CoveoAnalyticsActionsCause["MEGAMENU_SEARCH_AUTO_SUGGEST"] = "omniboxFromLink";
  CoveoAnalyticsActionsCause["SEARCHBOX_SUBMIT_AUTO_SUGGEST"] = "omniboxAnalytics";
})(CoveoAnalyticsActionsCause || (CoveoAnalyticsActionsCause = {}));
var Language;
(function (Language) {
  Language["EN"] = "en";
  Language["FR"] = "fr";
  Language["ZH_CN"] = "zh-cn";
  Language["ZH_TW"] = "zh-tw";
  Language["JA"] = "ja";
  Language["PT_BR"] = "pt-br";
  Language["RU"] = "ru";
  Language["ES_ES"] = "es-es";
  Language["KO"] = "ko";
  Language["FI"] = "fi-fi";
  Language["SV"] = "sv-se";
  Language["PL"] = "pl-pl";
  Language["DA"] = "da-dk";
  Language["NO"] = "no-no";
})(Language || (Language = {}));
var Logger;
(function (Logger) {
  Logger["NOTHING"] = "NOTHING";
  Logger["DEBUG"] = "DEBUG";
  Logger["INFO"] = "INFO";
  Logger["WARN"] = "WARN";
  Logger["ERROR"] = "ERROR";
  Logger["TRACE"] = "TRACE";
})(Logger || (Logger = {}));
var Context;
(function (Context) {
  Context["HELP_AND_SUPPORT_IPX"] = "help-and-support-ipx";
})(Context || (Context = {}));
var ContextClass;
(function (ContextClass) {
  ContextClass["HELP_AND_SUPPORT_IPX"] = "tr-coveo-context-hs-ipx-facet";
  ContextClass["EMPTY"] = "";
})(ContextClass || (ContextClass = {}));
var KeyboardEnums;
(function (KeyboardEnums) {
  KeyboardEnums["ARROW_UP"] = "ArrowUp";
  KeyboardEnums["ARROW_DOWN"] = "ArrowDown";
  KeyboardEnums["ENTER_KEY"] = "Enter";
  KeyboardEnums["ESC"] = "Escape";
  KeyboardEnums["TAB"] = "Tab";
})(KeyboardEnums || (KeyboardEnums = {}));
var InitType;
(function (InitType) {
  InitType[InitType["SKIP"] = 0] = "SKIP";
  InitType[InitType["MAIN"] = 1] = "MAIN";
  InitType[InitType["HEADER_AND_FOOTER"] = 2] = "HEADER_AND_FOOTER";
  InitType[InitType["IN_PAGE"] = 3] = "IN_PAGE";
})(InitType || (InitType = {}));
var BadgeType;
(function (BadgeType) {
  BadgeType["NEW_PRODUCT"] = "New product";
  BadgeType["SALE"] = "Sale";
})(BadgeType || (BadgeType = {}));
var BookChipType;
(function (BookChipType) {
  BookChipType["NEW"] = "NEW";
  BookChipType["PRE_SALE"] = "PRE-SALE";
  BookChipType["FRENCH_NEW"] = "NOUVEAU";
  BookChipType["FRENCH_PRE_SALE"] = "PR\xC9-VENTE";
})(BookChipType || (BookChipType = {}));
var CoveoEventNames;
(function (CoveoEventNames) {
  CoveoEventNames["BEFORE_REDIRECT"] = "beforeRedirect";
  CoveoEventNames["NEW_QUERY"] = "newQuery";
  CoveoEventNames["AFTER_INITIALIZATION"] = "afterInitialization";
  CoveoEventNames["DONE_BUILDING_QUERY"] = "doneBuildingQuery";
  CoveoEventNames["NEW_RESULTS_DISPLAYED"] = "newResultsDisplayed";
  CoveoEventNames["NO_RESULTS"] = "noResults";
  CoveoEventNames["QUERY_ERROR"] = "queryError";
  CoveoEventNames["QUERY_SUCCESS"] = "querySuccess";
  CoveoEventNames["PREPROCESS_RESULTS"] = "preprocessResults";
  CoveoEventNames["POPULATE_BREADCRUMB"] = "populateBreadcrumb";
  CoveoEventNames["CHANGE_ANALYTICS_CUSTOM_DATA"] = "changeAnalyticsCustomData";
  CoveoEventNames["BUILDING_QUERY"] = "buildingQuery";
  CoveoEventNames["DEFERRED_QUERY_SUCCESS"] = "deferredQuerySuccess";
  CoveoEventNames["SEARCH_EVENT"] = "CoveoSearchEvent";
})(CoveoEventNames || (CoveoEventNames = {}));
var CoveoEventTypeNames;
(function (CoveoEventTypeNames) {
  CoveoEventTypeNames["GET_MORE_RESULTS"] = "getMoreResults";
})(CoveoEventTypeNames || (CoveoEventTypeNames = {}));
var CoveoSortOptionObj = function CoveoSortOptionObj(value) {
  return [{
    name: 'role',
    value: null
  }, {
    name: 'role',
    value: 'option'
  }, {
    name: 'aria-selected',
    value: value
  }, {
    name: 'id',
    value: 'not-set-combo'
  }];
};
var SortComponentBtnId = 'combo-0';
var DateField;
(function (DateField) {
  DateField["Year"] = "@year";
  DateField["Month"] = "@month";
  DateField["CanPubMonth"] = "@tr_canadastore_publishmonth";
  DateField["EstorePubMonth"] = "@tr_estore_publishmonth";
})(DateField || (DateField = {}));
/**These should match MomentFormatSpecification */
var DateFieldFormat;
(function (DateFieldFormat) {
  DateFieldFormat["Year"] = "YYYY";
  DateFieldFormat["Month"] = "MM";
  DateFieldFormat["Year_month"] = "MMMM YYYY";
  DateFieldFormat["Default"] = "YYYY";
})(DateFieldFormat || (DateFieldFormat = {}));
var DefaultFieldProducts;
(function (DefaultFieldProducts) {
  DefaultFieldProducts["HELPS_WITH"] = "@tr_plp_subcategories";
  DefaultFieldProducts["PRLP_URL"] = "@tr_plp_popurl";
  DefaultFieldProducts["PUBLISHER_NAME"] = "@tr_plp_publishername";
  DefaultFieldProducts["SHORT_DESCRIPTION"] = "@tr_plp_productdescription";
  DefaultFieldProducts["WORKS_WITH"] = "@tr_plp_workswith";
})(DefaultFieldProducts || (DefaultFieldProducts = {}));
var DefaultFieldCanadastore;
(function (DefaultFieldCanadastore) {
  DefaultFieldCanadastore["DESCRIPTION"] = "@tr_canadastore_shortdescription";
})(DefaultFieldCanadastore || (DefaultFieldCanadastore = {}));
var DefaultFieldMKT;
(function (DefaultFieldMKT) {
  DefaultFieldMKT["URI"] = "@uri";
  DefaultFieldMKT["DESCRIPTION"] = "@tr_shortdescription";
})(DefaultFieldMKT || (DefaultFieldMKT = {}));

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var PropsKeys = {
  facet: ['facetData', 'facetIsEnable', 'facetPalette', 'facetDataNumber'],
  pager: ['pagerEnable', 'pagerStyle', 'pagerNumberOfPages', 'pagerMobileNumberOfPages', 'pagerMaxNumberOfPages'],
  resultsPerPage: ['resultsPerPageEnable', 'resultsPerPageStyle', 'resultsPerPageChoices'],
  resultList: ['resultListConfig', 'resultListPalette', 'resultListDefaultImage', 'resultListDateFormat'],
  resultCard: ['resultCardConfig', 'resultCardPalette', 'resultCardDefaultImage'],
  sort: ['sortData', 'sortIsEnable', 'sortIsHidden', 'sortInMobileViewEnable', 'sortEnableDefaultSortCriteria'],
  tab: ['tabEnable', 'tabValue', 'tabId', 'defaultLayout', 'enableArrayTabValue', 'arrayTabValue', 'showTabs', 'shouldKeepTabBarVisibleOnEmptyResults'],
  analytics: ['analyticsEnable', 'analyticsEventMapping', 'analyticsAdobeDefaultEvent', 'analyticsSearchPageTemplate', 'analyticsNoResultSearchPageTemplate'],
  productRecommendation: ['enablePersonalizedRecommendation', 'productRecommendationTitle', 'productRecommendationAnalytics']
};
var getPropsFromObject = function getPropsFromObject(src) {
  return function (keys) {
    return keys ? keys.reduce(function (props, current) {
      if (src.hasOwnProperty(current)) {
        // @ts-expect-error
        props[current] = src[current];
      }
      return props;
    }, {}) : undefined;
  };
};
var flatObject = function flatObject(src) {
  var keys = Object.keys(src);
  return keys.reduce(function (tt, key) {
    if (typeof src[key] === 'object' && !Array.isArray(src[key])) {
      tt = _extends({}, tt, src[key]);
    } else {
      tt[key] = src[key];
    }
    return tt;
  }, {});
};

var createBatchFromFields = function createBatchFromFields(fields, searchHub) {
  return {
    batch: fields.map(function (field) {
      return {
        field: field,
        searchHub: searchHub,
        maximumNumberOfValues: SearchConstant.MAX_VALUES
      };
    })
  };
};
var createDictionary = function createDictionary(_ref) {
  var batch = _ref.batch;
  return batch.flat(2).reduce(function (dictionary, _ref2) {
    var value = _ref2.value;
    var keys = value.split(SearchConstant.DELIMETER);
    keys[0] = keys[0].trim().toLowerCase();
    if (keys.length === 2) {
      dictionary[keys[0]] = keys[1];
    }
    return dictionary;
  }, {});
};
var getDictionary = function getDictionary(session, skipExpirationTime) {
  if (skipExpirationTime === void 0) {
    skipExpirationTime = false;
  }
  var cachedDictionaryData = session.getItem(SearchConstant.DICTIONARY_KEY);
  if (cachedDictionaryData) {
    var _JSON$parse = JSON.parse(cachedDictionaryData),
      expiredTime = _JSON$parse.expiredTime,
      dictionary = _JSON$parse.dictionary;
    if (new Date().getTime() > expiredTime && !skipExpirationTime) {
      return null;
    }
    return dictionary;
  }
  return null;
};
var translateFilters = function translateFilters(filters, session) {
  return filters.map(function (filter) {
    var filterValues = filter.split(SearchConstant.DELIMETER).map(function (value) {
      return value.trim();
    });
    var dictionary = getDictionary(session, true);
    // When we split the value either it should return an array with length === 2
    // Either return the fixed filter values
    if (!dictionary || Array.isArray(filterValues) && filterValues.length !== 2) {
      return filterValues.join(SearchConstant.DELIMETER);
    }
    // filterValues contains: facetCategory and facetValue
    // Example: Sector:Tax-Accounting -> Sector is category and Tax-Accounting is value
    var category = filterValues[0],
      value = filterValues[1];
    return category + ":" + (dictionary[value.toLowerCase()] || value);
  });
};
var filterFieldMappings = function filterFieldMappings(facet) {
  var _facet$facetData;
  return facet == null || (_facet$facetData = facet.facetData) == null ? void 0 : _facet$facetData.map(function (_ref3) {
    var fieldMapping = _ref3.fieldMapping;
    return fieldMapping;
  }).filter(function (value) {
    return value;
  });
};
var getExpiredTime = function getExpiredTime() {
  return new Date().getTime() + SearchConstant.EXPIRED_TIME;
};
var initDictionaryThunk = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(document, session, searchHub) {
    var _document$querySelect, data, facetData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          data = (_document$querySelect = document.querySelector('[data-prop-facet-data]')) == null ? void 0 : _document$querySelect.dataset; // if there won't be propFacetData attribute, then default value shoud be set to null
          facetData = data ? JSON.parse(data['propFacetData'] || 'null') : null;
          if (!(facetData && searchHub !== undefined)) {
            _context.next = 6;
            break;
          }
          _context.next = 6;
          return initDictionary({
            facetData: facetData
          }, searchHub, session);
        case 6:
          _context.next = 11;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function initDictionaryThunk(_x, _x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();
var initDictionary = /*#__PURE__*/function () {
  var _ref5 = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(facet, searchHub, session) {
    var fieldMappings, response, dictionary;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fieldMappings = filterFieldMappings(facet); // To check fieldMappings is Array type
          if (!(Array.isArray(fieldMappings) && !fieldMappings.length || getDictionary(session))) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          _context2.prev = 3;
          _context2.next = 6;
          return fetch(SearchConstant.DICTIONARY_ENDPOINT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: "Bearer " + session.getItem(SearchConstant.TOKEN_KEY)
            },
            body: JSON.stringify(createBatchFromFields(fieldMappings, searchHub))
          });
        case 6:
          response = _context2.sent;
          _context2.t0 = createDictionary;
          _context2.next = 10;
          return response.json();
        case 10:
          _context2.t1 = _context2.sent;
          dictionary = (0, _context2.t0)(_context2.t1);
          session.setItem(SearchConstant.DICTIONARY_KEY, JSON.stringify({
            expiredTime: getExpiredTime(),
            dictionary: dictionary
          }));
          _context2.next = 17;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t2 = _context2["catch"](3);
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 15]]);
  }));
  return function initDictionary(_x4, _x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

var getCoveoSearchPageUri = function getCoveoSearchPageUri(baseUri) {
  if (!baseUri) {
    return SearchPageUriEnum.V2_ENV;
  }
  switch (baseUri) {
    case SearchPageUriEnum.V2_ENV:
      return SearchPageUriEnum.V2_ENV;
    case SearchPageUriEnum.AU:
      return SearchPageUriEnum.AU;
    case SearchPageUriEnum.EU:
      return SearchPageUriEnum.EU;
    case SearchPageUriEnum.HIPPA:
      return SearchPageUriEnum.HIPPA;
    default:
      return SearchPageUriEnum.V2_ENV;
  }
};
var parseFacetState = function parseFacetState(analytics, session) {
  var _facetState, _facetState2;
  if (!analytics) return;
  var _ref = getCachedData(session) || {},
    _ref$facetState = _ref.facetState,
    facetState = _ref$facetState === void 0 ? [] : _ref$facetState;
  var actionCause = analytics.actionCause,
    actionType = analytics.actionType,
    customData = analytics.customData,
    analyticsFacetState = analytics.facetState;
  var _ref2 = customData || {},
    facetTitle = _ref2.facetTitle,
    facetValue = _ref2.facetValue;
  switch (actionCause) {
    case 'facetSelect':
      handleFacetSelect(actionType, facetState, facetTitle, facetValue, analyticsFacetState);
      break;
    case 'facetDeselect':
    case 'facetClearAll':
      facetState = handleFacetDeselect(actionCause, facetState, facetTitle, facetValue);
      break;
    case 'breadcrumbFacet':
      facetState = handleBreadCrumbDeSelect(facetState, facetTitle, facetValue, analyticsFacetState);
      break;
    case 'breadcrumbResetAll':
      facetState = [];
      break;
  }
  facetState = facetState.length ? Array.from(new Set((_facetState = facetState) == null ? void 0 : _facetState.map(function (item) {
    return JSON.stringify({
      title: item.title,
      value: item.value
    });
  }))).map(function (item) {
    return JSON.parse(item);
  }) : facetState;
  cacheNewData(session, {
    facetState: facetState
  });
  return (_facetState2 = facetState) == null ? void 0 : _facetState2.map(function (fs) {
    return fs.title + ":" + fs.value;
  });
};
var handleFacetSelect = function handleFacetSelect(actionType, facetState, facetTitle, facetValue, analyticsFacetState) {
  var _dynamicFacetState$fi;
  if (actionType !== 'dynamicFacet') {
    if (facetTitle && facetValue) {
      facetState.push({
        title: facetTitle,
        value: facetValue
      });
    }
    return;
  }
  var dynamicFacetState = analyticsFacetState == null ? void 0 : analyticsFacetState.map(function (fs) {
    return {
      title: fs == null ? void 0 : fs.title,
      value: fs == null ? void 0 : fs.value
    };
  });
  var newFacets = (_dynamicFacetState$fi = dynamicFacetState == null ? void 0 : dynamicFacetState.filter(function (newItem) {
    return !facetState.some(function (existingItem) {
      return existingItem.title === newItem.title && existingItem.value === newItem.value;
    });
  })) != null ? _dynamicFacetState$fi : [];
  //@ts-ignore
  facetState.push.apply(facetState, newFacets);
};
var handleFacetDeselect = function handleFacetDeselect(actionCause, facetState, facetTitle, facetValue) {
  if (!facetTitle) return facetState;
  var isClearAll = actionCause === 'facetClearAll';
  return facetState.filter(function (item) {
    if (isClearAll) {
      return item.title !== facetTitle;
    }
    return !(item.title === facetTitle && item.value === facetValue);
  });
};
var handleBreadCrumbDeSelect = function handleBreadCrumbDeSelect(facetState, facetTitle, facetValue, analyticsFacetState) {
  if (!facetTitle) return;
  if (facetValue) {
    return facetState.filter(function (item) {
      return !(item.title === facetTitle && item.value === facetValue);
    });
  } else {
    var validFacets = new Set(analyticsFacetState == null ? void 0 : analyticsFacetState.filter(function (fs) {
      return fs.title === facetTitle;
    }).map(function (fs) {
      return fs.title + ":" + fs.value;
    }));
    return facetState.filter(function (item) {
      return item.title !== facetTitle || validFacets.has(item.title + ":" + item.value);
    });
  }
};
var parseAdvanceQuery = function parseAdvanceQuery(analytics, keyedFacets) {
  if (analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_NUMBER || analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_NEXT || analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_PREVIOUS || analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_RESIZE) {
    return;
  }
  if (!keyedFacets) {
    return;
  }
  var str = analytics.advancedQuery;
  if (!str) {
    return [];
  }
  var facets = str.split(') (');
  var result = [];
  for (var _iterator = _createForOfIteratorHelperLoose(facets), _step; !(_step = _iterator()).done;) {
    var facet = _step.value;
    var cleanupValue = facet.replace(/\(|\)/g, '');
    var cleanupFacet = cleanupValue.split('==');
    var facetType = cleanupFacet == null ? void 0 : cleanupFacet[0];
    var facetValue = cleanupFacet == null ? void 0 : cleanupFacet[1];
    //a facetable field can have multiple fields selected.
    var fields = facetValue == null ? void 0 : facetValue.split(',');
    if (!fields) {
      return [];
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(fields), _step2; !(_step2 = _iterator2()).done;) {
      var field = _step2.value;
      var cleanupField = field.replace(/"/g, '');
      result.push(keyedFacets[facetType] + ":" + cleanupField);
    }
  }
  return result;
};
var parseFacet = function parseFacet(analytics, document, session) {
  var parsedFacet = parseFacetState(analytics, session);
  if (!parsedFacet) {
    parsedFacet = parseAdvanceQuery(analytics, parseFacetProp(document));
  }
  return parsedFacet ? translateFilters(parsedFacet, session) : parsedFacet;
};
var cacheNewData = function cacheNewData(session, data, key) {
  if (key === void 0) {
    key = SearchConstant.ANALYTICS_SESSION_KEY;
  }
  var old = getCachedData(session, key);
  var newData = _extends({}, old, data);
  session.setItem(key, JSON.stringify(newData));
  return newData;
};
var getCachedData = function getCachedData(session, key) {
  if (key === void 0) {
    key = SearchConstant.ANALYTICS_SESSION_KEY;
  }
  return JSON.parse(session.getItem(key) || '{}');
};
/**
 * Gets the current sort rule either from the analytics event or from the URL hash.
 * @param analytics - The Coveo analytics event data object.
 * @param window - The global window object.
 * @returns The sort rule string.
 */
var getCurrentSortRule = function getCurrentSortRule(analytics, window) {
  var _analytics$customData;
  if (analytics.actionCause !== CoveoAnalyticsActionsCause.RESULTS_SORT) {
    var _window$location;
    var sort = window == null || (_window$location = window.location) == null || (_window$location = _window$location.hash) == null || (_window$location = _window$location.split('sort=')) == null || (_window$location = _window$location[1]) == null || (_window$location = _window$location.split('&')) == null || (_window$location = _window$location[0]) == null ? void 0 : _window$location.replace(/%20/g, '').replace(/%40/g, '@');
    return sort || SearchConstant.DEFAULT_SORT_OPTION;
  }
  /**
   * resultsSortBy in Custom data is automatically filled by Coveo when the action
   * cause is a results sort interaction
   * @see https://docs.coveo.com/en/1389/build-a-search-ui/standard-actions-and-usage-analytics-reference#sort-query-results
   */
  var str = analytics == null || (_analytics$customData = analytics.customData) == null ? void 0 : _analytics$customData.resultsSortBy;
  return str || SearchConstant.DEFAULT_SORT_OPTION;
};
var parseFacetProp = function parseFacetProp(document) {
  var _document$querySelect, _attributes$dataProp;
  if (!document) {
    return;
  }
  var attributes = (_document$querySelect = document.querySelector('[data-prop-facet-data]')) == null ? void 0 : _document$querySelect.attributes;
  //@ts-ignore
  var facets = attributes == null || (_attributes$dataProp = attributes['data-prop-facet-data']) == null ? void 0 : _attributes$dataProp.value;
  if (!facets) {
    return;
  }
  var parsedFacets = JSON.parse(facets);
  if (!parsedFacets) {
    return;
  }
  var keyedFacets = {};
  for (var _iterator3 = _createForOfIteratorHelperLoose(parsedFacets), _step3; !(_step3 = _iterator3()).done;) {
    var _extends2;
    var facet = _step3.value;
    keyedFacets = _extends({}, keyedFacets, (_extends2 = {}, _extends2[facet.field] = facet.title, _extends2));
  }
  return keyedFacets;
};
var parseSortProp = function parseSortProp(document) {
  var _document$querySelect2, _attributes$dataProp2;
  if (!document) {
    return;
  }
  var attributes = (_document$querySelect2 = document.querySelector('[data-prop-sort-data]')) == null ? void 0 : _document$querySelect2.attributes;
  //@ts-ignore
  var sorts = attributes == null || (_attributes$dataProp2 = attributes['data-prop-sort-data']) == null ? void 0 : _attributes$dataProp2.value;
  if (!sorts) {
    return;
  }
  var parsedSorts = JSON.parse(sorts);
  if (!parsedSorts) {
    return;
  }
  return parsedSorts;
};
/**
 * Gets the string caption used for the current sort rule value
 * @param currentSortRule current sort rule
 * @param sortData authored sort data
 * @returns the caption associated with the selected sort rule.
 */
var mapSortRuleToCaption = function mapSortRuleToCaption(currentSortRule, sortData) {
  var _sortData$filter;
  var removeSpace = function removeSpace(str) {
    return str.replace(/ /g, '');
  };
  var selectedSortObj = sortData == null || (_sortData$filter = sortData.filter(function (sort) {
    return removeSpace(sort.sortCriteria) === currentSortRule;
  })) == null ? void 0 : _sortData$filter[0];
  if (!selectedSortObj) {
    return "no caption for sort rule: " + currentSortRule;
  }
  return selectedSortObj.sortCaption;
};
var isNewSearch = function isNewSearch(analytics, session) {
  var cachedObj = getCachedData(session);
  var isRedirect = cachedObj == null ? void 0 : cachedObj.isRedirect;
  if (isRedirect) {
    cacheNewData(session, {
      isRedirect: false
    });
    return true;
  } else {
    return analytics.actionCause === CoveoAnalyticsActionsCause.SEARCHBOX_SUBMIT && analytics.queryText !== '';
  }
};
var calculatePageNumberAndResultCount = function calculatePageNumberAndResultCount(analytics, window) {
  var _window$digitalData;
  var pageNumber = analytics == null ? void 0 : analytics.pageNumber;
  var count = analytics == null ? void 0 : analytics.numberOfResults;
  var currentResultsCount = window == null || (_window$digitalData = window.digitalData) == null || (_window$digitalData = _window$digitalData.search) == null ? void 0 : _window$digitalData.searchResults;
  if ((analytics == null ? void 0 : analytics.eventValue) === CoveoAnalyticsActionsCause.PAGER_NUMBER || (analytics == null ? void 0 : analytics.eventValue) === CoveoAnalyticsActionsCause.PAGER_NEXT || (analytics == null ? void 0 : analytics.eventValue) === CoveoAnalyticsActionsCause.PAGER_PREVIOUS) {
    var _analytics$customData2;
    pageNumber = analytics == null || (_analytics$customData2 = analytics.customData) == null ? void 0 : _analytics$customData2.pagerNumber;
    count = currentResultsCount;
  } else if ((analytics == null ? void 0 : analytics.eventValue) === CoveoAnalyticsActionsCause.PAGER_RESIZE) {
    pageNumber = 1;
    count = currentResultsCount;
  } else if (count !== 0) {
    pageNumber++;
  }
  return {
    pageNumber: pageNumber,
    count: count
  };
};
var cacheData = function cacheData(session, analytics, data, key) {
  if (key === void 0) {
    key = SearchConstant.ANALYTICS_SESSION_KEY;
  }
  var sessionItem = session.getItem(key);
  var oldData = sessionItem ? JSON.parse(sessionItem) : null;
  if (!oldData) {
    session.setItem(key, JSON.stringify(data));
    return _extends({}, data);
  }
  if (!data) {
    return oldData;
  }
  if (analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_NUMBER || analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_NEXT || analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_PREVIOUS || analytics.actionCause === CoveoAnalyticsActionsCause.PAGER_RESIZE) {
    return _extends({}, oldData, {
      newSearch: data.newSearch
    });
  }
  if (analytics.actionCause === CoveoAnalyticsActionsCause.SEARCHBOX_SUBMIT) {
    var _newData = _extends({}, oldData, {
      searchTerm: data.searchTerm,
      newSearch: data.newSearch,
      sortOption: data.sortOption || oldData.sortOption
    });
    session.setItem(key, JSON.stringify(_newData));
    return _newData;
  }
  if (analytics.actionCause === CoveoAnalyticsActionsCause.RESULTS_SORT) {
    var _newData2 = _extends({}, oldData, {
      sortOption: data.sortOption,
      newSearch: data.newSearch
    });
    session.setItem(key, JSON.stringify(_newData2));
    return _newData2;
  }
  var newData = _extends({}, oldData, data);
  session.setItem(key, JSON.stringify(newData));
  return newData;
};
/**
 * Check sessionStorage value for `interaction` item to see if the value of drop-down has changed.
 * Also, the status field should not be updated if the search was performed on a non-search results page.
 *
 * @param currentText - Current value of dropdown selected option.
 * @param actionCause - The Coveo analytics event data object.
 *
 * @returns empty string `''` if the value is still same or does not exist or provided action cause is valid for drop-down actions;
 *   `changed` otherwise.
 */
var getStatusChange = function getStatusChange(currentText, actionCause) {
  var _JSON$parse = JSON.parse(sessionStorage.getItem('interaction') || '{}'),
    prevText = _JSON$parse.itemText;
  //also return blank if search query was submitted from a non-search page
  if (actionCause === CoveoAnalyticsActionsCause.MEGAMENU_SEARCH_SUBMIT || actionCause === CoveoAnalyticsActionsCause.MEGAMENU_SEARCH_AUTO_SUGGEST || prevText === currentText || !prevText) {
    return '';
  }
  return 'changed';
};
// TODO: This function needs to be refactored. It's doing too many things.
var pushAnalyticsData = function pushAnalyticsData(_ref3) {
  var _window$digitalData$p;
  var coveoAnalyticsEventData = _ref3.coveoAnalyticsEventData,
    searchPageTemplate = _ref3.searchPageTemplate,
    analyticsSearchPageTemplate = _ref3.analyticsSearchPageTemplate,
    noResultSearchPageTemplate = _ref3.noResultSearchPageTemplate,
    analyticsNoResultSearchPageTemplate = _ref3.analyticsNoResultSearchPageTemplate;
  // @ts-ignore
  if (!window.digitalData) {
    // @ts-ignore
    window.digitalData = {};
  }
  if (!coveoAnalyticsEventData || (coveoAnalyticsEventData == null ? void 0 : coveoAnalyticsEventData.actionCause) === CoveoAnalyticsActionsCause.FACET_SEARCH) {
    return false;
  }
  var _calculatePageNumberA = calculatePageNumberAndResultCount(coveoAnalyticsEventData, window),
    pageNum = _calculatePageNumberA.pageNumber,
    searchResults = _calculatePageNumberA.count;
  var parsedFacet = parseFacet(coveoAnalyticsEventData, document, sessionStorage);
  var sortPropData = parseSortProp(document);
  var currentSortRule = getCurrentSortRule(coveoAnalyticsEventData, window);
  var currentSortCaption = mapSortRuleToCaption(currentSortRule, sortPropData);
  var parsedNewSearch = isNewSearch(coveoAnalyticsEventData, sessionStorage);
  var analyticsData = cacheData(sessionStorage, coveoAnalyticsEventData, {
    filters: parsedFacet,
    searchTerm: coveoAnalyticsEventData.queryText,
    sortOption: currentSortCaption,
    newSearch: parsedNewSearch
  });
  //checking if MegaMenu exists inside header
  var megaMenuSearchBoxPresent = isElementPresent('header .search-box-container');
  /**
   * An array of valid CoveoAnalyticsActionsCause values for drop-down actions.
   */
  var validDropDownActionCauses = [CoveoAnalyticsActionsCause.INTERFACE_LOAD, CoveoAnalyticsActionsCause.INTERFACE_CHANGE, CoveoAnalyticsActionsCause.MEGAMENU_SEARCH_SUBMIT, CoveoAnalyticsActionsCause.MEGAMENU_SEARCH_AUTO_SUGGEST];
  /**
   * Check if the CoveoAnalyticsActionsCause in the provided event data is a valid
   * drop-down action cause.
   *
   * @param coveoAnalyticsEventData - The Coveo analytics event data object.
   *
   * @returns `true` if the provided action cause is valid for drop-down actions;
   *   `false` otherwise.
   */
  if (validDropDownActionCauses.includes(coveoAnalyticsEventData.actionCause) && megaMenuSearchBoxPresent) {
    var itemText = coveoAnalyticsEventData.originLevel2;
    if (itemText) {
      var status = getStatusChange(itemText, coveoAnalyticsEventData.actionCause);
      updateDigitalData('interaction', {
        itemText: itemText,
        status: status
      });
      sessionStorage.setItem('interaction', JSON.stringify({
        itemText: itemText,
        status: status
      }));
    }
  } else {
    // @ts-ignore
    if (window.digitalData['interaction']) {
      // @ts-ignore
      window.digitalData['interaction'].status = '';
    }
  }
  var filters = analyticsData.filters,
    searchTerm = analyticsData.searchTerm,
    sortOption = analyticsData.sortOption,
    newSearch = analyticsData.newSearch;
  updateDigitalData('search', {
    filters: filters,
    searchTerm: searchTerm,
    sortOption: sortOption,
    newSearch: newSearch,
    pageNum: pageNum,
    searchResults: searchResults,
    vendor: SearchConstant.VENDOR
  });
  //#region This needs to be moved to its own function and test it properly!
  // @ts-ignore
  if ((_window$digitalData$p = window.digitalData.page) != null && _window$digitalData$p.pageInfo) {
    // @ts-ignore
    window.digitalData.page.pageInfo.pageTemplate = searchResults ? searchPageTemplate || analyticsSearchPageTemplate : noResultSearchPageTemplate || analyticsNoResultSearchPageTemplate;
  }
  //#endregion
  return true;
};
var updateDigitalData = function updateDigitalData(key, value) {
  // @ts-ignore
  window.digitalData[key] = value;
};
var generateRandomString = function generateRandomString() {
  return (Math.random() + 1).toString(36).substring(7);
};
var createDefaultTabId = function createDefaultTabId(tabValue) {
  // ex: @tr_wpagetype=="Blog Posts" -> blog-posts
  if (!tabValue) {
    return '';
  }
  var splitted = tabValue == null ? void 0 : tabValue.split('==');
  var result = 'all';
  if ((splitted == null ? void 0 : splitted.length) === 2) {
    if (splitted[1].split(',').length === 1) {
      var _splitted$;
      result = (_splitted$ = splitted[1]) == null || (_splitted$ = _splitted$.toLowerCase()) == null || (_splitted$ = _splitted$.replace(/ /g, '-')) == null ? void 0 : _splitted$.replace(/"|'/g, '');
    }
  }
  return result;
};
var normalizeHost = function normalizeHost(host) {
  return host.replace(/www\./, '');
};
var isMainSearch = function isMainSearch() {
  for (var _len = arguments.length, urls = new Array(_len), _key = 0; _key < _len; _key++) {
    urls[_key] = arguments[_key];
  }
  var searchPageUrl = urls[0],
    currentUrl = urls[1];
  if (normalizeHost(searchPageUrl.host) !== normalizeHost(currentUrl.host) && !(normalizeHost(searchPageUrl.host) === 'tr.com')) {
    return false;
  }
  var paths = [searchPageUrl.pathname, currentUrl.pathname];
  var _paths$map = paths.map(function (path) {
      return path.replaceAll('.html', '');
    }),
    searchPageUriPath = _paths$map[0],
    currentPath = _paths$map[1];
  // searchPageUri should be subpath of current URL
  return currentPath.includes(searchPageUriPath);
};
var createUrlFromPath = function createUrlFromPath(path) {
  try {
    return new URL(path);
  } catch (e) {
    return new URL(path, 'https://www.tr.com');
  }
};
var getInitType = function getInitType(searchPageUri, currentUrl) {
  if (searchPageUri === void 0) {
    searchPageUri = '';
  }
  // Create a url to get its pathname. There could be a scenario where the searchPageUri
  // can have a query or hash
  var searchPageUrl = createUrlFromPath(searchPageUri);
  if (searchPageUri && searchPageUri !== '/') {
    return isMainSearch(searchPageUrl, currentUrl) ? InitType.MAIN : InitType.HEADER_AND_FOOTER;
  } else {
    return InitType.IN_PAGE;
  }
};
var coveoInitHandler = function coveoInitHandler(searchPageUri, window, shouldRenderSearchBox, status) {
  // Get the type of how we want to init coveo
  var initType = getInitType(searchPageUri, new URL(window.location.href));
  if (initType === InitType.MAIN && !(shouldRenderSearchBox && !status.initSearchPage)) {
    return InitType.SKIP;
  }
  // The array holds the init function of this type: [Page/Header/Footer, Header/Footer, In Page]
  for (var _len2 = arguments.length, initFunctions = new Array(_len2 > 4 ? _len2 - 4 : 0), _key2 = 4; _key2 < _len2; _key2++) {
    initFunctions[_key2 - 4] = arguments[_key2];
  }
  initFunctions[initType - 1]();
  return initType;
};
var getPageType = function getPageType(pageType) {
  if (!pageType || pageType.length === 0) {
    return '';
  }
  var t = pageType[pageType.length - 1].split('|');
  if (!t || t.length === 0) {
    return pageType[0];
  }
  return t[t.length - 1];
};
var setQueryError = function setQueryError(window, setHasError) {
  setHasError(true);
  window.digitalData.page.pageInfo.pageName += ':error';
  window.digitalData.page.pageInfo.pageURL += '#error';
  window.digitalData.page.pageInfo.pageType = 'function_search-results';
  return cacheNewData(sessionStorage, {
    isError: true
  });
};
var getAnalyticsData = function getAnalyticsData(element) {
  var props = elementAttributesToProps(element);
  var data = getPropsFromObject(props)(['adobeDefaultEvent', 'analyticsAdobeDefaultEvent', 'analyticsEventMapping', 'searchPageTemplate', 'analyticsSearchPageTemplate', 'analyticsNoResultSearchPageTemplate', 'noResultSearchPageTemplate']);
  var enable = props.analyticsEnable || props.enableAdobeAnalytics;
  return {
    enable: enable,
    data: data
  };
};
/**
 * Check if a DOM element with a specific class name or ID exists inside in document.
 *
 * @param selector - The class name or ID of the DOM element to check for.
 * @returns Confirms whether a DOM element with the specified class name or ID exists.
 */
var isElementPresent = function isElementPresent(selector) {
  return document.querySelector("" + selector) !== null;
};
// handler for query success which will be triggered only once
var successHandlerThunk = function successHandlerThunk(CoveoInstance, analytics) {
  //checking if MegaMenu exists inside header
  var megaMenuSearchBoxPresent = isElementPresent('header .search-box-container');
  var analyticsEventReadyThunk = function analyticsEventReadyThunk(_, args) {
    var _analytics$data, _analytics$data2;
    var coveoAnalyticsEventData = args == null ? void 0 : args.coveoAnalyticsEventData;
    var adobeDefaultEvent = (analytics == null || (_analytics$data = analytics.data) == null ? void 0 : _analytics$data.adobeDefaultEvent) || (analytics == null || (_analytics$data2 = analytics.data) == null ? void 0 : _analytics$data2.analyticsAdobeDefaultEvent);
    var event = args == null ? void 0 : args.event;
    var shouldTrackAnalytics = pushAnalyticsData(_extends({
      coveoAnalyticsEventData: coveoAnalyticsEventData
    }, analytics.data));
    if (shouldTrackAnalytics) {
      var validActionCauses = [CoveoAnalyticsActionsCause.SEARCHBOX_SUBMIT, CoveoAnalyticsActionsCause.SEARCHBOX_SUBMIT_AUTO_SUGGEST];
      if (validActionCauses.includes(coveoAnalyticsEventData.actionCause) && megaMenuSearchBoxPresent) {
        var _window$_satellite;
        var eventName = SearchConstant.INTEGRATED_MENU_SEARCH;
        (_window$_satellite = window._satellite) == null || _window$_satellite.track(eventName);
      }
      /**
       * Trigger Adobe Analytics tracking only for specific Coveo events.
       *
       * @description Only triggers the adobeDefaultEvent for search-related events:
       * - Direct search events (CoveoEventNames.SEARCH_EVENT)
       * - Custom events with eventType 'getMoreResults' for pagination tracking
       *
       * Other event types (click events, non-search custom events) are excluded
       * to prevent unwanted tracking and maintain analytics data quality.
       *
       * @see {@link https://docs.coveo.com/en/2948/analyze-usage-data/standard-dimensions-reference#getmoreresults}
       * For more details on getMoreResults event tracking and standard dimensions.
       */
      if (event === CoveoEventNames.SEARCH_EVENT || coveoAnalyticsEventData.eventType === CoveoEventTypeNames.GET_MORE_RESULTS) {
        var _window$_satellite2;
        (_window$_satellite2 = window._satellite) == null || _window$_satellite2.track(adobeDefaultEvent);
      }
    }
  };
  var _listener = function listener() {
    CoveoInstance.$$(document.body).on(CoveoInstance.AnalyticsEvents.analyticsEventReady, analyticsEventReadyThunk);
    CoveoInstance.$$(document.body).off(CoveoEventNames.QUERY_SUCCESS, _listener);
  };
  return {
    listener: _listener,
    refHandler: analyticsEventReadyThunk
  };
};
// TODO: the function is doing too many things. It means it doesn't have
// a pure abstraction of function because of having many dependencies.
// After moving all analytics related functions to seperate file,
// we have to seperate the functions and follow SRP.
var initAnalytics = function initAnalytics(CoveoInstance, document) {
  //Search Result Analytics || Search Box Analytics
  var analyticsElement = document.querySelector('div[data-prop-analytics-enable="true"]') || document.querySelector('div[data-prop-enable-adobe-analytics="true"]');
  if (!analyticsElement) {
    return {
      analyticsEnable: false,
      refHandler: function refHandler() {
        return void 0;
      },
      afterInitializationHandler: function afterInitializationHandler() {
        return void 0;
      }
    };
  }
  var analytics = getAnalyticsData(analyticsElement);
  var _successHandlerThunk = successHandlerThunk(CoveoInstance, analytics),
    listener = _successHandlerThunk.listener,
    refHandler = _successHandlerThunk.refHandler;
  var afterInitializationHandler = function afterInitializationHandler() {
    CoveoInstance.$$(document.body).one(CoveoEventNames.QUERY_SUCCESS, listener);
  };
  if (analytics != null && analytics.enable) {
    var root = document.getElementById(SearchConstant.COVEO_SEARCH_RESULT_ID);
    CoveoInstance.$$(root).on(CoveoEventNames.AFTER_INITIALIZATION, afterInitializationHandler);
  }
  return {
    analyticsEnable: analytics == null ? void 0 : analytics.enable,
    refHandler: refHandler,
    afterInitializationHandler: afterInitializationHandler
  };
};
var enhanceCoveoPager = function enhanceCoveoPager(CoveoInstance, document) {
  var mainPageRoot = document.getElementById(SearchConstant.COVEO_SEARCH_RESULT_ID);
  if (mainPageRoot) {
    var refHandler = function refHandler() {
      setTimeout(function () {
        var previousText = document.getElementsByClassName('coveo-pager-previous-icon');
        var nextText = document.getElementsByClassName('coveo-pager-next-icon');
        if (nextText && nextText.length) {
          nextText[0].setAttribute('data-before-content', 'Next'.toLocaleString());
        }
        if (previousText && previousText.length) {
          previousText[0].setAttribute('data-after-content', 'Previous'.toLocaleString());
        }
      }, SearchConstant.COVEO_INIT_DELAY);
    };
    CoveoInstance.$$(mainPageRoot).on(CoveoEventNames.NEW_QUERY, refHandler);
    return {
      element: mainPageRoot,
      refHandler: refHandler
    };
  }
  return {
    element: null,
    refHandler: null
  };
};
var toggleFilters = function toggleFilters() {
  if (document.querySelector('.coveo-facet-dropdown-header')) {
    document.querySelector('.coveo-facet-dropdown-header').click();
  }
};
var removeWhiteSpace = function removeWhiteSpace(value) {
  return String(value).replace(/ /g, '');
};
var getDropdownPlaceholder = function getDropdownPlaceholder(args, sortData) {
  var _args$queryBuilder;
  var sortCriteria = removeWhiteSpace(args == null || (_args$queryBuilder = args.queryBuilder) == null ? void 0 : _args$queryBuilder.sortCriteria);
  var sortValue = sortData == null ? void 0 : sortData.find(function (data) {
    return removeWhiteSpace(data.sortCriteria) === sortCriteria;
  });
  if (sortValue != null && sortValue.sortCaption) {
    return sortValue.sortCaption;
  }
  return 'Relevance'.toLocaleString();
};
var dateFormatToString = function dateFormatToString(date, format) {
  if (format === void 0) {
    format = DateFormatEnum.SHORT;
  }
  var d = new Date(date);
  var ye = new Intl.DateTimeFormat('en', {
    year: 'numeric'
  }).format(d);
  var mo = new Intl.DateTimeFormat('en', {
    month: 'short'
  }).format(d);
  var moNumeric = new Intl.DateTimeFormat('en', {
    month: '2-digit'
  }).format(d);
  var da = new Intl.DateTimeFormat('en', {
    day: '2-digit'
  }).format(d);
  switch (format) {
    case DateFormatEnum.SHORT:
      {
        return mo + " " + da + ", " + ye;
      }
    case DateFormatEnum.WITH_SLASH:
      {
        return da + "/" + moNumeric + "/" + ye;
      }
    default:
      return;
  }
};
var getContext = function getContext(context) {
  switch (context) {
    case Context.HELP_AND_SUPPORT_IPX:
      return {
        css: {
          facet: ContextClass.HELP_AND_SUPPORT_IPX
        }
      };
    default:
      return {
        css: {
          facet: ContextClass.EMPTY
        }
      };
  }
};
var clickOutside = function clickOutside(event, ref, currentState, changeState) {
  var _ref$current;
  if (ref != null && (_ref$current = ref.current) != null && _ref$current.contains(event.target)) {
    return;
  }
  if (currentState) {
    changeState(false);
  }
};
/**
 * Gets the value of the passed attribute based on the attribute's name.
 * @param node html element
 * @param attribute object with the name and value of the attribute
 * @param comboIdIndex index of the current select option element
 * @returns value of the attribute
 */
var getValueByAttributeName = function getValueByAttributeName(node, attribute, comboIdIndex) {
  var name = attribute.name,
    value = attribute.value;
  switch (name) {
    case 'aria-selected':
      return String(node.textContent === value);
    case 'id':
      return "combo-" + comboIdIndex;
    default:
      return value;
  }
};
/**
 * Changes the "role", "aria-selected" and id attributes of sort options elements.
 * @param selector string selector of elements to change their attributes
 * @param attrObj name and value of the elemet attribute
 */
var changeNodeAttributesValue = function changeNodeAttributesValue(selector, attrObj) {
  var nodes = Array.from(document.querySelectorAll(selector) || []);
  if (!nodes.length) return;
  nodes.forEach(function (node, index) {
    attrObj.forEach(function (attribute) {
      var attrValue = getValueByAttributeName(node, attribute, index + 1);
      var name = attribute.name;
      if (attrValue === null) {
        node.removeAttribute(name);
      } else {
        node.setAttribute(name, attrValue);
      }
    });
  });
};
var handleEnterToggle = function handleEnterToggle(context) {
  return function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    if (e.key === 'Enter') {
      var _context$searchboxDro;
      context.handleClick();
      (_context$searchboxDro = context.searchboxDropdown) == null || _context$searchboxDro.toggle();
      var selectedElement = document.querySelector('.coveo-custom-searchbox-dropdown-selected');
      if (selectedElement) {
        selectedElement == null || selectedElement.focus();
      }
    }
  };
};
/**
 * Generates a CSS selector string based on an array of attribute values.
 *
 * @param attributeValues - An array of attribute values to generate selectors for.
 * @returns A CSS selector string.
 * @throws Throws an error if `attributeValues` is not an array.
 */
var generateSelector = function generateSelector(attributeValues) {
  if (!Array.isArray(attributeValues)) {
    throw new Error('attributeValues must be an array');
  }
  var selectors = attributeValues.map(function (value) {
    return ".CoveoDynamicFacet[data-field=\"" + value + "\"] .coveo-checkbox-span-label, .CoveoDynamicHierarchicalFacet[data-field=\"" + value + "\"] .coveo-dynamic-hierarchical-facet-value-label";
  });
  var selectorString = selectors.join(', ');
  return selectorString;
};
/**
 * Retrieves the facet title based on a search text, and optional facet data field values.
 *
 *
 * @param searchText - The search text to match against facet titles.
 * @param args - The HTML element or target for the search operation.
 * @param facetDataField - An optional array of facet data field values to narrow down the search.
 * @returns The facet title matching the search text or an empty string if not found.
 */
var getFacetTitle = function getFacetTitle(searchText, args, facetDataField) {
  var _facetDataField;
  if (facetDataField === void 0) {
    facetDataField = [];
  }
  var selectedAttribute = '.CoveoDynamicFacet  .coveo-checkbox-span-label, .CoveoDynamicHierarchicalFacet coveo-dynamic-hierarchical-facet-value-label';
  if (((_facetDataField = facetDataField) == null ? void 0 : _facetDataField.length) > 0) {
    selectedAttribute = generateSelector(facetDataField);
  }
  var searchInt = document.querySelectorAll(selectedAttribute);
  var facetTitle = '';
  for (var i = 0; i < searchInt.length; i++) {
    var _searchInt$i, _searchText$trim;
    var title = ((_searchInt$i = searchInt[i]) == null ? void 0 : _searchInt$i.getAttribute('title')) || '';
    if ((searchText == null || (_searchText$trim = searchText.trim()) == null ? void 0 : _searchText$trim.toLowerCase()) === (title == null ? void 0 : title.toLocaleLowerCase())) {
      state(args, 'q', '');
      facetTitle = title;
      break;
    }
  }
  return facetTitle;
};
/**
 * Selects a facet value with the specified title and make query search blank.
 *
 * @param facetValue - The title of the facet value to select.
 */
var selectFacet = function selectFacet(facetValue) {
  var coveoFacetValue = $$(document.body).find(".coveo-checkbox-span-label[title=\"" + facetValue + "\"]");
  if (!coveoFacetValue) {
    coveoFacetValue = $$(document.body).find(".coveo-dynamic-hierarchical-facet-value-label[title=\"" + facetValue + "\"]");
  }
  if (coveoFacetValue !== null) {
    var _coveoFacetValue, _facetElement$parentE;
    var facetElement = (_coveoFacetValue = coveoFacetValue) == null || (_coveoFacetValue = _coveoFacetValue.parentElement) == null ? void 0 : _coveoFacetValue.parentElement;
    var dataValue = facetElement == null ? void 0 : facetElement.getAttribute('data-value');
    if (facetElement != null && (_facetElement$parentE = facetElement.parentElement) != null && _facetElement$parentE.parentElement) {
      var _facetElement$parentE2;
      var facetInstance = get(facetElement == null || (_facetElement$parentE2 = facetElement.parentElement) == null ? void 0 : _facetElement$parentE2.parentElement);
      var isFacetInstance = facetInstance instanceof DynamicFacet || facetInstance instanceof DynamicHierarchicalFacet || facetInstance instanceof Facet$1;
      if (facetInstance !== null && dataValue && isFacetInstance) {
        facetInstance.selectValue(dataValue);
      }
    }
  }
};
/*
 * This function performs two things on facet's accessibilty attributes:
 * (1) Change checkbox element's rolw attribute from 'button' to 'checkbox' so screen reader annouces properly
 * (2) On hierarchical facets modifiying aria labels and adding parent's label as prefix so screenreader can annouce it's parent label as well.
 */
function correctFacetAccessibilityAttributes() {
  document.querySelectorAll('li.coveo-facet-value').forEach(function (liElm) {
    var facetCheckboxValue = liElm.querySelector("div.coveo-facet-value-checkbox[role='button']");
    if (facetCheckboxValue) {
      facetCheckboxValue.setAttribute('role', 'checkbox');
      facetCheckboxValue.setAttribute('aria-checked', facetCheckboxValue.getAttribute('aria-pressed') || 'false');
      var captionLabel = liElm.querySelector('span.coveo-facet-value-caption');
      if (captionLabel) {
        var title = captionLabel.getAttribute('title');
        var originalValue = captionLabel.dataset.originalValue;
        var existingDummyCheckboxAriaLabel = facetCheckboxValue.getAttribute('aria-label');
        if (title && originalValue && existingDummyCheckboxAriaLabel) {
          facetCheckboxValue.setAttribute('aria-label', existingDummyCheckboxAriaLabel.replace(title + ";", originalValue + ";"));
        }
      }
    }
  });
}
var setNewSortValue = function setNewSortValue(root, sortValue) {
  state($$(root).find("#" + SearchConstant.COVEO_SEARCH_RESULT_ID), 'sort', sortValue);
};
var handleVideoURIClick = function handleVideoURIClick(target) {
  return function () {
    // Select only Video URI's
    var links = document.body.querySelectorAll(target);
    if (links.length === 0) return;
    links.forEach(function (link) {
      link.onclick = function (e) {
        var _parentElement2, _parentElement3;
        // prevent redirecting to the link
        e.preventDefault();
        e.stopPropagation();
        var parentElement = e.target;
        while (!((_parentElement = parentElement) != null && _parentElement.querySelector('.playkit-icon-play')) && parentElement !== null) {
          var _parentElement;
          // Go up until you reach parent element which contains
          // video player
          parentElement = parentElement.parentElement;
        }
        if (parentElement === null) return;
        var playkitState = parentElement.querySelector('.playkit-tooltip-label');
        var kalturaVideoPlayButton = (_parentElement2 = parentElement) == null ? void 0 : _parentElement2.querySelector('.playkit-icon-play');
        var kalturaVideoActionLayer = (_parentElement3 = parentElement) == null ? void 0 : _parentElement3.querySelector('.playkit-overlay-action');
        if ((playkitState == null ? void 0 : playkitState.innerHTML) === 'Play') {
          // kaltura play icon which is responsible to play the video
          kalturaVideoPlayButton == null || kalturaVideoPlayButton.click();
        }
        // play it in fullscreen when URI was clicked kalturaVideoActionLayer?.dispatchEvent(new Event('mouseup'));
        kalturaVideoActionLayer == null || kalturaVideoActionLayer.dispatchEvent(new Event('mousedown'));
        kalturaVideoActionLayer == null || kalturaVideoActionLayer.dispatchEvent(new Event('mouseup'));
        kalturaVideoActionLayer == null || kalturaVideoActionLayer.dispatchEvent(new Event('mousedown'));
        kalturaVideoActionLayer == null || kalturaVideoActionLayer.dispatchEvent(new Event('mouseup'));
      };
    });
  };
};
/**
 * Gets the fieldname value set with authoring and remove the '@' from it
 * or use the default fieldname.
 * @param fieldObject object with the fieldname set with authoring box
 * @param defaultFieldname default string when no field was authored
 * @returns fieldname string
 */
var getFieldnameString = function getFieldnameString(fieldObject, defaultFieldname) {
  if (fieldObject && fieldObject.field) {
    return fieldObject.field.slice(1);
  }
  return defaultFieldname;
};

var LogConstant;
(function (LogConstant) {
  LogConstant["LOG_PREPEND"] = "*** Coveo ***";
})(LogConstant || (LogConstant = {}));
var UseCoveoLogs;
(function (UseCoveoLogs) {
  UseCoveoLogs["APIGEE_USE_EFFECT"] = "APIGEE useEffect is called";
  UseCoveoLogs["CLOUDV2_USE_EFFECT"] = "Coveo CloudV2 useEffect is called";
  UseCoveoLogs["CONFIGURE_CLOUDV2"] = "Configure Coveo CloudV2 with Token";
  UseCoveoLogs["COVEO_DIRECT_USE_EFFECT"] = "Configure Coveo with Token and Org ID useEffect is called";
  UseCoveoLogs["CONFIGURE_COVEO_DIRECT"] = "Configure Coveo with Token and Org ID Directly";
  UseCoveoLogs["INIT_COVEO_USE_EFFECT"] = "Init Coveo useEffect is called";
  UseCoveoLogs["ANALYTICS_SETUP"] = "Set up adobe analytics";
})(UseCoveoLogs || (UseCoveoLogs = {}));
var SearchBoxLogs;
(function (SearchBoxLogs) {
  SearchBoxLogs["SEARCHBOX_DEFAULT"] = "Rendering SearchBoxDefault";
  SearchBoxLogs["SEARCHBOX_ICON"] = "Rendering SearchBoxIcon";
  SearchBoxLogs["SEARCHBOX_BUTTON"] = "Rendering SearchBoxButton";
  SearchBoxLogs["SEARCHBOX_DARK"] = "Rendering SearchBoxDark";
  SearchBoxLogs["SEARCHBOX_DROPDOWN"] = "Rendering SearchDropDown";
  SearchBoxLogs["SEARCHBOX_WITHOUT_INPUT"] = "Rendering SearchBoxWithoutInput";
  SearchBoxLogs["SEARCHBOX_WITHOUT_INPUT_USE_EFFECT"] = "Call useEffect for SearchBoxWithoutInput";
})(SearchBoxLogs || (SearchBoxLogs = {}));
var SearchResultLogs;
(function (SearchResultLogs) {
  SearchResultLogs["SET_FILTERS_RESULTS_QUERY_TEXT"] = "SearchResult setSelectedFiltersCount, setResultsFound, setQueryText useEffect call";
  SearchResultLogs["SET_TOTAL_COUNT"] = "SearchResult setTotalCount useEffect call";
  SearchResultLogs["USE_SEARCH_RESULT_COVEO"] = "useSearchResultCoveo useEffect call";
  SearchResultLogs["SET_HAS_ERROR"] = "SearchResult setHasError useEffect call";
  SearchResultLogs["RESULT_LIST_SORT"] = "Rendering ResultListSort";
  SearchResultLogs["RESULT_LIST_SORT_USE_EFFECT"] = "ResultListSort useEffect call";
  SearchResultLogs["FACET_PLAIN"] = "Rendering FacetPlain";
  SearchResultLogs["FACET_PLAIN_USE_EFFECT"] = "FacetPlain useEffect call";
  SearchResultLogs["FACET_DEFAULT"] = "Rendering FacetDefault";
  SearchResultLogs["RESULT_LIST_DEFAULT"] = "Rendering ResultListDefault";
  SearchResultLogs["RESULT_LIST_STORE"] = "Rendering ResultListStore";
  SearchResultLogs["RESULT_LIST_HELP_AND_SUPPORT"] = "Rendering ResultListHelpAndSupport";
  SearchResultLogs["RESULT_LIST_LEGAL"] = "Rendering ResultListLegal";
  SearchResultLogs["RESULT_LIST_LEGAL_SCOPED"] = "Rendering ResultListLegalScoped";
  SearchResultLogs["RESULT_LIST_LEGAL_SCOPED_CARD"] = "Rendering ResultListLegalScopedCard";
  SearchResultLogs["RESULT_LIST_LEGAL_SCOPED_RIGHT_IMAGE"] = "Rendering ResultListLegalScopedRightImage";
  SearchResultLogs["RESULT_LIST_INTERNATIONAL_STORE"] = "Rendering ResultListInternationalStore";
  SearchResultLogs["RESULT_LIST_LOCATIONS"] = "Rendering ResultListLocations";
  SearchResultLogs["RESULT_LIST_PRODUCT_TRAINING"] = "Rendering ResultListProductTraining";
  SearchResultLogs["RESULT_LIST_CARDS"] = "Rendering ResultListCards";
  SearchResultLogs["RESULT_LIST_RIGHT_IMAGE"] = "Rendering ResultListRightImage";
  SearchResultLogs["PAGER"] = "Rendering Pager";
  SearchResultLogs["RESULT_LIST_SCOPED"] = "Rendering ResultListScoped";
  SearchResultLogs["RESULT_LIST_CANADA_STORE"] = "Rendering ResultListCanadaStore";
})(SearchResultLogs || (SearchResultLogs = {}));

var SearchLogger = function SearchLogger(loggerLevel) {
  var _this = this;
  this.loggerLevel = Logger.NOTHING;
  this.prepend = LogConstant.LOG_PREPEND;
  this.debug = function (msg) {
    if (_this.loggerLevel === Logger.DEBUG) {
      var _console;
      for (var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }
      (_console = console).debug.apply(_console, [_this.prepend, msg].concat(options));
    }
  };
  this.trace = function (msg) {
    if (_this.loggerLevel === Logger.TRACE) {
      var _console2;
      for (var _len2 = arguments.length, options = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        options[_key2 - 1] = arguments[_key2];
      }
      (_console2 = console).trace.apply(_console2, [_this.prepend, msg].concat(options));
    }
  };
  this.info = function (msg) {
    if (_this.loggerLevel === Logger.INFO) {
      var _console3;
      for (var _len3 = arguments.length, options = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        options[_key3 - 1] = arguments[_key3];
      }
      (_console3 = console).info.apply(_console3, [_this.prepend, msg].concat(options));
    }
  };
  this.warn = function (msg) {
    if (_this.loggerLevel === Logger.WARN) {
      var _console4;
      for (var _len4 = arguments.length, options = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        options[_key4 - 1] = arguments[_key4];
      }
      (_console4 = console).warn.apply(_console4, [_this.prepend, msg].concat(options));
    }
  };
  this.error = function (msg) {
    if (_this.loggerLevel === Logger.ERROR) {
      var _console5;
      for (var _len5 = arguments.length, options = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        options[_key5 - 1] = arguments[_key5];
      }
      (_console5 = console).error.apply(_console5, [_this.prepend, msg].concat(options));
    }
  };
  this.loggerLevel = loggerLevel ? loggerLevel : Logger.NOTHING;
};

/* eslint-disable import/no-anonymous-default-export */
var en = {
  'box user': 'User',
  'filetype_box user': 'User',
  cfpage: 'Confluence Page',
  filetype_cfpage: 'Confluence Page',
  cfcomment: 'Confluence Comment',
  filetype_cfcomment: 'Confluence Comment',
  cfspace: 'Confluence Space',
  filetype_cfspace: 'Confluence Space',
  cfblogentry: 'Confluence Blog Entry',
  filetype_cfblogentry: 'Confluence Blog Entry',
  confluencespace: 'Confluence Space',
  filetype_confluencespace: 'Confluence Space',
  exchangemessage: 'Message',
  filetype_exchangemessage: 'Message',
  exchangeappointment: 'Appointment',
  filetype_exchangeappointment: 'Appointment',
  exchangenote: 'Note',
  filetype_exchangenote: 'Note',
  exchangetask: 'Task',
  filetype_exchangetask: 'Task',
  exchangeperson: 'Exchange User',
  filetype_exchangeperson: 'Exchange User',
  activedirperson: 'Active Directory User',
  filetype_activedirperson: 'Active Directory User',
  exchangeactivity: 'Activity',
  filetype_exchangeactivity: 'Activity',
  exchangecalendarmessage: 'Calendar Message',
  filetype_exchangecalendarmessage: 'Calendar Message',
  exchangedocument: 'Exchange Document',
  filetype_exchangedocument: 'Exchange Document',
  exchangedsn: 'DSN',
  filetype_exchangedsn: 'DSN',
  exchangefreebusy: 'Free/Busy',
  filetype_exchangefreebusy: 'Free/Busy',
  exchangegroup: 'Group',
  filetype_exchangegroup: 'Group',
  exchangerssfeed: 'RSS Feed',
  filetype_exchangerssfeed: 'RSS Feed',
  exchangejunkmessage: 'Junk Email',
  filetype_exchangejunkmessage: 'Junk Email',
  exchangeofficecom: 'Communications',
  filetype_exchangeofficecom: 'Communications',
  lithiummessage: 'Lithium Message',
  filetype_lithiummessage: 'Lithium Message',
  lithiumthread: 'Lithium Thread',
  filetype_lithiumthread: 'Lithium Thread',
  lithiumboard: 'Lithium Board',
  filetype_lithiumboard: 'Lithium Board',
  lithiumcategory: 'Lithium Category',
  filetype_lithiumcategory: 'Lithium Category',
  lithiumcommunity: 'Lithium Community',
  filetype_lithiumcommunity: 'Lithium Community',
  sn_hr_core_case: 'HR Case',
  filetype_sn_hr_core_case: 'HR Case',
  sc_cat_item: 'Catalog Item',
  filetype_sc_cat_item: 'Catalog Item',
  sn_customerservice_case: 'Case',
  filetype_sn_customerservice_case: 'Case',
  kb_social_qa_answer: 'Answer',
  filetype_kb_social_qa_answer: 'Answer',
  kb_social_qa_question: 'Question',
  filetype_kb_social_qa_question: 'Question',
  kb_social_qa_comment: 'Comment',
  filetype_kb_social_qa_comment: 'Comment',
  incident: 'Incident',
  filetype_incident: 'Incident',
  kb_knowledge: 'Knowledge Article',
  filetype_kb_knowledge: 'Knowledge Article',
  youtube: 'YouTube Video',
  filetype_youtube: 'YouTube Video',
  youtubevideo: 'YouTube video',
  filetype_youtubevideo: 'YouTube video',
  youtubeplaylistitem: 'YouTube playlist item',
  filetype_youtubeplaylistitem: 'YouTube playlist item',
  youtubeplaylist: 'YouTube playlist',
  filetype_youtubeplaylist: 'YouTube playlist',
  html: 'HTML File',
  filetype_html: 'HTML File',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Web Page',
  filetype_webscraperwebpage: 'Web Page',
  image: 'Image',
  filetype_image: 'Image',
  folder: 'Folder',
  filetype_folder: 'Folder',
  txt: 'Text',
  filetype_txt: 'Text',
  zip: 'Zip File',
  filetype_zip: 'Zip File',
  olefile: 'OLE file',
  filetype_olefile: 'OLE file',
  gmailmessage: 'Gmail Message',
  filetype_gmailmessage: 'Gmail Message',
  pdf: 'PDF File',
  filetype_pdf: 'PDF File',
  swf: 'Flash File',
  filetype_swf: 'Flash File',
  xml: 'XML File',
  filetype_xml: 'XML File',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSS feed',
  filetype_rssitem: 'RSS feed',
  doc: 'Document',
  filetype_doc: 'Document',
  docx: 'Microsoft Word Document',
  filetype_docx: 'Microsoft Word Document',
  xls: 'Spreadsheet Document',
  filetype_xls: 'Spreadsheet Document',
  ppt: 'Presentation Document',
  filetype_ppt: 'Presentation Document',
  video: 'Video',
  filetype_video: 'Video',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Open Text Document',
  filetype_odt: 'Open Text Document',
  box: 'User',
  filetype_box: 'User',
  jiraissue: 'Jira Issue',
  filetype_jiraissue: 'Jira Issue',
  people: 'User',
  objecttype_people: 'User',
  message: 'Message',
  objecttype_message: 'Message',
  feed: 'RSS Feed',
  objecttype_feed: 'RSS Feed',
  thread: 'Thread',
  objecttype_thread: 'Thread',
  file: 'File',
  objecttype_file: 'File',
  board: 'Board',
  objecttype_board: 'Board',
  category: 'Category',
  objecttype_category: 'Category',
  account: 'Account',
  objecttype_account: 'Account',
  annotation: 'Note',
  objecttype_annotation: 'Note',
  campaign: 'Campaign',
  objecttype_campaign: 'Campaign',
  "case": 'Case',
  objecttype_case: 'Case',
  contact: 'Contact',
  objecttype_contact: 'Contact',
  contract: 'Contract',
  objecttype_contract: 'Contract',
  event: 'Event',
  objecttype_event: 'Event',
  email: 'Email',
  objecttype_email: 'Email',
  goal: 'Goal',
  objecttype_goal: 'Goal',
  objecttype_incident: 'Incident',
  invoice: 'Invoice',
  objecttype_invoice: 'Invoice',
  lead: 'Lead',
  objecttype_lead: 'Lead',
  list: 'List',
  objecttype_list: 'Marketing List',
  solution: 'Solution',
  objecttype_solution: 'Solution',
  report: 'Report',
  objecttype_report: 'Report',
  task: 'Task',
  objecttype_task: 'Task',
  user: 'User',
  objecttype_user: 'User',
  attachment: 'Attachment',
  objecttype_attachment: 'Attachment',
  casecomment: 'Case Comment',
  objecttype_casecomment: 'Case Comment',
  opportunity: 'Opportunity',
  objecttype_opportunity: 'Opportunity',
  opportunityproduct: 'Opportunity Product',
  objecttype_opportunityproduct: 'Opportunity Product',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Comment',
  objecttype_feedcomment: 'Comment',
  note: 'Note',
  objecttype_note: 'Note',
  product: 'Product',
  objecttype_product: 'Product',
  partner: 'Partner',
  objecttype_partner: 'Partner',
  queueitem: 'Queue Item',
  objecttype_queueitem: 'Queue Item',
  quote: 'Quote',
  objecttype_quote: 'Quote',
  salesliterature: 'Sales Literature',
  objecttype_salesliterature: 'Sales Literature',
  salesorder: 'Sales Order',
  objecttype_salesorder: 'Sales Order',
  service: 'Service',
  objecttype_service: 'Service',
  socialprofile: 'Social Profile',
  objecttype_socialprofile: 'Social Profile',
  kbdocumentation: 'Knowledge Document',
  objecttype_kbdocumentation: 'Knowledge Document',
  kbtechnicalarticle: 'Technical Documentation',
  objecttype_kbtechnicalarticle: 'Technical Documentation',
  kbsolution: 'Solution',
  objecttype_kbsolution: 'Solution',
  kbknowledgearticle: 'Knowledge Article',
  objecttype_kbknowledgearticle: 'Knowledge Article',
  kbattachment: 'Attachment',
  objecttype_kbattachment: 'Attachment',
  kbarticle: 'Article',
  objecttype_kbarticle: 'Article',
  kbarticlecomment: 'Article Comment',
  objecttype_kbarticlecomment: 'Article Comment',
  knowledgearticle: 'Knowledge Article',
  objecttype_knowledgearticle: 'Knowledge Article',
  topic: 'Topic',
  objecttype_topic: 'Topic',
  dashboard: 'Dashboard',
  objecttype_dashboard: 'Dashboard',
  contentversion: 'Document',
  objecttype_contentversion: 'Document',
  collaborationgroup: 'Collaboration group',
  objecttype_collaborationgroup: 'Collaboration group',
  phonecall: 'Phone call',
  objecttype_phonecall: 'Phone call',
  appointment: 'Appointment',
  objecttype_appointment: 'Appointment',
  spportal: 'Portal',
  filetype_spportal: 'Portal',
  spsite: 'SharePoint Site',
  filetype_spsite: 'SharePoint Site',
  spuserprofile: 'SharePoint User',
  filetype_spuserprofile: 'SharePoint User',
  sparea: 'Area',
  filetype_sparea: 'Area',
  spannouncement: 'Announcement',
  filetype_spannouncement: 'Announcement',
  spannouncementlist: 'Announcements',
  filetype_spannouncementlist: 'Announcements',
  spcontact: 'Contact',
  filetype_spcontact: 'Contact',
  spcontactlist: 'Contacts',
  filetype_spcontactlist: 'Contacts',
  spcustomlist: 'Custom Lists',
  filetype_spcustomlist: 'Custom Lists',
  spdiscussionboard: 'Discussion Board',
  filetype_spdiscussionboard: 'Discussion Board',
  spdiscussionboardlist: 'Discussion Boards',
  filetype_spdiscussionboardlist: 'Discussion Boards',
  spdocumentlibrarylist: 'Document Library',
  filetype_spdocumentlibrarylist: 'Document Library',
  spevent: 'Event',
  filetype_spevent: 'Event',
  speventlist: 'Events',
  filetype_speventlist: 'Events',
  spformlibrarylist: 'Form Library',
  filetype_spformlibrarylist: 'Form Library',
  spissue: 'Issue',
  filetype_spissue: 'Issue',
  spissuelist: 'Issues',
  filetype_spissuelist: 'Issues',
  splink: 'Link',
  filetype_splink: 'Link',
  splinklist: 'Links',
  filetype_splinklist: 'Links',
  sppicturelibrarylist: 'Picture Library',
  filetype_sppicturelibrarylist: 'Picture Library',
  spsurvey: 'Survey',
  filetype_spsurvey: 'Survey',
  spsurveylist: 'Surveys',
  filetype_spsurveylist: 'Surveys',
  sptask: 'Task',
  filetype_sptask: 'Task',
  sptasklist: 'Tasks',
  filetype_sptasklist: 'Tasks',
  spagenda: 'Agenda',
  filetype_spagenda: 'Agenda',
  spagendalist: 'Agendas',
  filetype_spagendalist: 'Agendas',
  spattendee: 'Attendee',
  filetype_spattendee: 'Attendee',
  spattendeelist: 'Attendees',
  filetype_spattendeelist: 'Attendees',
  spcustomgridlist: 'Custom Grids',
  filetype_spcustomgridlist: 'Custom Grids',
  spdecision: 'Decision',
  filetype_spdecision: 'Decision',
  spdecisionlist: 'Decisions',
  filetype_spdecisionlist: 'Decisions',
  spobjective: 'Objective',
  filetype_spobjective: 'Objective',
  spobjectivelist: 'Objectives',
  filetype_spobjectivelist: 'Objectives',
  sptextbox: 'Textbox',
  filetype_sptextbox: 'Textbox',
  sptextboxlist: 'Textbox list',
  filetype_sptextboxlist: 'Textbox list',
  spthingstobring: 'Thing To Bring',
  filetype_spthingstobring: 'Thing To Bring',
  spthingstobringlist: 'Things To Bring',
  filetype_spthingstobringlist: 'Things To Bring',
  sparealisting: 'Area Listing',
  filetype_sparealisting: 'Area Listing',
  spmeetingserie: 'Meeting series',
  filetype_spmeetingserie: 'Meeting series',
  spmeetingserielist: 'Meeting Series List',
  filetype_spmeetingserielist: 'Meeting Series List',
  spsitedirectory: 'Site Directory Item',
  filetype_spsitedirectory: 'Site Directory Item',
  spsitedirectorylist: 'Site Directory',
  filetype_spsitedirectorylist: 'Site Directory',
  spdatasource: 'Data Source',
  filetype_spdatasource: 'Data Source',
  spdatasourcelist: 'Data Source List',
  filetype_spdatasourcelist: 'Data Source List',
  splisttemplatecataloglist: 'List Template Gallery',
  filetype_splisttemplatecataloglist: 'List Template Gallery',
  spwebpartcataloglist: 'WebPart Gallery',
  filetype_spwebpartcataloglist: 'WebPart Gallery',
  spwebtemplatecataloglist: 'Site Template Gallery',
  filetype_spwebtemplatecataloglist: 'Site Template Gallery',
  spworkspacepagelist: 'Workspace Pages',
  filetype_spworkspacepagelist: 'Workspace Pages',
  spunknownlist: 'Custom List',
  filetype_spunknownlist: 'Custom List',
  spadministratortask: 'Administrator Task',
  filetype_spadministratortask: 'Administrator Task',
  spadministratortasklist: 'Administrator Tasks',
  filetype_spadministratortasklist: 'Administrator Tasks',
  spareadocumentlibrarylist: 'Area Document Library',
  filetype_spareadocumentlibrarylist: 'Area Document Library',
  spblogcategory: 'Blog Category',
  filetype_spblogcategory: 'Blog Category',
  spblogcategorylist: 'Blog Categories',
  filetype_spblogcategorylist: 'Blog Categories',
  spblogcomment: 'Blog Comment',
  filetype_spblogcomment: 'Blog Comment',
  spblogcommentlist: 'Blog Comments',
  filetype_spblogcommentlist: 'Blog Comments',
  spblogpost: 'Blog Post',
  filetype_spblogpost: 'Blog Post',
  spblogpostlist: 'Blog Posts',
  filetype_spblogpostlist: 'Blog Posts',
  spdataconnectionlibrarylist: 'Data Connection Library',
  filetype_spdataconnectionlibrarylist: 'Data Connection Library',
  spdistributiongroup: 'Distribution Group',
  filetype_spdistributiongroup: 'Distribution Group',
  spdistributiongrouplist: 'Distribution Groups',
  filetype_spdistributiongrouplist: 'Distribution Groups',
  spipfslist: 'InfoPath Forms Servers',
  filetype_spipfslist: 'InfoPath Forms Servers',
  spkeyperformanceindicator: 'Key Performance Indicator',
  filetype_spkeyperformanceindicator: 'Key Performance Indicator',
  spkeyperformanceindicatorlist: 'Key Performance Indicators',
  filetype_spkeyperformanceindicatorlist: 'Key Performance Indicators',
  splanguagesandtranslator: 'Languages and Translator',
  filetype_splanguagesandtranslator: 'Languages and Translator',
  splanguagesandtranslatorlist: 'Languages and Translators',
  filetype_splanguagesandtranslatorlist: 'Languages and Translators',
  spmasterpagescataloglist: 'Master Page Gallery',
  filetype_spmasterpagescataloglist: 'Master Page Gallery',
  spnocodeworkflowlibrarylist: 'No-code Workflow Libraries',
  filetype_spnocodeworkflowlibrarylist: 'No-code Workflow Libraries',
  spprojecttask: 'Project Task',
  filetype_spprojecttask: 'Project Task',
  spprojecttasklist: 'Project Tasks',
  filetype_spprojecttasklist: 'Project Tasks',
  sppublishingpageslibrarylist: 'Page Library',
  filetype_sppublishingpageslibrarylist: 'Page Library',
  spreportdocumentlibrarylist: 'Report Document Library',
  filetype_spreportdocumentlibrarylist: 'Report Document Library',
  spreportlibrarylist: 'Report Library',
  filetype_spreportlibrarylist: 'Report Library',
  spslidelibrarylist: 'Slide Library',
  filetype_spslidelibrarylist: 'Slide Library',
  sptab: 'Tabs',
  filetype_sptab: 'Tabs',
  sptablist: 'Tabs List',
  filetype_sptablist: 'Tabs List',
  sptranslationmanagementlibrarylist: 'Translation Management Library',
  filetype_sptranslationmanagementlibrarylist: 'Translation Management Library',
  spuserinformation: 'User Information',
  filetype_spuserinformation: 'User Information',
  spuserinformationlist: 'User Information List',
  filetype_spuserinformationlist: 'User Information List',
  spwikipagelibrarylist: 'Wiki Page Library',
  filetype_spwikipagelibrarylist: 'Wiki Page Library',
  spworkflowhistory: 'Workflow History',
  filetype_spworkflowhistory: 'Workflow History',
  spworkflowhistorylist: 'Workflow History List',
  filetype_spworkflowhistorylist: 'Workflow History List',
  spworkflowprocess: 'Custom Workflow Process',
  filetype_spworkflowprocess: 'Custom Workflow Process',
  spworkflowprocesslist: 'Custom Workflow Processes',
  filetype_spworkflowprocesslist: 'Custom Workflow Processes',
  sppublishingimageslibrarylist: 'Publishing Image Library',
  filetype_sppublishingimageslibrarylist: 'Publishing Image Library',
  spcirculation: 'Circulation',
  filetype_spcirculation: 'Circulation',
  spcirculationlist: 'Circulations',
  filetype_spcirculationlist: 'Circulations',
  spdashboardslibrarylist: 'Dashboards Library',
  filetype_spdashboardslibrarylist: 'Dashboards Library',
  spdataconnectionforperformancepointlibrarylist: 'PerformancePoint Data Connection Library',
  filetype_spdataconnectionforperformancepointlibrarylist: 'PerformancePoint Data Connection Library',
  sphealthreport: 'Health Report',
  filetype_sphealthreport: 'Health Report',
  sphealthreportlist: 'Health Reports',
  filetype_sphealthreportlist: 'Health Reports',
  sphealthrule: 'Health Rule',
  filetype_sphealthrule: 'Health Rule',
  sphealthrulelist: 'Health Rules',
  filetype_sphealthrulelist: 'Health Rules',
  spimedictionary: 'IME Dictionary',
  filetype_spimedictionary: 'IME Dictionary',
  spimedictionarylist: 'IME Dictionaries',
  filetype_spimedictionarylist: 'IME Dictionaries',
  spperformancepointcontent: 'PerformancePoint Content',
  filetype_spperformancepointcontent: 'PerformancePoint Content',
  spperformancepointcontentlist: 'PerformancePoint Contents',
  filetype_spperformancepointcontentlist: 'PerformancePoint Contents',
  spphonecallmemo: 'Phone Call Memo',
  filetype_spphonecallmemo: 'Phone Call Memo',
  spphonecallmemolist: 'Phone Call Memos',
  filetype_spphonecallmemolist: 'Phone Call Memos',
  sprecordlibrarylist: 'Record Library',
  filetype_sprecordlibrarylist: 'Record Library',
  spresource: 'Resource',
  filetype_spresource: 'Resource',
  spresourcelist: 'Resources',
  filetype_spresourcelist: 'Resources',
  spprocessdiagramslibrarylist: 'Process Diagram Library',
  filetype_spprocessdiagramslibrarylist: 'Process Diagram Library',
  spsitethemeslibrarylist: 'Site Theme Library',
  filetype_spsitethemeslibrarylist: 'Site Theme Library',
  spsolutionslibrarylist: 'Solution Library',
  filetype_spsolutionslibrarylist: 'Solution Library',
  spwfpublibrarylist: 'WFPUB Library',
  filetype_spwfpublibrarylist: 'WFPUB Library',
  spwhereabout: 'Whereabout',
  filetype_spwhereabout: 'Whereabout',
  spwhereaboutlist: 'Whereabouts',
  filetype_spwhereaboutlist: 'Whereabouts',
  spdocumentlink: 'Link to a Document',
  filetype_spdocumentlink: 'Link to a Document',
  spdocumentset: 'Document Set',
  filetype_spdocumentset: 'Document Set',
  spmicrofeedpost: 'Microfeed Post',
  filetype_spmicrofeedpost: 'Microfeed Post',
  spmicrofeedlist: 'Microfeed',
  filetype_spmicrofeedlist: 'Microfeed',
  splistfolder: 'List Folder',
  filetype_splistfolder: 'List Folder',
  Unknown: 'Unknown',
  And: 'AND',
  Authenticating: 'Authenticating {0}...',
  Clear: 'Clear {0}',
  CompleteQuery: 'Complete query',
  Exclude: 'Exclude {0}',
  EnterTag: 'Add Tag',
  Next: 'Next',
  Last: 'Last',
  Link: 'Link',
  Or: 'OR',
  Previous: 'Previous',
  QueryDidntMatchAnyDocuments: 'Your query did not match any documents.',
  QueryException: 'Your query has an error: {0}.',
  Me: 'Me',
  Remove: 'Remove',
  Search: 'Search',
  SearchFor: 'Search for {0}',
  SubmitSearch: 'Submit search',
  ShareQuery: 'Share Query',
  Preferences: 'Preferences',
  LinkOpeningSettings: 'Link opening settings',
  Reauthenticate: 'Reauthenticate {0}',
  ResultsFilteringExpression: 'Results filtering expressions',
  FiltersInYourPreferences: 'Filters in your preferences',
  Create: 'Create',
  SearchIn: 'Search in {0}',
  Seconds: 'in {0} second<pl>s</pl>',
  ShowingResultsOf: 'Showing: {0}<pl> to {1} of {2}</pl> result<pl>s</pl>',
  ShowingResultsOfPI: 'Results {0}-{1} of {2}',
  ShowingResultsOfWithQuery: 'Showing: {0}<pl> to {1} of {2}</pl> result<pl>s</pl> for {3}',
  SwitchTo: 'Switch to {0}',
  Unexclude: 'Remove exclusion filter on {0}',
  ClearAllFilters: 'Clear all filters',
  SkipLogin: 'Skip login',
  LoginInProgress: 'Login in progress, please wait ...',
  Login: 'Log In',
  GetStarted: 'Get Started',
  More: 'More',
  NMore: 'Show more ({0})',
  Less: 'Fewer',
  Settings: 'Settings',
  Score: 'Score',
  ScoreDescription: 'The score is computed from the number of occurrences as well as from the position in the result set.',
  Occurrences: 'Occurrences',
  OccurrencesDescription: 'Sort by number of occurrences, with values having the highest number appearing first.',
  Label: 'Label',
  Of: 'of',
  LabelDescription: 'Sort alphabetically on the field values.',
  Value: 'Value',
  ValueDescription: 'Sort on the values of the first computed field',
  AlphaAscending: 'Value Ascending',
  AlphaDescending: 'Value Descending',
  ChiSquare: 'Chi Square',
  Nosort: 'No Sort',
  NosortDescription: 'Do not sort the values. The values will be returned in a random order.',
  RelativeFrequency: 'Relative Frequency',
  RelativeFrequencyDescription: 'Sort based on the relative frequency of values. Less common values will appear higher.',
  DateDistribution: 'Date distribution',
  Custom: 'Custom',
  CustomDescription: 'Sort based on a custom order',
  ComputedField: 'Computed Field',
  Ascending: 'Ascending',
  Descending: 'Descending',
  noResultFor: 'No results for "{0}"',
  noResult: 'No results',
  autoCorrectedQueryTo: 'Query was automatically corrected to {0}',
  didYouMean: 'Did you mean {0}',
  SuggestedResults: 'Suggested Results',
  SuggestedQueries: 'Suggested Queries',
  MostRelevantItems: 'Most relevant items:',
  AllItems: 'All items:',
  ShowLess: 'Show less',
  ShowMore: 'Show more',
  HideFacet: 'Hide Facet',
  ShowFacet: 'Show Facet',
  AndOthers: 'and {0} other<pl>s</pl>',
  Others: '{0} other<pl>s</pl>',
  MostRelevantPosts: 'Most Relevant Posts:',
  CompleteThread: 'Complete Thread:',
  ShowCompleteThread: 'Show Complete Thread',
  ShowOnlyTopMatchingPosts: 'Show Only Top Matching Posts',
  MostRelevantReplies: 'Most Relevant Replies:',
  AllConversation: 'All Conversation:',
  ShowAllConversation: 'Show All Conversation',
  ShowAllReplies: 'Show All Replies',
  ShowOnlyMostRelevantReplies: 'Show Only Most Relevant Replies',
  Close: 'Close',
  Open: 'Open',
  OpenInOutlookWhenPossible: 'Open in Outlook (when possible)',
  AlwaysOpenInNewWindow: 'Always open results in new window',
  Quickview: 'Quick View',
  NoQuickview: 'The Quick View for this document is unavailable',
  ErrorReport: 'Error Report',
  OopsError: 'Search is down',
  ProblemPersists: "We're experiencing an issue with search. The good news is, we're on it! Try your search later.",
  GoBack: 'Go Back',
  Reset: 'Reset',
  Retry: 'Retry',
  MoreInfo: 'More Information',
  Username: 'Username',
  Password: 'Password',
  PostedBy: 'Posted by',
  CannotConnect: 'Cannot connect to the server address.',
  BadUserPass: 'Password does not match with username.',
  PleaseEnterYourCredentials: 'Please enter your credentials for {0}.',
  PleaseEnterYourSearchPage: 'Please enter your search page URL',
  Collapse: 'Collapse',
  Collapsable: 'Collapsible',
  Expand: 'Expand',
  CollapseFacet: 'Collapse {0} facet',
  ExpandFacet: 'Expand {0} facet',
  ShowLessFacetResults: 'Show fewer results for {0} facet',
  ShowMoreFacetResults: 'Show more results for {0} facet',
  ShowLessCategoryResults: 'Show fewer results for the {0} category',
  ShowMoreCategoryResults: 'Show more results for the {0} category',
  SearchFacetResults: 'Search for values in {0} facet',
  Today: 'Today',
  Yesterday: 'Yesterday',
  Tomorrow: 'Tomorrow',
  Duration: 'Duration: {0}',
  IndexDuration: 'Index Duration: {0}',
  ProxyDuration: 'Proxy Duration: {0}',
  ClientDuration: 'Client Duration: {0}',
  Unavailable: 'Unavailable',
  Reply: 'Reply',
  ReplyAll: 'Reply All',
  Forward: 'Forward',
  From: 'From',
  Caption: 'Caption',
  Expression: 'Expression',
  Tab: 'Tab',
  Tabs: 'Tabs',
  EnterExpressionName: 'Enter expression name',
  EnterExpressionToFilterWith: 'Enter expression to filter results with',
  SelectTab: 'Select Tab',
  SelectAll: 'Select All',
  PageUrl: 'Search page URL',
  ErrorSavingToDevice: 'Error while saving the information to your device',
  ErrorReadingFromDevice: 'Error while reading the information from your device',
  AppIntro: 'Speak with a product specialist who can answer your questions about Coveo and help you decide which Coveo solution is right for you. Or, try a live demo !',
  TryDemo: 'Try the demo',
  ContactUs: 'Contact us',
  NewToCoveo: 'New to Coveo?',
  LetUsHelpGetStarted: 'Let us help you get started',
  LikesThis: '{0} like<sn>s</sn> this.',
  CannotConnectSearchPage: 'Cannot connect to your search page',
  AreYouSureDeleteFilter: 'Are you sure you want to delete the filter {0} with the expression {1}',
  OnlineHelp: 'Online Help',
  Done: 'Done',
  SaveFacetState: 'Save this facet state',
  ClearFacetState: 'Clear facet state',
  DisplayingTheOnlyMessage: 'Displaying the only message in this conversation',
  NoNetworkConnection: 'No network connection',
  UnknownConnection: 'Unknown connection',
  EthernetConnection: 'Ethernet connection',
  WiFi: 'WiFi connection',
  CELL: 'Cellular connection',
  CELL_2G: 'Cellular 2G connection',
  CELL_3G: 'Cellular 3G connection',
  CELL_4G: 'Cellular 4G connection',
  Relevance: 'Relevance',
  Date: 'Date',
  Amount: 'Amount',
  QueryExceptionNoException: 'No exception',
  QueryExceptionInvalidSyntax: 'Invalid syntax',
  QueryExceptionInvalidCustomField: 'Invalid custom field',
  QueryExceptionInvalidDate: 'Invalid date',
  QueryExceptionInvalidExactPhrase: 'Invalid exact phrase',
  QueryExceptionInvalidDateOp: 'Invalid date operator',
  QueryExceptionInvalidNear: 'Invalid NEAR operator',
  QueryExceptionInvalidWeightedNear: 'Invalid weighted NEAR',
  QueryExceptionInvalidTerm: 'Invalid term',
  QueryExceptionTooManyTerms: 'Too many terms',
  QueryExceptionWildcardTooGeneral: 'Wildcard too general',
  QueryExceptionInvalidSortField: 'Invalid sort field',
  QueryExceptionInvalidSmallStringOp: 'Invalid small string operator',
  QueryExceptionRequestedResultsMax: 'Requested results maximum',
  QueryExceptionAggregatedMirrorDead: 'Aggregated mirror is offline',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Aggregated mirror query timeout',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Aggregated mirror invalid build number',
  QueryExceptionAggregatedMirrorCannotConnect: 'Aggregated mirror cannot connect',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Not enough leading character wildcard',
  QueryExceptionSecurityInverterNotFound: 'Security inverter not found',
  QueryExceptionSecurityInverterAccessDenied: 'Security inverter access denied',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'Aggregated mirror cannot impersonate',
  QueryExceptionUnexpected: 'Unexpected',
  QueryExceptionAccessDenied: 'Access denied',
  QueryExceptionSuperUserTokenInvalid: 'Super user token invalid',
  QueryExceptionSuperUserTokenExpired: 'Super user token is expired',
  QueryExceptionLicenseQueriesExpired: 'Queries license expired',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'License super user token not supported',
  QueryExceptionInvalidSession: 'Invalid session',
  QueryExceptionInvalidDocument: 'Invalid document',
  QueryExceptionSearchDisabled: 'Search disabled',
  FileType: 'File type',
  ShowAttachment: 'Show attachment',
  OnFeed: "on {0}'s feed.",
  Author: 'Author',
  NoTitle: 'No title',
  CurrentSelections: 'Current selections',
  AllContent: 'All content',
  CancelLastAction: 'Cancel last action',
  SearchTips: 'Search tips',
  CheckSpelling: 'Check the spelling of your keywords.',
  TryUsingFewerKeywords: 'Try using fewer, different or more general keywords.',
  SelectFewerFilters: 'Select fewer filters to broaden your search.',
  Document: 'Document',
  Time: 'Time',
  StartDate: 'Start Date',
  StartTime: 'Start Time',
  DurationTitle: 'Duration',
  UserQuery: 'User query',
  ShowUserActions: 'Show User Actions',
  NoData: 'No data available',
  EventType: 'Event type',
  GoToFullSearch: 'Full search',
  GoToEdition: 'Customize Panel',
  RemoveContext: 'Remove context',
  BoxAttachToCase: 'Attach to case',
  AttachToCase: 'Attach to case',
  Attach: 'Attach',
  Attached: 'Attached',
  Detach: 'Detach',
  Details: 'Details',
  AdditionalFilters: 'Additional filters',
  SelectNonContextualSearch: 'Remove the context from the current record to broaden your search',
  CopyPasteToSupport: 'Copy paste this message to the Coveo Support team for more information.',
  FollowQueryDescription: 'Alert me for changes to the search results of this query.',
  SearchAlerts_Panel: 'Manage Alerts',
  SearchAlerts_PanelDescription: 'View and manage your search alerts.',
  SearchAlerts_PanelNoSearchAlerts: 'You have no subscriptions.',
  SearchAlerts_Fail: 'The Search Alerts service is currently unavailable.',
  SearchAlerts_Type: 'Type',
  SearchAlerts_Content: 'Content',
  SearchAlerts_Actions: 'Action',
  EmptyQuery: '<empty>',
  SearchAlerts_Type_followQuery: 'Query',
  SearchAlerts_Type_followDocument: 'Item',
  SearchAlerts_unFollowing: 'Stop Following',
  SearchAlerts_follow: 'Follow',
  SearchAlerts_followed: 'Followed',
  SearchAlerts_followQuery: 'Follow Query',
  Subscription_StopFollowingQuery: 'Stop Following Query',
  SearchAlerts_Frequency: 'When',
  SubscriptionsManageSubscriptions: 'Manage Alerts',
  SubscriptionsMessageFollowQuery: 'You will receive alerts when the query <b>{0}</b> returns new or updated items.',
  SubscriptionsMessageFollow: 'You will receive alerts for changes to the item <b>{0}</b>.',
  Expiration: 'Expiration',
  Monthly: 'Monthly',
  Daily: 'Daily',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  NextDay: 'Next {0}',
  LastDay: 'Last {0}',
  StartTypingCaseForSuggestions: 'Describe your problem to see possible solutions',
  ExportToExcel: 'Export to Excel',
  ExportToExcelDescription: 'Export search results to Excel',
  CaseCreationNoResults: 'No recommended solutions were found',
  SortBy: 'Sort by',
  BoxCreateArticle: 'Create Article',
  Facets: 'Facets',
  AdvancedSearch: 'Advanced Search',
  Keywords: 'Keywords',
  AllTheseWords: 'All these words',
  ExactPhrase: 'This exact phrase',
  AnyOfTheseWords: 'Any of these words',
  NoneOfTheseWords: 'None of these words',
  Anytime: 'Anytime',
  InTheLast: 'In the last',
  Days: 'days',
  Months: 'months',
  Month: 'Month',
  Year: 'Year',
  Between: 'Between',
  Language: 'Language',
  Size: 'Size',
  AtLeast: 'at least',
  AtMost: 'at most',
  Contains: 'contains',
  DoesNotContain: 'does not contain',
  Matches: 'matches',
  Bytes: 'bytes',
  card: 'Card',
  table: 'Table',
  ResultLinks: 'Result links',
  EnableQuerySyntax: 'Enable query syntax',
  On: 'On',
  Off: 'Off',
  Automatic: 'Automatic',
  ResultsPerPage: 'Results per page',
  PreviousMonth: 'Previous month',
  NextMonth: 'Next month',
  Title: 'Title',
  FiltersInAdvancedSearch: 'Filters in Advanced Search',
  NoEndpoints: '{0} has no registered endpoints.',
  InvalidToken: 'The token used is invalid.',
  AddSources: 'You will need to add sources in your index, or wait for the created sources to finish indexing.',
  TryAgain: 'Please try again.',
  CoveoOnlineHelp: 'Coveo Online Help',
  CannotAccess: 'Something went wrong.',
  CoveoOrganization: 'Coveo Organization',
  SearchAPIDuration: 'Search API Duration: {0}',
  LastUpdated: 'Last updated',
  AllDates: 'All dates',
  WithinLastDay: 'Within last day',
  WithinLastWeek: 'Within last week',
  WithinLastMonth: 'Within last month',
  WithinLastYear: 'Within last year',
  RelevanceInspector: 'Relevance Inspector',
  KeywordInCategory: '{0} <span class="coveo-omnibox-suggestion-category">in {1}</span>',
  ResultCount: '{0} result<pl>s</pl>',
  ShowingResults: '{0} result<pl>s</pl>',
  ShowingResultsWithQuery: '{0} Viewing: results for "{1}"',
  NumberOfVideos: 'Number of videos',
  AllCategories: 'All Categories',
  Recommended: 'Recommended',
  Featured: 'Featured',
  CoveoHomePage: 'Coveo Home page',
  SizeValue: 'Size value',
  UnitMeasurement: 'Unit of measurement',
  Toggle: 'Toggle',
  FilterOn: 'Filter on {0}',
  RemoveFilterOn: 'Remove inclusion filter on {0}',
  Enter: 'Enter',
  InsertAQuery: 'Search',
  PressEnterToSend: '',
  SortResultsBy: 'Sort results by {0}',
  SortResultsByAscending: 'Sort by {0} in ascending order',
  SortResultsByDescending: 'Sort by {0} in descending order',
  DisplayResultsAs: 'Display results as {0}',
  FacetTitle: '{0} facet',
  IncludeValueWithResultCount: 'Inclusion filter on {0}; {1}',
  ExcludeValueWithResultCount: 'Exclusion filter on {0}; {1}',
  PageNumber: 'Page {0}',
  DisplayResultsPerPage: 'Display {0} results per page',
  GroupByAndFacetRequestsCannotCoexist: 'The query is invalid because it contains both Group By and Facet requests. Ensure that the search interface does not initialize DynamicFacet components alongside Facet components (or alongside any component extending the Facet component, such as FacetRange or FacetSlider).',
  MustContain: 'Must contain:',
  Missing: 'Missing:',
  Filters: 'Filters',
  FiltersDropdown: 'Filters dropdown',
  OpenFiltersDropdown: 'Open the filters dropdown',
  CloseFiltersDropdown: 'Close the filters dropdown',
  NoValuesFound: 'No values found.',
  To: 'to',
  DeselectFilterValues: 'Deselect all active filters on {0} field',
  Rated: 'Rated {0} out of {1} star<pl>s</pl>',
  RatedBy: 'by {0} user<pl>s</pl>',
  NoRatings: 'No ratings',
  Pagination: 'Pagination',
  ThumbnailOf: 'Thumbnail of "{0}"',
  CollapsedUriParts: 'Collapsed URI parts',
  HierarchicalFacetValueIndentedUnder: '{0} under {1}',
  HierarchicalFacetValuePathPrefix: 'in',
  UsefulnessFeedbackRequest: 'Was this useful?',
  UsefulnessFeedbackThankYou: 'Thanks for your feedback!',
  UsefulnessFeedbackExplainWhy: 'Explain why',
  UsefulnessFeedbackExplainWhyImperative: 'Explain why',
  UsefulnessFeedbackDoesNotAnswer: "This didn't answer my question at all",
  UsefulnessFeedbackPartiallyAnswers: 'This only partially answered my question',
  UsefulnessFeedbackWasNotAQuestion: "My request wasn't meant to be perceived as a question",
  Yes: 'Yes',
  No: 'No',
  Other: 'Other',
  Send: 'Send',
  UsefulnessFeedbackReason: 'Reason',
  AnswerSnippet: 'Answer to your question',
  AnswerSpecificSnippet: 'Answer to "{0}"',
  SuggestedQuestions: 'People also ask',
  ExpandQuestionAnswer: 'View answer for "{0}"',
  MoreValuesAvailable: 'additional values are available',
  Breadcrumb: 'Active filters',
  TRCoveoSearchResults: 'Search results',
  TRCoveoApply: 'Apply',
  TRCoveoClearAll: 'Clear All',
  SearchBoxSearch: 'Search',
  TRNoResultsFound: 'No results found',
  TRDidntFindResults: "We didn't find any results for {0}.",
  TRSuggestions: 'Suggestions',
  TRSpellAllWordsCorrectly: 'Spell all words correctly',
  // For this string, the word between the braces will be bold.
  TRChangeOrClearFilters: 'Change or {clear} your filters',
  TRTryDifferentKeywords: 'Try different keywords',
  TRViewingNoResults: 'Viewing: 0 results for {0}',
  TRLogin: 'Login',
  TRSupport: 'Support',
  TRStoreFormat: 'Format',
  TRStorePrice: 'Price',
  TRStoreStartingAt: '(starting at)',
  TRStoreAvailability: 'Availability',
  TRFilter: 'Filter',
  TRFilters: 'Filters',
  TRMin: 'min',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: 'Keep searching!',
  TRKeepSearchingDescription: "And we'll keep writing. Every search you do helps us figure out what you're looking for.",
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  TRBestSellers: 'Thomson Reuters best sellers',
  TRNMoreFormat: 'more format(s)'
};

// eslint-disable-next-line import/no-anonymous-default-export
var fr = {
  'box user': 'Utilisateur',
  'filetype_box user': 'Utilisateur',
  cfpage: 'Page Confluence',
  filetype_cfpage: 'Page Confluence',
  cfcomment: 'Commentaire Confluence',
  filetype_cfcomment: 'Commentaire Confluence',
  cfspace: 'Espace Confluence',
  filetype_cfspace: 'Espace Confluence',
  cfblogentry: 'Blogue Confluence',
  filetype_cfblogentry: 'Blogue Confluence',
  confluencespace: 'Espace Confluence',
  filetype_confluencespace: 'Espace Confluence',
  exchangemessage: 'Message',
  filetype_exchangemessage: 'Message',
  exchangeappointment: 'Rendez-vous',
  filetype_exchangeappointment: 'Rendez-vous',
  exchangenote: 'Note',
  filetype_exchangenote: 'Note',
  exchangetask: 'Tâche',
  filetype_exchangetask: 'Tâche',
  exchangeperson: 'Utilisateur Exchange',
  filetype_exchangeperson: 'Utilisateur Exchange',
  activedirperson: 'Utilisateur Active Directory',
  filetype_activedirperson: 'Utilisateur Active Directory',
  exchangeactivity: 'Activité',
  filetype_exchangeactivity: 'Activité',
  exchangecalendarmessage: 'Message de calendrier',
  filetype_exchangecalendarmessage: 'Message de calendrier',
  exchangedocument: 'Document Exchange',
  filetype_exchangedocument: 'Document Exchange',
  exchangedsn: 'DSN',
  filetype_exchangedsn: 'DSN',
  exchangefreebusy: 'Disponibilité',
  filetype_exchangefreebusy: 'Disponibilité',
  exchangegroup: 'Groupe',
  filetype_exchangegroup: 'Groupe',
  exchangerssfeed: 'Flux RSS',
  filetype_exchangerssfeed: 'Flux RSS',
  exchangejunkmessage: 'Courrier indésirable',
  filetype_exchangejunkmessage: 'Courrier indésirable',
  exchangeofficecom: 'Communications',
  filetype_exchangeofficecom: 'Communications',
  lithiummessage: 'Message Lithium',
  filetype_lithiummessage: 'Message Lithium',
  lithiumthread: 'Fil de conversation Lithium',
  filetype_lithiumthread: 'Fil de conversation Lithium',
  lithiumboard: 'Babillard électronique Lithium',
  filetype_lithiumboard: 'Babillard électronique Lithium',
  lithiumcategory: 'Catégorie Lithium',
  filetype_lithiumcategory: 'Catégorie Lithium',
  lithiumcommunity: 'Communauté Lithium',
  filetype_lithiumcommunity: 'Communauté Lithium',
  sn_hr_core_case: 'Requête RH',
  filetype_sn_hr_core_case: 'Requête RH',
  sc_cat_item: 'Item du Catalogue',
  filetype_sc_cat_item: 'Item du Catalogue',
  sn_customerservice_case: 'Requête',
  filetype_sn_customerservice_case: 'Requête',
  kb_social_qa_answer: 'Réponse',
  filetype_kb_social_qa_answer: 'Réponse',
  kb_social_qa_question: 'Question',
  filetype_kb_social_qa_question: 'Question',
  kb_social_qa_comment: 'Commentaire',
  filetype_kb_social_qa_comment: 'Commentaire',
  incident: 'Incident',
  filetype_incident: 'Incident',
  kb_knowledge: 'Article',
  filetype_kb_knowledge: 'Article',
  youtube: 'Vidéo YouTube',
  filetype_youtube: 'Vidéo YouTube',
  youtubevideo: 'Vidéos YouTube',
  filetype_youtubevideo: 'Vidéos YouTube',
  youtubeplaylistitem: 'Élément de liste de lecture',
  filetype_youtubeplaylistitem: 'Élément de liste de lecture',
  youtubeplaylist: 'Liste de lecture',
  filetype_youtubeplaylist: 'Liste de lecture',
  html: 'Fichier HTML',
  filetype_html: 'Fichier HTML',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Page Web',
  filetype_webscraperwebpage: 'Page Web',
  image: 'Image',
  filetype_image: 'Image',
  folder: 'Dossier',
  filetype_folder: 'Dossier',
  txt: 'Texte',
  filetype_txt: 'Texte',
  zip: 'Fichier Zip',
  filetype_zip: 'Fichier Zip',
  olefile: 'Fichier OLE',
  filetype_olefile: 'Fichier OLE',
  gmailmessage: 'Message Gmail',
  filetype_gmailmessage: 'Message Gmail',
  pdf: 'Fichier PDF',
  filetype_pdf: 'Fichier PDF',
  swf: 'Fichier Flash',
  filetype_swf: 'Fichier Flash',
  xml: 'Fichier XML',
  filetype_xml: 'Fichier XML',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'Flux RSS',
  filetype_rssitem: 'Flux RSS',
  doc: 'Document',
  filetype_doc: 'Document',
  docx: 'Document Microsoft Word',
  filetype_docx: 'Document Microsoft Word',
  xls: 'Feuille de calcul',
  filetype_xls: 'Feuille de calcul',
  ppt: 'Présentation',
  filetype_ppt: 'Présentation',
  video: 'Vidéo',
  filetype_video: 'Vidéo',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Document Open Text',
  filetype_odt: 'Document Open Text',
  box: 'Utilisateur',
  filetype_box: 'Utilisateur',
  jiraissue: 'Issue Jira',
  filetype_jiraissue: 'Issue Jira',
  people: 'Utilisateur',
  objecttype_people: 'Utilisateur',
  message: 'Message',
  objecttype_message: 'Message',
  feed: 'Flux RSS',
  objecttype_feed: 'Flux RSS',
  thread: 'Fil de conversation',
  objecttype_thread: 'Fil de conversation',
  file: 'Fichier',
  objecttype_file: 'Fichier',
  board: 'Tableau',
  objecttype_board: 'Tableau',
  category: 'Catégorie',
  objecttype_category: 'Catégorie',
  account: 'Compte',
  objecttype_account: 'Compte',
  annotation: 'Note',
  objecttype_annotation: 'Note',
  campaign: 'Campagne',
  objecttype_campaign: 'Campagne',
  "case": 'Cas',
  objecttype_case: 'Cas',
  contact: 'Contact',
  objecttype_contact: 'Contact',
  contract: 'Contrat',
  objecttype_contract: 'Contrat',
  event: 'Événement',
  objecttype_event: 'Événement',
  email: 'Email',
  objecttype_email: 'Email',
  goal: 'Objectif',
  objecttype_goal: 'Objectif',
  objecttype_incident: 'Incident',
  invoice: 'Facture',
  objecttype_invoice: 'Facture',
  lead: 'Lead',
  objecttype_lead: 'Lead',
  list: 'Liste',
  objecttype_list: 'Liste marketing',
  solution: 'Solution',
  objecttype_solution: 'Solution',
  report: 'Rapport',
  objecttype_report: 'Rapport',
  task: 'Tâche',
  objecttype_task: 'Tâche',
  user: 'Utilisateur',
  objecttype_user: 'Utilisateur',
  attachment: 'Pièce jointe',
  objecttype_attachment: 'Pièce jointe',
  casecomment: 'Commentaire sur un cas',
  objecttype_casecomment: 'Commentaire sur un cas',
  opportunity: 'Opportunité',
  objecttype_opportunity: 'Opportunité',
  opportunityproduct: "Produit d'opportunité",
  objecttype_opportunityproduct: "Produit d'opportunité",
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Commentaire',
  objecttype_feedcomment: 'Commentaire',
  note: 'Note',
  objecttype_note: 'Note',
  product: 'Produit',
  objecttype_product: 'Produit',
  partner: 'Partenaire',
  objecttype_partner: 'Partenaire',
  queueitem: "Élément de file d'attente",
  objecttype_queueitem: "Élément de file d'attente",
  quote: 'Devis',
  objecttype_quote: 'Devis',
  salesliterature: 'Documentation commerciale',
  objecttype_salesliterature: 'Documentation commerciale',
  salesorder: 'Commande',
  objecttype_salesorder: 'Commande',
  service: 'Service',
  objecttype_service: 'Service',
  socialprofile: 'Profil social',
  objecttype_socialprofile: 'Profil social',
  kbdocumentation: 'Article de Documentation',
  objecttype_kbdocumentation: 'Article de Documentation',
  kbtechnicalarticle: 'Documentation Technique',
  objecttype_kbtechnicalarticle: 'Documentation Technique',
  kbsolution: 'Solution',
  objecttype_kbsolution: 'Solution',
  kbknowledgearticle: 'Article de base de connaissance',
  objecttype_kbknowledgearticle: 'Article de base de connaissance',
  kbattachment: 'Pièce jointe',
  objecttype_kbattachment: 'Pièce jointe',
  kbarticle: 'Article',
  objecttype_kbarticle: 'Article',
  kbarticlecomment: "Commentaire d'article",
  objecttype_kbarticlecomment: "Commentaire d'article",
  knowledgearticle: 'Article de base de connaissance',
  objecttype_knowledgearticle: 'Article de base de connaissance',
  topic: 'Sujet',
  objecttype_topic: 'Sujet',
  dashboard: 'Tableau de bord',
  objecttype_dashboard: 'Tableau de bord',
  contentversion: 'Document',
  objecttype_contentversion: 'Document',
  collaborationgroup: 'Groupe de collaboration',
  objecttype_collaborationgroup: 'Groupe de collaboration',
  phonecall: 'Appel téléphonique',
  objecttype_phonecall: 'Appel téléphonique',
  appointment: 'Rendez vous',
  objecttype_appointment: 'Rendez vous',
  spportal: 'Portail',
  filetype_spportal: 'Portail',
  spsite: 'Site SharePoint',
  filetype_spsite: 'Site SharePoint',
  spuserprofile: 'Utilisateur SharePoint',
  filetype_spuserprofile: 'Utilisateur SharePoint',
  sparea: 'Zone',
  filetype_sparea: 'Zone',
  spannouncement: 'Annonce',
  filetype_spannouncement: 'Annonce',
  spannouncementlist: 'Annonces',
  filetype_spannouncementlist: 'Annonces',
  spcontact: 'Contact',
  filetype_spcontact: 'Contact',
  spcontactlist: 'Contacts',
  filetype_spcontactlist: 'Contacts',
  spcustomlist: 'Listes personnalisées',
  filetype_spcustomlist: 'Listes personnalisées',
  spdiscussionboard: 'Forum de discussion',
  filetype_spdiscussionboard: 'Forum de discussion',
  spdiscussionboardlist: 'Forums de discussion',
  filetype_spdiscussionboardlist: 'Forums de discussion',
  spdocumentlibrarylist: 'Bibliothèque de documents',
  filetype_spdocumentlibrarylist: 'Bibliothèque de documents',
  spevent: 'Événement',
  filetype_spevent: 'Événement',
  speventlist: 'Événements',
  filetype_speventlist: 'Événements',
  spformlibrarylist: 'Bibliothèque de formulaires',
  filetype_spformlibrarylist: 'Bibliothèque de formulaires',
  spissue: 'Problème',
  filetype_spissue: 'Problème',
  spissuelist: 'Problèmes',
  filetype_spissuelist: 'Problèmes',
  splink: 'Lien',
  filetype_splink: 'Lien',
  splinklist: 'Liens',
  filetype_splinklist: 'Liens',
  sppicturelibrarylist: "Bibliothèque d'images",
  filetype_sppicturelibrarylist: "Bibliothèque d'images",
  spsurvey: 'Enquête',
  filetype_spsurvey: 'Enquête',
  spsurveylist: 'Enquêtes',
  filetype_spsurveylist: 'Enquêtes',
  sptask: 'Tâche',
  filetype_sptask: 'Tâche',
  sptasklist: 'Tâches',
  filetype_sptasklist: 'Tâches',
  spagenda: 'Ordre du jour',
  filetype_spagenda: 'Ordre du jour',
  spagendalist: 'Ordres du jour',
  filetype_spagendalist: 'Ordres du jour',
  spattendee: 'Participant',
  filetype_spattendee: 'Participant',
  spattendeelist: 'Participants',
  filetype_spattendeelist: 'Participants',
  spcustomgridlist: 'Grilles personnalisées',
  filetype_spcustomgridlist: 'Grilles personnalisées',
  spdecision: 'Décision',
  filetype_spdecision: 'Décision',
  spdecisionlist: 'Décisions',
  filetype_spdecisionlist: 'Décisions',
  spobjective: 'Objectif',
  filetype_spobjective: 'Objectif',
  spobjectivelist: 'Objectifs',
  filetype_spobjectivelist: 'Objectifs',
  sptextbox: 'Zone de texte',
  filetype_sptextbox: 'Zone de texte',
  sptextboxlist: 'Liste de zones de texte',
  filetype_sptextboxlist: 'Liste de zones de texte',
  spthingstobring: 'Élément à prévoir',
  filetype_spthingstobring: 'Élément à prévoir',
  spthingstobringlist: 'Éléments à prévoir',
  filetype_spthingstobringlist: 'Éléments à prévoir',
  sparealisting: 'Listing de zone',
  filetype_sparealisting: 'Listing de zone',
  spmeetingserie: 'Série de réunions',
  filetype_spmeetingserie: 'Série de réunions',
  spmeetingserielist: 'Liste de séries de réunions',
  filetype_spmeetingserielist: 'Liste de séries de réunions',
  spsitedirectory: "Élément d'un annuaire de sites",
  filetype_spsitedirectory: "Élément d'un annuaire de sites",
  spsitedirectorylist: 'Annuaire de sites',
  filetype_spsitedirectorylist: 'Annuaire de sites',
  spdatasource: 'Source de données',
  filetype_spdatasource: 'Source de données',
  spdatasourcelist: 'Liste de sources de données',
  filetype_spdatasourcelist: 'Liste de sources de données',
  splisttemplatecataloglist: 'Galerie Modèles de listes',
  filetype_splisttemplatecataloglist: 'Galerie Modèles de listes',
  spwebpartcataloglist: 'Galerie Composants WebPart',
  filetype_spwebpartcataloglist: 'Galerie Composants WebPart',
  spwebtemplatecataloglist: 'Galerie Modèles de sites',
  filetype_spwebtemplatecataloglist: 'Galerie Modèles de sites',
  spworkspacepagelist: "Pages d'espace de travail",
  filetype_spworkspacepagelist: "Pages d'espace de travail",
  spunknownlist: 'Liste personnalisée',
  filetype_spunknownlist: 'Liste personnalisée',
  spadministratortask: "Tâche d'administration",
  filetype_spadministratortask: "Tâche d'administration",
  spadministratortasklist: "Tâches d'administration",
  filetype_spadministratortasklist: "Tâches d'administration",
  spareadocumentlibrarylist: 'Bibliothèque de documents de zone',
  filetype_spareadocumentlibrarylist: 'Bibliothèque de documents de zone',
  spblogcategory: 'Catégorie de blogue',
  filetype_spblogcategory: 'Catégorie de blogue',
  spblogcategorylist: 'Catégories de blogue',
  filetype_spblogcategorylist: 'Catégories de blogue',
  spblogcomment: 'Commentaire de blogue',
  filetype_spblogcomment: 'Commentaire de blogue',
  spblogcommentlist: 'Commentaires de blogue',
  filetype_spblogcommentlist: 'Commentaires de blogue',
  spblogpost: 'Article de blogue',
  filetype_spblogpost: 'Article de blogue',
  spblogpostlist: 'Articles de blogue',
  filetype_spblogpostlist: 'Articles de blogue',
  spdataconnectionlibrarylist: 'Bibliothèque de connexions de données',
  filetype_spdataconnectionlibrarylist: 'Bibliothèque de connexions de données',
  spdistributiongroup: 'Groupe de distribution',
  filetype_spdistributiongroup: 'Groupe de distribution',
  spdistributiongrouplist: 'Groupes de distribution',
  filetype_spdistributiongrouplist: 'Groupes de distribution',
  spipfslist: 'Serveurs de formulaires InfoPath',
  filetype_spipfslist: 'Serveurs de formulaires InfoPath',
  spkeyperformanceindicator: 'Indicateur de performance clé',
  filetype_spkeyperformanceindicator: 'Indicateur de performance clé',
  spkeyperformanceindicatorlist: 'Indicateurs de performance clé',
  filetype_spkeyperformanceindicatorlist: 'Indicateurs de performance clé',
  splanguagesandtranslator: 'Langues et traducteur',
  filetype_splanguagesandtranslator: 'Langues et traducteur',
  splanguagesandtranslatorlist: 'Langues et traducteurs',
  filetype_splanguagesandtranslatorlist: 'Langues et traducteurs',
  spmasterpagescataloglist: 'Galerie Pages maîtres',
  filetype_spmasterpagescataloglist: 'Galerie Pages maîtres',
  spnocodeworkflowlibrarylist: 'Bibliothèques de flux de travail sans code',
  filetype_spnocodeworkflowlibrarylist: 'Bibliothèques de flux de travail sans code',
  spprojecttask: 'Tâche de projet',
  filetype_spprojecttask: 'Tâche de projet',
  spprojecttasklist: 'Tâches de projet',
  filetype_spprojecttasklist: 'Tâches de projet',
  sppublishingpageslibrarylist: 'Bibliothèque de pages',
  filetype_sppublishingpageslibrarylist: 'Bibliothèque de pages',
  spreportdocumentlibrarylist: 'Bibliothèque de documents de rapport',
  filetype_spreportdocumentlibrarylist: 'Bibliothèque de documents de rapport',
  spreportlibrarylist: 'Bibliothèque de rapports',
  filetype_spreportlibrarylist: 'Bibliothèque de rapports',
  spslidelibrarylist: 'Bibliothèque de diapositives',
  filetype_spslidelibrarylist: 'Bibliothèque de diapositives',
  sptab: 'Onglets',
  filetype_sptab: 'Onglets',
  sptablist: "Liste d'onglets",
  filetype_sptablist: "Liste d'onglets",
  sptranslationmanagementlibrarylist: 'Bibliothèque Gestion des traductions',
  filetype_sptranslationmanagementlibrarylist: 'Bibliothèque Gestion des traductions',
  spuserinformation: 'Information utilisateur',
  filetype_spuserinformation: 'Information utilisateur',
  spuserinformationlist: "Liste d'informations utilisateur",
  filetype_spuserinformationlist: "Liste d'informations utilisateur",
  spwikipagelibrarylist: 'Bibliothèque de pages Wiki',
  filetype_spwikipagelibrarylist: 'Bibliothèque de pages Wiki',
  spworkflowhistory: 'Historique de flux de travail',
  filetype_spworkflowhistory: 'Historique de flux de travail',
  spworkflowhistorylist: "Liste d'historiques de flux de travail",
  filetype_spworkflowhistorylist: "Liste d'historiques de flux de travail",
  spworkflowprocess: 'Processus de flux de travail personnalisé',
  filetype_spworkflowprocess: 'Processus de flux de travail personnalisé',
  spworkflowprocesslist: 'Liste de processus de flux de travail personnalisés',
  filetype_spworkflowprocesslist: 'Liste de processus de flux de travail personnalisés',
  sppublishingimageslibrarylist: "Bibliothèque d'images de publication",
  filetype_sppublishingimageslibrarylist: "Bibliothèque d'images de publication",
  spcirculation: 'Circulation',
  filetype_spcirculation: 'Circulation',
  spcirculationlist: 'Circulations',
  filetype_spcirculationlist: 'Circulations',
  spdashboardslibrarylist: 'Bibliothèque de tableaux de bord',
  filetype_spdashboardslibrarylist: 'Bibliothèque de tableaux de bord',
  spdataconnectionforperformancepointlibrarylist: 'Bibliothèque de connexions de données PerformancePoint',
  filetype_spdataconnectionforperformancepointlibrarylist: 'Bibliothèque de connexions de données PerformancePoint',
  sphealthreport: "Rapport d'intégrité",
  filetype_sphealthreport: "Rapport d'intégrité",
  sphealthreportlist: "Rapports d'intégrité",
  filetype_sphealthreportlist: "Rapports d'intégrité",
  sphealthrule: "Règle d'intégrité",
  filetype_sphealthrule: "Règle d'intégrité",
  sphealthrulelist: "Règles d'intégrité",
  filetype_sphealthrulelist: "Règles d'intégrité",
  spimedictionary: 'Dictionnaire IME',
  filetype_spimedictionary: 'Dictionnaire IME',
  spimedictionarylist: 'Dictionnaires IME',
  filetype_spimedictionarylist: 'Dictionnaires IME',
  spperformancepointcontent: 'Contenu PerformancePoint',
  filetype_spperformancepointcontent: 'Contenu PerformancePoint',
  spperformancepointcontentlist: 'Contenus PerformancePoint',
  filetype_spperformancepointcontentlist: 'Contenus PerformancePoint',
  spphonecallmemo: "Mémo d'appel téléphonique",
  filetype_spphonecallmemo: "Mémo d'appel téléphonique",
  spphonecallmemolist: "Mémos d'appels téléphoniques",
  filetype_spphonecallmemolist: "Mémos d'appels téléphoniques",
  sprecordlibrarylist: "Bibliothèque d'enregistrements",
  filetype_sprecordlibrarylist: "Bibliothèque d'enregistrements",
  spresource: 'Ressource',
  filetype_spresource: 'Ressource',
  spresourcelist: 'Ressources',
  filetype_spresourcelist: 'Ressources',
  spprocessdiagramslibrarylist: 'Bibliothèque de diagrammes de processus',
  filetype_spprocessdiagramslibrarylist: 'Bibliothèque de diagrammes de processus',
  spsitethemeslibrarylist: 'Bibliothèque de thèmes de site',
  filetype_spsitethemeslibrarylist: 'Bibliothèque de thèmes de site',
  spsolutionslibrarylist: 'Bibliothèque de solutions',
  filetype_spsolutionslibrarylist: 'Bibliothèque de solutions',
  spwfpublibrarylist: 'Bibliothèque de WFPUB',
  filetype_spwfpublibrarylist: 'Bibliothèque de WFPUB',
  spwhereabout: 'Localisation',
  filetype_spwhereabout: 'Localisation',
  spwhereaboutlist: 'Localisations',
  filetype_spwhereaboutlist: 'Localisations',
  spdocumentlink: 'Lien vers un document',
  filetype_spdocumentlink: 'Lien vers un document',
  spdocumentset: 'Ensemble de documents',
  filetype_spdocumentset: 'Ensemble de documents',
  spmicrofeedpost: "Publication d'un microflux",
  filetype_spmicrofeedpost: "Publication d'un microflux",
  spmicrofeedlist: 'Microflux',
  filetype_spmicrofeedlist: 'Microflux',
  splistfolder: 'Dossier de liste',
  filetype_splistfolder: 'Dossier de liste',
  Unknown: 'Inconnu',
  And: 'ET',
  Authenticating: 'Authentification à {0} en cours...',
  Clear: 'Effacer {0}',
  CompleteQuery: 'Requête complète',
  Exclude: 'Exclure {0}',
  EnterTag: 'Ajouter un Tag',
  Next: 'Suivant',
  Last: 'Précédent',
  Link: 'Lien',
  Or: 'OU',
  Previous: 'Précédent',
  QueryDidntMatchAnyDocuments: "Votre requête n'a retourné aucun document.",
  QueryException: 'Votre requête a une erreur : {0}.',
  Me: 'Moi',
  Remove: 'Enlever',
  Search: 'Recherche',
  SearchFor: 'Recherche pour {0}',
  SubmitSearch: 'Envoyer la requête',
  ShareQuery: 'Partager cette requête',
  Preferences: 'Préférences',
  LinkOpeningSettings: "Réglage pour l'ouverture des liens",
  Reauthenticate: 'Réauthentifier {0}',
  ResultsFilteringExpression: 'Expression de filtrage des résultats',
  FiltersInYourPreferences: 'Filtres dans vos préférences',
  Create: 'Créer',
  SearchIn: 'Rechercher dans {0}',
  Seconds: 'en {0} seconde<pl>s</pl>',
  ShowingResultsOf: 'Résultat<pl>s</pl> {0}<pl>-{1}</pl> de {2}',
  ShowingResultsOfPI: 'Results {0}-{1} of {2}',
  ShowingResultsOfWithQuery: 'Résultat<pl>s</pl> {0}<pl>-{1}</pl> de {2} pour {3}',
  SwitchTo: 'Basculer vers {0}',
  Unexclude: "Enlever le filtre d'exclusion sur {0}",
  ClearAllFilters: 'Enlever tous les filtres',
  SkipLogin: 'Passer la connexion',
  LoginInProgress: 'Connexion en cours, veuillez patienter...',
  Login: 'Connexion',
  GetStarted: 'Démarrer',
  More: 'Plus',
  NMore: '{0} de plus...',
  Less: 'Moins',
  Settings: 'Réglages',
  Score: 'Score',
  ScoreDescription: "Le score est calculé en fonction du nombre d'occurences et de sa position dans les résultats.",
  Occurrences: 'Occurrences',
  OccurrencesDescription: "Trier selon l'occurrence, avec les valeurs les plus élevées apparaissant en premier.",
  Label: 'Étiquette',
  Of: 'de',
  LabelDescription: 'Trier alphabétiquement sur la valeur des champs.',
  Value: 'Valeur',
  ValueDescription: 'Trier sur les valeurs du premier champ calculé',
  AlphaAscending: 'Valeur croissante',
  AlphaDescending: 'Valeur Décroissante',
  ChiSquare: 'Chi Square',
  Nosort: 'Aucun tri',
  NosortDescription: 'Ne pas trier les valeurs. Les valeurs seront retournées dans un ordre aléatoire',
  RelativeFrequency: 'Fréquence relative',
  RelativeFrequencyDescription: 'Trier sur la fréquence relative des valeurs. Les valeurs moins fréquentes vont apparaîtrent plus haute.',
  DateDistribution: 'Date de distribution relative',
  Custom: 'Personnalisé',
  CustomDescription: 'Trier de manière personalisée',
  ComputedField: 'Champ calculé',
  Ascending: 'Croissant',
  Descending: 'Décroissant',
  noResultFor: 'Aucun résultat pour {0}',
  noResult: 'Aucun résultat',
  autoCorrectedQueryTo: 'La requête a été corrigée automatiquement à {0}',
  didYouMean: 'Vouliez-vous dire : {0}',
  SuggestedResults: 'Résultats suggérés',
  SuggestedQueries: 'Requêtes suggérées',
  MostRelevantItems: 'Items les plus pertinents :',
  AllItems: 'Tous les items :',
  ShowLess: 'Voir moins de résultats',
  ShowMore: 'Voir plus de résultats',
  HideFacet: 'Cacher la facette',
  ShowFacet: 'Afficher la facette',
  AndOthers: 'et {0}autre<pl>s</pl>',
  Others: '{0} autre<pl>s</pl>',
  MostRelevantPosts: 'Messages les plus pertinents :',
  CompleteThread: 'Toute la discussion :',
  ShowCompleteThread: "Voir l'ensemble de la discussion",
  ShowOnlyTopMatchingPosts: 'Voir seulement les messages les plus pertinents',
  MostRelevantReplies: 'Réponses les plus pertinentes :',
  AllConversation: 'Toute la conversation :',
  ShowAllConversation: "Voir l'ensemble de la conversation",
  ShowAllReplies: 'Voir toutes les réponses',
  ShowOnlyMostRelevantReplies: 'Voir seulement les réponses les plus pertinentes',
  Close: 'Fermer',
  Open: 'Ouvrir',
  OpenInOutlookWhenPossible: "Ouvrir dans Outlook (quand c'est possible)",
  AlwaysOpenInNewWindow: 'Toujours ouvrir les résultats dans une nouvelle fenêtre',
  Quickview: "Coup D'Oeil",
  NoQuickview: "Le Coup D'Oeil pour ce document n'est pas disponible",
  ErrorReport: "Rapport d'erreur",
  OopsError: 'La recherche est indisponible',
  ProblemPersists: "Nous éprouvons des difficultés avec la recherche. Mais rassurez-vous, on s'en occupe! Essayez votre recherche plus tard.",
  GoBack: 'Revenir',
  Reset: 'Réinitialiser',
  Retry: 'Réessayer',
  MoreInfo: "Plus d'information",
  Username: "Nom d'utilisateur",
  Password: 'Mot de passe',
  PostedBy: 'Écrit par',
  CannotConnect: 'Impossible de se connecter au serveur.',
  BadUserPass: "Mauvaise combinaison de nom d'utilisateur et mot de passe.",
  PleaseEnterYourCredentials: "Veuillez entrer votre nom d'utilisateur et mot de passe pour {0}.",
  PleaseEnterYourSearchPage: 'Veuillez entrer votre URL de page de recherche',
  Collapse: 'Réduire',
  Collapsable: 'Refermable',
  Expand: 'Agrandir',
  CollapseFacet: 'Réduire la facette {0}',
  ExpandFacet: 'Agrandir la facette {0}',
  ShowLessFacetResults: 'Afficher moins de résultats pour la facette {0}',
  ShowMoreFacetResults: 'Afficher plus de résultats pour la facette {0}',
  ShowLessCategoryResults: 'Afficher moins de résultats pour la catégorie {0}',
  ShowMoreCategoryResults: 'Afficher plus de résultats pour la catégorie {0}',
  SearchFacetResults: 'Rechercher des valeurs dans la facette {0}',
  Today: "Aujourd'hui",
  Yesterday: 'Hier',
  Tomorrow: 'Demain',
  Duration: 'Durée : {0}',
  IndexDuration: 'Durée Index : {0}',
  ProxyDuration: 'Durée Proxy: {0}',
  ClientDuration: 'Durée Client: {0}',
  Unavailable: 'Non disponible',
  Reply: 'Répondre',
  ReplyAll: 'Répondre à tous',
  Forward: 'Transférer',
  From: 'De',
  Caption: 'Légende',
  Expression: 'Expression',
  Tab: 'Onglet',
  Tabs: 'Onglets',
  EnterExpressionName: "Entrez le nom de l'expression",
  EnterExpressionToFilterWith: "Entrez l'expression pour filtrer les résultats",
  SelectTab: "Selectionnez l'onglet",
  SelectAll: 'Sélectionnez tout',
  PageUrl: 'URL de la page de recherche',
  ErrorSavingToDevice: "Erreur lors de l'écriture sur votre appareil",
  ErrorReadingFromDevice: "Erreur lors de la lecture de l'information sur votre appareil",
  AppIntro: 'Contactez-nous pour parler avec un spécialiste de produit qui pourra répondre à vos questions a propos de Coveo. Ou bien, essayer une demonstration !',
  TryDemo: 'Essayer le démo',
  ContactUs: 'Contactez-nous',
  NewToCoveo: "Qu'est-ce que Coveo?",
  LetUsHelpGetStarted: 'Laisser nous vous aidez a démarrer',
  LikesThis: '{0} aime<pl>nt</pl> ça.',
  CannotConnectSearchPage: 'Impossible de rejoindre votre page de recherche',
  AreYouSureDeleteFilter: "Êtes vous sur de vouloir effacer le filtre {0}avec l'expression {1}",
  OnlineHelp: 'Aide en ligne',
  Done: 'Terminé',
  SaveFacetState: "Sauvegarder l'état de la facette",
  ClearFacetState: "Effacer l'état de la facette",
  DisplayingTheOnlyMessage: 'Affichage du seul message dans cette conversation',
  NoNetworkConnection: 'Aucune connexion réseau',
  UnknownConnection: 'Connexion inconnue',
  EthernetConnection: 'Connexion Ethernet',
  WiFi: 'Connexion WiFi',
  CELL: 'Connexion cellulaire',
  CELL_2G: 'Connexion cellulaire 2g',
  CELL_3G: 'Connexion cellulaire 3g',
  CELL_4G: 'Connexion cellulaire 4g',
  Relevance: 'Pertinence',
  Date: 'Date',
  Amount: 'Montant',
  QueryExceptionNoException: 'Aucune exception',
  QueryExceptionInvalidSyntax: 'Syntaxe invalide',
  QueryExceptionInvalidCustomField: 'Champ personnalisé invalide',
  QueryExceptionInvalidDate: 'Date invalide',
  QueryExceptionInvalidExactPhrase: 'Phrase exacte invalide',
  QueryExceptionInvalidDateOp: 'Opérateur de date invalide',
  QueryExceptionInvalidNear: 'Fonction de proximité (PRES) invalide',
  QueryExceptionInvalidWeightedNear: 'Pondérée de la fonction de proximité invalide',
  QueryExceptionInvalidTerm: 'Terme invalide',
  QueryExceptionTooManyTerms: 'Trop de termes',
  QueryExceptionWildcardTooGeneral: 'Métacaractère trop général',
  QueryExceptionInvalidSortField: 'Champ de tri invalide',
  QueryExceptionInvalidSmallStringOp: 'Opérateur de petite chaîne invalide',
  QueryExceptionRequestedResultsMax: 'Maximum des résultats demandés',
  QueryExceptionAggregatedMirrorDead: 'Le miroir agrégé est hors-ligne',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Délai de requête du miroir agrégé dépassé',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Numéro de version du miroir agrégé invalide',
  QueryExceptionAggregatedMirrorCannotConnect: 'Connexion impossible au miroir agrégé',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Pas assez de caractères en début de chaîne pour le métacaractère',
  QueryExceptionSecurityInverterNotFound: 'Inverseur de sécurité introuvable',
  QueryExceptionSecurityInverterAccessDenied: "Accès refusé à l'inverseur de sécurité",
  QueryExceptionAggregatedMirrorCannotImpersonate: "Le miroir agrégé ne peut pas usurper l'identité",
  QueryExceptionUnexpected: 'Inattendu',
  QueryExceptionAccessDenied: 'Accès refusé',
  QueryExceptionSuperUserTokenInvalid: 'Jeton du super-utilisateur invalide',
  QueryExceptionSuperUserTokenExpired: 'Le jeton du super-utilisateur est expiré',
  QueryExceptionLicenseQueriesExpired: 'La licence de requêtes est expirée',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'Licence de jeton de super utilisateur non pris en charge',
  QueryExceptionInvalidSession: 'Session invalide',
  QueryExceptionInvalidDocument: 'Document invalide',
  QueryExceptionSearchDisabled: 'Recherche désactivée',
  FileType: 'Type de fichier',
  ShowAttachment: 'Voir pièce jointe',
  OnFeed: 'sur le fil de {0}.',
  Author: 'Auteur',
  NoTitle: 'Pas de titre',
  CurrentSelections: 'Sélections courantes',
  AllContent: 'Tout le contenu',
  CancelLastAction: 'Annuler la dernière action',
  SearchTips: 'Conseils de recherche',
  CheckSpelling: "Vérifiez l'orthographe de vos mots-clés.",
  TryUsingFewerKeywords: "Essayez d'utiliser moins ou différents mots-clés.",
  SelectFewerFilters: 'Sélectionner moins de filtres pour élargir votre recherche.',
  Document: 'Document',
  Time: 'Temps',
  StartDate: 'Date de début',
  StartTime: 'Heure de début',
  DurationTitle: 'Durée',
  UserQuery: "Requête de l'utilisateur",
  ShowUserActions: "Afficher les actions de l'utilisateur",
  NoData: 'Aucune donnée disponible',
  EventType: "Type d'évenement",
  GoToFullSearch: 'Aller à la page de recherche',
  GoToEdition: 'Personnaliser le panneau',
  RemoveContext: 'Enlever le contexte',
  BoxAttachToCase: 'Attacher à la requête',
  AttachToCase: 'Attacher à la requête',
  Attach: 'Attacher',
  Attached: 'Attaché',
  Detach: 'Détacher',
  Details: 'Détails',
  AdditionalFilters: 'Filtres additionnels',
  SelectNonContextualSearch: "Enlevez le contexte de l'entrée courante pour élargir vos résultats de recherche",
  CopyPasteToSupport: "Copier-coller ce message à l'équipe de support de Coveo pour plus d'informations.",
  FollowQueryDescription: 'Avertissez-moi lorsque les résultats de recherche de cette requête changent.',
  SearchAlerts_Panel: 'Gérer les alertes',
  SearchAlerts_PanelDescription: 'Afficher et gérer vos alertes de recherche.',
  SearchAlerts_PanelNoSearchAlerts: "Vous n'avez aucun abonnement.",
  SearchAlerts_Fail: "Le service d'alertes de recherche n'est actuellement pas disponible.",
  SearchAlerts_Type: 'Type',
  SearchAlerts_Content: 'Contenu',
  SearchAlerts_Actions: 'Action',
  EmptyQuery: '<vide>',
  SearchAlerts_Type_followQuery: 'Requête',
  SearchAlerts_Type_followDocument: 'Item',
  SearchAlerts_unFollowing: 'Ne plus suivre',
  SearchAlerts_follow: 'Suivre',
  SearchAlerts_followed: 'Suivi',
  SearchAlerts_followQuery: 'Suivre la requête',
  Subscription_StopFollowingQuery: 'Ne plus suivre la requête',
  SearchAlerts_Frequency: 'Quand',
  SubscriptionsManageSubscriptions: 'Gérer vos alertes',
  SubscriptionsMessageFollowQuery: 'Vous recevrez des alertes lorsque la requête <b>{0}</ b> retournera des items nouveaux ou mis à jour.',
  SubscriptionsMessageFollow: "Vous recevrez des alertes lorsque l'item <b>{0}</b> sera mis à jour.",
  Expiration: 'Expiration',
  Monthly: 'Mensuel',
  Daily: 'Quotidiennement',
  Monday: 'Lundi',
  Tuesday: 'Mardi',
  Wednesday: 'Mercredi',
  Thursday: 'Jeudi',
  Friday: 'Vendredi',
  Saturday: 'Samedi',
  Sunday: 'Dimanche',
  NextDay: '{0} prochain',
  LastDay: '{0} dernier',
  StartTypingCaseForSuggestions: 'Décrivez votre problème pour voir des solutions possibles',
  ExportToExcel: 'Exportez en format Excel',
  ExportToExcelDescription: 'Exportez les résultats de recherche en format Excel',
  CaseCreationNoResults: "Aucune recommandation de solution n'a été trouvée",
  SortBy: 'Trier par',
  BoxCreateArticle: 'Créer un Article',
  Facets: 'Facettes',
  AdvancedSearch: 'Recherche Avancée',
  Keywords: 'Mot-clés',
  AllTheseWords: 'Tous ces mots',
  ExactPhrase: 'Cette phrase exacte',
  AnyOfTheseWords: "N'importe lequel de ces mots",
  NoneOfTheseWords: 'Aucun de ces mots',
  Anytime: "N'importe quand",
  InTheLast: 'Dans les derniers',
  Days: 'jours',
  Months: 'mois',
  Month: 'Mois',
  Year: 'Année',
  Between: 'Entre',
  Language: 'Langage',
  Size: 'Taille',
  AtLeast: 'au moins',
  AtMost: 'au plus',
  Contains: 'contient',
  DoesNotContain: 'ne contient pas',
  Matches: 'égale',
  Bytes: 'octets',
  card: 'Carte',
  table: 'Tableau',
  ResultLinks: 'Liens de résultat',
  EnableQuerySyntax: 'Activation de la syntaxe de recherche',
  On: 'Activé',
  Off: 'Désactivé',
  Automatic: 'Automatique',
  ResultsPerPage: 'Résultats par page',
  PreviousMonth: 'Mois précédent',
  NextMonth: 'Mois suivant',
  Title: 'Titre',
  FiltersInAdvancedSearch: 'Filtres pour la Recherche Avancée',
  NoEndpoints: "{0} n'a pas de point de terminaison unique.",
  InvalidToken: "Le jeton d'identification est invalide.",
  AddSources: "Vous devrez ajouter des sources à votre index, ou attendre la fin de l'indexation des sources créées.",
  TryAgain: 'Veuillez essayer de nouveau.',
  CoveoOnlineHelp: 'Aide en ligne Coveo',
  CannotAccess: "Une erreur s'est produite.",
  CoveoOrganization: 'Organisation Coveo',
  SearchAPIDuration: "Durée de l'API de recherche : {0}",
  LastUpdated: 'Dernière mise à jour',
  AllDates: 'Toutes les dates',
  WithinLastDay: 'Depuis le dernier jour',
  WithinLastWeek: 'Depuis la dernière semaine',
  WithinLastMonth: 'Depuis le dernier mois',
  WithinLastYear: 'Depuis la dernière année',
  RelevanceInspector: 'Inspecteur de Pertinence des Documents',
  KeywordInCategory: '{0} <span class="coveo-omnibox-suggestion-category">dans {1}</span>',
  ResultCount: '{0} résultat<pl>s</pl>',
  ShowingResults: '{0} résultat<pl>s</pl>',
  ShowingResultsWithQuery: '{0} résultat<pl>s</pl> pour {1}',
  NumberOfVideos: 'Nombre de vidéos',
  AllCategories: 'Toutes les catégories',
  Recommended: 'Recommandé',
  Featured: 'En vedette',
  CoveoHomePage: "Page d'accueil Coveo",
  SizeValue: 'Valeur de la taille',
  UnitMeasurement: 'Unité de taille',
  Toggle: 'Basculer',
  FilterOn: 'Filtrer sur {0}',
  RemoveFilterOn: "Enlever le filtre d'inclusion sur {0}",
  Enter: 'Entrée',
  InsertAQuery: 'Rechercher',
  PressEnterToSend: '',
  SortResultsBy: 'Trier les résultats par {0}',
  SortResultsByAscending: 'Trier en ordre croissant de {0}',
  SortResultsByDescending: 'Trier en ordre décroissant de {0}',
  DisplayResultsAs: 'Afficher les résultats comme {0}',
  FacetTitle: 'Facette {0}',
  IncludeValueWithResultCount: "Filtre d'inclusion sur {0}; {1}",
  ExcludeValueWithResultCount: "Filtre d'exclusion sur {0}; {1}",
  PageNumber: 'Page {0}',
  DisplayResultsPerPage: 'Afficher {0} résultats par page',
  GroupByAndFacetRequestsCannotCoexist: "La requête n'est pas valide car elle contient les requêtes Group By et Facet. Assurez-vous que l'interface de recherche n'initialise pas les composants DynamicFacet aux côtés des composants Facet (ou de tout composant d'extension du composant Facet, tel que FacetRange ou FacetSlider).",
  MustContain: 'Doit contenir:',
  Missing: 'Manquant(s):',
  Filters: 'Filtres',
  FiltersDropdown: 'Menu déroulant de filtres',
  OpenFiltersDropdown: 'Ouvrir le menu déroulant de filtres',
  CloseFiltersDropdown: 'Fermer le menu déroulant de filtres',
  NoValuesFound: 'Aucune valeur trouvée.',
  To: 'à',
  DeselectFilterValues: 'Effacer tout de filtres actifs dans {0}',
  Rated: 'Évalué {0} sur {1} étoile<pl>s<pl/>',
  RatedBy: 'par {0} utilisateur<pl>s</pl>',
  NoRatings: 'Aucune évaluation',
  Pagination: 'Pagination',
  ThumbnailOf: 'Aperçu de « {0} »',
  CollapsedUriParts: "Segments d'URI réduits",
  HierarchicalFacetValueIndentedUnder: '{0} sous {1}',
  HierarchicalFacetValuePathPrefix: 'dans',
  UsefulnessFeedbackRequest: 'Était-ce utile?',
  UsefulnessFeedbackThankYou: 'Merci pour votre rétroaction!',
  UsefulnessFeedbackExplainWhy: 'Expliquer pourquoi',
  UsefulnessFeedbackExplainWhyImperative: 'Expliquez pourquoi',
  UsefulnessFeedbackDoesNotAnswer: "Ceci n'a pas répondu à ma question du tout",
  UsefulnessFeedbackPartiallyAnswers: 'Ceci a seulement partiellement répondu à ma question',
  UsefulnessFeedbackWasNotAQuestion: "Ma requête n'était pas sensée être perçue comme une question",
  Yes: 'Oui',
  No: 'Non',
  Other: 'Autre',
  Send: 'Envoyer',
  UsefulnessFeedbackReason: 'Raison',
  AnswerSnippet: 'Réponse à votre question',
  AnswerSpecificSnippet: 'Réponse à « {0} »',
  SuggestedQuestions: 'Autres questions posées',
  ExpandQuestionAnswer: 'Regarder la réponse à « {0} »',
  MoreValuesAvailable: 'des valeurs additionnelles sont disponibles',
  Breadcrumb: 'Filtres actifs',
  TRCoveoSearchResults: 'Résultats de la recherche',
  TRCoveoApply: 'Appliquer',
  TRCoveoClearAll: 'Effacer tout',
  TRLogin: 'Connexion',
  TRSupport: 'Assistance',
  TRStoreFormat: 'Format',
  TRStorePrice: 'Prix ',
  TRStoreStartingAt: '(à partir de)',
  TRStoreAvailability: 'Disponibilité',
  TRFilter: 'Filtre',
  TRFilters: 'Filtres',
  TRNoResultsFound: 'Aucun résultat trouvé',
  TRDidntFindResults: "Nous n'avons trouvé aucun résultat pour {0}.",
  TRSuggestions: 'Suggestions',
  TRSpellAllWordsCorrectly: 'Orthographiez correctement tous les mots',
  TRChangeOrClearFilters: 'Modifier ou {clear} vos filtres',
  TRTryDifferentKeywords: "Essayez d'autres mots-clés",
  TRViewingNoResults: 'Affichage : 0 résultat pour {0}',
  TRMin: 'min',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: 'Continuez à chercher !',
  TRKeepSearchingDescription: 'Et nous continuerons à écrire.  Chaque recherche que vous réalisez nous aide à mieux comprendre ce que vous recherchez.',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  TRNMoreFormat: 'autres format(s)',
  Product: 'Produit',
  'Sub-Product': 'Sous-produit',
  State: 'État',
  'Return Type': 'Type de retour',
  City: 'Ville',
  Video: 'Vidéo'
};

/* eslint-disable import/no-anonymous-default-export */
var zh_cn = {
  'box user': '用户',
  'filetype_box user': '用户',
  lithiummessage: 'Lithium 消息',
  filetype_lithiummessage: 'Lithium 消息',
  lithiumthread: 'Lithium 线程',
  filetype_lithiumthread: 'Lithium 线程',
  lithiumboard: 'Lithium 保护板',
  filetype_lithiumboard: 'Lithium 保护板',
  lithiumcategory: 'Lithium 类别',
  filetype_lithiumcategory: 'Lithium 类别',
  lithiumcommunity: 'Lithium 社区',
  filetype_lithiumcommunity: 'Lithium 社区',
  incident: '案例',
  youtube: 'YouTube 视频',
  filetype_youtube: 'YouTube 视频',
  html: 'HTML 文件',
  filetype_html: 'HTML 文件',
  wiki: '维基百科',
  filetype_wiki: '维基百科',
  webscraperwebpage: '网页',
  filetype_webscraperwebpage: '网页',
  image: '图片',
  filetype_image: '图片',
  folder: '文件夹',
  filetype_folder: '文件夹',
  txt: '文本',
  filetype_txt: '文本',
  zip: 'Zip 文件',
  filetype_zip: 'Zip 文件',
  olefile: 'OLE 文件',
  filetype_olefile: 'OLE 文件',
  gmailmessage: 'Gmail 消息',
  filetype_gmailmessage: 'Gmail 消息',
  pdf: 'PDF 文件',
  filetype_pdf: 'PDF 文件',
  swf: 'Flash 文件',
  filetype_swf: 'Flash 文件',
  xml: 'XML 文件',
  filetype_xml: 'XML 文件',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: '打开 Office',
  filetype_svm: '打开 Office',
  rssitem: 'RSS 源',
  filetype_rssitem: 'RSS 源',
  doc: '文档',
  filetype_doc: '文档',
  docx: 'Microsoft Word 文档',
  filetype_docx: 'Microsoft Word 文档',
  xls: '电子数据表文档',
  filetype_xls: '电子数据表文档',
  ppt: '演示文档',
  filetype_ppt: '演示文档',
  video: '视频',
  filetype_video: '视频',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: '打开文本文档',
  filetype_odt: '打开文本文档',
  people: '用户',
  objecttype_people: '用户',
  message: '消息',
  objecttype_message: '消息',
  feed: 'RSS 源',
  objecttype_feed: 'RSS 源',
  thread: '线程',
  objecttype_thread: '线程',
  file: '文件',
  objecttype_file: '文件',
  board: '保护板',
  objecttype_board: '保护板',
  category: '类别',
  objecttype_category: '类别',
  account: '账户',
  objecttype_account: '账户',
  annotation: '注释',
  objecttype_annotation: '注释',
  campaign: '活动',
  objecttype_campaign: '活动',
  "case": '案例',
  objecttype_case: '案例',
  contact: '联系',
  objecttype_contact: '联系',
  contract: '合同',
  objecttype_contract: '合同',
  event: '事件',
  objecttype_event: '事件',
  email: '电子邮件',
  objecttype_email: '电子邮件',
  goal: '目标',
  objecttype_goal: '目标',
  objecttype_incident: '案例',
  invoice: '账单',
  objecttype_invoice: '账单',
  lead: '带领',
  objecttype_lead: '带领',
  list: '列表',
  objecttype_list: '市场列表',
  solution: '解决方案',
  objecttype_solution: '解决方案',
  task: '任务',
  objecttype_task: '任务',
  user: '用户',
  objecttype_user: '用户',
  attachment: '附件',
  objecttype_attachment: '附件',
  casecomment: '案例意见',
  objecttype_casecomment: '案例意见',
  opportunity: '机会',
  objecttype_opportunity: '机会',
  opportunityproduct: '机会产品',
  objecttype_opportunityproduct: '机会产品',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: '注释',
  objecttype_note: '注释',
  product: '产品',
  objecttype_product: '产品',
  partner: '合作伙伴',
  objecttype_partner: '合作伙伴',
  queueitem: '列队项目',
  objecttype_queueitem: '列队项目',
  quote: '引用',
  objecttype_quote: '引用',
  salesliterature: '销售说明书',
  objecttype_salesliterature: '销售说明书',
  salesorder: '销售订单',
  objecttype_salesorder: '销售订单',
  service: '服务',
  objecttype_service: '服务',
  socialprofile: '社会形象',
  objecttype_socialprofile: '社会形象',
  kbdocumentation: '文件',
  objecttype_kbdocumentation: '文件',
  kbtechnicalarticle: '文件',
  objecttype_kbtechnicalarticle: '文件',
  kbsolution: '解决方案',
  objecttype_kbsolution: '解决方案',
  kbknowledgearticle: '知识文章',
  objecttype_kbknowledgearticle: '知识文章',
  kbattachment: '附件',
  objecttype_kbattachment: '附件',
  kbarticle: '文章',
  objecttype_kbarticle: '文章',
  kbarticlecomment: '文章评论',
  objecttype_kbarticlecomment: '文章评论',
  knowledgearticle: '知识文章',
  objecttype_knowledgearticle: '知识文章',
  topic: '主题',
  objecttype_topic: '主题',
  dashboard: '仪表板',
  objecttype_dashboard: '仪表板',
  contentversion: '文档',
  objecttype_contentversion: '文档',
  collaborationgroup: '协作组',
  objecttype_collaborationgroup: '协作组',
  spportal: '入口',
  filetype_spportal: '入口',
  spsite: '站点',
  filetype_spsite: '站点',
  spuserprofile: 'SharePoint 用户',
  filetype_spuserprofile: 'SharePoint 用户',
  sparea: '区域',
  filetype_sparea: '区域',
  spannouncement: '公告',
  filetype_spannouncement: '公告',
  spannouncementlist: '公告',
  filetype_spannouncementlist: '公告',
  spcontact: '联系',
  filetype_spcontact: '联系',
  spcontactlist: '联系',
  filetype_spcontactlist: '联系',
  spcustomlist: '自定义列表',
  filetype_spcustomlist: '自定义列表',
  spdiscussionboard: '讨论板块',
  filetype_spdiscussionboard: '讨论板块',
  spdiscussionboardlist: '讨论板块',
  filetype_spdiscussionboardlist: '讨论板块',
  spdocumentlibrarylist: '文档库',
  filetype_spdocumentlibrarylist: '文档库',
  spevent: '事件',
  filetype_spevent: '事件',
  speventlist: '事件',
  filetype_speventlist: '事件',
  spformlibrarylist: '从库',
  filetype_spformlibrarylist: '从库',
  spissue: '问题',
  filetype_spissue: '问题',
  spissuelist: '问题',
  filetype_spissuelist: '问题',
  splink: '链接',
  filetype_splink: '链接',
  splinklist: '链接',
  filetype_splinklist: '链接',
  sppicturelibrarylist: '图片库',
  filetype_sppicturelibrarylist: '图片库',
  spsurvey: '调查',
  filetype_spsurvey: '调查',
  spsurveylist: '调查',
  filetype_spsurveylist: '调查',
  sptask: '任务',
  filetype_sptask: '任务',
  sptasklist: '任务',
  filetype_sptasklist: '任务',
  spagenda: '议程',
  filetype_spagenda: '议程',
  spagendalist: '议程',
  filetype_spagendalist: '议程',
  spattendee: '参会人',
  filetype_spattendee: '参会人',
  spattendeelist: '参会人',
  filetype_spattendeelist: '参会人',
  spcustomgridlist: '自定义网格',
  filetype_spcustomgridlist: '自定义网格',
  spdecision: '决定',
  filetype_spdecision: '决定',
  spdecisionlist: '决定',
  filetype_spdecisionlist: '决定',
  spobjective: '目的',
  filetype_spobjective: '目的',
  spobjectivelist: '目的',
  filetype_spobjectivelist: '目的',
  sptextbox: '文本框',
  filetype_sptextbox: '文本框',
  sptextboxlist: '文本框列表',
  filetype_sptextboxlist: '文本框列表',
  spthingstobring: '议题',
  filetype_spthingstobring: '议题',
  spthingstobringlist: '议题',
  filetype_spthingstobringlist: '议题',
  sparealisting: '区域列表',
  filetype_sparealisting: '区域列表',
  spmeetingserie: '会议系列',
  filetype_spmeetingserie: '会议系列',
  spmeetingserielist: '会议系列列表',
  filetype_spmeetingserielist: '会议系列列表',
  spsitedirectory: '站点目录项',
  filetype_spsitedirectory: '站点目录项',
  spsitedirectorylist: '站点目录',
  filetype_spsitedirectorylist: '站点目录',
  spdatasource: '数据源',
  filetype_spdatasource: '数据源',
  spdatasourcelist: '数据源列表',
  filetype_spdatasourcelist: '数据源列表',
  splisttemplatecataloglist: '列表模板库',
  filetype_splisttemplatecataloglist: '列表模板库',
  spwebpartcataloglist: 'WebPart库',
  filetype_spwebpartcataloglist: 'WebPart库',
  spwebtemplatecataloglist: '站点模板库',
  filetype_spwebtemplatecataloglist: '站点模板库',
  spworkspacepagelist: '工作区页面',
  filetype_spworkspacepagelist: '工作区页面',
  spunknownlist: '自定义列表',
  filetype_spunknownlist: '自定义列表',
  spadministratortask: '管理员任务',
  filetype_spadministratortask: '管理员任务',
  spadministratortasklist: '管理员任务',
  filetype_spadministratortasklist: '管理员任务',
  spareadocumentlibrarylist: '区域文档库',
  filetype_spareadocumentlibrarylist: '区域文档库',
  spblogcategory: '博客分类',
  filetype_spblogcategory: '博客分类',
  spblogcategorylist: '博客分类',
  filetype_spblogcategorylist: '博客分类',
  spblogcomment: '博客评论',
  filetype_spblogcomment: '博客评论',
  spblogcommentlist: '博客评论',
  filetype_spblogcommentlist: '博客评论',
  spblogpost: '博客帖子',
  filetype_spblogpost: '博客帖子',
  spblogpostlist: '博客帖子',
  filetype_spblogpostlist: '博客帖子',
  spdataconnectionlibrarylist: '数据连接库',
  filetype_spdataconnectionlibrarylist: '数据连接库',
  spdistributiongroup: '通讯组',
  filetype_spdistributiongroup: '通讯组',
  spdistributiongrouplist: '通讯组',
  filetype_spdistributiongrouplist: '通讯组',
  spipfslist: 'InfoPath 表格服务器',
  filetype_spipfslist: 'InfoPath 表格服务器',
  spkeyperformanceindicator: '关键性能指示器',
  filetype_spkeyperformanceindicator: '关键性能指示器',
  spkeyperformanceindicatorlist: '关键性能指示器',
  filetype_spkeyperformanceindicatorlist: '关键性能指示器',
  splanguagesandtranslator: '语言和翻译',
  filetype_splanguagesandtranslator: '语言和翻译',
  splanguagesandtranslatorlist: '语言和翻译',
  filetype_splanguagesandtranslatorlist: '语言和翻译',
  spmasterpagescataloglist: '主页面库',
  filetype_spmasterpagescataloglist: '主页面库',
  spnocodeworkflowlibrarylist: '无代码工作流程库',
  filetype_spnocodeworkflowlibrarylist: '无代码工作流程库',
  spprojecttask: '项目任务',
  filetype_spprojecttask: '项目任务',
  spprojecttasklist: '项目任务',
  filetype_spprojecttasklist: '项目任务',
  sppublishingpageslibrarylist: '页面库',
  filetype_sppublishingpageslibrarylist: '页面库',
  spreportdocumentlibrarylist: '报告文档库',
  filetype_spreportdocumentlibrarylist: '报告文档库',
  spreportlibrarylist: '报告库',
  filetype_spreportlibrarylist: '报告库',
  spslidelibrarylist: '滑动库',
  filetype_spslidelibrarylist: '滑动库',
  sptab: '标签',
  filetype_sptab: '标签',
  sptablist: '标签列表',
  filetype_sptablist: '标签列表',
  sptranslationmanagementlibrarylist: '翻译管理库',
  filetype_sptranslationmanagementlibrarylist: '翻译管理库',
  spuserinformation: '用户信息',
  filetype_spuserinformation: '用户信息',
  spuserinformationlist: '用户信息列表',
  filetype_spuserinformationlist: '用户信息列表',
  spwikipagelibrarylist: '维基百科页面库',
  filetype_spwikipagelibrarylist: '维基百科页面库',
  spworkflowhistory: '工作流程历史',
  filetype_spworkflowhistory: '工作流程历史',
  spworkflowhistorylist: '工作流程历史列表',
  filetype_spworkflowhistorylist: '工作流程历史列表',
  spworkflowprocess: '自定义工作流过程',
  filetype_spworkflowprocess: '自定义工作流过程',
  spworkflowprocesslist: '自定义工作流过程',
  filetype_spworkflowprocesslist: '自定义工作流过程',
  sppublishingimageslibrarylist: '发布图像库',
  filetype_sppublishingimageslibrarylist: '发布图像库',
  spcirculation: '循环',
  filetype_spcirculation: '循环',
  spcirculationlist: '循环',
  filetype_spcirculationlist: '循环',
  spdashboardslibrarylist: '仪表板库',
  filetype_spdashboardslibrarylist: '仪表板库',
  spdataconnectionforperformancepointlibrarylist: 'PerformancePoint 数据连接库',
  filetype_spdataconnectionforperformancepointlibrarylist: 'PerformancePoint 数据连接库',
  sphealthreport: '健康报告',
  filetype_sphealthreport: '健康报告',
  sphealthreportlist: '健康报告',
  filetype_sphealthreportlist: '健康报告',
  sphealthrule: '健康规则',
  filetype_sphealthrule: '健康规则',
  sphealthrulelist: '健康规则',
  filetype_sphealthrulelist: '健康规则',
  spimedictionary: 'IME 字典',
  filetype_spimedictionary: 'IME 字典',
  spimedictionarylist: 'IME 字典',
  filetype_spimedictionarylist: 'IME 字典',
  spperformancepointcontent: 'PerformancePoint 内容',
  filetype_spperformancepointcontent: 'PerformancePoint 内容',
  spperformancepointcontentlist: 'PerformancePoint 内容',
  filetype_spperformancepointcontentlist: 'PerformancePoint 内容',
  spphonecallmemo: '电话通话备忘录',
  filetype_spphonecallmemo: '电话通话备忘录',
  spphonecallmemolist: '电话通话备忘录',
  filetype_spphonecallmemolist: '电话通话备忘录',
  sprecordlibrarylist: '记录库',
  filetype_sprecordlibrarylist: '记录库',
  spresource: '资源',
  filetype_spresource: '资源',
  spresourcelist: '资源',
  filetype_spresourcelist: '资源',
  spprocessdiagramslibrarylist: '流程图库',
  filetype_spprocessdiagramslibrarylist: '流程图库',
  spsitethemeslibrarylist: '站点主题库',
  filetype_spsitethemeslibrarylist: '站点主题库',
  spsolutionslibrarylist: '解决方案库',
  filetype_spsolutionslibrarylist: '解决方案库',
  spwfpublibrarylist: 'WFPUB 库',
  filetype_spwfpublibrarylist: 'WFPUB 库',
  spwhereabout: '行踪',
  filetype_spwhereabout: '行踪',
  spwhereaboutlist: '行踪',
  filetype_spwhereaboutlist: '行踪',
  spdocumentlink: '链接到文档',
  filetype_spdocumentlink: '链接到文档',
  spdocumentset: '文件组',
  filetype_spdocumentset: '文件组',
  spmicrofeedpost: 'Microfeed 帖子',
  filetype_spmicrofeedpost: 'Microfeed 帖子',
  spmicrofeedlist: 'Microfeed',
  filetype_spmicrofeedlist: 'Microfeed',
  splistfolder: '列表文件夹',
  filetype_splistfolder: '列表文件夹',
  Unknown: '未知',
  And: '与',
  Authenticating: '验证 {0}...',
  Clear: '清除 {0}',
  CompleteQuery: '完整查询',
  Exclude: '排除 {0}',
  EnterTag: '添加标记',
  Next: '下一页',
  Last: '最后一页',
  Link: '链接',
  Or: '或',
  Previous: '上一页',
  QueryDidntMatchAnyDocuments: '您的查询与任何文档都不匹配。',
  QueryException: '您的查询存在错误： {0}。',
  Me: '我',
  Remove: '删除',
  Search: '搜索',
  SearchFor: '搜索 {0}',
  ShareQuery: '共享查询',
  Preferences: '首选项',
  LinkOpeningSettings: '链接打开设置',
  Reauthenticate: '重新验证 {0}',
  ResultsFilteringExpression: '结果筛选表达式',
  FiltersInYourPreferences: '首选项中的筛选条件',
  Create: '创建',
  SearchIn: '在 {0} 中搜索',
  Seconds: '用时 {0} 秒',
  ShowingResultsOf: '查看：第{0}<pl>到{1}条{2}的</pl>结果<pl></pl>',
  ShowingResultsOfWithQuery: '查看：第{0}<pl>到{1}条{2}的</pl>结果<pl></pl>（设置筛选条件{3})',
  SwitchTo: '切换到 {0}',
  Unexclude: '不排除 {0}',
  ClearAllFilters: '清除所有筛选条件',
  SkipLogin: '跳过登录',
  LoginInProgress: '正在登录，请稍候...',
  Login: '登录',
  GetStarted: '开始体验',
  More: '更多',
  NMore: '显示更多 ({0})',
  Less: '更少',
  Settings: '设置',
  Score: '得分',
  ScoreDescription: '得分是根据出现次数和在结果集中的位置计算得来。',
  Occurrences: '出现次数',
  OccurrencesDescription: '按出现次数排序，出现次数最高的值排在首位。',
  Label: '标签',
  Of: '第...个，共...个',
  LabelDescription: '对字段值按字母顺序排序。',
  Value: '值',
  ValueDescription: '按第一个计算得出的字段的值排序',
  AlphaAscending: '值升序排序',
  AlphaDescending: '值降序排序',
  ChiSquare: '卡方值',
  Nosort: '无排序',
  NosortDescription: '不排序值。值将返回随机顺序排列。',
  RelativeFrequency: '相对频率',
  RelativeFrequencyDescription: '基于值的相对频率排序。较不常见的值将出现在较高位置。',
  DateDistribution: '日期分布',
  Custom: '自定义',
  CustomDescription: '基于自定义顺序排序',
  ComputedField: '计算得出的字段',
  Ascending: '升序',
  Descending: '降序',
  noResultFor: '没有找到与 {0} 相关的结果',
  autoCorrectedQueryTo: '查询自动更正为 {0}',
  didYouMean: '您是想 {0}',
  SuggestedResults: '建议的结果',
  SuggestedQueries: '建议的查询',
  MostRelevantItems: '最相关的项：',
  AllItems: '所有项：',
  ShowLess: '显示较少的值',
  ShowMore: '显示较多的值',
  HideFacet: '隐藏快捷控制界面',
  ShowFacet: '显示快捷控制界面',
  AndOthers: '以及 {0} 个其他项',
  Others: '{0} 个其他项',
  MostRelevantPosts: '最相关的帖子：',
  CompleteThread: '完整的主题：',
  ShowCompleteThread: '显示完整的主题',
  ShowOnlyTopMatchingPosts: '仅显示最匹配的帖子',
  MostRelevantReplies: '最相关的回复：',
  AllConversation: '所有对话：',
  ShowAllConversation: '显示所有对话',
  ShowAllReplies: '显示所有回复',
  ShowOnlyMostRelevantReplies: '仅显示最相关的回复',
  Close: '关闭',
  Open: '打开',
  OpenInOutlookWhenPossible: '在 Outlook 中打开（如果可能）',
  AlwaysOpenInNewWindow: '总是在新窗口中打开结果',
  Quickview: '快速查看',
  NoQuickview: '该文件无法快速浏览。',
  ErrorReport: '错误报告',
  OopsError: 'Search is down',
  ProblemPersists: "We're experiencing an issue with search. The good news is, we're on it! Try your search later.",
  GoBack: 'Go Back',
  Reset: '重置',
  Retry: '重试',
  MoreInfo: '更多信息',
  Username: '用户名',
  Password: '密码',
  PostedBy: '发贴者',
  CannotConnect: '无法连接到该服务器地址。',
  BadUserPass: '密码与用户名不匹配。',
  PleaseEnterYourCredentials: '请输入您的 {0} 凭据。',
  PleaseEnterYourSearchPage: '请输入您的搜索页面的网址',
  Collapse: '折叠',
  Collapsable: '可折叠',
  Expand: '展开',
  Today: '今天',
  Yesterday: '昨天',
  Tomorrow: '明天',
  Duration: '持续时间： {0}',
  IndexDuration: '索引持续时间： {0}',
  ProxyDuration: '代理持续时间： {0}',
  ClientDuration: '客户端持续时间： {0}',
  Unavailable: '不可用',
  Reply: '回复',
  ReplyAll: '全部回复',
  Forward: '转发',
  From: '发件人',
  Caption: '标题',
  Expression: '表达式',
  Tab: '选项卡',
  Tabs: '多个选项卡',
  EnterExpressionName: '输入表达式名称',
  EnterExpressionToFilterWith: '输入用于筛选结果的表达式',
  SelectTab: '选择选项卡',
  SelectAll: '全选',
  PageUrl: '搜索页面的网址',
  ErrorSavingToDevice: '在将信息保存到您的设备时出错',
  ErrorReadingFromDevice: '在从您的设备读取信息时出错',
  AppIntro: '咨询能够回答您有关 Coveo 的问题的产品专家，并帮助您确定哪个 Coveo 解决方案适合您。或者，尝试现场演示！',
  TryDemo: '尝试演示',
  ContactUs: '联系我们',
  NewToCoveo: 'Coveo 的新用户？',
  LetUsHelpGetStarted: '让我们帮助您开始体验',
  LikesThis: '{0} 喜欢此解决方案。',
  CannotConnectSearchPage: '无法连接到您的搜索页面',
  AreYouSureDeleteFilter: '您是否确定要删除采用 {1} 表达式的筛选条件 {0}',
  OnlineHelp: '在线帮助',
  Done: '完成',
  SaveFacetState: '保存此快捷控制界面状态',
  ClearFacetState: '清除快捷控制界面状态',
  DisplayingTheOnlyMessage: '仅显示此对话中的消息',
  NoNetworkConnection: '没有网络连接',
  UnknownConnection: '未知的连接',
  EthernetConnection: '以太网连接',
  WiFi: 'WiFi 连接',
  CELL: '移动连接',
  CELL_2G: '移动 2G 连接',
  CELL_3G: '移动 3G 连接',
  CELL_4G: '移动 4G 连接',
  Relevance: '关联',
  Date: '日期',
  Amount: '数量',
  QueryExceptionNoException: '没有例外',
  QueryExceptionInvalidSyntax: '无效语法',
  QueryExceptionInvalidCustomField: '无效自定义字段',
  QueryExceptionInvalidDate: '无效日期',
  QueryExceptionInvalidExactPhrase: '无效精确短语',
  QueryExceptionInvalidDateOp: '无效日期运算符',
  QueryExceptionInvalidNear: '无效 NEAR 运算符',
  QueryExceptionInvalidWeightedNear: '无效加权 NEAR',
  QueryExceptionInvalidTerm: '无效条件',
  QueryExceptionTooManyTerms: '太多条件',
  QueryExceptionWildcardTooGeneral: '通配符太常见',
  QueryExceptionInvalidSortField: '无效排序字段',
  QueryExceptionInvalidSmallStringOp: '无效小字符串运算符',
  QueryExceptionRequestedResultsMax: '要求的最大结果数',
  QueryExceptionAggregatedMirrorDead: '远程聚合镜像处于离线状态',
  QueryExceptionAggregatedMirrorQueryTimeOut: '远程聚合镜像查询超时',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: '远程聚合镜像无效版本号',
  QueryExceptionAggregatedMirrorCannotConnect: '远程聚合镜像无法连接',
  QueryExceptionNotEnoughLeadingCharsWildcard: '主字符通配符不足',
  QueryExceptionSecurityInverterNotFound: '未找到安全变换器',
  QueryExceptionSecurityInverterAccessDenied: '安全变换器访问被拒绝',
  QueryExceptionAggregatedMirrorCannotImpersonate: '远程聚合镜像无法模拟',
  QueryExceptionUnexpected: '意外',
  QueryExceptionAccessDenied: '访问被拒绝',
  QueryExceptionSuperUserTokenInvalid: '超级用户令牌无效',
  QueryExceptionSuperUserTokenExpired: '超级用户令牌已过期',
  QueryExceptionLicenseQueriesExpired: '查询许可证已过期',
  QueryExceptionLicenseSuperUserTokenNotSupported: '许可证超级用户令牌不支持',
  QueryExceptionInvalidSession: '无效会话',
  QueryExceptionInvalidDocument: '无效文档',
  QueryExceptionSearchDisabled: '搜索被禁用',
  FileType: '文件类型',
  ShowAttachment: '显示附件',
  OnFeed: '有关 {0} 的输入。',
  Author: '作者',
  NoTitle: '无标题',
  CurrentSelections: '当前选择',
  AllContent: '所有内容',
  CancelLastAction: '取消最后一个动作',
  SearchTips: '搜索提示',
  CheckSpelling: '检查关键字的拼写。',
  TryUsingFewerKeywords: '尝试使用更少、更常用或不同的关键字。',
  SelectFewerFilters: '选择较少的筛选条件以扩大您的搜索范围。',
  Document: '文件',
  Time: '时间',
  StartDate: '开始日期',
  StartTime: '开始时间',
  DurationTitle: '持续时间',
  UserQuery: '用户查询',
  ShowUserActions: '显示用户指令',
  NoData: '无有效数据',
  EventType: '事件类型',
  GoToFullSearch: '全面搜索',
  GoToEdition: '自定义界面',
  RemoveContext: '清除内容',
  BoxAttachToCase: '为案例添加附件',
  AttachToCase: '为案例添加附件',
  Attach: '附件',
  Attached: '已添加附件',
  Detach: '分离',
  Details: '详细信息',
  AdditionalFilters: '附加筛选器',
  SelectNonContextualSearch: '从当前记录中清除内容，以扩大您的搜索',
  CopyPasteToSupport: '复制并粘贴该消息至 Coveo 支持团队，以获取更多信息。',
  FollowQueryDescription: '通知我更改查询结果。',
  SearchAlerts_Panel: '管理通知',
  SearchAlerts_PanelDescription: '查看并管理您的搜索通知。',
  SearchAlerts_PanelNoSearchAlerts: '您尚未订阅。',
  SearchAlerts_Fail: '当前搜索通知不可用。',
  SearchAlerts_Type: '类型',
  SearchAlerts_Content: '内容',
  SearchAlerts_Actions: '指令',
  EmptyQuery: '<empty>',
  SearchAlerts_Type_followQuery: '查询',
  SearchAlerts_Type_followDocument: '项目',
  SearchAlerts_unFollowing: '停止遵循',
  SearchAlerts_follow: '遵循',
  SearchAlerts_followed: '已遵循',
  SearchAlerts_followQuery: '遵循查询',
  Subscription_StopFollowingQuery: '停止遵循查询',
  SearchAlerts_Frequency: '时间',
  SubscriptionsManageSubscriptions: '管理通知',
  SubscriptionsMessageFollowQuery: '当查询 <b>{0}</b> 返回新项目或更新项目时，您将会收到通知。',
  SubscriptionsMessageFollow: '您将会收到更改项目 <b>{0}</b> 的通知。',
  Expiration: '到期时间',
  Monthly: '月度',
  Daily: '日常',
  Monday: '星期一',
  Tuesday: '星期二',
  Wednesday: '星期三',
  Thursday: '星期四',
  Friday: '星期五',
  Saturday: '星期六',
  Sunday: '星期日',
  NextDay: '下个 {0}',
  LastDay: '上个 {0}',
  StartTypingCaseForSuggestions: '描述您的问题，以查看可能的解决方案',
  ExportToExcel: '导出到 Excel',
  ExportToExcelDescription: '导出搜索结果到 Excel',
  CaseCreationNoResults: '未找到可推荐的解决方案。',
  SortBy: '排序依据',
  BoxCreateArticle: '创建文章',
  Facets: '小平面',
  AdvancedSearch: '高级搜索',
  Keywords: '关键词',
  AllTheseWords: '全部词',
  ExactPhrase: '精确匹配',
  AnyOfTheseWords: '任意词',
  NoneOfTheseWords: '都不是这些词',
  Anytime: '任何时间',
  InTheLast: '最后',
  Days: '天',
  Months: '月',
  Month: '月',
  Year: '年',
  Between: '日期范围',
  Language: '语言',
  Size: '大小',
  AtLeast: '至少',
  AtMost: '至多',
  Contains: '包含',
  DoesNotContain: '不包含',
  Matches: '匹配',
  Bytes: '字节',
  card: '卡片',
  table: '表格',
  ResultLinks: '结果链接',
  EnableQuerySyntax: '启用查询语法',
  On: '开',
  Off: '关',
  Automatic: '自动',
  ResultsPerPage: '每一页的结果',
  PreviousMonth: '上个月',
  NextMonth: '下个月',
  Title: '标题',
  TRCoveoSearchResults: '搜索结果',
  TRCoveoApply: '应用',
  TRCoveoClearAll: '清除所有',
  SearchBoxSearch: '搜索',
  TRNoResultsFound: '未找到记录',
  TRDidntFindResults: '未找到关于 {0} 的任何记录。',
  TRSuggestions: '建议',
  TRSpellAllWordsCorrectly: '请正确拼写所有单词',
  TRChangeOrClearFilters: '改变或 {clear} 筛选条件',
  TRTryDifferentKeywords: '请尝试不同的关键字',
  TRViewingNoResults: '查看：0 条 {0} 的结果',
  TRLogin: '登录',
  TRSupport: '支持',
  TRStoreFormat: '格式',
  TRStoreAvailability: '可用性',
  TRFilter: '筛选条件',
  TRFilters: '筛选条件',
  TRMin: '分钟',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: '继续搜索!',
  TRKeepSearchingDescription: '我们会持续记录。您的每一次搜索都有助于我们找出您要查找的内容。',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  InsertAQuery: '搜索',
  PressEnterToSend: ''
};

/* eslint-disable import/no-anonymous-default-export */
var zh_tw = {
  'box user': '用戶',
  'filetype_box user': '用戶',
  html: 'HTML文件',
  filetype_html: 'HTML文件',
  wiki: 'WiKi',
  filetype_wiki: 'WiKi',
  webscraperwebpage: '網頁',
  filetype_webscraperwebpage: '網頁',
  image: '影像',
  filetype_image: '影像',
  folder: '資料夾',
  filetype_folder: '資料夾',
  txt: '文本',
  filetype_txt: '文本',
  zip: 'Zip文件',
  filetype_zip: 'Zip文件',
  olefile: 'OLE文件',
  filetype_olefile: 'OLE文件',
  gmailmessage: 'Gmail訊息',
  filetype_gmailmessage: 'Gmail訊息',
  pdf: 'PDF文件',
  filetype_pdf: 'PDF文件',
  swf: 'Flash文件',
  filetype_swf: 'Flash文件',
  xml: 'XML文件',
  filetype_xml: 'XML文件',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSS 訂閱',
  filetype_rssitem: 'RSS 訂閱',
  doc: '文檔',
  filetype_doc: '文檔',
  docx: 'Microsoft Word 文檔',
  filetype_docx: 'Microsoft Word 文檔',
  xls: '試算表文文件',
  filetype_xls: '試算表文文件',
  ppt: '演示視窗',
  filetype_ppt: '演示視窗',
  video: '視頻',
  filetype_video: '視頻',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: '打開文本文檔',
  filetype_odt: '打開文本文檔',
  lithiummessage: 'Lithium 訊息',
  filetype_lithiummessage: 'Lithium 訊息',
  lithiumthread: 'Lithium 執行緒',
  filetype_lithiumthread: 'Lithium 執行緒',
  lithiumboard: 'Lithium 寫字板',
  filetype_lithiumboard: 'Lithium 寫字板',
  lithiumcategory: 'Lithium 類別',
  filetype_lithiumcategory: 'Lithium 類別',
  lithiumcommunity: 'Lithium 社區',
  filetype_lithiumcommunity: 'Lithium 社區',
  incident: '實例',
  people: '用戶',
  objecttype_people: '用戶',
  message: '訊息',
  objecttype_message: '訊息',
  feed: 'RSS 訂閱',
  objecttype_feed: 'RSS 訂閱',
  thread: '執行緒',
  objecttype_thread: '執行緒',
  file: '文件',
  objecttype_file: '文件',
  board: '寫字板',
  objecttype_board: '寫字板',
  category: '類別',
  objecttype_category: '類別',
  account: '帳戶',
  objecttype_account: '帳戶',
  annotation: '注解',
  objecttype_annotation: '注解',
  campaign: '活動',
  objecttype_campaign: '活動',
  "case": '實例',
  objecttype_case: '實例',
  contact: '聯繫方式',
  objecttype_contact: '聯繫方式',
  contract: '聯繫方式',
  objecttype_contract: '聯繫方式',
  event: '公開活動',
  objecttype_event: '公開活動',
  email: 'Email',
  objecttype_email: 'Email',
  goal: '目標',
  objecttype_goal: '目標',
  objecttype_incident: '實例',
  invoice: '裝貨清單',
  objecttype_invoice: '裝貨清單',
  lead: '導線',
  objecttype_lead: '導線',
  list: '列表',
  objecttype_list: '市場行銷列表',
  solution: '解決方案',
  objecttype_solution: '解決方案',
  task: '任務',
  objecttype_task: '任務',
  user: '用戶',
  objecttype_user: '用戶',
  attachment: '附件',
  objecttype_attachment: '附件',
  casecomment: '案例評論',
  objecttype_casecomment: '案例評論',
  opportunity: '機會',
  objecttype_opportunity: '機會',
  opportunityproduct: '評估產品機會',
  objecttype_opportunityproduct: '評估產品機會',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: '注解',
  objecttype_note: '注解',
  product: '產品',
  objecttype_product: '產品',
  partner: '合夥人',
  objecttype_partner: '合夥人',
  queueitem: '佇列項',
  objecttype_queueitem: '佇列項',
  quote: '報價',
  objecttype_quote: '報價',
  salesliterature: '銷售說明書',
  objecttype_salesliterature: '銷售說明書',
  salesorder: '銷售定單',
  objecttype_salesorder: '銷售定單',
  service: '服務',
  objecttype_service: '服務',
  socialprofile: '社會形象',
  objecttype_socialprofile: '社會形象',
  kbdocumentation: '檔編制',
  objecttype_kbdocumentation: '檔編制',
  kbtechnicalarticle: '檔編制',
  objecttype_kbtechnicalarticle: '檔編制',
  kbsolution: '解決方案',
  objecttype_kbsolution: '解決方案',
  kbknowledgearticle: '知識文章',
  objecttype_kbknowledgearticle: '知識文章',
  kbattachment: '附件',
  objecttype_kbattachment: '附件',
  kbarticle: '文章',
  objecttype_kbarticle: '文章',
  kbarticlecomment: '文章評論',
  objecttype_kbarticlecomment: '文章評論',
  knowledgearticle: '知識文章',
  objecttype_knowledgearticle: '知識文章',
  topic: '題目',
  objecttype_topic: '題目',
  dashboard: '儀錶板',
  objecttype_dashboard: '儀錶板',
  contentversion: '文檔',
  objecttype_contentversion: '文檔',
  collaborationgroup: '協作組',
  objecttype_collaborationgroup: '協作組',
  spportal: '入口',
  filetype_spportal: '入口',
  spsite: '位置',
  filetype_spsite: '位置',
  spuserprofile: 'SharePoint用戶',
  filetype_spuserprofile: 'SharePoint用戶',
  sparea: '區域',
  filetype_sparea: '區域',
  spannouncement: '公告',
  filetype_spannouncement: '公告',
  spannouncementlist: '公告',
  filetype_spannouncementlist: '公告',
  spcontact: '聯繫方式',
  filetype_spcontact: '聯繫方式',
  spcontactlist: '聯繫方式',
  filetype_spcontactlist: '聯繫方式',
  spcustomlist: '自訂清單',
  filetype_spcustomlist: '自訂清單',
  spdiscussionboard: '討論板',
  filetype_spdiscussionboard: '討論板',
  spdiscussionboardlist: '討論板',
  filetype_spdiscussionboardlist: '討論板',
  spdocumentlibrarylist: '文件庫',
  filetype_spdocumentlibrarylist: '文件庫',
  spevent: '公開活動',
  filetype_spevent: '公開活動',
  speventlist: '公開活動',
  filetype_speventlist: '公開活動',
  spformlibrarylist: '表格庫',
  filetype_spformlibrarylist: '表格庫',
  spissue: '期號',
  filetype_spissue: '期號',
  spissuelist: '期號',
  filetype_spissuelist: '期號',
  splink: '鏈接',
  filetype_splink: '鏈接',
  splinklist: '鏈接',
  filetype_splinklist: '鏈接',
  sppicturelibrarylist: '圖片庫',
  filetype_sppicturelibrarylist: '圖片庫',
  spsurvey: '調查',
  filetype_spsurvey: '調查',
  spsurveylist: '調查',
  filetype_spsurveylist: '調查',
  sptask: '任務',
  filetype_sptask: '任務',
  sptasklist: '任務',
  filetype_sptasklist: '任務',
  spagenda: '議程表',
  filetype_spagenda: '議程表',
  spagendalist: '議程表',
  filetype_spagendalist: '議程表',
  spattendee: '與會者',
  filetype_spattendee: '與會者',
  spattendeelist: '與會者',
  filetype_spattendeelist: '與會者',
  spcustomgridlist: '自訂網格',
  filetype_spcustomgridlist: '自訂網格',
  spdecision: '決策',
  filetype_spdecision: '決策',
  spdecisionlist: '決策',
  filetype_spdecisionlist: '決策',
  spobjective: '目標',
  filetype_spobjective: '目標',
  spobjectivelist: '目標',
  filetype_spobjectivelist: '目標',
  sptextbox: '文字方塊',
  filetype_sptextbox: '文字方塊',
  sptextboxlist: '文字方塊清單',
  filetype_sptextboxlist: '文字方塊清單',
  spthingstobring: '要帶的物品',
  filetype_spthingstobring: '要帶的物品',
  spthingstobringlist: '要帶的物品',
  filetype_spthingstobringlist: '要帶的物品',
  sparealisting: '區域登記',
  filetype_sparealisting: '區域登記',
  spmeetingserie: '會議序列',
  filetype_spmeetingserie: '會議序列',
  spmeetingserielist: '會議序列列表',
  filetype_spmeetingserielist: '會議序列列表',
  spsitedirectory: '網站目錄項',
  filetype_spsitedirectory: '網站目錄項',
  spsitedirectorylist: '網站目錄',
  filetype_spsitedirectorylist: '網站目錄',
  spdatasource: '資料來源',
  filetype_spdatasource: '資料來源',
  spdatasourcelist: '資料來源清單',
  filetype_spdatasourcelist: '資料來源清單',
  splisttemplatecataloglist: '清單範本庫',
  filetype_splisttemplatecataloglist: '清單範本庫',
  spwebpartcataloglist: 'WebPart庫',
  filetype_spwebpartcataloglist: 'WebPart庫',
  spwebtemplatecataloglist: '网站範本庫',
  filetype_spwebtemplatecataloglist: '网站範本庫',
  spworkspacepagelist: '工作區頁面',
  filetype_spworkspacepagelist: '工作區頁面',
  spunknownlist: '自訂列表',
  filetype_spunknownlist: '自訂列表',
  spadministratortask: '管理員任務',
  filetype_spadministratortask: '管理員任務',
  spadministratortasklist: '管理員任務',
  filetype_spadministratortasklist: '管理員任務',
  spareadocumentlibrarylist: '區域文件庫',
  filetype_spareadocumentlibrarylist: '區域文件庫',
  spblogcategory: '博客分類',
  filetype_spblogcategory: '博客分類',
  spblogcategorylist: '博客分類',
  filetype_spblogcategorylist: '博客分類',
  spblogcomment: '博客評論',
  filetype_spblogcomment: '博客評論',
  spblogcommentlist: '博客評論',
  filetype_spblogcommentlist: '博客評論',
  spblogpost: '博客帖子',
  filetype_spblogpost: '博客帖子',
  spblogpostlist: '博客帖子',
  filetype_spblogpostlist: '博客帖子',
  spdataconnectionlibrarylist: '資料連接庫',
  filetype_spdataconnectionlibrarylist: '資料連接庫',
  spdistributiongroup: '流通組織',
  filetype_spdistributiongroup: '流通組織',
  spdistributiongrouplist: '流通組織',
  filetype_spdistributiongrouplist: '流通組織',
  spipfslist: 'InfoPath表單伺服器',
  filetype_spipfslist: 'InfoPath表單伺服器',
  spkeyperformanceindicator: '關鍵績效指標',
  filetype_spkeyperformanceindicator: '關鍵績效指標',
  spkeyperformanceindicatorlist: '關鍵績效指標',
  filetype_spkeyperformanceindicatorlist: '關鍵績效指標',
  splanguagesandtranslator: '语言和譯員',
  filetype_splanguagesandtranslator: '语言和譯員',
  splanguagesandtranslatorlist: '语言和譯員',
  filetype_splanguagesandtranslatorlist: '语言和譯員',
  spmasterpagescataloglist: '母版頁樣式庫',
  filetype_spmasterpagescataloglist: '母版頁樣式庫',
  spnocodeworkflowlibrarylist: '無代碼工作流庫',
  filetype_spnocodeworkflowlibrarylist: '無代碼工作流庫',
  spprojecttask: '項目任務',
  filetype_spprojecttask: '項目任務',
  spprojecttasklist: '項目任務',
  filetype_spprojecttasklist: '項目任務',
  sppublishingpageslibrarylist: '頁面庫',
  filetype_sppublishingpageslibrarylist: '頁面庫',
  spreportdocumentlibrarylist: '報告文件庫',
  filetype_spreportdocumentlibrarylist: '報告文件庫',
  spreportlibrarylist: '報告庫',
  filetype_spreportlibrarylist: '報告庫',
  spslidelibrarylist: '幻燈片庫',
  filetype_spslidelibrarylist: '幻燈片庫',
  sptab: '標籤',
  filetype_sptab: '標籤',
  sptablist: '標籤列表',
  filetype_sptablist: '標籤列表',
  sptranslationmanagementlibrarylist: '翻譯管理庫',
  filetype_sptranslationmanagementlibrarylist: '翻譯管理庫',
  spuserinformation: '使用者資訊',
  filetype_spuserinformation: '使用者資訊',
  spuserinformationlist: '使用者資訊清單',
  filetype_spuserinformationlist: '使用者資訊清單',
  spwikipagelibrarylist: '維琪頁面庫',
  filetype_spwikipagelibrarylist: '維琪頁面庫',
  spworkflowhistory: '工作流歷史',
  filetype_spworkflowhistory: '工作流歷史',
  spworkflowhistorylist: '工作流歷史列表',
  filetype_spworkflowhistorylist: '工作流歷史列表',
  spworkflowprocess: '自訂工作流程',
  filetype_spworkflowprocess: '自訂工作流程',
  spworkflowprocesslist: '自訂工作流程',
  filetype_spworkflowprocesslist: '自訂工作流程',
  sppublishingimageslibrarylist: '發行圖像庫',
  filetype_sppublishingimageslibrarylist: '發行圖像庫',
  spcirculation: '發行量',
  filetype_spcirculation: '發行量',
  spcirculationlist: '發行量',
  filetype_spcirculationlist: '發行量',
  spdashboardslibrarylist: '儀錶板庫',
  filetype_spdashboardslibrarylist: '儀錶板庫',
  spdataconnectionforperformancepointlibrarylist: 'PerformancePoint 數據連接庫',
  filetype_spdataconnectionforperformancepointlibrarylist: 'PerformancePoint 數據連接庫',
  sphealthreport: '健康報導',
  filetype_sphealthreport: '健康報導',
  sphealthreportlist: '健康報導',
  filetype_sphealthreportlist: '健康報導',
  sphealthrule: '保健規律',
  filetype_sphealthrule: '保健規律',
  sphealthrulelist: '保健規律',
  filetype_sphealthrulelist: '保健規律',
  spimedictionary: 'IME詞典',
  filetype_spimedictionary: 'IME詞典',
  spimedictionarylist: 'IME詞典',
  filetype_spimedictionarylist: 'IME詞典',
  spperformancepointcontent: 'PerformancePoint 目錄',
  filetype_spperformancepointcontent: 'PerformancePoint 目錄',
  spperformancepointcontentlist: 'PerformancePoint 目錄',
  filetype_spperformancepointcontentlist: 'PerformancePoint 目錄',
  spphonecallmemo: '電話備忘錄',
  filetype_spphonecallmemo: '電話備忘錄',
  spphonecallmemolist: '電話備忘錄',
  filetype_spphonecallmemolist: '電話備忘錄',
  sprecordlibrarylist: '唱片貯藏室',
  filetype_sprecordlibrarylist: '唱片貯藏室',
  spresource: '資源',
  filetype_spresource: '資源',
  spresourcelist: '資源',
  filetype_spresourcelist: '資源',
  spprocessdiagramslibrarylist: '流程圖庫',
  filetype_spprocessdiagramslibrarylist: '流程圖庫',
  spsitethemeslibrarylist: '網站主題庫',
  filetype_spsitethemeslibrarylist: '網站主題庫',
  spsolutionslibrarylist: '解決方案庫',
  filetype_spsolutionslibrarylist: '解決方案庫',
  spwfpublibrarylist: 'WFPUB 庫',
  filetype_spwfpublibrarylist: 'WFPUB 庫',
  spwhereabout: '所在之處',
  filetype_spwhereabout: '所在之處',
  spwhereaboutlist: '所在之處',
  filetype_spwhereaboutlist: '所在之處',
  spdocumentlink: '連結到文檔',
  filetype_spdocumentlink: '連結到文檔',
  spdocumentset: '文檔集',
  filetype_spdocumentset: '文檔集',
  spmicrofeedpost: 'Microfeed 帖子',
  filetype_spmicrofeedpost: 'Microfeed 帖子',
  spmicrofeedlist: 'Microfeed',
  filetype_spmicrofeedlist: 'Microfeed',
  splistfolder: '列表文件夾',
  filetype_splistfolder: '列表文件夾',
  Unknown: '未知',
  And: '與',
  Authenticating: '驗證 {0}...',
  Clear: '清除 {0}',
  CompleteQuery: '完整查詢',
  Exclude: '排除 {0}',
  EnterTag: '添加標記',
  Next: '下一頁',
  Last: '最後一頁',
  Link: '連結',
  Or: '或',
  Previous: '上一頁',
  QueryDidntMatchAnyDocuments: '您的查詢與任何文件都不匹配。',
  QueryException: '您的查詢存在錯誤： {0}。',
  Me: '我',
  Remove: '刪除',
  Search: '搜尋',
  SearchFor: '搜尋 {0}',
  ShareQuery: '共用查詢',
  Preferences: '喜好設定',
  LinkOpeningSettings: '連結打開設定',
  Reauthenticate: '重新驗證 {0}',
  ResultsFilteringExpression: '結果篩選運算式',
  FiltersInYourPreferences: '喜好設定中的篩選條件',
  Create: '創建',
  SearchIn: '在 {0} 中搜尋',
  Seconds: '用時 {0} 秒',
  ShowingResultsOf: '查看：第{0}到{1}條的結果（共{2}條）',
  ShowingResultsOfWithQuery: '查看：第{0}到{1}條的結果（{3}共{2}條）',
  SwitchTo: '切換到 {0}',
  Unexclude: '不排除 {0}',
  ClearAllFilters: '清除所有篩選條件',
  SkipLogin: '跳過登入',
  LoginInProgress: '正在登入，請稍候...',
  Login: '登入',
  GetStarted: '開始體驗',
  More: '更多',
  NMore: '顯示更多 ({0})',
  Less: '更少',
  Settings: '設定',
  Score: '得分',
  ScoreDescription: '得分是根據出現次數和在結果集中的位置計算得來。',
  Occurrences: '出現次數',
  OccurrencesDescription: '按出現次數排序，出現次數最高的值排在首位。',
  Label: '標籤',
  Of: '第...個，共...個',
  LabelDescription: '對欄位值按字母順序排序。',
  Value: '值',
  ValueDescription: '按第一個計算得出的欄位的值排序',
  AlphaAscending: '值遞增排序',
  AlphaDescending: '值遞減排序',
  ChiSquare: '卡方值',
  Nosort: '無排序',
  NosortDescription: '不排序值。值將返回隨機排序。',
  RelativeFrequency: '相對頻率',
  RelativeFrequencyDescription: '基於值的相對頻率排序。較不常見的值將出現在較高位置。',
  DateDistribution: '日期分佈',
  Custom: '自訂',
  CustomDescription: '基於自訂順序排序',
  ComputedField: '計算得出的欄位',
  Ascending: '遞增',
  Descending: '遞減',
  noResultFor: '沒有找到與 {0} 相關的結果',
  autoCorrectedQueryTo: '查詢自動校正為 {0}',
  didYouMean: '你的意思是 {0}？',
  SuggestedResults: '建議的結果',
  SuggestedQueries: '建議的查詢',
  MostRelevantItems: '最相關的項：',
  AllItems: '所有項：',
  ShowLess: '顯示較少的值',
  ShowMore: '顯示較多的值',
  HideFacet: '隱藏快捷控制介面',
  ShowFacet: '顯示快捷控制介面',
  AndOthers: '以及 {0} 個其他項',
  Others: '{0} 個其他項',
  MostRelevantPosts: '最相關的公佈內容：',
  CompleteThread: '完整的主題：',
  ShowCompleteThread: '顯示完整的主題',
  ShowOnlyTopMatchingPosts: '僅顯示最匹配的公佈內容',
  MostRelevantReplies: '最相關的回復：',
  AllConversation: '所有對話：',
  ShowAllConversation: '顯示所有對話',
  ShowAllReplies: '顯示所有回復',
  ShowOnlyMostRelevantReplies: '僅顯示最相關的回復',
  Close: '關閉',
  Open: '打開',
  OpenInOutlookWhenPossible: '在 Outlook 中打開（如果可能）',
  AlwaysOpenInNewWindow: '總是在新視窗中打開結果',
  Quickview: '快速檢視',
  NoQuickview: '此文檔無法快速瀏覽。',
  ErrorReport: '錯誤報告',
  OopsError: '伺服器出現了錯誤。',
  ProblemPersists: '如果問題仍然存在，請連絡管理員。',
  GoBack: '返回',
  Reset: '重設',
  Retry: '重試',
  MoreInfo: '更多資訊',
  Username: '用戶名',
  Password: '密碼',
  PostedBy: '公佈者',
  CannotConnect: '無法連線到該伺服器位址。',
  BadUserPass: '密碼與用戶名不匹配。',
  PleaseEnterYourCredentials: '請輸入您的 {0} 認證。',
  PleaseEnterYourSearchPage: '請輸入您的搜尋網頁 URL',
  Collapse: '摺疊',
  Collapsable: '可摺疊',
  Expand: '展開',
  Today: '今天',
  Yesterday: '昨天',
  Tomorrow: '明天',
  Duration: '持續時間： {0}',
  IndexDuration: '索引持續時間： {0}',
  ProxyDuration: 'Proxy 持續時間： {0}',
  ClientDuration: '用戶端持續時間： {0}',
  Unavailable: '不可用',
  Reply: '回復',
  ReplyAll: '全部回復',
  Forward: '轉寄',
  From: '寄件者',
  Caption: '標題',
  Expression: '運算式',
  Tab: '索引標籤',
  Tabs: '多個索引標籤',
  EnterExpressionName: '輸入運算式名稱',
  EnterExpressionToFilterWith: '輸入用於篩選結果的運算式',
  SelectTab: '選擇索引標籤',
  SelectAll: '全選',
  PageUrl: '搜尋網頁 URL',
  ErrorSavingToDevice: '在將資訊保存到您的設備時出錯',
  ErrorReadingFromDevice: '在從您的設備讀取資訊時出錯',
  AppIntro: '諮詢能夠回答您有關 Coveo 的問題的產品專家，並幫助您確定哪個 Coveo 解決方案適合您。或者，嘗試現場示範！',
  TryDemo: '嘗試示範',
  ContactUs: '連絡我們',
  NewToCoveo: 'Coveo 的新使用者？',
  LetUsHelpGetStarted: '讓我們幫助您開始體驗',
  LikesThis: '{0} 喜歡此解決方案。',
  CannotConnectSearchPage: '無法連線到您的搜尋網頁',
  AreYouSureDeleteFilter: '您是否確定要刪除採用 {1} 運算式的篩選條件 {0}',
  OnlineHelp: '線上說明',
  Done: '完成',
  SaveFacetState: '保存此快捷控制介面狀態',
  ClearFacetState: '清除快捷控制介面狀態',
  DisplayingTheOnlyMessage: '僅顯示此對話中的消息',
  NoNetworkConnection: '沒有網路連線',
  UnknownConnection: '未知的連線',
  EthernetConnection: '乙太網路連線',
  WiFi: 'WiFi 連線',
  CELL: '行動電話連線',
  CELL_2G: '行動電話 2G 連線',
  CELL_3G: '行動電話 3G 連線',
  CELL_4G: '行動電話 4G 連線',
  Relevance: '關聯',
  Date: '日期',
  Amount: '數量',
  QueryExceptionNoException: '沒有例外',
  QueryExceptionInvalidSyntax: '無效語法',
  QueryExceptionInvalidCustomField: '無效自訂欄位',
  QueryExceptionInvalidDate: '無效日期',
  QueryExceptionInvalidExactPhrase: '無效精確短語',
  QueryExceptionInvalidDateOp: '無效日期運算子',
  QueryExceptionInvalidNear: '無效 NEAR 運算子',
  QueryExceptionInvalidWeightedNear: '無效加權 NEAR',
  QueryExceptionInvalidTerm: '無效條件',
  QueryExceptionTooManyTerms: '太多條件',
  QueryExceptionWildcardTooGeneral: '萬用字元太常見',
  QueryExceptionInvalidSortField: '無效排序欄位',
  QueryExceptionInvalidSmallStringOp: '無效小字串運算子',
  QueryExceptionRequestedResultsMax: '要求的最大結果數',
  QueryExceptionAggregatedMirrorDead: '遠端聚合鏡像處於離線狀態',
  QueryExceptionAggregatedMirrorQueryTimeOut: '遠端聚合鏡像查詢超時',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: '遠程聚合鏡像無效版本號',
  QueryExceptionAggregatedMirrorCannotConnect: '遠端聚合鏡像無法連線',
  QueryExceptionNotEnoughLeadingCharsWildcard: '主字元萬用字元不足',
  QueryExceptionSecurityInverterNotFound: '未找到安全變換器',
  QueryExceptionSecurityInverterAccessDenied: '安全變換器存取被拒絕',
  QueryExceptionAggregatedMirrorCannotImpersonate: '遠端聚合鏡像無法模擬',
  QueryExceptionUnexpected: '意外',
  QueryExceptionAccessDenied: '存取被拒絕',
  QueryExceptionSuperUserTokenInvalid: '進階使用者權杖無效',
  QueryExceptionSuperUserTokenExpired: '進階使用者權杖已過期',
  QueryExceptionLicenseQueriesExpired: '查詢授權已過期',
  QueryExceptionLicenseSuperUserTokenNotSupported: '授權進階使用者權杖不支援',
  QueryExceptionInvalidSession: '無效會話',
  QueryExceptionInvalidDocument: '無效文件',
  QueryExceptionSearchDisabled: '搜尋被禁用',
  FileType: '檔案類型',
  ShowAttachment: '顯示附件',
  OnFeed: '有關 {0} 的輸入。',
  Author: '作者',
  NoTitle: '無標題',
  CurrentSelections: '當前選擇',
  AllContent: '所有內容',
  CancelLastAction: '取消最後一個動作',
  SearchTips: '搜尋提示',
  CheckSpelling: '檢查關鍵字的拼寫。',
  TryUsingFewerKeywords: '嘗試使用更少、更常用或不同的關鍵字。',
  SelectFewerFilters: '選擇較少的篩選條件以擴大您的搜尋範圍。',
  Document: '文件',
  Time: '時間',
  StartDate: '開始日期',
  StartTime: '啟動時間',
  DurationTitle: '持續時間',
  UserQuery: '用戶查詢',
  ShowUserActions: '顯示用戶操作',
  NoData: '無可用資料',
  EventType: '事件類型',
  GoToFullSearch: '全面搜尋',
  GoToEdition: '定制儀錶板',
  RemoveContext: '刪除上下文',
  BoxAttachToCase: '加入實例',
  AttachToCase: '加入實例',
  Attach: '附件',
  Attached: '附上',
  Detach: '分離',
  Details: '詳細說明',
  AdditionalFilters: '額外的篩選器',
  SelectNonContextualSearch: '於目前記錄中刪除上下文以擴大搜尋範圍',
  CopyPasteToSupport: '將此消息複製粘貼到柯維歐支援小組以獲取更多資訊。',
  FollowQueryDescription: '提醒我對此查詢的搜尋結果的更改。',
  SearchAlerts_Panel: '管理通告',
  SearchAlerts_PanelDescription: '查看並管理您的搜尋通告',
  SearchAlerts_PanelNoSearchAlerts: '您沒有訂閱',
  SearchAlerts_Fail: '搜尋通告服務目前無法使用.',
  SearchAlerts_Type: '類型',
  SearchAlerts_Content: '內容',
  SearchAlerts_Actions: '動作',
  EmptyQuery: '<清空>',
  SearchAlerts_Type_followQuery: '查詢',
  SearchAlerts_Type_followDocument: '項',
  SearchAlerts_unFollowing: '停止關注',
  SearchAlerts_follow: '按照',
  SearchAlerts_followed: '緊隨',
  SearchAlerts_followQuery: '按照查詢',
  Subscription_StopFollowingQuery: '停止以下查詢',
  SearchAlerts_Frequency: '什麼時間',
  SubscriptionsManageSubscriptions: '管理通告',
  SubscriptionsMessageFollowQuery: '當查詢<b> {0} </ b>恢復新專案或更動專案時，您將收到提示。',
  SubscriptionsMessageFollow: '您會收到有關專案<b> {0} </ b>的更改的提醒。',
  Expiration: '期滿',
  Monthly: '每月一次',
  Daily: '每日一次',
  Monday: '星期一',
  Tuesday: '星期二',
  Wednesday: '星期三',
  Thursday: '週四',
  Friday: '星期五',
  Saturday: '星期六',
  Sunday: '周日',
  NextDay: '下一頁{0}',
  LastDay: '最後一頁{0}',
  StartTypingCaseForSuggestions: '描述你的問題，參見可能的解決方案',
  ExportToExcel: '匯出到 Excel',
  ExportToExcelDescription: '將搜尋結果匯出到 Excel',
  CaseCreationNoResults: '沒有找到推薦的解決方案',
  SortBy: '排序方式',
  BoxCreateArticle: '創建文章',
  Facets: '快捷控制介面',
  AdvancedSearch: '高級搜尋',
  Keywords: '關鍵字',
  AllTheseWords: '所有這些詞語',
  ExactPhrase: '這個確切詞',
  AnyOfTheseWords: '所有這些詞語',
  NoneOfTheseWords: '無這些詞語',
  Anytime: '任何時間',
  InTheLast: '最後',
  Days: '天數',
  Months: '月份',
  Month: '月份',
  Year: '年度',
  Between: '介於',
  Language: '語言設定',
  Size: '規格',
  AtLeast: '最低限度',
  AtMost: '最高限度',
  Contains: '含有',
  DoesNotContain: '不含',
  Matches: '匹配',
  Bytes: '位元組',
  card: '卡片',
  table: '表格',
  ResultLinks: '結果頁面的連結',
  EnableQuerySyntax: '啟用查詢語法',
  On: '打開',
  Off: '關閉',
  Automatic: '自動',
  ResultsPerPage: '每頁的結果數',
  PreviousMonth: '前一個月',
  NextMonth: '下個月',
  Title: '題目',
  TRCoveoSearchResults: '搜索結果',
  TRCoveoApply: '申請',
  TRCoveoClearAll: '全部清除',
  SearchBoxSearch: '搜索',
  TRNoResultsFound: '未找到結果',
  TRDidntFindResults: '我們沒有找到任何結果 {0}',
  TRSuggestions: '建議',
  TRSpellAllWordsCorrectly: '正確拼寫所有單詞',
  TRChangeOrClearFilters: '更改或{清除}您的篩選',
  TRTryDifferentKeywords: '嘗試不同的關鍵詞',
  TRViewingNoResults: '正在查看：“{0}”有 0 個結果',
  TRLogin: '登錄',
  TRSupport: '支持',
  TRStoreFormat: '格式',
  TRStoreAvailability: '庫存量',
  TRFilter: '篩選',
  TRFilters: '篩選',
  TRMin: '分鐘',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: '繼續搜索!',
  TRKeepSearchingDescription: '很好，請繼續輸入。您所做的每一次搜索都會幫助我們找出您正在尋找的內容。',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  InsertAQuery: '搜索',
  PressEnterToSend: ''
};

/* eslint-disable import/no-anonymous-default-export */
var ja = {
  'box user': 'ユーザー',
  'filetype_box user': 'ユーザー',
  lithiummessage: 'Lithiumメッセージ',
  filetype_lithiummessage: 'Lithiumメッセージ',
  lithiumthread: 'Lithiumスレッド',
  filetype_lithiumthread: 'Lithiumスレッド',
  lithiumboard: 'Lithiumボード',
  filetype_lithiumboard: 'Lithiumボード',
  lithiumcategory: 'Lithiumカテゴリ',
  filetype_lithiumcategory: 'Lithiumカテゴリ',
  lithiumcommunity: 'Lithiumコミュニティ',
  filetype_lithiumcommunity: 'Lithiumコミュニティ',
  incident: 'ケース',
  youtube: 'YouTubeビデオ',
  filetype_youtube: 'YouTubeビデオ',
  html: 'HTMLファイル',
  filetype_html: 'HTMLファイル',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'ウェブページ',
  filetype_webscraperwebpage: 'ウェブページ',
  image: '画像',
  filetype_image: '画像',
  folder: 'フォルダ',
  filetype_folder: 'フォルダ',
  txt: 'テキスト',
  filetype_txt: 'テキスト',
  zip: 'Zipファイル',
  filetype_zip: 'Zipファイル',
  olefile: 'OLEファイル',
  filetype_olefile: 'OLEファイル',
  gmailmessage: 'Gmailメッセージ',
  filetype_gmailmessage: 'Gmailメッセージ',
  pdf: 'PDFファイル',
  filetype_pdf: 'PDFファイル',
  swf: 'Flashファイル',
  filetype_swf: 'Flashファイル',
  xml: 'XMLファイル',
  filetype_xml: 'XMLファイル',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSSフィード',
  filetype_rssitem: 'RSSフィード',
  doc: 'ドキュメント',
  filetype_doc: 'ドキュメント',
  docx: 'Microsoft Wordドキュメント',
  filetype_docx: 'Microsoft Wordドキュメント',
  xls: 'スプレッドシートドキュメント',
  filetype_xls: 'スプレッドシートドキュメント',
  ppt: 'プレゼンテーションドキュメント',
  filetype_ppt: 'プレゼンテーションドキュメント',
  video: 'ビデオ',
  filetype_video: 'ビデオ',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Open Textドキュメント',
  filetype_odt: 'Open Textドキュメント',
  people: 'ユーザー',
  objecttype_people: 'ユーザー',
  message: 'メッセージ',
  objecttype_message: 'メッセージ',
  feed: 'RSSフィード',
  objecttype_feed: 'RSSフィード',
  thread: 'スレッド',
  objecttype_thread: 'スレッド',
  file: 'ファイル',
  objecttype_file: 'ファイル',
  board: 'ボード',
  objecttype_board: 'ボード',
  category: 'カテゴリ',
  objecttype_category: 'カテゴリ',
  account: 'アカウント',
  objecttype_account: 'アカウント',
  annotation: '注',
  objecttype_annotation: '注',
  campaign: 'キャンペーン',
  objecttype_campaign: 'キャンペーン',
  "case": 'ケース',
  objecttype_case: 'ケース',
  contact: '連絡先',
  objecttype_contact: '連絡先',
  contract: '契約',
  objecttype_contract: '契約',
  event: 'イベント',
  objecttype_event: 'イベント',
  email: '電子メール',
  objecttype_email: '電子メール',
  goal: '目標',
  objecttype_goal: '目標',
  objecttype_incident: 'ケース',
  invoice: '請求書',
  objecttype_invoice: '請求書',
  lead: 'リード',
  objecttype_lead: 'リード',
  list: 'リスト',
  objecttype_list: 'マーケティングリスト',
  solution: 'ソリューション',
  objecttype_solution: 'ソリューション',
  task: 'タスク',
  objecttype_task: 'タスク',
  user: 'ユーザー',
  objecttype_user: 'ユーザー',
  attachment: '添付',
  objecttype_attachment: '添付',
  casecomment: 'ケースコメント',
  objecttype_casecomment: 'ケースコメント',
  opportunity: '提案',
  objecttype_opportunity: '提案',
  opportunityproduct: '提案製品',
  objecttype_opportunityproduct: '提案製品',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: '注',
  objecttype_note: '注',
  product: '製品',
  objecttype_product: '製品',
  partner: 'パートナー',
  objecttype_partner: 'パートナー',
  queueitem: 'キューアイテム',
  objecttype_queueitem: 'キューアイテム',
  quote: '見積もり',
  objecttype_quote: '見積もり',
  salesliterature: '営業資料',
  objecttype_salesliterature: '営業資料',
  salesorder: '販売注文',
  objecttype_salesorder: '販売注文',
  service: 'サービス',
  objecttype_service: 'サービス',
  socialprofile: 'ソーシャルプロファイル',
  objecttype_socialprofile: 'ソーシャルプロファイル',
  kbdocumentation: '文書',
  objecttype_kbdocumentation: '文書',
  kbtechnicalarticle: '文書',
  objecttype_kbtechnicalarticle: '文書',
  kbsolution: 'ソリューション',
  objecttype_kbsolution: 'ソリューション',
  kbknowledgearticle: 'ナレッジ記事',
  objecttype_kbknowledgearticle: 'ナレッジ記事',
  kbattachment: '添付',
  objecttype_kbattachment: '添付',
  kbarticle: '記事',
  objecttype_kbarticle: '記事',
  kbarticlecomment: '記事のコメント',
  objecttype_kbarticlecomment: '記事のコメント',
  knowledgearticle: 'ナレッジ記事',
  objecttype_knowledgearticle: 'ナレッジ記事',
  topic: 'トピック',
  objecttype_topic: 'トピック',
  dashboard: 'ダッシュボード',
  objecttype_dashboard: 'ダッシュボード',
  contentversion: 'ドキュメント',
  objecttype_contentversion: 'ドキュメント',
  collaborationgroup: 'コラボレーショングループ',
  objecttype_collaborationgroup: 'コラボレーショングループ',
  spportal: 'ポータル',
  filetype_spportal: 'ポータル',
  spsite: 'サイト',
  filetype_spsite: 'サイト',
  spuserprofile: 'SharePointユーザー',
  filetype_spuserprofile: 'SharePointユーザー',
  sparea: 'エリア',
  filetype_sparea: 'エリア',
  spannouncement: '通知',
  filetype_spannouncement: '通知',
  spannouncementlist: '通知',
  filetype_spannouncementlist: '通知',
  spcontact: '連絡先',
  filetype_spcontact: '連絡先',
  spcontactlist: '連絡先',
  filetype_spcontactlist: '連絡先',
  spcustomlist: 'カスタムリスト',
  filetype_spcustomlist: 'カスタムリスト',
  spdiscussionboard: 'ディスカッションボード',
  filetype_spdiscussionboard: 'ディスカッションボード',
  spdiscussionboardlist: 'ディスカッションボード',
  filetype_spdiscussionboardlist: 'ディスカッションボード',
  spdocumentlibrarylist: 'ドキュメントライブラリ',
  filetype_spdocumentlibrarylist: 'ドキュメントライブラリ',
  spevent: 'イベント',
  filetype_spevent: 'イベント',
  speventlist: 'イベント',
  filetype_speventlist: 'イベント',
  spformlibrarylist: 'ライブラリから',
  filetype_spformlibrarylist: 'ライブラリから',
  spissue: '問題',
  filetype_spissue: '問題',
  spissuelist: '問題',
  filetype_spissuelist: '問題',
  splink: 'リンク',
  filetype_splink: 'リンク',
  splinklist: 'リンク',
  filetype_splinklist: 'リンク',
  sppicturelibrarylist: '画像ライブラリ',
  filetype_sppicturelibrarylist: '画像ライブラリ',
  spsurvey: '調査',
  filetype_spsurvey: '調査',
  spsurveylist: '調査',
  filetype_spsurveylist: '調査',
  sptask: 'タスク',
  filetype_sptask: 'タスク',
  sptasklist: 'タスク',
  filetype_sptasklist: 'タスク',
  spagenda: '議題',
  filetype_spagenda: '議題',
  spagendalist: '議題',
  filetype_spagendalist: '議題',
  spattendee: '出席者',
  filetype_spattendee: '出席者',
  spattendeelist: '出席者',
  filetype_spattendeelist: '出席者',
  spcustomgridlist: 'カスタムグリッド',
  filetype_spcustomgridlist: 'カスタムグリッド',
  spdecision: '決定',
  filetype_spdecision: '決定',
  spdecisionlist: '決定',
  filetype_spdecisionlist: '決定',
  spobjective: '目的',
  filetype_spobjective: '目的',
  spobjectivelist: '目的',
  filetype_spobjectivelist: '目的',
  sptextbox: 'テキストボックス',
  filetype_sptextbox: 'テキストボックス',
  sptextboxlist: 'テキストボックスリスト',
  filetype_sptextboxlist: 'テキストボックスリスト',
  spthingstobring: '持参物',
  filetype_spthingstobring: '持参物',
  spthingstobringlist: '持参物',
  filetype_spthingstobringlist: '持参物',
  sparealisting: 'エリアの一覧',
  filetype_sparealisting: 'エリアの一覧',
  spmeetingserie: '関連する会議',
  filetype_spmeetingserie: '関連する会議',
  spmeetingserielist: '関連する会議のリスト',
  filetype_spmeetingserielist: '関連する会議のリスト',
  spsitedirectory: 'サイトディレクトリ項目',
  filetype_spsitedirectory: 'サイトディレクトリ項目',
  spsitedirectorylist: 'サイトディレクトリ',
  filetype_spsitedirectorylist: 'サイトディレクトリ',
  spdatasource: 'データソース',
  filetype_spdatasource: 'データソース',
  spdatasourcelist: 'データソースリスト',
  filetype_spdatasourcelist: 'データソースリスト',
  splisttemplatecataloglist: 'リストテンプレートギャラリー',
  filetype_splisttemplatecataloglist: 'リストテンプレートギャラリー',
  spwebpartcataloglist: 'Webパーツギャラリー',
  filetype_spwebpartcataloglist: 'Webパーツギャラリー',
  spwebtemplatecataloglist: 'サイトテンプレートギャラリー',
  filetype_spwebtemplatecataloglist: 'サイトテンプレートギャラリー',
  spworkspacepagelist: 'ワークスペースページ',
  filetype_spworkspacepagelist: 'ワークスペースページ',
  spunknownlist: 'カスタムリスト',
  filetype_spunknownlist: 'カスタムリスト',
  spadministratortask: '管理者タスク',
  filetype_spadministratortask: '管理者タスク',
  spadministratortasklist: '管理者タスク',
  filetype_spadministratortasklist: '管理者タスク',
  spareadocumentlibrarylist: 'エリアドキュメントライブラリ',
  filetype_spareadocumentlibrarylist: 'エリアドキュメントライブラリ',
  spblogcategory: 'ブログカテゴリ',
  filetype_spblogcategory: 'ブログカテゴリ',
  spblogcategorylist: 'ブログカテゴリ',
  filetype_spblogcategorylist: 'ブログカテゴリ',
  spblogcomment: 'ブログコメント',
  filetype_spblogcomment: 'ブログコメント',
  spblogcommentlist: 'ブログコメント',
  filetype_spblogcommentlist: 'ブログコメント',
  spblogpost: 'ブログ投稿',
  filetype_spblogpost: 'ブログ投稿',
  spblogpostlist: 'ブログ投稿',
  filetype_spblogpostlist: 'ブログ投稿',
  spdataconnectionlibrarylist: 'データ接続ライブラリ',
  filetype_spdataconnectionlibrarylist: 'データ接続ライブラリ',
  spdistributiongroup: '配布グループ',
  filetype_spdistributiongroup: '配布グループ',
  spdistributiongrouplist: '配布グループ',
  filetype_spdistributiongrouplist: '配布グループ',
  spipfslist: 'InfoPathフォームサーバー',
  filetype_spipfslist: 'InfoPathフォームサーバー',
  spkeyperformanceindicator: '主要業績評価指標',
  filetype_spkeyperformanceindicator: '主要業績評価指標',
  spkeyperformanceindicatorlist: '主要業績評価指標',
  filetype_spkeyperformanceindicatorlist: '主要業績評価指標',
  splanguagesandtranslator: '言語と翻訳者',
  filetype_splanguagesandtranslator: '言語と翻訳者',
  splanguagesandtranslatorlist: '言語と翻訳者',
  filetype_splanguagesandtranslatorlist: '言語と翻訳者',
  spmasterpagescataloglist: 'マスターページギャラリー',
  filetype_spmasterpagescataloglist: 'マスターページギャラリー',
  spnocodeworkflowlibrarylist: 'コードなしのワークフローライブラリ',
  filetype_spnocodeworkflowlibrarylist: 'コードなしのワークフローライブラリ',
  spprojecttask: 'プロジェクトタスク',
  filetype_spprojecttask: 'プロジェクトタスク',
  spprojecttasklist: 'プロジェクトタスク',
  filetype_spprojecttasklist: 'プロジェクトタスク',
  sppublishingpageslibrarylist: 'ページライブラリ',
  filetype_sppublishingpageslibrarylist: 'ページライブラリ',
  spreportdocumentlibrarylist: 'レポートドキュメントライブラリ',
  filetype_spreportdocumentlibrarylist: 'レポートドキュメントライブラリ',
  spreportlibrarylist: 'レポートライブラリ',
  filetype_spreportlibrarylist: 'レポートライブラリ',
  spslidelibrarylist: 'スライドライブラリ',
  filetype_spslidelibrarylist: 'スライドライブラリ',
  sptab: 'タブ',
  filetype_sptab: 'タブ',
  sptablist: 'タブリスト',
  filetype_sptablist: 'タブリスト',
  sptranslationmanagementlibrarylist: '翻訳管理ライブラリ',
  filetype_sptranslationmanagementlibrarylist: '翻訳管理ライブラリ',
  spuserinformation: 'ユーザー情報',
  filetype_spuserinformation: 'ユーザー情報',
  spuserinformationlist: 'ユーザー情報リスト',
  filetype_spuserinformationlist: 'ユーザー情報リスト',
  spwikipagelibrarylist: 'Wikiページライブラリ',
  filetype_spwikipagelibrarylist: 'Wikiページライブラリ',
  spworkflowhistory: 'ワークフローの履歴',
  filetype_spworkflowhistory: 'ワークフローの履歴',
  spworkflowhistorylist: 'ワークフロー履歴リスト',
  filetype_spworkflowhistorylist: 'ワークフロー履歴リスト',
  spworkflowprocess: 'カスタムワークフロープロセス',
  filetype_spworkflowprocess: 'カスタムワークフロープロセス',
  spworkflowprocesslist: 'カスタムワークフロープロセス',
  filetype_spworkflowprocesslist: 'カスタムワークフロープロセス',
  sppublishingimageslibrarylist: '発行イメージライブラリ',
  filetype_sppublishingimageslibrarylist: '発行イメージライブラリ',
  spcirculation: '回覧',
  filetype_spcirculation: '回覧',
  spcirculationlist: '回覧',
  filetype_spcirculationlist: '回覧',
  spdashboardslibrarylist: 'ダッシュボードライブラリ',
  filetype_spdashboardslibrarylist: 'ダッシュボードライブラリ',
  spdataconnectionforperformancepointlibrarylist: 'PerformancePointデータ接続ライブラリ',
  filetype_spdataconnectionforperformancepointlibrarylist: 'PerformancePointデータ接続ライブラリ',
  sphealthreport: '正常性レポート',
  filetype_sphealthreport: '正常性レポート',
  sphealthreportlist: '正常性レポート',
  filetype_sphealthreportlist: '正常性レポート',
  sphealthrule: '正常性ルール',
  filetype_sphealthrule: '正常性ルール',
  sphealthrulelist: '正常性ルール',
  filetype_sphealthrulelist: '正常性ルール',
  spimedictionary: 'IME辞書',
  filetype_spimedictionary: 'IME辞書',
  spimedictionarylist: 'IME辞書',
  filetype_spimedictionarylist: 'IME辞書',
  spperformancepointcontent: 'PerformancePointコンテンツ',
  filetype_spperformancepointcontent: 'PerformancePointコンテンツ',
  spperformancepointcontentlist: 'PerformancePointコンテンツ',
  filetype_spperformancepointcontentlist: 'PerformancePointコンテンツ',
  spphonecallmemo: '電話メモ',
  filetype_spphonecallmemo: '電話メモ',
  spphonecallmemolist: '電話メモ',
  filetype_spphonecallmemolist: '電話メモ',
  sprecordlibrarylist: 'レコードライブラリ',
  filetype_sprecordlibrarylist: 'レコードライブラリ',
  spresource: 'リソース',
  filetype_spresource: 'リソース',
  spresourcelist: 'リソース',
  filetype_spresourcelist: 'リソース',
  spprocessdiagramslibrarylist: 'プロセスダイアグラムライブラリ',
  filetype_spprocessdiagramslibrarylist: 'プロセスダイアグラムライブラリ',
  spsitethemeslibrarylist: 'サイトテーマライブラリ',
  filetype_spsitethemeslibrarylist: 'サイトテーマライブラリ',
  spsolutionslibrarylist: 'ソリューションライブラリ',
  filetype_spsolutionslibrarylist: 'ソリューションライブラリ',
  spwfpublibrarylist: 'WFPUBライブラリ',
  filetype_spwfpublibrarylist: 'WFPUBライブラリ',
  spwhereabout: '所在情報',
  filetype_spwhereabout: '所在情報',
  spwhereaboutlist: '所在情報',
  filetype_spwhereaboutlist: '所在情報',
  spdocumentlink: 'ドキュメントにリンクする',
  filetype_spdocumentlink: 'ドキュメントにリンクする',
  spdocumentset: 'ドキュメントセット',
  filetype_spdocumentset: 'ドキュメントセット',
  spmicrofeedpost: 'マイクロフィードの投稿',
  filetype_spmicrofeedpost: 'マイクロフィードの投稿',
  spmicrofeedlist: 'マイクロフィード',
  filetype_spmicrofeedlist: 'マイクロフィード',
  splistfolder: 'リストフォルダ',
  filetype_splistfolder: 'リストフォルダ',
  Unknown: '不明',
  And: 'および',
  Authenticating: '{0}を認証中...',
  Clear: '{0}をクリア',
  CompleteQuery: 'すべてのクエリ',
  Exclude: '{0}を除外',
  EnterTag: 'タグを追加',
  Next: '次へ',
  Last: '最後へ',
  Link: 'リンク',
  Or: 'または',
  Previous: '前へ',
  QueryDidntMatchAnyDocuments: 'クエリがどのドキュメントにも適合しませんでした。',
  QueryException: 'クエリにエラーがあります：{0}。',
  Me: 'ユーザー自身',
  Remove: '削除する',
  Search: '検索する',
  SearchFor: '{0}を検索',
  ShareQuery: 'クエリを共有',
  Preferences: '優先項目',
  LinkOpeningSettings: 'リンクを開く設定',
  Reauthenticate: '{0}を再認証',
  ResultsFilteringExpression: '結果フィルタリング表現',
  FiltersInYourPreferences: '優先するフィルター',
  Create: '作成する',
  SearchIn: '{0}を検索',
  Seconds: '{0}秒',
  ShowingResultsOf: '表示: {2}<pl>件の結果</pl>のうち、<pl>{0}件目から{1}件目</pl>',
  ShowingResultsOfWithQuery: '表示: {3} の{2}件の結果<pl>のうち、</pl>{0}<pl>件目から{1}件目まで</pl>',
  SwitchTo: '{0}に変更',
  Unexclude: '{0}の除外を元に戻す',
  ClearAllFilters: 'すべてのフィルターをクリア',
  SkipLogin: 'ログインをスキップ',
  LoginInProgress: 'ログイン中、お待ちください...',
  Login: 'ログインする',
  GetStarted: '始める',
  More: 'もっと表示',
  NMore: 'さらに表示 ({0})',
  Less: '少なく表示',
  Settings: '設定',
  Score: 'スコア',
  ScoreDescription: 'スコアは発生回数ならびに一連の結果内での位置から計算されます。',
  Occurrences: '発生',
  OccurrencesDescription: '発生回数の高い値から順に並べ替える',
  Label: 'ラベル',
  Of: '/',
  LabelDescription: 'フィールド値をアルファベット順に並べ替える',
  Value: '値',
  ValueDescription: '最初の計算フィールドの値を並べ替える',
  AlphaAscending: '値の小さい順',
  AlphaDescending: '値の大きい順',
  ChiSquare: 'カイ二乗',
  Nosort: '並び替えなし',
  NosortDescription: '値の並び替えをしないでください。値はランダムな順序で返されます。',
  RelativeFrequency: '相対頻度',
  RelativeFrequencyDescription: '値の相対頻度で並べ替える。相対頻度の低い値から順に表示。',
  DateDistribution: '日付の分布',
  Custom: 'カスタム作成',
  CustomDescription: 'カスタム作成した条件で並べ替える',
  ComputedField: '計算フィールド',
  Ascending: '昇順',
  Descending: '降順',
  noResultFor: '{0}に該当する結果なし',
  autoCorrectedQueryTo: 'クエリは{0}に自動修正されました',
  didYouMean: 'もしかして: {0}',
  SuggestedResults: '提案された結果',
  SuggestedQueries: '提案されたクエリ',
  MostRelevantItems: '最も関連性の高い項目：',
  AllItems: '全項目：',
  ShowLess: '少なく表示',
  ShowMore: 'もっと表示',
  HideFacet: 'ファセットを隠す',
  ShowFacet: 'ファセットを表示',
  AndOthers: 'およびその他{0}件',
  Others: 'その他{0}件',
  MostRelevantPosts: '最も関連性の高い投稿：',
  CompleteThread: 'すべてのスレッド：',
  ShowCompleteThread: 'すべてのスレッドを表示',
  ShowOnlyTopMatchingPosts: '一致した上位の投稿のみを表示',
  MostRelevantReplies: '最も関連性の高い返信：',
  AllConversation: 'すべての会話：',
  ShowAllConversation: 'すべての会話を表示',
  ShowAllReplies: 'すべての返信を表示',
  ShowOnlyMostRelevantReplies: '最も関連性の高い返信のみを表示',
  Close: '閉じる',
  Open: '開く',
  OpenInOutlookWhenPossible: 'Outlookで開く（可能な場合）',
  AlwaysOpenInNewWindow: '常に新しいウィンドウで結果を開く',
  Quickview: 'クイックビュー',
  NoQuickview: 'このドキュメントのクイックビューはありません',
  ErrorReport: 'エラー報告',
  OopsError: 'Search is down',
  ProblemPersists: "We're experiencing an issue with search. The good news is, we're on it! Try your search later.",
  GoBack: 'Go Back',
  Reset: 'リセット',
  Retry: '再試行',
  MoreInfo: '詳細',
  Username: 'ユーザー名',
  Password: 'パスワード',
  PostedBy: '投稿者名',
  CannotConnect: 'サーバーアドレスに接続できません。',
  BadUserPass: 'ユーザー名とパスワードが一致しません。',
  PleaseEnterYourCredentials: '{0}の認証情報を入力してください。',
  PleaseEnterYourSearchPage: '検索ページのURLを入力してください',
  Collapse: '折り畳む',
  Collapsable: '折り畳み可能',
  Expand: '展開する',
  Today: '今日',
  Yesterday: '昨日',
  Tomorrow: '明日',
  Duration: '期間：{0}',
  IndexDuration: 'インデックス期間：{0}',
  ProxyDuration: 'プロキシ期間：{0}',
  ClientDuration: 'クライアント期間：{0}',
  Unavailable: '不明',
  Reply: '返信',
  ReplyAll: '全員に返信',
  Forward: '転送',
  From: '差出人',
  Caption: '表題',
  Expression: '表現',
  Tab: 'タブ',
  Tabs: 'タブ',
  EnterExpressionName: '表現名を入力',
  EnterExpressionToFilterWith: '結果をフィルターする表現を入力',
  SelectTab: 'タブを選択',
  SelectAll: 'すべてを選択',
  PageUrl: 'ページのURLを検索',
  ErrorSavingToDevice: 'デバイスへの情報保存中にエラー発生',
  ErrorReadingFromDevice: 'デバイスから情報読み込み中にエラー発生',
  AppIntro: 'Coveoに関するご質問にお答えし、お客様に合ったCoveoソリューションの選択をお手伝いする製品スペシャリストと話す。または、実践デモをお試しください！',
  TryDemo: 'デモを試す',
  ContactUs: 'お問い合わせ',
  NewToCoveo: 'Coveoのご利用は初めてですか？',
  LetUsHelpGetStarted: '始めるお手伝いをいたします',
  LikesThis: '{0}はこれがお気に入りです。',
  CannotConnectSearchPage: '検索ページに接続できません',
  AreYouSureDeleteFilter: '本当に、フィルタ{0}と表現{1}を削除しますか',
  OnlineHelp: 'オンラインヘルプ',
  Done: '完了',
  SaveFacetState: 'このファセット状態を保存',
  ClearFacetState: 'ファセット状態をクリア',
  DisplayingTheOnlyMessage: '本会話中のメッセージのみを表示',
  NoNetworkConnection: 'ネットワーク接続なし',
  UnknownConnection: '不明の接続',
  EthernetConnection: 'イーサネット接続',
  WiFi: 'Wi-Fi接続',
  CELL: '携帯電話接続',
  CELL_2G: '2G携帯電話接続',
  CELL_3G: '3G携帯電話接続',
  CELL_4G: '4G携帯電話接続',
  Relevance: '関連性',
  Date: '日付',
  Amount: '量',
  QueryExceptionNoException: '例外なし',
  QueryExceptionInvalidSyntax: '無効の構文',
  QueryExceptionInvalidCustomField: '無効のカスタム作成フィールド',
  QueryExceptionInvalidDate: '無効の日付',
  QueryExceptionInvalidExactPhrase: '無効の完全一致',
  QueryExceptionInvalidDateOp: '無効の日付演算子',
  QueryExceptionInvalidNear: '無効のNEAR演算子',
  QueryExceptionInvalidWeightedNear: '無効の重み付けNEAR',
  QueryExceptionInvalidTerm: '無効の語句',
  QueryExceptionTooManyTerms: '語句が多すぎます',
  QueryExceptionWildcardTooGeneral: 'ワイルドカードが一般的すぎます',
  QueryExceptionInvalidSortField: '無効の並び替えフィールド',
  QueryExceptionInvalidSmallStringOp: '無効の小文字列演算子',
  QueryExceptionRequestedResultsMax: '要求した結果最大数',
  QueryExceptionAggregatedMirrorDead: 'リモートインデックスはオフラインです',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'リモートインデックスのクエリがタイムアウトしました',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'リモートインデックス無効の形成数字です',
  QueryExceptionAggregatedMirrorCannotConnect: 'リモートインデックスに接続できません',
  QueryExceptionNotEnoughLeadingCharsWildcard: '主要ワイルドカード不足です',
  QueryExceptionSecurityInverterNotFound: 'セキュリティインバーターが見つかりません',
  QueryExceptionSecurityInverterAccessDenied: 'セキュリティインバーターのアクセスが拒否されました',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'リモートインデックスはなりすまし利用できません',
  QueryExceptionUnexpected: '想定外',
  QueryExceptionAccessDenied: 'アクセスが拒否されました',
  QueryExceptionSuperUserTokenInvalid: 'スーパーユーザートークンが無効です',
  QueryExceptionSuperUserTokenExpired: 'スーパーユーザートークンが失効しています',
  QueryExceptionLicenseQueriesExpired: 'クエリライセンスが失効しています',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'スーパーユーザートークンのライセンスがサポートされていません',
  QueryExceptionInvalidSession: '無効のセッション',
  QueryExceptionInvalidDocument: '無効のドキュメント',
  QueryExceptionSearchDisabled: '検索が無効になっています',
  FileType: 'ファイルの種類',
  ShowAttachment: '添付を表示',
  OnFeed: '{0}のフィードに',
  Author: '作成者',
  NoTitle: '表題なし',
  CurrentSelections: '現在の選択項目',
  AllContent: 'すべての内容',
  CancelLastAction: '最後の動作を取り消す',
  SearchTips: '検索ヒント',
  CheckSpelling: 'キーワードのスペルを確認してください。',
  TryUsingFewerKeywords: 'より少ない、異なる、または一般的なキーワードを使用してみてください。',
  SelectFewerFilters: '選択するフィルタ数を減らして検索の幅を広げてください。',
  Document: 'ドキュメント',
  Time: '時間',
  StartDate: '開始日',
  StartTime: '開始時刻',
  DurationTitle: '期間',
  UserQuery: 'ユーザークエリ',
  ShowUserActions: 'ユーザーアクションを表示',
  NoData: 'データがありません',
  EventType: 'イベントタイプ',
  GoToFullSearch: '完全検索',
  GoToEdition: 'パネルをカスタマイズする',
  RemoveContext: 'コンテキストの削除',
  BoxAttachToCase: 'ケースに添付',
  AttachToCase: 'ケースに添付',
  Attach: '添付',
  Attached: '添付済み',
  Detach: '添付解除',
  Details: '詳細',
  AdditionalFilters: '追加のフィルタ',
  SelectNonContextualSearch: '現在の記録から',
  CopyPasteToSupport: 'このメッセージをコピー＆ペーストして、Coveoサポートチームに詳細について問い合わせます。',
  FollowQueryDescription: 'このクエリの検索結果に変更があった場合にアラートを送信してください。',
  SearchAlerts_Panel: 'アラートの管理',
  SearchAlerts_PanelDescription: '検索アラートの表示と管理を行います。',
  SearchAlerts_PanelNoSearchAlerts: 'サブスクリプションがありません。',
  SearchAlerts_Fail: '検索アラートサービスは現在利用できません。',
  SearchAlerts_Type: 'タイプ',
  SearchAlerts_Content: '内容',
  SearchAlerts_Actions: 'アクション',
  EmptyQuery: '<空>',
  SearchAlerts_Type_followQuery: 'クエリ',
  SearchAlerts_Type_followDocument: '項目',
  SearchAlerts_unFollowing: 'フォローの停止',
  SearchAlerts_follow: 'フォロー',
  SearchAlerts_followed: 'フォロー済み',
  SearchAlerts_followQuery: 'クエリのフォロー',
  Subscription_StopFollowingQuery: 'クエリのフォローを停止',
  SearchAlerts_Frequency: '日時',
  SubscriptionsManageSubscriptions: 'アラートの管理',
  SubscriptionsMessageFollowQuery: 'クエリ<b>{0}</b>が新規または更新済み項目を返した時にアラートを受信します。',
  SubscriptionsMessageFollow: '項目<b>{0}</b>への変更についてのアラートを受信します。',
  Expiration: '有効期限',
  Monthly: '毎月',
  Daily: '毎日',
  Monday: '月曜日',
  Tuesday: '火曜日',
  Wednesday: '水曜日',
  Thursday: '木曜日',
  Friday: '金曜日',
  Saturday: '土曜日',
  Sunday: '日曜日',
  NextDay: '来週の{0}',
  LastDay: '先週の{0}',
  StartTypingCaseForSuggestions: 'ソリューションを表示するために問題について説明してください',
  ExportToExcel: 'Excelにエクスポート',
  ExportToExcelDescription: '検索結果をExcelにエキスポート',
  CaseCreationNoResults: '推奨ソリューションが見つかりませんでした',
  SortBy: '並べ替え',
  BoxCreateArticle: '記事を作成する',
  Facets: 'ファセット',
  AdvancedSearch: '高度検索',
  Keywords: 'キーワード',
  AllTheseWords: 'すべての言葉',
  ExactPhrase: '完全に一致するフレーズ',
  AnyOfTheseWords: 'いずれかの言葉',
  NoneOfTheseWords: 'いずれの言葉も含まない',
  Anytime: '随時',
  InTheLast: '過去',
  Days: '日',
  Months: '月',
  Month: '月',
  Year: '年',
  Between: '期間',
  Language: '言語',
  Size: 'サイズ',
  AtLeast: '最小',
  AtMost: '最大',
  Contains: '次を含む：',
  DoesNotContain: '次の値を含まない',
  Matches: '一致',
  Bytes: 'バイト',
  card: 'カード',
  table: '表',
  ResultLinks: '結果のリンク',
  EnableQuerySyntax: 'クエリ構文を有効にする',
  On: 'オン',
  Off: 'オフ',
  Automatic: '自動',
  ResultsPerPage: 'ページごとの結果',
  PreviousMonth: '前月',
  NextMonth: '来月',
  Title: '表題',
  TRCoveoSearchResults: '検索結果',
  TRCoveoApply: '適用する',
  TRCoveoClearAll: 'すべてクリア',
  SearchBoxSearch: '検索する',
  TRNoResultsFound: '検索結果が見つかりません。',
  TRDidntFindResults: '{0} の結果は見つかりませんでした。',
  TRSuggestions: 'アドバイス',
  TRSpellAllWordsCorrectly: 'すべての語を正しく綴る',
  TRChangeOrClearFilters: 'フィルターを変更または{clear}',
  TRTryDifferentKeywords: '別のキーワードを試す',
  TRViewingNoResults: '表示: {0} の結果はありません',
  TRLogin: 'ログイン',
  TRSupport: 'サポート',
  TRStoreFormat: '形式',
  TRStoreAvailability: '在庫の有無',
  TRFilter: 'フィルター',
  TRFilters: 'フィルター',
  TRMin: '分',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: '検索を続けてください！',
  TRKeepSearchingDescription: 'そしてこちらでは記載を続けていきます。検索する度に、探しているものが見つかりやすくなります。',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  InsertAQuery: '検索する',
  PressEnterToSend: ''
};

/* eslint-disable import/no-anonymous-default-export */
var pt_br = {
  'box user': 'Usuário',
  'filetype_box user': 'Usuário',
  lithiummessage: 'Mensagem do Lithium',
  filetype_lithiummessage: 'Mensagem do Lithium',
  lithiumthread: 'Tópico da conversa do Lithium',
  filetype_lithiumthread: 'Tópico da conversa do Lithium',
  lithiumboard: 'Quadro de avisos do Lithium',
  filetype_lithiumboard: 'Quadro de avisos do Lithium',
  lithiumcategory: 'Categoria do Lithium',
  filetype_lithiumcategory: 'Categoria do Lithium',
  lithiumcommunity: 'Comunidade do Lithium',
  filetype_lithiumcommunity: 'Comunidade do Lithium',
  incident: 'Caso',
  youtube: 'Vídeo do YouTube',
  filetype_youtube: 'Vídeo do YouTube',
  html: 'Arquivo HTML',
  filetype_html: 'Arquivo HTML',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Página da web',
  filetype_webscraperwebpage: 'Página da web',
  image: 'Imagem',
  filetype_image: 'Imagem',
  folder: 'Pasta',
  filetype_folder: 'Pasta',
  txt: 'Texto',
  filetype_txt: 'Texto',
  zip: 'Arquivo ZIP',
  filetype_zip: 'Arquivo ZIP',
  olefile: 'Arquivo OLE',
  filetype_olefile: 'Arquivo OLE',
  gmailmessage: 'Mensagem do Gmail',
  filetype_gmailmessage: 'Mensagem do Gmail',
  pdf: 'Arquivo PDF',
  filetype_pdf: 'Arquivo PDF',
  swf: 'Arquivo Flash',
  filetype_swf: 'Arquivo Flash',
  xml: 'Arquivo XML',
  filetype_xml: 'Arquivo XML',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'Feed RSS',
  filetype_rssitem: 'Feed RSS',
  doc: 'Documento',
  filetype_doc: 'Documento',
  docx: 'Documento do Microsoft Word',
  filetype_docx: 'Documento do Microsoft Word',
  xls: 'Documento de planilha',
  filetype_xls: 'Documento de planilha',
  ppt: 'Documento de apresentação',
  filetype_ppt: 'Documento de apresentação',
  video: 'Vídeo',
  filetype_video: 'Vídeo',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Documento do Open Text',
  filetype_odt: 'Documento do Open Text',
  people: 'Usuário',
  objecttype_people: 'Usuário',
  message: 'Mensagem',
  objecttype_message: 'Mensagem',
  feed: 'Feed RSS',
  objecttype_feed: 'Feed RSS',
  thread: 'Tópico da conversa',
  objecttype_thread: 'Tópico da conversa',
  file: 'Arquivo',
  objecttype_file: 'Arquivo',
  board: 'Quadro de avisos',
  objecttype_board: 'Quadro de avisos',
  category: 'Categoria',
  objecttype_category: 'Categoria',
  account: 'Conta',
  objecttype_account: 'Conta',
  annotation: 'Nota',
  objecttype_annotation: 'Nota',
  campaign: 'Campanha',
  objecttype_campaign: 'Campanha',
  "case": 'Caso',
  objecttype_case: 'Caso',
  contact: 'Contato',
  objecttype_contact: 'Contato',
  contract: 'Contrato',
  objecttype_contract: 'Contrato',
  event: 'Evento',
  objecttype_event: 'Evento',
  email: 'E-mail',
  objecttype_email: 'E-mail',
  goal: 'Objetivo',
  objecttype_goal: 'Objetivo',
  objecttype_incident: 'Caso',
  invoice: 'Fatura',
  objecttype_invoice: 'Fatura',
  lead: 'Lead',
  objecttype_lead: 'Lead',
  list: 'Lista',
  objecttype_list: 'Lista de marketing',
  solution: 'Solução',
  objecttype_solution: 'Solução',
  task: 'Tarefa',
  objecttype_task: 'Tarefa',
  user: 'Usuário',
  objecttype_user: 'Usuário',
  attachment: 'Anexo',
  objecttype_attachment: 'Anexo',
  casecomment: 'Comentário do caso',
  objecttype_casecomment: 'Comentário do caso',
  opportunity: 'Oportunidade',
  objecttype_opportunity: 'Oportunidade',
  opportunityproduct: 'Produto de oportunidade',
  objecttype_opportunityproduct: 'Produto de oportunidade',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: 'Nota',
  objecttype_note: 'Nota',
  product: 'Produto',
  objecttype_product: 'Produto',
  partner: 'Parceiro',
  objecttype_partner: 'Parceiro',
  queueitem: 'Item da fila',
  objecttype_queueitem: 'Item da fila',
  quote: 'Cotação',
  objecttype_quote: 'Cotação',
  salesliterature: 'Literatura de vendas',
  objecttype_salesliterature: 'Literatura de vendas',
  salesorder: 'Pedido de vendas',
  objecttype_salesorder: 'Pedido de vendas',
  service: 'Serviço',
  objecttype_service: 'Serviço',
  socialprofile: 'Perfil social',
  objecttype_socialprofile: 'Perfil social',
  kbdocumentation: 'Documentação',
  objecttype_kbdocumentation: 'Documentação',
  kbtechnicalarticle: 'Documentação',
  objecttype_kbtechnicalarticle: 'Documentação',
  kbsolution: 'Solução',
  objecttype_kbsolution: 'Solução',
  kbknowledgearticle: 'Artigo da base de conhecimento',
  objecttype_kbknowledgearticle: 'Artigo da base de conhecimento',
  kbattachment: 'Anexo',
  objecttype_kbattachment: 'Anexo',
  kbarticle: 'Artigo',
  objecttype_kbarticle: 'Artigo',
  kbarticlecomment: 'Comentário do artigo',
  objecttype_kbarticlecomment: 'Comentário do artigo',
  knowledgearticle: 'Artigo da base de conhecimento',
  objecttype_knowledgearticle: 'Artigo da base de conhecimento',
  topic: 'Tópico',
  objecttype_topic: 'Tópico',
  dashboard: 'Painel de controle',
  objecttype_dashboard: 'Painel de controle',
  contentversion: 'Documento',
  objecttype_contentversion: 'Documento',
  collaborationgroup: 'Grupo de colaboração',
  objecttype_collaborationgroup: 'Grupo de colaboração',
  spportal: 'Portal',
  filetype_spportal: 'Portal',
  spsite: 'Site',
  filetype_spsite: 'Site',
  spuserprofile: 'Usuário do SharePoint',
  filetype_spuserprofile: 'Usuário do SharePoint',
  sparea: 'Área',
  filetype_sparea: 'Área',
  spannouncement: 'Anúncio',
  filetype_spannouncement: 'Anúncio',
  spannouncementlist: 'Anúncios',
  filetype_spannouncementlist: 'Anúncios',
  spcontact: 'Contato',
  filetype_spcontact: 'Contato',
  spcontactlist: 'Contatos',
  filetype_spcontactlist: 'Contatos',
  spcustomlist: 'Listas personalizadas',
  filetype_spcustomlist: 'Listas personalizadas',
  spdiscussionboard: 'Fórum de discussão',
  filetype_spdiscussionboard: 'Fórum de discussão',
  spdiscussionboardlist: 'Fóruns de discussão',
  filetype_spdiscussionboardlist: 'Fóruns de discussão',
  spdocumentlibrarylist: 'Biblioteca de documentos',
  filetype_spdocumentlibrarylist: 'Biblioteca de documentos',
  spevent: 'Evento',
  filetype_spevent: 'Evento',
  speventlist: 'Eventos',
  filetype_speventlist: 'Eventos',
  spformlibrarylist: 'Biblioteca de formulários',
  filetype_spformlibrarylist: 'Biblioteca de formulários',
  spissue: 'Problema',
  filetype_spissue: 'Problema',
  spissuelist: 'Problemas',
  filetype_spissuelist: 'Problemas',
  splink: 'Link',
  filetype_splink: 'Link',
  splinklist: 'Links',
  filetype_splinklist: 'Links',
  sppicturelibrarylist: 'Biblioteca de imagens',
  filetype_sppicturelibrarylist: 'Biblioteca de imagens',
  spsurvey: 'Pesquisa',
  filetype_spsurvey: 'Pesquisa',
  spsurveylist: 'Pesquisas',
  filetype_spsurveylist: 'Pesquisas',
  sptask: 'Tarefa',
  filetype_sptask: 'Tarefa',
  sptasklist: 'Tarefas',
  filetype_sptasklist: 'Tarefas',
  spagenda: 'Agenda',
  filetype_spagenda: 'Agenda',
  spagendalist: 'Agendas',
  filetype_spagendalist: 'Agendas',
  spattendee: 'Participante',
  filetype_spattendee: 'Participante',
  spattendeelist: 'Participantes',
  filetype_spattendeelist: 'Participantes',
  spcustomgridlist: 'Grades personalizadas',
  filetype_spcustomgridlist: 'Grades personalizadas',
  spdecision: 'Decisão',
  filetype_spdecision: 'Decisão',
  spdecisionlist: 'Decisões',
  filetype_spdecisionlist: 'Decisões',
  spobjective: 'Objetivo',
  filetype_spobjective: 'Objetivo',
  spobjectivelist: 'Objetivos',
  filetype_spobjectivelist: 'Objetivos',
  sptextbox: 'Caixa de texto',
  filetype_sptextbox: 'Caixa de texto',
  sptextboxlist: 'Lista de caixa de texto',
  filetype_sptextboxlist: 'Lista de caixa de texto',
  spthingstobring: 'Coisa para trazer',
  filetype_spthingstobring: 'Coisa para trazer',
  spthingstobringlist: 'Coisas para trazer',
  filetype_spthingstobringlist: 'Coisas para trazer',
  sparealisting: 'Lista de áreas',
  filetype_sparealisting: 'Lista de áreas',
  spmeetingserie: 'Série de reuniões',
  filetype_spmeetingserie: 'Série de reuniões',
  spmeetingserielist: 'Lista de séries de reuniões',
  filetype_spmeetingserielist: 'Lista de séries de reuniões',
  spsitedirectory: 'Item do diretório do site',
  filetype_spsitedirectory: 'Item do diretório do site',
  spsitedirectorylist: 'Diretório do site',
  filetype_spsitedirectorylist: 'Diretório do site',
  spdatasource: 'Fonte de dados',
  filetype_spdatasource: 'Fonte de dados',
  spdatasourcelist: 'Lista de fontes de dados',
  filetype_spdatasourcelist: 'Lista de fontes de dados',
  splisttemplatecataloglist: 'Galeria de modelos de lista',
  filetype_splisttemplatecataloglist: 'Galeria de modelos de lista',
  spwebpartcataloglist: 'Galeria de web parts',
  filetype_spwebpartcataloglist: 'Galeria de web parts',
  spwebtemplatecataloglist: 'Galeria de modelos do site',
  filetype_spwebtemplatecataloglist: 'Galeria de modelos do site',
  spworkspacepagelist: 'Páginas de espaço de trabalho',
  filetype_spworkspacepagelist: 'Páginas de espaço de trabalho',
  spunknownlist: 'Lista personalizada',
  filetype_spunknownlist: 'Lista personalizada',
  spadministratortask: 'Tarefa do administrador',
  filetype_spadministratortask: 'Tarefa do administrador',
  spadministratortasklist: 'Tarefas do administrador',
  filetype_spadministratortasklist: 'Tarefas do administrador',
  spareadocumentlibrarylist: 'Biblioteca de documentos de área',
  filetype_spareadocumentlibrarylist: 'Biblioteca de documentos de área',
  spblogcategory: 'Categoria do blog',
  filetype_spblogcategory: 'Categoria do blog',
  spblogcategorylist: 'Categorias do blog',
  filetype_spblogcategorylist: 'Categorias do blog',
  spblogcomment: 'Comentário do blog',
  filetype_spblogcomment: 'Comentário do blog',
  spblogcommentlist: 'Comentários do blog',
  filetype_spblogcommentlist: 'Comentários do blog',
  spblogpost: 'Postagem do blog',
  filetype_spblogpost: 'Postagem do blog',
  spblogpostlist: 'Postagens do blog',
  filetype_spblogpostlist: 'Postagens do blog',
  spdataconnectionlibrarylist: 'Biblioteca de conexões de dados',
  filetype_spdataconnectionlibrarylist: 'Biblioteca de conexões de dados',
  spdistributiongroup: 'Grupo de distribuição',
  filetype_spdistributiongroup: 'Grupo de distribuição',
  spdistributiongrouplist: 'Grupos de distribuição',
  filetype_spdistributiongrouplist: 'Grupos de distribuição',
  spipfslist: 'Servidores de formulários do InfoPath',
  filetype_spipfslist: 'Servidores de formulários do InfoPath',
  spkeyperformanceindicator: 'Indicador Chave de Desempenho',
  filetype_spkeyperformanceindicator: 'Indicador Chave de Desempenho',
  spkeyperformanceindicatorlist: 'Indicadores Chave de Desempenho',
  filetype_spkeyperformanceindicatorlist: 'Indicadores Chave de Desempenho',
  splanguagesandtranslator: 'Idiomas e tradutor',
  filetype_splanguagesandtranslator: 'Idiomas e tradutor',
  splanguagesandtranslatorlist: 'Idiomas e tradutores',
  filetype_splanguagesandtranslatorlist: 'Idiomas e tradutores',
  spmasterpagescataloglist: 'Galeria de Páginas Mestras',
  filetype_spmasterpagescataloglist: 'Galeria de Páginas Mestras',
  spnocodeworkflowlibrarylist: 'Bibliotecas de fluxo de trabalho sem código',
  filetype_spnocodeworkflowlibrarylist: 'Bibliotecas de fluxo de trabalho sem código',
  spprojecttask: 'Tarefa do projeto',
  filetype_spprojecttask: 'Tarefa do projeto',
  spprojecttasklist: 'Tarefas de projeto',
  filetype_spprojecttasklist: 'Tarefas de projeto',
  sppublishingpageslibrarylist: 'Biblioteca de páginas',
  filetype_sppublishingpageslibrarylist: 'Biblioteca de páginas',
  spreportdocumentlibrarylist: 'Biblioteca de documentos de relatório',
  filetype_spreportdocumentlibrarylist: 'Biblioteca de documentos de relatório',
  spreportlibrarylist: 'Biblioteca de relatórios',
  filetype_spreportlibrarylist: 'Biblioteca de relatórios',
  spslidelibrarylist: 'Biblioteca de slides',
  filetype_spslidelibrarylist: 'Biblioteca de slides',
  sptab: 'Guias',
  filetype_sptab: 'Guias',
  sptablist: 'Lista de guias',
  filetype_sptablist: 'Lista de guias',
  sptranslationmanagementlibrarylist: 'Biblioteca de gerenciamento de tradução',
  filetype_sptranslationmanagementlibrarylist: 'Biblioteca de gerenciamento de tradução',
  spuserinformation: 'Informações do usuário',
  filetype_spuserinformation: 'Informações do usuário',
  spuserinformationlist: 'Lista de informações do usuário',
  filetype_spuserinformationlist: 'Lista de informações do usuário',
  spwikipagelibrarylist: 'Biblioteca de páginas wiki',
  filetype_spwikipagelibrarylist: 'Biblioteca de páginas wiki',
  spworkflowhistory: 'Histórico do fluxo de trabalho',
  filetype_spworkflowhistory: 'Histórico do fluxo de trabalho',
  spworkflowhistorylist: 'Lista do histórico do fluxo de trabalho',
  filetype_spworkflowhistorylist: 'Lista do histórico do fluxo de trabalho',
  spworkflowprocess: 'Processo de fluxo de trabalho personalizado',
  filetype_spworkflowprocess: 'Processo de fluxo de trabalho personalizado',
  spworkflowprocesslist: 'Processos de fluxo de trabalho personalizados',
  filetype_spworkflowprocesslist: 'Processos de fluxo de trabalho personalizados',
  sppublishingimageslibrarylist: 'Biblioteca de imagens de publicação',
  filetype_sppublishingimageslibrarylist: 'Biblioteca de imagens de publicação',
  spcirculation: 'Circulação',
  filetype_spcirculation: 'Circulação',
  spcirculationlist: 'Circulações',
  filetype_spcirculationlist: 'Circulações',
  spdashboardslibrarylist: 'Biblioteca de painéis de controle',
  filetype_spdashboardslibrarylist: 'Biblioteca de painéis de controle',
  spdataconnectionforperformancepointlibrarylist: 'Biblioteca de conexões de dados do PerformancePoint',
  filetype_spdataconnectionforperformancepointlibrarylist: 'Biblioteca de conexões de dados do PerformancePoint',
  sphealthreport: 'Relatório de saúde',
  filetype_sphealthreport: 'Relatório de saúde',
  sphealthreportlist: 'Relatórios de saúde',
  filetype_sphealthreportlist: 'Relatórios de saúde',
  sphealthrule: 'Regra de saúde',
  filetype_sphealthrule: 'Regra de saúde',
  sphealthrulelist: 'Regras de saúde',
  filetype_sphealthrulelist: 'Regras de saúde',
  spimedictionary: 'Dicionário IME',
  filetype_spimedictionary: 'Dicionário IME',
  spimedictionarylist: 'Dicionários IME',
  filetype_spimedictionarylist: 'Dicionários IME',
  spperformancepointcontent: 'Conteúdo do PerformancePoint',
  filetype_spperformancepointcontent: 'Conteúdo do PerformancePoint',
  spperformancepointcontentlist: 'Conteúdos do PerformancePoint',
  filetype_spperformancepointcontentlist: 'Conteúdos do PerformancePoint',
  spphonecallmemo: 'Memorando de chamadas telefônicas',
  filetype_spphonecallmemo: 'Memorando de chamadas telefônicas',
  spphonecallmemolist: 'Memorandos de chamadas telefônicas',
  filetype_spphonecallmemolist: 'Memorandos de chamadas telefônicas',
  sprecordlibrarylist: 'Biblioteca de gravações',
  filetype_sprecordlibrarylist: 'Biblioteca de gravações',
  spresource: 'Recurso',
  filetype_spresource: 'Recurso',
  spresourcelist: 'Recursos',
  filetype_spresourcelist: 'Recursos',
  spprocessdiagramslibrarylist: 'Biblioteca de diagramas de processo',
  filetype_spprocessdiagramslibrarylist: 'Biblioteca de diagramas de processo',
  spsitethemeslibrarylist: 'Biblioteca de temas do site',
  filetype_spsitethemeslibrarylist: 'Biblioteca de temas do site',
  spsolutionslibrarylist: 'Biblioteca de soluções',
  filetype_spsolutionslibrarylist: 'Biblioteca de soluções',
  spwfpublibrarylist: 'Biblioteca de WFPUB',
  filetype_spwfpublibrarylist: 'Biblioteca de WFPUB',
  spwhereabout: 'Local',
  filetype_spwhereabout: 'Local',
  spwhereaboutlist: 'Locais',
  filetype_spwhereaboutlist: 'Locais',
  spdocumentlink: 'Link para um documento',
  filetype_spdocumentlink: 'Link para um documento',
  spdocumentset: 'Conjunto de documentos',
  filetype_spdocumentset: 'Conjunto de documentos',
  spmicrofeedpost: 'Postagem de microfeed',
  filetype_spmicrofeedpost: 'Postagem de microfeed',
  spmicrofeedlist: 'Microfeed',
  filetype_spmicrofeedlist: 'Microfeed',
  splistfolder: 'Pasta de lista',
  filetype_splistfolder: 'Pasta de lista',
  Unknown: 'Desconhecido',
  And: 'E',
  Authenticating: 'Autenticando {0} ...',
  Clear: 'Desmarcar {0}',
  CompleteQuery: 'Consulta completa',
  Exclude: 'Excluir {0}',
  EnterTag: 'Adicionar tag',
  Next: 'Próximo',
  Last: 'Último',
  Link: 'Link',
  Or: 'OU',
  Previous: 'Anterior',
  QueryDidntMatchAnyDocuments: 'Sua consulta não encontrou nenhum documento correspondente.',
  QueryException: 'Sua consulta tem um erro: {0}.',
  Me: 'Eu',
  Remove: 'Remover',
  Search: 'Pesquisar',
  SearchFor: 'Pesquisar por {0}',
  ShareQuery: 'Compartilhar consulta',
  Preferences: 'Preferências',
  LinkOpeningSettings: 'Configurações de abertura do link',
  Reauthenticate: 'Reautenticar {0}',
  ResultsFilteringExpression: 'Expressões de filtragem de resultados',
  FiltersInYourPreferences: 'Filtros em suas preferências',
  Create: 'Criar',
  SearchIn: 'Pesquisar em {0}',
  Seconds: 'em {0} segundo<pl>s</pl>',
  ShowingResultsOf: 'Visualizando: {0}<pl> até {1} de {2}</pl> resultado<pl>s</pl>',
  ShowingResultsOfWithQuery: 'Visualizando: {0}<pl> até {1} de {2}</pl> resultado<pl>s</pl> para {3}',
  SwitchTo: 'Mudar para {0}',
  Unexclude: 'Desfazer exclusão {0}',
  ClearAllFilters: 'Desmarcar todos os filtros',
  SkipLogin: 'Ignorar login',
  LoginInProgress: 'Login em andamento, aguarde ...',
  Login: 'Login',
  GetStarted: 'Introdução',
  More: 'Mais',
  NMore: 'Mostrar mais ({0})',
  Less: 'Menos',
  Settings: 'Configurações',
  Score: 'Pontuação',
  ScoreDescription: 'A pontuação é calculada a partir do número de ocorrências, bem como a partir da posição no conjunto de resultados.',
  Occurrences: 'Ocorrências',
  OccurrencesDescription: 'Classifica pelo número de ocorrências, com valores que têm o maior número aparecendo em primeiro lugar.',
  Label: 'Rótulo',
  Of: 'de',
  LabelDescription: 'Classifica os valores do campo em ordem alfabética.',
  Value: 'Valor',
  ValueDescription: 'Classifica os valores do primeiro campo calculado',
  AlphaAscending: 'Valor crescente',
  AlphaDescending: 'Valor decrescente',
  ChiSquare: 'Qui-quadrado',
  Nosort: 'Sem classificação',
  NosortDescription: 'Não classificar os valores. Os valores serão retornados em uma ordem aleatória.',
  RelativeFrequency: 'Frequência relativa',
  RelativeFrequencyDescription: 'Classifica com base na frequência relativa dos valores. Valores menos comuns aparecerão mais altos.',
  DateDistribution: 'Distribuição de data',
  Custom: 'Personalizada',
  CustomDescription: 'Classifica com base em uma ordem personalizada',
  ComputedField: 'Campo calculado',
  Ascending: 'Crescente',
  Descending: 'Decrescente',
  noResultFor: 'Nenhum resultado para {0}',
  autoCorrectedQueryTo: 'A consulta foi corrigida automaticamente para {0}',
  didYouMean: 'Você quis dizer {0}',
  SuggestedResults: 'Resultados sugeridos',
  SuggestedQueries: 'Consultas sugeridas',
  MostRelevantItems: 'Itens mais relevantes:',
  AllItems: 'Todos os itens:',
  ShowLess: 'Mostrar menos',
  ShowMore: 'Mostrar mais',
  HideFacet: 'Ocultar faceta',
  ShowFacet: 'Mostrar faceta',
  AndOthers: 'e {0} outro<pl>s</pl>',
  Others: '{0} outro<pl>s</pl>',
  MostRelevantPosts: 'Postagens mais relevantes:',
  CompleteThread: 'Tópico completo:',
  ShowCompleteThread: 'Mostrar o tópico completo',
  ShowOnlyTopMatchingPosts: 'Mostrar somente as principais postagens correspondentes',
  MostRelevantReplies: 'Respostas mais relevantes:',
  AllConversation: 'Todas as conversas:',
  ShowAllConversation: 'Mostrar todas as conversas',
  ShowAllReplies: 'Mostrar todas as respostas',
  ShowOnlyMostRelevantReplies: 'Mostrar somente as respostas mais relevantes',
  Close: 'Fechar',
  Open: 'Abrir',
  OpenInOutlookWhenPossible: 'Abrir no Outlook (quando possível)',
  AlwaysOpenInNewWindow: 'Sempre abrir os resultados em uma nova janela',
  Quickview: 'Visualização rápida',
  NoQuickview: 'A Visualização rápida para este documento não está disponível',
  ErrorReport: 'Relatório de erros',
  OopsError: 'O site de busca está em manutenção.',
  ProblemPersists: 'Nós estamos com um problema no site de busca. A boa notícia é que nós estamos trabalhando para resolver o problema. Tente a sua busca mais tarde.',
  GoBack: 'Voltar',
  Reset: 'Reiniciar',
  Retry: 'Tentar novamente',
  MoreInfo: 'Mais Informações',
  Username: 'Nome de usuário',
  Password: 'Senha',
  PostedBy: 'Postado por',
  CannotConnect: 'Não é possível conectar ao endereço do servidor.',
  BadUserPass: 'Nome de usuário e senha não correspondem.',
  PleaseEnterYourCredentials: 'Digite as suas credenciais para {0}.',
  PleaseEnterYourSearchPage: 'Digite a URL da página de pesquisa',
  Collapse: 'Recolher',
  Collapsable: 'Recolhível',
  Expand: 'Expandir',
  Today: 'Hoje',
  Yesterday: 'Ontem',
  Tomorrow: 'Amanhã',
  Duration: 'Duração: {0}',
  IndexDuration: 'Duração do índice: {0}',
  ProxyDuration: 'Duração do proxy: {0}',
  ClientDuration: 'Duração do cliente: {0}',
  Unavailable: 'Indisponível',
  Reply: 'Responder',
  ReplyAll: 'Responder a todos',
  Forward: 'Encaminhar',
  From: 'De',
  Caption: 'Legenda',
  Expression: 'Expressão',
  Tab: 'Guia',
  Tabs: 'Guias',
  EnterExpressionName: 'Digite o nome da expressão',
  EnterExpressionToFilterWith: 'Digite a expressão para filtrar os resultados',
  SelectTab: 'Selecionar guia',
  SelectAll: 'Selecionar tudo',
  PageUrl: 'URL da página de pesquisa',
  ErrorSavingToDevice: 'Erro ao salvar as informações para o seu dispositivo',
  ErrorReadingFromDevice: 'Erro ao ler as informações do seu dispositivo',
  AppIntro: 'Fale com um especialista de produto que possa responder suas dúvidas sobre a Coveo e ajudá-lo a decidir qual solução Coveo é adequada para você. Ou experimente uma demonstração ao vivo!',
  TryDemo: 'Experimente a demonstração',
  ContactUs: 'Entre em contato conosco',
  NewToCoveo: 'Novo para a Coveo?',
  LetUsHelpGetStarted: 'Vamos ajudá-lo a começar',
  LikesThis: '{0} assim<sn>s</sn>.',
  CannotConnectSearchPage: 'Não é possível conectar à sua página de pesquisa',
  AreYouSureDeleteFilter: 'Você tem certeza que deseja excluir o filtro {0} com a expressão {1}',
  OnlineHelp: 'Ajuda online',
  Done: 'Concluído',
  SaveFacetState: 'Salvar este estado da faceta',
  ClearFacetState: 'Desmarcar estado da faceta',
  DisplayingTheOnlyMessage: 'Exibindo a única mensagem nesta conversa',
  NoNetworkConnection: 'Sem conexão de rede',
  UnknownConnection: 'Conexão desconhecida',
  EthernetConnection: 'Conexão de Ethernet',
  WiFi: 'Conexão de Wi-fi',
  CELL: 'Conexão de celular',
  CELL_2G: 'Conexão de celular 2G',
  CELL_3G: 'Conexão de celular 3G',
  CELL_4G: 'Conexão de celular 4G',
  Relevance: 'Relevância',
  Date: 'Data',
  Amount: 'Quantidade',
  QueryExceptionNoException: 'Sem exceção',
  QueryExceptionInvalidSyntax: 'Sintaxe inválida',
  QueryExceptionInvalidCustomField: 'Campo personalizado inválido',
  QueryExceptionInvalidDate: 'Data inválida',
  QueryExceptionInvalidExactPhrase: 'Frase exata inválida',
  QueryExceptionInvalidDateOp: 'Operador de data inválido',
  QueryExceptionInvalidNear: 'Operador NEAR inválido',
  QueryExceptionInvalidWeightedNear: 'NEAR ponderado inválido',
  QueryExceptionInvalidTerm: 'Termo inválido',
  QueryExceptionTooManyTerms: 'Muitos termos',
  QueryExceptionWildcardTooGeneral: 'Caractere curinga muito geral',
  QueryExceptionInvalidSortField: 'Campo de classificação inválido',
  QueryExceptionInvalidSmallStringOp: 'Operador de pequena cadeia de caracteres inválido',
  QueryExceptionRequestedResultsMax: 'Resultados máximos solicitados',
  QueryExceptionAggregatedMirrorDead: 'O espelho agregado está offline',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Tempo limite da consulta do espelho agregado',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Número de compilação inválido do espelho agregado',
  QueryExceptionAggregatedMirrorCannotConnect: 'Espelho agregado não pode se conectar',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Caractere curinga líder insuficiente',
  QueryExceptionSecurityInverterNotFound: 'Inversor de segurança não encontrado',
  QueryExceptionSecurityInverterAccessDenied: 'Acesso ao inversor de segurança negado',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'O espelho agregado não pode representar',
  QueryExceptionUnexpected: 'Inesperado',
  QueryExceptionAccessDenied: 'Acesso negado',
  QueryExceptionSuperUserTokenInvalid: 'Token de superusuário inválido',
  QueryExceptionSuperUserTokenExpired: 'Token de superusuário expirado',
  QueryExceptionLicenseQueriesExpired: 'Consultas de licença expiradas',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'Licença de token de superusuário não suportada',
  QueryExceptionInvalidSession: 'Sessão inválida',
  QueryExceptionInvalidDocument: 'Documento inválido',
  QueryExceptionSearchDisabled: 'Pesquisa desativada',
  FileType: 'Tipo de arquivo',
  ShowAttachment: 'Mostrar anexo',
  OnFeed: 'no feed de {0} .',
  Author: 'Autor',
  NoTitle: 'Sem título',
  CurrentSelections: 'Seleções atuais',
  AllContent: 'Todo o conteúdo',
  CancelLastAction: 'Cancelar a última ação',
  SearchTips: 'Dicas de pesquisa',
  CheckSpelling: 'Verifique a ortografia das suas palavras-chave.',
  TryUsingFewerKeywords: 'Tente usar palavras-chave menores, diferentes ou mais simples.',
  SelectFewerFilters: 'Selecione filtros menores para ampliar a sua pesquisa.',
  Document: 'Documento',
  Time: 'Hora',
  StartDate: 'Data de início',
  StartTime: 'Hora de início',
  DurationTitle: 'Duração',
  UserQuery: 'Consulta do usuário',
  ShowUserActions: 'Mostrar as ações do usuário',
  NoData: 'Nenhum dado disponível',
  EventType: 'Tipo de evento',
  GoToFullSearch: 'Pesquisa completa',
  GoToEdition: 'Painel de personalização',
  RemoveContext: 'Remover contexto',
  BoxAttachToCase: 'Anexar ao caso',
  AttachToCase: 'Anexar ao caso',
  Attach: 'Anexar',
  Attached: 'Anexado',
  Detach: 'Desanexar',
  Details: 'Detalhes',
  AdditionalFilters: 'Filtros adicionais',
  SelectNonContextualSearch: 'Remova o contexto do registro atual para ampliar a sua pesquisa',
  CopyPasteToSupport: 'Copie e cole esta mensagem para a equipe de Suporte da Coveo para obter mais informações.',
  FollowQueryDescription: 'Alerte-me quando ocorrer alterações nos resultados da pesquisa desta consulta.',
  SearchAlerts_Panel: 'Gerenciar alertas',
  SearchAlerts_PanelDescription: 'Visualizar e gerenciar os seus alertas de pesquisa.',
  SearchAlerts_PanelNoSearchAlerts: 'Você não possui assinaturas.',
  SearchAlerts_Fail: 'O serviço de Pesquisa de alertas não está disponível no momento.',
  SearchAlerts_Type: 'Tipo',
  SearchAlerts_Content: 'Conteúdo',
  SearchAlerts_Actions: 'Ação',
  EmptyQuery: '<vazio>',
  SearchAlerts_Type_followQuery: 'Consulta',
  SearchAlerts_Type_followDocument: 'Item',
  SearchAlerts_unFollowing: 'Parar de seguir',
  SearchAlerts_follow: 'Seguir',
  SearchAlerts_followed: 'Seguido',
  SearchAlerts_followQuery: 'Seguir consulta',
  Subscription_StopFollowingQuery: 'Parar de seguir a consulta',
  SearchAlerts_Frequency: 'Quando',
  SubscriptionsManageSubscriptions: 'Gerenciar alertas',
  SubscriptionsMessageFollowQuery: 'Você receberá alertas quando a consulta <b>{0}</b> retornar itens novos ou atualizados.',
  SubscriptionsMessageFollow: 'Você receberá alertas se ocorrer alterações no item <b>{0}</b>.',
  Expiration: 'Expiração',
  Monthly: 'Mensal',
  Daily: 'Diário',
  Monday: 'Segunda-feira',
  Tuesday: 'Terça-feira',
  Wednesday: 'Quarta-feira',
  Thursday: 'Quinta-feira',
  Friday: 'Sexta-feira',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
  NextDay: 'Próximo(a) {0}',
  LastDay: 'Último(a) {0}',
  StartTypingCaseForSuggestions: 'Descreva o seu problema para ver as possíveis soluções',
  ExportToExcel: 'Exportar para o Excel',
  ExportToExcelDescription: 'Exportar os resultados da pesquisa para o Excel',
  CaseCreationNoResults: 'Nenhuma solução recomendada foi encontrada',
  SortBy: 'Ordenar por',
  BoxCreateArticle: 'Criar artigo',
  Facets: 'Facetas',
  AdvancedSearch: 'Pesquisa avançada',
  Keywords: 'Palavras-chave',
  AllTheseWords: 'Todas essas palavras',
  ExactPhrase: 'Esta frase exata',
  AnyOfTheseWords: 'Qualquer uma dessas palavras',
  NoneOfTheseWords: 'Nenhuma dessas palavras',
  Anytime: 'A qualquer momento',
  InTheLast: 'Nos últimos',
  Days: 'dias',
  Months: 'meses',
  Month: 'Mês',
  Year: 'Ano',
  Between: 'Entre',
  Language: 'Idioma',
  Size: 'Tamanho',
  AtLeast: 'pelo menos',
  AtMost: 'no máximo',
  Contains: 'contém',
  DoesNotContain: 'não contém',
  Matches: 'coincidências',
  Bytes: 'bytes',
  card: 'Cartão',
  table: 'Tabela',
  ResultLinks: 'Links do resultado',
  EnableQuerySyntax: 'Habilitar a sintaxe da consulta',
  On: 'Ativar',
  Off: 'Desativar',
  Automatic: 'Automático',
  ResultsPerPage: 'Resultados por página',
  PreviousMonth: 'Mês anterior',
  NextMonth: 'Próximo mês',
  Title: 'Título',
  TRCoveoSearchResults: 'Resultados da pesquisa',
  TRCoveoApply: 'Aplicar',
  TRCoveoClearAll: 'Limpar tudo',
  SearchBoxSearch: 'Pesquisar',
  TRNoResultsFound: 'Nenhum resultado encontrado',
  TRDidntFindResults: 'Não encontramos nenhum resultado para {0}.',
  TRSuggestions: 'Sugestões',
  TRSpellAllWordsCorrectly: 'Soletre todas as palavras corretamente',
  // For this string, the word between the braces will be bold.
  TRChangeOrClearFilters: 'Altere ou {clear} seus filtros',
  TRTryDifferentKeywords: 'Tente diferentes teclados',
  TRViewingNoResults: 'Visualizando: 0 resultados para {0}',
  TRLogin: 'Login',
  TRSupport: 'Apoio',
  TRStoreFormat: 'Formato',
  TRStoreAvailability: 'Disponibilidade',
  TRFilter: 'Filtro',
  TRFilters: 'Filtros',
  TRMin: 'min',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: 'Continue procurando!',
  TRKeepSearchingDescription: 'E continuaremos escrevendo. Toda busca que você faz nos ajuda a saber o que você está procurando.',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  InsertAQuery: 'Pesquisar',
  PressEnterToSend: ''
};

/* eslint-disable import/no-anonymous-default-export */
var ru = {
  'box user': 'Пользователь',
  'filetype_box user': 'Пользователь',
  lithiummessage: 'Сообщение Lithium',
  filetype_lithiummessage: 'Сообщение Lithium',
  lithiumthread: 'Цепочка Lithium',
  filetype_lithiumthread: 'Цепочка Lithium',
  lithiumboard: 'Панель Lithium',
  filetype_lithiumboard: 'Панель Lithium',
  lithiumcategory: 'Категория Lithium',
  filetype_lithiumcategory: 'Категория Lithium',
  lithiumcommunity: 'Сообщество Lithium',
  filetype_lithiumcommunity: 'Сообщество Lithium',
  incident: 'Обращение',
  youtube: 'Видео YouTube',
  filetype_youtube: 'Видео YouTube',
  html: 'Файл HTML',
  filetype_html: 'Файл HTML',
  wiki: 'Вики',
  filetype_wiki: 'Вики',
  webscraperwebpage: 'Веб-страница',
  filetype_webscraperwebpage: 'Веб-страница',
  image: 'Изображение',
  filetype_image: 'Изображение',
  folder: 'Папка',
  filetype_folder: 'Папка',
  txt: 'Текст',
  filetype_txt: 'Текст',
  zip: 'Файл Zip',
  filetype_zip: 'Файл Zip',
  olefile: 'Файл OLE',
  filetype_olefile: 'Файл OLE',
  gmailmessage: 'Сообщение Gmail',
  filetype_gmailmessage: 'Сообщение Gmail',
  pdf: 'Файл PDF',
  filetype_pdf: 'Файл PDF',
  swf: 'Файл Flash',
  filetype_swf: 'Файл Flash',
  xml: 'Файл XML',
  filetype_xml: 'Файл XML',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'Канал RSS',
  filetype_rssitem: 'Канал RSS',
  doc: 'Документ',
  filetype_doc: 'Документ',
  docx: 'Документ Microsoft Word',
  filetype_docx: 'Документ Microsoft Word',
  xls: 'Документ электронной таблицы',
  filetype_xls: 'Документ электронной таблицы',
  ppt: 'Документ презентации',
  filetype_ppt: 'Документ презентации',
  video: 'Видео',
  filetype_video: 'Видео',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Текстовый документ открытого формата',
  filetype_odt: 'Текстовый документ открытого формата',
  people: 'Пользователь',
  objecttype_people: 'Пользователь',
  message: 'Сообщение',
  objecttype_message: 'Сообщение',
  feed: 'Канал RSS',
  objecttype_feed: 'Канал RSS',
  thread: 'Цепочка',
  objecttype_thread: 'Цепочка',
  file: 'Файл',
  objecttype_file: 'Файл',
  board: 'Панель',
  objecttype_board: 'Панель',
  category: 'Категория',
  objecttype_category: 'Категория',
  account: 'Учетная запись',
  objecttype_account: 'Учетная запись',
  annotation: 'Заметка',
  objecttype_annotation: 'Заметка',
  campaign: 'Кампания',
  objecttype_campaign: 'Кампания',
  "case": 'Обращение',
  objecttype_case: 'Обращение',
  contact: 'Контакт',
  objecttype_contact: 'Контакт',
  contract: 'Контракт',
  objecttype_contract: 'Контракт',
  event: 'Событие',
  objecttype_event: 'Событие',
  email: 'Электронное письмо',
  objecttype_email: 'Электронное письмо',
  goal: 'Цель',
  objecttype_goal: 'Цель',
  objecttype_incident: 'Обращение',
  invoice: 'Счет',
  objecttype_invoice: 'Счет',
  lead: 'Интерес',
  objecttype_lead: 'Интерес',
  list: 'Список',
  objecttype_list: 'Маркетинговый список',
  solution: 'Решение',
  objecttype_solution: 'Решение',
  task: 'Задача',
  objecttype_task: 'Задача',
  user: 'Пользователь',
  objecttype_user: 'Пользователь',
  attachment: 'Приложение',
  objecttype_attachment: 'Приложение',
  casecomment: 'Комментарий к обращению',
  objecttype_casecomment: 'Комментарий к обращению',
  opportunity: 'Возможная сделка',
  objecttype_opportunity: 'Возможная сделка',
  opportunityproduct: 'Продукт для возможной сделки',
  objecttype_opportunityproduct: 'Продукт для возможной сделки',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: 'Заметка',
  objecttype_note: 'Заметка',
  product: 'Продукт',
  objecttype_product: 'Продукт',
  partner: 'Партнёр',
  objecttype_partner: 'Партнёр',
  queueitem: 'Элемент в очереди',
  objecttype_queueitem: 'Элемент в очереди',
  quote: 'Цитата',
  objecttype_quote: 'Цитата',
  salesliterature: 'Литература по продажам',
  objecttype_salesliterature: 'Литература по продажам',
  salesorder: 'Заказ на продажу',
  objecttype_salesorder: 'Заказ на продажу',
  service: 'Сервис',
  objecttype_service: 'Сервис',
  socialprofile: 'Профиль в социальной сети',
  objecttype_socialprofile: 'Профиль в социальной сети',
  kbdocumentation: 'Документация',
  objecttype_kbdocumentation: 'Документация',
  kbtechnicalarticle: 'Документация',
  objecttype_kbtechnicalarticle: 'Документация',
  kbsolution: 'Решение',
  objecttype_kbsolution: 'Решение',
  kbknowledgearticle: 'Статья базы знаний',
  objecttype_kbknowledgearticle: 'Статья базы знаний',
  kbattachment: 'Приложение',
  objecttype_kbattachment: 'Приложение',
  kbarticle: 'Статья',
  objecttype_kbarticle: 'Статья',
  kbarticlecomment: 'Комментарий к статье',
  objecttype_kbarticlecomment: 'Комментарий к статье',
  knowledgearticle: 'Статья базы знаний',
  objecttype_knowledgearticle: 'Статья базы знаний',
  topic: 'Тема',
  objecttype_topic: 'Тема',
  dashboard: 'Информационная панель',
  objecttype_dashboard: 'Информационная панель',
  contentversion: 'Документ',
  objecttype_contentversion: 'Документ',
  collaborationgroup: 'Группа сотрудничества',
  objecttype_collaborationgroup: 'Группа сотрудничества',
  spportal: 'Портал',
  filetype_spportal: 'Портал',
  spsite: 'Сайт',
  filetype_spsite: 'Сайт',
  spuserprofile: 'Пользователь SharePoint',
  filetype_spuserprofile: 'Пользователь SharePoint',
  sparea: 'Область',
  filetype_sparea: 'Область',
  spannouncement: 'Объявление',
  filetype_spannouncement: 'Объявление',
  spannouncementlist: 'Объявления',
  filetype_spannouncementlist: 'Объявления',
  spcontact: 'Контакт',
  filetype_spcontact: 'Контакт',
  spcontactlist: 'Контакты',
  filetype_spcontactlist: 'Контакты',
  spcustomlist: 'Произвольный список',
  filetype_spcustomlist: 'Произвольный список',
  spdiscussionboard: 'Доска обсуждений',
  filetype_spdiscussionboard: 'Доска обсуждений',
  spdiscussionboardlist: 'Доски обсуждений',
  filetype_spdiscussionboardlist: 'Доски обсуждений',
  spdocumentlibrarylist: 'Библиотека документов',
  filetype_spdocumentlibrarylist: 'Библиотека документов',
  spevent: 'Событие',
  filetype_spevent: 'Событие',
  speventlist: 'События',
  filetype_speventlist: 'События',
  spformlibrarylist: 'Библиотека форм',
  filetype_spformlibrarylist: 'Библиотека форм',
  spissue: 'Проблема',
  filetype_spissue: 'Проблема',
  spissuelist: 'Проблемы',
  filetype_spissuelist: 'Проблемы',
  splink: 'Ссылка',
  filetype_splink: 'Ссылка',
  splinklist: 'Ссылки',
  filetype_splinklist: 'Ссылки',
  sppicturelibrarylist: 'Библиотека изображений',
  filetype_sppicturelibrarylist: 'Библиотека изображений',
  spsurvey: 'Опрос',
  filetype_spsurvey: 'Опрос',
  spsurveylist: 'Опросы',
  filetype_spsurveylist: 'Опросы',
  sptask: 'Задача',
  filetype_sptask: 'Задача',
  sptasklist: 'Задачи',
  filetype_sptasklist: 'Задачи',
  spagenda: 'Повестка дня',
  filetype_spagenda: 'Повестка дня',
  spagendalist: 'Повестки дня',
  filetype_spagendalist: 'Повестки дня',
  spattendee: 'Участник',
  filetype_spattendee: 'Участник',
  spattendeelist: 'Участники',
  filetype_spattendeelist: 'Участники',
  spcustomgridlist: 'Пользовательские сетки',
  filetype_spcustomgridlist: 'Пользовательские сетки',
  spdecision: 'Решение',
  filetype_spdecision: 'Решение',
  spdecisionlist: 'Решения',
  filetype_spdecisionlist: 'Решения',
  spobjective: 'Цель',
  filetype_spobjective: 'Цель',
  spobjectivelist: 'Цели',
  filetype_spobjectivelist: 'Цели',
  sptextbox: 'Текстовое поле',
  filetype_sptextbox: 'Текстовое поле',
  sptextboxlist: 'Список в текстовом поле',
  filetype_sptextboxlist: 'Список в текстовом поле',
  spthingstobring: 'Необходимая вещь',
  filetype_spthingstobring: 'Необходимая вещь',
  spthingstobringlist: 'Необходимые вещи',
  filetype_spthingstobringlist: 'Необходимые вещи',
  sparealisting: 'Вхождение в область',
  filetype_sparealisting: 'Вхождение в область',
  spmeetingserie: 'Ряд собраний',
  filetype_spmeetingserie: 'Ряд собраний',
  spmeetingserielist: 'Список ряда собраний',
  filetype_spmeetingserielist: 'Список ряда собраний',
  spsitedirectory: 'Элемент каталога сайтов',
  filetype_spsitedirectory: 'Элемент каталога сайтов',
  spsitedirectorylist: 'Каталог сайтов',
  filetype_spsitedirectorylist: 'Каталог сайтов',
  spdatasource: 'Источник данных',
  filetype_spdatasource: 'Источник данных',
  spdatasourcelist: 'Список источников данных',
  filetype_spdatasourcelist: 'Список источников данных',
  splisttemplatecataloglist: 'Коллекция шаблонов списков',
  filetype_splisttemplatecataloglist: 'Коллекция шаблонов списков',
  spwebpartcataloglist: 'Коллекция веб-частей',
  filetype_spwebpartcataloglist: 'Коллекция веб-частей',
  spwebtemplatecataloglist: 'Коллекция шаблонов сайтов',
  filetype_spwebtemplatecataloglist: 'Коллекция шаблонов сайтов',
  spworkspacepagelist: 'Страницы рабочей области',
  filetype_spworkspacepagelist: 'Страницы рабочей области',
  spunknownlist: 'Настраиваемый список',
  filetype_spunknownlist: 'Настраиваемый список',
  spadministratortask: 'Задача администратора',
  filetype_spadministratortask: 'Задача администратора',
  spadministratortasklist: 'Задачи администратора',
  filetype_spadministratortasklist: 'Задачи администратора',
  spareadocumentlibrarylist: 'Библиотека документов области',
  filetype_spareadocumentlibrarylist: 'Библиотека документов области',
  spblogcategory: 'Категория блога',
  filetype_spblogcategory: 'Категория блога',
  spblogcategorylist: 'Категории блога',
  filetype_spblogcategorylist: 'Категории блога',
  spblogcomment: 'Комментарий в блоге',
  filetype_spblogcomment: 'Комментарий в блоге',
  spblogcommentlist: 'Комментарии в блоге',
  filetype_spblogcommentlist: 'Комментарии в блоге',
  spblogpost: 'Запись в блоге',
  filetype_spblogpost: 'Запись в блоге',
  spblogpostlist: 'Записи в блоге',
  filetype_spblogpostlist: 'Записи в блоге',
  spdataconnectionlibrarylist: 'Библиотека подключений к данным',
  filetype_spdataconnectionlibrarylist: 'Библиотека подключений к данным',
  spdistributiongroup: 'Группа рассылки',
  filetype_spdistributiongroup: 'Группа рассылки',
  spdistributiongrouplist: 'Группы рассылки',
  filetype_spdistributiongrouplist: 'Группы рассылки',
  spipfslist: 'Серверы форм InfoPath',
  filetype_spipfslist: 'Серверы форм InfoPath',
  spkeyperformanceindicator: 'Ключевой показатель эффективности',
  filetype_spkeyperformanceindicator: 'Ключевой показатель эффективности',
  spkeyperformanceindicatorlist: 'Ключевые показатели эффективности',
  filetype_spkeyperformanceindicatorlist: 'Ключевые показатели эффективности',
  splanguagesandtranslator: 'Языки и переводчик',
  filetype_splanguagesandtranslator: 'Языки и переводчик',
  splanguagesandtranslatorlist: 'Языки и переводчики',
  filetype_splanguagesandtranslatorlist: 'Языки и переводчики',
  spmasterpagescataloglist: 'Коллекция главных страниц',
  filetype_spmasterpagescataloglist: 'Коллекция главных страниц',
  spnocodeworkflowlibrarylist: 'Библиотеки рабочих процессов без кода',
  filetype_spnocodeworkflowlibrarylist: 'Библиотеки рабочих процессов без кода',
  spprojecttask: 'Задача проекта',
  filetype_spprojecttask: 'Задача проекта',
  spprojecttasklist: 'Задачи проекта',
  filetype_spprojecttasklist: 'Задачи проекта',
  sppublishingpageslibrarylist: 'Библиотека страниц',
  filetype_sppublishingpageslibrarylist: 'Библиотека страниц',
  spreportdocumentlibrarylist: 'Библиотека документов отчетов',
  filetype_spreportdocumentlibrarylist: 'Библиотека документов отчетов',
  spreportlibrarylist: 'Библиотека отчетов',
  filetype_spreportlibrarylist: 'Библиотека отчетов',
  spslidelibrarylist: 'Библиотека слайдов',
  filetype_spslidelibrarylist: 'Библиотека слайдов',
  sptab: 'Вкладки',
  filetype_sptab: 'Вкладки',
  sptablist: 'Список вкладок',
  filetype_sptablist: 'Список вкладок',
  sptranslationmanagementlibrarylist: 'Многоязыковая библиотека',
  filetype_sptranslationmanagementlibrarylist: 'Многоязыковая библиотека',
  spuserinformation: 'Сведения о пользователе',
  filetype_spuserinformation: 'Сведения о пользователе',
  spuserinformationlist: 'Список сведений о пользователе',
  filetype_spuserinformationlist: 'Список сведений о пользователе',
  spwikipagelibrarylist: 'Библиотека вики-страниц',
  filetype_spwikipagelibrarylist: 'Библиотека вики-страниц',
  spworkflowhistory: 'Журнал рабочего процесса',
  filetype_spworkflowhistory: 'Журнал рабочего процесса',
  spworkflowhistorylist: 'Список журналов рабочего процесса',
  filetype_spworkflowhistorylist: 'Список журналов рабочего процесса',
  spworkflowprocess: 'Пользовательский рабочий процесс',
  filetype_spworkflowprocess: 'Пользовательский рабочий процесс',
  spworkflowprocesslist: 'Пользовательские рабочие процессы',
  filetype_spworkflowprocesslist: 'Пользовательские рабочие процессы',
  sppublishingimageslibrarylist: 'Библиотека изображений публикации',
  filetype_sppublishingimageslibrarylist: 'Библиотека изображений публикации',
  spcirculation: 'Циркуляр',
  filetype_spcirculation: 'Циркуляр',
  spcirculationlist: 'Циркуляры',
  filetype_spcirculationlist: 'Циркуляры',
  spdashboardslibrarylist: 'Библиотека панелей мониторинга',
  filetype_spdashboardslibrarylist: 'Библиотека панелей мониторинга',
  spdataconnectionforperformancepointlibrarylist: 'Библиотека подключений к данным PerformancePoint',
  filetype_spdataconnectionforperformancepointlibrarylist: 'Библиотека подключений к данным PerformancePoint',
  sphealthreport: 'Отчет о работоспособности',
  filetype_sphealthreport: 'Отчет о работоспособности',
  sphealthreportlist: 'Отчеты о работоспособности',
  filetype_sphealthreportlist: 'Отчеты о работоспособности',
  sphealthrule: 'Правило работоспособности',
  filetype_sphealthrule: 'Правило работоспособности',
  sphealthrulelist: 'Правила работоспособности',
  filetype_sphealthrulelist: 'Правила работоспособности',
  spimedictionary: 'Словарь IME',
  filetype_spimedictionary: 'Словарь IME',
  spimedictionarylist: 'Словари IME',
  filetype_spimedictionarylist: 'Словари IME',
  spperformancepointcontent: 'Содержание PerformancePoint',
  filetype_spperformancepointcontent: 'Содержание PerformancePoint',
  spperformancepointcontentlist: 'Содержание PerformancePoint',
  filetype_spperformancepointcontentlist: 'Содержание PerformancePoint',
  spphonecallmemo: 'Памятка телефонного вызова',
  filetype_spphonecallmemo: 'Памятка телефонного вызова',
  spphonecallmemolist: 'Памятки телефонных вызовов',
  filetype_spphonecallmemolist: 'Памятки телефонных вызовов',
  sprecordlibrarylist: 'Библиотека записей',
  filetype_sprecordlibrarylist: 'Библиотека записей',
  spresource: 'Ресурс',
  filetype_spresource: 'Ресурс',
  spresourcelist: 'Ресурсы',
  filetype_spresourcelist: 'Ресурсы',
  spprocessdiagramslibrarylist: 'Библиотека схем процессов',
  filetype_spprocessdiagramslibrarylist: 'Библиотека схем процессов',
  spsitethemeslibrarylist: 'Библиотека тем сайта',
  filetype_spsitethemeslibrarylist: 'Библиотека тем сайта',
  spsolutionslibrarylist: 'Библиотека решений',
  filetype_spsolutionslibrarylist: 'Библиотека решений',
  spwfpublibrarylist: 'Библиотека WFPUB',
  filetype_spwfpublibrarylist: 'Библиотека WFPUB',
  spwhereabout: 'Местонахождение',
  filetype_spwhereabout: 'Местонахождение',
  spwhereaboutlist: 'Местонахождения',
  filetype_spwhereaboutlist: 'Местонахождения',
  spdocumentlink: 'Ссылка на документ',
  filetype_spdocumentlink: 'Ссылка на документ',
  spdocumentset: 'Набор документов',
  filetype_spdocumentset: 'Набор документов',
  spmicrofeedpost: 'Запись микроканала',
  filetype_spmicrofeedpost: 'Запись микроканала',
  spmicrofeedlist: 'Микроканал',
  filetype_spmicrofeedlist: 'Микроканал',
  splistfolder: 'Содержимое папки',
  filetype_splistfolder: 'Содержимое папки',
  Unknown: 'Неизвестно',
  And: 'И',
  Authenticating: 'Аутентификация {0}...',
  Clear: 'Очистить {0}',
  CompleteQuery: 'Полная строка запроса',
  Exclude: 'Исключить {0}',
  EnterTag: 'Добавить тег',
  Next: 'Следующая',
  Last: 'Последняя',
  Link: 'Ссылка',
  Or: 'ИЛИ',
  Previous: 'Предыдущая',
  QueryDidntMatchAnyDocuments: 'Ни один из документов не отвечает вашему запросу.',
  QueryException: 'В вашем запросе содержится ошибка: {0}.',
  Me: 'Я',
  Remove: 'Удалить',
  Search: 'Искать',
  SearchFor: 'Найти {0}',
  ShareQuery: 'Поделиться запросом',
  Preferences: 'Личные параметры настройки',
  LinkOpeningSettings: 'Параметры настройки открытия ссылок',
  Reauthenticate: 'Повторная аутентификация {0}',
  ResultsFilteringExpression: 'Результаты фильтрации поисковых фраз',
  FiltersInYourPreferences: 'Фильтры в личных параметрах настройки',
  Create: 'Создать',
  SearchIn: 'Найти в {0}',
  Seconds: 'через {0} <sn>секунду</sn><pl>секунд</pl>',
  ShowingResultsOf: 'Результат<pl>ы</pl> {0}<pl>-{1}</pl> из {2}',
  ShowingResultsOfWithQuery: 'Результат<pl>ы</pl> {0}<pl>-{1}</pl> из {2} на {3}',
  SwitchTo: 'Переключиться на {0}',
  Unexclude: 'Убрать исключение {0}',
  ClearAllFilters: 'Сброс всех фильтров',
  SkipLogin: 'Пропустить авторизацию',
  LoginInProgress: 'Выполняется авторизация, пожалуйста, подождите ...',
  Login: 'Авторизоваться',
  GetStarted: 'Начать',
  More: 'Больше',
  NMore: 'еще {0}…',
  Less: 'Меньше',
  Settings: 'Параметры настройки',
  Score: 'Показатель',
  ScoreDescription: 'Показатель рассчитывается исходя из количества результатов, а также из положения в перечне результатов.',
  Occurrences: 'Совпадения',
  OccurrencesDescription: 'Сортировать по количеству совпадений - в порядке убывания.',
  Label: 'Ярлык',
  Of: 'из',
  LabelDescription: 'Сортировать в алфавитном порядке по значениям поля.',
  Value: 'Значение',
  ValueDescription: 'Сортировать по значениям первого расчетного поля',
  AlphaAscending: 'Возрастающее значение',
  AlphaDescending: 'Убывающее значение',
  ChiSquare: 'Хи-квадрат',
  Nosort: 'Не отсортировано',
  NosortDescription: 'Не сортировать значения. Они будут показаны в произвольном порядке.',
  RelativeFrequency: 'Относительная частота',
  RelativeFrequencyDescription: 'Сортировать по значению относительной частоты. Нечастотные значения отобразятся сверху',
  DateDistribution: 'Дата распределения',
  Custom: 'Пользовательский',
  CustomDescription: 'Сортировать в специальном порядке',
  ComputedField: 'Расчетное поле',
  Ascending: 'По возрастанию',
  Descending: 'По убыванию',
  noResultFor: 'Нет результатов по {0}',
  autoCorrectedQueryTo: 'Запрос автоматически исправлен на {0}',
  didYouMean: 'Вы имели в виду {0}',
  SuggestedResults: 'Предлагаемые результаты',
  SuggestedQueries: 'Предлагаемые запросы',
  MostRelevantItems: 'Наиболее релевантные пункты:',
  AllItems: 'Все пункты:',
  ShowLess: 'Показывать меньше',
  ShowMore: 'Показывать больше',
  HideFacet: 'Скрыть ячейку',
  ShowFacet: 'Показать ячейку',
  AndOthers: 'и {0} другой (другие)',
  Others: '{0} другой (другие)',
  MostRelevantPosts: 'Наиболее релевантные сообщения:',
  CompleteThread: 'Вся ветка обсуждения:',
  ShowCompleteThread: 'Показать всю ветку обсуждения',
  ShowOnlyTopMatchingPosts: 'Показать только верхние подходящие сообщения',
  MostRelevantReplies: 'Наиболее релевантные ответы:',
  AllConversation: 'Все диалоги:',
  ShowAllConversation: 'Показать весь диалог',
  ShowAllReplies: 'Показать все ответы',
  ShowOnlyMostRelevantReplies: 'Показывать только наиболее релевантные ответы',
  Close: 'Закрыть',
  Open: 'Открыть',
  OpenInOutlookWhenPossible: 'Открывать в Outlook (когда возможно)',
  AlwaysOpenInNewWindow: 'Всегда открывать результаты в новом окне',
  Quickview: 'Быстрый просмотр',
  NoQuickview: 'Быстрый просмотр для этого документа недоступен',
  ErrorReport: 'Сообщение об ошибке',
  OopsError: 'Что-то случилось с сервером.',
  ProblemPersists: 'При постоянном возникновении этой проблемы обратитесь к администратору.',
  GoBack: 'Назад',
  Reset: 'Перезагрузка',
  Retry: 'Повторить',
  MoreInfo: 'Дополнительная информация',
  Username: 'Имя пользователя',
  Password: 'Пароль',
  PostedBy: 'Опубликовано',
  CannotConnect: 'Невозможно подключиться к адресу сервера',
  BadUserPass: 'Пароль не соответствует имени пользователя',
  PleaseEnterYourCredentials: 'Введите свои учетные данные для {0}.',
  PleaseEnterYourSearchPage: 'Пожалуйста, введите URL-адрес искомой страницы',
  Collapse: 'Свернуть',
  Collapsable: 'Свертываемый',
  Expand: 'Расширить',
  Today: 'Сегодня',
  Yesterday: 'Вчера',
  Tomorrow: 'Завтра',
  Duration: 'Продолжительность: {0}',
  IndexDuration: 'Продолжительность индекса: {0}',
  ProxyDuration: 'Продолжительность прокси: {0}',
  ClientDuration: 'Продолжительность клиента: {0}',
  Unavailable: 'Недоступно',
  Reply: 'Ответить',
  ReplyAll: 'Ответить всем',
  Forward: 'Переслать',
  From: 'От',
  Caption: 'Заголовок',
  Expression: 'Поисковая фраза',
  Tab: 'Вкладка',
  Tabs: 'Вкладки',
  EnterExpressionName: 'Введите фразу',
  EnterExpressionToFilterWith: 'Введите фразу для фильтрации результатов',
  SelectTab: 'Выбрать вкладку',
  SelectAll: 'Выбрать все',
  PageUrl: 'Найти URL-адрес страницы',
  ErrorSavingToDevice: 'Ошибка при сохранении информации на ваше устройство',
  ErrorReadingFromDevice: 'Ошибка при чтении информации с вашего устройства',
  AppIntro: 'Пообщайтесь со специалистом по продукции, который сможет ответить на ваши вопросы о Conveo и поможет решить, какое решение Coveo вам подойдет. Или попробуйте демоверсию с автоматическим обновлением!',
  TryDemo: 'Попробовать демоверсию',
  ContactUs: 'Связаться с нами',
  NewToCoveo: 'Не знакомы с Coveo?',
  LetUsHelpGetStarted: 'Позвольте помочь вам приступить к работе',
  LikesThis: '{0} нравится<sn> нравится</sn> это.',
  CannotConnectSearchPage: 'Не удалось подключиться к вашей странице поиска',
  AreYouSureDeleteFilter: 'Вы действительно желаете удалить фильтр {0} с поисковой фразой {1}',
  OnlineHelp: 'Онлайн справка',
  Done: 'Выполнено',
  SaveFacetState: 'Сохранить формат данной ячейки',
  ClearFacetState: 'Очистить формат ячейки',
  DisplayingTheOnlyMessage: 'Отображение единственного сообщения в данном диалоге',
  NoNetworkConnection: 'Нет сетевых подключений',
  UnknownConnection: 'Неизвестное подключение',
  EthernetConnection: 'Подключение через Ethernet',
  WiFi: 'Подключение через WiFi',
  CELL: 'Мобильное подключение',
  CELL_2G: 'Мобильное подключение 2G',
  CELL_3G: 'Мобильное подключение 3G',
  CELL_4G: 'Мобильное подключение 4G',
  Relevance: 'Релевантность',
  Date: 'Дата',
  Amount: 'Количество',
  QueryExceptionNoException: 'Нет исключений',
  QueryExceptionInvalidSyntax: 'Недопустимый синтаксис',
  QueryExceptionInvalidCustomField: 'Недопустимое расчетное поле',
  QueryExceptionInvalidDate: 'Недопустимая дата',
  QueryExceptionInvalidExactPhrase: 'Недопустимая точная фраза',
  QueryExceptionInvalidDateOp: 'Недопустимый оператор дат',
  QueryExceptionInvalidNear: 'Недопустимый оператор NEAR',
  QueryExceptionInvalidWeightedNear: 'Недопустимый взвешенный NEAR',
  QueryExceptionInvalidTerm: 'Недопустимый термин',
  QueryExceptionTooManyTerms: 'Слишком много терминов',
  QueryExceptionWildcardTooGeneral: 'Слишком общий специальный символ',
  QueryExceptionInvalidSortField: 'Недопустимое поле сортировки',
  QueryExceptionInvalidSmallStringOp: 'Недопустимый строковый оператор',
  QueryExceptionRequestedResultsMax: 'Максимум запрашиваемых результатов',
  QueryExceptionAggregatedMirrorDead: 'Уделенное зеркало отключено',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Время ожидания запроса через уделенное зеркало',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Недопустимый текущий номер удаленного зеркала',
  QueryExceptionAggregatedMirrorCannotConnect: 'Интегральное зеркало невозможно подключить',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Недостаточное количество ведущих символов до специального символа',
  QueryExceptionSecurityInverterNotFound: 'Инвертор безопасности не найден',
  QueryExceptionSecurityInverterAccessDenied: 'В доступе к инвертору безопасности отказано',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'Уделенное зеркало не может отправлять запросы от имени пользователя',
  QueryExceptionUnexpected: 'Непредвиденный',
  QueryExceptionAccessDenied: 'В доступе отказано',
  QueryExceptionSuperUserTokenInvalid: 'Право доступа привилегированного пользователя недействительно',
  QueryExceptionSuperUserTokenExpired: 'Право доступа привилегированного пользователя истекло',
  QueryExceptionLicenseQueriesExpired: 'Лицензия на осуществление запросов истекла',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'Лицензия доступа привилегированного пользователя не поддерживается',
  QueryExceptionInvalidSession: 'Сессия недействительна',
  QueryExceptionInvalidDocument: 'Недействительный документ',
  QueryExceptionSearchDisabled: 'Поиск отключен',
  FileType: 'Тип файла',
  ShowAttachment: 'Показать приложение',
  OnFeed: 'на {0} исходный материал.',
  Author: 'Автор',
  NoTitle: 'Без названия',
  CurrentSelections: 'Текущие результаты выбора',
  AllContent: 'Все содержание',
  CancelLastAction: 'Отменить последнее действие',
  SearchTips: 'Найти подсказку',
  CheckSpelling: 'Проверьте правописание ключевых слов',
  TryUsingFewerKeywords: 'Попытайтесь использовать меньшее количество, другие и более общие ключевые слова.',
  SelectFewerFilters: 'Сократите количество фильтров для расширения поиска.',
  Document: 'Документ',
  Time: 'Время',
  StartDate: 'Дата начала',
  StartTime: 'Время начала',
  DurationTitle: 'Продолжительность',
  UserQuery: 'Запрос пользователя',
  ShowUserActions: 'Показывать действия пользователя',
  NoData: 'Нет доступных данных',
  EventType: 'Тип события',
  GoToFullSearch: 'Полный поиск',
  GoToEdition: 'Настроить панель',
  RemoveContext: 'Удалить контекст',
  BoxAttachToCase: 'Приложить к обращению',
  AttachToCase: 'Приложить к обращению',
  Attach: 'Приложить',
  Attached: 'Приложено',
  Detach: 'Удалить',
  Details: 'Подробности',
  AdditionalFilters: 'Дополнительные фильтры',
  SelectNonContextualSearch: 'Удалить контекст из текущей записи, чтобы расширить поиск',
  CopyPasteToSupport: 'Для получения дополнительной информации скопируйте и вставьте это сообщение для службы поддержки Coveo.',
  FollowQueryDescription: 'Оповещать меня об изменениях в результатах поиска по этому запросу.',
  SearchAlerts_Panel: 'Управление оповещениями',
  SearchAlerts_PanelDescription: 'Просматривайте и управляйте поиском оповещений.',
  SearchAlerts_PanelNoSearchAlerts: 'У вас нет подписок.',
  SearchAlerts_Fail: 'Служба поиска оповещений сейчас недоступна.',
  SearchAlerts_Type: 'Тип',
  SearchAlerts_Content: 'Содержание',
  SearchAlerts_Actions: 'Действие',
  EmptyQuery: '<пусто>',
  SearchAlerts_Type_followQuery: 'Запрос',
  SearchAlerts_Type_followDocument: 'Элемент',
  SearchAlerts_unFollowing: 'Отменить подписку',
  SearchAlerts_follow: 'Подписаться',
  SearchAlerts_followed: 'Подписка оформлена',
  SearchAlerts_followQuery: 'Подписаться на запрос',
  Subscription_StopFollowingQuery: 'Отменить подписку на запрос',
  SearchAlerts_Frequency: 'Когда',
  SubscriptionsManageSubscriptions: 'Управление оповещениями',
  SubscriptionsMessageFollowQuery: 'Вы будете оповещены, когда по запросу <b>{0}</b> будут выданы новые или обновленные элементы.',
  SubscriptionsMessageFollow: 'Вы будете оповещены об изменениях элемента <b>{0}</b>.',
  Expiration: 'Срок действия',
  Monthly: 'Ежемесячно',
  Daily: 'Ежедневно',
  Monday: 'Понедельник',
  Tuesday: 'Вторник',
  Wednesday: 'Среда',
  Thursday: 'Четверг',
  Friday: 'Пятница',
  Saturday: 'Суббота',
  Sunday: 'Воскресенье',
  NextDay: 'В следующий (-ую, -ее) {0}',
  LastDay: 'В прошлый (-ую, ое) {0}',
  StartTypingCaseForSuggestions: 'Опишите свою проблему, чтобы увидеть возможные решения',
  ExportToExcel: 'Экспортировать в Excel',
  ExportToExcelDescription: 'Экспортировать результаты поиска в Excel',
  CaseCreationNoResults: 'Рекомендованные решения не найдены',
  SortBy: 'Сортировать по',
  BoxCreateArticle: 'Создать статью',
  Facets: 'Аспекты',
  AdvancedSearch: 'Расширенный поиск',
  Keywords: 'Ключевые слова',
  AllTheseWords: 'Все эти слова',
  ExactPhrase: 'Эта точная фраза',
  AnyOfTheseWords: 'Любое из этих слов',
  NoneOfTheseWords: 'Ни одно из этих слов',
  Anytime: 'В любое время',
  InTheLast: 'За последние',
  Days: 'день (дня, дней)',
  Months: 'месяца(-ев)',
  Month: 'Месяц',
  Year: 'Год',
  Between: 'Между',
  Language: 'Язык',
  Size: 'Размер',
  AtLeast: 'минимум',
  AtMost: 'максимум',
  Contains: 'содержит',
  DoesNotContain: 'не содержит',
  Matches: 'совпадения(-й)',
  Bytes: 'байт(-а, -ов)',
  card: 'Карта',
  table: 'Таблица',
  ResultLinks: 'Ссылки на результаты',
  EnableQuerySyntax: 'Включить синтаксис запросов',
  On: 'Включено',
  Off: 'Выключено',
  Automatic: 'Автоматически',
  ResultsPerPage: 'Результатов на странице',
  PreviousMonth: 'Предыдущий месяц',
  NextMonth: 'Следующий месяц',
  Title: 'Заголовок',
  TRCoveoSearchResults: 'Результаты поиска',
  TRCoveoApply: 'Применить',
  TRCoveoClearAll: 'Очистить все',
  SearchBoxSearch: 'Поиск',
  TRNoResultsFound: 'Результаты не найдены',
  TRDidntFindResults: 'Мы не нашли результатов по запросу {0}.',
  TRSuggestions: 'Предложения',
  TRSpellAllWordsCorrectly: 'Слова должны быть написаны правильно',
  TRChangeOrClearFilters: 'Изменить или {clear} ваши фильтры',
  TRTryDifferentKeywords: 'Try different keywords',
  TRViewingNoResults: 'Просмотр: 0 результатов по запросу {0}',
  TRLogin: 'Вход',
  TRSupport: 'Поддержка',
  TRStoreFormat: 'Формат',
  TRStoreAvailability: 'Доступность',
  TRFilter: 'фильтр',
  TRFilters: 'фильтры',
  TRMin: 'мин',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: 'Продолжайте искать!',
  TRKeepSearchingDescription: 'И мы продолжим писать. Каждый ваш поиск помогает нам понять, что вас интересует.',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  InsertAQuery: 'Поиск',
  PressEnterToSend: ''
};

/* eslint-disable import/no-anonymous-default-export */
var es_es = {
  'box user': 'Usuario',
  'filetype_box user': 'Usuario',
  lithiummessage: 'Mensaje de Lithium',
  filetype_lithiummessage: 'Mensaje de Lithium',
  lithiumthread: 'Conversación de Lithium',
  filetype_lithiumthread: 'Conversación de Lithium',
  lithiumboard: 'Panel de Lithium',
  filetype_lithiumboard: 'Panel de Lithium',
  lithiumcategory: 'Categoría de Lithium',
  filetype_lithiumcategory: 'Categoría de Lithium',
  lithiumcommunity: 'Comunidad de Lithium',
  filetype_lithiumcommunity: 'Comunidad de Lithium',
  incident: 'Consulta',
  youtube: 'Vídeo de YouTube',
  filetype_youtube: 'Vídeo de YouTube',
  html: 'Archivo HTML',
  filetype_html: 'Archivo HTML',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Página web',
  filetype_webscraperwebpage: 'Página web',
  image: 'Imagen',
  filetype_image: 'Imagen',
  folder: 'Carpeta',
  filetype_folder: 'Carpeta',
  txt: 'Texto',
  filetype_txt: 'Texto',
  zip: 'Archivo Zip',
  filetype_zip: 'Archivo Zip',
  olefile: 'Archivo OLE',
  filetype_olefile: 'Archivo OLE',
  gmailmessage: 'Mensaje de Gmail',
  filetype_gmailmessage: 'Mensaje de Gmail',
  pdf: 'Archivo PDF',
  filetype_pdf: 'Archivo PDF',
  swf: 'Archivo Flash',
  filetype_swf: 'Archivo Flash',
  xml: 'Archivo XML',
  filetype_xml: 'Archivo XML',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'Feed RSS',
  filetype_rssitem: 'Feed RSS',
  doc: 'Documento',
  filetype_doc: 'Documento',
  docx: 'Documento de Microsoft Word',
  filetype_docx: 'Documento de Microsoft Word',
  xls: 'Hoja de cálculo',
  filetype_xls: 'Hoja de cálculo',
  ppt: 'Presentación',
  filetype_ppt: 'Presentación',
  video: 'Vídeo',
  filetype_video: 'Vídeo',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Documento de Open Text',
  filetype_odt: 'Documento de Open Text',
  people: 'Usuario',
  objecttype_people: 'Usuario',
  message: 'Mensaje',
  objecttype_message: 'Mensaje',
  feed: 'Feed RSS',
  objecttype_feed: 'Feed RSS',
  thread: 'Conversación',
  objecttype_thread: 'Conversación',
  file: 'Archivo',
  objecttype_file: 'Archivo',
  board: 'Panel',
  objecttype_board: 'Panel',
  category: 'Categoría',
  objecttype_category: 'Categoría',
  account: 'Cuenta',
  objecttype_account: 'Cuenta',
  annotation: 'Nota',
  objecttype_annotation: 'Nota',
  campaign: 'Campaña',
  objecttype_campaign: 'Campaña',
  "case": 'Consulta',
  objecttype_case: 'Consulta',
  contact: 'Contacto',
  objecttype_contact: 'Contacto',
  contract: 'Contrato',
  objecttype_contract: 'Contrato',
  event: 'Evento',
  objecttype_event: 'Evento',
  email: 'Correo electrónico',
  objecttype_email: 'Correo electrónico',
  goal: 'Objetivo',
  objecttype_goal: 'Objetivo',
  objecttype_incident: 'Consulta',
  invoice: 'Factura',
  objecttype_invoice: 'Factura',
  lead: 'Cliente potencial',
  objecttype_lead: 'Cliente potencial',
  list: 'Lista',
  objecttype_list: 'Lista de marketing',
  solution: 'Solución',
  objecttype_solution: 'Solución',
  task: 'Tarea',
  objecttype_task: 'Tarea',
  user: 'Usuario',
  objecttype_user: 'Usuario',
  attachment: 'Archivo adjunto',
  objecttype_attachment: 'Archivo adjunto',
  casecomment: 'Comentario sobre una consulta',
  objecttype_casecomment: 'Comentario sobre una consulta',
  opportunity: 'Oportunidad',
  objecttype_opportunity: 'Oportunidad',
  opportunityproduct: 'Producto de oportunidad',
  objecttype_opportunityproduct: 'Producto de oportunidad',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: 'Nota',
  objecttype_note: 'Nota',
  product: 'Producto',
  objecttype_product: 'Producto',
  partner: 'Socio',
  objecttype_partner: 'Socio',
  queueitem: 'Elemento en cola',
  objecttype_queueitem: 'Elemento en cola',
  quote: 'Presupuesto',
  objecttype_quote: 'Presupuesto',
  salesliterature: 'Documentación de ventas',
  objecttype_salesliterature: 'Documentación de ventas',
  salesorder: 'Pedido',
  objecttype_salesorder: 'Pedido',
  service: 'Servicio',
  objecttype_service: 'Servicio',
  socialprofile: 'Perfil social',
  objecttype_socialprofile: 'Perfil social',
  kbdocumentation: 'Documentación',
  objecttype_kbdocumentation: 'Documentación',
  kbtechnicalarticle: 'Documentación',
  objecttype_kbtechnicalarticle: 'Documentación',
  kbsolution: 'Solución',
  objecttype_kbsolution: 'Solución',
  kbknowledgearticle: 'Artículo de base de conocimiento',
  objecttype_kbknowledgearticle: 'Artículo de base de conocimiento',
  kbattachment: 'Archivo adjunto',
  objecttype_kbattachment: 'Archivo adjunto',
  kbarticle: 'Artículo',
  objecttype_kbarticle: 'Artículo',
  kbarticlecomment: 'Comentario del artículo',
  objecttype_kbarticlecomment: 'Comentario del artículo',
  knowledgearticle: 'Artículo de base de conocimiento',
  objecttype_knowledgearticle: 'Artículo de base de conocimiento',
  topic: 'Tema',
  objecttype_topic: 'Tema',
  dashboard: 'Panel de información',
  objecttype_dashboard: 'Panel de información',
  contentversion: 'Documento',
  objecttype_contentversion: 'Documento',
  collaborationgroup: 'Grupo de colaboración',
  objecttype_collaborationgroup: 'Grupo de colaboración',
  spportal: 'Portal',
  filetype_spportal: 'Portal',
  spsite: 'Sitio',
  filetype_spsite: 'Sitio',
  spuserprofile: 'Usuario de SharePoint',
  filetype_spuserprofile: 'Usuario de SharePoint',
  sparea: 'Área',
  filetype_sparea: 'Área',
  spannouncement: 'Anuncio',
  filetype_spannouncement: 'Anuncio',
  spannouncementlist: 'Anuncios',
  filetype_spannouncementlist: 'Anuncios',
  spcontact: 'Contacto',
  filetype_spcontact: 'Contacto',
  spcontactlist: 'Contactos',
  filetype_spcontactlist: 'Contactos',
  spcustomlist: 'Listas personalizadas',
  filetype_spcustomlist: 'Listas personalizadas',
  spdiscussionboard: 'Panel de discusión',
  filetype_spdiscussionboard: 'Panel de discusión',
  spdiscussionboardlist: 'Paneles de discusión',
  filetype_spdiscussionboardlist: 'Paneles de discusión',
  spdocumentlibrarylist: 'Biblioteca de documentos',
  filetype_spdocumentlibrarylist: 'Biblioteca de documentos',
  spevent: 'Evento',
  filetype_spevent: 'Evento',
  speventlist: 'Eventos',
  filetype_speventlist: 'Eventos',
  spformlibrarylist: 'Biblioteca de formularios',
  filetype_spformlibrarylist: 'Biblioteca de formularios',
  spissue: 'Problema',
  filetype_spissue: 'Problema',
  spissuelist: 'Problemas',
  filetype_spissuelist: 'Problemas',
  splink: 'Vínculo',
  filetype_splink: 'Vínculo',
  splinklist: 'Vínculos',
  filetype_splinklist: 'Vínculos',
  sppicturelibrarylist: 'Biblioteca de imágenes',
  filetype_sppicturelibrarylist: 'Biblioteca de imágenes',
  spsurvey: 'Encuesta',
  filetype_spsurvey: 'Encuesta',
  spsurveylist: 'Encuestas',
  filetype_spsurveylist: 'Encuestas',
  sptask: 'Tarea',
  filetype_sptask: 'Tarea',
  sptasklist: 'Tareas',
  filetype_sptasklist: 'Tareas',
  spagenda: 'Agenda',
  filetype_spagenda: 'Agenda',
  spagendalist: 'Agendas',
  filetype_spagendalist: 'Agendas',
  spattendee: 'Asistente',
  filetype_spattendee: 'Asistente',
  spattendeelist: 'Asistentes',
  filetype_spattendeelist: 'Asistentes',
  spcustomgridlist: 'Cuadrículas personalizadas',
  filetype_spcustomgridlist: 'Cuadrículas personalizadas',
  spdecision: 'Decisión',
  filetype_spdecision: 'Decisión',
  spdecisionlist: 'Decisiones',
  filetype_spdecisionlist: 'Decisiones',
  spobjective: 'Objetivo',
  filetype_spobjective: 'Objetivo',
  spobjectivelist: 'Objetivos',
  filetype_spobjectivelist: 'Objetivos',
  sptextbox: 'Cuadro de texto',
  filetype_sptextbox: 'Cuadro de texto',
  sptextboxlist: 'Lista de cuadros de texto',
  filetype_sptextboxlist: 'Lista de cuadros de texto',
  spthingstobring: 'Elemento que aportar',
  filetype_spthingstobring: 'Elemento que aportar',
  spthingstobringlist: 'Elementos que aportar',
  filetype_spthingstobringlist: 'Elementos que aportar',
  sparealisting: 'Listado de área',
  filetype_sparealisting: 'Listado de área',
  spmeetingserie: 'Serie de reuniones',
  filetype_spmeetingserie: 'Serie de reuniones',
  spmeetingserielist: 'Lista de series de reuniones',
  filetype_spmeetingserielist: 'Lista de series de reuniones',
  spsitedirectory: 'Elemento del directorio de sitios',
  filetype_spsitedirectory: 'Elemento del directorio de sitios',
  spsitedirectorylist: 'Directorio de sitios',
  filetype_spsitedirectorylist: 'Directorio de sitios',
  spdatasource: 'Fuente de datos',
  filetype_spdatasource: 'Fuente de datos',
  spdatasourcelist: 'Lista de fuentes de datos',
  filetype_spdatasourcelist: 'Lista de fuentes de datos',
  splisttemplatecataloglist: 'Galería de plantillas de listas',
  filetype_splisttemplatecataloglist: 'Galería de plantillas de listas',
  spwebpartcataloglist: 'Galería de elementos web',
  filetype_spwebpartcataloglist: 'Galería de elementos web',
  spwebtemplatecataloglist: 'Galería de plantillas de sitio',
  filetype_spwebtemplatecataloglist: 'Galería de plantillas de sitio',
  spworkspacepagelist: 'Páginas del área de trabajo',
  filetype_spworkspacepagelist: 'Páginas del área de trabajo',
  spunknownlist: 'Lista personalizada',
  filetype_spunknownlist: 'Lista personalizada',
  spadministratortask: 'Tarea del administrador',
  filetype_spadministratortask: 'Tarea del administrador',
  spadministratortasklist: 'Tareas del administrador',
  filetype_spadministratortasklist: 'Tareas del administrador',
  spareadocumentlibrarylist: 'Biblioteca de documentos del área',
  filetype_spareadocumentlibrarylist: 'Biblioteca de documentos del área',
  spblogcategory: 'Categoría del blog',
  filetype_spblogcategory: 'Categoría del blog',
  spblogcategorylist: 'Categorías del blog',
  filetype_spblogcategorylist: 'Categorías del blog',
  spblogcomment: 'Comentario del blog',
  filetype_spblogcomment: 'Comentario del blog',
  spblogcommentlist: 'Comentarios del blog',
  filetype_spblogcommentlist: 'Comentarios del blog',
  spblogpost: 'Publicación del blog',
  filetype_spblogpost: 'Publicación del blog',
  spblogpostlist: 'Publicaciones del blog',
  filetype_spblogpostlist: 'Publicaciones del blog',
  spdataconnectionlibrarylist: 'Biblioteca de conexión de datos',
  filetype_spdataconnectionlibrarylist: 'Biblioteca de conexión de datos',
  spdistributiongroup: 'Grupo de distribución',
  filetype_spdistributiongroup: 'Grupo de distribución',
  spdistributiongrouplist: 'Grupos de distribución',
  filetype_spdistributiongrouplist: 'Grupos de distribución',
  spipfslist: 'Servidores de formularios InfoPath',
  filetype_spipfslist: 'Servidores de formularios InfoPath',
  spkeyperformanceindicator: 'Indicador de rendimiento clave',
  filetype_spkeyperformanceindicator: 'Indicador de rendimiento clave',
  spkeyperformanceindicatorlist: 'Indicadores de rendimiento clave',
  filetype_spkeyperformanceindicatorlist: 'Indicadores de rendimiento clave',
  splanguagesandtranslator: 'Idiomas y traductor',
  filetype_splanguagesandtranslator: 'Idiomas y traductor',
  splanguagesandtranslatorlist: 'Idiomas y traductores',
  filetype_splanguagesandtranslatorlist: 'Idiomas y traductores',
  spmasterpagescataloglist: 'Galería de página principal',
  filetype_spmasterpagescataloglist: 'Galería de página principal',
  spnocodeworkflowlibrarylist: 'Bibliotecas de flujo de trabajo sin código',
  filetype_spnocodeworkflowlibrarylist: 'Bibliotecas de flujo de trabajo sin código',
  spprojecttask: 'Tarea de proyecto',
  filetype_spprojecttask: 'Tarea de proyecto',
  spprojecttasklist: 'Tareas de proyecto',
  filetype_spprojecttasklist: 'Tareas de proyecto',
  sppublishingpageslibrarylist: 'Biblioteca de páginas',
  filetype_sppublishingpageslibrarylist: 'Biblioteca de páginas',
  spreportdocumentlibrarylist: 'Biblioteca de documentos de informe',
  filetype_spreportdocumentlibrarylist: 'Biblioteca de documentos de informe',
  spreportlibrarylist: 'Bilioteca de informes',
  filetype_spreportlibrarylist: 'Bilioteca de informes',
  spslidelibrarylist: 'Biblioteca de diapositivas',
  filetype_spslidelibrarylist: 'Biblioteca de diapositivas',
  sptab: 'Pestañas',
  filetype_sptab: 'Pestañas',
  sptablist: 'Lista de pestañas',
  filetype_sptablist: 'Lista de pestañas',
  sptranslationmanagementlibrarylist: 'Biblioteca de administración de traducciones',
  filetype_sptranslationmanagementlibrarylist: 'Biblioteca de administración de traducciones',
  spuserinformation: 'Información de usuario',
  filetype_spuserinformation: 'Información de usuario',
  spuserinformationlist: 'Lista de información de usuario',
  filetype_spuserinformationlist: 'Lista de información de usuario',
  spwikipagelibrarylist: 'Biblioteca de páginas wiki',
  filetype_spwikipagelibrarylist: 'Biblioteca de páginas wiki',
  spworkflowhistory: 'Historial del flujo de trabajo',
  filetype_spworkflowhistory: 'Historial del flujo de trabajo',
  spworkflowhistorylist: 'Lista de historial del flujo de trabajo',
  filetype_spworkflowhistorylist: 'Lista de historial del flujo de trabajo',
  spworkflowprocess: 'Proceso personalizado del flujo de trabajo',
  filetype_spworkflowprocess: 'Proceso personalizado del flujo de trabajo',
  spworkflowprocesslist: 'Procesos personalizados del flujo de trabajo',
  filetype_spworkflowprocesslist: 'Procesos personalizados del flujo de trabajo',
  sppublishingimageslibrarylist: 'Biblioteca de imágenes de publicación',
  filetype_sppublishingimageslibrarylist: 'Biblioteca de imágenes de publicación',
  spcirculation: 'Circulación',
  filetype_spcirculation: 'Circulación',
  spcirculationlist: 'Circulaciones',
  filetype_spcirculationlist: 'Circulaciones',
  spdashboardslibrarylist: 'Biblioteca de los paneles de información',
  filetype_spdashboardslibrarylist: 'Biblioteca de los paneles de información',
  spdataconnectionforperformancepointlibrarylist: 'Biblioteca de conexiones de datos de PerformancePoint',
  filetype_spdataconnectionforperformancepointlibrarylist: 'Biblioteca de conexiones de datos de PerformancePoint',
  sphealthreport: 'Informe de mantenimiento',
  filetype_sphealthreport: 'Informe de mantenimiento',
  sphealthreportlist: 'Informes de mantenimiento',
  filetype_sphealthreportlist: 'Informes de mantenimiento',
  sphealthrule: 'Regla de mantenimiento',
  filetype_sphealthrule: 'Regla de mantenimiento',
  sphealthrulelist: 'Reglas de mantenimiento',
  filetype_sphealthrulelist: 'Reglas de mantenimiento',
  spimedictionary: 'Diccionario IME',
  filetype_spimedictionary: 'Diccionario IME',
  spimedictionarylist: 'Diccionarios IME',
  filetype_spimedictionarylist: 'Diccionarios IME',
  spperformancepointcontent: 'Contenido de PerformancePoint',
  filetype_spperformancepointcontent: 'Contenido de PerformancePoint',
  spperformancepointcontentlist: 'Contenidos de PerformancePoint',
  filetype_spperformancepointcontentlist: 'Contenidos de PerformancePoint',
  spphonecallmemo: 'Memo de llamada telefónica',
  filetype_spphonecallmemo: 'Memo de llamada telefónica',
  spphonecallmemolist: 'Memos de llamadas telefónicas',
  filetype_spphonecallmemolist: 'Memos de llamadas telefónicas',
  sprecordlibrarylist: 'Biblioteca de registros',
  filetype_sprecordlibrarylist: 'Biblioteca de registros',
  spresource: 'Recurso',
  filetype_spresource: 'Recurso',
  spresourcelist: 'Recursos',
  filetype_spresourcelist: 'Recursos',
  spprocessdiagramslibrarylist: 'Biblioteca de diagramas de procesos',
  filetype_spprocessdiagramslibrarylist: 'Biblioteca de diagramas de procesos',
  spsitethemeslibrarylist: 'Biblioteca de temas del sitio',
  filetype_spsitethemeslibrarylist: 'Biblioteca de temas del sitio',
  spsolutionslibrarylist: 'Biblioteca de soluciones',
  filetype_spsolutionslibrarylist: 'Biblioteca de soluciones',
  spwfpublibrarylist: 'Biblioteca de WFPUB',
  filetype_spwfpublibrarylist: 'Biblioteca de WFPUB',
  spwhereabout: 'Localización',
  filetype_spwhereabout: 'Localización',
  spwhereaboutlist: 'Localizaciones',
  filetype_spwhereaboutlist: 'Localizaciones',
  spdocumentlink: 'Vínculo a un documento',
  filetype_spdocumentlink: 'Vínculo a un documento',
  spdocumentset: 'Conjunto de documentos',
  filetype_spdocumentset: 'Conjunto de documentos',
  spmicrofeedpost: 'Publicación de microfeed',
  filetype_spmicrofeedpost: 'Publicación de microfeed',
  spmicrofeedlist: 'Microfeed',
  filetype_spmicrofeedlist: 'Microfeed',
  splistfolder: 'Carpeta de listas',
  filetype_splistfolder: 'Carpeta de listas',
  Unknown: 'Desconocido',
  And: 'Y',
  Authenticating: 'Autenticando {0}...',
  Clear: 'Borrar {0}',
  CompleteQuery: 'Consulta completa',
  Exclude: 'Excluir {0}',
  EnterTag: 'Añadir etiqueta',
  Next: 'Siguiente',
  Last: 'Última',
  Link: 'Enlace',
  Or: 'O',
  Previous: 'Anterior',
  QueryDidntMatchAnyDocuments: 'Su consulta no coincide con ningún documento.',
  QueryException: 'Su consulta tiene un error: {0}.',
  Me: 'Yo',
  Remove: 'Eliminar',
  Search: 'Buscar',
  SearchFor: 'Buscar {0}',
  ShareQuery: 'Compartir consulta',
  Preferences: 'Preferencias',
  LinkOpeningSettings: 'Configuración de apertura de enlace',
  Reauthenticate: 'Volver a autenticar {0}',
  ResultsFilteringExpression: 'Expresiones de filtrado de resultados',
  FiltersInYourPreferences: 'Filtros en sus preferencias',
  Create: 'Crear',
  SearchIn: 'Buscar en {0}',
  Seconds: 'en {0} segundo<pl>s</pl>',
  ShowingResultsOf: 'Viendo: {0}<pl> a {1} de {2}</pl> resultado<pl>s</pl>',
  ShowingResultsOfWithQuery: 'Viendo: {0}<pl> a {1} de {2}</pl> resultado<pl>s</pl> para {3}',
  SwitchTo: 'Cambiar a {0}',
  Unexclude: 'No excluir {0}',
  ClearAllFilters: 'Borrar todos los filtros',
  SkipLogin: 'Omitir inicio de sesión',
  LoginInProgress: 'Iniciando sesión. Por favor, espere...',
  Login: 'Iniciar sesión',
  GetStarted: 'Empezar',
  More: 'Más',
  NMore: 'Mostrar más ({0})',
  Less: 'Menos',
  Settings: 'Configuración',
  Score: 'Relevancia',
  ScoreDescription: 'La relevancia se calcula a partir del número de apariciones, así como de la posición en el conjunto de resultados.',
  Occurrences: 'Apariciones',
  OccurrencesDescription: 'Ordenar por número de apariciones, con los valores que tienen un número superior primero.',
  Label: 'Etiqueta',
  Of: 'de',
  LabelDescription: 'Ordenar alfabéticamente en los valores de campo.',
  Value: 'Valor',
  ValueDescription: 'Ordenar por los valores del primer campo computado.',
  AlphaAscending: 'Valor ascendente',
  AlphaDescending: 'Valor descendente',
  ChiSquare: 'Chi cuadrado',
  Nosort: 'No ordenar',
  NosortDescription: 'No ordenar los valores. Los valores se devolverán en orden aleatorio.',
  RelativeFrequency: 'Frecuencia relativa',
  RelativeFrequencyDescription: 'Ordenar según la frecuencia relativa de los valores. Los valores menos comunes aparecerán más arriba.',
  DateDistribution: 'Distribución de fecha',
  Custom: 'Personalizado',
  CustomDescription: 'Ordenar según un pedido personalizado.',
  ComputedField: 'Campo computado',
  Ascending: 'Ascendente',
  Descending: 'Descendente',
  noResultFor: 'No hay resultados para {0}',
  noResult: 'No hay resultados',
  autoCorrectedQueryTo: 'La consulta se ha corregido automáticamente a {0}',
  didYouMean: 'Quiso decir {0}',
  SuggestedResults: 'Resultados sugeridos',
  SuggestedQueries: 'Consultas sugeridas',
  MostRelevantItems: 'Elementos más relevantes',
  AllItems: 'Todos los elementos:',
  ShowLess: 'Mostrar menos',
  ShowMore: 'Mostrar más',
  HideFacet: 'Ocultar faceta',
  ShowFacet: 'Mostrar faceta',
  AndOthers: 'y {0} otro<pl>s</pl>',
  Others: '{0} otro<pl>s</pl>',
  MostRelevantPosts: 'Publicaciones más relevantes:',
  CompleteThread: 'Hilo completo:',
  ShowCompleteThread: 'Mostrar hilo completo',
  ShowOnlyTopMatchingPosts: 'Mostrar solo publicaciones de mayor coincidencia',
  MostRelevantReplies: 'Respuestas más relevantes:',
  AllConversation: 'Toda la conversación:',
  ShowAllConversation: 'Mostrar toda la conversación',
  ShowAllReplies: 'Mostrar todas las respuestas',
  ShowOnlyMostRelevantReplies: 'Mostrar solo las respuestas más relevantes',
  Close: 'Cerrar',
  Open: 'Abrir',
  OpenInOutlookWhenPossible: 'Abrir en Outlook (si es posible)',
  AlwaysOpenInNewWindow: 'Abrir resultados siempre en ventana nueva',
  Quickview: 'Vista rápida',
  NoQuickview: 'La vista rápida de este documento no está disponible',
  ErrorReport: 'Informe de errores',
  OopsError: 'La búsqueda no funciona',
  ProblemPersists: 'Estamos experimentando problemas con la búsqueda. La buena noticia es, que estamos trabajando en eso!',
  GoBack: 'Volver',
  Reset: 'Restablecer',
  Retry: 'Reintentar',
  MoreInfo: 'Más información',
  Username: 'Nombre de usuario',
  Password: 'Contraseña',
  PostedBy: 'Publicado por',
  CannotConnect: 'No se puede establecer conexión con la dirección del servidor.',
  BadUserPass: 'La contraseña no coincide con el nombre de usuario.',
  PleaseEnterYourCredentials: 'Introduzca sus credenciales para {0}.',
  PleaseEnterYourSearchPage: 'Introduzca la URL de su página de búsqueda',
  Collapse: 'Contraer',
  Collapsable: 'Contraíble',
  Expand: 'Expandir',
  Today: 'Hoy',
  Yesterday: 'Ayer',
  Tomorrow: 'Mañana',
  Duration: 'Duración: {0}',
  IndexDuration: 'Duración de índice: {0}',
  ProxyDuration: 'Duración de proxy: {0}',
  ClientDuration: 'Duración de cliente: {0}',
  Unavailable: 'No disponible',
  Reply: 'Responder',
  ReplyAll: 'Responder a todos',
  Forward: 'Reenviar',
  From: 'De',
  Caption: 'Leyenda',
  Expression: 'Expresión',
  Tab: 'Ficha',
  Tabs: 'Fichas',
  EnterExpressionName: 'Introducir nombre de expresión',
  EnterExpressionToFilterWith: 'Introducir expresión con la que filtrar resultados',
  SelectTab: 'Seleccionar ficha',
  SelectAll: 'Seleccionar todo',
  PageUrl: 'URL de página de búsqueda',
  ErrorSavingToDevice: 'Error al intentar guardar la información en su dispositivo',
  ErrorReadingFromDevice: 'Error al intentar guardar la información desde su dispositivo',
  AppIntro: 'Hable con un especialista en el producto que pueda responder a sus preguntas sobre Coveo y le ayude a decidir qué solución Coveo se adapta a sus necesidades. O pruebe una versión de prueba.',
  TryDemo: 'Probar la versión de prueba',
  ContactUs: 'Contacte con nosotros',
  NewToCoveo: '¿Es la primera vez que usa Coveo?',
  LetUsHelpGetStarted: 'Le ayudaremos a empezar a utilizarlo',
  LikesThis: 'A {0} persona<pl>s</pl> le<pl>s</pl> gusta esto.',
  CannotConnectSearchPage: 'No se puede establecer conexión con su página de búsqueda',
  AreYouSureDeleteFilter: '¿Seguro que desea eliminar el filtro {0} con la expresión {1}?',
  OnlineHelp: 'Ayuda en línea',
  Done: 'Finalizado',
  SaveFacetState: 'Guardar este estado de faceta',
  ClearFacetState: 'Borrar el estado de faceta',
  DisplayingTheOnlyMessage: 'Mostrando el único mensaje de esta conversación',
  NoNetworkConnection: 'Sin conexión de red',
  UnknownConnection: 'Conexión desconocida',
  EthernetConnection: 'Conexión Ethernet',
  WiFi: 'Conexión WiFi',
  CELL: 'Conexión por móvil',
  CELL_2G: 'Conexión por móvil 2G',
  CELL_3G: 'Conexión por móvil 3G',
  CELL_4G: 'Conexión por móvil 4G',
  Relevance: 'Relevancia',
  Date: 'Fecha',
  Amount: 'Cantidad',
  QueryExceptionNoException: 'Sin excepciones',
  QueryExceptionInvalidSyntax: 'Sintaxis no válida',
  QueryExceptionInvalidCustomField: 'Campo personalizado no válido',
  QueryExceptionInvalidDate: 'Fecha no válida',
  QueryExceptionInvalidExactPhrase: 'Frase exacta no válida',
  QueryExceptionInvalidDateOp: 'Operador de fecha no válido',
  QueryExceptionInvalidNear: 'Operador NEAR no válido',
  QueryExceptionInvalidWeightedNear: 'NEAR ponderado no válido',
  QueryExceptionInvalidTerm: 'Término no válido',
  QueryExceptionTooManyTerms: 'Demasiados términos',
  QueryExceptionWildcardTooGeneral: 'Carácter comodín demasiado general',
  QueryExceptionInvalidSortField: 'Campo de ordenación no válido',
  QueryExceptionInvalidSmallStringOp: 'Operador de cadenas pequeñas no válido',
  QueryExceptionRequestedResultsMax: 'Máximo de resultados solicitados',
  QueryExceptionAggregatedMirrorDead: 'El reflejo agregado no está conectado',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Tiempo de espera agotado para consulta de reflejo agregado',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Número de versión no válido para reflejo agregado',
  QueryExceptionAggregatedMirrorCannotConnect: 'El reflejo agregado no puede establecer conexión',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'No hay suficientes comodines de carácter inicial',
  QueryExceptionSecurityInverterNotFound: 'No se ha encontrado el inversor de seguridad',
  QueryExceptionSecurityInverterAccessDenied: 'Acceso de inversor de seguridad denegado',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'El reflejo agregado no puede suplantar',
  QueryExceptionUnexpected: 'Inesperado',
  QueryExceptionAccessDenied: 'Acceso denegado',
  QueryExceptionSuperUserTokenInvalid: 'Token de superusuario no válido',
  QueryExceptionSuperUserTokenExpired: 'El token de superusuario ha vencido',
  QueryExceptionLicenseQueriesExpired: 'La licencia de consultas ha vencido',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'El token de superusuario de licencia no es compatible',
  QueryExceptionInvalidSession: 'Sesión no válida',
  QueryExceptionInvalidDocument: 'Documento no válido',
  QueryExceptionSearchDisabled: 'Búsqueda deshabilitada',
  FileType: 'Tipo de archivo',
  ShowAttachment: 'Mostrar adjunto',
  OnFeed: 'en el feed de {0}.',
  Author: 'Autor',
  NoTitle: 'Sin título',
  CurrentSelections: 'Selecciones actuales',
  AllContent: 'Todo el contenido',
  CancelLastAction: 'Cancelar última acción',
  SearchTips: 'Sugerencias de búsqueda',
  CheckSpelling: 'Compruebe la ortografía de las palabras clave.',
  TryUsingFewerKeywords: 'Pruebe a utilizar menos palabras, o palabras distintas o más generales.',
  SelectFewerFilters: 'Seleccione menos filtros para ampliar su búsqueda.',
  Document: 'Documento',
  Time: 'Hora',
  StartDate: 'Fecha de comienzo',
  StartTime: 'Tiempo de comienzo',
  DurationTitle: 'Duración',
  UserQuery: 'Consulta del usuario',
  ShowUserActions: 'Mostrar acciones del usuario',
  NoData: 'Ningún dato disponible',
  EventType: 'Tipo de evento',
  GoToFullSearch: 'Búsqueda completa',
  GoToEdition: 'Personalizar panel',
  RemoveContext: 'Eliminar contexto',
  BoxAttachToCase: 'Agregar a la consulta',
  AttachToCase: 'Agregar a la consulta',
  Attach: 'Agregar',
  Attached: 'Agregado',
  Detach: 'Quitar',
  Details: 'Detalles',
  AdditionalFilters: 'Filtros adicionales',
  SelectNonContextualSearch: 'Eliminar contexto del actual registro para ampliar la búsqueda',
  CopyPasteToSupport: 'Copiar y pegar este mensaje al equipo de soporte técnico de Coveo para obtener más información.',
  FollowQueryDescription: 'Avisarme cuando haya cambios en los resultados de búsqueda de esta consulta.',
  SearchAlerts_Panel: 'Gestionar alertas',
  SearchAlerts_PanelDescription: 'Ver y gestionar sus alertas de búsqueda.',
  SearchAlerts_PanelNoSearchAlerts: 'No tiene ninguna suscripción.',
  SearchAlerts_Fail: 'El servicio de alertas de búsqueda no está actualmente disponible.',
  SearchAlerts_Type: 'Tipo',
  SearchAlerts_Content: 'Contenido',
  SearchAlerts_Actions: 'Acción',
  EmptyQuery: '<vacío>',
  SearchAlerts_Type_followQuery: 'Consulta',
  SearchAlerts_Type_followDocument: 'Elemento',
  SearchAlerts_unFollowing: 'No dar seguimiento',
  SearchAlerts_follow: 'Dar seguimiento',
  SearchAlerts_followed: 'Con seguimiento',
  SearchAlerts_followQuery: 'Dar seguimiento a la consulta',
  Subscription_StopFollowingQuery: 'Detener seguimiento de consulta',
  SearchAlerts_Frequency: 'Cuándo',
  SubscriptionsManageSubscriptions: 'Gestionar alertas',
  SubscriptionsMessageFollowQuery: 'Recibirá alertas cuando la consulta <b>{0}</b> le devuelva elementos nuevos o actualizados.',
  SubscriptionsMessageFollow: 'Recibirá alertas cuando se realicen cambios en el elemento <b>{0}</b>.',
  Expiration: 'Vencimiento',
  Monthly: 'Mensual',
  Daily: 'Diariamente',
  Monday: 'Lunes',
  Tuesday: 'Martes',
  Wednesday: 'Miércoles',
  Thursday: 'Jueves',
  Friday: 'Viernes',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
  NextDay: 'Siguientes {0}',
  LastDay: 'Últimos {0}',
  StartTypingCaseForSuggestions: 'Describa su problema para ver las posibles soluciones',
  ExportToExcel: 'Exportar a Excel',
  ExportToExcelDescription: 'Exportar resultados de búsqueda a Excel',
  CaseCreationNoResults: 'No se encontró ninguna solución recomendada',
  SortBy: 'Ordenar por',
  BoxCreateArticle: 'Crear artículo',
  Facets: 'Facetas',
  AdvancedSearch: 'Búsqueda avanzada',
  Keywords: 'Palabras clave',
  AllTheseWords: 'Todas estas palabras',
  ExactPhrase: 'Esta frase exacta',
  AnyOfTheseWords: 'Cualquiera de estas palabras',
  NoneOfTheseWords: 'Ninguna de estas palabras',
  Anytime: 'Cualquier momento',
  InTheLast: 'En los últimos',
  Days: 'días',
  Months: 'meses',
  Month: 'Mes',
  Year: 'Año',
  Between: 'Entre',
  Language: 'Idioma',
  Size: 'Tamaño',
  AtLeast: 'como mínimo',
  AtMost: 'como máximo',
  Contains: 'contiene',
  DoesNotContain: 'no contiene',
  Matches: 'coincidencias',
  Bytes: 'bytes',
  card: 'Tarjeta',
  table: 'Tabla',
  ResultLinks: 'Vínculos de resultado',
  EnableQuerySyntax: 'Activar la sintaxis de búsqueda',
  On: 'Activado',
  Off: 'Desactivado',
  Automatic: 'Automático',
  ResultsPerPage: 'Resultados por página',
  PreviousMonth: 'Mes anterior',
  NextMonth: 'Mes siguiente',
  Title: 'Título',
  DeselectFilterValues: 'Quitar los filtros activos en el campo {0}',
  TRCoveoSearchResults: 'Resultados de búsqueda',
  TRCoveoApply: 'Aplicar',
  TRCoveoClearAll: 'Borrar todo',
  SearchBoxSearch: 'Búsqueda',
  TRNoResultsFound: 'No se encontraron resultados',
  TRDidntFindResults: 'No encontramos ningún resultado para {0}',
  TRSuggestions: 'Sugerencias',
  TRSpellAllWordsCorrectly: 'Deletree todas las palabras correctamente',
  TRChangeOrClearFilters: 'Cambiar o {clear} filtros',
  TRTryDifferentKeywords: 'Pruebe diferentes palabras clave',
  TRViewingNoResults: 'Viendo: 0 resultados para {0}',
  TRLogin: 'Iniciar sesión',
  TRSupport: 'Soporte',
  TRStoreFormat: 'Formato',
  TRStoreAvailability: 'Disponibilidad',
  TRFilter: 'Filtro',
  TRFilters: 'Filtros',
  TRMin: 'min',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: '¡Siga buscando!',
  TRKeepSearchingDescription: 'Y nosotros seguiremos escribiendo. Cada búsqueda que hace nos ayuda a entender mejor lo que quiere encontrar.',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  InsertAQuery: 'Búsqueda',
  PressEnterToSend: ''
};

/* eslint-disable import/no-anonymous-default-export */
var ko = {
  'box user': '사용자',
  'filetype_box user': '사용자',
  lithiummessage: 'Lithium 메시지',
  filetype_lithiummessage: 'Lithium 메시지',
  lithiumthread: 'Lithium 스레드',
  filetype_lithiumthread: 'Lithium 스레드',
  lithiumboard: 'Lithium 게시판',
  filetype_lithiumboard: 'Lithium 게시판',
  lithiumcategory: 'Lithium 카테고리',
  filetype_lithiumcategory: 'Lithium 카테고리',
  lithiumcommunity: 'Lithium 커뮤니티',
  filetype_lithiumcommunity: 'Lithium 커뮤니티',
  incident: '사건',
  youtube: 'YouTube 동영상',
  filetype_youtube: 'YouTube 동영상',
  html: 'HTML 파일',
  filetype_html: 'HTML 파일',
  wiki: '위키',
  filetype_wiki: '위키',
  webscraperwebpage: '웹 페이지',
  filetype_webscraperwebpage: '웹 페이지',
  image: '이미지',
  filetype_image: '이미지',
  folder: '폴더',
  filetype_folder: '폴더',
  txt: '텍스트',
  filetype_txt: '텍스트',
  zip: 'Zip 파일',
  filetype_zip: 'Zip 파일',
  olefile: 'OLE 파일',
  filetype_olefile: 'OLE 파일',
  gmailmessage: 'Gmail 메시지',
  filetype_gmailmessage: 'Gmail 메시지',
  pdf: 'PDF 파일',
  filetype_pdf: 'PDF 파일',
  swf: '플래시 파일',
  filetype_swf: '플래시 파일',
  xml: 'XML 파일',
  filetype_xml: 'XML 파일',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSS 피드',
  filetype_rssitem: 'RSS 피드',
  doc: '문서',
  filetype_doc: '문서',
  docx: '마이크로소프트 워드 문서',
  filetype_docx: '마이크로소프트 워드 문서',
  xls: '스프레드시트 문서',
  filetype_xls: '스프레드시트 문서',
  ppt: '프레젠테이션 문서',
  filetype_ppt: '프레젠테이션 문서',
  video: '동영상',
  filetype_video: '동영상',
  saleforceitem: '세일즈포스',
  filetype_saleforceitem: '세일즈포스',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: '세일즈포스',
  filetype_salesforceitem: '세일즈포스',
  odt: '오픈 텍스트 문서',
  filetype_odt: '오픈 텍스트 문서',
  people: '사용자',
  objecttype_people: '사용자',
  message: '메시지',
  objecttype_message: '메시지',
  feed: 'RSS 피드',
  objecttype_feed: 'RSS 피드',
  thread: '스레드',
  objecttype_thread: '스레드',
  file: '파일',
  objecttype_file: '파일',
  board: '게시판',
  objecttype_board: '게시판',
  category: '카테고리',
  objecttype_category: '카테고리',
  account: '계정',
  objecttype_account: '계정',
  annotation: '메모',
  objecttype_annotation: '메모',
  campaign: '캠페인',
  objecttype_campaign: '캠페인',
  "case": '사례',
  objecttype_case: '사례',
  contact: '연락처',
  objecttype_contact: '연락처',
  contract: '계약',
  objecttype_contract: '계약',
  event: '이벤트',
  objecttype_event: '이벤트',
  email: '이메일',
  objecttype_email: '이메일',
  goal: '목표',
  objecttype_goal: '목표',
  objecttype_incident: '사건',
  invoice: '인보이스',
  objecttype_invoice: '인보이스',
  lead: '잠재 고객',
  objecttype_lead: '잠재 고객',
  list: '목록',
  objecttype_list: '마케팅 목록',
  solution: '솔루션',
  objecttype_solution: '솔루션',
  task: '작업',
  objecttype_task: '작업',
  user: '사용자',
  objecttype_user: '사용자',
  attachment: '첨부 파일',
  objecttype_attachment: '첨부 파일',
  casecomment: '사례 메모',
  objecttype_casecomment: '사례 메모',
  opportunity: '기회',
  objecttype_opportunity: '기회',
  opportunityproduct: '영업 기회 제품',
  objecttype_opportunityproduct: '영업 기회 제품',
  feeditem: '채터',
  objecttype_feeditem: '채터',
  feedcomment: '채터',
  objecttype_feedcomment: '채터',
  note: '메모',
  objecttype_note: '메모',
  product: '제품',
  objecttype_product: '제품',
  partner: '파트너',
  objecttype_partner: '파트너',
  queueitem: '큐 항목',
  objecttype_queueitem: '큐 항목',
  quote: '견적',
  objecttype_quote: '견적',
  salesliterature: '영업 홍보 자료',
  objecttype_salesliterature: '영업 홍보 자료',
  salesorder: '판매 주문',
  objecttype_salesorder: '판매 주문',
  service: '서비스',
  objecttype_service: '서비스',
  socialprofile: '소셜 프로필',
  objecttype_socialprofile: '소셜 프로필',
  kbdocumentation: '문서',
  objecttype_kbdocumentation: '문서',
  kbtechnicalarticle: '문서',
  objecttype_kbtechnicalarticle: '문서',
  kbsolution: '솔루션',
  objecttype_kbsolution: '솔루션',
  kbknowledgearticle: '참조 문서',
  objecttype_kbknowledgearticle: '참조 문서',
  kbattachment: '첨부 파일',
  objecttype_kbattachment: '첨부 파일',
  kbarticle: '문서',
  objecttype_kbarticle: '문서',
  kbarticlecomment: '문서 주석',
  objecttype_kbarticlecomment: '문서 주석',
  knowledgearticle: '참조 문서',
  objecttype_knowledgearticle: '참조 문서',
  topic: '주제',
  objecttype_topic: '주제',
  dashboard: '대시보드',
  objecttype_dashboard: '대시보드',
  contentversion: '문서',
  objecttype_contentversion: '문서',
  collaborationgroup: '공동 작업 그룹',
  objecttype_collaborationgroup: '공동 작업 그룹',
  spportal: '포털',
  filetype_spportal: '포털',
  spsite: '사이트',
  filetype_spsite: '사이트',
  spuserprofile: 'SharePoint 사용자',
  filetype_spuserprofile: 'SharePoint 사용자',
  sparea: '영역',
  filetype_sparea: '영역',
  spannouncement: '공지 사항',
  filetype_spannouncement: '공지 사항',
  spannouncementlist: '공지 사항',
  filetype_spannouncementlist: '공지 사항',
  spcontact: '연락처',
  filetype_spcontact: '연락처',
  spcontactlist: '연락처',
  filetype_spcontactlist: '연락처',
  spcustomlist: '사용자 지정 목록',
  filetype_spcustomlist: '사용자 지정 목록',
  spdiscussionboard: '토론 게시판',
  filetype_spdiscussionboard: '토론 게시판',
  spdiscussionboardlist: '토론 게시판',
  filetype_spdiscussionboardlist: '토론 게시판',
  spdocumentlibrarylist: '문서 라이브러리',
  filetype_spdocumentlibrarylist: '문서 라이브러리',
  spevent: '이벤트',
  filetype_spevent: '이벤트',
  speventlist: '이벤트',
  filetype_speventlist: '이벤트',
  spformlibrarylist: '양식 라이브러리',
  filetype_spformlibrarylist: '양식 라이브러리',
  spissue: '문제',
  filetype_spissue: '문제',
  spissuelist: '문제',
  filetype_spissuelist: '문제',
  splink: '링크',
  filetype_splink: '링크',
  splinklist: '링크',
  filetype_splinklist: '링크',
  sppicturelibrarylist: '그림 라이브러리',
  filetype_sppicturelibrarylist: '그림 라이브러리',
  spsurvey: '설문 조사',
  filetype_spsurvey: '설문 조사',
  spsurveylist: '설문 조사',
  filetype_spsurveylist: '설문 조사',
  sptask: '작업',
  filetype_sptask: '작업',
  sptasklist: '작업',
  filetype_sptasklist: '작업',
  spagenda: '회의록',
  filetype_spagenda: '회의록',
  spagendalist: '회의록',
  filetype_spagendalist: '회의록',
  spattendee: '참석자',
  filetype_spattendee: '참석자',
  spattendeelist: '참석자',
  filetype_spattendeelist: '참석자',
  spcustomgridlist: '사용자 지정 눈금',
  filetype_spcustomgridlist: '사용자 지정 눈금',
  spdecision: '결정 사항',
  filetype_spdecision: '결정 사항',
  spdecisionlist: '결정 사항',
  filetype_spdecisionlist: '결정 사항',
  spobjective: '목표',
  filetype_spobjective: '목표',
  spobjectivelist: '목표',
  filetype_spobjectivelist: '목표',
  sptextbox: '텍스트 상자',
  filetype_sptextbox: '텍스트 상자',
  sptextboxlist: '텍스트 상자 목록',
  filetype_sptextboxlist: '텍스트 상자 목록',
  spthingstobring: '필요한 것',
  filetype_spthingstobring: '필요한 것',
  spthingstobringlist: '필요한 것',
  filetype_spthingstobringlist: '필요한 것',
  sparealisting: '영역 목록',
  filetype_sparealisting: '영역 목록',
  spmeetingserie: '모임 되풀이 항목',
  filetype_spmeetingserie: '모임 되풀이 항목',
  spmeetingserielist: '모임 되풀이 항목 목록',
  filetype_spmeetingserielist: '모임 되풀이 항목 목록',
  spsitedirectory: '사이트 디렉터리 항목',
  filetype_spsitedirectory: '사이트 디렉터리 항목',
  spsitedirectorylist: '사이트 디렉터리',
  filetype_spsitedirectorylist: '사이트 디렉터리',
  spdatasource: '데이터 원본',
  filetype_spdatasource: '데이터 원본',
  spdatasourcelist: '데이터 원본 목록',
  filetype_spdatasourcelist: '데이터 원본 목록',
  splisttemplatecataloglist: '목록 서식 파일 갤러리',
  filetype_splisttemplatecataloglist: '목록 서식 파일 갤러리',
  spwebpartcataloglist: '웹 파트 갤러리',
  filetype_spwebpartcataloglist: '웹 파트 갤러리',
  spwebtemplatecataloglist: '사이트 서식 파일 갤러리',
  filetype_spwebtemplatecataloglist: '사이트 서식 파일 갤러리',
  spworkspacepagelist: '작업 영역 페이지',
  filetype_spworkspacepagelist: '작업 영역 페이지',
  spunknownlist: '사용자 지정 목록',
  filetype_spunknownlist: '사용자 지정 목록',
  spadministratortask: '관리자 작업',
  filetype_spadministratortask: '관리자 작업',
  spadministratortasklist: '관리자 작업',
  filetype_spadministratortasklist: '관리자 작업',
  spareadocumentlibrarylist: '영역 문서 라이브러리',
  filetype_spareadocumentlibrarylist: '영역 문서 라이브러리',
  spblogcategory: '블로그 카테고리',
  filetype_spblogcategory: '블로그 카테고리',
  spblogcategorylist: '블로그 카테고리',
  filetype_spblogcategorylist: '블로그 카테고리',
  spblogcomment: '블로그 메모',
  filetype_spblogcomment: '블로그 메모',
  spblogcommentlist: '블로그 메모',
  filetype_spblogcommentlist: '블로그 메모',
  spblogpost: '블로그 게시물',
  filetype_spblogpost: '블로그 게시물',
  spblogpostlist: '블로그 게시물',
  filetype_spblogpostlist: '블로그 게시물',
  spdataconnectionlibrarylist: '데이터 연결 라이브러리',
  filetype_spdataconnectionlibrarylist: '데이터 연결 라이브러리',
  spdistributiongroup: '메일 그룹',
  filetype_spdistributiongroup: '메일 그룹',
  spdistributiongrouplist: '메일 그룹',
  filetype_spdistributiongrouplist: '메일 그룹',
  spipfslist: 'InfoPath 양식 서버',
  filetype_spipfslist: 'InfoPath 양식 서버',
  spkeyperformanceindicator: '핵심 성과 지표',
  filetype_spkeyperformanceindicator: '핵심 성과 지표',
  spkeyperformanceindicatorlist: '핵심 성과 지표',
  filetype_spkeyperformanceindicatorlist: '핵심 성과 지표',
  splanguagesandtranslator: '언어와 번역기',
  filetype_splanguagesandtranslator: '언어와 번역기',
  splanguagesandtranslatorlist: '언어와 번역기',
  filetype_splanguagesandtranslatorlist: '언어와 번역기',
  spmasterpagescataloglist: '마스터 페이지 갤러리',
  filetype_spmasterpagescataloglist: '마스터 페이지 갤러리',
  spnocodeworkflowlibrarylist: '코드 없는 워크플로 라이브러리',
  filetype_spnocodeworkflowlibrarylist: '코드 없는 워크플로 라이브러리',
  spprojecttask: '프로젝트 작업',
  filetype_spprojecttask: '프로젝트 작업',
  spprojecttasklist: '프로젝트 작업',
  filetype_spprojecttasklist: '프로젝트 작업',
  sppublishingpageslibrarylist: '페이지 라이브러리',
  filetype_sppublishingpageslibrarylist: '페이지 라이브러리',
  spreportdocumentlibrarylist: '보고서 문서 라이브러리',
  filetype_spreportdocumentlibrarylist: '보고서 문서 라이브러리',
  spreportlibrarylist: '보고서 라이브러리',
  filetype_spreportlibrarylist: '보고서 라이브러리',
  spslidelibrarylist: '슬라이드 라이브러리',
  filetype_spslidelibrarylist: '슬라이드 라이브러리',
  sptab: '탭',
  filetype_sptab: '탭',
  sptablist: '탭 목록',
  filetype_sptablist: '탭 목록',
  sptranslationmanagementlibrarylist: '번역 관리 라이브러리',
  filetype_sptranslationmanagementlibrarylist: '번역 관리 라이브러리',
  spuserinformation: '사용자 정보',
  filetype_spuserinformation: '사용자 정보',
  spuserinformationlist: '사용자 정보 목록',
  filetype_spuserinformationlist: '사용자 정보 목록',
  spwikipagelibrarylist: '위키 페이지 라이브러리',
  filetype_spwikipagelibrarylist: '위키 페이지 라이브러리',
  spworkflowhistory: '워크플로 기록',
  filetype_spworkflowhistory: '워크플로 기록',
  spworkflowhistorylist: '워크플로 기록 목록',
  filetype_spworkflowhistorylist: '워크플로 기록 목록',
  spworkflowprocess: '사용자 지정 워크플로 프로세스',
  filetype_spworkflowprocess: '사용자 지정 워크플로 프로세스',
  spworkflowprocesslist: '사용자 지정 워크플로 프로세스',
  filetype_spworkflowprocesslist: '사용자 지정 워크플로 프로세스',
  sppublishingimageslibrarylist: '게시 이미지 라이브러리',
  filetype_sppublishingimageslibrarylist: '게시 이미지 라이브러리',
  spcirculation: '회람',
  filetype_spcirculation: '회람',
  spcirculationlist: '회람',
  filetype_spcirculationlist: '회람',
  spdashboardslibrarylist: '대시보드 라이브러리',
  filetype_spdashboardslibrarylist: '대시보드 라이브러리',
  spdataconnectionforperformancepointlibrarylist: 'PerformancePoint 데이터 연결 라이브러리',
  filetype_spdataconnectionforperformancepointlibrarylist: 'PerformancePoint 데이터 연결 라이브러리',
  sphealthreport: '상태 보고서',
  filetype_sphealthreport: '상태 보고서',
  sphealthreportlist: '상태 보고서',
  filetype_sphealthreportlist: '상태 보고서',
  sphealthrule: '상태 규칙',
  filetype_sphealthrule: '상태 규칙',
  sphealthrulelist: '상태 규칙',
  filetype_sphealthrulelist: '상태 규칙',
  spimedictionary: 'IME 사전',
  filetype_spimedictionary: 'IME 사전',
  spimedictionarylist: 'IME 사전',
  filetype_spimedictionarylist: 'IME 사전',
  spperformancepointcontent: 'PerformancePoint 콘텐츠',
  filetype_spperformancepointcontent: 'PerformancePoint 콘텐츠',
  spperformancepointcontentlist: 'PerformancePoint 콘텐츠',
  filetype_spperformancepointcontentlist: 'PerformancePoint 콘텐츠',
  spphonecallmemo: '부재 중 전화 메모',
  filetype_spphonecallmemo: '부재 중 전화 메모',
  spphonecallmemolist: '부재 중 전화 메모',
  filetype_spphonecallmemolist: '부재 중 전화 메모',
  sprecordlibrarylist: '레코드 라이브러리',
  filetype_sprecordlibrarylist: '레코드 라이브러리',
  spresource: '리소스',
  filetype_spresource: '리소스',
  spresourcelist: '리소스',
  filetype_spresourcelist: '리소스',
  spprocessdiagramslibrarylist: '프로세스 다이어그램 라이브러리',
  filetype_spprocessdiagramslibrarylist: '프로세스 다이어그램 라이브러리',
  spsitethemeslibrarylist: '사이트 테마 라이브러리',
  filetype_spsitethemeslibrarylist: '사이트 테마 라이브러리',
  spsolutionslibrarylist: '솔루션 라이브러리',
  filetype_spsolutionslibrarylist: '솔루션 라이브러리',
  spwfpublibrarylist: 'WFPUB 라이브러리',
  filetype_spwfpublibrarylist: 'WFPUB 라이브러리',
  spwhereabout: '소재',
  filetype_spwhereabout: '소재',
  spwhereaboutlist: '소재',
  filetype_spwhereaboutlist: '소재',
  spdocumentlink: '문서 링크',
  filetype_spdocumentlink: '문서 링크',
  spdocumentset: '문서 집합',
  filetype_spdocumentset: '문서 집합',
  spmicrofeedpost: '마이크로피드 게시물',
  filetype_spmicrofeedpost: '마이크로피드 게시물',
  spmicrofeedlist: '마이크로피드',
  filetype_spmicrofeedlist: '마이크로피드',
  splistfolder: '목록 폴더',
  filetype_splistfolder: '목록 폴더',
  Unknown: '알 수 없음',
  And: '및',
  Authenticating: '{0}을(를) 인증하는 중...',
  Clear: '{0} 지우기',
  CompleteQuery: '전체 쿼리',
  Exclude: '{0} 제외',
  EnterTag: '태그 추가',
  Next: '다음',
  Last: '마지막',
  Link: '링크',
  Or: '또는',
  Previous: '이전',
  QueryDidntMatchAnyDocuments: '쿼리가 어느 문서와도 일치하지 않습니다.',
  QueryException: '쿼리에 오류가 있습니다: {0}.',
  Me: '나',
  Remove: '제거',
  Search: '검색',
  SearchFor: '{0} 검색',
  ShareQuery: '쿼리 공유',
  Preferences: '기본 설정',
  LinkOpeningSettings: '링크 열기 설정',
  Reauthenticate: '{0} 재인증',
  ResultsFilteringExpression: '결과 필터링 표현',
  FiltersInYourPreferences: '사용자의 기본 설정에서 필터',
  Create: '만들기',
  SearchIn: '{0}에서 검색',
  Seconds: '{0} 초 후',
  ShowingResultsOf: '표시: 결과 {0}<pl>~{1}개 / 총 {2}</pl>개<pl></pl>',
  ShowingResultsOfWithQuery: '표시: {3}에 대한 결과 {0}<pl>~{1} 개 / 총 {2}</pl>개<pl></pl>',
  SwitchTo: '{0}(으)로 전환',
  Unexclude: '{0} 비제외',
  ClearAllFilters: '모든 필터 지우기',
  SkipLogin: '로그인 건너뛰기',
  LoginInProgress: '로그인 진행 중, 기다려주십시오...',
  Login: '로그인',
  GetStarted: '시작하기',
  More: '더 보기',
  NMore: '더 보기({0})',
  Less: '덜 보기',
  Settings: '설정',
  Score: '점수',
  ScoreDescription: '점수는 결과 세트 내 위치에서뿐 아니라 빈도 수로부터도 계산됩니다.',
  Occurrences: '빈도',
  OccurrencesDescription: '가장 큰 수가 있는 값이 먼저 표시되게 빈도 수로 정렬',
  Label: '라벨',
  Of: '중',
  LabelDescription: '필드 값 알파벳 순 정렬',
  Value: '값',
  ValueDescription: '최초 계산된 필드의 값으로 정렬',
  AlphaAscending: '오름차순 값',
  AlphaDescending: '내림차순 값',
  ChiSquare: '카이 제곱',
  Nosort: '정렬 항목 없음',
  NosortDescription: '값을 정렬하지 않습니다. 값이 임의 순서대로 반환됩니다.',
  RelativeFrequency: '상대 빈도',
  RelativeFrequencyDescription: '값의 상대 빈도를 기준으로 정렬. 덜 흔한 값이 더 높은 위치에 표시됩니다.',
  DateDistribution: '날짜 분포',
  Custom: '사용자 정의',
  CustomDescription: '사용자 정의 순서대로 정렬',
  ComputedField: '계산된 필드',
  Ascending: '오름차순',
  Descending: '내림차순',
  noResultFor: '{0}에 대한 검색 결과가 없습니다',
  autoCorrectedQueryTo: '쿼리가 {0}(으)로 자동 교정됐습니다',
  didYouMean: '{0}(으)로 검색할까요?',
  SuggestedResults: '제안된 결과',
  SuggestedQueries: '제안된 쿼리',
  MostRelevantItems: '가장 관련 있는 항목:',
  AllItems: '모든 항목:',
  ShowLess: '최소 표시',
  ShowMore: '최대 표시',
  HideFacet: '패싯 감추기',
  ShowFacet: '패싯 표시',
  AndOthers: '및 기타 {0}',
  Others: '기타 {0}',
  MostRelevantPosts: '가장 관련 있는 게시글:',
  CompleteThread: '전체 스레드:',
  ShowCompleteThread: '전체 스레드 표시',
  ShowOnlyTopMatchingPosts: '최대 일치 게시글만 표시',
  MostRelevantReplies: '가장 관련 있는 댓글:',
  AllConversation: '모든 대화:',
  ShowAllConversation: '모든 대화 표시',
  ShowAllReplies: '모든 댓글 표시',
  ShowOnlyMostRelevantReplies: '가장 관련 있는 댓글만 표시',
  Close: '닫기',
  Open: '열기',
  OpenInOutlookWhenPossible: 'Outlook에서 열기(가능한 경우)',
  AlwaysOpenInNewWindow: '결과를 항상 새 창에서 열기',
  Quickview: '간략히 보기',
  NoQuickview: '이 문서의 빨리 보기를 사용할 수 없습니다',
  ErrorReport: '오류 보고',
  OopsError: 'Search is down',
  ProblemPersists: "We're experiencing an issue with search. The good news is, we're on it! Try your search later.",
  GoBack: 'Go Back',
  Reset: '재설정',
  Retry: '재시도',
  MoreInfo: '추가 정보',
  Username: '사용자 이름',
  Password: '암호',
  PostedBy: '게시자',
  CannotConnect: '서버 주소에 연결할 수 없습니다.',
  BadUserPass: '암호가 사용자 이름과 일치하지 않습니다.',
  PleaseEnterYourCredentials: '{0}에 대한 자격 증명을 입력하십시오.',
  PleaseEnterYourSearchPage: '검색 페이지 URL을 입력하십시오.',
  Collapse: '축소',
  Collapsable: '축소 가능',
  Expand: '확대',
  Today: '오늘',
  Yesterday: '어제',
  Tomorrow: '내일',
  Duration: '표시 시간: {0}',
  IndexDuration: '색인 표시 시간: {0}',
  ProxyDuration: '프록시 표시 시간: {0}',
  ClientDuration: '클라이언트 표시 시간: {0}',
  Unavailable: '없음',
  Reply: '회신',
  ReplyAll: '모두에게 회신',
  Forward: '전달',
  From: '보낸 사람',
  Caption: '제목',
  Expression: '표현식',
  Tab: '탭',
  Tabs: '탭들',
  EnterExpressionName: '표현식 이름 입력',
  EnterExpressionToFilterWith: '다음 결과를 필터할 표현식 입력',
  SelectTab: '탭 선택',
  SelectAll: '모두 선택',
  PageUrl: '검색 페이지 URL',
  ErrorSavingToDevice: '정보를 사용자의 기기에 저장하는 중 오류',
  ErrorReadingFromDevice: '정보를 사용자의 기기에서 읽는 중 오류',
  AppIntro: 'Coveo에 관한 질문에 답하고 Coveo 솔루션이 사용자에게 적합한지 알아보는 데 도움을 줄 수 있는 제품 전문가와 상담하십시오. 또는 실제 시연을 이용하십시오!',
  TryDemo: '시연 이용',
  ContactUs: '연락처',
  NewToCoveo: 'Coveo가 처음이신가요?',
  LetUsHelpGetStarted: '저희가 시작을 돕겠습니다',
  LikesThis: '{0}(이)가 이것을 좋아합니다.',
  CannotConnectSearchPage: '검색 페이지에 연결할 수 없습니다',
  AreYouSureDeleteFilter: '{1} 식이 있는 필터 {0}(을)를 삭제하시겠습니까?',
  OnlineHelp: '온라인 도움말',
  Done: '완료',
  SaveFacetState: '이 패싯 상태를 저장',
  ClearFacetState: '패싯 상태 지우기',
  DisplayingTheOnlyMessage: '이 대화에서 유일한 메시지를 표시',
  NoNetworkConnection: '네트워크에 연결할 수 없습니다',
  UnknownConnection: '알 수 없는 연결',
  EthernetConnection: '이더넷 연결',
  WiFi: 'WiFi 연결',
  CELL: '휴대 전화 연결',
  CELL_2G: '휴대 전화 2G 연결',
  CELL_3G: '휴대 전화 3G 연결',
  CELL_4G: '휴대 전화 4G 연결',
  Relevance: '관련성',
  Date: '날짜',
  Amount: '금액',
  QueryExceptionNoException: '예외가 없습니다',
  QueryExceptionInvalidSyntax: '구문이 잘못되었습니다',
  QueryExceptionInvalidCustomField: '사용자 정의 필드가 잘못되었습니다',
  QueryExceptionInvalidDate: '날짜가 잘못되었습니다',
  QueryExceptionInvalidExactPhrase: '일치하여야 하는 구가 잘못되었습니다',
  QueryExceptionInvalidDateOp: '날짜 연산자가 잘못되었습니다',
  QueryExceptionInvalidNear: 'NEAR 연산자가 잘못되었습니다',
  QueryExceptionInvalidWeightedNear: '가중 NEAR 연산자가 잘못되었습니다',
  QueryExceptionInvalidTerm: '용어가 잘못되었습니다',
  QueryExceptionTooManyTerms: '용어가 너무 많습니다',
  QueryExceptionWildcardTooGeneral: '와일드카드가 너무 일반적입니다',
  QueryExceptionInvalidSortField: '정렬 필드가 잘못되었습니다',
  QueryExceptionInvalidSmallStringOp: '단문자열 연산자가 잘못되었습니다',
  QueryExceptionRequestedResultsMax: '요청 결과 최대 한도',
  QueryExceptionAggregatedMirrorDead: '집합 미러가 오프라인입니다',
  QueryExceptionAggregatedMirrorQueryTimeOut: '집합 미러 쿼리 시간 제한',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: '집합 미러의 잘못된 빌드 번호',
  QueryExceptionAggregatedMirrorCannotConnect: '집합 미러를 연결할 수 없습니다',
  QueryExceptionNotEnoughLeadingCharsWildcard: '선행 문자 와일드카드가 충분하지 않습니다',
  QueryExceptionSecurityInverterNotFound: '보안 인버터를 찾을 수 없습니다',
  QueryExceptionSecurityInverterAccessDenied: '보안 인버터 접근이 거부됐습니다',
  QueryExceptionAggregatedMirrorCannotImpersonate: '집합 미러를 가장할 수 없습니다',
  QueryExceptionUnexpected: '예상하지 않은',
  QueryExceptionAccessDenied: '접근이 거부됐습니다',
  QueryExceptionSuperUserTokenInvalid: '슈퍼 유저 토큰이 잘못되었습니다',
  QueryExceptionSuperUserTokenExpired: '슈퍼 유저 토큰이 만료됐습니다',
  QueryExceptionLicenseQueriesExpired: '쿼리 라이선스가 만료됐습니다',
  QueryExceptionLicenseSuperUserTokenNotSupported: '지원하지 않는 라이선스 슈퍼 유저 토큰입니다',
  QueryExceptionInvalidSession: '세션이 잘못됐습니다',
  QueryExceptionInvalidDocument: '문서가 잘못됐습니다',
  QueryExceptionSearchDisabled: '검색 사용 안 함',
  FileType: '파일 형식',
  ShowAttachment: '첨부 표시',
  OnFeed: '{0}의 피드.',
  Author: '작성자',
  NoTitle: '제목 없음',
  CurrentSelections: '현재 선택',
  AllContent: '모든 콘텐츠',
  CancelLastAction: '마지막 실행 취소',
  SearchTips: '검색 요령',
  CheckSpelling: '핵심어의 철자를 확인합니다.',
  TryUsingFewerKeywords: '키워드를 더 적게 또는 다양하게 사용하거나 더 일반적인 키워드를 사용해봅니다',
  SelectFewerFilters: '필터를 줄여 검색 범위를 넓힙니다.',
  Document: '문서',
  Time: '시간',
  StartDate: '시작 날짜',
  StartTime: '시작 시간',
  DurationTitle: '표시 시간',
  UserQuery: '사용자 쿼리',
  ShowUserActions: '사용자 작업 보이기',
  NoData: '데이터가 없습니다',
  EventType: '이벤트 유형',
  GoToFullSearch: '전체 검색',
  GoToEdition: '패널 사용자 지정',
  RemoveContext: '컨텍스트 제거',
  BoxAttachToCase: '요청에 연결',
  AttachToCase: '요청에 연결',
  Attach: '연결',
  Attached: '연결됨',
  Detach: '분리',
  Details: '세부 정보',
  AdditionalFilters: '추가 필터',
  SelectNonContextualSearch: '검색 범위를 넓히려면 현재 레코드에서 컨텍스트를 제거하십시오',
  CopyPasteToSupport: '자세한 정보를 원하시면 이 메시지를 복사하고 붙여 넣어 Coveo 지원팀에 보내십시오.',
  FollowQueryDescription: '이 쿼리의 검색 결과에 대한 변경 내용을 내게 알려줍니다.',
  SearchAlerts_Panel: '알림 관리',
  SearchAlerts_PanelDescription: '사용자의 검색 알림을 보고 관리합니다.',
  SearchAlerts_PanelNoSearchAlerts: '구독이 없습니다.',
  SearchAlerts_Fail: '검색 알림 서비스를 현재 사용할 수 없습니다.',
  SearchAlerts_Type: '유형',
  SearchAlerts_Content: '내용',
  SearchAlerts_Actions: '작업',
  EmptyQuery: '<비어 있음>',
  SearchAlerts_Type_followQuery: '쿼리',
  SearchAlerts_Type_followDocument: '항목',
  SearchAlerts_unFollowing: '팔로잉 중지',
  SearchAlerts_follow: '팔로우',
  SearchAlerts_followed: '팔로우함',
  SearchAlerts_followQuery: '쿼리 팔로우',
  Subscription_StopFollowingQuery: '쿼리 팔로잉 중지',
  SearchAlerts_Frequency: '언제',
  SubscriptionsManageSubscriptions: '알림 관리',
  SubscriptionsMessageFollowQuery: '쿼리 <b>{0}</b>(이)가 새 항목이나 업데이트된 항목을 반환할 때 알림을 받습니다.',
  SubscriptionsMessageFollow: '항목 <b>{0}</b>의 변경 내용에 대한 알림을 받습니다.',
  Expiration: '만료',
  Monthly: '매월',
  Daily: '매일',
  Monday: '월요일',
  Tuesday: '화요일',
  Wednesday: '수요일',
  Thursday: '목요일',
  Friday: '금요일',
  Saturday: '토요일',
  Sunday: '일요일',
  NextDay: '다음 {0}',
  LastDay: '지난 {0}',
  StartTypingCaseForSuggestions: '가능한 솔루션을 보려면 문제를 설명하십시오',
  ExportToExcel: '엑셀로 내부내기',
  ExportToExcelDescription: '검색 결과를 엑셀로 내보내기',
  CaseCreationNoResults: '권장 솔루션이 없습니다',
  SortBy: '정렬 기준',
  BoxCreateArticle: '문서 만들기',
  Facets: '패싯',
  AdvancedSearch: '고급 검색',
  Keywords: '키워드',
  AllTheseWords: '이 모든 단어',
  ExactPhrase: '이와 똑같은 어구',
  AnyOfTheseWords: '이 단어 중 어느 것이든',
  NoneOfTheseWords: '이 단어 중 아무것도 없음',
  Anytime: '항상',
  InTheLast: '최근',
  Days: '일',
  Months: '개월',
  Month: '월',
  Year: '연',
  Between: '사이',
  Language: '언어',
  Size: '크기',
  AtLeast: '최소',
  AtMost: '최대',
  Contains: '포함',
  DoesNotContain: '(이)가 없습니다',
  Matches: '일치',
  Bytes: '바이트',
  card: '카드',
  table: '표',
  ResultLinks: '결과 링크',
  EnableQuerySyntax: '쿼리 구문 사용',
  On: '켬',
  Off: '끔',
  Automatic: '자동',
  ResultsPerPage: '페이지당 결과 표시',
  PreviousMonth: '이전 달',
  NextMonth: '다음 달',
  Title: '제목',
  TRCoveoSearchResults: '검색 결과',
  TRCoveoApply: '적용',
  TRCoveoClearAll: '모두 지우기',
  SearchBoxSearch: '검색 결과',
  TRNoResultsFound: '결과가 없습니다',
  TRDidntFindResults: '{0}에 대한 검색 결과가 없습니다.',
  TRSuggestions: '제안',
  TRSpellAllWordsCorrectly: '모든 단어의 철자가 올바르게 입력되었는지 확인하세요',
  TRChangeOrClearFilters: '필터 변경 또는 {지우기}',
  TRTryDifferentKeywords: '다른 키워드를 입력해 보세요',
  TRViewingNoResults: '표시: {0}에 대한 결과 0개',
  TRLogin: '로그인',
  TRSupport: '지원',
  TRStoreFormat: '형식',
  TRStoreAvailability: '재고',
  TRFilter: '필터',
  TRFilters: '필터',
  TRMin: '분',
  TRCloseDropdownFilters: 'Close dropdown filters',
  TROpenDropdownFilters: 'Open dropdown filters',
  TRCollapseSortDropdown: 'Collapse sort dropdown',
  TRExpandSortDropdown: 'Expand sort dropdown',
  TRKeepSearchingTitle: '계속 검색하십시오!',
  TRKeepSearchingDescription: '저희는 계속 기록하겠습니다. 여러분의 모든 검색은 여러분이 무엇을 찾고 있는지 저희가 파악하는 데 도움이 됩니다.',
  TRDirector: 'Director',
  TRCoordinator: 'Coordinator',
  TREdition: 'Edition',
  TREbook: 'E-book',
  TRHardboundBook: 'Hardbound Book',
  TRCdRom: 'CD-ROM',
  TRSoftboundBook: 'Softbound Book',
  InsertAQuery: '검색 결과',
  PressEnterToSend: ''
};

// eslint-disable-next-line import/no-anonymous-default-export
var fi = {
  'box user': 'KÃ¤yttÃ¤jÃ¤',
  'filetype_box user': 'KÃ¤yttÃ¤jÃ¤',
  html: 'HTML-tiedosto',
  filetype_html: 'HTML-tiedosto',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Verkkosivu',
  filetype_webscraperwebpage: 'Verkkosivu',
  image: 'Kuva',
  filetype_image: 'Kuva',
  folder: 'Kansio',
  filetype_folder: 'Kansio',
  txt: 'Teksti',
  filetype_txt: 'Teksti',
  zip: 'Zip-tiedosto',
  filetype_zip: 'Zip-tiedosto',
  olefile: 'OLE-tiedosto',
  filetype_olefile: 'OLE-tiedosto',
  gmailmessage: 'Gmail-viesti',
  filetype_gmailmessage: 'Gmail-viesti',
  pdf: 'PDF-tiedosto',
  filetype_pdf: 'PDF-tiedosto',
  swf: 'Flash-tiedosto',
  filetype_swf: 'Flash-tiedosto',
  xml: 'XML-tiedosto',
  filetype_xml: 'XML-tiedosto',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSS-syÃ¶te',
  filetype_rssitem: 'RSS-syÃ¶te',
  doc: 'Asiakirja',
  filetype_doc: 'Asiakirja',
  docx: 'Microsoft Word -asiakirja',
  filetype_docx: 'Microsoft Word -asiakirja',
  xls: 'Laskentataulukkotiedosto',
  filetype_xls: 'Laskentataulukkotiedosto',
  ppt: 'Esitystiedosto',
  filetype_ppt: 'Esitystiedosto',
  video: 'Video',
  filetype_video: 'Video',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Open Text -tiedosto',
  filetype_odt: 'Open Text -tiedosto',
  lithiummessage: 'Lithium-viesti',
  filetype_lithiummessage: 'Lithium-viesti',
  lithiumthread: 'Lithium-viestiketju',
  filetype_lithiumthread: 'Lithium-viestiketju',
  lithiumboard: 'Lithium-elektroninen taulu',
  filetype_lithiumboard: 'Lithium-elektroninen taulu',
  lithiumcategory: 'Lithium-kategoria',
  filetype_lithiumcategory: 'Lithium-kategoria',
  lithiumcommunity: 'Lithium-yhteisÃ¶',
  filetype_lithiumcommunity: 'Lithium-yhteisÃ¶',
  people: 'KÃ¤yttÃ¤jÃ¤',
  objecttype_people: 'KÃ¤yttÃ¤jÃ¤',
  message: 'Viesti',
  objecttype_message: 'Viesti',
  feed: 'RSS-syÃ¶te',
  objecttype_feed: 'RSS-syÃ¶te',
  thread: 'Viestiketju',
  objecttype_thread: 'Viestiketju',
  file: 'Tiedosto',
  objecttype_file: 'Tiedosto',
  board: 'Taulukko',
  objecttype_board: 'Taulukko',
  category: 'Kategoria',
  objecttype_category: 'Kategoria',
  account: 'Tili',
  objecttype_account: 'Tili',
  annotation: 'Huomautus',
  objecttype_annotation: 'Huomautus',
  campaign: 'Kampanja',
  objecttype_campaign: 'Kampanja',
  "case": 'Tapaus',
  objecttype_case: 'Tapaus',
  contact: 'Yhteydenotto',
  objecttype_contact: 'Yhteydenotto',
  contract: 'Sopimus',
  objecttype_contract: 'Sopimus',
  event: 'Tapahtuma',
  objecttype_event: 'Tapahtuma',
  email: 'SÃ¤hkÃ¶posti',
  objecttype_email: 'SÃ¤hkÃ¶posti',
  goal: 'Tavoite',
  objecttype_goal: 'Tavoite',
  objecttype_incident: 'Tapaus',
  invoice: 'Lasku',
  objecttype_invoice: 'Lasku',
  lead: 'Johto',
  objecttype_lead: 'Johto',
  list: 'Lista',
  objecttype_list: 'Markkinointilista',
  solution: 'Ratkaisu',
  objecttype_solution: 'Ratkaisu',
  task: 'TehtÃ¤vÃ¤',
  objecttype_task: 'TehtÃ¤vÃ¤',
  user: 'KÃ¤yttÃ¤jÃ¤',
  objecttype_user: 'KÃ¤yttÃ¤jÃ¤',
  attachment: 'Liite',
  objecttype_attachment: 'Liite',
  casecomment: 'Tapauskommentti',
  objecttype_casecomment: 'Tapauskommentti',
  opportunity: 'Mahdollisuus',
  objecttype_opportunity: 'Mahdollisuus',
  opportunityproduct: 'Tuotemahdollisuus',
  objecttype_opportunityproduct: 'Tuotemahdollisuus',
  feeditem: 'Jutustelu',
  objecttype_feeditem: 'Jutustelu',
  feedcomment: 'Jutustelu',
  objecttype_feedcomment: 'Jutustelu',
  note: 'Huomautus',
  objecttype_note: 'Huomautus',
  product: 'Tuote',
  objecttype_product: 'Tuote',
  partner: 'Kumppani',
  objecttype_partner: 'Kumppani',
  queueitem: 'Jonotuskohde',
  objecttype_queueitem: 'Jonotuskohde',
  quote: 'Tarjous',
  objecttype_quote: 'Tarjous',
  salesliterature: 'Mainosesite',
  objecttype_salesliterature: 'Mainosesite',
  salesorder: 'Tilaus',
  objecttype_salesorder: 'Tilaus',
  service: 'Palvelu',
  objecttype_service: 'Palvelu',
  socialprofile: 'Sosiaalinen profiili',
  objecttype_socialprofile: 'Sosiaalinen profiili',
  kbdocumentation: 'Dokumentaatio',
  objecttype_kbdocumentation: 'Dokumentaatio',
  kbtechnicalarticle: 'Dokumentaatio',
  objecttype_kbtechnicalarticle: 'Dokumentaatio',
  kbsolution: 'Ratkaisu',
  objecttype_kbsolution: 'Ratkaisu',
  kbknowledgearticle: 'Tietoartikkeli',
  objecttype_kbknowledgearticle: 'Tietoartikkeli',
  kbattachment: 'Liite',
  objecttype_kbattachment: 'Liite',
  kbarticle: 'Artikkeli',
  objecttype_kbarticle: 'Artikkeli',
  kbarticlecomment: 'Artikkelin kommentti',
  objecttype_kbarticlecomment: 'Artikkelin kommentti',
  knowledgearticle: 'Tietoartikkeli',
  objecttype_knowledgearticle: 'Tietoartikkeli',
  topic: 'Aihe',
  objecttype_topic: 'Aihe',
  dashboard: 'KoontinÃ¤yttÃ¶',
  objecttype_dashboard: 'KoontinÃ¤yttÃ¶',
  contentversion: 'Asiakirja',
  objecttype_contentversion: 'Asiakirja',
  collaborationgroup: 'YhteistyÃ¶ryhmÃ¤',
  objecttype_collaborationgroup: 'YhteistyÃ¶ryhmÃ¤',
  spportal: 'Portaali',
  filetype_spportal: 'Portaali',
  spsite: 'Sivusto',
  filetype_spsite: 'Sivusto',
  spuserprofile: 'SharePoint-kÃ¤yttÃ¤jÃ¤',
  filetype_spuserprofile: 'SharePoint-kÃ¤yttÃ¤jÃ¤',
  sparea: 'Alue',
  filetype_sparea: 'Alue',
  spannouncement: 'Ilmoitus',
  filetype_spannouncement: 'Ilmoitus',
  spannouncementlist: 'Ilmoitukset',
  filetype_spannouncementlist: 'Ilmoitukset',
  spcontact: 'Yhteydenotto',
  filetype_spcontact: 'Yhteydenotto',
  spcontactlist: 'YhteyshenkilÃ¶t',
  filetype_spcontactlist: 'YhteyshenkilÃ¶t',
  spcustomlist: 'RÃ¤Ã¤tÃ¤lÃ¶ity lista',
  filetype_spcustomlist: 'RÃ¤Ã¤tÃ¤lÃ¶ity lista',
  spdiscussionboard: 'Keskustelufoorumi',
  filetype_spdiscussionboard: 'Keskustelufoorumi',
  spdiscussionboardlist: 'Keskustelufoorumit',
  filetype_spdiscussionboardlist: 'Keskustelufoorumit',
  spdocumentlibrarylist: 'Asiakirjakirjasto',
  filetype_spdocumentlibrarylist: 'Asiakirjakirjasto',
  spevent: 'Tapahtuma',
  filetype_spevent: 'Tapahtuma',
  speventlist: 'Tapahtumat',
  filetype_speventlist: 'Tapahtumat',
  spformlibrarylist: 'Lomakekirjasto',
  filetype_spformlibrarylist: 'Lomakekirjasto',
  spissue: 'Ongelma',
  filetype_spissue: 'Ongelma',
  spissuelist: 'Ongelmat',
  filetype_spissuelist: 'Ongelmat',
  splink: 'Linkki',
  filetype_splink: 'Linkki',
  splinklist: 'Linkit',
  filetype_splinklist: 'Linkit',
  sppicturelibrarylist: 'Kuvakirjasto',
  filetype_sppicturelibrarylist: 'Kuvakirjasto',
  spsurvey: 'Kysely',
  filetype_spsurvey: 'Kysely',
  spsurveylist: 'Kyselyt',
  filetype_spsurveylist: 'Kyselyt',
  sptask: 'TehtÃ¤vÃ¤',
  filetype_sptask: 'TehtÃ¤vÃ¤',
  sptasklist: 'TehtÃ¤vÃ¤t',
  filetype_sptasklist: 'TehtÃ¤vÃ¤t',
  spagenda: 'PÃ¤ivÃ¤ohjelma',
  filetype_spagenda: 'PÃ¤ivÃ¤ohjelma',
  spagendalist: 'PÃ¤ivÃ¤ohjelmat',
  filetype_spagendalist: 'PÃ¤ivÃ¤ohjelmat',
  spattendee: 'Osallistuja',
  filetype_spattendee: 'Osallistuja',
  spattendeelist: 'Osallistujat',
  filetype_spattendeelist: 'Osallistujat',
  spcustomgridlist: 'RÃ¤Ã¤tÃ¤lÃ¶ity taulukko',
  filetype_spcustomgridlist: 'RÃ¤Ã¤tÃ¤lÃ¶ity taulukko',
  spdecision: 'PÃ¤Ã¤tÃ¶s',
  filetype_spdecision: 'PÃ¤Ã¤tÃ¶s',
  spdecisionlist: 'PÃ¤Ã¤tÃ¶kset',
  filetype_spdecisionlist: 'PÃ¤Ã¤tÃ¶kset',
  spobjective: 'Tavoite',
  filetype_spobjective: 'Tavoite',
  spobjectivelist: 'Tavoitteet',
  filetype_spobjectivelist: 'Tavoitteet',
  sptextbox: 'Tekstiruutu',
  filetype_sptextbox: 'Tekstiruutu',
  sptextboxlist: 'Tekstiruutulista',
  filetype_sptextboxlist: 'Tekstiruutulista',
  spthingstobring: 'Tuotava asia',
  filetype_spthingstobring: 'Tuotava asia',
  spthingstobringlist: 'Tuotavat asiat',
  filetype_spthingstobringlist: 'Tuotavat asiat',
  sparealisting: 'Aluelistaus',
  filetype_sparealisting: 'Aluelistaus',
  spmeetingserie: 'Tapaamissarja',
  filetype_spmeetingserie: 'Tapaamissarja',
  spmeetingserielist: 'Tapaamissarjan lista',
  filetype_spmeetingserielist: 'Tapaamissarjan lista',
  spsitedirectory: 'Sivuston hakemiston kohde',
  filetype_spsitedirectory: 'Sivuston hakemiston kohde',
  spsitedirectorylist: 'Sivuston hakemisto',
  filetype_spsitedirectorylist: 'Sivuston hakemisto',
  spdatasource: 'TietolÃ¤hde',
  filetype_spdatasource: 'TietolÃ¤hde',
  spdatasourcelist: 'TietolÃ¤hdelista',
  filetype_spdatasourcelist: 'TietolÃ¤hdelista',
  splisttemplatecataloglist: 'Mallilistan galleria',
  filetype_splisttemplatecataloglist: 'Mallilistan galleria',
  spwebpartcataloglist: 'WebPart-galleria',
  filetype_spwebpartcataloglist: 'WebPart-galleria',
  spwebtemplatecataloglist: 'Sivustomallin galleria',
  filetype_spwebtemplatecataloglist: 'Sivustomallin galleria',
  spworkspacepagelist: 'TyÃ¶tilan sivut',
  filetype_spworkspacepagelist: 'TyÃ¶tilan sivut',
  spunknownlist: 'RÃ¤Ã¤tÃ¤lÃ¶ity lista',
  filetype_spunknownlist: 'RÃ¤Ã¤tÃ¤lÃ¶ity lista',
  spadministratortask: 'JÃ¤rjestelmÃ¤nvalvojan tehtÃ¤vÃ¤',
  filetype_spadministratortask: 'JÃ¤rjestelmÃ¤nvalvojan tehtÃ¤vÃ¤',
  spadministratortasklist: 'JÃ¤rjestelmÃ¤nvalvojan tehtÃ¤vÃ¤t',
  filetype_spadministratortasklist: 'JÃ¤rjestelmÃ¤nvalvojan tehtÃ¤vÃ¤t',
  spareadocumentlibrarylist: 'Alueen asiakirjakirjasto',
  filetype_spareadocumentlibrarylist: 'Alueen asiakirjakirjasto',
  spblogcategory: 'Blogikategoria',
  filetype_spblogcategory: 'Blogikategoria',
  spblogcategorylist: 'Blogikategoriat',
  filetype_spblogcategorylist: 'Blogikategoriat',
  spblogcomment: 'Blogikommentti',
  filetype_spblogcomment: 'Blogikommentti',
  spblogcommentlist: 'Blogikommentit',
  filetype_spblogcommentlist: 'Blogikommentit',
  spblogpost: 'Blogijulkaisu',
  filetype_spblogpost: 'Blogijulkaisu',
  spblogpostlist: 'Blogijulkaisut',
  filetype_spblogpostlist: 'Blogijulkaisut',
  spdataconnectionlibrarylist: 'Tietoyhteyksien kirjasto',
  filetype_spdataconnectionlibrarylist: 'Tietoyhteyksien kirjasto',
  spdistributiongroup: 'JakeluryhmÃ¤',
  filetype_spdistributiongroup: 'JakeluryhmÃ¤',
  spdistributiongrouplist: 'JakeluryhmÃ¤t',
  filetype_spdistributiongrouplist: 'JakeluryhmÃ¤t',
  spipfslist: 'InfoPath-lomakkeiden palvelimet',
  filetype_spipfslist: 'InfoPath-lomakkeiden palvelimet',
  spkeyperformanceindicator: 'Avainsuorituksen ilmaisin',
  filetype_spkeyperformanceindicator: 'Avainsuorituksen ilmaisin',
  spkeyperformanceindicatorlist: 'Avainsuoritusten ilmaisimet',
  filetype_spkeyperformanceindicatorlist: 'Avainsuoritusten ilmaisimet',
  splanguagesandtranslator: 'Kielet ja kÃ¤Ã¤ntÃ¤jÃ¤',
  filetype_splanguagesandtranslator: 'Kielet ja kÃ¤Ã¤ntÃ¤jÃ¤',
  splanguagesandtranslatorlist: 'Kielet ja kÃ¤Ã¤ntÃ¤jÃ¤t',
  filetype_splanguagesandtranslatorlist: 'Kielet ja kÃ¤Ã¤ntÃ¤jÃ¤t',
  spmasterpagescataloglist: 'PÃ¤Ã¤sivun galleria',
  filetype_spmasterpagescataloglist: 'PÃ¤Ã¤sivun galleria',
  spnocodeworkflowlibrarylist: 'Koodittoman tyÃ¶nkulun kirjasto',
  filetype_spnocodeworkflowlibrarylist: 'Koodittoman tyÃ¶nkulun kirjasto',
  spprojecttask: 'ProjektitehtÃ¤vÃ¤',
  filetype_spprojecttask: 'ProjektitehtÃ¤vÃ¤',
  spprojecttasklist: 'ProjektitehtÃ¤vÃ¤t',
  filetype_spprojecttasklist: 'ProjektitehtÃ¤vÃ¤t',
  sppublishingpageslibrarylist: 'Sivujen kirjasto',
  filetype_sppublishingpageslibrarylist: 'Sivujen kirjasto',
  spreportdocumentlibrarylist: 'Raportin asiakirjakirjasto',
  filetype_spreportdocumentlibrarylist: 'Raportin asiakirjakirjasto',
  spreportlibrarylist: 'Raporttikirjasto',
  filetype_spreportlibrarylist: 'Raporttikirjasto',
  spslidelibrarylist: 'Diakuvakirjasto',
  filetype_spslidelibrarylist: 'Diakuvakirjasto',
  sptab: 'VÃ¤lilehdet',
  filetype_sptab: 'VÃ¤lilehdet',
  sptablist: 'VÃ¤lilehtilista',
  filetype_sptablist: 'VÃ¤lilehtilista',
  sptranslationmanagementlibrarylist: 'KÃ¤Ã¤ntÃ¤misen hallinnan kirjasto',
  filetype_sptranslationmanagementlibrarylist: 'KÃ¤Ã¤ntÃ¤misen hallinnan kirjasto',
  spuserinformation: 'KÃ¤yttÃ¤jÃ¤tiedot',
  filetype_spuserinformation: 'KÃ¤yttÃ¤jÃ¤tiedot',
  spuserinformationlist: 'KÃ¤yttÃ¤jÃ¤tietojen lista',
  filetype_spuserinformationlist: 'KÃ¤yttÃ¤jÃ¤tietojen lista',
  spwikipagelibrarylist: 'Wiki-sivun kirjasto',
  filetype_spwikipagelibrarylist: 'Wiki-sivun kirjasto',
  spworkflowhistory: 'TyÃ¶nkulkuhistoria',
  filetype_spworkflowhistory: 'TyÃ¶nkulkuhistoria',
  spworkflowhistorylist: 'TyÃ¶nkulkuhistorian lista',
  filetype_spworkflowhistorylist: 'TyÃ¶nkulkuhistorian lista',
  spworkflowprocess: 'RÃ¤Ã¤tÃ¤lÃ¶ity tyÃ¶nkulku',
  filetype_spworkflowprocess: 'RÃ¤Ã¤tÃ¤lÃ¶ity tyÃ¶nkulku',
  spworkflowprocesslist: 'RÃ¤Ã¤tÃ¤lÃ¶idyt tyÃ¶nkulut',
  filetype_spworkflowprocesslist: 'RÃ¤Ã¤tÃ¤lÃ¶idyt tyÃ¶nkulut',
  sppublishingimageslibrarylist: 'Julkaistujen kuvien kirjasto',
  filetype_sppublishingimageslibrarylist: 'Julkaistujen kuvien kirjasto',
  spcirculation: 'Jakelu',
  filetype_spcirculation: 'Jakelu',
  spcirculationlist: 'Jakelut',
  filetype_spcirculationlist: 'Jakelut',
  spdashboardslibrarylist: 'KoontinÃ¤ytÃ¶n kirjasto',
  filetype_spdashboardslibrarylist: 'KoontinÃ¤ytÃ¶n kirjasto',
  spdataconnectionforperformancepointlibrarylist: 'PerformancePointi-tietoyhteyksien kirjasto',
  filetype_spdataconnectionforperformancepointlibrarylist: 'PerformancePointi-tietoyhteyksien kirjasto',
  sphealthreport: 'Terveysraportti',
  filetype_sphealthreport: 'Terveysraportti',
  sphealthreportlist: 'Terveysraportit',
  filetype_sphealthreportlist: 'Terveysraportit',
  sphealthrule: 'TerveyssÃ¤Ã¤ntÃ¶',
  filetype_sphealthrule: 'TerveyssÃ¤Ã¤ntÃ¶',
  sphealthrulelist: 'TerveyssÃ¤Ã¤nnÃ¶t',
  filetype_sphealthrulelist: 'TerveyssÃ¤Ã¤nnÃ¶t',
  spimedictionary: 'IME-sanakirja',
  filetype_spimedictionary: 'IME-sanakirja',
  spimedictionarylist: 'IME-sanakirjat',
  filetype_spimedictionarylist: 'IME-sanakirjat',
  spperformancepointcontent: 'PerformancePoint-sisÃ¤ltÃ¶',
  filetype_spperformancepointcontent: 'PerformancePoint-sisÃ¤ltÃ¶',
  spperformancepointcontentlist: 'PerformancePoint-sisÃ¤llÃ¶t',
  filetype_spperformancepointcontentlist: 'PerformancePoint-sisÃ¤llÃ¶t',
  spphonecallmemo: 'Soitetun puhelun muistio',
  filetype_spphonecallmemo: 'Soitetun puhelun muistio',
  spphonecallmemolist: 'Soitettujen puheluiden muistiot',
  filetype_spphonecallmemolist: 'Soitettujen puheluiden muistiot',
  sprecordlibrarylist: 'Tallennusten kirjasto',
  filetype_sprecordlibrarylist: 'Tallennusten kirjasto',
  spresource: 'Resurssi',
  filetype_spresource: 'Resurssi',
  spresourcelist: 'Resurssit',
  filetype_spresourcelist: 'Resurssit',
  spprocessdiagramslibrarylist: 'Prosessikaavion kirjasto',
  filetype_spprocessdiagramslibrarylist: 'Prosessikaavion kirjasto',
  spsitethemeslibrarylist: 'Sivustoteeman kirjasto',
  filetype_spsitethemeslibrarylist: 'Sivustoteeman kirjasto',
  spsolutionslibrarylist: 'Ratkaisujen kirjasto',
  filetype_spsolutionslibrarylist: 'Ratkaisujen kirjasto',
  spwfpublibrarylist: 'WFPUB-kirjasto',
  filetype_spwfpublibrarylist: 'WFPUB-kirjasto',
  spwhereabout: 'Sijainti',
  filetype_spwhereabout: 'Sijainti',
  spwhereaboutlist: 'Sijainnit',
  filetype_spwhereaboutlist: 'Sijainnit',
  spdocumentlink: 'Linkki asiakirjaan',
  filetype_spdocumentlink: 'Linkki asiakirjaan',
  spdocumentset: 'Asiakirjasetti',
  filetype_spdocumentset: 'Asiakirjasetti',
  spmicrofeedpost: 'MikrosyÃ¶tejulkaisu',
  filetype_spmicrofeedpost: 'MikrosyÃ¶tejulkaisu',
  spmicrofeedlist: 'MikrosyÃ¶te',
  filetype_spmicrofeedlist: 'MikrosyÃ¶te',
  splistfolder: 'Listakansio',
  filetype_splistfolder: 'Listakansio',
  Unknown: 'Tuntematon',
  And: 'JA',
  Authenticating: 'Varmentaa {0}â€¦',
  Clear: 'TyhjennÃ¤ {0}',
  CompleteQuery: 'TÃ¤ydennÃ¤ kysely',
  Exclude: 'Poissulje {0}',
  EnterTag: 'LisÃ¤Ã¤ tagi',
  Next: 'Seuraava',
  Last: 'Viimeinen',
  Link: 'Linkki',
  Or: 'TAI',
  Previous: 'Edellinen',
  QueryDidntMatchAnyDocuments: 'Kyselysi ei vastannut mitÃ¤Ã¤n asiakirjoja.',
  QueryException: 'KyselyssÃ¤si on virhe: {0}.',
  Me: 'MinÃ¤',
  Remove: 'Poista',
  Search: 'Hae',
  SearchFor: 'Haku kohteelle {0}',
  ShareQuery: 'Jaa kysely',
  Preferences: 'Asetukset',
  LinkOpeningSettings: 'Linkin avausasetukset',
  Reauthenticate: 'Varmenna uudestaan {0}',
  ResultsFilteringExpression: 'Tulosten suodatusilmaisut',
  FiltersInYourPreferences: 'Suodattaa asetuksiisi',
  Create: 'Luo',
  SearchIn: 'Hae kohteessa {0}',
  Seconds: '{0} sekunnissa',
  ShowingResultsOf: '<sn>Tulos</sn><pl>Tulokset</pl> {0}<pl>â€“{1}</pl> / {2}',
  ShowingResultsOfWithQuery: '<sn>Tulos</sn><pl>Tulokset</pl> {0}<pl>â€“{1}</pl> / {2} sta {3}',
  SwitchTo: 'Vaihda kohteeseen {0}',
  Unexclude: 'SisÃ¤llytÃ¤ {0}',
  ClearAllFilters: 'TyhjennÃ¤ kaikki suodattimet',
  SkipLogin: 'Ohita kirjautuminen',
  LoginInProgress: 'Kirjautuminen kÃ¤ynnissÃ¤, odota',
  Login: 'Kirjaudu sisÃ¤Ã¤n',
  GetStarted: 'Aloita',
  More: 'LisÃ¤Ã¤',
  NMore: '{0} lisÃ¤Ã¤â€¦',
  Less: 'VÃ¤hemmÃ¤n',
  Settings: 'Asetukset',
  Score: 'PistemÃ¤Ã¤rÃ¤',
  ScoreDescription: 'PistemÃ¤Ã¤rÃ¤ lasketaan esiintymisten mÃ¤Ã¤rÃ¤stÃ¤ sekÃ¤ sijainnista tulosasetuksessa.',
  Occurrences: 'Esiintymiset',
  OccurrencesDescription: 'Lajittele esiintymismÃ¤Ã¤rÃ¤n mukaan, siten ettÃ¤ arvot, joiden mÃ¤Ã¤rÃ¤ on suurin, tulevat ensin.',
  Label: 'Merkki',
  Of: '/',
  LabelDescription: 'Lajittele aakkosjÃ¤rjestyksessÃ¤ kenttÃ¤arvojen perusteella.',
  Value: 'Arvo',
  ValueDescription: 'Lajittele ensimmÃ¤isenÃ¤ lasketun kentÃ¤n arvojen perusteella',
  AlphaAscending: 'Nouseva arvo',
  AlphaDescending: 'Laskeva arvo',
  ChiSquare: 'Khiin neliÃ¶',
  Nosort: 'Ei lajittelua',
  NosortDescription: 'Ã„lÃ¤ jÃ¤rjestÃ¤ arvoja. Arvot palautuvat satunnaiseen jÃ¤rjestykseen.',
  RelativeFrequency: 'Suhteellinen tiheys',
  RelativeFrequencyDescription: 'Lajittele arvojen suhteellisen tiheyden perusteella. VÃ¤hiten yleiset arvot tulevat ylempÃ¤nÃ¤.',
  DateDistribution: 'PÃ¤ivÃ¤mÃ¤Ã¤rÃ¤n jako',
  Custom: 'RÃ¤Ã¤tÃ¤lÃ¶ity',
  CustomDescription: 'Lajittele rÃ¤Ã¤tÃ¤lÃ¶idyn jÃ¤rjestyksen perusteella',
  ComputedField: 'Laskettu kenttÃ¤',
  Ascending: 'Nouseva',
  Descending: 'Laskeva',
  noResultFor: 'Ei tuloksia kohteelle {0}',
  autoCorrectedQueryTo: 'Kysely korjattiin automaattisesti kohteeseen {0}',
  didYouMean: 'Tarkoititko: {0}',
  SuggestedResults: 'Ehdotetut tulokset',
  SuggestedQueries: 'Ehdotetut kyselyt',
  MostRelevantItems: 'MerkityksellisimmÃ¤t kohteet:',
  AllItems: 'Kaikki kohteet:',
  ShowLess: 'NÃ¤ytÃ¤ vÃ¤hemmÃ¤n',
  ShowMore: 'NÃ¤ytÃ¤ enemmÃ¤n',
  HideFacet: 'Piilota fasetti',
  ShowFacet: 'NÃ¤ytÃ¤ fasetti',
  AndOthers: 'ja {0} muu<pl>ta</pl>',
  Others: '{0} muu<pl>ta</pl>',
  MostRelevantPosts: 'MerkityksellisimmÃ¤t postaukset:',
  CompleteThread: 'TÃ¤ydennÃ¤ ketju:',
  ShowCompleteThread: 'NÃ¤ytÃ¤ tÃ¤ysi ketju',
  ShowOnlyTopMatchingPosts: 'NÃ¤ytÃ¤ vain parhaiten sopivat postaukset',
  MostRelevantReplies: 'MerkityksellisimmÃ¤t vastaukset:',
  AllConversation: 'Koko keskustelu:',
  ShowAllConversation: 'NÃ¤ytÃ¤ koko keskustelu',
  ShowAllReplies: 'NÃ¤ytÃ¤ kaikki vastaukset',
  ShowOnlyMostRelevantReplies: 'NÃ¤ytÃ¤ vain merkityksellisimmÃ¤t vastaukset',
  Close: 'Sulje',
  Open: 'Avaa',
  OpenInOutlookWhenPossible: 'Avaa Outlook (kun mahdollista)',
  AlwaysOpenInNewWindow: 'Avaa aina tulokset uudessa ikkunassa',
  Quickview: 'PikanÃ¤kymÃ¤',
  NoQuickview: 'Asiakirjan pikanÃ¤kymÃ¤ ei ole saatavilla',
  ErrorReport: 'Virheraportti',
  OopsError: 'Jotain meni pieleen palvelimella.',
  ProblemPersists: 'Jos ongelma ei poistu, ota yhteyttÃ¤ yllÃ¤pitoon.',
  GoBack: 'Siirry takaisin',
  Reset: 'Nollaa',
  Retry: 'YritÃ¤ uudestaan',
  MoreInfo: 'LisÃ¤tietoja',
  Username: 'KÃ¤yttÃ¤jÃ¤tunnus',
  Password: 'Salasana',
  PostedBy: 'Julkaisija:',
  CannotConnect: 'Palvelinosoitteeseen ei pysty muodostamaan yhteyttÃ¤.',
  BadUserPass: 'Salasana ei vastaa kÃ¤yttÃ¤jÃ¤tunnusta.',
  PleaseEnterYourCredentials: 'SyÃ¶tÃ¤ tunnistetietosi jÃ¤rjestelmÃ¤lle {0}.',
  PleaseEnterYourSearchPage: 'SyÃ¶tÃ¤ hakusivusi URL',
  Collapse: 'PienennÃ¤',
  Collapsable: 'PienennettÃ¤vÃ¤',
  Expand: 'Laajenna',
  Today: 'TÃ¤nÃ¤Ã¤n',
  Yesterday: 'Eilen',
  Tomorrow: 'Huomenna',
  Duration: 'Kesto: {0}',
  IndexDuration: 'Hakemiston kesto: {0}',
  ProxyDuration: 'VÃ¤lityspalvelimen kesto: {0}',
  ClientDuration: 'Asiakkaan kesto: {0}',
  Unavailable: 'Ei saatavissa',
  Reply: 'Vastaa',
  ReplyAll: 'Vastaa kaikille',
  Forward: 'VÃ¤litÃ¤ eteenpÃ¤in',
  From: 'LÃ¤hettÃ¤jÃ¤',
  Caption: 'Kuvateksti',
  Expression: 'Ilmaisu',
  Tab: 'VÃ¤lilehti',
  Tabs: 'VÃ¤lilehdet',
  EnterExpressionName: 'SyÃ¶tÃ¤ ilmaisun nimi',
  EnterExpressionToFilterWith: 'SyÃ¶tÃ¤ ilmaisu suodattaaksesi tulokset',
  SelectTab: 'Valitse vÃ¤lilehti',
  SelectAll: 'Valitse kaikki',
  PageUrl: 'Hakusivu URL',
  ErrorSavingToDevice: 'Virhe tietojen tallennuksessa laitteellesi',
  ErrorReadingFromDevice: 'Virhe tietoja luettaessa laitteeltasi',
  AppIntro: 'Puhu tuoteasiantuntijan kanssa, joka pystyy vastaamaan kysymyksiisi   Coveosta ja auttamaan sinua pÃ¤Ã¤ttÃ¤mÃ¤Ã¤n, mikÃ¤ Coveo-ratkaisu on oikea sinulle. Kokeile live-demoa!',
  TryDemo: 'Kokeile demoa',
  ContactUs: 'Ota meihin yhteyttÃ¤',
  NewToCoveo: 'Uusi Coveossa?',
  LetUsHelpGetStarted: 'Anna meidÃ¤n auttaa sinut alkuun',
  LikesThis: '{0} <pl>pitÃ¤vÃ¤t</pl><sn>pitÃ¤Ã¤</sn> tÃ¤stÃ¤.',
  CannotConnectSearchPage: 'Hakusivullesi ei pystytÃ¤ yhdistÃ¤mÃ¤Ã¤n',
  AreYouSureDeleteFilter: 'Oletko varma, ettÃ¤ haluat poistaa suodattimen {0} ilmaisulla {1}',
  OnlineHelp: 'Verkkotuki',
  Done: 'Valmis',
  SaveFacetState: 'Tallenna tÃ¤mÃ¤ fasettitila',
  ClearFacetState: 'TyhjennÃ¤ fasettitila',
  DisplayingTheOnlyMessage: 'NÃ¤yttÃ¤Ã¤ ainoan viestin tÃ¤ssÃ¤ keskustelussa',
  NoNetworkConnection: 'Ei verkkoyhteyttÃ¤',
  UnknownConnection: 'Tuntematon yhteys',
  EthernetConnection: 'Ethernet-yhteys',
  WiFi: 'WiFi-yhteys',
  CELL: 'Mobiiliyhteys',
  CELL_2G: '2G-mobiiliyhteys',
  CELL_3G: '3G-mobiiliyhteys',
  CELL_4G: '4G-mobiiliyhteys',
  Relevance: 'Merkitys',
  Date: 'PÃ¤ivÃ¤mÃ¤Ã¤rÃ¤',
  Amount: 'MÃ¤Ã¤rÃ¤',
  QueryExceptionNoException: 'Ei poikkeusta',
  QueryExceptionInvalidSyntax: 'Virheellinen syntaksi',
  QueryExceptionInvalidCustomField: 'Virheellinen rÃ¤Ã¤tÃ¤lÃ¶ity kenttÃ¤',
  QueryExceptionInvalidDate: 'Virheellinen pÃ¤ivÃ¤mÃ¤Ã¤rÃ¤',
  QueryExceptionInvalidExactPhrase: 'Virheellinen tarkka lauseke',
  QueryExceptionInvalidDateOp: 'Virheellinen pÃ¤ivÃ¤yskÃ¤yttÃ¤jÃ¤',
  QueryExceptionInvalidNear: 'Virheellinen NEAR-kÃ¤yttÃ¤jÃ¤',
  QueryExceptionInvalidWeightedNear: 'Virheellinen painotettu NEAR',
  QueryExceptionInvalidTerm: 'Virheellinen termi',
  QueryExceptionTooManyTerms: 'Liian monta termiÃ¤',
  QueryExceptionWildcardTooGeneral: 'Liian yleinen villikortti',
  QueryExceptionInvalidSortField: 'Virheellinen lajittelukenttÃ¤',
  QueryExceptionInvalidSmallStringOp: 'Virheellinen pienen jonon kÃ¤yttÃ¤jÃ¤',
  QueryExceptionRequestedResultsMax: 'PyydettyjÃ¤ tuloksia enintÃ¤Ã¤n',
  QueryExceptionAggregatedMirrorDead: 'Koottu peili on pois verkosta',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Kootun peilin kyselyn aikakatkaisu',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Kootun peilin virheellinen rakennusnumero',
  QueryExceptionAggregatedMirrorCannotConnect: 'Koottuun peiliin ei voida yhdistÃ¤Ã¤',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Ei tarpeeksi johtavan merkin villikortteja',
  QueryExceptionSecurityInverterNotFound: 'Turvallisuusmuunninta ei lÃ¶ytynyt',
  QueryExceptionSecurityInverterAccessDenied: 'Turvallisuusmuuntimen kÃ¤yttÃ¶oikeus kielletty',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'Koottu peili ei pysty esiintymÃ¤Ã¤n toisena',
  QueryExceptionUnexpected: 'Odottamaton',
  QueryExceptionAccessDenied: 'KÃ¤yttÃ¶oikeus kielletty',
  QueryExceptionSuperUserTokenInvalid: 'SuperkÃ¤yttÃ¤jÃ¤n merkki virheellinen',
  QueryExceptionSuperUserTokenExpired: 'SuperkÃ¤yttÃ¤jÃ¤n merkki vanhentunut',
  QueryExceptionLicenseQueriesExpired: 'Kyselyjen lisenssi vanhentunut',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'LisenssiÃ¤ superkÃ¤yttÃ¤jÃ¤n merkille ei tueta',
  QueryExceptionInvalidSession: 'Virheellinen istunto',
  QueryExceptionInvalidDocument: 'Virheellinen asiakirja',
  QueryExceptionSearchDisabled: 'Haku poistettu kÃ¤ytÃ¶stÃ¤',
  FileType: 'Tiedostotyyppi',
  ShowAttachment: 'NÃ¤ytÃ¤ liite',
  OnFeed: '{0}:n syÃ¶tteestÃ¤.',
  Author: 'TekijÃ¤',
  NoTitle: 'Ei otsikkoa',
  CurrentSelections: 'Nykyiset valinnat',
  AllContent: 'Koko sisÃ¤ltÃ¶',
  CancelLastAction: 'Peruuta viimeinen toiminta',
  SearchTips: 'Hakuvihjeet',
  CheckSpelling: 'Tarkasta asiasanojen kirjoitusasu.',
  TryUsingFewerKeywords: 'Kokeile kÃ¤yttÃ¤Ã¤ vÃ¤hemmÃ¤n, erilaisia tai yleisempiÃ¤ asiasanoja.',
  SelectFewerFilters: 'Valitse vÃ¤hemmÃ¤n suodattimia hakusi laajentamiseksi.',
  Document: 'Asiakirja',
  Time: 'Aika',
  StartDate: 'AloituspÃ¤ivÃ¤',
  StartTime: 'Aloitusaika',
  DurationTitle: 'Kesto',
  UserQuery: 'KÃ¤yttÃ¤jÃ¤kysely',
  ShowUserActions: 'NÃ¤ytÃ¤ kÃ¤yttÃ¤jÃ¤n toiminta',
  NoData: 'Tietoja ei saatavilla',
  EventType: 'Tapahtumatyyppi',
  GoToFullSearch: 'TÃ¤ysi haku',
  GoToEdition: 'RÃ¤Ã¤tÃ¤lÃ¶i paneeli',
  RemoveContext: 'Poista konteksti',
  BoxAttachToCase: 'LiitÃ¤ pyyntÃ¶Ã¶n',
  AttachToCase: 'LiitÃ¤ pyyntÃ¶Ã¶n',
  Attach: 'LiitÃ¤',
  Attached: 'Liitetty',
  Detach: 'Irrota',
  Details: 'Tietoja',
  AdditionalFilters: 'LisÃ¤suodattimet',
  SelectNonContextualSearch: 'Poista konteksti tÃ¤mÃ¤nhetkisestÃ¤ kirjauksesta laajentaaksesi hakua',
  CopyPasteToSupport: 'Kopioi ja liitÃ¤ tÃ¤mÃ¤ viesti lisÃ¤tiedoksi Coveon tukitiimille.',
  FollowQueryDescription: 'Ilmoita minulle tÃ¤mÃ¤n kyselyn hakutulosten muutoksista.',
  SearchAlerts_Panel: 'Hallitse hÃ¤lytyksiÃ¤',
  SearchAlerts_PanelDescription: 'Tarkastele ja hallinnoi hakuhÃ¤lytyksiÃ¤.',
  SearchAlerts_PanelNoSearchAlerts: 'Sinulla ei ole tilauksia.',
  SearchAlerts_Fail: 'HakuhÃ¤lytysten palvelu ei ole tÃ¤llÃ¤ hetkellÃ¤ kÃ¤ytettÃ¤vissÃ¤.',
  SearchAlerts_Type: 'Tyyppi',
  SearchAlerts_Content: 'SisÃ¤ltÃ¶',
  SearchAlerts_Actions: 'Toiminta',
  EmptyQuery: '<tyhjÃ¤>',
  SearchAlerts_Type_followQuery: 'Kysely',
  SearchAlerts_Type_followDocument: 'Kohta',
  SearchAlerts_unFollowing: 'Lopeta seuraaminen',
  SearchAlerts_follow: 'Seuraa',
  SearchAlerts_followed: 'Seurattu',
  SearchAlerts_followQuery: 'Seuraa kyselyÃ¤',
  Subscription_StopFollowingQuery: 'Lopeta kyselyn seuraaminen',
  SearchAlerts_Frequency: 'Kun',
  SubscriptionsManageSubscriptions: 'Hallitse hÃ¤lytyksiÃ¤',
  SubscriptionsMessageFollowQuery: 'Saat hÃ¤lytyksiÃ¤, kun kysely <b>{0}</b> uudistetaan tai sitÃ¤ pÃ¤ivitetÃ¤Ã¤n.',
  SubscriptionsMessageFollow: 'Saat hÃ¤lytyksiÃ¤ muutoksista kohteelle <b>{0}</b>.',
  Expiration: 'Umpeutuminen',
  Monthly: 'Kuukausittain',
  Daily: 'PÃ¤ivittÃ¤in',
  Monday: 'Maanantai',
  Tuesday: 'Tiistai',
  Wednesday: 'Keskiviikko',
  Thursday: 'Torstai',
  Friday: 'Perjantai',
  Saturday: 'Lauantai',
  Sunday: 'Sunnuntai',
  NextDay: 'Seuraava {0}',
  LastDay: 'Viime {0}',
  StartTypingCaseForSuggestions: 'Kuvaile ongelmaasi nÃ¤hdÃ¤ksesi mahdollisia ratkaisuja',
  ExportToExcel: 'Tuo Exceliin',
  ExportToExcelDescription: 'Tuo hakutulokset Exceliin',
  CaseCreationNoResults: 'Suositeltuja ratkaisuja ei lÃ¶ytynyt',
  SortBy: 'Lajittelutapa',
  BoxCreateArticle: 'Luo artikkeli',
  Facets: 'Fasetit',
  AdvancedSearch: 'Tarkennettu haku',
  Keywords: 'Avainsanat',
  AllTheseWords: 'Kaikki nÃ¤mÃ¤ sanat',
  ExactPhrase: 'Sanatarkasti tÃ¤mÃ¤ lause',
  AnyOfTheseWords: 'MikÃ¤ tahansa nÃ¤istÃ¤ sanoista',
  NoneOfTheseWords: 'MikÃ¤Ã¤n nÃ¤istÃ¤ sanoista',
  Anytime: 'Milloin tahansa',
  InTheLast: 'ViimeisessÃ¤',
  Days: 'pÃ¤ivÃ¤Ã¤',
  Months: 'kuukautta',
  Month: 'Kuukausi',
  Year: 'Vuosi',
  Between: 'VÃ¤lillÃ¤',
  Language: 'Kieli',
  Size: 'Koko',
  AtLeast: 'vÃ¤hintÃ¤Ã¤n',
  AtMost: 'enintÃ¤Ã¤n',
  Contains: 'sisÃ¤ltÃ¤Ã¤',
  DoesNotContain: 'ei sisÃ¤llÃ¤',
  Matches: 'vastaa',
  Bytes: 'tavua',
  card: 'Kortti',
  table: 'Taulukko',
  ResultLinks: 'Tuloslinkit',
  EnableQuerySyntax: 'Salli kyselyn syntaksi',
  On: 'PÃ¤Ã¤llÃ¤',
  Off: 'PoispÃ¤Ã¤ltÃ¤',
  Automatic: 'Automaattinen',
  ResultsPerPage: 'Tuloksia per sivu',
  PreviousMonth: 'Edellinen kuukausi',
  NextMonth: 'Seuraava kuukausi',
  Title: 'Otsikko',
  TRFilters: 'Filters'
};

// eslint-disable-next-line import/no-anonymous-default-export
var sv = {
  'box user': 'AnvÃ¤ndare',
  'filetype_box user': 'AnvÃ¤ndare',
  html: 'HTML-fil',
  filetype_html: 'HTML-fil',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Webbsida',
  filetype_webscraperwebpage: 'Webbsida',
  image: 'Bild',
  filetype_image: 'Bild',
  folder: 'Mapp',
  filetype_folder: 'Mapp',
  txt: 'Text',
  filetype_txt: 'Text',
  zip: 'Zip-fil',
  filetype_zip: 'Zip-fil',
  olefile: 'OLE-fil',
  filetype_olefile: 'OLE-fil',
  gmailmessage: 'Gmail-meddelande',
  filetype_gmailmessage: 'Gmail-meddelande',
  pdf: 'PDF-fil',
  filetype_pdf: 'PDF-fil',
  swf: 'Flash-fil',
  filetype_swf: 'Flash-fil',
  xml: 'XML-fil',
  filetype_xml: 'XML-fil',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSS-kanal',
  filetype_rssitem: 'RSS-kanal',
  doc: 'Dokument',
  filetype_doc: 'Dokument',
  docx: 'Microsoft Word-dokument',
  filetype_docx: 'Microsoft Word-dokument',
  xls: 'Kalkylarksdokument',
  filetype_xls: 'Kalkylarksdokument',
  ppt: 'Presentationsdokument',
  filetype_ppt: 'Presentationsdokument',
  video: 'Video',
  filetype_video: 'Video',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Open Text-dokument',
  filetype_odt: 'Open Text-dokument',
  lithiummessage: 'Lithium-meddelande',
  filetype_lithiummessage: 'Lithium-meddelande',
  lithiumthread: 'Lithium-trÃ¥d',
  filetype_lithiumthread: 'Lithium-trÃ¥d',
  lithiumboard: 'Lithium-anslagstavla',
  filetype_lithiumboard: 'Lithium-anslagstavla',
  lithiumcategory: 'Lithium-kategori',
  filetype_lithiumcategory: 'Lithium-kategori',
  lithiumcommunity: 'Lithium-diskussionsgrupp',
  filetype_lithiumcommunity: 'Lithium-diskussionsgrupp',
  people: 'AnvÃ¤ndare',
  objecttype_people: 'AnvÃ¤ndare',
  message: 'Meddelande',
  objecttype_message: 'Meddelande',
  feed: 'RSS-kanal',
  objecttype_feed: 'RSS-kanal',
  thread: 'TrÃ¥d',
  objecttype_thread: 'TrÃ¥d',
  file: 'Fil',
  objecttype_file: 'Fil',
  board: 'Anslagstavla',
  objecttype_board: 'Anslagstavla',
  category: 'Kategori',
  objecttype_category: 'Kategori',
  account: 'Konto',
  objecttype_account: 'Konto',
  annotation: 'Notis',
  objecttype_annotation: 'Notis',
  campaign: 'Kampanj',
  objecttype_campaign: 'Kampanj',
  "case": 'Kundcase',
  objecttype_case: 'Kundcase',
  contact: 'Kontakt',
  objecttype_contact: 'Kontakt',
  contract: 'Kontrakt',
  objecttype_contract: 'Kontrakt',
  event: 'HÃ¤ndelse',
  objecttype_event: 'HÃ¤ndelse',
  email: 'E-post',
  objecttype_email: 'E-post',
  goal: 'MÃ¥l',
  objecttype_goal: 'MÃ¥l',
  objecttype_incident: 'Kundcase',
  invoice: 'Faktura',
  objecttype_invoice: 'Faktura',
  lead: 'Lead',
  objecttype_lead: 'Lead',
  list: 'Lista',
  objecttype_list: 'MarknadsfÃ¶ringslista',
  solution: 'LÃ¶sning',
  objecttype_solution: 'LÃ¶sning',
  task: 'Uppgift',
  objecttype_task: 'Uppgift',
  user: 'AnvÃ¤ndare',
  objecttype_user: 'AnvÃ¤ndare',
  attachment: 'Bilaga',
  objecttype_attachment: 'Bilaga',
  casecomment: 'Kommentar fÃ¶r kundcase',
  objecttype_casecomment: 'Kommentar fÃ¶r kundcase',
  opportunity: 'SÃ¤ljprojekt',
  objecttype_opportunity: 'SÃ¤ljprojekt',
  opportunityproduct: 'SÃ¤ljprojektprodukt',
  objecttype_opportunityproduct: 'SÃ¤ljprojektprodukt',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: 'Notis',
  objecttype_note: 'Notis',
  product: 'Produkt',
  objecttype_product: 'Produkt',
  partner: 'Partner',
  objecttype_partner: 'Partner',
  queueitem: 'Artikel i kÃ¶',
  objecttype_queueitem: 'Artikel i kÃ¶',
  quote: 'Offert',
  objecttype_quote: 'Offert',
  salesliterature: 'SÃ¤ljlitteratur',
  objecttype_salesliterature: 'SÃ¤ljlitteratur',
  salesorder: 'SÃ¤ljorder',
  objecttype_salesorder: 'SÃ¤ljorder',
  service: 'Service',
  objecttype_service: 'Service',
  socialprofile: 'Social profil',
  objecttype_socialprofile: 'Social profil',
  kbdocumentation: 'Dokumentation',
  objecttype_kbdocumentation: 'Dokumentation',
  kbtechnicalarticle: 'Dokumentation',
  objecttype_kbtechnicalarticle: 'Dokumentation',
  kbsolution: 'LÃ¶sning',
  objecttype_kbsolution: 'LÃ¶sning',
  kbknowledgearticle: 'Kunskapsartikel',
  objecttype_kbknowledgearticle: 'Kunskapsartikel',
  kbattachment: 'Bilaga',
  objecttype_kbattachment: 'Bilaga',
  kbarticle: 'Artikel',
  objecttype_kbarticle: 'Artikel',
  kbarticlecomment: 'Artikelkommentar',
  objecttype_kbarticlecomment: 'Artikelkommentar',
  knowledgearticle: 'Kunskapsartikel',
  objecttype_knowledgearticle: 'Kunskapsartikel',
  topic: 'Ã„mne',
  objecttype_topic: 'Ã„mne',
  dashboard: 'Instrumentpanel',
  objecttype_dashboard: 'Instrumentpanel',
  contentversion: 'Dokument',
  objecttype_contentversion: 'Dokument',
  collaborationgroup: 'Samarbetsgrupp',
  objecttype_collaborationgroup: 'Samarbetsgrupp',
  spportal: 'Portal',
  filetype_spportal: 'Portal',
  spsite: 'Sida',
  filetype_spsite: 'Sida',
  spuserprofile: 'SharePoint-anvÃ¤ndare',
  filetype_spuserprofile: 'SharePoint-anvÃ¤ndare',
  sparea: 'OmrÃ¥de',
  filetype_sparea: 'OmrÃ¥de',
  spannouncement: 'TillkÃ¤nnagivande',
  filetype_spannouncement: 'TillkÃ¤nnagivande',
  spannouncementlist: 'TillkÃ¤nnagivanden',
  filetype_spannouncementlist: 'TillkÃ¤nnagivanden',
  spcontact: 'Kontakt',
  filetype_spcontact: 'Kontakt',
  spcontactlist: 'Kontakter',
  filetype_spcontactlist: 'Kontakter',
  spcustomlist: 'Egna listor',
  filetype_spcustomlist: 'Egna listor',
  spdiscussionboard: 'Diskussionsanslagstavla',
  filetype_spdiscussionboard: 'Diskussionsanslagstavla',
  spdiscussionboardlist: 'Diskussionsanslagstavlor',
  filetype_spdiscussionboardlist: 'Diskussionsanslagstavlor',
  spdocumentlibrarylist: 'Dokumentbibliotek',
  filetype_spdocumentlibrarylist: 'Dokumentbibliotek',
  spevent: 'HÃ¤ndelse',
  filetype_spevent: 'HÃ¤ndelse',
  speventlist: 'HÃ¤ndelser',
  filetype_speventlist: 'HÃ¤ndelser',
  spformlibrarylist: 'FormulÃ¤rbibliotek',
  filetype_spformlibrarylist: 'FormulÃ¤rbibliotek',
  spissue: 'Problem',
  filetype_spissue: 'Problem',
  spissuelist: 'Problem',
  filetype_spissuelist: 'Problem',
  splink: 'LÃ¤nk',
  filetype_splink: 'LÃ¤nk',
  splinklist: 'LÃ¤nkar',
  filetype_splinklist: 'LÃ¤nkar',
  sppicturelibrarylist: 'Bildbibliotek',
  filetype_sppicturelibrarylist: 'Bildbibliotek',
  spsurvey: 'UndersÃ¶kning',
  filetype_spsurvey: 'UndersÃ¶kning',
  spsurveylist: 'UndersÃ¶kningar',
  filetype_spsurveylist: 'UndersÃ¶kningar',
  sptask: 'Uppgift',
  filetype_sptask: 'Uppgift',
  sptasklist: 'Uppgifter',
  filetype_sptasklist: 'Uppgifter',
  spagenda: 'Dagordning',
  filetype_spagenda: 'Dagordning',
  spagendalist: 'Dagordningar',
  filetype_spagendalist: 'Dagordningar',
  spattendee: 'Deltagare',
  filetype_spattendee: 'Deltagare',
  spattendeelist: 'Deltagare',
  filetype_spattendeelist: 'Deltagare',
  spcustomgridlist: 'Egna rutnÃ¤t',
  filetype_spcustomgridlist: 'Egna rutnÃ¤t',
  spdecision: 'Beslut',
  filetype_spdecision: 'Beslut',
  spdecisionlist: 'Beslut',
  filetype_spdecisionlist: 'Beslut',
  spobjective: 'Objektiv',
  filetype_spobjective: 'Objektiv',
  spobjectivelist: 'Objektiv',
  filetype_spobjectivelist: 'Objektiv',
  sptextbox: 'Textruta',
  filetype_sptextbox: 'Textruta',
  sptextboxlist: 'Lista med textrutor',
  filetype_sptextboxlist: 'Lista med textrutor',
  spthingstobring: 'Sak att ta med',
  filetype_spthingstobring: 'Sak att ta med',
  spthingstobringlist: 'Saker att ta med',
  filetype_spthingstobringlist: 'Saker att ta med',
  sparealisting: 'OmrÃ¥deslista',
  filetype_sparealisting: 'OmrÃ¥deslista',
  spmeetingserie: 'MÃ¶tesserier',
  filetype_spmeetingserie: 'MÃ¶tesserier',
  spmeetingserielist: 'Lista med mÃ¶tesserier',
  filetype_spmeetingserielist: 'Lista med mÃ¶tesserier',
  spsitedirectory: 'Artikel fÃ¶r sidkatalog',
  filetype_spsitedirectory: 'Artikel fÃ¶r sidkatalog',
  spsitedirectorylist: 'Sidartikel',
  filetype_spsitedirectorylist: 'Sidartikel',
  spdatasource: 'DatakÃ¤lla',
  filetype_spdatasource: 'DatakÃ¤lla',
  spdatasourcelist: 'Lista med datakÃ¤lla',
  filetype_spdatasourcelist: 'Lista med datakÃ¤lla',
  splisttemplatecataloglist: 'Galleri med listmall',
  filetype_splisttemplatecataloglist: 'Galleri med listmall',
  spwebpartcataloglist: 'WebPart-galleri',
  filetype_spwebpartcataloglist: 'WebPart-galleri',
  spwebtemplatecataloglist: 'Galleri med sidmall',
  filetype_spwebtemplatecataloglist: 'Galleri med sidmall',
  spworkspacepagelist: 'Workspace-sidor',
  filetype_spworkspacepagelist: 'Workspace-sidor',
  spunknownlist: 'Egen lista',
  filetype_spunknownlist: 'Egen lista',
  spadministratortask: 'AdministratÃ¶rsuppgift',
  filetype_spadministratortask: 'AdministratÃ¶rsuppgift',
  spadministratortasklist: 'AdministratÃ¶ruppgifter',
  filetype_spadministratortasklist: 'AdministratÃ¶ruppgifter',
  spareadocumentlibrarylist: 'Bibliotek fÃ¶r omrÃ¥desdokument',
  filetype_spareadocumentlibrarylist: 'Bibliotek fÃ¶r omrÃ¥desdokument',
  spblogcategory: 'Bloggkategori',
  filetype_spblogcategory: 'Bloggkategori',
  spblogcategorylist: 'Bloggkategorier',
  filetype_spblogcategorylist: 'Bloggkategorier',
  spblogcomment: 'Bloggkommentar',
  filetype_spblogcomment: 'Bloggkommentar',
  spblogcommentlist: 'Bloggkommentarer',
  filetype_spblogcommentlist: 'Bloggkommentarer',
  spblogpost: 'BlogginlÃ¤gg',
  filetype_spblogpost: 'BlogginlÃ¤gg',
  spblogpostlist: 'BlogginlÃ¤gg',
  filetype_spblogpostlist: 'BlogginlÃ¤gg',
  spdataconnectionlibrarylist: 'Bibliotek fÃ¶r dataanslutning',
  filetype_spdataconnectionlibrarylist: 'Bibliotek fÃ¶r dataanslutning',
  spdistributiongroup: 'Distribueringsgrupp',
  filetype_spdistributiongroup: 'Distribueringsgrupp',
  spdistributiongrouplist: 'Distribueringsgrupp',
  filetype_spdistributiongrouplist: 'Distribueringsgrupp',
  spipfslist: 'FormulÃ¤rservrar fÃ¶r InforPath',
  filetype_spipfslist: 'FormulÃ¤rservrar fÃ¶r InforPath',
  spkeyperformanceindicator: 'Nyckelresultatindikator',
  filetype_spkeyperformanceindicator: 'Nyckelresultatindikator',
  spkeyperformanceindicatorlist: 'Nyckelresultatindikatorer',
  filetype_spkeyperformanceindicatorlist: 'Nyckelresultatindikatorer',
  splanguagesandtranslator: 'SprÃ¥k och Ã¶versÃ¤ttare',
  filetype_splanguagesandtranslator: 'SprÃ¥k och Ã¶versÃ¤ttare',
  splanguagesandtranslatorlist: 'SprÃ¥k och Ã¶versÃ¤ttare',
  filetype_splanguagesandtranslatorlist: 'SprÃ¥k och Ã¶versÃ¤ttare',
  spmasterpagescataloglist: 'Galleri fÃ¶r huvudsida',
  filetype_spmasterpagescataloglist: 'Galleri fÃ¶r huvudsida',
  spnocodeworkflowlibrarylist: 'Bibliotek fÃ¶r arbetsflÃ¶de utan kod',
  filetype_spnocodeworkflowlibrarylist: 'Bibliotek fÃ¶r arbetsflÃ¶de utan kod',
  spprojecttask: 'Projektuppgift',
  filetype_spprojecttask: 'Projektuppgift',
  spprojecttasklist: 'Projektuppgifter',
  filetype_spprojecttasklist: 'Projektuppgifter',
  sppublishingpageslibrarylist: 'Sidbibliotek',
  filetype_sppublishingpageslibrarylist: 'Sidbibliotek',
  spreportdocumentlibrarylist: 'Bibliotek fÃ¶r rapportdokument',
  filetype_spreportdocumentlibrarylist: 'Bibliotek fÃ¶r rapportdokument',
  spreportlibrarylist: 'Rapportbibliotek',
  filetype_spreportlibrarylist: 'Rapportbibliotek',
  spslidelibrarylist: 'Slide-bibliotek',
  filetype_spslidelibrarylist: 'Slide-bibliotek',
  sptab: 'Flikar',
  filetype_sptab: 'Flikar',
  sptablist: 'Fliklista',
  filetype_sptablist: 'Fliklista',
  sptranslationmanagementlibrarylist: 'Bibliotek fÃ¶r Ã¶versÃ¤ttningshantering',
  filetype_sptranslationmanagementlibrarylist: 'Bibliotek fÃ¶r Ã¶versÃ¤ttningshantering',
  spuserinformation: 'AnvÃ¤ndarinformation',
  filetype_spuserinformation: 'AnvÃ¤ndarinformation',
  spuserinformationlist: 'AnvÃ¤ndarinformationslista',
  filetype_spuserinformationlist: 'AnvÃ¤ndarinformationslista',
  spwikipagelibrarylist: 'Bibliotek med Wiki-sidor',
  filetype_spwikipagelibrarylist: 'Bibliotek med Wiki-sidor',
  spworkflowhistory: 'ArbetsflÃ¶deshistorik',
  filetype_spworkflowhistory: 'ArbetsflÃ¶deshistorik',
  spworkflowhistorylist: 'Lista med arbetsflÃ¶deshistorik',
  filetype_spworkflowhistorylist: 'Lista med arbetsflÃ¶deshistorik',
  spworkflowprocess: 'Egen arbetsflÃ¶desprocess',
  filetype_spworkflowprocess: 'Egen arbetsflÃ¶desprocess',
  spworkflowprocesslist: 'Egna arbetsflÃ¶desprocesser',
  filetype_spworkflowprocesslist: 'Egna arbetsflÃ¶desprocesser',
  sppublishingimageslibrarylist: 'Publicering av bildbibliotek',
  filetype_sppublishingimageslibrarylist: 'Publicering av bildbibliotek',
  spcirculation: 'Cirkulering',
  filetype_spcirculation: 'Cirkulering',
  spcirculationlist: 'Cirkuleringar',
  filetype_spcirculationlist: 'Cirkuleringar',
  spdashboardslibrarylist: 'Instrumentpanelbibliotek',
  filetype_spdashboardslibrarylist: 'Instrumentpanelbibliotek',
  spdataconnectionforperformancepointlibrarylist: 'Bibliotek med PerformancePoint-dataanslutning',
  filetype_spdataconnectionforperformancepointlibrarylist: 'Bibliotek med PerformancePoint-dataanslutning',
  sphealthreport: 'HÃ¤lsorapport',
  filetype_sphealthreport: 'HÃ¤lsorapport',
  sphealthreportlist: 'HÃ¤lsorapporter',
  filetype_sphealthreportlist: 'HÃ¤lsorapporter',
  sphealthrule: 'HÃ¤lsoregel',
  filetype_sphealthrule: 'HÃ¤lsoregel',
  sphealthrulelist: 'HÃ¤lsoregler',
  filetype_sphealthrulelist: 'HÃ¤lsoregler',
  spimedictionary: 'IME-ordlista',
  filetype_spimedictionary: 'IME-ordlista',
  spimedictionarylist: 'IME-ordlistor',
  filetype_spimedictionarylist: 'IME-ordlistor',
  spperformancepointcontent: 'PerformancePoint-innehÃ¥ll',
  filetype_spperformancepointcontent: 'PerformancePoint-innehÃ¥ll',
  spperformancepointcontentlist: 'PerformancePoint-innehÃ¥ll',
  filetype_spperformancepointcontentlist: 'PerformancePoint-innehÃ¥ll',
  spphonecallmemo: 'Minnesanteckning fÃ¶r telefonsamtal',
  filetype_spphonecallmemo: 'Minnesanteckning fÃ¶r telefonsamtal',
  spphonecallmemolist: 'Minnesanteckningar fÃ¶r telefonsamtal',
  filetype_spphonecallmemolist: 'Minnesanteckningar fÃ¶r telefonsamtal',
  sprecordlibrarylist: 'Postbibliotek',
  filetype_sprecordlibrarylist: 'Postbibliotek',
  spresource: 'Resurs',
  filetype_spresource: 'Resurs',
  spresourcelist: 'Resurser',
  filetype_spresourcelist: 'Resurser',
  spprocessdiagramslibrarylist: 'Bibliotek fÃ¶r processdiagram',
  filetype_spprocessdiagramslibrarylist: 'Bibliotek fÃ¶r processdiagram',
  spsitethemeslibrarylist: 'Bibliotek fÃ¶r sidtema',
  filetype_spsitethemeslibrarylist: 'Bibliotek fÃ¶r sidtema',
  spsolutionslibrarylist: 'Bibliotek fÃ¶r lÃ¶sningar',
  filetype_spsolutionslibrarylist: 'Bibliotek fÃ¶r lÃ¶sningar',
  spwfpublibrarylist: 'WFPUB-bibliotek',
  filetype_spwfpublibrarylist: 'WFPUB-bibliotek',
  spwhereabout: 'Vistelseplats',
  filetype_spwhereabout: 'Vistelseplats',
  spwhereaboutlist: 'Vistelseplatser',
  filetype_spwhereaboutlist: 'Vistelseplatser',
  spdocumentlink: 'LÃ¤nk till ett dokument',
  filetype_spdocumentlink: 'LÃ¤nk till ett dokument',
  spdocumentset: 'DokumentuppsÃ¤ttning',
  filetype_spdocumentset: 'DokumentuppsÃ¤ttning',
  spmicrofeedpost: 'MikrokanalinlÃ¤gg',
  filetype_spmicrofeedpost: 'MikrokanalinlÃ¤gg',
  spmicrofeedlist: 'Mikrokanal',
  filetype_spmicrofeedlist: 'Mikrokanal',
  splistfolder: 'Listmapp',
  filetype_splistfolder: 'Listmapp',
  Unknown: 'OkÃ¤nd',
  And: 'OCH',
  Authenticating: 'Autentiserar {0}â€¦',
  Clear: 'Rensa {0}',
  CompleteQuery: 'FullstÃ¤ndig fÃ¶rfrÃ¥gan',
  Exclude: 'Exkludera {0}',
  EnterTag: 'LÃ¤gg till etikett',
  Next: 'NÃ¤sta',
  Last: 'Sista',
  Link: 'LÃ¤nk',
  Or: 'ELLER',
  Previous: 'Tidigare',
  QueryDidntMatchAnyDocuments: 'Din fÃ¶rfrÃ¥gan matchade inte nÃ¥gra dokument',
  QueryException: 'Din fÃ¶rfrÃ¥gan har ett fel: {0}.',
  Me: 'Jag',
  Remove: 'Ta bort',
  Search: 'SÃ¶k',
  SearchFor: 'SÃ¶k efter {0}',
  ShareQuery: 'Dela FÃ¶rfrÃ¥gan',
  Preferences: 'Preferenser',
  LinkOpeningSettings: 'InstÃ¤llningar fÃ¶r Ã–ppnande av LÃ¤nk',
  Reauthenticate: 'Ã…terautentisera {0}',
  ResultsFilteringExpression: 'Uttryck Resultatfiltrering',
  FiltersInYourPreferences: 'Filtrerar bland dina preferenser',
  Create: 'Skapa',
  SearchIn: 'SÃ¶k i {0}',
  Seconds: 'I {0} sekund <pl>sekunder</pl>',
  ShowingResultsOf: 'Resultat<pl>en</pl> {0}<pl>-{1}</pl> av {2}',
  ShowingResultsOfWithQuery: 'Resultat<pl>en</pl> {0}<pl>-{1}</pl> av {2} fÃ¶r {3}',
  SwitchTo: 'Byt till {0}',
  Unexclude: 'Ta bort exkludering {0}',
  ClearAllFilters: 'Rensa Alla Filter',
  SkipLogin: 'Hoppa Ã–ver Inloggning',
  LoginInProgress: 'Inloggning sker, var god vÃ¤nta...',
  Login: 'Logga in',
  GetStarted: 'Kom igÃ¥ng',
  More: 'Mer',
  NMore: '{0} flerâ€¦',
  Less: 'FÃ¤rre',
  Settings: 'InstÃ¤llningar',
  Score: 'PoÃ¤ng',
  ScoreDescription: 'PoÃ¤ngen kalkyleras med antal fÃ¶rekomster sÃ¥vÃ¤l frÃ¥n positionen i den aktuella resultatuppsÃ¤ttningen',
  Occurrences: 'FÃ¶rekomster',
  OccurrencesDescription: 'Sortera genom antalet fÃ¶rekomster dÃ¤r hÃ¶gsta numret visas fÃ¶rst',
  Label: 'Etikett',
  Of: 'av',
  LabelDescription: 'Sortera alfabetiskt pÃ¥ fÃ¤ltvÃ¤rden',
  Value: 'VÃ¤rde',
  ValueDescription: 'Sortera pÃ¥ vÃ¤rdena pÃ¥ de fÃ¶rst utrÃ¤knade fÃ¤lten',
  AlphaAscending: 'VÃ¤rde stigande',
  AlphaDescending: 'VÃ¤rde sjunkande',
  ChiSquare: 'Chi-Ruta',
  Nosort: 'Ingen sort',
  NosortDescription: 'Sortera inte vÃ¤rdena. VÃ¤rdena returneras i slumpmÃ¤ssig ordning.',
  RelativeFrequency: 'Relativ frekvens',
  RelativeFrequencyDescription: 'Sortera baserat pÃ¥ relativa frekvensvÃ¤rden. Mindre vanliga vÃ¤rden kommer visas hÃ¶gre upp.',
  DateDistribution: 'Datumdistribution',
  Custom: 'InstÃ¤llning',
  CustomDescription: 'Sortera baserat pÃ¥ en instÃ¤lld order',
  ComputedField: 'Kalkylerat fÃ¤lt',
  Ascending: 'Stigande',
  Descending: 'Sjunkande',
  noResultFor: 'Inga resultat fÃ¶r {0}',
  autoCorrectedQueryTo: 'FÃ¶rfrÃ¥gan korrigerades automatiskt till {0}',
  didYouMean: 'Menade du: {0}',
  SuggestedResults: 'FÃ¶reslagna resultat',
  SuggestedQueries: 'FÃ¶reslagna fÃ¶rfrÃ¥gan',
  MostRelevantItems: 'Mest relevanta objekt:',
  AllItems: 'Alla objekt:',
  ShowLess: 'Visa mindre',
  ShowMore: 'Visa mer',
  HideFacet: 'GÃ¶m sida',
  ShowFacet: 'Visa sida',
  AndOthers: 'och {0} <sn>annan</sn><pl>andra</pl>',
  Others: '{0} <sn>annan</sn><pl>andra</pl>',
  MostRelevantPosts: 'Mest relevanta poster:',
  CompleteThread: 'FullstÃ¤ndig TrÃ¥d:',
  ShowCompleteThread: 'Visa FullstÃ¤ndig TrÃ¥d:',
  ShowOnlyTopMatchingPosts: 'Visa Endast Mest Matchande Poster',
  MostRelevantReplies: 'Mest Relevanta Svar:',
  AllConversation: 'Hel konversation:',
  ShowAllConversation: 'Visa Hel Konversation',
  ShowAllReplies: 'Visa Alla Svar',
  ShowOnlyMostRelevantReplies: 'Visa Endast Mest Relevanta Svar',
  Close: 'StÃ¤ng',
  Open: 'Ã–ppna',
  OpenInOutlookWhenPossible: 'Ã–ppna i Outlook (nÃ¤r det Ã¤r mÃ¶jligt)',
  AlwaysOpenInNewWindow: 'Ã–ppna alltid resultat i nytt fÃ¶nster',
  Quickview: 'Snabbvy',
  NoQuickview: 'Snabbvisningen fÃ¶r detta dokument finns inte',
  ErrorReport: 'Felrapport',
  OopsError: 'Det blev nÃ¥gonting fel pÃ¥ servern.',
  ProblemPersists: 'Om problemet fortgÃ¥r kontakta administratÃ¶r',
  GoBack: 'GÃ¥ tillbaka',
  Reset: 'Ã…terstÃ¤ll',
  Retry: 'FÃ¶rsÃ¶k igen',
  MoreInfo: 'Mer information',
  Username: 'AnvÃ¤ndarnamn',
  Password: 'LÃ¶senord',
  PostedBy: 'Upplagd av',
  CannotConnect: 'Kan inte koppla upp till serveradressen.',
  BadUserPass: 'LÃ¶senord matchar inte anvÃ¤ndarnamn.',
  PleaseEnterYourCredentials: 'Skriv in dina referenser fÃ¶r {0}',
  PleaseEnterYourSearchPage: 'VÃ¤nligen skriv in URL fÃ¶r din sÃ¶ksida',
  Collapse: 'Komprimera',
  Collapsable: 'Komprimerbar',
  Expand: 'Expandera',
  Today: 'Idag',
  Yesterday: 'IgÃ¥r',
  Tomorrow: 'Imorgon',
  Duration: 'Varaktighet: {0}',
  IndexDuration: 'Indexvaraktighet: {0}',
  ProxyDuration: 'Proxyvaraktighet: {0}',
  ClientDuration: 'Klientvaraktighet: {0}',
  Unavailable: 'OtillgÃ¤nglig',
  Reply: 'Svara',
  ReplyAll: 'Svara alla',
  Forward: 'FramÃ¥t',
  From: 'FrÃ¥n',
  Caption: 'Rubrik',
  Expression: 'Uttryck',
  Tab: 'Flik',
  Tabs: 'Flikar',
  EnterExpressionName: 'Skriv namn pÃ¥ uttryck',
  EnterExpressionToFilterWith: 'Skriv ett uttryck att filtrera resultat med',
  SelectTab: 'VÃ¤lj Flik',
  SelectAll: 'VÃ¤lj Alla',
  PageUrl: 'SÃ¶ksida URL',
  ErrorSavingToDevice: 'Fel nÃ¤r information sparades pÃ¥ din enhet',
  ErrorReadingFromDevice: 'Fel nÃ¤r information inlÃ¤stes frÃ¥n din enhet',
  AppIntro: 'Tala med en produktspecialist som kan svara pÃ¥ dina frÃ¥gor om Coveo och hjÃ¤lpa dig vÃ¤lja vilken CoveolÃ¶sning som passar dig. Eller, prova en live demo',
  TryDemo: 'Prova Demo',
  ContactUs: 'Kontakta oss.',
  NewToCoveo: 'Ny CoveoanvÃ¤ndare?',
  LetUsHelpGetStarted: 'LÃ¥t oss hjÃ¤lpa dig komma igÃ¥ng',
  LikesThis: '{0} Gillar denna.',
  CannotConnectSearchPage: 'Kan ej koppla upp till din sÃ¶ksida',
  AreYouSureDeleteFilter: 'Ã„r du sÃ¤ker pÃ¥ att vill radera filter{0} med uttryck {1}',
  OnlineHelp: 'OnlinehjÃ¤lp',
  Done: 'Klar',
  SaveFacetState: 'Spara sidotillstÃ¥nd',
  ClearFacetState: 'Rensa sidotillstÃ¥nd',
  DisplayingTheOnlyMessage: 'Visar det enda meddelandet i denna konversation',
  NoNetworkConnection: 'Ingen nÃ¤tverksuppkoppling',
  UnknownConnection: 'OkÃ¤nd uppkoppling',
  EthernetConnection: 'Ethernet-uppkoppling',
  WiFi: 'WiFi- uppkoppling',
  CELL: 'Mobil-uppkoppling',
  CELL_2G: 'Mobil 2G-uppkoppling',
  CELL_3G: 'Mobil 3G-uppkoppling',
  CELL_4G: 'Mobil 4G-uppkoppling',
  Relevance: 'Relevans',
  Date: 'Datum',
  Amount: 'MÃ¤ngd',
  QueryExceptionNoException: 'Inget undantag',
  QueryExceptionInvalidSyntax: 'Ogiltig syntax',
  QueryExceptionInvalidCustomField: 'Ogiltigt instÃ¤llt fÃ¤lt',
  QueryExceptionInvalidDate: 'Ogiltigt datum',
  QueryExceptionInvalidExactPhrase: 'Ogiltigt exakt fras',
  QueryExceptionInvalidDateOp: 'Ogiltig datumoperatÃ¶r',
  QueryExceptionInvalidNear: 'Ogiltig NÃ„R-operatÃ¶r',
  QueryExceptionInvalidWeightedNear: 'Ogiltig vÃ¤gd NÃ„R',
  QueryExceptionInvalidTerm: 'Ogiltig term',
  QueryExceptionTooManyTerms: 'FÃ¶r mÃ¥nga termer',
  QueryExceptionWildcardTooGeneral: 'Vildkort fÃ¶r omfattande',
  QueryExceptionInvalidSortField: 'Ogiltigt sorteringsfÃ¤lt',
  QueryExceptionInvalidSmallStringOp: 'Ogiltig Liten StringoperatÃ¶r',
  QueryExceptionRequestedResultsMax: 'BegÃ¤rt resultat Maximum',
  QueryExceptionAggregatedMirrorDead: 'FjÃ¤rrindexkopia Ã¤r offline',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'FjÃ¤rrindexkopia fÃ¶rfrÃ¥gan tidsgrÃ¤ns gÃ¥tt ut',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'FjÃ¤rrindexkopia ogiltigt byggnummer',
  QueryExceptionAggregatedMirrorCannotConnect: 'FjÃ¤rrindexkopia kan ej koppla upp',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Inte tillrÃ¤ckligt ledande karaktÃ¤r vildkort',
  QueryExceptionSecurityInverterNotFound: 'SÃ¤kerhetsinverterare ej funnen',
  QueryExceptionSecurityInverterAccessDenied: 'SÃ¤kerhetsinverterare Ã¥tkomst nekad',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'FjÃ¤rrindexkopia kan ej behandla fÃ¶rfrÃ¥gan fÃ¶r anvÃ¤ndare',
  QueryExceptionUnexpected: 'OvÃ¤ntad',
  QueryExceptionAccessDenied: 'Ã…tkomst nekad',
  QueryExceptionSuperUserTokenInvalid: 'SuperanvÃ¤ndarlÃ¶sen ogiltig',
  QueryExceptionSuperUserTokenExpired: 'SuperanvÃ¤ndarlÃ¶sen har gÃ¥tt ut',
  QueryExceptionLicenseQueriesExpired: 'Licensen fÃ¶r fÃ¶rfrÃ¥gan har gÃ¥tt ut',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'Licens superanvÃ¤ndarlÃ¶sen stÃ¶ds ej',
  QueryExceptionInvalidSession: 'Ogiltig session',
  QueryExceptionInvalidDocument: 'Ogiltigt dokument',
  QueryExceptionSearchDisabled: 'SÃ¶kning inaktiverad',
  FileType: 'Filtyp',
  ShowAttachment: 'Visa bilaga',
  OnFeed: 'pÃ¥ {0}Â´s feed',
  Author: 'FÃ¶rfattare',
  NoTitle: 'Ingen Titel',
  CurrentSelections: 'Aktuella val',
  AllContent: 'Allt innehÃ¥ll',
  CancelLastAction: 'Avbryt senaste Ã¥tgÃ¤rd',
  SearchTips: 'SÃ¶ktips',
  CheckSpelling: 'Kontrollera stavningen pÃ¥ dina nyckelord',
  TryUsingFewerKeywords: 'FÃ¶rsÃ¶k att anvÃ¤nda fÃ¤rre, annorlunda eller mer generella nyckelord',
  SelectFewerFilters: 'VÃ¤lj fÃ¤rre filter fÃ¶r att bredda din sÃ¶kning.',
  Document: 'Dokument',
  Time: 'Tid',
  StartDate: 'Startdatum',
  StartTime: 'Starttid',
  DurationTitle: 'Varaktighet',
  UserQuery: 'AnvÃ¤ndarfrÃ¥ga',
  ShowUserActions: 'Visa anvÃ¤ndarÃ¥tgÃ¤rder',
  NoData: 'Ingen tillgÃ¤ngig data',
  EventType: 'HÃ¤ndelsetyp',
  GoToFullSearch: 'FullstÃ¤ndig sÃ¶kning',
  GoToEdition: 'Anpassa panel',
  RemoveContext: 'Ta bort sammanhang',
  BoxAttachToCase: 'Bifoga till kundcase',
  AttachToCase: 'Bifoga till kundcase',
  Attach: 'Bifoga',
  Attached: 'Bifogat',
  Detach: 'Ta bort',
  Details: 'Detaljer',
  AdditionalFilters: 'Ytterligare filter',
  SelectNonContextualSearch: 'Ta bort sammanhanget frÃ¥n aktuell post fÃ¶r att bredda din sÃ¶kning',
  CopyPasteToSupport: 'Kopiera och klistra in detta meddelande till Coveo-supportteam fÃ¶r mer information.',
  FollowQueryDescription: 'Varna mig fÃ¶r Ã¤ndringar i sÃ¶kresultaten fÃ¶r denna frÃ¥ga.',
  SearchAlerts_Panel: 'Hantera varningar',
  SearchAlerts_PanelDescription: 'Visa och hantera dina sÃ¶kresultatsvarningar.',
  SearchAlerts_PanelNoSearchAlerts: 'Du har inga prenumerationer.',
  SearchAlerts_Fail: 'TjÃ¤nsten fÃ¶r sÃ¶kvarningarna finns fÃ¶r tillfÃ¤llet inte.',
  SearchAlerts_Type: 'Typ',
  SearchAlerts_Content: 'InnehÃ¥ll',
  SearchAlerts_Actions: 'Ã…tgÃ¤rd',
  EmptyQuery: '<tom>',
  SearchAlerts_Type_followQuery: 'FrÃ¥ga',
  SearchAlerts_Type_followDocument: 'Artikel',
  SearchAlerts_unFollowing: 'Sluta fÃ¶lja',
  SearchAlerts_follow: 'FÃ¶lja',
  SearchAlerts_followed: 'FÃ¶ljd',
  SearchAlerts_followQuery: 'FÃ¶lj frÃ¥ga',
  Subscription_StopFollowingQuery: 'Sluta fÃ¶lja frÃ¥ga',
  SearchAlerts_Frequency: 'NÃ¤r',
  SubscriptionsManageSubscriptions: 'Hantera varningar',
  SubscriptionsMessageFollowQuery: 'Du fÃ¥r varningar nÃ¤r frÃ¥gan <b>{0}</b> returnerar nya eller uppdaterade artiklar.',
  SubscriptionsMessageFollow: 'Du fÃ¥r varningar fÃ¶r Ã¤ndringar till artikeln <b>{0}</b>.',
  Expiration: 'UtgÃ¥ngstid',
  Monthly: 'MÃ¥nadsvis',
  Daily: 'Dagligen',
  Monday: 'MÃ¥ndag',
  Tuesday: 'Tisdag',
  Wednesday: 'Onsdag',
  Thursday: 'Torsdag',
  Friday: 'Fredag',
  Saturday: 'LÃ¶rdag',
  Sunday: 'LÃ¶rdag',
  NextDay: 'NÃ¤sta {0}',
  LastDay: 'Sista {0}',
  StartTypingCaseForSuggestions: 'Beskriv ditt problem fÃ¶r att se mÃ¶jliga lÃ¶sningar',
  ExportToExcel: 'Exportera till Excel',
  ExportToExcelDescription: 'Exportera sÃ¶kresultat till Excel',
  CaseCreationNoResults: 'Inga rekommenderade lÃ¶sningar hittades',
  SortBy: 'Sortera efter',
  BoxCreateArticle: 'Skapa artikel',
  Facets: 'Fasetter',
  AdvancedSearch: 'Avancerad sÃ¶kning',
  Keywords: 'Nyckelord',
  AllTheseWords: 'Alla dessa ord',
  ExactPhrase: 'Denna exakta fras',
  AnyOfTheseWords: 'NÃ¥got av dessa ord',
  NoneOfTheseWords: 'Inga av dessa ord',
  Anytime: 'NÃ¤r som helst',
  InTheLast: 'I den senaste',
  Days: 'dagar',
  Months: 'mÃ¥nader',
  Month: 'MÃ¥nad',
  Year: 'Ã…r',
  Between: 'Mellan',
  Language: 'SprÃ¥k',
  Size: 'Storlek',
  AtLeast: 'som mest',
  AtMost: 'som minst',
  Contains: 'innehÃ¥ller',
  DoesNotContain: 'innehÃ¥ller inte',
  Matches: 'matchningar',
  Bytes: 'bytes',
  card: 'Kort',
  table: 'Tabell',
  ResultLinks: 'ResultatlÃ¤nkar',
  EnableQuerySyntax: 'Aktivera frÃ¥ge-syntax',
  On: 'PÃ¥',
  Off: 'Av',
  Automatic: 'Automatik',
  ResultsPerPage: 'Resultat per sida',
  PreviousMonth: 'FÃ¶regÃ¥ende mÃ¥nad',
  NextMonth: 'NÃ¤sta mÃ¥nad',
  Title: 'Titel',
  TRFilters: 'Filters'
};

// eslint-disable-next-line import/no-anonymous-default-export
var pl = {
  'box user': 'UÅ¼ytkownik',
  'filetype_box user': 'UÅ¼ytkownik',
  html: 'Plik HTML',
  filetype_html: 'Plik HTML',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Strona sieci Web',
  filetype_webscraperwebpage: 'Strona sieci Web',
  image: 'Obraz',
  filetype_image: 'Obraz',
  folder: 'Folder',
  filetype_folder: 'Folder',
  txt: 'Plik tekstowy',
  filetype_txt: 'Plik tekstowy',
  zip: 'Plik zip',
  filetype_zip: 'Plik zip',
  olefile: 'Plik OLE',
  filetype_olefile: 'Plik OLE',
  gmailmessage: 'WiadomoÅ›Ä‡ Gmail',
  filetype_gmailmessage: 'WiadomoÅ›Ä‡ Gmail',
  pdf: 'Plik PDF',
  filetype_pdf: 'Plik PDF',
  swf: 'Plik Flash',
  filetype_swf: 'Plik Flash',
  xml: 'Plik XML',
  filetype_xml: 'Plik XML',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'Å¹rÃ³dÅ‚o danych RSS',
  filetype_rssitem: 'Å¹rÃ³dÅ‚o danych RSS',
  doc: 'Dokument',
  filetype_doc: 'Dokument',
  docx: 'Dokument Microsoft Word',
  filetype_docx: 'Dokument Microsoft Word',
  xls: 'Arkusz kalkulacyjny',
  filetype_xls: 'Arkusz kalkulacyjny',
  ppt: 'Prezentacja',
  filetype_ppt: 'Prezentacja',
  video: 'Wideo',
  filetype_video: 'Wideo',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Dokument Open Text',
  filetype_odt: 'Dokument Open Text',
  lithiummessage: 'WiadomoÅ›Ä‡ Lithium',
  filetype_lithiummessage: 'WiadomoÅ›Ä‡ Lithium',
  lithiumthread: 'WÄ…tek Lithium',
  filetype_lithiumthread: 'WÄ…tek Lithium',
  lithiumboard: 'Tablica Lithium',
  filetype_lithiumboard: 'Tablica Lithium',
  lithiumcategory: 'Kategoria Lithium',
  filetype_lithiumcategory: 'Kategoria Lithium',
  lithiumcommunity: 'SpoÅ‚ecznoÅ›Ä‡ Lithium',
  filetype_lithiumcommunity: 'SpoÅ‚ecznoÅ›Ä‡ Lithium',
  people: 'UÅ¼ytkownik',
  objecttype_people: 'UÅ¼ytkownik',
  message: 'WiadomoÅ›Ä‡',
  objecttype_message: 'WiadomoÅ›Ä‡',
  feed: 'Å¹rÃ³dÅ‚o danych RSS',
  objecttype_feed: 'Å¹rÃ³dÅ‚o danych RSS',
  thread: 'WÄ…tek',
  objecttype_thread: 'WÄ…tek',
  file: 'Plik',
  objecttype_file: 'Plik',
  board: 'Tablica',
  objecttype_board: 'Tablica',
  category: 'Kategoria',
  objecttype_category: 'Kategoria',
  account: 'Konto',
  objecttype_account: 'Konto',
  annotation: 'Uwaga',
  objecttype_annotation: 'Uwaga',
  campaign: 'Kampania',
  objecttype_campaign: 'Kampania',
  "case": 'Sprawa',
  objecttype_case: 'Sprawa',
  contact: 'Kontakt',
  objecttype_contact: 'Kontakt',
  contract: 'Umowa',
  objecttype_contract: 'Umowa',
  event: 'Zdarzenie',
  objecttype_event: 'Zdarzenie',
  email: 'WiadomoÅ›Ä‡ e-mail',
  objecttype_email: 'WiadomoÅ›Ä‡ e-mail',
  goal: 'Cel',
  objecttype_goal: 'Cel',
  objecttype_incident: 'Sprawa',
  invoice: 'Faktura',
  objecttype_invoice: 'Faktura',
  lead: 'Potencjalny klient',
  objecttype_lead: 'Potencjalny klient',
  list: 'Lista',
  objecttype_list: 'Lista marketingowa',
  solution: 'RozwiÄ…zanie',
  objecttype_solution: 'RozwiÄ…zanie',
  task: 'Zadanie',
  objecttype_task: 'Zadanie',
  user: 'UÅ¼ytkownik',
  objecttype_user: 'UÅ¼ytkownik',
  attachment: 'ZaÅ‚Ä…cznik',
  objecttype_attachment: 'ZaÅ‚Ä…cznik',
  casecomment: 'Komentarz do sprawy',
  objecttype_casecomment: 'Komentarz do sprawy',
  opportunity: 'MoÅ¼liwoÅ›Ä‡',
  objecttype_opportunity: 'MoÅ¼liwoÅ›Ä‡',
  opportunityproduct: 'Produkt moÅ¼liwoÅ›ci',
  objecttype_opportunityproduct: 'Produkt moÅ¼liwoÅ›ci',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Rozmowa',
  objecttype_feedcomment: 'Rozmowa',
  note: 'Uwaga',
  objecttype_note: 'Uwaga',
  product: 'Produkt',
  objecttype_product: 'Produkt',
  partner: 'Partner',
  objecttype_partner: 'Partner',
  queueitem: 'Pozycja kolejki',
  objecttype_queueitem: 'Pozycja kolejki',
  quote: 'Oferta',
  objecttype_quote: 'Oferta',
  salesliterature: 'Literatura sprzedaÅ¼owa',
  objecttype_salesliterature: 'Literatura sprzedaÅ¼owa',
  salesorder: 'ZamÃ³wienie sprzedaÅ¼y',
  objecttype_salesorder: 'ZamÃ³wienie sprzedaÅ¼y',
  service: 'UsÅ‚uga',
  objecttype_service: 'UsÅ‚uga',
  socialprofile: 'Profil spoÅ‚eczny',
  objecttype_socialprofile: 'Profil spoÅ‚eczny',
  kbdocumentation: 'Dokumentacja',
  objecttype_kbdocumentation: 'Dokumentacja',
  kbtechnicalarticle: 'Dokumentacja',
  objecttype_kbtechnicalarticle: 'Dokumentacja',
  kbsolution: 'RozwiÄ…zanie',
  objecttype_kbsolution: 'RozwiÄ…zanie',
  kbknowledgearticle: 'ArtykuÅ‚ w bazie wiedzy',
  objecttype_kbknowledgearticle: 'ArtykuÅ‚ w bazie wiedzy',
  kbattachment: 'ZaÅ‚Ä…cznik',
  objecttype_kbattachment: 'ZaÅ‚Ä…cznik',
  kbarticle: 'ArtykuÅ‚',
  objecttype_kbarticle: 'ArtykuÅ‚',
  kbarticlecomment: 'Komentarz do artykuÅ‚u',
  objecttype_kbarticlecomment: 'Komentarz do artykuÅ‚u',
  knowledgearticle: 'ArtykuÅ‚ w bazie wiedzy',
  objecttype_knowledgearticle: 'ArtykuÅ‚ w bazie wiedzy',
  topic: 'Temat',
  objecttype_topic: 'Temat',
  dashboard: 'Pulpit',
  objecttype_dashboard: 'Pulpit',
  contentversion: 'Dokument',
  objecttype_contentversion: 'Dokument',
  collaborationgroup: 'Grupa wspÃ³Å‚pracy',
  objecttype_collaborationgroup: 'Grupa wspÃ³Å‚pracy',
  spportal: 'Portal',
  filetype_spportal: 'Portal',
  spsite: 'Witryna',
  filetype_spsite: 'Witryna',
  spuserprofile: 'UÅ¼ytkownik SharePoint',
  filetype_spuserprofile: 'UÅ¼ytkownik SharePoint',
  sparea: 'Obszar',
  filetype_sparea: 'Obszar',
  spannouncement: 'OgÅ‚oszenie',
  filetype_spannouncement: 'OgÅ‚oszenie',
  spannouncementlist: 'OgÅ‚oszenia',
  filetype_spannouncementlist: 'OgÅ‚oszenia',
  spcontact: 'Kontakt',
  filetype_spcontact: 'Kontakt',
  spcontactlist: 'Kontakty',
  filetype_spcontactlist: 'Kontakty',
  spcustomlist: 'Niestandardowe listy',
  filetype_spcustomlist: 'Niestandardowe listy',
  spdiscussionboard: 'Tablica dyskusyjna',
  filetype_spdiscussionboard: 'Tablica dyskusyjna',
  spdiscussionboardlist: 'Tablice dyskusyjne',
  filetype_spdiscussionboardlist: 'Tablice dyskusyjne',
  spdocumentlibrarylist: 'Biblioteka dokumentÃ³w',
  filetype_spdocumentlibrarylist: 'Biblioteka dokumentÃ³w',
  spevent: 'Zdarzenie',
  filetype_spevent: 'Zdarzenie',
  speventlist: 'Zdarzenia',
  filetype_speventlist: 'Zdarzenia',
  spformlibrarylist: 'Biblioteka formularzy',
  filetype_spformlibrarylist: 'Biblioteka formularzy',
  spissue: 'Problem',
  filetype_spissue: 'Problem',
  spissuelist: 'Problemy',
  filetype_spissuelist: 'Problemy',
  splink: 'ÅÄ…cze',
  filetype_splink: 'ÅÄ…cze',
  splinklist: 'ÅÄ…cza',
  filetype_splinklist: 'ÅÄ…cza',
  sppicturelibrarylist: 'Biblioteka obrazÃ³w',
  filetype_sppicturelibrarylist: 'Biblioteka obrazÃ³w',
  spsurvey: 'Ankieta',
  filetype_spsurvey: 'Ankieta',
  spsurveylist: 'Ankiety',
  filetype_spsurveylist: 'Ankiety',
  sptask: 'Zadanie',
  filetype_sptask: 'Zadanie',
  sptasklist: 'Zadania',
  filetype_sptasklist: 'Zadania',
  spagenda: 'Plan spotkania',
  filetype_spagenda: 'Plan spotkania',
  spagendalist: 'Plany spotkania',
  filetype_spagendalist: 'Plany spotkania',
  spattendee: 'Uczestnik',
  filetype_spattendee: 'Uczestnik',
  spattendeelist: 'Uczestnicy',
  filetype_spattendeelist: 'Uczestnicy',
  spcustomgridlist: 'Niestandardowe siatki',
  filetype_spcustomgridlist: 'Niestandardowe siatki',
  spdecision: 'Decyzja',
  filetype_spdecision: 'Decyzja',
  spdecisionlist: 'Decyzje',
  filetype_spdecisionlist: 'Decyzje',
  spobjective: 'Cel',
  filetype_spobjective: 'Cel',
  spobjectivelist: 'Cele',
  filetype_spobjectivelist: 'Cele',
  sptextbox: 'Pole tekstowe',
  filetype_sptextbox: 'Pole tekstowe',
  sptextboxlist: 'Pola tekstowe',
  filetype_sptextboxlist: 'Pola tekstowe',
  spthingstobring: 'Rzecz do przyniesienia',
  filetype_spthingstobring: 'Rzecz do przyniesienia',
  spthingstobringlist: 'Rzeczy do przyniesienia',
  filetype_spthingstobringlist: 'Rzeczy do przyniesienia',
  sparealisting: 'Lista obszaru',
  filetype_sparealisting: 'Lista obszaru',
  spmeetingserie: 'Seria spotkaÅ„',
  filetype_spmeetingserie: 'Seria spotkaÅ„',
  spmeetingserielist: 'Lista serii spotkaÅ„',
  filetype_spmeetingserielist: 'Lista serii spotkaÅ„',
  spsitedirectory: 'Pozycja katalogu witryny',
  filetype_spsitedirectory: 'Pozycja katalogu witryny',
  spsitedirectorylist: 'Katalog witryny',
  filetype_spsitedirectorylist: 'Katalog witryny',
  spdatasource: 'Å¹rÃ³dÅ‚o danych',
  filetype_spdatasource: 'Å¹rÃ³dÅ‚o danych',
  spdatasourcelist: 'Lista ÅºrÃ³deÅ‚ danych',
  filetype_spdatasourcelist: 'Lista ÅºrÃ³deÅ‚ danych',
  splisttemplatecataloglist: 'Galeria szablonÃ³w listy',
  filetype_splisttemplatecataloglist: 'Galeria szablonÃ³w listy',
  spwebpartcataloglist: 'Galeria skÅ‚adnikÃ³w WebPart',
  filetype_spwebpartcataloglist: 'Galeria skÅ‚adnikÃ³w WebPart',
  spwebtemplatecataloglist: 'Galeria szablonÃ³w witryny',
  filetype_spwebtemplatecataloglist: 'Galeria szablonÃ³w witryny',
  spworkspacepagelist: 'Strony obszarÃ³w roboczych',
  filetype_spworkspacepagelist: 'Strony obszarÃ³w roboczych',
  spunknownlist: 'Niestandardowa lista',
  filetype_spunknownlist: 'Niestandardowa lista',
  spadministratortask: 'Zadanie administratora',
  filetype_spadministratortask: 'Zadanie administratora',
  spadministratortasklist: 'Zadania administratora',
  filetype_spadministratortasklist: 'Zadania administratora',
  spareadocumentlibrarylist: 'Biblioteka dokumentÃ³w obszaru',
  filetype_spareadocumentlibrarylist: 'Biblioteka dokumentÃ³w obszaru',
  spblogcategory: 'Kategoria blogu',
  filetype_spblogcategory: 'Kategoria blogu',
  spblogcategorylist: 'Kategorie blogu',
  filetype_spblogcategorylist: 'Kategorie blogu',
  spblogcomment: 'Komentarz do blogu',
  filetype_spblogcomment: 'Komentarz do blogu',
  spblogcommentlist: 'Komentarze do blogu',
  filetype_spblogcommentlist: 'Komentarze do blogu',
  spblogpost: 'Wpis blogu',
  filetype_spblogpost: 'Wpis blogu',
  spblogpostlist: 'Wpisy blogu',
  filetype_spblogpostlist: 'Wpisy blogu',
  spdataconnectionlibrarylist: 'Biblioteka poÅ‚Ä…czeÅ„ danych',
  filetype_spdataconnectionlibrarylist: 'Biblioteka poÅ‚Ä…czeÅ„ danych',
  spdistributiongroup: 'Grupa dystrybucyjna',
  filetype_spdistributiongroup: 'Grupa dystrybucyjna',
  spdistributiongrouplist: 'Grupy dystrybucyjne',
  filetype_spdistributiongrouplist: 'Grupy dystrybucyjne',
  spipfslist: 'Serwery formularzy InfoPath',
  filetype_spipfslist: 'Serwery formularzy InfoPath',
  spkeyperformanceindicator: 'Kluczowy wskaÅºnik efektywnoÅ›ci',
  filetype_spkeyperformanceindicator: 'Kluczowy wskaÅºnik efektywnoÅ›ci',
  spkeyperformanceindicatorlist: 'Kluczowe wskaÅºniki efektywnoÅ›ci',
  filetype_spkeyperformanceindicatorlist: 'Kluczowe wskaÅºniki efektywnoÅ›ci',
  splanguagesandtranslator: 'JÄ™zyki i tÅ‚umacz',
  filetype_splanguagesandtranslator: 'JÄ™zyki i tÅ‚umacz',
  splanguagesandtranslatorlist: 'JÄ™zyki i tÅ‚umacze',
  filetype_splanguagesandtranslatorlist: 'JÄ™zyki i tÅ‚umacze',
  spmasterpagescataloglist: 'Galeria stron gÅ‚Ã³wnych',
  filetype_spmasterpagescataloglist: 'Galeria stron gÅ‚Ã³wnych',
  spnocodeworkflowlibrarylist: 'Biblioteki przepÅ‚ywÃ³w pracy bez kodu',
  filetype_spnocodeworkflowlibrarylist: 'Biblioteki przepÅ‚ywÃ³w pracy bez kodu',
  spprojecttask: 'Zadanie projektu',
  filetype_spprojecttask: 'Zadanie projektu',
  spprojecttasklist: 'Zadania projektu',
  filetype_spprojecttasklist: 'Zadania projektu',
  sppublishingpageslibrarylist: 'Biblioteka stron',
  filetype_sppublishingpageslibrarylist: 'Biblioteka stron',
  spreportdocumentlibrarylist: 'Biblioteka dokumentÃ³w raportÃ³w',
  filetype_spreportdocumentlibrarylist: 'Biblioteka dokumentÃ³w raportÃ³w',
  spreportlibrarylist: 'Biblioteka raportÃ³w',
  filetype_spreportlibrarylist: 'Biblioteka raportÃ³w',
  spslidelibrarylist: 'Biblioteka slajdÃ³w',
  filetype_spslidelibrarylist: 'Biblioteka slajdÃ³w',
  sptab: 'Karty',
  filetype_sptab: 'Karty',
  sptablist: 'Lista kart',
  filetype_sptablist: 'Lista kart',
  sptranslationmanagementlibrarylist: 'Biblioteka zarzÄ…dzania tÅ‚umaczeniami',
  filetype_sptranslationmanagementlibrarylist: 'Biblioteka zarzÄ…dzania tÅ‚umaczeniami',
  spuserinformation: 'Informacje o uÅ¼ytkowniku',
  filetype_spuserinformation: 'Informacje o uÅ¼ytkowniku',
  spuserinformationlist: 'Lista informacji o uÅ¼ytkowniku',
  filetype_spuserinformationlist: 'Lista informacji o uÅ¼ytkowniku',
  spwikipagelibrarylist: 'Biblioteka stron Wiki',
  filetype_spwikipagelibrarylist: 'Biblioteka stron Wiki',
  spworkflowhistory: 'Historia przepÅ‚ywu pracy',
  filetype_spworkflowhistory: 'Historia przepÅ‚ywu pracy',
  spworkflowhistorylist: 'Lista historii przepÅ‚ywu pracy',
  filetype_spworkflowhistorylist: 'Lista historii przepÅ‚ywu pracy',
  spworkflowprocess: 'Proces niestandardowego przepÅ‚ywu pracy',
  filetype_spworkflowprocess: 'Proces niestandardowego przepÅ‚ywu pracy',
  spworkflowprocesslist: 'Procesy niestandardowego przepÅ‚ywu pracy',
  filetype_spworkflowprocesslist: 'Procesy niestandardowego przepÅ‚ywu pracy',
  sppublishingimageslibrarylist: 'Biblioteka obrazÃ³w do opublikowania',
  filetype_sppublishingimageslibrarylist: 'Biblioteka obrazÃ³w do opublikowania',
  spcirculation: 'Obieg',
  filetype_spcirculation: 'Obieg',
  spcirculationlist: 'Obiegi',
  filetype_spcirculationlist: 'Obiegi',
  spdashboardslibrarylist: 'Biblioteka pulpitÃ³w',
  filetype_spdashboardslibrarylist: 'Biblioteka pulpitÃ³w',
  spdataconnectionforperformancepointlibrarylist: 'Biblioteka poÅ‚Ä…czeÅ„ danych PerformancePoint',
  filetype_spdataconnectionforperformancepointlibrarylist: 'Biblioteka poÅ‚Ä…czeÅ„ danych PerformancePoint',
  sphealthreport: 'Raport zdrowia',
  filetype_sphealthreport: 'Raport zdrowia',
  sphealthreportlist: 'Raporty zdrowia',
  filetype_sphealthreportlist: 'Raporty zdrowia',
  sphealthrule: 'ReguÅ‚a zdrowia',
  filetype_sphealthrule: 'ReguÅ‚a zdrowia',
  sphealthrulelist: 'ReguÅ‚y zdrowia',
  filetype_sphealthrulelist: 'ReguÅ‚y zdrowia',
  spimedictionary: 'SÅ‚ownik IME',
  filetype_spimedictionary: 'SÅ‚ownik IME',
  spimedictionarylist: 'SÅ‚owniki IME',
  filetype_spimedictionarylist: 'SÅ‚owniki IME',
  spperformancepointcontent: 'ZawartoÅ›Ä‡ PerformancePoint',
  filetype_spperformancepointcontent: 'ZawartoÅ›Ä‡ PerformancePoint',
  spperformancepointcontentlist: 'ZawartoÅ›ci PerformancePoint',
  filetype_spperformancepointcontentlist: 'ZawartoÅ›ci PerformancePoint',
  spphonecallmemo: 'Nota dotyczÄ…ca poÅ‚Ä…czenia telefonicznego',
  filetype_spphonecallmemo: 'Nota dotyczÄ…ca poÅ‚Ä…czenia telefonicznego',
  spphonecallmemolist: 'Noty dotyczÄ…ce poÅ‚Ä…czenia telefonicznego',
  filetype_spphonecallmemolist: 'Noty dotyczÄ…ce poÅ‚Ä…czenia telefonicznego',
  sprecordlibrarylist: 'Biblioteka rekordÃ³w',
  filetype_sprecordlibrarylist: 'Biblioteka rekordÃ³w',
  spresource: 'ZasÃ³b',
  filetype_spresource: 'ZasÃ³b',
  spresourcelist: 'Zasoby',
  filetype_spresourcelist: 'Zasoby',
  spprocessdiagramslibrarylist: 'Biblioteka schematÃ³w procesu',
  filetype_spprocessdiagramslibrarylist: 'Biblioteka schematÃ³w procesu',
  spsitethemeslibrarylist: 'Biblioteka motywÃ³w witryny',
  filetype_spsitethemeslibrarylist: 'Biblioteka motywÃ³w witryny',
  spsolutionslibrarylist: 'Biblioteka rozwiÄ…zaÅ„',
  filetype_spsolutionslibrarylist: 'Biblioteka rozwiÄ…zaÅ„',
  spwfpublibrarylist: 'Biblioteka WFPUB',
  filetype_spwfpublibrarylist: 'Biblioteka WFPUB',
  spwhereabout: 'Lokalizacja',
  filetype_spwhereabout: 'Lokalizacja',
  spwhereaboutlist: 'Lokalizacje',
  filetype_spwhereaboutlist: 'Lokalizacje',
  spdocumentlink: 'ÅÄ…cze do dokumentu',
  filetype_spdocumentlink: 'ÅÄ…cze do dokumentu',
  spdocumentset: 'Zestaw dokumentÃ³w',
  filetype_spdocumentset: 'Zestaw dokumentÃ³w',
  spmicrofeedpost: 'Wpis mikrokanaÅ‚u informacyjnego',
  filetype_spmicrofeedpost: 'Wpis mikrokanaÅ‚u informacyjnego',
  spmicrofeedlist: 'MikrokanaÅ‚ informacyjny',
  filetype_spmicrofeedlist: 'MikrokanaÅ‚ informacyjny',
  splistfolder: 'Folder listy',
  filetype_splistfolder: 'Folder listy',
  Unknown: 'Nieznany',
  And: 'I',
  Authenticating: 'Trwa uwierzytelnianie uÅ¼ytkownika {0}...',
  Clear: 'WyczyÅ›Ä‡ {0}',
  CompleteQuery: 'CaÅ‚e zapytanie',
  Exclude: 'Wyklucz {0}',
  EnterTag: 'Dodaj znacznik',
  Next: 'NastÄ™pna',
  Last: 'Ostatnia',
  Link: 'ÅÄ…cze',
  Or: 'LUB',
  Previous: 'Poprzednia',
  QueryDidntMatchAnyDocuments: 'Å»aden dokument nie pasuje do zapytania.',
  QueryException: 'Zapytanie zawiera bÅ‚Ä…d: {0}.',
  Me: 'Ja',
  Remove: 'UsuÅ„',
  Search: 'Wyszukaj',
  SearchFor: 'Wyszukaj {0}',
  ShareQuery: 'UdostÄ™pnij zapytanie',
  Preferences: 'Preferencje',
  LinkOpeningSettings: 'Ustawienia dotyczÄ…ce otwierania Å‚Ä…czy',
  Reauthenticate: 'Ponownie uwierzytelnij uÅ¼ytkownika {0}',
  ResultsFilteringExpression: 'WyraÅ¼enia filtrowania wynikÃ³w',
  FiltersInYourPreferences: 'Filtry w preferencjach uÅ¼ytkownika',
  Create: 'UtwÃ³rz',
  SearchIn: 'Wyszukaj w {0}',
  Seconds: 'w {0} sekundÄ™<pl>(sekundy/sekund)</pl>',
  ShowingResultsOf: 'Wynik<pl>i</pl> {0}<pl>-{1}</pl> z {2}',
  ShowingResultsOfWithQuery: 'Wynik<pl>i</pl> {0}<pl>-{1}</pl> z {2} za {3}',
  SwitchTo: 'PrzeÅ‚Ä…cz na {0}',
  Unexclude: 'Cofnij wykluczenie {0}',
  ClearAllFilters: 'WyczyÅ›Ä‡ wszystkie filtry',
  SkipLogin: 'PomiÅ„ logowanie',
  LoginInProgress: 'Logowanie w toku, proszÄ™ czekaÄ‡...',
  Login: 'Zaloguj',
  GetStarted: 'Rozpocznij',
  More: 'WiÄ™cej',
  NMore: '{0} wiÄ™cej...',
  Less: 'Mniej',
  Settings: 'Ustawienia',
  Score: 'Punktacja',
  ScoreDescription: 'Punktacja jest obliczana na podstawie liczby wystÄ…pieÅ„ oraz pozycji w zestawie wynikÃ³w.',
  Occurrences: 'WystÄ…pienia',
  OccurrencesDescription: 'Sortuj wedÅ‚ug liczby wystÄ…pieÅ„, tak aby wartoÅ›ci o najwyÅ¼szej liczbie pojawiaÅ‚y siÄ™ jako pierwsze.',
  Label: 'Etykieta',
  Of: 'z',
  LabelDescription: 'Sortuj alfabetycznie wedÅ‚ug wartoÅ›ci pÃ³l.',
  Value: 'WartoÅ›Ä‡',
  ValueDescription: 'Sortuj wedÅ‚ug wartoÅ›ci pierwszego obliczonego pola',
  AlphaAscending: 'WartoÅ›Ä‡ rosnÄ…co',
  AlphaDescending: 'WartoÅ›Ä‡ malejÄ…co',
  ChiSquare: 'Chi-kwadrat',
  Nosort: 'Bez sortowania',
  NosortDescription: 'Nie sortuj wartoÅ›ci. Te wartoÅ›ci zostanÄ… zwrÃ³cone w kolejnoÅ›ci losowej.',
  RelativeFrequency: 'CzÄ™stotliwoÅ›Ä‡ wzglÄ™dna',
  RelativeFrequencyDescription: 'Sortuj wedÅ‚ug wzglÄ™dnej czÄ™stotliwoÅ›ci wystÄ™powania wartoÅ›ci. Mniej rozpowszechnione wartoÅ›ci bÄ™dÄ… pojawiaÅ‚y siÄ™ wyÅ¼ej.',
  DateDistribution: 'RozÅ‚oÅ¼enie dat',
  Custom: 'Niestandardowe',
  CustomDescription: 'Sortuj wedÅ‚ug niestandardowej kolejnoÅ›ci',
  ComputedField: 'Pole obliczane',
  Ascending: 'RosnÄ…co',
  Descending: 'MalejÄ…co',
  noResultFor: 'Brak wynikÃ³w dla zapytania {0}',
  autoCorrectedQueryTo: 'Zapytanie zostaÅ‚o automatycznie poprawione na {0}',
  didYouMean: 'Czy chodziÅ‚o Ci o: {0}',
  SuggestedResults: 'Sugerowane wyniki',
  SuggestedQueries: 'Sugerowane zapytania',
  MostRelevantItems: 'Najbardziej trafne elementy:',
  AllItems: 'Wszystkie elementy:',
  ShowLess: 'PokaÅ¼ mniej',
  ShowMore: 'PokaÅ¼ wiÄ™cej',
  HideFacet: 'Ukryj Aspekt',
  ShowFacet: 'PokaÅ¼ Aspekt',
  AndOthers: 'i {0} pozostaÅ‚y<pl>(pozostaÅ‚e/pozostaÅ‚ych)</pl>',
  Others: '{0} pozostaÅ‚y<pl>(pozostaÅ‚e/pozostaÅ‚ych)</pl>',
  MostRelevantPosts: 'Najbardziej trafne wpisy:',
  CompleteThread: 'CaÅ‚y wÄ…tek:',
  ShowCompleteThread: 'PokaÅ¼ caÅ‚y wÄ…tek',
  ShowOnlyTopMatchingPosts: 'PokaÅ¼ tylko wpisy o najwyÅ¼szej zgodnoÅ›ci',
  MostRelevantReplies: 'Najbardziej trafne odpowiedzi:',
  AllConversation: 'CaÅ‚a rozmowa:',
  ShowAllConversation: 'PokaÅ¼ caÅ‚Ä… rozmowÄ™',
  ShowAllReplies: 'PokaÅ¼ wszystkie odpowiedzi',
  ShowOnlyMostRelevantReplies: 'PokaÅ¼ tylko najbardziej trafne odpowiedzi',
  Close: 'Zamknij',
  Open: 'OtwÃ³rz',
  OpenInOutlookWhenPossible: 'OtwÃ³rz w programie Outlook (o ile to moÅ¼liwe)',
  AlwaysOpenInNewWindow: 'Zawsze otwieraj wyniki w nowym oknie',
  Quickview: 'Szybki podglÄ…d',
  NoQuickview: 'Szybki podglÄ…d nie jest dostÄ™pny dla tego dokumentu',
  ErrorReport: 'Raport o bÅ‚Ä™dach',
  OopsError: 'WystÄ…piÅ‚ problem dotyczÄ…cy serwera.',
  ProblemPersists: 'JeÅ›li ten problem bÄ™dzie siÄ™ powtarzaÄ‡, skontaktuj siÄ™ z administratorem.',
  GoBack: 'PowrÃ³t',
  Reset: 'Resetuj',
  Retry: 'SprÃ³buj ponownie',
  MoreInfo: 'WiÄ™cej informacji',
  Username: 'Nazwa uÅ¼ytkownika',
  Password: 'HasÅ‚o',
  PostedBy: 'OpublikowaÅ‚ uÅ¼ytkownik',
  CannotConnect: 'Nie moÅ¼na nawiÄ…zaÄ‡ poÅ‚Ä…czenia z adresem serwera.',
  BadUserPass: 'HasÅ‚o nie pasuje do nazwy uÅ¼ytkownika.',
  PleaseEnterYourCredentials: 'ProszÄ™ wpisaÄ‡ poÅ›wiadczenia dla systemu {0}.',
  PleaseEnterYourSearchPage: 'ProszÄ™ wpisaÄ‡ adres URL strony wyszukiwania',
  Collapse: 'ZwiÅ„',
  Collapsable: 'Zwijany',
  Expand: 'RozwiÅ„',
  Today: 'Dzisiaj',
  Yesterday: 'Wczoraj',
  Tomorrow: 'Jutro',
  Duration: 'Czas trwania: {0}',
  IndexDuration: 'Czas trwania indeksu: {0}',
  ProxyDuration: 'Czas trwania serwera proxy: {0}',
  ClientDuration: 'Czas trwania klienta: {0}',
  Unavailable: 'NiedostÄ™pny',
  Reply: 'Odpowiedz',
  ReplyAll: 'Odpowiedz wszystkim',
  Forward: 'PrzeÅ›lij dalej',
  From: 'Od',
  Caption: 'Podpis',
  Expression: 'WyraÅ¼enie',
  Tab: 'Karta',
  Tabs: 'Karty',
  EnterExpressionName: 'WprowadÅº nazwÄ™ wyraÅ¼enia',
  EnterExpressionToFilterWith: 'WprowadÅº wyraÅ¼enie do filtrowania wynikÃ³w',
  SelectTab: 'Zaznacz kartÄ™',
  SelectAll: 'Zaznacz wszystko',
  PageUrl: 'Adres URL strony wyszukiwania',
  ErrorSavingToDevice: 'Podczas zapisywania informacji na urzÄ…dzeniu wystÄ…piÅ‚ bÅ‚Ä…d',
  ErrorReadingFromDevice: 'Podczas odczytu informacji z urzÄ…dzenia wystÄ…piÅ‚ bÅ‚Ä…d',
  AppIntro: 'Skontaktuj siÄ™ ze specjalistÄ… ds. produktÃ³w, ktÃ³ry odpowie na pytania dotyczÄ…ce Coveo i pomoÅ¼e Ci w wyborze odpowiedniego rozwiÄ…zania Coveo. MoÅ¼esz teÅ¼ wyprÃ³bowaÄ‡ interaktywne demo!',
  TryDemo: 'WyprÃ³buj demo',
  ContactUs: 'Skontaktuj siÄ™ z nami',
  NewToCoveo: 'Jeszcze nie znasz Coveo?',
  LetUsHelpGetStarted: 'PomoÅ¼emy Ci zaczÄ…Ä‡',
  LikesThis: '{0} lubiÄ…<sn>(lubi)</sn> to.',
  CannotConnectSearchPage: 'Nie moÅ¼na poÅ‚Ä…czyÄ‡ ze stronÄ… wyszukiwania',
  AreYouSureDeleteFilter: 'Czy na pewno chcesz usunÄ…Ä‡ filtr {0} z wyraÅ¼eniem {1}?',
  OnlineHelp: 'Pomoc online',
  Done: 'Gotowe',
  SaveFacetState: 'Zapisz stan aspektu',
  ClearFacetState: 'WyczyÅ›Ä‡ stan aspektu',
  DisplayingTheOnlyMessage: 'WyÅ›wietlanie jedynej wiadomoÅ›ci w ramach rozmowy',
  NoNetworkConnection: 'Brak poÅ‚Ä…czenia sieciowego',
  UnknownConnection: 'Nieznane poÅ‚Ä…czenie',
  EthernetConnection: 'PoÅ‚Ä…czenie Ethernet',
  WiFi: 'PoÅ‚Ä…czenie WiFi',
  CELL: 'PoÅ‚Ä…czenie komÃ³rkowe',
  CELL_2G: 'PoÅ‚Ä…czenie komÃ³rkowe 2G',
  CELL_3G: 'PoÅ‚Ä…czenie komÃ³rkowe 3G',
  CELL_4G: 'PoÅ‚Ä…czenie komÃ³rkowe 4G',
  Relevance: 'TrafnoÅ›Ä‡',
  Date: 'Data',
  Amount: 'IloÅ›Ä‡',
  QueryExceptionNoException: 'Brak wyjÄ…tkÃ³w',
  QueryExceptionInvalidSyntax: 'NieprawidÅ‚owa skÅ‚adnia',
  QueryExceptionInvalidCustomField: 'NieprawidÅ‚owe pole niestandardowe',
  QueryExceptionInvalidDate: 'NieprawidÅ‚owa data',
  QueryExceptionInvalidExactPhrase: 'NieprawidÅ‚owa dokÅ‚adna fraza',
  QueryExceptionInvalidDateOp: 'NieprawidÅ‚owy operator daty',
  QueryExceptionInvalidNear: 'NieprawidÅ‚owy operator NEAR',
  QueryExceptionInvalidWeightedNear: 'NieprawidÅ‚owy waÅ¼ony operator NEAR',
  QueryExceptionInvalidTerm: 'NieprawidÅ‚owy termin',
  QueryExceptionTooManyTerms: 'Zbyt wiele terminÃ³w',
  QueryExceptionWildcardTooGeneral: 'Symbol wieloznaczny zbyt ogÃ³lny',
  QueryExceptionInvalidSortField: 'NieprawidÅ‚owe pole sortowania',
  QueryExceptionInvalidSmallStringOp: 'NieprawidÅ‚owy operator maÅ‚ych ciÄ…gÃ³w',
  QueryExceptionRequestedResultsMax: 'Maksymalna liczba Å¼Ä…danych wynikÃ³w',
  QueryExceptionAggregatedMirrorDead: 'Duplikat agregowany jest niedostÄ™pny',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Limit czasu zapytania duplikatu agregowanego',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'NieprawidÅ‚owy numer kompilacji duplikatu agregowanego',
  QueryExceptionAggregatedMirrorCannotConnect: 'Brak poÅ‚Ä…czenia z duplikatem agregowanym',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Zbyt maÅ‚a liczba znakÃ³w poprzedzajÄ…cych symbol wieloznaczny',
  QueryExceptionSecurityInverterNotFound: 'Brak inwertora zabezpieczeÅ„',
  QueryExceptionSecurityInverterAccessDenied: 'Odmowa dostÄ™pu do inwertora zabezpieczeÅ„',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'Duplikat agregowany nie moÅ¼e dokonaÄ‡ personifikacji',
  QueryExceptionUnexpected: 'Nieoczekiwany',
  QueryExceptionAccessDenied: 'Odmowa dostÄ™pu',
  QueryExceptionSuperUserTokenInvalid: 'NieprawidÅ‚owy token administratora',
  QueryExceptionSuperUserTokenExpired: 'WygasÅ‚y token administratora',
  QueryExceptionLicenseQueriesExpired: 'WygasÅ‚a licencja zapytaÅ„',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'NieobsÅ‚ugiwany token administratora licencji',
  QueryExceptionInvalidSession: 'NieprawidÅ‚owa sesja',
  QueryExceptionInvalidDocument: 'NieprawidÅ‚owy dokument',
  QueryExceptionSearchDisabled: 'Wyszukiwanie wyÅ‚Ä…czone',
  FileType: 'Typ pliku',
  ShowAttachment: 'PokaÅ¼ zaÅ‚Ä…cznik',
  OnFeed: 'w kanale uÅ¼ytkownika {0}.',
  Author: 'Autor',
  NoTitle: 'Brak tytuÅ‚u',
  CurrentSelections: 'BieÅ¼Ä…ce zaznaczenia',
  AllContent: 'CaÅ‚a zawartoÅ›Ä‡',
  CancelLastAction: 'Anuluj ostatniÄ… czynnoÅ›Ä‡',
  SearchTips: 'WskazÃ³wki dotyczÄ…ce wyszukiwania',
  CheckSpelling: 'SprawdÅº pisowniÄ™ sÅ‚Ã³w kluczowych.',
  TryUsingFewerKeywords: 'SprÃ³buj uÅ¼yÄ‡ rÃ³Å¼nych lub bardziej ogÃ³lnych sÅ‚Ã³w kluczowych albo zmniejsz ich liczbÄ™.',
  SelectFewerFilters: 'Zmniejsz liczbÄ™ filtrÃ³w, aby poszerzyÄ‡ zakres wyszukiwania.',
  Document: 'Dokument',
  Time: 'Godzina',
  StartDate: 'Data poczÄ…tkowa',
  StartTime: 'Godzina poczÄ…tkowa',
  DurationTitle: 'Czas trwania',
  UserQuery: 'Zapytanie uÅ¼ytkownika',
  ShowUserActions: 'PokaÅ¼ akcje uÅ¼ytkownika',
  NoData: 'Brak danych',
  EventType: 'Typ zdarzenia',
  GoToFullSearch: 'PeÅ‚ne wyszukiwanie',
  GoToEdition: 'Dostosuj panel',
  RemoveContext: 'UsuÅ„ kontekst',
  BoxAttachToCase: 'DoÅ‚Ä…cz do sprawy',
  AttachToCase: 'DoÅ‚Ä…cz do sprawy',
  Attach: 'DoÅ‚Ä…cz',
  Attached: 'DoÅ‚Ä…czono',
  Detach: 'OdÅ‚Ä…cz',
  Details: 'SzczegÃ³Å‚y',
  AdditionalFilters: 'Dodatkowe filtry',
  SelectNonContextualSearch: 'UsuÅ„ kontekst z bieÅ¼Ä…cego rekordu, aby rozszerzyÄ‡ wyszukiwanie',
  CopyPasteToSupport: 'Skopiuj i wklej tÄ™ treÅ›Ä‡ w wiadomoÅ›ci do pomocy technicznej Coveo, aby uzyskaÄ‡ wiÄ™cej informacji.',
  FollowQueryDescription: 'Ostrzegaj mnie o zmianach w wynikach wyszukiwania tego zapytania.',
  SearchAlerts_Panel: 'ZarzÄ…dzaj alertami',
  SearchAlerts_PanelDescription: 'WyÅ›wietl i zarzÄ…dzaj alertami wyszukiwania.',
  SearchAlerts_PanelNoSearchAlerts: 'Brak subskrypcji.',
  SearchAlerts_Fail: 'UsÅ‚uga alertÃ³w wyszukiwania jest aktualnie niedostÄ™pna.',
  SearchAlerts_Type: 'Typ',
  SearchAlerts_Content: 'ZawartoÅ›Ä‡',
  SearchAlerts_Actions: 'Akcja',
  EmptyQuery: '<puste>',
  SearchAlerts_Type_followQuery: 'Zapytanie',
  SearchAlerts_Type_followDocument: 'Element',
  SearchAlerts_unFollowing: 'Anuluj obserwowanie',
  SearchAlerts_follow: 'Obserwuj',
  SearchAlerts_followed: 'Obserwowane',
  SearchAlerts_followQuery: 'Obserwuj zapytanie',
  Subscription_StopFollowingQuery: 'Anuluj obserwowanie zapytania',
  SearchAlerts_Frequency: 'Kiedy',
  SubscriptionsManageSubscriptions: 'ZarzÄ…dzaj alertami',
  SubscriptionsMessageFollowQuery: 'UÅ¼ytkownik bÄ™dzie otrzymywaÄ‡ alerty, kiedy zapytanie <b>{0}</b> zwrÃ³ci nowe lub zaktualizowane elementy.',
  SubscriptionsMessageFollow: 'UÅ¼ytkownik bÄ™dzie otrzymywaÄ‡ alerty dotyczÄ…ce zmian elementu <b>{0}</b>.',
  Expiration: 'WygaÅ›niÄ™cie',
  Monthly: 'MiesiÄ™cznie',
  Daily: 'Codziennie',
  Monday: 'PoniedziaÅ‚ek',
  Tuesday: 'Wtorek',
  Wednesday: 'Åšroda',
  Thursday: 'Czwartek',
  Friday: 'PiÄ…tek',
  Saturday: 'Sobota',
  Sunday: 'Niedziela',
  NextDay: 'NastÄ™pny(a) {0}',
  LastDay: 'Ostatni(a) {0}',
  StartTypingCaseForSuggestions: 'Opisz swÃ³j problem, aby uzyskaÄ‡ moÅ¼liwe rozwiÄ…zania',
  ExportToExcel: 'Eksportuj do programu Excel',
  ExportToExcelDescription: 'Eksportuj wyniki wyszukiwania do programu Excel',
  CaseCreationNoResults: 'Nie znaleziono zalecanych rozwiÄ…zaÅ„',
  SortBy: 'Sortuj wg',
  BoxCreateArticle: 'UtwÃ³rz artykuÅ‚',
  Facets: 'Fasety',
  AdvancedSearch: 'Wyszukiwanie zaawansowane',
  Keywords: 'SÅ‚owa kluczowe',
  AllTheseWords: 'Wszystkie te sÅ‚owa',
  ExactPhrase: 'DokÅ‚adnie taka fraza',
  AnyOfTheseWords: 'Dowolne z tych sÅ‚Ã³w',
  NoneOfTheseWords: 'Å»adne z tych sÅ‚Ã³w',
  Anytime: 'Zawsze',
  InTheLast: 'W ostatnich',
  Days: 'dniach',
  Months: 'miesiÄ…cach',
  Month: 'MiesiÄ…c',
  Year: 'Rok',
  Between: 'MiÄ™dzy',
  Language: 'JÄ™zyk',
  Size: 'Rozmiar',
  AtLeast: 'przynajmniej',
  AtMost: 'co najwyÅ¼ej',
  Contains: 'zawiera',
  DoesNotContain: 'nie zawiera',
  Matches: 'dopasowaÅ„',
  Bytes: 'bajtÃ³w',
  card: 'Karta',
  table: 'Tabela',
  ResultLinks: 'ÅÄ…cza wynikÃ³w',
  EnableQuerySyntax: 'WÅ‚Ä…cz skÅ‚adniÄ™ zapytania',
  On: 'WÅ‚.',
  Off: 'WyÅ‚.',
  Automatic: 'Automatyczne',
  ResultsPerPage: 'Liczba wynikÃ³w na stronÄ™',
  PreviousMonth: 'Poprzedni miesiÄ…c',
  NextMonth: 'NastÄ™pny miesiÄ…c',
  Title: 'TytuÅ‚',
  TRFilters: 'Filters'
};

// eslint-disable-next-line import/no-anonymous-default-export
var da = {
  'box user': 'Bruger',
  'filetype_box user': 'Bruger',
  html: 'HTML-fil',
  filetype_html: 'HTML-fil',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Webside',
  filetype_webscraperwebpage: 'Webside',
  image: 'Billede',
  filetype_image: 'Billede',
  folder: 'Mappe',
  filetype_folder: 'Mappe',
  txt: 'Tekst',
  filetype_txt: 'Tekst',
  zip: 'Zip-fil',
  filetype_zip: 'Zip-fil',
  olefile: 'OLE-fil',
  filetype_olefile: 'OLE-fil',
  gmailmessage: 'Gmail-meddelelse',
  filetype_gmailmessage: 'Gmail-meddelelse',
  pdf: 'PDF-fil',
  filetype_pdf: 'PDF-fil',
  swf: 'Flash-fil',
  filetype_swf: 'Flash-fil',
  xml: 'XML-fil',
  filetype_xml: 'XML-fil',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSS-feed',
  filetype_rssitem: 'RSS-feed',
  doc: 'Dokument',
  filetype_doc: 'Dokument',
  docx: 'Microsoft Word-dokument',
  filetype_docx: 'Microsoft Word-dokument',
  xls: 'Regneark',
  filetype_xls: 'Regneark',
  ppt: 'PrÃ¦sentationsdokument',
  filetype_ppt: 'PrÃ¦sentationsdokument',
  video: 'Video',
  filetype_video: 'Video',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Open Text-dokument',
  filetype_odt: 'Open Text-dokument',
  lithiummessage: 'Lithium-meddelelse',
  filetype_lithiummessage: 'Lithium-meddelelse',
  lithiumthread: 'Lithium-trÃ¥d',
  filetype_lithiumthread: 'Lithium-trÃ¥d',
  lithiumboard: 'Lithium-kort',
  filetype_lithiumboard: 'Lithium-kort',
  lithiumcategory: 'Lithium-kategori',
  filetype_lithiumcategory: 'Lithium-kategori',
  lithiumcommunity: 'Lithium-fÃ¦llesskab',
  filetype_lithiumcommunity: 'Lithium-fÃ¦llesskab',
  people: 'Bruger',
  objecttype_people: 'Bruger',
  message: 'Meddelelse',
  objecttype_message: 'Meddelelse',
  feed: 'RSS-feed',
  objecttype_feed: 'RSS-feed',
  thread: 'TrÃ¥d',
  objecttype_thread: 'TrÃ¥d',
  file: 'Fil',
  objecttype_file: 'Fil',
  board: 'Kort',
  objecttype_board: 'Kort',
  category: 'Kategori',
  objecttype_category: 'Kategori',
  account: 'Konto',
  objecttype_account: 'Konto',
  annotation: 'BemÃ¦rk',
  objecttype_annotation: 'BemÃ¦rk',
  campaign: 'Kampagne',
  objecttype_campaign: 'Kampagne',
  "case": 'Sag',
  objecttype_case: 'Sag',
  contact: 'Kontakt',
  objecttype_contact: 'Kontakt',
  contract: 'Kontrakt',
  objecttype_contract: 'Kontrakt',
  event: 'HÃ¦ndelse',
  objecttype_event: 'HÃ¦ndelse',
  email: 'E-mail',
  objecttype_email: 'E-mail',
  goal: 'MÃ¥l',
  objecttype_goal: 'MÃ¥l',
  objecttype_incident: 'Sag',
  invoice: 'Faktura',
  objecttype_invoice: 'Faktura',
  lead: 'Lead',
  objecttype_lead: 'Lead',
  list: 'Liste',
  objecttype_list: 'Marketingliste',
  solution: 'LÃ¸sning',
  objecttype_solution: 'LÃ¸sning',
  task: 'Opgave',
  objecttype_task: 'Opgave',
  user: 'Bruger',
  objecttype_user: 'Bruger',
  attachment: 'VedhÃ¦ftet fil',
  objecttype_attachment: 'VedhÃ¦ftet fil',
  casecomment: 'Kommentar til sag',
  objecttype_casecomment: 'Kommentar til sag',
  opportunity: 'Mulighed',
  objecttype_opportunity: 'Mulighed',
  opportunityproduct: 'Mulighedsprodukt',
  objecttype_opportunityproduct: 'Mulighedsprodukt',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: 'BemÃ¦rk',
  objecttype_note: 'BemÃ¦rk',
  product: 'Produkt',
  objecttype_product: 'Produkt',
  partner: 'Partner',
  objecttype_partner: 'Partner',
  queueitem: 'KÃ¸element',
  objecttype_queueitem: 'KÃ¸element',
  quote: 'Tilbud',
  objecttype_quote: 'Tilbud',
  salesliterature: 'Salgstekst',
  objecttype_salesliterature: 'Salgstekst',
  salesorder: 'Salgsordre',
  objecttype_salesorder: 'Salgsordre',
  service: 'Tjeneste',
  objecttype_service: 'Tjeneste',
  socialprofile: 'Social profil',
  objecttype_socialprofile: 'Social profil',
  kbdocumentation: 'Dokumentation',
  objecttype_kbdocumentation: 'Dokumentation',
  kbtechnicalarticle: 'Dokumentation',
  objecttype_kbtechnicalarticle: 'Dokumentation',
  kbsolution: 'LÃ¸sning',
  objecttype_kbsolution: 'LÃ¸sning',
  kbknowledgearticle: 'Vidensartikel',
  objecttype_kbknowledgearticle: 'Vidensartikel',
  kbattachment: 'VedhÃ¦ftet fil',
  objecttype_kbattachment: 'VedhÃ¦ftet fil',
  kbarticle: 'Artikel',
  objecttype_kbarticle: 'Artikel',
  kbarticlecomment: 'Kommentar til artikel',
  objecttype_kbarticlecomment: 'Kommentar til artikel',
  knowledgearticle: 'Vidensartikel',
  objecttype_knowledgearticle: 'Vidensartikel',
  topic: 'Emne',
  objecttype_topic: 'Emne',
  dashboard: 'Dashboard',
  objecttype_dashboard: 'Dashboard',
  contentversion: 'Dokument',
  objecttype_contentversion: 'Dokument',
  collaborationgroup: 'Samarbejdsgruppe',
  objecttype_collaborationgroup: 'Samarbejdsgruppe',
  spportal: 'Portal',
  filetype_spportal: 'Portal',
  spsite: 'Websted',
  filetype_spsite: 'Websted',
  spuserprofile: 'SharePoint-bruger',
  filetype_spuserprofile: 'SharePoint-bruger',
  sparea: 'OmrÃ¥de',
  filetype_sparea: 'OmrÃ¥de',
  spannouncement: 'Meddelelse',
  filetype_spannouncement: 'Meddelelse',
  spannouncementlist: 'Meddelelser',
  filetype_spannouncementlist: 'Meddelelser',
  spcontact: 'Kontakt',
  filetype_spcontact: 'Kontakt',
  spcontactlist: 'Kontakter',
  filetype_spcontactlist: 'Kontakter',
  spcustomlist: 'Brugerdefinerede lister',
  filetype_spcustomlist: 'Brugerdefinerede lister',
  spdiscussionboard: 'Diskussionsforum',
  filetype_spdiscussionboard: 'Diskussionsforum',
  spdiscussionboardlist: 'Diskussionsfora',
  filetype_spdiscussionboardlist: 'Diskussionsfora',
  spdocumentlibrarylist: 'Bibliotek for dokumenter',
  filetype_spdocumentlibrarylist: 'Bibliotek for dokumenter',
  spevent: 'HÃ¦ndelse',
  filetype_spevent: 'HÃ¦ndelse',
  speventlist: 'HÃ¦ndelser',
  filetype_speventlist: 'HÃ¦ndelser',
  spformlibrarylist: 'Bibliotek for formularer',
  filetype_spformlibrarylist: 'Bibliotek for formularer',
  spissue: 'Sag',
  filetype_spissue: 'Sag',
  spissuelist: 'Sager',
  filetype_spissuelist: 'Sager',
  splink: 'Link',
  filetype_splink: 'Link',
  splinklist: 'Links',
  filetype_splinklist: 'Links',
  sppicturelibrarylist: 'Billedbibliotek',
  filetype_sppicturelibrarylist: 'Billedbibliotek',
  spsurvey: 'UndersÃ¸gelse',
  filetype_spsurvey: 'UndersÃ¸gelse',
  spsurveylist: 'UndersÃ¸gelser',
  filetype_spsurveylist: 'UndersÃ¸gelser',
  sptask: 'Opgave',
  filetype_sptask: 'Opgave',
  sptasklist: 'Opgaver',
  filetype_sptasklist: 'Opgaver',
  spagenda: 'Dagsorden',
  filetype_spagenda: 'Dagsorden',
  spagendalist: 'Dagsordner',
  filetype_spagendalist: 'Dagsordner',
  spattendee: 'Deltager',
  filetype_spattendee: 'Deltager',
  spattendeelist: 'Deltagere',
  filetype_spattendeelist: 'Deltagere',
  spcustomgridlist: 'Brugerdefinerede gitre',
  filetype_spcustomgridlist: 'Brugerdefinerede gitre',
  spdecision: 'Beslutning',
  filetype_spdecision: 'Beslutning',
  spdecisionlist: 'Beslutninger',
  filetype_spdecisionlist: 'Beslutninger',
  spobjective: 'MÃ¥lsÃ¦tning',
  filetype_spobjective: 'MÃ¥lsÃ¦tning',
  spobjectivelist: 'MÃ¥lsÃ¦tninger',
  filetype_spobjectivelist: 'MÃ¥lsÃ¦tninger',
  sptextbox: 'Tekstboks',
  filetype_sptextbox: 'Tekstboks',
  sptextboxlist: 'Tekstboksliste',
  filetype_sptextboxlist: 'Tekstboksliste',
  spthingstobring: 'Ting at tage med',
  filetype_spthingstobring: 'Ting at tage med',
  spthingstobringlist: 'Ting at tage med',
  filetype_spthingstobringlist: 'Ting at tage med',
  sparealisting: 'Liste over omrÃ¥de',
  filetype_sparealisting: 'Liste over omrÃ¥de',
  spmeetingserie: 'MÃ¸deserie',
  filetype_spmeetingserie: 'MÃ¸deserie',
  spmeetingserielist: 'Liste over mÃ¸deserie',
  filetype_spmeetingserielist: 'Liste over mÃ¸deserie',
  spsitedirectory: 'Bibliotek for webstedselementer',
  filetype_spsitedirectory: 'Bibliotek for webstedselementer',
  spsitedirectorylist: 'Webstedsbibliotek',
  filetype_spsitedirectorylist: 'Webstedsbibliotek',
  spdatasource: 'Datakilde',
  filetype_spdatasource: 'Datakilde',
  spdatasourcelist: 'Liste over datakilde',
  filetype_spdatasourcelist: 'Liste over datakilde',
  splisttemplatecataloglist: 'Liste over skabelongalleri',
  filetype_splisttemplatecataloglist: 'Liste over skabelongalleri',
  spwebpartcataloglist: 'WebPart-galleri',
  filetype_spwebpartcataloglist: 'WebPart-galleri',
  spwebtemplatecataloglist: 'Webstedsskabelongalleri',
  filetype_spwebtemplatecataloglist: 'Webstedsskabelongalleri',
  spworkspacepagelist: 'Sider for arbejdsomrÃ¥de',
  filetype_spworkspacepagelist: 'Sider for arbejdsomrÃ¥de',
  spunknownlist: 'Brugerdefineret liste',
  filetype_spunknownlist: 'Brugerdefineret liste',
  spadministratortask: 'Administratoropgave',
  filetype_spadministratortask: 'Administratoropgave',
  spadministratortasklist: 'Administratoropgaver',
  filetype_spadministratortasklist: 'Administratoropgaver',
  spareadocumentlibrarylist: 'Bibliotek for omrÃ¥dedokumenter',
  filetype_spareadocumentlibrarylist: 'Bibliotek for omrÃ¥dedokumenter',
  spblogcategory: 'Blogkategori',
  filetype_spblogcategory: 'Blogkategori',
  spblogcategorylist: 'Blogkategorier',
  filetype_spblogcategorylist: 'Blogkategorier',
  spblogcomment: 'Blogkommentar',
  filetype_spblogcomment: 'Blogkommentar',
  spblogcommentlist: 'Blogkommentarer',
  filetype_spblogcommentlist: 'Blogkommentarer',
  spblogpost: 'BlogindlÃ¦g',
  filetype_spblogpost: 'BlogindlÃ¦g',
  spblogpostlist: 'BlogindlÃ¦g',
  filetype_spblogpostlist: 'BlogindlÃ¦g',
  spdataconnectionlibrarylist: 'Bibliotek for dataforbindelser',
  filetype_spdataconnectionlibrarylist: 'Bibliotek for dataforbindelser',
  spdistributiongroup: 'Distributionsgruppe',
  filetype_spdistributiongroup: 'Distributionsgruppe',
  spdistributiongrouplist: 'Distributionsgrupper',
  filetype_spdistributiongrouplist: 'Distributionsgrupper',
  spipfslist: 'InfoPath Forms Servers',
  filetype_spipfslist: 'InfoPath Forms Servers',
  spkeyperformanceindicator: 'NÃ¸gleindikator for performance',
  filetype_spkeyperformanceindicator: 'NÃ¸gleindikator for performance',
  spkeyperformanceindicatorlist: 'NÃ¸gleindikatorer for performance',
  filetype_spkeyperformanceindicatorlist: 'NÃ¸gleindikatorer for performance',
  splanguagesandtranslator: 'Sprog og oversÃ¦tter',
  filetype_splanguagesandtranslator: 'Sprog og oversÃ¦tter',
  splanguagesandtranslatorlist: 'Sprog og oversÃ¦ttere',
  filetype_splanguagesandtranslatorlist: 'Sprog og oversÃ¦ttere',
  spmasterpagescataloglist: 'Mastersidegalleri',
  filetype_spmasterpagescataloglist: 'Mastersidegalleri',
  spnocodeworkflowlibrarylist: 'Bibliotek for arbejdsgange uden kode',
  filetype_spnocodeworkflowlibrarylist: 'Bibliotek for arbejdsgange uden kode',
  spprojecttask: 'Projektopgave',
  filetype_spprojecttask: 'Projektopgave',
  spprojecttasklist: 'Projektopgaver',
  filetype_spprojecttasklist: 'Projektopgaver',
  sppublishingpageslibrarylist: 'Sidebibliotek',
  filetype_sppublishingpageslibrarylist: 'Sidebibliotek',
  spreportdocumentlibrarylist: 'Bibliotek for rapportdokumenter',
  filetype_spreportdocumentlibrarylist: 'Bibliotek for rapportdokumenter',
  spreportlibrarylist: 'Rapportbibliotek',
  filetype_spreportlibrarylist: 'Rapportbibliotek',
  spslidelibrarylist: 'Diasbibliotek',
  filetype_spslidelibrarylist: 'Diasbibliotek',
  sptab: 'Faner',
  filetype_sptab: 'Faner',
  sptablist: 'Liste med faner',
  filetype_sptablist: 'Liste med faner',
  sptranslationmanagementlibrarylist: 'Bibliotek for oversÃ¦ttelsesadministration',
  filetype_sptranslationmanagementlibrarylist: 'Bibliotek for oversÃ¦ttelsesadministration',
  spuserinformation: 'Brugerinformation',
  filetype_spuserinformation: 'Brugerinformation',
  spuserinformationlist: 'Liste med brugerinformation',
  filetype_spuserinformationlist: 'Liste med brugerinformation',
  spwikipagelibrarylist: 'Bibliotek for Wiki-sider',
  filetype_spwikipagelibrarylist: 'Bibliotek for Wiki-sider',
  spworkflowhistory: 'Historik over arbejdsgang',
  filetype_spworkflowhistory: 'Historik over arbejdsgang',
  spworkflowhistorylist: 'Liste med historik over arbejdsgang',
  filetype_spworkflowhistorylist: 'Liste med historik over arbejdsgang',
  spworkflowprocess: 'Brugerdefineret arbejdsgang',
  filetype_spworkflowprocess: 'Brugerdefineret arbejdsgang',
  spworkflowprocesslist: 'Brugerdefinerede arbejdsgange',
  filetype_spworkflowprocesslist: 'Brugerdefinerede arbejdsgange',
  sppublishingimageslibrarylist: 'Udgivelse af billedbibliotek',
  filetype_sppublishingimageslibrarylist: 'Udgivelse af billedbibliotek',
  spcirculation: 'Cirkulation',
  filetype_spcirculation: 'Cirkulation',
  spcirculationlist: 'Cirkulationer',
  filetype_spcirculationlist: 'Cirkulationer',
  spdashboardslibrarylist: 'Dashboard-bibliotek',
  filetype_spdashboardslibrarylist: 'Dashboard-bibliotek',
  spdataconnectionforperformancepointlibrarylist: 'Bibliotek for dataforbindelse til PerformancePoint',
  filetype_spdataconnectionforperformancepointlibrarylist: 'Bibliotek for dataforbindelse til PerformancePoint',
  sphealthreport: 'Sundhedsrapport',
  filetype_sphealthreport: 'Sundhedsrapport',
  sphealthreportlist: 'Sundhedsrapporter',
  filetype_sphealthreportlist: 'Sundhedsrapporter',
  sphealthrule: 'Sundhedsregel',
  filetype_sphealthrule: 'Sundhedsregel',
  sphealthrulelist: 'Sundhedsregler',
  filetype_sphealthrulelist: 'Sundhedsregler',
  spimedictionary: 'IME-ordbog',
  filetype_spimedictionary: 'IME-ordbog',
  spimedictionarylist: 'IME-ordbÃ¸ger',
  filetype_spimedictionarylist: 'IME-ordbÃ¸ger',
  spperformancepointcontent: 'Indhold af PerformancePoint',
  filetype_spperformancepointcontent: 'Indhold af PerformancePoint',
  spperformancepointcontentlist: 'Indhold af PerformancePoint',
  filetype_spperformancepointcontentlist: 'Indhold af PerformancePoint',
  spphonecallmemo: 'Memo om telefonopkald',
  filetype_spphonecallmemo: 'Memo om telefonopkald',
  spphonecallmemolist: 'Memoer om telefonopkald',
  filetype_spphonecallmemolist: 'Memoer om telefonopkald',
  sprecordlibrarylist: 'Optegnelsesbibliotek',
  filetype_sprecordlibrarylist: 'Optegnelsesbibliotek',
  spresource: 'Ressource',
  filetype_spresource: 'Ressource',
  spresourcelist: 'Ressourcer',
  filetype_spresourcelist: 'Ressourcer',
  spprocessdiagramslibrarylist: 'Bibliotek for procesdiagrammer',
  filetype_spprocessdiagramslibrarylist: 'Bibliotek for procesdiagrammer',
  spsitethemeslibrarylist: 'Bibliotek for webstedstemaer',
  filetype_spsitethemeslibrarylist: 'Bibliotek for webstedstemaer',
  spsolutionslibrarylist: 'LÃ¸sningsbibliotek',
  filetype_spsolutionslibrarylist: 'LÃ¸sningsbibliotek',
  spwfpublibrarylist: 'WFPUB-bibliotek',
  filetype_spwfpublibrarylist: 'WFPUB-bibliotek',
  spwhereabout: 'Opholdssted',
  filetype_spwhereabout: 'Opholdssted',
  spwhereaboutlist: 'Opholdssteder',
  filetype_spwhereaboutlist: 'Opholdssteder',
  spdocumentlink: 'Link til et dokument',
  filetype_spdocumentlink: 'Link til et dokument',
  spdocumentset: 'DokumentsÃ¦t',
  filetype_spdocumentset: 'DokumentsÃ¦t',
  spmicrofeedpost: 'Microfeed-indlÃ¦g',
  filetype_spmicrofeedpost: 'Microfeed-indlÃ¦g',
  spmicrofeedlist: 'Microfeed',
  filetype_spmicrofeedlist: 'Microfeed',
  splistfolder: 'Listemappe',
  filetype_splistfolder: 'Listemappe',
  Unknown: 'Ukendt',
  And: 'OG',
  Authenticating: 'Legaliserer {0}â€¦',
  Clear: 'Ryd {0}',
  CompleteQuery: 'Afslut forespÃ¸rgsel',
  Exclude: 'Udeluk {0}',
  EnterTag: 'TilfÃ¸j MÃ¦rke',
  Next: 'NÃ¦ste',
  Last: 'Sidste',
  Link: 'Link',
  Or: 'ELLER',
  Previous: 'Forrige',
  QueryDidntMatchAnyDocuments: 'Din forespÃ¸rgsel matchede ingen dokumenter.',
  QueryException: 'Din forespÃ¸rgsel har en fejl: {0}',
  Me: 'Mig',
  Remove: 'Fjern',
  Search: 'SÃ¸g',
  SearchFor: 'SÃ¸g efter {0}',
  ShareQuery: 'Del forespÃ¸rgsel',
  Preferences: 'Foretrukne',
  LinkOpeningSettings: 'Indstillinger til Ã¥bning af links',
  Reauthenticate: 'Gen-legaliser {0}',
  ResultsFilteringExpression: 'Tilkendegivelser filtrerer resultater',
  FiltersInYourPreferences: 'Filtre i dine prÃ¦ferencer',
  Create: 'Opret',
  SearchIn: 'SÃ¸g i {0}',
  Seconds: 'i {0} sekund<pl>er</pl>',
  ShowingResultsOf: 'Resultat<pl>er</pl> {0}<pl>-{1}</pl> af {2}',
  ShowingResultsOfWithQuery: 'Resultat<pl>er</pl> {0}<pl>-{1}</pl> af {2} til {3}',
  SwitchTo: 'Skift til {0}',
  Unexclude: 'Udeluk ikke {0}',
  ClearAllFilters: 'Ryd alle filtre',
  SkipLogin: 'Spring over login',
  LoginInProgress: 'Login er i gang, vent venligst â€¦',
  Login: 'Log ind',
  GetStarted: 'Kom i gang',
  More: 'Mere',
  NMore: '{0} mere ...',
  Less: 'FÃ¦rre',
  Settings: 'Indstillinger',
  Score: 'Score',
  ScoreDescription: 'Scoren beregnes ud fra antallet af hÃ¦ndelser samt fra positionen i resultatsÃ¦ttet.',
  Occurrences: 'HÃ¦ndelser',
  OccurrencesDescription: 'SortÃ©r efter antal hÃ¦ndelser, hvor vÃ¦rdier, der har det hÃ¸jeste antal, vises fÃ¸rst.',
  Label: 'MÃ¦rke',
  Of: 'af',
  LabelDescription: 'SortÃ©r alfabetisk i feltvÃ¦rdierne.',
  Value: 'VÃ¦rdi',
  ValueDescription: 'Sorter efter vÃ¦rdierne i det fÃ¸rste beregnede felt',
  AlphaAscending: 'VÃ¦rdi stiger',
  AlphaDescending: 'VÃ¦rdi falder',
  ChiSquare: 'Chi-Square',
  Nosort: 'Ingen sortering',
  NosortDescription: 'Sorter ikke vÃ¦rdierne. VÃ¦rdierne vil blive returneret i tilfÃ¦ldig rÃ¦kkefÃ¸lge.',
  RelativeFrequency: 'Relativ frekvens',
  RelativeFrequencyDescription: 'SortÃ©r efter den relative hyppighed af vÃ¦rdier. Mindre fÃ¦llesvÃ¦rdier vises hÃ¸jere.',
  DateDistribution: 'Distributionsdato',
  Custom: 'Almindelig',
  CustomDescription: 'SortÃ©r efter almindelig ordre',
  ComputedField: 'Beregnet felt',
  Ascending: 'Stiger',
  Descending: 'Falder',
  noResultFor: 'Ingen resultater for {0}',
  autoCorrectedQueryTo: 'ForespÃ¸rgsel blev automatisk rettet til {0}',
  didYouMean: 'Mente du: {0}',
  SuggestedResults: 'ForeslÃ¥ede resultater',
  SuggestedQueries: 'ForeslÃ¥ede forespÃ¸rgsler',
  MostRelevantItems: 'Mest relevante punkter:',
  AllItems: 'Alle punkter:',
  ShowLess: 'Vis mindre',
  ShowMore: 'Vis mere',
  HideFacet: 'Skjul facet',
  ShowFacet: 'Vis facet',
  AndOthers: 'og {0} andet',
  Others: '{0} andet',
  MostRelevantPosts: 'Mest relevante opslag:',
  CompleteThread: 'FÃ¦rdiggÃ¸r trÃ¥d:',
  ShowCompleteThread: 'Vis den fÃ¦rdige trÃ¥d:',
  ShowOnlyTopMatchingPosts: 'Vis kun matchende opslag',
  MostRelevantReplies: 'Mest relevante svar:',
  AllConversation: 'Hele samtalen:',
  ShowAllConversation: 'Vis hele samtalen',
  ShowAllReplies: 'Vis alle svar',
  ShowOnlyMostRelevantReplies: 'Vis kun mest relevante svar',
  Close: 'Luk',
  Open: 'Ã…bn',
  OpenInOutlookWhenPossible: 'Ã…bn i Outlook (hvis det er muligt)',
  AlwaysOpenInNewWindow: 'Ã…bn altid resultater i et nyt vindue',
  Quickview: 'Hurtigvis',
  NoQuickview: 'Hurtigvis er utilgÃ¦ngeligt for dette dokument',
  ErrorReport: 'Fejlrapport',
  OopsError: 'Noget gik galt pÃ¥ serveren.',
  ProblemPersists: 'Kontakt administratoren, hvis problemet fortsÃ¦tter.',
  GoBack: 'GÃ¥ tilbage',
  Reset: 'Nulstil',
  Retry: 'PrÃ¸v igen',
  MoreInfo: 'Mere information',
  Username: 'Brugernavn',
  Password: 'Adgangskode',
  PostedBy: 'OpslÃ¥et af',
  CannotConnect: 'Kan ikke forbinde til serveradressen.',
  BadUserPass: 'Adgangskoden passer ikke til brugernavnet.',
  PleaseEnterYourCredentials: 'Indtast venligst dine brugeroplysninger for {0}.',
  PleaseEnterYourSearchPage: 'Indtast venligst din sÃ¸gesides URL',
  Collapse: 'Klap sammen',
  Collapsable: 'Sammenklappelig',
  Expand: 'Udvid',
  Today: 'I dag',
  Yesterday: 'I gÃ¥r',
  Tomorrow: 'I morgen',
  Duration: 'Varighed: {0}',
  IndexDuration: 'Indeksvarighed: {0}',
  ProxyDuration: 'Proxyvarighed: {0}',
  ClientDuration: 'Kundevarighed: {0}',
  Unavailable: 'UtilgÃ¦ngelig',
  Reply: 'Svar',
  ReplyAll: 'Svar alle',
  Forward: 'Videresend',
  From: 'Fra',
  Caption: 'Undertekst',
  Expression: 'Tilkendegivelse',
  Tab: 'Fane',
  Tabs: 'Faner',
  EnterExpressionName: 'Indtast tilkendegivelses navn',
  EnterExpressionToFilterWith: 'Indtast tilkendegivelse til at filtrere resultater med',
  SelectTab: 'VÃ¦lg fane',
  SelectAll: 'VÃ¦lg alle',
  PageUrl: 'SÃ¸gesides URL',
  ErrorSavingToDevice: 'Fejl under gemning af informationen pÃ¥ din enhed',
  ErrorReadingFromDevice: 'Fejl under lÃ¦sning af informationen fra din enhed',
  AppIntro: 'Tal med en produktspecialist, der kan besvare dine spÃ¸rgsmÃ¥l om Coveo og hjÃ¦lpe dig med at beslutte hvilken Coveo-lÃ¸sning, der passer til dig. Eller prÃ¸v en live demo!',
  TryDemo: 'PrÃ¸v demoen',
  ContactUs: 'Kontakt os',
  NewToCoveo: 'Ny med Coveo?',
  LetUsHelpGetStarted: 'Lad os hjÃ¦lpe dig med at komme i gang',
  LikesThis: '{0} synes godt om dette.',
  CannotConnectSearchPage: 'Kan ikke forbinde til din sÃ¸geside',
  AreYouSureDeleteFilter: 'Er du sikker pÃ¥, du vil slette filter {0} med tilkendegivelsen {1}',
  OnlineHelp: 'OnlinehjÃ¦lp',
  Done: 'FÃ¦rdig',
  SaveFacetState: 'Gem denne facettilstand',
  ClearFacetState: 'Ryd facettilstand',
  DisplayingTheOnlyMessage: 'Viser den eneste besked i denne samtale',
  NoNetworkConnection: 'Ingen netvÃ¦rksforbindelse',
  UnknownConnection: 'Ukendt forbindelse',
  EthernetConnection: 'Ethernetforbindelse',
  WiFi: 'WiFi-forbindelse',
  CELL: 'Mobil forbindelse',
  CELL_2G: 'Mobil 2G forbindelse',
  CELL_3G: 'Mobil 3G forbindelse',
  CELL_4G: 'Mobil 4G forbindelse',
  Relevance: 'Relevans',
  Date: 'Dato',
  Amount: 'MÃ¦ngde',
  QueryExceptionNoException: 'Ingen undtagelse',
  QueryExceptionInvalidSyntax: 'Ugyldig syntaks',
  QueryExceptionInvalidCustomField: 'Ugyldigt standardfelt',
  QueryExceptionInvalidDate: 'Ugyldig dato',
  QueryExceptionInvalidExactPhrase: 'Ugyldig eksakt sÃ¦tning',
  QueryExceptionInvalidDateOp: 'Ugyldig datooperatÃ¸r',
  QueryExceptionInvalidNear: 'Ugyldig NEAR operatÃ¸r',
  QueryExceptionInvalidWeightedNear: 'Ugyldigt vÃ¦gtet NEAR',
  QueryExceptionInvalidTerm: 'Ugyldigt udtryk',
  QueryExceptionTooManyTerms: 'For mange udtryk',
  QueryExceptionWildcardTooGeneral: 'Wildcard for generelt',
  QueryExceptionInvalidSortField: 'Ugyldigt sorteringsfelt',
  QueryExceptionInvalidSmallStringOp: 'Ugyldig kortbÃ¥ndsoperatÃ¸r',
  QueryExceptionRequestedResultsMax: 'Maksimum anmodede resultater',
  QueryExceptionAggregatedMirrorDead: 'Aggregeret spejl er offline',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Timeout ved aggregeret spejlforespÃ¸rgsel',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Ugyldigt konstruktionsnummer ved aggregeret spejl',
  QueryExceptionAggregatedMirrorCannotConnect: 'Aggregeret spejl kan ikke forbindes',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Ikke nok ledende karakter wildcard',
  QueryExceptionSecurityInverterNotFound: 'Sikkerhedsomvender kunne ikke findes',
  QueryExceptionSecurityInverterAccessDenied: 'Adgang til sikkerhedsomvender nÃ¦gtet',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'Aggregeret spejl kan ikke personificeres',
  QueryExceptionUnexpected: 'Uforventet',
  QueryExceptionAccessDenied: 'Adgang nÃ¦gtet',
  QueryExceptionSuperUserTokenInvalid: 'Superbrugertegn ugyldigt',
  QueryExceptionSuperUserTokenExpired: 'Superbrugertegn er udlÃ¸bet',
  QueryExceptionLicenseQueriesExpired: 'ForespÃ¸rgselslicens udlÃ¸bet',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'Licenssuperbrugertegn understÃ¸ttes ikke',
  QueryExceptionInvalidSession: 'Ugyldig session',
  QueryExceptionInvalidDocument: 'Ugyldigt dokument',
  QueryExceptionSearchDisabled: 'SÃ¸gning invalideret',
  FileType: 'Filtype',
  ShowAttachment: 'Vis vedhÃ¦ftede fil',
  OnFeed: "pÃ¥ {0}'s feed.",
  Author: 'Forfatter',
  NoTitle: 'Ingen titel',
  CurrentSelections: 'Aktuelle valg',
  AllContent: 'Alt indhold',
  CancelLastAction: 'AnnullÃ©r sidste handling',
  SearchTips: 'SÃ¸getips',
  CheckSpelling: 'Tjek stavningen i dine nÃ¸gleord.',
  TryUsingFewerKeywords: 'PrÃ¸v at benytte fÃ¦rre, andre eller mere generelle nÃ¸gleord.',
  SelectFewerFilters: 'VÃ¦lg fÃ¦rre filtre for at gÃ¸re din sÃ¸gning bredere.',
  Document: 'Dokument',
  Time: 'Tidspunkt',
  StartDate: 'Startdato',
  StartTime: 'Starttidspunkt',
  DurationTitle: 'Varighed',
  UserQuery: 'BrugerforespÃ¸rgsel',
  ShowUserActions: 'Vis brugerhandlinger',
  NoData: 'Ingen tilgÃ¦ngelige data',
  EventType: 'HÃ¦ndelsestype',
  GoToFullSearch: 'Fuld sÃ¸gning',
  GoToEdition: 'Tilpas panel',
  RemoveContext: 'Fjern kontekst',
  BoxAttachToCase: 'VedhÃ¦ft til sag',
  AttachToCase: 'VedhÃ¦ft til sag',
  Attach: 'vedhÃ¦ft',
  Attached: 'VedhÃ¦ftet',
  Detach: 'Fjern',
  Details: 'Detaljer',
  AdditionalFilters: 'Yderligere filtre',
  SelectNonContextualSearch: 'Fjern kontekst fra den aktuelle indtastning for at udvide din sÃ¸gning',
  CopyPasteToSupport: 'Kopier indsÃ¦t denne besked til Coveo Support teamet for at fÃ¥ flere oplysninger.',
  FollowQueryDescription: 'Advar mig om Ã¦ndringer i sÃ¸geresultaterne for denne forespÃ¸rgsel.',
  SearchAlerts_Panel: 'Administrer alarmer',
  SearchAlerts_PanelDescription: 'Se og administrer dine sÃ¸gealarmer',
  SearchAlerts_PanelNoSearchAlerts: 'Du har ingen abonnementer.',
  SearchAlerts_Fail: 'Tjenesten sÃ¸gealarmer er pt. ikke tilgÃ¦ngelig.',
  SearchAlerts_Type: 'Type',
  SearchAlerts_Content: 'Indhold',
  SearchAlerts_Actions: 'Handling',
  EmptyQuery: '<tom>',
  SearchAlerts_Type_followQuery: 'ForespÃ¸rgsel',
  SearchAlerts_Type_followDocument: 'Element',
  SearchAlerts_unFollowing: 'Stop med at fÃ¸lge',
  SearchAlerts_follow: 'FÃ¸lg',
  SearchAlerts_followed: 'Fulgt',
  SearchAlerts_followQuery: 'FÃ¸lg forespÃ¸rgsel',
  Subscription_StopFollowingQuery: 'ForespÃ¸rgel om at stoppe med at fÃ¸lge',
  SearchAlerts_Frequency: 'NÃ¥r',
  SubscriptionsManageSubscriptions: 'Administrer alarmer',
  SubscriptionsMessageFollowQuery: 'Du modtager underretninger, nÃ¥r forespÃ¸rgslen <b>{0}</b> returnerer nye eller opdaterede elementer.',
  SubscriptionsMessageFollow: 'Du modtager underretninger om Ã¦ndringer af elementet <b>{0}</b>.',
  Expiration: 'UdlÃ¸b',
  Monthly: 'MÃ¥nedligt',
  Daily: 'Daglig',
  Monday: 'Mandag',
  Tuesday: 'Torsdag',
  Wednesday: 'Onsdag',
  Thursday: 'Torsdag',
  Friday: 'Fredag',
  Saturday: 'LÃ¸rdag',
  Sunday: 'SÃ¸ndag',
  NextDay: 'NÃ¦ste {0}',
  LastDay: 'Sidste {0}',
  StartTypingCaseForSuggestions: 'Beskriv dit problem for at se mulige lÃ¸sninger',
  ExportToExcel: 'Eksporter til Excel',
  ExportToExcelDescription: 'Eksporter sÃ¸geresultater til Excel',
  CaseCreationNoResults: 'Ingen anbefalede lÃ¸sninger fundet',
  SortBy: 'Sorter efter',
  BoxCreateArticle: 'Opret artikel',
  Facets: 'Facetter',
  AdvancedSearch: 'Avanceret sÃ¸gning',
  Keywords: 'NÃ¸gleord',
  AllTheseWords: 'Alle disse ord',
  ExactPhrase: 'Denne prÃ¦cise formulering',
  AnyOfTheseWords: 'Et hvilket som helst af disse ord',
  NoneOfTheseWords: 'Ingen af disse ord',
  Anytime: 'Uanset hvornÃ¥r',
  InTheLast: 'I de seneste',
  Days: 'dage',
  Months: 'mÃ¥neder',
  Month: 'MÃ¥ned',
  Year: 'Ã…r',
  Between: 'Mellem',
  Language: 'Sprog',
  Size: 'StÃ¸rrelse',
  AtLeast: 'mindst',
  AtMost: 'mest',
  Contains: 'indeholder',
  DoesNotContain: 'indeholder ikke',
  Matches: 'samme',
  Bytes: 'bytes',
  card: 'Kort',
  table: 'Tabel',
  ResultLinks: 'Resultatlinks',
  EnableQuerySyntax: 'Aktiver forespÃ¸rgselssyntax',
  On: 'Til',
  Off: 'Fra',
  Automatic: 'Automatisk',
  ResultsPerPage: 'Resultater pr. side',
  PreviousMonth: 'Forrige mÃ¥ned',
  NextMonth: 'NÃ¦ste mÃ¥ned',
  Title: 'Titel',
  TRFilters: 'Filters'
};

// eslint-disable-next-line import/no-anonymous-default-export
var no = {
  'box user': 'Bruker',
  'filetype_box user': 'Bruker',
  html: 'HTML-fil',
  filetype_html: 'HTML-fil',
  wiki: 'Wiki',
  filetype_wiki: 'Wiki',
  webscraperwebpage: 'Nettside',
  filetype_webscraperwebpage: 'Nettside',
  image: 'Bilde',
  filetype_image: 'Bilde',
  folder: 'Mappe',
  filetype_folder: 'Mappe',
  txt: 'Tekst',
  filetype_txt: 'Tekst',
  zip: 'Zip-fil',
  filetype_zip: 'Zip-fil',
  olefile: 'OLE-fil',
  filetype_olefile: 'OLE-fil',
  gmailmessage: 'Gmail-melding',
  filetype_gmailmessage: 'Gmail-melding',
  pdf: 'PDF-fil',
  filetype_pdf: 'PDF-fil',
  swf: 'Flash-fil',
  filetype_swf: 'Flash-fil',
  xml: 'XML-fil',
  filetype_xml: 'XML-fil',
  vsd: 'Visio',
  filetype_vsd: 'Visio',
  svg: 'SVG',
  filetype_svg: 'SVG',
  svm: 'Open Office',
  filetype_svm: 'Open Office',
  rssitem: 'RSS-feed',
  filetype_rssitem: 'RSS-feed',
  doc: 'Dokument',
  filetype_doc: 'Dokument',
  docx: 'Microsoft Word-dokument',
  filetype_docx: 'Microsoft Word-dokument',
  xls: 'Regneark-dokument',
  filetype_xls: 'Regneark-dokument',
  ppt: 'Presentasjon-dokument',
  filetype_ppt: 'Presentasjon-dokument',
  video: 'Video',
  filetype_video: 'Video',
  saleforceitem: 'Salesforce',
  filetype_saleforceitem: 'Salesforce',
  dynamicscrmitem: 'Dynamics CRM',
  filetype_dynamicscrmitem: 'Dynamics CRM',
  salesforceitem: 'Salesforce',
  filetype_salesforceitem: 'Salesforce',
  odt: 'Open Text-dokument',
  filetype_odt: 'Open Text-dokument',
  lithiummessage: 'Lithium-melding',
  filetype_lithiummessage: 'Lithium-melding',
  lithiumthread: 'Lithium-trÃ¥d',
  filetype_lithiumthread: 'Lithium-trÃ¥d',
  lithiumboard: 'Lithium-tavle',
  filetype_lithiumboard: 'Lithium-tavle',
  lithiumcategory: 'Lithiium-kategori',
  filetype_lithiumcategory: 'Lithiium-kategori',
  lithiumcommunity: 'Lithium-samfunn',
  filetype_lithiumcommunity: 'Lithium-samfunn',
  people: 'Bruker',
  objecttype_people: 'Bruker',
  message: 'Melding',
  objecttype_message: 'Melding',
  feed: 'RSS-feed',
  objecttype_feed: 'RSS-feed',
  thread: 'TrÃ¥d',
  objecttype_thread: 'TrÃ¥d',
  file: 'Fil',
  objecttype_file: 'Fil',
  board: 'Tavle',
  objecttype_board: 'Tavle',
  category: 'Kategori',
  objecttype_category: 'Kategori',
  account: 'Konto',
  objecttype_account: 'Konto',
  annotation: 'Notat',
  objecttype_annotation: 'Notat',
  campaign: 'Kampanje',
  objecttype_campaign: 'Kampanje',
  "case": 'Sak',
  objecttype_case: 'Sak',
  contact: 'Kontakt',
  objecttype_contact: 'Kontakt',
  contract: 'Kontrakt',
  objecttype_contract: 'Kontrakt',
  event: 'Hendelse',
  objecttype_event: 'Hendelse',
  email: 'E-post',
  objecttype_email: 'E-post',
  goal: 'MÃ¥lsetting',
  objecttype_goal: 'MÃ¥lsetting',
  objecttype_incident: 'Sak',
  invoice: 'Faktura',
  objecttype_invoice: 'Faktura',
  lead: 'Leder',
  objecttype_lead: 'Leder',
  list: 'Liste',
  objecttype_list: 'MarkedsfÃ¸ringsliste',
  solution: 'LÃ¸sning',
  objecttype_solution: 'LÃ¸sning',
  task: 'Oppgave',
  objecttype_task: 'Oppgave',
  user: 'Bruker',
  objecttype_user: 'Bruker',
  attachment: 'Vedlegg',
  objecttype_attachment: 'Vedlegg',
  casecomment: 'Sakskommentar',
  objecttype_casecomment: 'Sakskommentar',
  opportunity: 'Mulighet',
  objecttype_opportunity: 'Mulighet',
  opportunityproduct: 'Opportunity-produkt',
  objecttype_opportunityproduct: 'Opportunity-produkt',
  feeditem: 'Chatter',
  objecttype_feeditem: 'Chatter',
  feedcomment: 'Chatter',
  objecttype_feedcomment: 'Chatter',
  note: 'Notat',
  objecttype_note: 'Notat',
  product: 'Produkt',
  objecttype_product: 'Produkt',
  partner: 'Partner',
  objecttype_partner: 'Partner',
  queueitem: 'KÃ¸element',
  objecttype_queueitem: 'KÃ¸element',
  quote: 'Sitat',
  objecttype_quote: 'Sitat',
  salesliterature: 'Salgslitteratur',
  objecttype_salesliterature: 'Salgslitteratur',
  salesorder: 'Salgsordre',
  objecttype_salesorder: 'Salgsordre',
  service: 'Service',
  objecttype_service: 'Service',
  socialprofile: 'Sosial profil',
  objecttype_socialprofile: 'Sosial profil',
  kbdocumentation: 'Dokumentasjon',
  objecttype_kbdocumentation: 'Dokumentasjon',
  kbtechnicalarticle: 'Dokumentasjon',
  objecttype_kbtechnicalarticle: 'Dokumentasjon',
  kbsolution: 'LÃ¸sning',
  objecttype_kbsolution: 'LÃ¸sning',
  kbknowledgearticle: 'Kunnskapsartikkel',
  objecttype_kbknowledgearticle: 'Kunnskapsartikkel',
  kbattachment: 'Vedlegg',
  objecttype_kbattachment: 'Vedlegg',
  kbarticle: 'Artikkel',
  objecttype_kbarticle: 'Artikkel',
  kbarticlecomment: 'Artikkelkommentar',
  objecttype_kbarticlecomment: 'Artikkelkommentar',
  knowledgearticle: 'Kunnskapsartikkel',
  objecttype_knowledgearticle: 'Kunnskapsartikkel',
  topic: 'Tema',
  objecttype_topic: 'Tema',
  dashboard: 'Dashbord',
  objecttype_dashboard: 'Dashbord',
  contentversion: 'Dokument',
  objecttype_contentversion: 'Dokument',
  collaborationgroup: 'Samarbeidsgruppe',
  objecttype_collaborationgroup: 'Samarbeidsgruppe',
  spportal: 'Portal',
  filetype_spportal: 'Portal',
  spsite: 'Side',
  filetype_spsite: 'Side',
  spuserprofile: 'SharePoint-bruker',
  filetype_spuserprofile: 'SharePoint-bruker',
  sparea: 'OmrÃ¥de',
  filetype_sparea: 'OmrÃ¥de',
  spannouncement: 'KunngjÃ¸ring',
  filetype_spannouncement: 'KunngjÃ¸ring',
  spannouncementlist: 'KunngjÃ¸ringer',
  filetype_spannouncementlist: 'KunngjÃ¸ringer',
  spcontact: 'Kontakt',
  filetype_spcontact: 'Kontakt',
  spcontactlist: 'Kontakter',
  filetype_spcontactlist: 'Kontakter',
  spcustomlist: 'Egendefinerte lister',
  filetype_spcustomlist: 'Egendefinerte lister',
  spdiscussionboard: 'Diskusjonspanel',
  filetype_spdiscussionboard: 'Diskusjonspanel',
  spdiscussionboardlist: 'Diskusjonspaneler',
  filetype_spdiscussionboardlist: 'Diskusjonspaneler',
  spdocumentlibrarylist: 'Dokumentbibliotek',
  filetype_spdocumentlibrarylist: 'Dokumentbibliotek',
  spevent: 'Hendelse',
  filetype_spevent: 'Hendelse',
  speventlist: 'Hendelser',
  filetype_speventlist: 'Hendelser',
  spformlibrarylist: 'Skjemabibliotek',
  filetype_spformlibrarylist: 'Skjemabibliotek',
  spissue: 'Emne',
  filetype_spissue: 'Emne',
  spissuelist: 'Emner',
  filetype_spissuelist: 'Emner',
  splink: 'Lenke',
  filetype_splink: 'Lenke',
  splinklist: 'Lenker',
  filetype_splinklist: 'Lenker',
  sppicturelibrarylist: 'Bildebibliotek',
  filetype_sppicturelibrarylist: 'Bildebibliotek',
  spsurvey: 'UndersÃ¸kelse',
  filetype_spsurvey: 'UndersÃ¸kelse',
  spsurveylist: 'UndersÃ¸kelser',
  filetype_spsurveylist: 'UndersÃ¸kelser',
  sptask: 'Oppgave',
  filetype_sptask: 'Oppgave',
  sptasklist: 'Oppgaver',
  filetype_sptasklist: 'Oppgaver',
  spagenda: 'Agenda',
  filetype_spagenda: 'Agenda',
  spagendalist: 'Agendaer',
  filetype_spagendalist: 'Agendaer',
  spattendee: 'Deltager',
  filetype_spattendee: 'Deltager',
  spattendeelist: 'Deltagere',
  filetype_spattendeelist: 'Deltagere',
  spcustomgridlist: 'Egendefinerte rutenett',
  filetype_spcustomgridlist: 'Egendefinerte rutenett',
  spdecision: 'AvgjÃ¸relse',
  filetype_spdecision: 'AvgjÃ¸relse',
  spdecisionlist: 'AvgjÃ¸relser',
  filetype_spdecisionlist: 'AvgjÃ¸relser',
  spobjective: 'FormÃ¥l',
  filetype_spobjective: 'FormÃ¥l',
  spobjectivelist: 'FormÃ¥l',
  filetype_spobjectivelist: 'FormÃ¥l',
  sptextbox: 'Tekstfelt',
  filetype_sptextbox: 'Tekstfelt',
  sptextboxlist: 'Tekstfelt-liste',
  filetype_sptextboxlist: 'Tekstfelt-liste',
  spthingstobring: 'Ting Ã¥ ta med',
  filetype_spthingstobring: 'Ting Ã¥ ta med',
  spthingstobringlist: 'Ting Ã¥ ta med',
  filetype_spthingstobringlist: 'Ting Ã¥ ta med',
  sparealisting: 'OmrÃ¥deliste',
  filetype_sparealisting: 'OmrÃ¥deliste',
  spmeetingserie: 'MÃ¸teserie',
  filetype_spmeetingserie: 'MÃ¸teserie',
  spmeetingserielist: 'MÃ¸teserie-liste',
  filetype_spmeetingserielist: 'MÃ¸teserie-liste',
  spsitedirectory: 'Sidekatalog-enhet',
  filetype_spsitedirectory: 'Sidekatalog-enhet',
  spsitedirectorylist: 'Sidekatalog',
  filetype_spsitedirectorylist: 'Sidekatalog',
  spdatasource: 'Datakilde',
  filetype_spdatasource: 'Datakilde',
  spdatasourcelist: 'Datakilde-liste',
  filetype_spdatasourcelist: 'Datakilde-liste',
  splisttemplatecataloglist: 'Liste over templatgalleri',
  filetype_splisttemplatecataloglist: 'Liste over templatgalleri',
  spwebpartcataloglist: 'WepPart-galleri',
  filetype_spwebpartcataloglist: 'WepPart-galleri',
  spwebtemplatecataloglist: 'Sidetemplat-galleri',
  filetype_spwebtemplatecataloglist: 'Sidetemplat-galleri',
  spworkspacepagelist: 'Workspace-sider',
  filetype_spworkspacepagelist: 'Workspace-sider',
  spunknownlist: 'Egendefinert liste',
  filetype_spunknownlist: 'Egendefinert liste',
  spadministratortask: 'Administratoroppgave',
  filetype_spadministratortask: 'Administratoroppgave',
  spadministratortasklist: 'Administratoroppgaver',
  filetype_spadministratortasklist: 'Administratoroppgaver',
  spareadocumentlibrarylist: 'OmrÃ¥dedokument-bibliotek',
  filetype_spareadocumentlibrarylist: 'OmrÃ¥dedokument-bibliotek',
  spblogcategory: 'Blogg-kategori',
  filetype_spblogcategory: 'Blogg-kategori',
  spblogcategorylist: 'Blogg-kategorier',
  filetype_spblogcategorylist: 'Blogg-kategorier',
  spblogcomment: 'Blogg-kommentar',
  filetype_spblogcomment: 'Blogg-kommentar',
  spblogcommentlist: 'Blogg-kommentarer',
  filetype_spblogcommentlist: 'Blogg-kommentarer',
  spblogpost: 'Blogg-post',
  filetype_spblogpost: 'Blogg-post',
  spblogpostlist: 'Blogg-poster',
  filetype_spblogpostlist: 'Blogg-poster',
  spdataconnectionlibrarylist: 'Dataforbindelse-bibliotek',
  filetype_spdataconnectionlibrarylist: 'Dataforbindelse-bibliotek',
  spdistributiongroup: 'Distribusjonsgruppe',
  filetype_spdistributiongroup: 'Distribusjonsgruppe',
  spdistributiongrouplist: 'Distribusjonsgrupper',
  filetype_spdistributiongrouplist: 'Distribusjonsgrupper',
  spipfslist: 'InfoPath Skjermaservere',
  filetype_spipfslist: 'InfoPath Skjermaservere',
  spkeyperformanceindicator: 'NÃ¸kkelprestasjon-indikator',
  filetype_spkeyperformanceindicator: 'NÃ¸kkelprestasjon-indikator',
  spkeyperformanceindicatorlist: 'NÃ¸kkelprestasjon-indikatorer',
  filetype_spkeyperformanceindicatorlist: 'NÃ¸kkelprestasjon-indikatorer',
  splanguagesandtranslator: 'SprÃ¥k og oversetter',
  filetype_splanguagesandtranslator: 'SprÃ¥k og oversetter',
  splanguagesandtranslatorlist: 'SprÃ¥k og oversettere',
  filetype_splanguagesandtranslatorlist: 'SprÃ¥k og oversettere',
  spmasterpagescataloglist: 'Hovedside-galleri',
  filetype_spmasterpagescataloglist: 'Hovedside-galleri',
  spnocodeworkflowlibrarylist: 'No-code Arbeidsflyt-biblioteker',
  filetype_spnocodeworkflowlibrarylist: 'No-code Arbeidsflyt-biblioteker',
  spprojecttask: 'Prosjektoppgave',
  filetype_spprojecttask: 'Prosjektoppgave',
  spprojecttasklist: 'Prosjektoppgaver',
  filetype_spprojecttasklist: 'Prosjektoppgaver',
  sppublishingpageslibrarylist: 'Sidebibliotek',
  filetype_sppublishingpageslibrarylist: 'Sidebibliotek',
  spreportdocumentlibrarylist: 'Rapportdokument-bibliotek',
  filetype_spreportdocumentlibrarylist: 'Rapportdokument-bibliotek',
  spreportlibrarylist: 'Rapport-bibliotek',
  filetype_spreportlibrarylist: 'Rapport-bibliotek',
  spslidelibrarylist: 'Sidebibliotek',
  filetype_spslidelibrarylist: 'Sidebibliotek',
  sptab: 'Faner',
  filetype_sptab: 'Faner',
  sptablist: 'Faneliste',
  filetype_sptablist: 'Faneliste',
  sptranslationmanagementlibrarylist: 'Oversettelseadministrasjon-bibliotek',
  filetype_sptranslationmanagementlibrarylist: 'Oversettelseadministrasjon-bibliotek',
  spuserinformation: 'Brukerinformasjon',
  filetype_spuserinformation: 'Brukerinformasjon',
  spuserinformationlist: 'Brukerinformasjon-liste',
  filetype_spuserinformationlist: 'Brukerinformasjon-liste',
  spwikipagelibrarylist: 'Wiki-side-bibliotek',
  filetype_spwikipagelibrarylist: 'Wiki-side-bibliotek',
  spworkflowhistory: 'Arbeidsflythistorikk',
  filetype_spworkflowhistory: 'Arbeidsflythistorikk',
  spworkflowhistorylist: 'Arbeidsflythistorikk-liste',
  filetype_spworkflowhistorylist: 'Arbeidsflythistorikk-liste',
  spworkflowprocess: 'Egendefinert arbeidsflyt-prosess',
  filetype_spworkflowprocess: 'Egendefinert arbeidsflyt-prosess',
  spworkflowprocesslist: 'Egendefinerte arbeidsflyt-prosesser',
  filetype_spworkflowprocesslist: 'Egendefinerte arbeidsflyt-prosesser',
  sppublishingimageslibrarylist: 'Publisering-bildebibliotek',
  filetype_sppublishingimageslibrarylist: 'Publisering-bildebibliotek',
  spcirculation: 'Sirkulering',
  filetype_spcirculation: 'Sirkulering',
  spcirculationlist: 'Sirkuleringer',
  filetype_spcirculationlist: 'Sirkuleringer',
  spdashboardslibrarylist: 'Bashbord-bibliotek',
  filetype_spdashboardslibrarylist: 'Bashbord-bibliotek',
  spdataconnectionforperformancepointlibrarylist: 'PerformancePoint-dataforbindelse-bibliotek',
  filetype_spdataconnectionforperformancepointlibrarylist: 'PerformancePoint-dataforbindelse-bibliotek',
  sphealthreport: 'Helserapport',
  filetype_sphealthreport: 'Helserapport',
  sphealthreportlist: 'Helserapporter',
  filetype_sphealthreportlist: 'Helserapporter',
  sphealthrule: 'Helseregel',
  filetype_sphealthrule: 'Helseregel',
  sphealthrulelist: 'Helseregler',
  filetype_sphealthrulelist: 'Helseregler',
  spimedictionary: 'IME-ordliste',
  filetype_spimedictionary: 'IME-ordliste',
  spimedictionarylist: 'IME-ordlister',
  filetype_spimedictionarylist: 'IME-ordlister',
  spperformancepointcontent: 'PerformancePoint-innhold',
  filetype_spperformancepointcontent: 'PerformancePoint-innhold',
  spperformancepointcontentlist: 'PerformancePoint-innhold',
  filetype_spperformancepointcontentlist: 'PerformancePoint-innhold',
  spphonecallmemo: 'Telefon-notat',
  filetype_spphonecallmemo: 'Telefon-notat',
  spphonecallmemolist: 'Telefon-notater',
  filetype_spphonecallmemolist: 'Telefon-notater',
  sprecordlibrarylist: 'Register-bibliotek',
  filetype_sprecordlibrarylist: 'Register-bibliotek',
  spresource: 'Ressurs',
  filetype_spresource: 'Ressurs',
  spresourcelist: 'Ressurser',
  filetype_spresourcelist: 'Ressurser',
  spprocessdiagramslibrarylist: 'Prosessdiagram-bibliotek',
  filetype_spprocessdiagramslibrarylist: 'Prosessdiagram-bibliotek',
  spsitethemeslibrarylist: 'Sidetema-bibliotek',
  filetype_spsitethemeslibrarylist: 'Sidetema-bibliotek',
  spsolutionslibrarylist: 'LÃ¸sningsbibliotek',
  filetype_spsolutionslibrarylist: 'LÃ¸sningsbibliotek',
  spwfpublibrarylist: 'WFPUB-bibliotek',
  filetype_spwfpublibrarylist: 'WFPUB-bibliotek',
  spwhereabout: 'Oppholdssted',
  filetype_spwhereabout: 'Oppholdssted',
  spwhereaboutlist: 'Oppholdssteder',
  filetype_spwhereaboutlist: 'Oppholdssteder',
  spdocumentlink: 'Lenke til et dokument',
  filetype_spdocumentlink: 'Lenke til et dokument',
  spdocumentset: 'Dokumentsett',
  filetype_spdocumentset: 'Dokumentsett',
  spmicrofeedpost: 'Mikrofeed-post',
  filetype_spmicrofeedpost: 'Mikrofeed-post',
  spmicrofeedlist: 'Mikrofeed',
  filetype_spmicrofeedlist: 'Mikrofeed',
  splistfolder: 'Listemappe',
  filetype_splistfolder: 'Listemappe',
  Unknown: 'Ukjent',
  And: 'OG',
  Authenticating: 'Autentiserer {0}â€¦',
  Clear: 'TÃ¸m {0}',
  CompleteQuery: 'Fullstendig forespÃ¸rsel',
  Exclude: 'Ekskluder {0}',
  EnterTag: 'Legg til tag',
  Next: 'Neste',
  Last: 'Siste',
  Link: 'Link',
  Or: 'ELLER',
  Previous: 'Forrige',
  QueryDidntMatchAnyDocuments: 'Din forespÃ¸rsel samsvarte ikke med noen dokumenter.',
  QueryException: 'Din forespÃ¸rsel har en feil: {0}.',
  Me: 'Meg',
  Remove: 'Fjern',
  Search: 'SÃ¸k',
  SearchFor: 'SÃ¸k etter{0}',
  ShareQuery: 'Del forespÃ¸rsel',
  Preferences: 'Preferanser',
  LinkOpeningSettings: 'Innstillinger for Ã¥pning av link',
  Reauthenticate: 'Autentiser pÃ¥ nytt {0}',
  ResultsFilteringExpression: 'Uttrykk for resultatfiltrering',
  FiltersInYourPreferences: 'Filtre i dine preferanser',
  Create: 'Opprett',
  SearchIn: 'SÃ¸k i {0}',
  Seconds: 'om {0} sekund<pl>er</pl>',
  ShowingResultsOf: 'Resultat<pl>er</pl>-{0}<pl>-{1}</pl> av {2}',
  ShowingResultsOfWithQuery: 'Resultat<pl>er</pl>-{0}<pl>-{1}</pl> av {2} for {3}',
  SwitchTo: 'Bytt til {0}',
  Unexclude: 'Ikke ekskluder {0}',
  ClearAllFilters: 'TÃ¸m alle filtre',
  SkipLogin: 'Hopp over innlogging',
  LoginInProgress: 'Innlogging pÃ¥gÃ¥r, vennligst ventâ€¦',
  Login: 'Logg inn',
  GetStarted: 'Kom i gang',
  More: 'Mer',
  NMore: '{0} mer...',
  Less: 'Mindre',
  Settings: 'Innstillinger',
  Score: 'SkÃ¥r',
  ScoreDescription: 'SkÃ¥ren er beregnet ut fra antall hendelser sÃ¥ vel som posisjonen i resultatsettet.',
  Occurrences: 'Hendelser',
  OccurrencesDescription: 'Sorter etter antall hendelser med verdier med hÃ¸yest nummer fÃ¸rst.',
  Label: 'Etikett',
  Of: 'av',
  LabelDescription: 'Sorter alfabetisk etter feltverdiene',
  Value: 'Verdi',
  ValueDescription: 'Sorter etter verdiene i det fÃ¸rste beregnede feltet',
  AlphaAscending: 'Verdi stigende',
  AlphaDescending: 'Verdi synkende',
  ChiSquare: 'Chi-kvadrat',
  Nosort: 'Ingen sortering',
  NosortDescription: 'Ikke sorter verdiene. Verdiene vil komme tilbake i en tilfeldig rekkefÃ¸lge.',
  RelativeFrequency: 'Relativ frekvens',
  RelativeFrequencyDescription: 'Sorter basert pÃ¥ den relative frekvensen av verdier. Mindre vanlige verdier vil vises hÃ¸yere.',
  DateDistribution: 'Datodistribusjon',
  Custom: 'Tilpasset',
  CustomDescription: 'Sorter basert pÃ¥ en tilpasset rekkefÃ¸lge',
  ComputedField: 'Beregnet felt',
  Ascending: 'Stigende',
  Descending: 'Synkende',
  noResultFor: 'Ingen resultater for {0}',
  autoCorrectedQueryTo: 'ForespÃ¸rsel ble automatisk korrigert til {0}',
  didYouMean: 'Mente du: {0}',
  SuggestedResults: 'ForeslÃ¥tte resultater',
  SuggestedQueries: 'ForeslÃ¥tte forespÃ¸rsler',
  MostRelevantItems: 'Mest relevante elementer:',
  AllItems: 'Alle elementer:',
  ShowLess: 'Vis mindre',
  ShowMore: 'Vis mer',
  HideFacet: 'Skjul fasett',
  ShowFacet: 'Vis fasett',
  AndOthers: 'og {0} <sn>annen</sn><pl>andre</pl>',
  Others: '{0} <sn>annen</sn><pl>andre</pl>',
  MostRelevantPosts: 'Mest relevante poster',
  CompleteThread: 'Fullstendig trÃ¥d:',
  ShowCompleteThread: 'Vis fullstendig trÃ¥d',
  ShowOnlyTopMatchingPosts: 'Vis kun de postene som matcher best',
  MostRelevantReplies: 'Mest relevante svar',
  AllConversation: 'All konversasjon:',
  ShowAllConversation: 'Vis all konversasjon',
  ShowAllReplies: 'Vis alle svar',
  ShowOnlyMostRelevantReplies: 'Vis kun de mest relevante svarene',
  Close: 'Lukk',
  Open: 'Ã…pne',
  OpenInOutlookWhenPossible: 'Ã…pne i Outlook (hvor mulig)',
  AlwaysOpenInNewWindow: 'Ã…pne alltid resultater i nytt vindu',
  Quickview: 'Hurtigvisning',
  NoQuickview: 'Hurtigvisning for dette dokumentet er ikke tilgjengelig',
  ErrorReport: 'Feilrapport',
  OopsError: 'Noe gikk galt pÃ¥ serveren.',
  ProblemPersists: 'Kontakt administratoren hvis problemet vedvarer.',
  GoBack: 'GÃ¥ tilbake',
  Reset: 'Tilbakestill',
  Retry: 'PrÃ¸v pÃ¥ nytt',
  MoreInfo: 'Mer informasjon',
  Username: 'Brukernavn',
  Password: 'Passord',
  PostedBy: 'Postet av',
  CannotConnect: 'Kan ikke koble til serveradressen.',
  BadUserPass: 'Passord samsvarer ikke med brukernavnet.',
  PleaseEnterYourCredentials: 'Vennligst angi dine akkreditiver for {0}.',
  PleaseEnterYourSearchPage: 'Vennligst angi URL for din sÃ¸keside',
  Collapse: 'Fold sammen',
  Collapsable: 'Sammenfoldbar',
  Expand: 'Utvid',
  Today: 'I dag',
  Yesterday: 'I gÃ¥r',
  Tomorrow: 'I morgen',
  Duration: 'Varighet: {0}',
  IndexDuration: 'Indeks varighet: {0}',
  ProxyDuration: 'Proxy varighet: {0}',
  ClientDuration: 'Klient varighet: {0}',
  Unavailable: 'Utilgjengelig',
  Reply: 'Svar',
  ReplyAll: 'Svar alle',
  Forward: 'Videresend',
  From: 'Fra',
  Caption: 'Tittel',
  Expression: 'Uttrykk',
  Tab: 'Fane',
  Tabs: 'Faner',
  EnterExpressionName: 'Angi uttrykksnavn',
  EnterExpressionToFilterWith: 'Angi uttrykk Ã¥ filtrere resultater med',
  SelectTab: 'Velg fane',
  SelectAll: 'Velg alle',
  PageUrl: 'Velg URL for side',
  ErrorSavingToDevice: 'Feil ved lagring av informasjon til din enhet',
  ErrorReadingFromDevice: 'Feil ved lesing av informasjon fra din enhet',
  AppIntro: 'Snakk med en produktspesialist som kan besvare dine spÃ¸rsmÃ¥l om Coveo og hjelpe deg Ã¥ avgjÃ¸re hvilken Coveo-lÃ¸sning som er riktig for deg. Eller prÃ¸v en live demo!',
  TryDemo: 'PrÃ¸v demoen',
  ContactUs: 'Kontakt oss',
  NewToCoveo: 'Ny med Coveo?',
  LetUsHelpGetStarted: 'La oss hjelpe deg Ã¥ komme i gang',
  LikesThis: '{0} liker dette.',
  CannotConnectSearchPage: 'kan ikke koble til din sÃ¸keside',
  AreYouSureDeleteFilter: 'Er du sikker pÃ¥ at du Ã¸nsker Ã¥ slette filter {0} med uttrykket {1}',
  OnlineHelp: 'Online hjelp',
  Done: 'Ferdig',
  SaveFacetState: 'Lagre denne fasettstatusen',
  ClearFacetState: 'TÃ¸m fasettstatus',
  DisplayingTheOnlyMessage: 'Viser den eneste meldingen i denne samtalen',
  NoNetworkConnection: 'Ingen nettverksforbindelse',
  UnknownConnection: 'Ukjent tilkobling',
  EthernetConnection: 'Ethernet-tilkobling',
  WiFi: 'WiFi-tilkobling',
  CELL: 'Mobil tilkobling',
  CELL_2G: 'Mobil 2G-tilkobling',
  CELL_3G: 'Mobil 3G-tilkobling',
  CELL_4G: 'Mobil 4G-tilkobling',
  Relevance: 'Relevans',
  Date: 'Dato',
  Amount: 'Mengde',
  QueryExceptionNoException: 'Ingen unntak',
  QueryExceptionInvalidSyntax: 'Ugyldig syntaks',
  QueryExceptionInvalidCustomField: 'Ugyldig tilpasset felt',
  QueryExceptionInvalidDate: 'Ugyldig dato',
  QueryExceptionInvalidExactPhrase: 'Ugyldig nÃ¸yaktig frase',
  QueryExceptionInvalidDateOp: 'Ugyldig datooperatÃ¸r',
  QueryExceptionInvalidNear: 'Ugyldig NEAR-operatÃ¸r',
  QueryExceptionInvalidWeightedNear: 'Ugyldig vektet NEAR',
  QueryExceptionInvalidTerm: 'Ugyldig term',
  QueryExceptionTooManyTerms: 'For mange termer',
  QueryExceptionWildcardTooGeneral: 'Jokertegn for generelt',
  QueryExceptionInvalidSortField: 'Ugyldig sorteringsfelt',
  QueryExceptionInvalidSmallStringOp: 'Ugyldig liten stringoperatÃ¸r',
  QueryExceptionRequestedResultsMax: 'Forespurte resultater maksimum',
  QueryExceptionAggregatedMirrorDead: 'Fjern indekskopi offline',
  QueryExceptionAggregatedMirrorQueryTimeOut: 'Fjern indekskopi forespÃ¸rsel timeout',
  QueryExceptionAggregatedMirrorInvalidBuildNumber: 'Fjern indekskopi ugyldig byggnummer',
  QueryExceptionAggregatedMirrorCannotConnect: 'Fjern indekskopi kan ikke koble til',
  QueryExceptionNotEnoughLeadingCharsWildcard: 'Ikke nok ledende tegn i jokertegn',
  QueryExceptionSecurityInverterNotFound: 'Sikkerhetsinverter ikke funnet',
  QueryExceptionSecurityInverterAccessDenied: 'Adgang til sikkerhetsinverter avslÃ¥tt',
  QueryExceptionAggregatedMirrorCannotImpersonate: 'Fjern indekskopi kan ikke representere',
  QueryExceptionUnexpected: 'Uventet',
  QueryExceptionAccessDenied: 'Adgang avslÃ¥tt',
  QueryExceptionSuperUserTokenInvalid: 'Superbruker symbol ikke gyldig',
  QueryExceptionSuperUserTokenExpired: 'Superbruker symbol er utlÃ¸pt',
  QueryExceptionLicenseQueriesExpired: 'ForespÃ¸rselslisens utlÃ¸pt',
  QueryExceptionLicenseSuperUserTokenNotSupported: 'Lisens for superbruker symbol ikke stÃ¸ttet',
  QueryExceptionInvalidSession: 'Ugyldig Ã¸kt',
  QueryExceptionInvalidDocument: 'Ugyldig dokument',
  QueryExceptionSearchDisabled: 'SÃ¸k deaktivert',
  FileType: 'Filtype',
  ShowAttachment: 'Vis vedlegg',
  OnFeed: 'pÃ¥ {0}s feed.',
  Author: 'Forfatter',
  NoTitle: 'Ingen tittel',
  CurrentSelections: 'Gjeldende valg',
  AllContent: 'Alt innhold',
  CancelLastAction: 'Avbryt siste handling',
  SearchTips: 'SÃ¸ketips',
  CheckSpelling: 'Sjekk staving for dine nÃ¸kkelord',
  TryUsingFewerKeywords: 'PrÃ¸v Ã¥ bruke fÃ¦rre, andre eller flere generelle nÃ¸kkelord.',
  SelectFewerFilters: 'Velg fÃ¦rre filtre for Ã¥ utvide sÃ¸ket ditt',
  Document: 'Dokument',
  Time: 'Tid',
  StartDate: 'Startdato',
  StartTime: 'Starttid',
  DurationTitle: 'Varighet',
  UserQuery: 'BrukerforespÃ¸rsel',
  ShowUserActions: 'Vis brukerhandlinger',
  NoData: 'Ingen data tilgjengelig',
  EventType: 'Hendelsetype',
  GoToFullSearch: 'Fult sÃ¸k',
  GoToEdition: 'Tilpass panel',
  RemoveContext: 'Fjern kontekst',
  BoxAttachToCase: 'Legg ved sak',
  AttachToCase: 'Legg ved sak',
  Attach: 'Legg ved',
  Attached: 'Vedlagt',
  Detach: 'LÃ¸sne',
  Details: 'Detaljer',
  AdditionalFilters: 'Ytterligere filtre',
  SelectNonContextualSearch: 'Fjern kontekst fra den gjeldende registreringen for Ã¥ utvide sÃ¸ket ditt',
  CopyPasteToSupport: 'Kopier og lim inn denne meldingen til Coveo BrukerstÃ¸tte for mer informasjon.',
  FollowQueryDescription: 'Send meg varsel om endringer i sÃ¸keresultatet for dette sÃ¸ket.',
  SearchAlerts_Panel: 'Administrer varsler',
  SearchAlerts_PanelDescription: 'Se og administrer dine sÃ¸k-varsler.',
  SearchAlerts_PanelNoSearchAlerts: 'Du har ingen abonnementer.',
  SearchAlerts_Fail: 'SÃ¸k-varsel-tjenesten er for tiden ikke tilgjengelig.',
  SearchAlerts_Type: 'Type',
  SearchAlerts_Content: 'Innhold',
  SearchAlerts_Actions: 'Handling',
  EmptyQuery: '<tom>',
  SearchAlerts_Type_followQuery: 'ForespÃ¸rsel',
  SearchAlerts_Type_followDocument: 'Enhet',
  SearchAlerts_unFollowing: 'Slutt Ã¥ fÃ¸lge',
  SearchAlerts_follow: 'FÃ¸lg',
  SearchAlerts_followed: 'Fulgt',
  SearchAlerts_followQuery: 'FÃ¸lg forespÃ¸rsel',
  Subscription_StopFollowingQuery: 'Slutt Ã¥ fÃ¸lge forespÃ¸rsel',
  SearchAlerts_Frequency: 'NÃ¥r',
  SubscriptionsManageSubscriptions: 'Administrer varsler',
  SubscriptionsMessageFollowQuery: 'Du vil motta varsler nÃ¥r forespÃ¸rselen <b>{0}</b> kommer tilbake med nye eller oppdaterte enheter.',
  SubscriptionsMessageFollow: 'Du vil motta varsler om endringer for enheten <b>{0}</b>.',
  Expiration: 'UtlÃ¸psdato',
  Monthly: 'MÃ¥nedlig',
  Daily: 'Daglig',
  Monday: 'Mandag',
  Tuesday: 'Tirsdag',
  Wednesday: 'Onsdag',
  Thursday: 'Torsdag',
  Friday: 'Fredag',
  Saturday: 'LÃ¸rdag',
  Sunday: 'SÃ¸ndag',
  NextDay: 'Neste {0}',
  LastDay: 'Siste {0}',
  StartTypingCaseForSuggestions: 'Beskriv problemet ditt for Ã¥ se mulige lÃ¸sninger',
  ExportToExcel: 'Eksporter til Excel',
  ExportToExcelDescription: 'Eksporter sÃ¸keresultatene til Excel',
  CaseCreationNoResults: 'Ingen anbefalte lÃ¸sninger ble funnet',
  SortBy: 'Sorter etter',
  BoxCreateArticle: 'Opprett artikkel',
  Facets: 'Fasetter',
  AdvancedSearch: 'Avansert sÃ¸k',
  Keywords: 'NÃ¸kkelord',
  AllTheseWords: 'Alle disse ordene',
  ExactPhrase: 'Denne eksakte frasen',
  AnyOfTheseWords: 'Ett av disse ordene',
  NoneOfTheseWords: 'Ingen av disse ordene',
  Anytime: 'NÃ¥r som helst',
  InTheLast: 'I det minste',
  Days: 'dager',
  Months: 'mÃ¥neder',
  Month: 'MÃ¥ned',
  Year: 'Ã…r',
  Between: 'Mellom',
  Language: 'SprÃ¥k',
  Size: 'StÃ¸rrelse',
  AtLeast: 'minimum',
  AtMost: 'maksimum',
  Contains: 'inneholder',
  DoesNotContain: 'inneholder ikke',
  Matches: 'stemmer med',
  Bytes: 'byte',
  card: 'Kort',
  table: 'Tabell',
  ResultLinks: 'Resultat-lenker',
  EnableQuerySyntax: 'Aktiver sÃ¸k-syntaks',
  On: 'PÃ¥',
  Off: 'Av',
  Automatic: 'Automatisk',
  ResultsPerPage: 'Resultater per side',
  PreviousMonth: 'Forrige mÃ¥ned',
  NextMonth: 'Neste mÃ¥ned',
  Title: 'Tittel',
  TRFilters: 'Filters'
};

var setLocale = function setLocale(locale, data) {
  var _String$toLocaleStrin;
  //@ts-ignore
  String.toLocaleString((_String$toLocaleStrin = {}, _String$toLocaleStrin[locale] = data, _String$toLocaleStrin));
  //@ts-ignore
  String['locale'] = locale;
};
var setTranslation = function setTranslation(lang) {
  switch (lang) {
    case Language.EN:
      setLocale(lang, en);
      break;
    case Language.FR:
      setLocale(lang, fr);
      break;
    case Language.ZH_CN:
      setLocale(lang, zh_cn);
      break;
    case Language.ZH_TW:
      setLocale(lang, zh_tw);
      break;
    case Language.JA:
      setLocale(lang, ja);
      break;
    case Language.PT_BR:
      setLocale(lang, pt_br);
      break;
    case Language.RU:
      setLocale(lang, ru);
      break;
    case Language.ES_ES:
      setLocale(lang, es_es);
      break;
    case Language.KO:
      setLocale(lang, ko);
      break;
    case Language.FI:
      setLocale(lang, fi);
      break;
    case Language.SV:
      setLocale(lang, sv);
      break;
    case Language.PL:
      setLocale(lang, pl);
      break;
    case Language.DA:
      setLocale(lang, da);
      break;
    case Language.NO:
      setLocale(lang, no);
      break;
    default:
      setLocale(lang, en);
      break;
  }
};

var getJwtToken = function getJwtToken(cookieKey) {
  if (cookieKey) {
    return window.sessionStorage.getItem(cookieKey) || Cookies.get(cookieKey);
  }
  return undefined;
};
var generateHeader = function generateHeader(tokenSchema, token) {
  var headers = {
    'Content-Type': 'application/json'
  };
  if (token && tokenSchema) {
    return _extends({
      Authorization: tokenSchema + " " + token
    }, headers);
  }
  return headers;
};
// Function to get the value of a specific cookie by name
var getCookie = function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  // @ts-ignore
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};
// Function to delete the cookie
var deleteCookie = function deleteCookie(name, path) {
  if (path === void 0) {
    path = '/';
  }
  var cookieString = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + path + ";";
  document.cookie = cookieString;
  return true;
};
// Function to check if the cookie exists and delete it
var checkAndDeleteCookie = function checkAndDeleteCookie(cookieKey) {
  if (getCookie(cookieKey)) {
    return deleteCookie(cookieKey, '/');
  }
  return;
};
var renewToken = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(EndpointURL, logger, jwtTokenCookieKey, tokenSchema, searchHub) {
    var _searchHub;
    var token, headers, response, _yield$response$json, renewedToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          searchHub = (_searchHub = searchHub) == null ? void 0 : _searchHub.trim();
          token = getJwtToken(jwtTokenCookieKey);
          headers = generateHeader(tokenSchema, token);
          _context.prev = 3;
          _context.next = 6;
          return fetch(EndpointURL, {
            method: 'POST',
            headers: new Headers(headers),
            body: JSON.stringify({
              searchHub: searchHub
            })
          });
        case 6:
          response = _context.sent;
          if (!(response.status === 401 && jwtTokenCookieKey)) {
            _context.next = 9;
            break;
          }
          throw new Error('NON_AUTHORIZED_USER');
        case 9:
          _context.next = 11;
          return response.json();
        case 11:
          _yield$response$json = _context.sent;
          renewedToken = _yield$response$json.token;
          /**
           * Save renewedToken in sessionStorage
           */
          sessionStorage.setItem(SearchConstant.TOKEN_KEY, renewedToken);
          return _context.abrupt("return", renewedToken);
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](3);
          // This code should only work when we recieve 401 response
          if (_context.t0 instanceof Error && _context.t0.message === 'NON_AUTHORIZED_USER') {
            // checks either H&S token exists and remove it from Cookies
            // ideally, static value should be changed to dynamic value coming
            // from authoring
            logger.debug("Starting the process to remove " + jwtTokenCookieKey + " from Cookies!");
            // if we get error message 401, it always passes validation at the top
            checkAndDeleteCookie(jwtTokenCookieKey);
          }
          logger.error(_context.t0);
          return _context.abrupt("return", new Error('error occured'));
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 17]]);
  }));
  return function renewToken(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var useToken = function useToken(props, status, setStatus, logger) {
  var _props$apigeeEnvironm = props.apigeeEnvironment,
    apigeeEnvironment = _props$apigeeEnvironm === void 0 ? 'QA' : _props$apigeeEnvironm,
    jwtTokenCookieKey = props.jwtTokenCookieKey,
    _props$tokenSchema = props.tokenSchema,
    tokenSchema = _props$tokenSchema === void 0 ? 'Bearer' : _props$tokenSchema,
    shouldUseSearchToken = props.shouldUseSearchToken,
    searchHub = props.searchHub;
  useEffect(function () {
    logger.debug(UseCoveoLogs.APIGEE_USE_EFFECT);
    //Handle APIGEE if required.
    var getToken = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var renewedToken, newRenewedToken;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return renewToken(ApigeeEnvironmentEnum[apigeeEnvironment], logger, jwtTokenCookieKey, tokenSchema, searchHub);
            case 2:
              renewedToken = _context.sent;
              if (!(renewedToken instanceof Error)) {
                _context.next = 10;
                break;
              }
              _context.next = 6;
              return renewToken(ApigeeEnvironmentEnum[apigeeEnvironment], logger, jwtTokenCookieKey, tokenSchema, searchHub);
            case 6:
              newRenewedToken = _context.sent;
              setStatus(_extends({}, status, {
                apigeeToken: newRenewedToken
              }));
              _context.next = 11;
              break;
            case 10:
              setStatus(_extends({}, status, {
                apigeeToken: renewedToken
              }));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getToken() {
        return _ref.apply(this, arguments);
      };
    }();
    if (shouldUseSearchToken && !status.apigeeToken) {
      getToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, status.apigeeToken]);
};

var coveoInitSearch = function coveoInitSearch(mainPageRoot, searchBoxRoot, options) {
  return {
    Main: function Main(handleStatusChange) {
      return function () {
        //Search Page: Header/Footer/In Page
        if (mainPageRoot) {
          init(mainPageRoot, _extends({}, options, {
            externalComponents: Array.from(document.getElementsByClassName(SearchConstant.COVEO_SEARCHBOXES_CLASSNAME))
          }));
          handleStatusChange();
        }
      };
    },
    HeaderAndFooter: function HeaderAndFooter(searchPageUri) {
      return function () {
        //Scoped: Header/Footer
        initSearchbox(searchBoxRoot, searchPageUri, options);
        $$(searchBoxRoot).on(CoveoEventNames.BEFORE_REDIRECT, function (args) {
          var _document$querySelect;
          //checking if MegaMenu exists inside header
          var megaMenuSearchBoxPresent = isElementPresent('header .search-box-container');
          // Send analytics DCR event before redirecting to search results page without using Coveo Analytics
          if (megaMenuSearchBoxPresent) {
            var _window$_satellite;
            (_window$_satellite = window._satellite) == null || _window$_satellite.track(SearchConstant.INTEGRATED_MENU_SEARCH);
          }
          var tabValue = ((_document$querySelect = document.querySelector('.coveo-custom-searchbox-dropdown-selected')) == null || (_document$querySelect = _document$querySelect.textContent) == null ? void 0 : _document$querySelect.trim()) || '';
          if (tabValue) {
            // Redirect to the search results page with the search tab (#t) parameter
            args.currentTarget.Coveostate.attributes.t = tabValue;
            //update digital data object
            updateDigitalData('interaction', {
              itemText: tabValue
            });
          }
          sessionStorage.setItem(SearchConstant.ANALYTICS_SESSION_KEY, JSON.stringify({
            isRedirect: true
          }));
        });
      };
    },
    InPage: function InPage() {
      //Scoped: In Page
      if (mainPageRoot) {
        init(mainPageRoot, _extends({}, options, {
          externalComponents: [searchBoxRoot]
        }));
      }
    }
  };
};

var useInitCoveo = function useInitCoveo(props, searchBoxElId, searchResultElId, logger, status, setStatus) {
  var _props$loggerLevel = props.loggerLevel,
    loggerLevel = _props$loggerLevel === void 0 ? Logger.NOTHING : _props$loggerLevel,
    shouldRenderSearchBox = props.shouldRenderSearchBox,
    searchPageUri = props.searchPageUri,
    options = props.options;
  var handleStatusChange = function handleStatusChange() {
    setStatus(_extends({}, status, {
      initSearchPage: true
    }));
  };
  useEffect(function () {
    logger.debug(UseCoveoLogs.INIT_COVEO_USE_EFFECT);
    var initCoveo = function initCoveo() {
      var searchBoxRoot = document.getElementById(searchBoxElId);
      var mainPageRoot = document.getElementById(searchResultElId);
      /**
       * Get CoveoInitTypes Main | Header and Footer | In Page
       */
      var CoveoInitSearch = coveoInitSearch(mainPageRoot, searchBoxRoot, options);
      Logger$1.level = Logger$1[loggerLevel];
      coveoInitHandler(searchPageUri, window, shouldRenderSearchBox, status, CoveoInitSearch.Main(handleStatusChange), CoveoInitSearch.HeaderAndFooter(searchPageUri), CoveoInitSearch.InPage);
    };
    //either hard coded key or apigee token must be available to run this
    if (status.config && !status.init && (status.apigeeToken || status.apikey)) {
      initCoveo();
      setStatus(_extends({}, status, {
        init: true
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
};

var useConfigureCoveo = function useConfigureCoveo(props, status, setStatus, logger, baseUri) {
  /**
   * Configure Coveo CloudV2 with Token.
   */
  var queryParameters = props.queryParameters,
    jwtTokenCookieKey = props.jwtTokenCookieKey,
    _props$apigeeEnvironm = props.apigeeEnvironment,
    apigeeEnvironment = _props$apigeeEnvironm === void 0 ? 'QA' : _props$apigeeEnvironm,
    _props$tokenSchema = props.tokenSchema,
    tokenSchema = _props$tokenSchema === void 0 ? 'Bearer' : _props$tokenSchema,
    searchHub = props.searchHub,
    organizationId = props.organizationId,
    token = props.token;
  useEffect(function () {
    logger.debug(UseCoveoLogs.CLOUDV2_USE_EFFECT);
    var configure = function configure() {
      logger.debug(UseCoveoLogs.CONFIGURE_CLOUDV2);
      SearchEndpoint.configureCloudV2Endpoint('', status.apigeeToken, baseUri, {
        queryStringArguments: queryParameters,
        renewAccessToken: function renewAccessToken() {
          return renewToken(ApigeeEnvironmentEnum[apigeeEnvironment], logger, jwtTokenCookieKey, tokenSchema, searchHub);
        }
      });
    };
    if (!status.config && status.apigeeToken) {
      configure();
      setStatus(_extends({}, status, {
        config: true
      }));
      //set coveoConfigured to true in localstorage to indicate that Coveo has been configured
      localStorage.setItem('coveoConfigured', 'true');
    }
    // Add event listener for beforeunload to remove the item from localStorage
    var removeCoveoItem = function removeCoveoItem() {
      localStorage.removeItem('coveoConfigured');
    };
    window.addEventListener('beforeunload', removeCoveoItem);
    // Clean up the event listener when the component unmounts or on dependency change
    return function () {
      window.removeEventListener('beforeunload', removeCoveoItem);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
  /**
   * Configure Coveo with Token and Org ID Directly
   */
  useEffect(function () {
    logger.debug(UseCoveoLogs.COVEO_DIRECT_USE_EFFECT);
    var handleManualConfig = function handleManualConfig() {
      logger.debug(UseCoveoLogs.CONFIGURE_COVEO_DIRECT);
      SearchEndpoint.configureCloudV2Endpoint(organizationId, token, baseUri, {
        queryStringArguments: queryParameters
      });
    };
    if (status.apikey && !status.manualConfig) {
      handleManualConfig();
      setStatus(_extends({}, status, {
        manualConfig: true
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
};

var useCoveo = function useCoveo(props, searchBoxElId, searchResultElId, baseUri) {
  var organizationId = props.organizationId,
    token = props.token,
    _props$shouldUseSearc = props.shouldUseSearchToken,
    shouldUseSearchToken = _props$shouldUseSearc === void 0 ? true : _props$shouldUseSearc,
    _props$language = props.language,
    language = _props$language === void 0 ? 'en' : _props$language,
    _props$loggerLevel = props.loggerLevel,
    loggerLevel = _props$loggerLevel === void 0 ? Logger.NOTHING : _props$loggerLevel,
    searchHub = props.searchHub;
  var _useState = useState({
      config: false,
      manualConfig: false,
      init: false,
      initSearchPage: false,
      apigeeToken: undefined,
      apikey: shouldUseSearchToken === false && token && organizationId
    }),
    status = _useState[0],
    setStatus = _useState[1];
  var logger = useMemo(function () {
    return new SearchLogger(loggerLevel);
  }, [loggerLevel]);
  /**
   * Call APIGEE for Token
   */
  useToken(props, status, setStatus, logger);
  /**
   * Init Dictionary once token is renewed
   */
  if (status.apigeeToken) {
    initDictionaryThunk(document, sessionStorage, searchHub);
  }
  /**
   * Configure Coveo with Token or Token and Org ID Directly
   */
  useConfigureCoveo(props, status, setStatus, logger, baseUri);
  /**
   * Initialize Coveo
   */
  useInitCoveo(props, searchBoxElId, searchResultElId, logger, status, setStatus);
  //After Coveo is initalized, set translation
  setTranslation(language);
  moment.locale(language);
};

var useSearchResultCoveo = function useSearchResultCoveo(props) {
  var _props$language = props.language,
    language = _props$language === void 0 ? 'en' : _props$language,
    _props$loggerLevel = props.loggerLevel,
    loggerLevel = _props$loggerLevel === void 0 ? Logger.NOTHING : _props$loggerLevel,
    shouldEnableWithoutSearchBox = props.shouldEnableWithoutSearchBox,
    analytics = props.analytics;
  var _useState = useState({
      init: false,
      storageStatus: false
    }),
    status = _useState[0],
    setStatus = _useState[1];
  //check if Coveo.init has triggered
  var _useState2 = useState(false),
    eventReceived = _useState2[0],
    setEventReceived = _useState2[1];
  useEffect(function () {
    var logger = new SearchLogger(Logger.NOTHING);
    logger.loggerLevel = loggerLevel;
    logger.debug(SearchResultLogs.USE_SEARCH_RESULT_COVEO);
    var init$1 = function init$1() {
      if (shouldEnableWithoutSearchBox) {
        Logger$1.level = Logger$1[loggerLevel];
        // Set state to indicate event received, setting it to true early in case Coveo.init fails
        setEventReceived(true);
        init(document.querySelector('div[data-init-search-result=true]'));
      }
    };
    // call init() if Coveo is not initialized and localStorage has been set to true
    if (!status.init && status.storageStatus) {
      init$1();
      setStatus(_extends({}, status, {
        init: true
      }));
    }
  }, [status, loggerLevel, shouldEnableWithoutSearchBox, analytics]);
  // Polling to check if Coveo has been initialized
  // This is not the ideal technique but it is the only way to check if Coveo 'configureCloudV2Endpoint' has been completed
  useEffect(function () {
    if (!shouldEnableWithoutSearchBox || status.init) {
      return; // Exit if shouldEnableWithoutSearchBox is false or Coveo has been initialized
    }
    var interval = setInterval(function () {
      if (eventReceived) {
        clearInterval(interval);
      } else {
        var _ref;
        var configureCoveo = localStorage.getItem('coveoConfigured');
        var isCoveoConfigured = (_ref = configureCoveo === 'true') != null ? _ref : false; // Set a default value if configureCoveo is not 'true' or is null/undefined
        // if localStorage has been set to true, set storageStatus to true
        if (isCoveoConfigured) {
          setStatus(_extends({}, status, {
            storageStatus: true
          }));
          clearInterval(interval);
        }
      }
    }, SearchConstant.COVEO_INIT_DELAY); // Polling interval: every 1 second
    return function () {
      clearInterval(interval);
    };
  }, [eventReceived, status, shouldEnableWithoutSearchBox]);
  if (shouldEnableWithoutSearchBox) {
    //After Coveo is initalized, set translation
    setTranslation(language);
  }
};

/**
 * useScrollPosition hook controls the previous search result position when you come back from the article link.
 *
 *
 * @returns After render all DOM elements then it goes to the position where the user was.
 */
var useScrollPosition = function useScrollPosition(enablePreviousScrollPostion) {
  useEffect(function () {
    if (enablePreviousScrollPostion) {
      var handleScroll = function handleScroll() {
        localStorage.setItem('scrollPosition', window.scrollY.toString());
      };
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }
    return;
  }, [enablePreviousScrollPostion]);
  useEffect(function () {
    if (enablePreviousScrollPostion) {
      var previousScrollPosition = localStorage.getItem('scrollPosition');
      var scrollToPosition = function scrollToPosition() {
        window.scrollTo({
          top: parseInt(previousScrollPosition),
          behavior: 'smooth'
        });
      };
      if (previousScrollPosition) {
        $$(document.body).on('newResultsDisplayed', scrollToPosition);
        localStorage.removeItem('scrollPosition');
      }
      window.history.scrollRestoration = 'manual';
      return function () {
        $$(document.body).off('newResultsDisplayed', scrollToPosition);
      };
    }
    return;
  }, [enablePreviousScrollPostion]);
};

/**
 * Custom React Hook for handling Coveo query errors.
 *
 * This hook monitors Coveo query events for errors and successes and provides a boolean
 * value indicating whether an error has occurred during a Coveo search query.
 *
 * @param loggerLevel Optional. The logging level for the search logger.
 * @returns `true` if there is an error in the query, `false` otherwise.
 *
 * @remarks If the logger is enabled (when `analyticsEnable` is `true`), query errors are logged,
 * and the hook allows you to specify the logging level using the `loggerLevel` parameter.
 */
var useQueryErrorHandler = function useQueryErrorHandler(loggerLevel) {
  var _useState = useState(false),
    hasError = _useState[0],
    setHasError = _useState[1];
  var handleQuerySuccess = useCallback(function () {
    return setHasError(false);
  }, []);
  useEffect(function () {
    var _initAnalytics = initAnalytics(Coveo$1, document),
      analyticsEnable = _initAnalytics.analyticsEnable,
      refHandler = _initAnalytics.refHandler,
      afterInitializationHandler = _initAnalytics.afterInitializationHandler;
    var searchResultElement = document.getElementById(SearchConstant.COVEO_SEARCH_RESULT_ID);
    var logger = new SearchLogger(Logger.NOTHING);
    logger.loggerLevel = loggerLevel || logger.loggerLevel;
    logger == null || logger.debug(SearchResultLogs.SET_HAS_ERROR);
    var handleQueryError = function handleQueryError() {
      if (analyticsEnable) {
        var _window$_satellite;
        setQueryError(window, setHasError);
        (_window$_satellite = window._satellite) == null || _window$_satellite.track(SearchConstant.INTERNAL_SEARCH_ERROR);
      } else {
        setHasError(true);
      }
    };
    $$(document.body).on(CoveoEventNames.QUERY_ERROR, handleQueryError);
    $$(document.body).on(CoveoEventNames.QUERY_SUCCESS, handleQuerySuccess);
    return function () {
      var _Coveo$AnalyticsEvent;
      $$(document.body).off(CoveoEventNames.QUERY_ERROR, handleQueryError);
      $$(document.body).off(CoveoEventNames.QUERY_SUCCESS, handleQuerySuccess);
      if ((_Coveo$AnalyticsEvent = AnalyticsEvents) != null && _Coveo$AnalyticsEvent.analyticsEventReady) {
        $$(document.body).off(AnalyticsEvents.analyticsEventReady, refHandler);
      }
      if (searchResultElement) {
        $$(searchResultElement).off(CoveoEventNames.AFTER_INITIALIZATION, afterInitializationHandler);
      }
    };
  }, [handleQuerySuccess, loggerLevel]);
  return hasError;
};

/**
 * Custom React hook to set the default sort value based on the provided `sortData` and template.
 *
 * @param {ISortData[] | undefined} sortData - An array of sorting criteria data.
 * @returns {void}
 */
var firstQueryRender = true;
var useHandleSortCriteria = function useHandleSortCriteria(sortData, sortEnableDefaultSortCriteria) {
  /**
   * Handler function to change the sort value when a new query is triggered.
   *
   * @param {unknown} _ - Unused parameter.
   * @param {Object} data - An object containing information about the event.
   * @param {unknown} data.origin - The origin of the event.
   * @returns {void}
   */
  useEffect(function () {
    if (!sortEnableDefaultSortCriteria) return;
    var root = document.body;
    var changeSortValueHandler = function changeSortValueHandler(_, data) {
      var _document$querySelect;
      // Get the current query text from the input field.
      var queryText = (_document$querySelect = document.querySelector('input')) == null ? void 0 : _document$querySelect.value;
      /**
       * Don't set the sort value on subsequent renders if the NEW_QUERY's origin
       * was pager, results per page click or manual selection of sort value (data.origin === undefined)
       */
      if (!firstQueryRender) {
        if (!data.origin || data.origin.type === 'Pager' || data.origin.type === 'ResultsPerPage') return;
      }
      if (!sortData) return;
      firstQueryRender = false;
      // Set the new sort value based on the presence of query text and provided sort data.
      queryText ? setNewSortValue(root, sortData[0].sortCriteria) : setNewSortValue(root, sortData[1].sortCriteria);
    };
    // Attach the 'newQuery' event listener to handle future query
    $$(root).on(CoveoEventNames.NEW_QUERY, changeSortValueHandler);
    return function () {
      // Cleanup: Remove the 'newQuery' event listener when the component is unmounted.
      $$(root).off(CoveoEventNames.NEW_QUERY, changeSortValueHandler);
    };
  }, [sortData, sortEnableDefaultSortCriteria]);
};

/**
 * A custom React hook to monitor search results and network status using Coveo Search UI events.
 * It listens for the "NO_RESULTS" event, online/offline status changes, and new queries.
 *
 * @returns An object containing information about search results and network status.
 */
var useCoveoSearchAndNetworkStatus = function useCoveoSearchAndNetworkStatus() {
  var _useState = useState(false),
    noResults = _useState[0],
    setNoResults = _useState[1];
  var _useState2 = useState(false),
    isOffline = _useState2[0],
    setIsOffline = _useState2[1];
  useEffect(function () {
    /**
     * Handler function to set noResults state to true when there are no search results.
     */
    var handleNoResults = function handleNoResults() {
      setNoResults(true);
    };
    /**
     * Handler function to set noResults state to false when there are search results.
     */
    var handleResults = function handleResults(_, data) {
      var _data$results;
      if ((data == null || (_data$results = data.results) == null ? void 0 : _data$results.totalCount) > 0) {
        setNoResults(false);
      } else {
        setNoResults(true);
      }
    };
    /**
     * Handler function to set isOffline state to false when the network connection is online.
     */
    var handleOnline = function handleOnline() {
      setIsOffline(false);
    };
    /**
     * Handler function to set isOffline state to true when the network connection is offline.
     */
    var handleOffline = function handleOffline() {
      setIsOffline(true);
    };
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    $$(document.body).on(CoveoEventNames.NO_RESULTS, handleNoResults);
    $$(document.body).on(CoveoEventNames.PREPROCESS_RESULTS, handleResults);
    // Cleanup: Remove event listeners when unmounted.
    return function () {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      $$(document.body).off(CoveoEventNames.NO_RESULTS, handleNoResults);
      $$(document.body).off(CoveoEventNames.PREPROCESS_RESULTS, handleResults);
    };
  }, []);
  return {
    noResults: noResults,
    isOffline: isOffline
  };
};

/**
 * Custom React Hook for changeAnalyticsCustomData event.
 *
 * This hook monitors 'changeAnalyticsCustomData' events for 'ClickEvent', 'SearchEvent', and 'CustomEvent' in Coveo,
 * and it provides a method to pass an object containing the 'customData' properties that you wish to add.
 *
 * @param properties - an object with properties you want to edit in customData
 * For ex:
 * {
 * product:'Legal',
 * langauage:'en',
 * pagetype:(args)=>args.resultData?.raw?.pagetype
 * }
 *
 * @returns {void}
 */
var useChangeAnalyticsCustomData = function useChangeAnalyticsCustomData(properties) {
  useEffect(function () {
    var handler = function handler(_, args) {
      Object.entries(properties).forEach(function (_ref) {
        var key = _ref[0],
          value = _ref[1];
        var computedValue = typeof value === 'function' ? value(args) : value;
        if (computedValue) args.metaObject[key] = computedValue;
      });
    };
    $$(document.body).on(CoveoEventNames.CHANGE_ANALYTICS_CUSTOM_DATA, handler);
    return function () {
      $$(document.body).off(CoveoEventNames.CHANGE_ANALYTICS_CUSTOM_DATA, handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [properties]);
};

/**
 * Custom React Hook for buildingQuery event.
 *
 * This hook monitors buildingQuery event which occurs whenever coveo send or create a query event
 * @param {string} elementID -- HTML element id
 * @param properties -- properties to modify
 *
 * @returns {void}
 * const properties = {
    locale: 'en',
    requiredFields: (args) =>
      args.queryBuilder.requiredFields.concat('newfield'),
  };
 *
 */
var useBuildingQueryEvent = function useBuildingQueryEvent(elementID, properties) {
  useEffect(function () {
    var element = document.getElementById(elementID);
    if (!element || !properties) {
      return;
    }
    var handler = function handler(_, args) {
      Object.entries(properties).forEach(function (_ref) {
        var key = _ref[0],
          value = _ref[1];
        var computedValue = typeof value === 'function' ? value(args) : value;
        if (computedValue) args.queryBuilder[key] = computedValue;
      });
    };
    $$(element).on(CoveoEventNames.BUILDING_QUERY, handler);
    return function () {
      $$(element).off(CoveoEventNames.BUILDING_QUERY, handler);
    };
  }, [properties, elementID]);
};

var CacheContext = /*#__PURE__*/createContext(undefined);
/**
 * Provides a cache for contextual search results.
 */
var ContextualSearchCacheProvider = function ContextualSearchCacheProvider(_ref) {
  var children = _ref.children;
  var _useState = useState({}),
    cache = _useState[0],
    setCache = _useState[1];
  return React.createElement(CacheContext.Provider, {
    value: {
      cache: cache,
      setCache: setCache
    }
  }, children);
};
/**
 * Custom hook that provides access to the contextual search cache context.
 * @returns The contextual search cache context.
 * @throws {Error} If used outside of a ContextualSearchCacheProvider.
 */
var useContextualSearchCache = function useContextualSearchCache() {
  var context = useContext(CacheContext);
  if (!context) {
    throw new Error('useSearchContextualCache must be used within a ContextualSearchCacheProvider');
  }
  return context;
};

var PRODUCTS_VALUE = {
  'ONESOURCE Income Tax': ['tr_productscreen', 'tr_taxform']
};
/**
 * Extracts the breadcrumb values from a string of breadcrumbs.
 *
 * @param breadcrumbs  - The string of breadcrumbs to extract values from.
 * @returns An array of extracted breadcrumb values.
 */
var extractBreadcrumbValues = function extractBreadcrumbValues(breadcrumbs) {
  return breadcrumbs.split('>').map(function (part) {
    return part.trim();
  }).reverse();
};
/**
 * Generates unique data values from the given query results based on the specified keys.
 *
 * @param resultData - The query results containing the data.
 * @param keys - The keys to extract the data values from.
 * @returns An object containing unique data values for each key.
 */
var generateUniqueDatavaluesFromResults = function generateUniqueDatavaluesFromResults(resultData, keys) {
  var _resultData$results;
  var uniqueValues = {};
  keys.forEach(function (key) {
    uniqueValues[key] = [];
  });
  resultData == null || (_resultData$results = resultData.results) == null || _resultData$results.forEach(function (item) {
    keys.forEach(function (key) {
      var rawValue = item.raw[key];
      if (rawValue) {
        var values = rawValue.split(',');
        for (var i = 0; i < values.length; i++) {
          var trimmedValue = values[i].trim();
          if (trimmedValue && !uniqueValues[key].includes(trimmedValue)) {
            uniqueValues[key].push(trimmedValue);
          }
        }
      }
    });
  });
  return uniqueValues;
};
/**
 * Calculates the score between a breadcrumb and a result.
 * @param breadcrumb - The breadcrumb string.
 * @param result - The result string.
 * @returns The calculated score.
 */
var calculateScore = function calculateScore(breadcrumb, result) {
  var breadcrumbWords = breadcrumb.toLowerCase().split(/\s+/).filter(function (word) {
    return word.length > 2;
  });
  var resultWords = result.toLowerCase().split(/[-\s]+/).filter(function (word) {
    return word.length > 2;
  });
  var score = 0;
  if (breadcrumb.toLowerCase() === result.toLowerCase()) {
    return 100;
  }
  for (var _iterator = _createForOfIteratorHelperLoose(breadcrumbWords), _step; !(_step = _iterator()).done;) {
    var bWord = _step.value;
    for (var _iterator2 = _createForOfIteratorHelperLoose(resultWords), _step2; !(_step2 = _iterator2()).done;) {
      var rWord = _step2.value;
      if (bWord === rWord) {
        score += 3;
      } else if (bWord.includes(rWord) || rWord.includes(bWord)) {
        score += 1;
      }
    }
  }
  return score;
};
/**
 * Finds the best matches between breadcrumb values and unique values from query results.
 * @param breadcrumbValues - An array of breadcrumb values.
 * @param uniqueValuesFromQueryResults - An array of unique values from query results.
 * @returns An array of best matches between breadcrumb values and unique values.
 */
var findMatches = function findMatches(breadcrumbValues, uniqueValuesFromQueryResults) {
  var matches = [];
  var seen = {};
  for (var _iterator3 = _createForOfIteratorHelperLoose(breadcrumbValues), _step3; !(_step3 = _iterator3()).done;) {
    var breadcrumb = _step3.value;
    var bestMatch = '';
    var bestScore = 0;
    for (var _iterator4 = _createForOfIteratorHelperLoose(uniqueValuesFromQueryResults), _step4; !(_step4 = _iterator4()).done;) {
      var result = _step4.value;
      if (!seen[result]) {
        var score = calculateScore(breadcrumb, result);
        if (score > bestScore) {
          bestScore = score;
          bestMatch = result;
        }
      }
    }
    if (bestMatch && !seen[bestMatch] && bestScore > 2) {
      matches.push(bestMatch);
      seen[bestMatch] = true;
    }
  }
  return matches;
};
/**
 * Validates the breadcrumb values and extracts the query value based on the provided parameters.
 *
 * @param {string} product - The product value.
 * @param {string[]} breadcrumbValues - The array of breadcrumb values.
 * @param {string[]} compareWithArray - The array of values to compare with.
 * @param {ContextualSearchCache} cache - The cache object.
 * @param {SetContextualSearchCache} setCache - The function to set the cache object.
 * @returns {Promise<{ error: string; matched: Record<string, string[]> }>} - A promise that resolves to an object containing the error message and the matched values.
 */
var validateBreadcrumbAndExtractQueryValue = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(product, breadcrumbValues, compareWithArray, cache, setCache) {
    var resultDataOfkeyToGenerateBreadcrumbValue, cacheOldUniqueResultData, _Coveo$SearchEndpoint, compareWith, resultData, uniqueValuesFromResults, matchesObject, key, matches;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          resultDataOfkeyToGenerateBreadcrumbValue = product + "_breadcrumbsValues";
          cacheOldUniqueResultData = {};
          if (!cache[resultDataOfkeyToGenerateBreadcrumbValue]) {
            _context.next = 7;
            break;
          }
          cacheOldUniqueResultData = cache[resultDataOfkeyToGenerateBreadcrumbValue];
          _context.next = 14;
          break;
        case 7:
          compareWith = compareWithArray.map(function (item) {
            return "@" + item;
          });
          _context.next = 10;
          return Coveo$1 == null || (_Coveo$SearchEndpoint = SearchEndpoint) == null || (_Coveo$SearchEndpoint = _Coveo$SearchEndpoint.endpoints['default']) == null ? void 0 : _Coveo$SearchEndpoint.search({
            q: '',
            cq: "@tr_product=" + product + " AND (" + compareWith.join(' OR ') + ")",
            fieldsToInclude: compareWithArray,
            numberOfResults: 500
          });
        case 10:
          resultData = _context.sent;
          uniqueValuesFromResults = generateUniqueDatavaluesFromResults(resultData, compareWithArray);
          cacheOldUniqueResultData = uniqueValuesFromResults;
          setCache(function (prevCache) {
            var _extends2;
            return _extends({}, prevCache, (_extends2 = {}, _extends2[resultDataOfkeyToGenerateBreadcrumbValue] = uniqueValuesFromResults, _extends2));
          });
        case 14:
          matchesObject = {};
          _context.t0 = _regeneratorRuntime().keys(cacheOldUniqueResultData);
        case 16:
          if ((_context.t1 = _context.t0()).done) {
            _context.next = 24;
            break;
          }
          key = _context.t1.value;
          matches = findMatches(breadcrumbValues, cacheOldUniqueResultData[key]);
          if (!(matches.length > 0)) {
            _context.next = 22;
            break;
          }
          matchesObject[key] = matches;
          return _context.abrupt("return", {
            error: '',
            matched: matchesObject
          });
        case 22:
          _context.next = 16;
          break;
        case 24:
          return _context.abrupt("return", {
            error: 'No matching breadcrumbs found.',
            matched: {}
          });
        case 27:
          _context.prev = 27;
          _context.t2 = _context["catch"](0);
          return _context.abrupt("return", {
            error: _context.t2.message,
            matched: {}
          });
        case 30:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 27]]);
  }));
  return function validateBreadcrumbAndExtractQueryValue(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Custom hook for performing contextual search based on breadcrumbs, product name, and other query parameters.
 *
 * @param breadcrumbs - The breadcrumbs string.
 * @param productName - The product name string.
 * @param otherQueryParams - Additional query parameters as a record of key-value pairs.
 * @param numberOfResults - The number of results to retrieve.
 * @returns An object containing the search results, loading state, and error message.
 */
var useContextualSearch = function useContextualSearch(breadcrumbs, productName, otherQueryParams, numberOfResults) {
  var _useState = useState([]),
    results = _useState[0],
    setResults = _useState[1];
  var _useState2 = useState(true),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(null),
    error = _useState3[0],
    setError = _useState3[1];
  var _useContextualSearchC = useContextualSearchCache(),
    cache = _useContextualSearchC.cache,
    setCache = _useContextualSearchC.setCache;
  var keysToGenerateBreadcrumbValue = useMemo(function () {
    return PRODUCTS_VALUE[productName] || [];
  }, [productName]);
  var breadcrumbValues = useMemo(function () {
    return extractBreadcrumbValues(breadcrumbs);
  }, [breadcrumbs]);
  var performSearch = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var cacheKey, _Coveo$SearchEndpoint2, _yield$validateBreadc, validationError, matched, valueExtracted, constantQuery, constantQueryParams, resultData, searchResults;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (keysToGenerateBreadcrumbValue.length) {
            _context2.next = 5;
            break;
          }
          setResults([]);
          setLoading(false);
          setError('No articles found with the given product name.');
          return _context2.abrupt("return");
        case 5:
          cacheKey = productName + "_" + breadcrumbValues.join('_');
          if (!cache[cacheKey]) {
            _context2.next = 11;
            break;
          }
          setResults(cache[cacheKey]);
          setLoading(false);
          setError(null);
          return _context2.abrupt("return");
        case 11:
          _context2.prev = 11;
          setLoading(true);
          setError(null);
          _context2.next = 16;
          return validateBreadcrumbAndExtractQueryValue(productName, breadcrumbValues, keysToGenerateBreadcrumbValue, cache, setCache);
        case 16:
          _yield$validateBreadc = _context2.sent;
          validationError = _yield$validateBreadc.error;
          matched = _yield$validateBreadc.matched;
          if (Object.keys(matched).length) {
            _context2.next = 23;
            break;
          }
          setResults([]);
          setError(validationError);
          return _context2.abrupt("return");
        case 23:
          valueExtracted = "(" + Object.entries(matched).map(function (_ref3) {
            var key = _ref3[0],
              values = _ref3[1];
            return "(" + values.map(function (value) {
              return "@" + key + "=\"" + value + "\"";
            }).join(' OR ') + ")";
          }).join(' OR ') + ")";
          constantQuery = _extends({
            tr_product: productName
          }, otherQueryParams);
          constantQueryParams = Object.keys(constantQuery).map(function (key) {
            return "@" + key + "=\"" + constantQuery[key] + "\"";
          }).concat(valueExtracted).join(' AND ');
          _context2.next = 28;
          return Coveo$1 == null || (_Coveo$SearchEndpoint2 = SearchEndpoint) == null || (_Coveo$SearchEndpoint2 = _Coveo$SearchEndpoint2.endpoints['default']) == null ? void 0 : _Coveo$SearchEndpoint2.search({
            q: '',
            aq: constantQueryParams,
            numberOfResults: numberOfResults
          });
        case 28:
          resultData = _context2.sent;
          searchResults = (resultData == null ? void 0 : resultData.results.map(function (result) {
            return result;
          })) || [];
          setResults(searchResults);
          setCache(function (prevCache) {
            var _extends3;
            return _extends({}, prevCache, (_extends3 = {}, _extends3[cacheKey] = searchResults, _extends3));
          });
          _context2.next = 37;
          break;
        case 34:
          _context2.prev = 34;
          _context2.t0 = _context2["catch"](11);
          setError(_context2.t0.message);
        case 37:
          _context2.prev = 37;
          setLoading(false);
          return _context2.finish(37);
        case 40:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[11, 34, 37, 40]]);
  })), [breadcrumbValues, cache, keysToGenerateBreadcrumbValue, numberOfResults, otherQueryParams, productName, setCache]);
  var handleNewQuery = useCallback(function () {
    performSearch();
  }, [performSearch]);
  useEffect(function () {
    $$(document.body).on('newQuery', handleNewQuery);
    return function () {
      $$(document.body).off('newQuery', handleNewQuery);
    };
  }, [handleNewQuery]);
  return {
    results: results,
    loading: loading,
    error: error
  };
};

var _excluded = ["children"];
var SearchBoxContext = /*#__PURE__*/createContext(null);
var SearchBoxProvider = function SearchBoxProvider(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement(SearchBoxContext.Provider, {
    value: rest,
    children: children
  });
};
var useSearchBoxProps = function useSearchBoxProps() {
  return useContext(SearchBoxContext);
};

var SearchBoxDefault = function SearchBoxDefault() {
  var _useSearchBoxProps = useSearchBoxProps(),
    enableOmnibox = _useSearchBoxProps.enableOmnibox,
    numberOfSuggestions = _useSearchBoxProps.numberOfSuggestions,
    partialMatchKeywords = _useSearchBoxProps.partialMatchKeywords,
    enablePartialMatch = _useSearchBoxProps.enablePartialMatch,
    inline = _useSearchBoxProps.inline,
    style = _useSearchBoxProps.style,
    searchBoxPlaceHolder = _useSearchBoxProps.searchBoxPlaceHolder,
    logger = _useSearchBoxProps.logger,
    enableResetSearchOnClear = _useSearchBoxProps.enableResetSearchOnClear;
  logger == null || logger.debug(SearchBoxLogs.SEARCHBOX_DEFAULT);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-search-section"
  }, React.createElement("div", {
    className: "CoveoSearchbox",
    "data-enable-omnibox": enableOmnibox,
    "data-number-of-suggestions": numberOfSuggestions,
    "data-partial-match-keywords": partialMatchKeywords,
    "data-enable-partial-match": enablePartialMatch,
    "data-inline": inline,
    style: _extends({}, style == null ? void 0 : style.input),
    "data-placeholder": searchBoxPlaceHolder,
    "data-trigger-query-on-clear": enableResetSearchOnClear
  })));
};

var SearchBoxButton = function SearchBoxButton() {
  var _useSearchBoxProps = useSearchBoxProps(),
    style = _useSearchBoxProps.style,
    searchBoxPlaceHolder = _useSearchBoxProps.searchBoxPlaceHolder,
    logger = _useSearchBoxProps.logger;
  logger == null || logger.debug(SearchBoxLogs.SEARCHBOX_BUTTON);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-tr-search-container"
  }, React.createElement("div", {
    className: "CoveoSearchbox coveo-tr-search-box",
    "data-enable-omnibox": "true",
    "data-add-search-button": "false",
    style: _extends({}, style == null ? void 0 : style.input),
    "data-placeholder": searchBoxPlaceHolder
  }), React.createElement("a", {
    className: "CoveoSearchButton coveo-tr-search-button coveo-accessible-button",
    role: "button",
    "aria-label": 'Search'.toLocaleString(),
    tabIndex: 0,
    style: _extends({}, style == null ? void 0 : style.button)
  }, React.createElement("span", {
    className: "coveo-search-button",
    style: _extends({}, style == null ? void 0 : style.buttonText)
  }, 'Search'.toLocaleString()))));
};

/**
 * Adds the button role and removes the aria-selected attribute to button like elements
 * found with the passed selectors.
 * Removes the focusable attribute from the svg children of those elements.
 * @param parentIdName Parent's element id name where the search button is located
 * @param elementSelectors Selectors to be used to find the button like elements
 * with the selector to find their children SVGs
 */
function handleBtnsAcccesibility(parentIdName, elementsSelectors) {
  var parentElement = document.getElementById(parentIdName);
  elementsSelectors.forEach(function (elementSelector) {
    var buttonLikeElement = parentElement == null ? void 0 : parentElement.querySelector(elementSelector.buttonLikeSelector);
    if (parentElement && buttonLikeElement) {
      buttonLikeElement.setAttribute('role', 'button');
      buttonLikeElement.removeAttribute('aria-selected');
      //remove svg children focusable attribute
      var svgElements = buttonLikeElement.querySelectorAll(elementSelector.svgChildSelector);
      svgElements.forEach(function (svgElement) {
        svgElement.removeAttribute('focusable');
      });
    }
  });
}
/**
 * Gets the next dropdown option id to be focused
 * @param currentId id of the current focused dropdown option
 * @param numberOfElements max number of current dropdown options
 * @param keyName either arrow down or arrow up
 * @returns string id of the next dropdown option to be focused
 */
function getNextDropdownId(currentId, numberOfElements, keyName) {
  var currentNumber = parseInt(currentId.split('combo-')[1], 10);
  var nextNumber = currentNumber;
  if (keyName === 'ArrowDown') {
    nextNumber = currentNumber >= numberOfElements ? numberOfElements : currentNumber + 1;
  } else {
    nextNumber = currentNumber > 0 ? currentNumber - 1 : 0;
  }
  return "combo-" + nextNumber;
}
/**
 * Removes 'role' attribute from elements found with the specified selector
 * @param selector string selector of elements to remove the 'role' attribute
 */
function removeRoleAttribute(selector) {
  var elements = document.querySelectorAll(selector);
  elements.forEach(function (element) {
    element.removeAttribute('role');
  });
}

var SearchBoxIcon = function SearchBoxIcon() {
  var _useSearchBoxProps = useSearchBoxProps(),
    enableOmnibox = _useSearchBoxProps.enableOmnibox,
    numberOfSuggestions = _useSearchBoxProps.numberOfSuggestions,
    partialMatchKeywords = _useSearchBoxProps.partialMatchKeywords,
    enablePartialMatch = _useSearchBoxProps.enablePartialMatch,
    inline = _useSearchBoxProps.inline,
    style = _useSearchBoxProps.style,
    searchBoxPlaceHolder = _useSearchBoxProps.searchBoxPlaceHolder,
    logger = _useSearchBoxProps.logger,
    enableResetSearchOnClear = _useSearchBoxProps.enableResetSearchOnClear,
    _useSearchBoxProps$en = _useSearchBoxProps.enableNewBranding,
    enableNewBranding = _useSearchBoxProps$en === void 0 ? false : _useSearchBoxProps$en;
  logger == null || logger.debug(SearchBoxLogs.SEARCHBOX_ICON);
  /**
   * Calls function to fix some accesibility related attributes of the search box
   * and clear buttons
   */
  useEffect(function () {
    var fieldValuesPositionHandler = function fieldValuesPositionHandler() {
      handleBtnsAcccesibility('SearchBoxIcon', [{
        buttonLikeSelector: '.CoveoSearchButton',
        svgChildSelector: '.coveo-search-button-svg'
      }, {
        buttonLikeSelector: '.magic-box-clear',
        svgChildSelector: '.magic-box-clear-svg'
      }]);
    };
    Coveo.$$(document.body).on(CoveoEventNames.DEFERRED_QUERY_SUCCESS, fieldValuesPositionHandler);
    //Clean up
    return function () {
      Coveo.$$(document.body).off(CoveoEventNames.DEFERRED_QUERY_SUCCESS, fieldValuesPositionHandler);
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-search-section"
  }, React.createElement("div", {
    id: "SearchBoxIcon",
    className: classNames('CoveoSearchbox coveo-tr-searchbox-icon coveo-tr-searchbox-icon--alone', {
      'coveo-tr-searchbox-icon--new-branding':
      //@ts-ignore
      enableNewBranding === true || enableNewBranding === 'true'
    }),
    "data-enable-omnibox": enableOmnibox,
    "data-number-of-suggestions": numberOfSuggestions,
    "data-partial-match-keywords": partialMatchKeywords,
    "data-enable-partial-match": enablePartialMatch,
    "data-inline": inline,
    style: _extends({}, style == null ? void 0 : style.input),
    "data-placeholder": searchBoxPlaceHolder,
    "data-trigger-query-on-clear": enableResetSearchOnClear
  })));
};

var MagnifyingGlassIcon = function MagnifyingGlassIcon() {
  return React.createElement("span", {
    className: "tr-Svg"
  }, React.createElement("span", {
    className: "tr-Svg-inner"
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M22 22l-5.6-5.6",
    "data-color": "color-2"
  }), React.createElement("path", {
    d: "M10 1a9 9 0 1 0 0 18 9 9 0 1 0 0-18z"
  })))));
};

var SearchBoxWithoutInput = function SearchBoxWithoutInput(props) {
  var _useSearchBoxProps = useSearchBoxProps(),
    enableOmnibox = _useSearchBoxProps.enableOmnibox,
    numberOfSuggestions = _useSearchBoxProps.numberOfSuggestions,
    partialMatchKeywords = _useSearchBoxProps.partialMatchKeywords,
    enablePartialMatch = _useSearchBoxProps.enablePartialMatch,
    inline = _useSearchBoxProps.inline,
    style = _useSearchBoxProps.style,
    searchBoxPlaceHolder = _useSearchBoxProps.searchBoxPlaceHolder,
    logger = _useSearchBoxProps.logger,
    enableResetSearchOnClear = _useSearchBoxProps.enableResetSearchOnClear;
  var onChange = props.onChange;
  var _useState = useState(false),
    searchBoxExpanded = _useState[0],
    setSearchBoxExpanded = _useState[1];
  logger == null || logger.debug(SearchBoxLogs.SEARCHBOX_WITHOUT_INPUT);
  useEffect(function () {
    logger == null || logger.debug(SearchBoxLogs.SEARCHBOX_WITHOUT_INPUT_USE_EFFECT);
    var closeSearchBox = function closeSearchBox() {
      setSearchBoxExpanded(false);
      onChange(false);
    };
    var clickOutside = function clickOutside(e) {
      var _document$querySelect;
      if (!((_document$querySelect = document.querySelector('.coveo-search-section')) != null && _document$querySelect.contains(e.target))) {
        closeSearchBox();
      }
    };
    var clickEsc = function clickEsc(e) {
      if (e.key === KeyboardEnums.ESC) {
        var _document$querySelect2;
        closeSearchBox();
        (_document$querySelect2 = document.querySelector('.tr-SiteHeader-searchButton')) == null || _document$querySelect2.focus();
      }
    };
    var clickTab = function clickTab(e) {
      if (e.key === KeyboardEnums.TAB) {
        var targetElement = e.target;
        // Check if the target element has the class 'CoveoSearchButton'
        if (targetElement != null && targetElement.classList.contains('CoveoSearchButton')) {
          closeSearchBox();
        }
      }
    };
    if (searchBoxExpanded) {
      var _document$querySelect3, _document$querySelect4, _document$querySelect5;
      (_document$querySelect3 = document.querySelector('body')) == null || _document$querySelect3.addEventListener('mousedown', clickOutside);
      (_document$querySelect4 = document.querySelector('body')) == null || _document$querySelect4.addEventListener('keyup', clickEsc);
      (_document$querySelect5 = document.querySelector('body')) == null || _document$querySelect5.addEventListener('keydown', clickTab);
    }
    return function () {
      var _document$querySelect6, _document$querySelect7, _document$querySelect8;
      (_document$querySelect6 = document.querySelector('body')) == null || _document$querySelect6.removeEventListener('mousedown', clickOutside);
      (_document$querySelect7 = document.querySelector('body')) == null || _document$querySelect7.removeEventListener('keyup', clickEsc);
      (_document$querySelect8 = document.querySelector('body')) == null || _document$querySelect8.removeEventListener('keydown', clickTab);
    };
  }, [onChange, searchBoxExpanded, logger]);
  var toggleSearchBox = function toggleSearchBox() {
    setSearchBoxExpanded(!searchBoxExpanded);
    onChange(!searchBoxExpanded);
    setTimeout(function () {
      document.querySelector('.magic-box-input input').focus();
    });
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-tr-searchbox-header"
  }, React.createElement("div", {
    className: classNames('coveo-search-section coveo-search-section-withoutInput', {
      'coveo-search-section-withoutInput-expanded': searchBoxExpanded
    })
  }, React.createElement("div", {
    className: "CoveoSearchbox  coveo-tr-searchbox-withoutInput",
    "data-enable-omnibox": enableOmnibox,
    "data-number-of-suggestions": numberOfSuggestions,
    "data-partial-match-keywords": partialMatchKeywords,
    "data-enable-partial-match": enablePartialMatch,
    "data-inline": inline,
    style: _extends({}, style == null ? void 0 : style.input),
    "data-placeholder": searchBoxPlaceHolder,
    "data-trigger-query-on-clear": enableResetSearchOnClear
  })), !searchBoxExpanded && React.createElement("div", {
    className: "coveo-searchboxWithoutInput-toggle-buttons coveo-searchboxWithoutInput-toggle-buttons-expanded"
  }, React.createElement("button", {
    onClick: toggleSearchBox,
    className: "tr-SiteHeader-searchButton",
    "aria-label": "Search"
  }, React.createElement(MagnifyingGlassIcon, null)))));
};

var SearchBoxDark = function SearchBoxDark() {
  var _useSearchBoxProps = useSearchBoxProps(),
    enableOmnibox = _useSearchBoxProps.enableOmnibox,
    numberOfSuggestions = _useSearchBoxProps.numberOfSuggestions,
    partialMatchKeywords = _useSearchBoxProps.partialMatchKeywords,
    enablePartialMatch = _useSearchBoxProps.enablePartialMatch,
    inline = _useSearchBoxProps.inline,
    style = _useSearchBoxProps.style,
    searchBoxPlaceHolder = _useSearchBoxProps.searchBoxPlaceHolder,
    logger = _useSearchBoxProps.logger,
    enableResetSearchOnClear = _useSearchBoxProps.enableResetSearchOnClear;
  logger == null || logger.debug(SearchBoxLogs.SEARCHBOX_DARK);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-search-section"
  }, React.createElement("div", {
    className: "CoveoSearchbox coveo-tr-searchbox-dark",
    "data-enable-omnibox": enableOmnibox,
    "data-number-of-suggestions": numberOfSuggestions,
    "data-partial-match-keywords": partialMatchKeywords,
    "data-enable-partial-match": enablePartialMatch,
    "data-inline": inline,
    style: _extends({}, style == null ? void 0 : style.input),
    "data-placeholder": searchBoxPlaceHolder,
    "data-trigger-query-on-clear": enableResetSearchOnClear
  })));
};

var SearchboxDropdownItem = /*#__PURE__*/function (_Component) {
  function SearchboxDropdownItem(element, options, bindings) {
    var _this;
    _this = _Component.call(this, element, SearchboxDropdownItem.ID, bindings) || this;
    _this.element = element;
    _this.options = options;
    _this.bindings = bindings;
    _this.searchboxDropdown = null;
    _this.actualCaption = '';
    _this.options = ComponentOptions.initComponentOptions(element, SearchboxDropdownItem, options);
    _this.shouldSkipDefaultValue();
    // The bind.onRootElement is a thin wrapper around a standard event listener.
    _this.bind.onRootElement(InitializationEvents.afterComponentsInitialization, function () {
      return _this.renderComponent();
    });
    return _this;
  }
  _inheritsLoose(SearchboxDropdownItem, _Component);
  var _proto = SearchboxDropdownItem.prototype;
  _proto.shouldSkipDefaultValue = function shouldSkipDefaultValue() {
    var _this2 = this;
    if (!this.element.parentElement) return;
    var urlParams = window.location.hash.slice(1).split('&').reduce(function (t, hash) {
      var _decodeURIComponent$s = decodeURIComponent(hash).split('='),
        key = _decodeURIComponent$s[0],
        value = _decodeURIComponent$s[1];
      t[key] = value;
      return t;
    }, {});
    var tabValue = urlParams.t;
    if (!tabValue) return;
    var searchBoxDropDown = this.element.parentElement;
    searchBoxDropDown.querySelectorAll('.CoveoSearchboxDropdownItem').forEach(function (node) {
      var caption = node.dataset.caption;
      if (caption === tabValue) {
        _this2.actualCaption = caption;
      }
    });
  }
  /**
   * Toggles the selected item. It is also called by the SearchboxDropdown component when
   *  the user clicks on the item. `true` indicates it is the user who clicked on the item.
   */;
  _proto.handleClick = function handleClick() {
    var _this$searchboxDropdo;
    (_this$searchboxDropdo = this.searchboxDropdown) == null || _this$searchboxDropdo.selectItem(this, true);
    // This is most likely where you would include code to
    // affect the query, probably using this.options.target
  };
  _proto.renderComponent = function renderComponent() {
    var _this3 = this;
    if (!this.element.parentElement) return;
    this.searchboxDropdown = get(this.element.parentElement);
    var _this$options = this.options,
      caption = _this$options.caption,
      position = _this$options.position,
      isDefault = _this$options.defaultOption;
    var link = $$('span', {}, caption).el;
    var item = $$('li', {
      "class": position
    }, '', link).el;
    item.setAttribute('role', 'none');
    link.setAttribute('tabindex', '0');
    link.setAttribute('role', 'menuitem');
    $$(item).on('click', function () {
      return _this3.handleClick();
    });
    $$(item).on('keypress', handleEnterToggle(this));
    if (position) {
      item.setAttribute('class', position);
    }
    if (!this.searchboxDropdown) {
      return;
    }
    if (this.actualCaption === caption || !this.actualCaption && isDefault) {
      this.searchboxDropdown.selectItem(this);
    }
    if (this.searchboxDropdown.itemList) {
      this.searchboxDropdown.itemList.append(item);
    }
  };
  return SearchboxDropdownItem;
}(Component);
SearchboxDropdownItem.ID = 'SearchboxDropdownItem';
/**
 * The options for the component.
 * @componentOptions
 */
SearchboxDropdownItem.options = {
  /**
   * Specifies the caption to be displayed on the component.
   */
  caption: /*#__PURE__*/ComponentOptions.buildStringOption({
    defaultValue: ''
  }),
  /**
   * Specifies the target of the component. To be used in your
   * implementation, for example, in the toggle() function below.
   */
  target: /*#__PURE__*/ComponentOptions.buildStringOption({
    defaultValue: ''
  }),
  /**
   * Specifies whether the component is displayed when the search
   * page first loads.
   */
  defaultOption: /*#__PURE__*/ComponentOptions.buildBooleanOption({
    defaultValue: false
  }),
  /**
   * Specifies the position of the component.
   */
  position: /*#__PURE__*/ComponentOptions.buildStringOption({
    defaultValue: ''
  })
};
// Register the 'SearchboxDropdownItem' component using registerAutoCreateComponent
Initialization.registerAutoCreateComponent(SearchboxDropdownItem);

var SearchboxDropdown = /*#__PURE__*/function (_Component) {
  function SearchboxDropdown(element, options, bindings) {
    var _this;
    _this = _Component.call(this, element, SearchboxDropdown.ID, bindings) || this;
    _this.element = element;
    _this.options = options;
    _this.bindings = bindings;
    _this.itemList = null;
    _this.selectedItem = null;
    /**
     * Selects the hidden Coveo Tabs on the page.
     * @param tabId The tab to select.
     */
    _this.selectTab = function (tabId) {
      Coveo.load('Tab').then(function () {
        var selectedTabElement = Coveo.$$(document.body).find(".CoveoTab[data-id='" + tabId + "']");
        if (selectedTabElement) {
          var selectedTabInstance = Coveo.get(selectedTabElement);
          selectedTabInstance.select();
        }
      });
    };
    _this.options = ComponentOptions.initComponentOptions(element, SearchboxDropdown, options);
    _this.renderComponent();
    return _this;
  }
  /**
   * Adds a SearchboxDropdownItem to the dropdown menu.
   * @param options The options to apply to the new item.
   */
  _inheritsLoose(SearchboxDropdown, _Component);
  var _proto = SearchboxDropdown.prototype;
  _proto.addItem = function addItem(options) {
    var newHTMLElement = $$('div', {
      "class": 'SearchboxDropdownItem'
    }).el;
    this.element.appendChild(newHTMLElement);
    new SearchboxDropdownItem(newHTMLElement, options);
  }
  /**
   * Toggles the SearchboxDropDown menu
   */;
  _proto.toggle = function toggle() {
    $$(this.element).toggleClass('active');
  };
  _proto.highlightSelectedTab = function highlightSelectedTab() {
    var _this$element, _this$itemList;
    var selectedValue = (_this$element = this.element) == null || (_this$element = _this$element.querySelector('.coveo-custom-searchbox-dropdown-selected-caption')) == null ? void 0 : _this$element.innerHTML;
    (_this$itemList = this.itemList) == null || _this$itemList.childNodes.forEach(function (node) {
      var clasListOfNode = node.classList;
      if (clasListOfNode.contains('selected-value')) {
        clasListOfNode.remove('selected-value');
      }
      if (node.textContent === (selectedValue == null ? void 0 : selectedValue.replace('&amp;', '&'))) {
        clasListOfNode.add('selected-value');
      }
    });
  }
  /**
   * Renders the selected item in the searchbox dropdown and also selects a Tab if dropDownItem is changed by the user.
   */;
  _proto.renderSelectedItem = function renderSelectedItem(isUserAction) {
    var _this$selectedItem;
    if (isUserAction === void 0) {
      isUserAction = false;
    }
    //check if tab is present in DOM
    var isTabPresent = isElementPresent('.CoveoTab');
    var renderedSelectedItem = $$(this.element).findClass('coveo-custom-searchbox-dropdown-selected')[0];
    renderedSelectedItem && renderedSelectedItem.remove();
    var selectedItem = $$('button', {
      "class": 'coveo-custom-searchbox-dropdown-selected'
    }).el;
    selectedItem.setAttribute('aria-haspopup', 'listbox');
    selectedItem.setAttribute('aria-controls', 'listbox1');
    selectedItem.setAttribute('id', 'dropdown-button');
    var caption = (_this$selectedItem = this.selectedItem) == null ? void 0 : _this$selectedItem.options.caption;
    if (caption) {
      var selectedItemCaption = $$('div', {
        "class": 'coveo-custom-searchbox-dropdown-selected-caption'
      }, caption).el;
      selectedItem.append(selectedItemCaption || '');
    }
    var selectedItemButton = $$('div', {
      "class": 'coveo-custom-searchbox-dropdown-selected'
    }, SearchboxDropdown.arrowDownIcon).el;
    selectedItem.append(selectedItemButton);
    var arrowDownSvg = $$(selectedItem).find('svg');
    if (arrowDownSvg) {
      arrowDownSvg.classList.add('coveo-custom-searchbox-dropdown-down-icon-svg');
    }
    this.element.prepend(selectedItem);
    //only selectTab if it is a user action and tab is present in DOM
    if (isTabPresent && isUserAction) {
      this.selectTab(this.selectedItem.options.caption);
    }
  }
  /**
   * Selects a SearchboxDropdownItem.
   * @param item The item to select.
   * @param isUserAction to indicate if it is a user action.
   */;
  _proto.selectItem = function selectItem(item, isUserAction) {
    var _this2 = this;
    if (isUserAction === void 0) {
      isUserAction = false;
    }
    this.selectedItem = item;
    this.renderSelectedItem(isUserAction);
    setTimeout(function () {
      return _this2.highlightSelectedTab();
    }, 0);
  }
  /**
   * Toggles the SearchboxDropDown menu
   */;
  _proto.renderComponent = function renderComponent() {
    var _this3 = this;
    this.itemList = $$('ul', {
      "class": 'coveo-custom-searchbox-dropdown-content'
    }).el;
    this.itemList.setAttribute('role', 'listbox');
    this.itemList.setAttribute('id', 'listbox1');
    this.element.appendChild(this.itemList);
    $$(this.element).addClass('coveo-custom-searchbox-dropdown');
    $$(this.element).on('click', function () {
      return _this3.toggle();
    });
    var that = this;
    var clickEsc = function clickEsc(e) {
      if (e.key === KeyboardEnums.ESC) {
        if ($$(that.element).hasClass('active')) {
          $$(that.element).toggleClass('active', false);
        }
      }
    };
    document.addEventListener('keydown', clickEsc);
    document.onclick = function (event) {
      if (!$$(event.target).closest('coveo-custom-searchbox-dropdown')) {
        if ($$(that.element).hasClass('active')) {
          $$(that.element).toggleClass('active', false);
        }
      }
    };
  };
  return SearchboxDropdown;
}(Component);
SearchboxDropdown.ID = 'SearchboxDropdown';
SearchboxDropdown.options = {};
SearchboxDropdown.arrowDownIcon = "<svg\n  xmlns=\"http://www.w3.org/2000/svg\"\n  height=\"24px\"\n  viewBox=\"0 0 24 24\"\n  width=\"24px\"\n  fill=\"#ffffff\"\n>\n  <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n  <path d=\"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z\" />\n</svg>";
// Register the 'SearchboxDropdownItem' component using registerAutoCreateComponent
Initialization.registerAutoCreateComponent(SearchboxDropdown);

var css_248z$1 = ".CoveoSearchboxDropdownItem {\n  display: none;\n}\n\n.coveo-custom-searchbox-dropdown {\n  background-color: var(--tr-coveo-color-tr-white);\n  border: 1px solid var(--tr-coveo-color-tr-grey);\n  border-radius: 0.25rem;\n  color: var(--tr-coveo-color-tr-black);\n  cursor: pointer;\n  float: left;\n  font-size: var(--tr-coveo-searchbox-font-size);\n  line-height: var(--tr-coveo-searchbox-dropdown-line-height);\n  margin: var(--tr-coveo-searchbox-dropdown-margin);\n  max-width: fit-content;\n  min-width: var(--tr-coveo-searchbox-dropdown-min-width);\n  padding: var(--tr-coveo-searchbox-dropdown-padding);\n  position: relative;\n}\n\n.coveo-custom-searchbox-dropdown.active,\n.coveo-custom-searchbox-dropdown:hover {\n  background-color: var(--tr-coveo-color-tr-black);\n}\n\n.coveo-custom-searchbox-dropdown.active button,\n.coveo-custom-searchbox-dropdown:hover button {\n  color: var(--tr-coveo-color-tr-white);\n}\n\n.coveo-custom-searchbox-dropdown.active svg,\n.coveo-custom-searchbox-dropdown:hover svg {\n  fill: var(--tr-coveo-color-tr-white);\n}\n\n.coveo-custom-searchbox-dropdown-down-icon-svg {\n  fill: var(--tr-coveo-color-tr-black);\n  transition: transform 0.3s ease-in-out;\n}\n\n.coveo-custom-searchbox-dropdown.active .coveo-custom-searchbox-dropdown-content {\n  display: block;\n}\n\n.coveo-custom-searchbox-dropdown-selected {\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  color: var(--tr-coveo-color-tr-black);\n  display: flex !important;\n  justify-content: space-between;\n  padding: var(--tr-coveo-0);\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchboxDropdown .coveo-custom-searchbox-dropdown-selected {\n  font-family: var(--tr-coveo-font-family-S3) !important;\n}\n\nul.coveo-custom-searchbox-dropdown-content {\n  background-color: var(--tr-coveo-color-tr-white);\n  border: 1px solid var(--tr-coveo-color-tr-grey);\n  border-radius: var(--tr-coveo-searchbox-border-radius-8);\n  display: none;\n  left: var(--tr-coveo-searchbox-dropdown-left);\n  list-style-type: none;\n  margin: var(--tr-coveo-searchbox-margin-0);\n  min-width: var(--tr-coveo-searchbox-dropdown-content-min-width);\n  padding: var(--tr-coveo-searchbox-padding-1);\n  position: absolute;\n  text-align: left;\n  top: var(--tr-coveo-searchbox-dropdown-top);\n  z-index: var(--tr-coveo-searchbox-dropdown-z-index);\n}\n\nul.coveo-custom-searchbox-dropdown-content li.hidden {\n  display: none;\n}\n\nul.coveo-custom-searchbox-dropdown-content li {\n  margin: var(--tr-coveo-searchbox-dropdown-margin-link);\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchboxDropdown ul.coveo-custom-searchbox-dropdown-content li {\n  font-family: var(--tr-coveo-font-family-S3) !important;\n}\n\n.selected-value span {\n  color: var(--tr-coveo-color-tr-white) !important;\n}\n\nul.coveo-custom-searchbox-dropdown-content li span {\n  color: var(--tr-coveo-color-tr-black);\n  display: block;\n  padding: var(--tr-coveo-searchbox-dropdown-padding-link);\n  text-decoration: none;\n}\n\nul.coveo-custom-searchbox-dropdown-content li span:hover {\n  background-color: var(--tr-coveo-color-tr-orange-light);\n  border-radius: var(--tr-coveo-searchbox-border-radius-4);\n  color: var(--tr-coveo-color-tr-black) !important;\n}\n\n.selected-value {\n  background-color: var(--tr-coveo-color-tr-black);\n  border-radius: var(--tr-coveo-searchbox-border-radius-4);\n}\n";
styleInject(css_248z$1);

var SearchBoxWithDropDown = function SearchBoxWithDropDown() {
  var _useSearchBoxProps = useSearchBoxProps(),
    enableOmnibox = _useSearchBoxProps.enableOmnibox,
    numberOfSuggestions = _useSearchBoxProps.numberOfSuggestions,
    partialMatchKeywords = _useSearchBoxProps.partialMatchKeywords,
    enablePartialMatch = _useSearchBoxProps.enablePartialMatch,
    inline = _useSearchBoxProps.inline,
    style = _useSearchBoxProps.style,
    searchBoxPlaceHolder = _useSearchBoxProps.searchBoxPlaceHolder,
    logger = _useSearchBoxProps.logger,
    dropDownOptions = _useSearchBoxProps.dropDownOptions,
    enableResetSearchOnClear = _useSearchBoxProps.enableResetSearchOnClear,
    _useSearchBoxProps$en = _useSearchBoxProps.enableNewBranding,
    enableNewBranding = _useSearchBoxProps$en === void 0 ? false : _useSearchBoxProps$en;
  logger == null || logger.debug(SearchBoxLogs.SEARCHBOX_DROPDOWN);
  /**
   * Changes the button aria-expanded attribute according the dropdown menu class
   * "active" for expanded and without it when collapsed
   */
  useEffect(function () {
    var coveoDropdownElement = document.getElementById('CoveoSearchboxDropdown-ID');
    var mutationConfig = {
      attributes: true,
      attributeFilter: ['class']
    };
    var observer = new MutationObserver(function (mutationsList) {
      for (var _iterator = _createForOfIteratorHelperLoose(mutationsList), _step; !(_step = _iterator()).done;) {
        var mutation = _step.value;
        var classNameString = mutation.target.className;
        if (mutation.type === 'attributes') {
          var dropdownButton = document.getElementById('dropdown-button');
          if (dropdownButton) {
            var isActive = classNameString.includes('active');
            dropdownButton.setAttribute('aria-expanded', "" + isActive);
          }
        }
      }
    });
    if (coveoDropdownElement) {
      observer.observe(coveoDropdownElement, mutationConfig);
    }
    // Clean up
    return function () {
      observer.disconnect();
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classNames('coveo-search-section coveo-drop-down-header', {
      'coveo-tr-searchbox--new-branding':
      //@ts-ignore
      enableNewBranding === true || enableNewBranding === 'true'
    })
  }, React.createElement("div", {
    id: "CoveoSearchboxDropdown-ID",
    className: "CoveoSearchboxDropdown"
  }, dropDownOptions ? dropDownOptions.map(function (option) {
    return React.createElement("div", {
      className: "CoveoSearchboxDropdownItem",
      key: option.target,
      "data-target": option.target,
      "data-caption": option.caption,
      "data-default-option": option.defaultOption,
      "data-position": option.position
    });
  }) : null), React.createElement("div", {
    className: "CoveoSearchbox coveo-tr-searchbox-icon",
    "data-enable-omnibox": enableOmnibox,
    "data-number-of-suggestions": numberOfSuggestions,
    "data-partial-match-keywords": partialMatchKeywords,
    "data-enable-partial-match": enablePartialMatch,
    "data-inline": inline,
    style: _extends({}, style == null ? void 0 : style.input),
    "data-placeholder": searchBoxPlaceHolder,
    "data-trigger-query-on-clear": enableResetSearchOnClear
  })));
};

var css_248z$2 = "@import url(https://fonts.googleapis.com/css?family=Lato:300,400,700);.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-content,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-content,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-content{padding:0}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header{font-size:12px;display:inline-block;padding:0 7px;height:22px;font-weight:700;line-height:20px;letter-spacing:.09px;vertical-align:middle;white-space:normal;color:#1d4f76;cursor:pointer;text-transform:uppercase}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header *,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header *,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header *{display:inline-block;margin:0}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header li,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header li,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header li{display:list-item}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header p,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header p,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header p{line-height:16px}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header .coveo-more-tabs,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header .coveo-more-tabs,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header .coveo-more-tabs{margin-left:10px}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header.coveo-hidden,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header.coveo-hidden,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header.coveo-hidden{display:none}.CoveoSearchInterface.coveo-small-facets .coveo-tab-section>a:last-of-type,.CoveoSearchInterface.coveo-small-recommendation .coveo-tab-section>a:last-of-type,.CoveoSearchInterface.coveo-small-tabs .coveo-tab-section>a:last-of-type{margin-right:20px}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header-wrapper,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header-wrapper,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header-wrapper{width:100%;margin:0;padding:0;display:-webkit-inline-box;display:-moz-inline-box;display:inline-box;display:-moz-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-lines:single;-moz-box-lines:single;box-lines:single;-ms-flex-wrap:nowrap;flex-wrap:nowrap;box-pack:end;-moz-justify-content:flex-end;-ms-justify-content:flex-end;-o-justify-content:flex-end;justify-content:flex-end;-ms-flex-pack:end}.CoveoSearchInterface.coveo-small-facets .coveo-dropdown-header-wrapper a,.CoveoSearchInterface.coveo-small-recommendation .coveo-dropdown-header-wrapper a,.CoveoSearchInterface.coveo-small-tabs .coveo-dropdown-header-wrapper a{margin-right:10px}.coveo-dropdown-background{transition-property:opacity;transition-duration:.3s;background:hsla(0,0%,100%,.85);opacity:0;position:fixed;top:0;right:0;bottom:0;left:0;z-index:15}.coveo-media-max-width-480 .CoveoSearchInterface .coveo-tab-section{background-color:#f7f8f9}.coveo-media-max-width-480 .CoveoSearchInterface .CoveoSearchbox{max-width:800px;margin-right:50px}.coveo-media-max-width-480 .CoveoSearchInterface .CoveoSettings{margin-left:0}.coveo-media-max-width-480 .CoveoSearchInterface .CoveoSettings+.CoveoSearchbox{margin-right:50px}@media (max-width:480px){.CoveoSearchInterface .coveo-tab-section{background-color:#f7f8f9}.CoveoSearchInterface .CoveoSearchbox{max-width:800px;margin-right:50px}.CoveoSearchInterface .CoveoSettings{margin-left:0}.CoveoSearchInterface .CoveoSettings+.CoveoSearchbox{margin-right:50px}}@charset \"UTF-8\";.coveo-emails-excess-collapsed,.coveo-emails-excess-expanded{display:none;cursor:pointer}.coveo-emails-excess-collapsed.coveo-active,.coveo-emails-excess-expanded.coveo-active{display:inline}.coveo-emails-excess-collapsed{color:#0059b3;text-decoration:none;cursor:pointer}.coveo-emails-excess-collapsed:visited,.coveo-emails-excess-collapsed:visited:hover{color:#609}.coveo-emails-excess-collapsed:hover,.coveo-emails-excess-collapsed:hover a{text-decoration:underline}.coveo-emails-excess-collapsed.coveo-selected *{color:#0059b3}.coveo-email-child-from{margin:0 10px 0 5px}.coveo-email-child-excerpt{font-size:13px;text-decoration:none!important}.coveo-email-child-excerpt:not(:hover){color:inherit!important}.coveo-modal-container .coveo-email-from,.coveo-modal-container .coveo-email-to{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:5px 16px;font-size:13px;font-size:14px}.coveo-modal-container .coveo-email-from a,.coveo-modal-container .coveo-email-to a{color:#0059b3;text-decoration:none;cursor:pointer;white-space:nowrap}.coveo-modal-container .coveo-email-from a:visited,.coveo-modal-container .coveo-email-from a:visited:hover,.coveo-modal-container .coveo-email-to a:visited,.coveo-modal-container .coveo-email-to a:visited:hover{color:#609}.coveo-modal-container .coveo-email-from a:hover,.coveo-modal-container .coveo-email-from a:hover a,.coveo-modal-container .coveo-email-to a:hover,.coveo-modal-container .coveo-email-to a:hover a{text-decoration:underline}.coveo-modal-container .coveo-email-from a.coveo-selected *,.coveo-modal-container .coveo-email-to a.coveo-selected *{color:#0059b3}.CoveoEmailAction{color:#0059b3;text-decoration:none;cursor:pointer;display:inline-block;font-size:14px;border:thin solid #bcc3ca;border-radius:2px;padding:5px;margin:5px 16px}.CoveoEmailAction:visited,.CoveoEmailAction:visited:hover{color:#609}.CoveoEmailAction:hover,.CoveoEmailAction:hover a{text-decoration:underline}.CoveoEmailAction.coveo-selected *{color:#0059b3}.CoveoEmailAction>div{display:inline-block}.CoveoSearchInterface{min-width:300px}.CoveoSearchInterface>*{display:none;visibility:hidden}.CoveoSearchInterface.coveo-waiting-for-query .coveo-search-section{display:block;visibility:visible;margin-top:20%}.CoveoSearchInterface.coveo-waiting-for-query .coveo-search-section .CoveoSettings{display:none}.CoveoSearchInterface .coveo-search-section{max-width:800px;margin:54px auto 47px;padding:0 10px;display:flex;align-items:center}.CoveoSearchInterface .coveo-search-section .coveo-media-max-width-480{padding:20px 10px;margin:0 auto;width:100%;max-width:none}@media (max-width:480px){.CoveoSearchInterface .coveo-search-section{padding:20px 10px;margin:0 auto;width:100%;max-width:none}}.CoveoSearchInterface .coveo-main-section{*zoom:1;max-width:1200px;margin-left:auto;margin-right:auto;position:relative}.CoveoSearchInterface .coveo-main-section:after,.CoveoSearchInterface .coveo-main-section:before{content:\" \";display:table}.CoveoSearchInterface .coveo-main-section:after{clear:both}.CoveoSearchInterface .coveo-facet-column{display:block;float:left;margin-right:2.84259%;width:28.01019%;margin-right:0;padding:13px 10px 5px}.CoveoSearchInterface .coveo-facet-column:last-child{margin-right:0}.CoveoSearchInterface .coveo-facet-column.coveo-no-results{display:none}.CoveoSearchInterface .coveo-results-column{overflow:hidden;padding:10px 10px 10px 15px}.CoveoSearchInterface .coveo-results-column.coveo-no-results{max-width:75%;margin:auto;text-align:center}.CoveoSearchInterface .coveo-results-column .coveo-media-max-width-800.coveo-no-results{max-width:100%}@media (max-width:800px){.CoveoSearchInterface .coveo-results-column.coveo-no-results{max-width:100%}}.CoveoSearchInterface .coveo-results-column .coveo-media-max-width-480{padding:0}@media (max-width:480px){.CoveoSearchInterface .coveo-results-column{padding:0}}.CoveoSearchInterface.coveo-during-initialization .coveo-results-header{height:35px}.CoveoSearchInterface.coveo-during-initialization .coveo-results-header *,.CoveoSearchInterface.coveo-during-initialization .CoveoLogo,.CoveoSearchInterface.coveo-during-initialization .CoveoResultsPerPage{display:none}.CoveoSearchInterface .coveo-results-footer,.CoveoSearchInterface .coveo-results-footer .coveo-results-footer-left,.CoveoSearchInterface .coveo-results-footer .coveo-results-footer-right{display:flex;align-items:center}.CoveoSearchInterface .coveo-results-footer .coveo-results-footer-left{flex-grow:1}.coveo-after-initialization>*{display:inherit;visibility:inherit}.coveo-after-initialization link,.coveo-after-initialization script,.coveo-after-initialization template{display:none}.coveo-after-initialization output{display:inline}.coveo-after-initialization button,.coveo-after-initialization input,.coveo-after-initialization keygen,.coveo-after-initialization meter,.coveo-after-initialization progress,.coveo-after-initialization select,.coveo-after-initialization textarea{display:inline-block}.coveo-after-initialization table{display:table}.coveo-results-header{display:-moz-flex;display:-ms-flexbox;display:flex;box-pack:justify;-moz-justify-content:space-between;-ms-justify-content:space-between;-o-justify-content:space-between;justify-content:space-between;-ms-flex-pack:justify;padding-top:10px;min-height:35px;overflow:hidden;box-shadow:inset 0 -1px 0 0 #bcc3ca}.coveo-results-header.coveo-no-results,.coveo-results-header.coveo-query-error{box-shadow:none}.coveo-summary-section{display:inline-block;font-size:14px;margin-right:auto;box-flex:auto;-moz-flex:auto;-ms-flex:auto;flex:auto}.coveo-result-layout-section{display:-moz-flex;display:-ms-flexbox;display:flex;flex-shrink:0;-ms-flex-negative:0}.coveo-result-layout-section.coveo-result-layout-hidden{display:none}.coveo-sort-section{display:-moz-flex;display:-ms-flexbox;display:flex;flex-shrink:0;-ms-flex-negative:0}.coveo-results-header>:not(:first-child){padding-right:10px;margin-left:10px;border-right:1px solid #bcc3ca}.coveo-results-header>:last-child{padding-right:0;border-right:none}.coveo-media-max-width-800 .coveo-results-header{padding-right:10px}@media (max-width:800px){.coveo-results-header{padding-right:10px}}.coveo-media-max-width-480 .coveo-results-header{padding-left:10px;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}.coveo-media-max-width-480 .coveo-sort-section span:first-child{padding-left:0}.coveo-media-max-width-480 .coveo-list-layout .CoveoResult{margin:0;padding:15px 10px 15px 15px}.coveo-media-max-width-480 .CoveoResultList{margin-bottom:15px}.coveo-media-max-width-480 .coveo-summary-section{width:100%;margin-bottom:10px}.coveo-media-max-width-480 .coveo-results-header>:not(:first-child){border-right:none;margin-left:0;padding:0}.coveo-media-max-width-480 .coveo-results-header>:last-child{margin-left:0;margin-bottom:0}@media (max-width:480px){.coveo-results-header{padding-left:10px;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}.coveo-sort-section span:first-child{padding-left:0}.coveo-list-layout .CoveoResult{margin:0;padding:15px 10px 15px 15px}.CoveoResultList{margin-bottom:15px}.coveo-summary-section{width:100%;margin-bottom:10px}.coveo-results-header>:not(:first-child){border-right:none;margin-left:0;padding:0}.coveo-results-header>:last-child{margin-left:0;margin-bottom:0}}.CoveoResult.coveo-lithium-result .coveo-lithium-header{padding-top:3px}.coveo-lithium-result .coveo-expanded-child-result+.coveo-expanded-child-result{border-top:1px solid #ccc;padding-top:10px}.coveo-lithium-from,.coveo-lithium-to{font-size:13px}.coveo-lithium-from a,.coveo-lithium-to a{color:#0059b3;text-decoration:none;cursor:pointer;white-space:nowrap}.coveo-lithium-from a:visited,.coveo-lithium-from a:visited:hover,.coveo-lithium-to a:visited,.coveo-lithium-to a:visited:hover{color:#609}.coveo-lithium-from a:hover,.coveo-lithium-from a:hover a,.coveo-lithium-to a:hover,.coveo-lithium-to a:hover a{text-decoration:underline}.coveo-lithium-from a.coveo-selected *,.coveo-lithium-to a.coveo-selected *{color:#0059b3}.coveo-loading-spinner{margin:3em auto;font-size:10px;position:relative;text-indent:-9999em;border:.7em solid hsla(0,0%,50%,.2);border-left-color:gray;animation:coveo-loading-spinner-animation 1.1s infinite linear}.coveo-loading-spinner-container{width:100%}.coveo-loading-spinner,.coveo-loading-spinner:after{border-radius:50%;width:3em;height:3em}@keyframes coveo-loading-spinner-animation{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.coveo-first-loading-animation{position:absolute;top:0;left:0;right:0;bottom:0;text-align:center;padding-top:100px;background:#f7f7f7}.coveo-first-loading-animation .coveo-loading-container{transform:translateZ(0);transform:rotatex(0)}.coveo-first-loading-animation .coveo-loading-container .coveo-loading-dot{background-color:hsla(0,0%,8%,.9);background:hsla(0,0%,8%,.9);border-radius:5px;box-shadow:inset 0 0 5px #000,0 1px 1px hsla(0,0%,100%,.1);display:inline-block;width:8px;height:8px;margin:0 4px;border-radius:50%;opacity:0;box-shadow:0 0 2px #000;animation:loadingFade 1s infinite}.coveo-first-loading-animation .coveo-loading-container .coveo-loading-dot:first-child{animation-delay:.1s}.coveo-first-loading-animation .coveo-loading-container .coveo-loading-dot:nth-child(2){animation-delay:.2s}.coveo-first-loading-animation .coveo-loading-container .coveo-loading-dot:nth-child(3){animation-delay:.3s}.coveo-first-loading-animation .coveo-loading-container .coveo-loading-dot:nth-child(4){animation-delay:.4s}.coveo-first-loading-animation .coveo-loading-container{margin-top:15px}.coveo-generic-loading-animation .coveo-loading-container{transform:translateZ(0);transform:rotatex(0)}.coveo-generic-loading-animation .coveo-loading-container .coveo-loading-dot{background-color:hsla(0,0%,8%,.9);background:hsla(0,0%,8%,.9);border-radius:5px;box-shadow:inset 0 0 5px #000,0 1px 1px hsla(0,0%,100%,.1);display:inline-block;width:8px;height:8px;margin:0 4px;border-radius:50%;opacity:0;box-shadow:0 0 2px #000;animation:loadingFade 1s infinite}.coveo-generic-loading-animation .coveo-loading-container .coveo-loading-dot:first-child{animation-delay:.1s}.coveo-generic-loading-animation .coveo-loading-container .coveo-loading-dot:nth-child(2){animation-delay:.2s}.coveo-generic-loading-animation .coveo-loading-container .coveo-loading-dot:nth-child(3){animation-delay:.3s}.coveo-generic-loading-animation .coveo-loading-container .coveo-loading-dot:nth-child(4){animation-delay:.4s}.coveo-filetype-attachment,.coveo-filetype-calendar,.coveo-filetype-case,.coveo-filetype-custom,.coveo-filetype-document,.coveo-filetype-file,.coveo-filetype-folder,.coveo-filetype-images,.coveo-filetype-kb,.coveo-filetype-link,.coveo-filetype-mail,.coveo-filetype-salesforce-standard-account,.coveo-filetype-salesforce-standard-action-list-component,.coveo-filetype-salesforce-standard-address,.coveo-filetype-salesforce-standard-announcement,.coveo-filetype-salesforce-standard-answer-best,.coveo-filetype-salesforce-standard-answer-private,.coveo-filetype-salesforce-standard-answer-public,.coveo-filetype-salesforce-standard-approval,.coveo-filetype-salesforce-standard-apps,.coveo-filetype-salesforce-standard-apps-admin,.coveo-filetype-salesforce-standard-article,.coveo-filetype-salesforce-standard-asset-relationship,.coveo-filetype-salesforce-standard-assigned-resource,.coveo-filetype-salesforce-standard-avatar,.coveo-filetype-salesforce-standard-avatar-loading,.coveo-filetype-salesforce-standard-bot,.coveo-filetype-salesforce-standard-business-hours,.coveo-filetype-salesforce-standard-calibration,.coveo-filetype-salesforce-standard-call,.coveo-filetype-salesforce-standard-call-history,.coveo-filetype-salesforce-standard-campaign,.coveo-filetype-salesforce-standard-campaign-members,.coveo-filetype-salesforce-standard-canvas,.coveo-filetype-salesforce-standard-carousel,.coveo-filetype-salesforce-standard-case,.coveo-filetype-salesforce-standard-case-change-status,.coveo-filetype-salesforce-standard-case-comment,.coveo-filetype-salesforce-standard-case-email,.coveo-filetype-salesforce-standard-case-log-a-call,.coveo-filetype-salesforce-standard-case-milestone,.coveo-filetype-salesforce-standard-case-transcript,.coveo-filetype-salesforce-standard-channel-program-history,.coveo-filetype-salesforce-standard-channel-program-levels,.coveo-filetype-salesforce-standard-channel-program-members,.coveo-filetype-salesforce-standard-channel-programs,.coveo-filetype-salesforce-standard-client,.coveo-filetype-salesforce-standard-cms,.coveo-filetype-salesforce-standard-coaching,.coveo-filetype-salesforce-standard-connected-apps,.coveo-filetype-salesforce-standard-contact,.coveo-filetype-salesforce-standard-contact-list,.coveo-filetype-salesforce-standard-contract,.coveo-filetype-salesforce-standard-contract-line-item,.coveo-filetype-salesforce-standard-custom,.coveo-filetype-salesforce-standard-custom-notification,.coveo-filetype-salesforce-standard-customers,.coveo-filetype-salesforce-standard-dashboard,.coveo-filetype-salesforce-standard-data-integration-hub,.coveo-filetype-salesforce-standard-default,.coveo-filetype-salesforce-standard-document,.coveo-filetype-salesforce-standard-drafts,.coveo-filetype-salesforce-standard-email,.coveo-filetype-salesforce-standard-email-chatter,.coveo-filetype-salesforce-standard-empty,.coveo-filetype-salesforce-standard-endorsement,.coveo-filetype-salesforce-standard-entitlement,.coveo-filetype-salesforce-standard-entitlement-process,.coveo-filetype-salesforce-standard-entitlement-template,.coveo-filetype-salesforce-standard-entity,.coveo-filetype-salesforce-standard-entity-milestone,.coveo-filetype-salesforce-standard-environment-hub,.coveo-filetype-salesforce-standard-event,.coveo-filetype-salesforce-standard-feed,.coveo-filetype-salesforce-standard-feedback,.coveo-filetype-salesforce-standard-file,.coveo-filetype-salesforce-standard-flow,.coveo-filetype-salesforce-standard-folder,.coveo-filetype-salesforce-standard-forecasts,.coveo-filetype-salesforce-standard-generic-loading,.coveo-filetype-salesforce-standard-goals,.coveo-filetype-salesforce-standard-group-loading,.coveo-filetype-salesforce-standard-groups,.coveo-filetype-salesforce-standard-hierarchy,.coveo-filetype-salesforce-standard-home,.coveo-filetype-salesforce-standard-household,.coveo-filetype-salesforce-standard-individual,.coveo-filetype-salesforce-standard-insights,.coveo-filetype-salesforce-standard-investment-account,.coveo-filetype-salesforce-standard-iot-orchestrations,.coveo-filetype-salesforce-standard-knowledge,.coveo-filetype-salesforce-standard-lead,.coveo-filetype-salesforce-standard-lead-insights,.coveo-filetype-salesforce-standard-lead-list,.coveo-filetype-salesforce-standard-link,.coveo-filetype-salesforce-standard-list-email,.coveo-filetype-salesforce-standard-live-chat,.coveo-filetype-salesforce-standard-live-chat-visitor,.coveo-filetype-salesforce-standard-location,.coveo-filetype-salesforce-standard-log-a-call,.coveo-filetype-salesforce-standard-logging,.coveo-filetype-salesforce-standard-macros,.coveo-filetype-salesforce-standard-maintenance-asset,.coveo-filetype-salesforce-standard-maintenance-plan,.coveo-filetype-salesforce-standard-marketing-actions,.coveo-filetype-salesforce-standard-merge,.coveo-filetype-salesforce-standard-messaging-conversation,.coveo-filetype-salesforce-standard-messaging-session,.coveo-filetype-salesforce-standard-messaging-user,.coveo-filetype-salesforce-standard-metrics,.coveo-filetype-salesforce-standard-news,.coveo-filetype-salesforce-standard-note,.coveo-filetype-salesforce-standard-omni-supervisor,.coveo-filetype-salesforce-standard-operating-hours,.coveo-filetype-salesforce-standard-opportunity,.coveo-filetype-salesforce-standard-opportunity-splits,.coveo-filetype-salesforce-standard-orders,.coveo-filetype-salesforce-standard-partner-fund-allocation,.coveo-filetype-salesforce-standard-partner-fund-claim,.coveo-filetype-salesforce-standard-partner-fund-request,.coveo-filetype-salesforce-standard-partner-marketing-budget,.coveo-filetype-salesforce-standard-partners,.coveo-filetype-salesforce-standard-past-chat,.coveo-filetype-salesforce-standard-people,.coveo-filetype-salesforce-standard-performance,.coveo-filetype-salesforce-standard-person-account,.coveo-filetype-salesforce-standard-photo,.coveo-filetype-salesforce-standard-poll,.coveo-filetype-salesforce-standard-portal,.coveo-filetype-salesforce-standard-post,.coveo-filetype-salesforce-standard-pricebook,.coveo-filetype-salesforce-standard-process,.coveo-filetype-salesforce-standard-product,.coveo-filetype-salesforce-standard-product-consumed,.coveo-filetype-salesforce-standard-product-item,.coveo-filetype-salesforce-standard-product-item-transaction,.coveo-filetype-salesforce-standard-product-request,.coveo-filetype-salesforce-standard-product-request-line-item,.coveo-filetype-salesforce-standard-product-required,.coveo-filetype-salesforce-standard-product-transfer,.coveo-filetype-salesforce-standard-question-best,.coveo-filetype-salesforce-standard-question-feed,.coveo-filetype-salesforce-standard-quick-text,.coveo-filetype-salesforce-standard-quip,.coveo-filetype-salesforce-standard-quip-sheet,.coveo-filetype-salesforce-standard-quotes,.coveo-filetype-salesforce-standard-read-receipts,.coveo-filetype-salesforce-standard-recent,.coveo-filetype-salesforce-standard-record,.coveo-filetype-salesforce-standard-related-list,.coveo-filetype-salesforce-standard-relationship,.coveo-filetype-salesforce-standard-report,.coveo-filetype-salesforce-standard-resource-absence,.coveo-filetype-salesforce-standard-resource-capacity,.coveo-filetype-salesforce-standard-resource-preference,.coveo-filetype-salesforce-standard-resource-skill,.coveo-filetype-salesforce-standard-return-order,.coveo-filetype-salesforce-standard-return-order-line-item,.coveo-filetype-salesforce-standard-reward,.coveo-filetype-salesforce-standard-rtc-presence,.coveo-filetype-salesforce-standard-sales-path,.coveo-filetype-salesforce-standard-scan-card,.coveo-filetype-salesforce-standard-search,.coveo-filetype-salesforce-standard-service-appointment,.coveo-filetype-salesforce-standard-service-contract,.coveo-filetype-salesforce-standard-service-crew,.coveo-filetype-salesforce-standard-service-crew-member,.coveo-filetype-salesforce-standard-service-report,.coveo-filetype-salesforce-standard-service-resource,.coveo-filetype-salesforce-standard-service-territory,.coveo-filetype-salesforce-standard-service-territory-location,.coveo-filetype-salesforce-standard-service-territory-member,.coveo-filetype-salesforce-standard-shipment,.coveo-filetype-salesforce-standard-skill,.coveo-filetype-salesforce-standard-skill-entity,.coveo-filetype-salesforce-standard-skill-requirement,.coveo-filetype-salesforce-standard-social,.coveo-filetype-salesforce-standard-solution,.coveo-filetype-salesforce-standard-sossession,.coveo-filetype-salesforce-standard-stage,.coveo-filetype-salesforce-standard-stage-collection,.coveo-filetype-salesforce-standard-survey,.coveo-filetype-salesforce-standard-task,.coveo-filetype-salesforce-standard-task2,.coveo-filetype-salesforce-standard-team-member,.coveo-filetype-salesforce-standard-template,.coveo-filetype-salesforce-standard-thanks,.coveo-filetype-salesforce-standard-thanks-loading,.coveo-filetype-salesforce-standard-timesheet,.coveo-filetype-salesforce-standard-timesheet-entry,.coveo-filetype-salesforce-standard-timeslot,.coveo-filetype-salesforce-standard-today,.coveo-filetype-salesforce-standard-topic,.coveo-filetype-salesforce-standard-topic2,.coveo-filetype-salesforce-standard-unmatched,.coveo-filetype-salesforce-standard-user,.coveo-filetype-salesforce-standard-work-order,.coveo-filetype-salesforce-standard-work-order-item,.coveo-filetype-salesforce-standard-work-type,.coveo-filetype-user,.coveo-filetype-video,.coveo-filetype-webpage,.coveo-icon.filetype,.coveo-icon.filetype.Activedirperson,.coveo-icon.filetype.activedirperson,.coveo-icon.filetype.Box,.coveo-icon.filetype.box,.coveo-icon.filetype.Box-user,.coveo-icon.filetype.box user,.coveo-icon.filetype.cfblogentry,.coveo-icon.filetype.Cfblogentry,.coveo-icon.filetype.Cfcomment,.coveo-icon.filetype.cfcomment,.coveo-icon.filetype.cfpage,.coveo-icon.filetype.Cfpage,.coveo-icon.filetype.Cfspace,.coveo-icon.filetype.cfspace,.coveo-icon.filetype.confluencespace,.coveo-icon.filetype.Confluencespace,.coveo-icon.filetype.dynamicscrmitem,.coveo-icon.filetype.Dynamicscrmitem,.coveo-icon.filetype.exchangeappointment,.coveo-icon.filetype.Exchangeappointment,.coveo-icon.filetype.Exchangecalendarmessage,.coveo-icon.filetype.exchangecalendarmessage,.coveo-icon.filetype.Exchangedocument,.coveo-icon.filetype.exchangedocument,.coveo-icon.filetype.exchangedsn,.coveo-icon.filetype.Exchangedsn,.coveo-icon.filetype.exchangefreebusy,.coveo-icon.filetype.Exchangefreebusy,.coveo-icon.filetype.exchangegroup,.coveo-icon.filetype.Exchangegroup,.coveo-icon.filetype.Exchangejunkmessage,.coveo-icon.filetype.exchangejunkmessage,.coveo-icon.filetype.exchangemdn,.coveo-icon.filetype.Exchangemdn,.coveo-icon.filetype.exchangemessage,.coveo-icon.filetype.Exchangemessage,.coveo-icon.filetype.Exchangeobject,.coveo-icon.filetype.exchangeobject,.coveo-icon.filetype.Exchangeperson,.coveo-icon.filetype.exchangeperson,.coveo-icon.filetype.Exchangerecallmessage,.coveo-icon.filetype.exchangerecallmessage,.coveo-icon.filetype.exchangerecallreport,.coveo-icon.filetype.Exchangerecallreport,.coveo-icon.filetype.exchangetask,.coveo-icon.filetype.Exchangetask,.coveo-icon.filetype.Folder,.coveo-icon.filetype.folder,.coveo-icon.filetype.Gmailmessage,.coveo-icon.filetype.gmailmessage,.coveo-icon.filetype.incident,.coveo-icon.filetype.Incident,.coveo-icon.filetype.Jiraissue,.coveo-icon.filetype.jiraissue,.coveo-icon.filetype.Kb_knowledge,.coveo-icon.filetype.kb_knowledge,.coveo-icon.filetype.Lithiumboard,.coveo-icon.filetype.lithiumboard,.coveo-icon.filetype.lithiumcategory,.coveo-icon.filetype.Lithiumcategory,.coveo-icon.filetype.Lithiumcommunity,.coveo-icon.filetype.lithiumcommunity,.coveo-icon.filetype.lithiummessage,.coveo-icon.filetype.Lithiummessage,.coveo-icon.filetype.lithiumthread,.coveo-icon.filetype.Lithiumthread,.coveo-icon.filetype.odt,.coveo-icon.filetype.Odt,.coveo-icon.filetype.olefile,.coveo-icon.filetype.OleFile,.coveo-icon.filetype.Rssitem,.coveo-icon.filetype.rssitem,.coveo-icon.filetype.saleforceitem,.coveo-icon.filetype.Saleforceitem,.coveo-icon.filetype.Salesforceitem,.coveo-icon.filetype.salesforceitem,.coveo-icon.filetype.Sc_cat_item,.coveo-icon.filetype.sc_cat_item,.coveo-icon.filetype.sn_customerservice_case,.coveo-icon.filetype.Sn_customerservice_case,.coveo-icon.filetype.Sn_hr_core_case,.coveo-icon.filetype.sn_hr_core_case,.coveo-icon.filetype.spadministratortask,.coveo-icon.filetype.Spadministratortask,.coveo-icon.filetype.Spadministratortasklist,.coveo-icon.filetype.spadministratortasklist,.coveo-icon.filetype.spagenda,.coveo-icon.filetype.Spagenda,.coveo-icon.filetype.spagendalist,.coveo-icon.filetype.Spagendalist,.coveo-icon.filetype.Sparea,.coveo-icon.filetype.sparea,.coveo-icon.filetype.Spareadocumentlibrarylist,.coveo-icon.filetype.spareadocumentlibrarylist,.coveo-icon.filetype.Sparealisting,.coveo-icon.filetype.sparealisting,.coveo-icon.filetype.spattendee,.coveo-icon.filetype.Spattendee,.coveo-icon.filetype.spattendeelist,.coveo-icon.filetype.Spattendeelist,.coveo-icon.filetype.spcirculation,.coveo-icon.filetype.Spcirculation,.coveo-icon.filetype.Spcirculationlist,.coveo-icon.filetype.spcirculationlist,.coveo-icon.filetype.Spcontact,.coveo-icon.filetype.spcontact,.coveo-icon.filetype.Spcontactlist,.coveo-icon.filetype.spcontactlist,.coveo-icon.filetype.Spcustomgridlist,.coveo-icon.filetype.spcustomgridlist,.coveo-icon.filetype.Spcustomlist,.coveo-icon.filetype.spcustomlist,.coveo-icon.filetype.Spdashboardslibrarylist,.coveo-icon.filetype.spdashboardslibrarylist,.coveo-icon.filetype.Spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.spdataconnectionlibrarylist,.coveo-icon.filetype.Spdataconnectionlibrarylist,.coveo-icon.filetype.spdatasource,.coveo-icon.filetype.Spdatasource,.coveo-icon.filetype.Spdatasourcelist,.coveo-icon.filetype.spdatasourcelist,.coveo-icon.filetype.Spdecision,.coveo-icon.filetype.spdecision,.coveo-icon.filetype.Spdecisionlist,.coveo-icon.filetype.spdecisionlist,.coveo-icon.filetype.spdistributiongroup,.coveo-icon.filetype.Spdistributiongroup,.coveo-icon.filetype.Spdistributiongrouplist,.coveo-icon.filetype.spdistributiongrouplist,.coveo-icon.filetype.spdocumentlibrarylist,.coveo-icon.filetype.Spdocumentlibrarylist,.coveo-icon.filetype.spdocumentlink,.coveo-icon.filetype.Spdocumentlink,.coveo-icon.filetype.spdocumentset,.coveo-icon.filetype.Spdocumentset,.coveo-icon.filetype.Spevent,.coveo-icon.filetype.spevent,.coveo-icon.filetype.Speventlist,.coveo-icon.filetype.speventlist,.coveo-icon.filetype.spformlibrarylist,.coveo-icon.filetype.Spformlibrarylist,.coveo-icon.filetype.spimedictionary,.coveo-icon.filetype.Spimedictionary,.coveo-icon.filetype.spimedictionarylist,.coveo-icon.filetype.Spimedictionarylist,.coveo-icon.filetype.Spipfslist,.coveo-icon.filetype.spipfslist,.coveo-icon.filetype.spissue,.coveo-icon.filetype.Spissue,.coveo-icon.filetype.Spissuelist,.coveo-icon.filetype.spissuelist,.coveo-icon.filetype.spkeyperformanceindicator,.coveo-icon.filetype.Spkeyperformanceindicator,.coveo-icon.filetype.spkeyperformanceindicatorlist,.coveo-icon.filetype.Spkeyperformanceindicatorlist,.coveo-icon.filetype.Splink,.coveo-icon.filetype.splink,.coveo-icon.filetype.splinklist,.coveo-icon.filetype.Splinklist,.coveo-icon.filetype.Splistfolder,.coveo-icon.filetype.splistfolder,.coveo-icon.filetype.splisttemplatecataloglist,.coveo-icon.filetype.Splisttemplatecataloglist,.coveo-icon.filetype.Spmasterpagescataloglist,.coveo-icon.filetype.spmasterpagescataloglist,.coveo-icon.filetype.Spmeetingserie,.coveo-icon.filetype.spmeetingserie,.coveo-icon.filetype.Spmeetingserielist,.coveo-icon.filetype.spmeetingserielist,.coveo-icon.filetype.spnocodeworkflowlibrarylist,.coveo-icon.filetype.Spnocodeworkflowlibrarylist,.coveo-icon.filetype.spobjective,.coveo-icon.filetype.Spobjective,.coveo-icon.filetype.Spobjectivelist,.coveo-icon.filetype.spobjectivelist,.coveo-icon.filetype.sppicturelibrarylist,.coveo-icon.filetype.Sppicturelibrarylist,.coveo-icon.filetype.spportal,.coveo-icon.filetype.Spportal,.coveo-icon.filetype.Spprocessdiagramslibrarylist,.coveo-icon.filetype.spprocessdiagramslibrarylist,.coveo-icon.filetype.Spprojecttask,.coveo-icon.filetype.spprojecttask,.coveo-icon.filetype.spprojecttasklist,.coveo-icon.filetype.Spprojecttasklist,.coveo-icon.filetype.sppublishingimageslibrarylist,.coveo-icon.filetype.Sppublishingimageslibrarylist,.coveo-icon.filetype.Sppublishingpageslibrarylist,.coveo-icon.filetype.sppublishingpageslibrarylist,.coveo-icon.filetype.sprecordlibrarylist,.coveo-icon.filetype.Sprecordlibrarylist,.coveo-icon.filetype.Spreportdocumentlibrarylist,.coveo-icon.filetype.spreportdocumentlibrarylist,.coveo-icon.filetype.Spreportlibrarylist,.coveo-icon.filetype.spreportlibrarylist,.coveo-icon.filetype.spresource,.coveo-icon.filetype.Spresource,.coveo-icon.filetype.Spresourcelist,.coveo-icon.filetype.spresourcelist,.coveo-icon.filetype.Spsite,.coveo-icon.filetype.spsite,.coveo-icon.filetype.spsitedirectory,.coveo-icon.filetype.Spsitedirectory,.coveo-icon.filetype.spsitedirectorylist,.coveo-icon.filetype.Spsitedirectorylist,.coveo-icon.filetype.spsitethemeslibrarylist,.coveo-icon.filetype.Spsitethemeslibrarylist,.coveo-icon.filetype.Spslidelibrarylist,.coveo-icon.filetype.spslidelibrarylist,.coveo-icon.filetype.spsolutionslibrarylist,.coveo-icon.filetype.Spsolutionslibrarylist,.coveo-icon.filetype.Spsurvey,.coveo-icon.filetype.spsurvey,.coveo-icon.filetype.spsurveylist,.coveo-icon.filetype.Spsurveylist,.coveo-icon.filetype.Sptab,.coveo-icon.filetype.sptab,.coveo-icon.filetype.sptablist,.coveo-icon.filetype.Sptablist,.coveo-icon.filetype.sptask,.coveo-icon.filetype.Sptask,.coveo-icon.filetype.Sptasklist,.coveo-icon.filetype.sptasklist,.coveo-icon.filetype.spthingstobring,.coveo-icon.filetype.Spthingstobring,.coveo-icon.filetype.Spthingstobringlist,.coveo-icon.filetype.spthingstobringlist,.coveo-icon.filetype.Sptranslationmanagementlibrarylist,.coveo-icon.filetype.sptranslationmanagementlibrarylist,.coveo-icon.filetype.Spunknownlist,.coveo-icon.filetype.spunknownlist,.coveo-icon.filetype.spuserinformation,.coveo-icon.filetype.Spuserinformation,.coveo-icon.filetype.Spuserinformationlist,.coveo-icon.filetype.spuserinformationlist,.coveo-icon.filetype.Spuserprofile,.coveo-icon.filetype.spuserprofile,.coveo-icon.filetype.Spwebpartcataloglist,.coveo-icon.filetype.spwebpartcataloglist,.coveo-icon.filetype.spwebtemplatecataloglist,.coveo-icon.filetype.Spwebtemplatecataloglist,.coveo-icon.filetype.Spwfpublibrarylist,.coveo-icon.filetype.spwfpublibrarylist,.coveo-icon.filetype.spwhereabout,.coveo-icon.filetype.Spwhereabout,.coveo-icon.filetype.Spwhereaboutlist,.coveo-icon.filetype.spwhereaboutlist,.coveo-icon.filetype.spwikipagelibrarylist,.coveo-icon.filetype.Spwikipagelibrarylist,.coveo-icon.filetype.Spworkflowhistory,.coveo-icon.filetype.spworkflowhistory,.coveo-icon.filetype.spworkflowhistorylist,.coveo-icon.filetype.Spworkflowhistorylist,.coveo-icon.filetype.spworkflowprocess,.coveo-icon.filetype.Spworkflowprocess,.coveo-icon.filetype.Spworkflowprocesslist,.coveo-icon.filetype.spworkflowprocesslist,.coveo-icon.filetype.Spworkspacepagelist,.coveo-icon.filetype.spworkspacepagelist,.coveo-icon.filetype.video,.coveo-icon.filetype.Video,.coveo-icon.filetype.Youtube,.coveo-icon.filetype.youtube,.coveo-icon.filetype.Youtubeplaylist,.coveo-icon.filetype.youtubeplaylist,.coveo-icon.filetype.youtubeplaylistitem,.coveo-icon.filetype.Youtubeplaylistitem,.coveo-icon.filetype.Youtubevideo,.coveo-icon.filetype.youtubevideo,.coveo-icon.objecttype,.coveo-icon.objecttype.account,.coveo-icon.objecttype.Account,.coveo-icon.objecttype.annotation,.coveo-icon.objecttype.Annotation,.coveo-icon.objecttype.Appointment,.coveo-icon.objecttype.appointment,.coveo-icon.objecttype.Attachment,.coveo-icon.objecttype.attachment,.coveo-icon.objecttype.campaign,.coveo-icon.objecttype.Campaign,.coveo-icon.objecttype.case,.coveo-icon.objecttype.Case,.coveo-icon.objecttype.casecomment,.coveo-icon.objecttype.Casecomment,.coveo-icon.objecttype.Collaborationgroup,.coveo-icon.objecttype.collaborationgroup,.coveo-icon.objecttype.contact,.coveo-icon.objecttype.Contact,.coveo-icon.objecttype.contentversion,.coveo-icon.objecttype.Contentversion,.coveo-icon.objecttype.contract,.coveo-icon.objecttype.Contract,.coveo-icon.objecttype.Dashboard,.coveo-icon.objecttype.dashboard,.coveo-icon.objecttype.email,.coveo-icon.objecttype.Email,.coveo-icon.objecttype.Event,.coveo-icon.objecttype.event,.coveo-icon.objecttype.feed,.coveo-icon.objecttype.Feed,.coveo-icon.objecttype.feedcomment,.coveo-icon.objecttype.Feedcomment,.coveo-icon.objecttype.feeditem,.coveo-icon.objecttype.Feeditem,.coveo-icon.objecttype.File,.coveo-icon.objecttype.file,.coveo-icon.objecttype.goal,.coveo-icon.objecttype.Goal,.coveo-icon.objecttype.Incident,.coveo-icon.objecttype.incident,.coveo-icon.objecttype.Kbarticle,.coveo-icon.objecttype.kbarticle,.coveo-icon.objecttype.kbarticlecomment,.coveo-icon.objecttype.Kbarticlecomment,.coveo-icon.objecttype.kbdocumentation,.coveo-icon.objecttype.Kbdocumentation,.coveo-icon.objecttype.kbknowledgearticle,.coveo-icon.objecttype.Kbknowledgearticle,.coveo-icon.objecttype.Kbsolution,.coveo-icon.objecttype.kbsolution,.coveo-icon.objecttype.kbtechnicalarticle,.coveo-icon.objecttype.Kbtechnicalarticle,.coveo-icon.objecttype.Knowledgearticle,.coveo-icon.objecttype.knowledgearticle,.coveo-icon.objecttype.Lead,.coveo-icon.objecttype.lead,.coveo-icon.objecttype.list,.coveo-icon.objecttype.List,.coveo-icon.objecttype.message,.coveo-icon.objecttype.Message,.coveo-icon.objecttype.Note,.coveo-icon.objecttype.note,.coveo-icon.objecttype.Opportunity,.coveo-icon.objecttype.opportunity,.coveo-icon.objecttype.opportunityproduct,.coveo-icon.objecttype.Opportunityproduct,.coveo-icon.objecttype.partner,.coveo-icon.objecttype.Partner,.coveo-icon.objecttype.People,.coveo-icon.objecttype.people,.coveo-icon.objecttype.Phonecall,.coveo-icon.objecttype.phonecall,.coveo-icon.objecttype.Product,.coveo-icon.objecttype.product,.coveo-icon.objecttype.quote,.coveo-icon.objecttype.Quote,.coveo-icon.objecttype.Report,.coveo-icon.objecttype.report,.coveo-icon.objecttype.Salesliterature,.coveo-icon.objecttype.salesliterature,.coveo-icon.objecttype.Salesorder,.coveo-icon.objecttype.salesorder,.coveo-icon.objecttype.Service,.coveo-icon.objecttype.service,.coveo-icon.objecttype.Socialprofile,.coveo-icon.objecttype.socialprofile,.coveo-icon.objecttype.solution,.coveo-icon.objecttype.Solution,.coveo-icon.objecttype.task,.coveo-icon.objecttype.Task,.coveo-icon.objecttype.thread,.coveo-icon.objecttype.Thread,.coveo-icon.objecttype.Topic,.coveo-icon.objecttype.topic,.coveo-icon.objecttype.User,.coveo-icon.objecttype.user{display:inline-block;width:60px;height:60px;background-size:60px 60px}.coveo-filetype-list,.coveo-icon.filetype.Exchangeactivity,.coveo-icon.filetype.exchangeactivity,.coveo-icon.filetype.exchangenote,.coveo-icon.filetype.Exchangenote,.coveo-icon.filetype.Exchangeofficecom,.coveo-icon.filetype.exchangeofficecom,.coveo-icon.filetype.exchangerssfeed,.coveo-icon.filetype.Exchangerssfeed,.coveo-icon.filetype.kb_social_qa_answer,.coveo-icon.filetype.Kb_social_qa_answer,.coveo-icon.filetype.kb_social_qa_comment,.coveo-icon.filetype.Kb_social_qa_comment,.coveo-icon.filetype.Kb_social_qa_question,.coveo-icon.filetype.kb_social_qa_question,.coveo-icon.filetype.Spannouncement,.coveo-icon.filetype.spannouncement,.coveo-icon.filetype.spannouncementlist,.coveo-icon.filetype.Spannouncementlist,.coveo-icon.filetype.Spblogcategory,.coveo-icon.filetype.spblogcategory,.coveo-icon.filetype.Spblogcategorylist,.coveo-icon.filetype.spblogcategorylist,.coveo-icon.filetype.Spblogcomment,.coveo-icon.filetype.spblogcomment,.coveo-icon.filetype.spblogcommentlist,.coveo-icon.filetype.Spblogcommentlist,.coveo-icon.filetype.Spblogpost,.coveo-icon.filetype.spblogpost,.coveo-icon.filetype.Spblogpostlist,.coveo-icon.filetype.spblogpostlist,.coveo-icon.filetype.Spdiscussionboard,.coveo-icon.filetype.spdiscussionboard,.coveo-icon.filetype.spdiscussionboardlist,.coveo-icon.filetype.Spdiscussionboardlist,.coveo-icon.filetype.sphealthreport,.coveo-icon.filetype.Sphealthreport,.coveo-icon.filetype.sphealthreportlist,.coveo-icon.filetype.Sphealthreportlist,.coveo-icon.filetype.sphealthrule,.coveo-icon.filetype.Sphealthrule,.coveo-icon.filetype.sphealthrulelist,.coveo-icon.filetype.Sphealthrulelist,.coveo-icon.filetype.splanguagesandtranslator,.coveo-icon.filetype.Splanguagesandtranslator,.coveo-icon.filetype.splanguagesandtranslatorlist,.coveo-icon.filetype.Splanguagesandtranslatorlist,.coveo-icon.filetype.spmicrofeedlist,.coveo-icon.filetype.Spmicrofeedlist,.coveo-icon.filetype.spmicrofeedpost,.coveo-icon.filetype.Spmicrofeedpost,.coveo-icon.filetype.spperformancepointcontent,.coveo-icon.filetype.Spperformancepointcontent,.coveo-icon.filetype.spperformancepointcontentlist,.coveo-icon.filetype.Spperformancepointcontentlist,.coveo-icon.filetype.spphonecallmemo,.coveo-icon.filetype.Spphonecallmemo,.coveo-icon.filetype.Spphonecallmemolist,.coveo-icon.filetype.spphonecallmemolist,.coveo-icon.filetype.Sptextbox,.coveo-icon.filetype.sptextbox,.coveo-icon.filetype.sptextboxlist,.coveo-icon.filetype.Sptextboxlist,.coveo-icon.objecttype.Board,.coveo-icon.objecttype.board,.coveo-icon.objecttype.category,.coveo-icon.objecttype.Category,.coveo-icon.objecttype.Invoice,.coveo-icon.objecttype.invoice,.coveo-icon.objecttype.Queueitem,.coveo-icon.objecttype.queueitem{display:inline-block;width:52px;height:52px;background-size:52px 52px}.coveo-filetype-salesforce-doctype-ai,.coveo-filetype-salesforce-doctype-attachment,.coveo-filetype-salesforce-doctype-audio,.coveo-filetype-salesforce-doctype-box-notes,.coveo-filetype-salesforce-doctype-csv,.coveo-filetype-salesforce-doctype-eps,.coveo-filetype-salesforce-doctype-excel,.coveo-filetype-salesforce-doctype-exe,.coveo-filetype-salesforce-doctype-flash,.coveo-filetype-salesforce-doctype-folder,.coveo-filetype-salesforce-doctype-gdoc,.coveo-filetype-salesforce-doctype-gdocs,.coveo-filetype-salesforce-doctype-gform,.coveo-filetype-salesforce-doctype-gpres,.coveo-filetype-salesforce-doctype-gsheet,.coveo-filetype-salesforce-doctype-html,.coveo-filetype-salesforce-doctype-image,.coveo-filetype-salesforce-doctype-keynote,.coveo-filetype-salesforce-doctype-library-folder,.coveo-filetype-salesforce-doctype-link,.coveo-filetype-salesforce-doctype-mp4,.coveo-filetype-salesforce-doctype-overlay,.coveo-filetype-salesforce-doctype-pack,.coveo-filetype-salesforce-doctype-pages,.coveo-filetype-salesforce-doctype-pdf,.coveo-filetype-salesforce-doctype-ppt,.coveo-filetype-salesforce-doctype-psd,.coveo-filetype-salesforce-doctype-quip-doc,.coveo-filetype-salesforce-doctype-quip-sheet,.coveo-filetype-salesforce-doctype-rtf,.coveo-filetype-salesforce-doctype-slide,.coveo-filetype-salesforce-doctype-stypi,.coveo-filetype-salesforce-doctype-txt,.coveo-filetype-salesforce-doctype-unknown,.coveo-filetype-salesforce-doctype-video,.coveo-filetype-salesforce-doctype-visio,.coveo-filetype-salesforce-doctype-webex,.coveo-filetype-salesforce-doctype-word,.coveo-filetype-salesforce-doctype-xml,.coveo-filetype-salesforce-doctype-zip,.coveo-icon.filetype.doc,.coveo-icon.filetype.Doc,.coveo-icon.filetype.docx,.coveo-icon.filetype.Docx,.coveo-icon.filetype.html,.coveo-icon.filetype.Html,.coveo-icon.filetype.Image,.coveo-icon.filetype.image,.coveo-icon.filetype.pdf,.coveo-icon.filetype.Pdf,.coveo-icon.filetype.ppt,.coveo-icon.filetype.Ppt,.coveo-icon.filetype.Svg,.coveo-icon.filetype.svg,.coveo-icon.filetype.Svm,.coveo-icon.filetype.svm,.coveo-icon.filetype.Swf,.coveo-icon.filetype.swf,.coveo-icon.filetype.txt,.coveo-icon.filetype.Txt,.coveo-icon.filetype.Vsd,.coveo-icon.filetype.vsd,.coveo-icon.filetype.webscraperwebpage,.coveo-icon.filetype.Webscraperwebpage,.coveo-icon.filetype.Wiki,.coveo-icon.filetype.wiki,.coveo-icon.filetype.Xls,.coveo-icon.filetype.xls,.coveo-icon.filetype.Xml,.coveo-icon.filetype.xml,.coveo-icon.filetype.zip,.coveo-icon.filetype.Zip,.coveo-icon.objecttype.kbattachment,.coveo-icon.objecttype.Kbattachment{display:inline-block;width:56px;height:64px;background-size:56px 64px}.coveo-filetype-attachment-small,.coveo-filetype-calendar-small,.coveo-filetype-case-small,.coveo-filetype-custom-small,.coveo-filetype-document-small,.coveo-filetype-file-small,.coveo-filetype-folder-small,.coveo-filetype-images-small,.coveo-filetype-kb-small,.coveo-filetype-link-small,.coveo-filetype-mail-small,.coveo-filetype-salesforce-standard-account-small,.coveo-filetype-salesforce-standard-action-list-component-small,.coveo-filetype-salesforce-standard-address-small,.coveo-filetype-salesforce-standard-announcement-small,.coveo-filetype-salesforce-standard-answer-best-small,.coveo-filetype-salesforce-standard-answer-private-small,.coveo-filetype-salesforce-standard-answer-public-small,.coveo-filetype-salesforce-standard-approval-small,.coveo-filetype-salesforce-standard-apps-admin-small,.coveo-filetype-salesforce-standard-apps-small,.coveo-filetype-salesforce-standard-article-small,.coveo-filetype-salesforce-standard-asset-relationship-small,.coveo-filetype-salesforce-standard-assigned-resource-small,.coveo-filetype-salesforce-standard-avatar-loading-small,.coveo-filetype-salesforce-standard-avatar-small,.coveo-filetype-salesforce-standard-bot-small,.coveo-filetype-salesforce-standard-business-hours-small,.coveo-filetype-salesforce-standard-calibration-small,.coveo-filetype-salesforce-standard-call-history-small,.coveo-filetype-salesforce-standard-call-small,.coveo-filetype-salesforce-standard-campaign-members-small,.coveo-filetype-salesforce-standard-campaign-small,.coveo-filetype-salesforce-standard-canvas-small,.coveo-filetype-salesforce-standard-carousel-small,.coveo-filetype-salesforce-standard-case-change-status-small,.coveo-filetype-salesforce-standard-case-comment-small,.coveo-filetype-salesforce-standard-case-email-small,.coveo-filetype-salesforce-standard-case-log-a-call-small,.coveo-filetype-salesforce-standard-case-milestone-small,.coveo-filetype-salesforce-standard-case-small,.coveo-filetype-salesforce-standard-case-transcript-small,.coveo-filetype-salesforce-standard-channel-program-history-small,.coveo-filetype-salesforce-standard-channel-program-levels-small,.coveo-filetype-salesforce-standard-channel-program-members-small,.coveo-filetype-salesforce-standard-channel-programs-small,.coveo-filetype-salesforce-standard-client-small,.coveo-filetype-salesforce-standard-cms-small,.coveo-filetype-salesforce-standard-coaching-small,.coveo-filetype-salesforce-standard-connected-apps-small,.coveo-filetype-salesforce-standard-contact-list-small,.coveo-filetype-salesforce-standard-contact-small,.coveo-filetype-salesforce-standard-contract-line-item-small,.coveo-filetype-salesforce-standard-contract-small,.coveo-filetype-salesforce-standard-custom-notification-small,.coveo-filetype-salesforce-standard-custom-small,.coveo-filetype-salesforce-standard-customers-small,.coveo-filetype-salesforce-standard-dashboard-small,.coveo-filetype-salesforce-standard-data-integration-hub-small,.coveo-filetype-salesforce-standard-default-small,.coveo-filetype-salesforce-standard-document-small,.coveo-filetype-salesforce-standard-drafts-small,.coveo-filetype-salesforce-standard-email-chatter-small,.coveo-filetype-salesforce-standard-email-small,.coveo-filetype-salesforce-standard-empty-small,.coveo-filetype-salesforce-standard-endorsement-small,.coveo-filetype-salesforce-standard-entitlement-process-small,.coveo-filetype-salesforce-standard-entitlement-small,.coveo-filetype-salesforce-standard-entitlement-template-small,.coveo-filetype-salesforce-standard-entity-milestone-small,.coveo-filetype-salesforce-standard-entity-small,.coveo-filetype-salesforce-standard-environment-hub-small,.coveo-filetype-salesforce-standard-event-small,.coveo-filetype-salesforce-standard-feed-small,.coveo-filetype-salesforce-standard-feedback-small,.coveo-filetype-salesforce-standard-file-small,.coveo-filetype-salesforce-standard-flow-small,.coveo-filetype-salesforce-standard-folder-small,.coveo-filetype-salesforce-standard-forecasts-small,.coveo-filetype-salesforce-standard-generic-loading-small,.coveo-filetype-salesforce-standard-goals-small,.coveo-filetype-salesforce-standard-group-loading-small,.coveo-filetype-salesforce-standard-groups-small,.coveo-filetype-salesforce-standard-hierarchy-small,.coveo-filetype-salesforce-standard-home-small,.coveo-filetype-salesforce-standard-household-small,.coveo-filetype-salesforce-standard-individual-small,.coveo-filetype-salesforce-standard-insights-small,.coveo-filetype-salesforce-standard-investment-account-small,.coveo-filetype-salesforce-standard-iot-orchestrations-small,.coveo-filetype-salesforce-standard-knowledge-small,.coveo-filetype-salesforce-standard-lead-insights-small,.coveo-filetype-salesforce-standard-lead-list-small,.coveo-filetype-salesforce-standard-lead-small,.coveo-filetype-salesforce-standard-link-small,.coveo-filetype-salesforce-standard-list-email-small,.coveo-filetype-salesforce-standard-live-chat-small,.coveo-filetype-salesforce-standard-live-chat-visitor-small,.coveo-filetype-salesforce-standard-location-small,.coveo-filetype-salesforce-standard-log-a-call-small,.coveo-filetype-salesforce-standard-logging-small,.coveo-filetype-salesforce-standard-macros-small,.coveo-filetype-salesforce-standard-maintenance-asset-small,.coveo-filetype-salesforce-standard-maintenance-plan-small,.coveo-filetype-salesforce-standard-marketing-actions-small,.coveo-filetype-salesforce-standard-merge-small,.coveo-filetype-salesforce-standard-messaging-conversation-small,.coveo-filetype-salesforce-standard-messaging-session-small,.coveo-filetype-salesforce-standard-messaging-user-small,.coveo-filetype-salesforce-standard-metrics-small,.coveo-filetype-salesforce-standard-news-small,.coveo-filetype-salesforce-standard-note-small,.coveo-filetype-salesforce-standard-omni-supervisor-small,.coveo-filetype-salesforce-standard-operating-hours-small,.coveo-filetype-salesforce-standard-opportunity-small,.coveo-filetype-salesforce-standard-opportunity-splits-small,.coveo-filetype-salesforce-standard-orders-small,.coveo-filetype-salesforce-standard-partner-fund-allocation-small,.coveo-filetype-salesforce-standard-partner-fund-claim-small,.coveo-filetype-salesforce-standard-partner-fund-request-small,.coveo-filetype-salesforce-standard-partner-marketing-budget-small,.coveo-filetype-salesforce-standard-partners-small,.coveo-filetype-salesforce-standard-past-chat-small,.coveo-filetype-salesforce-standard-people-small,.coveo-filetype-salesforce-standard-performance-small,.coveo-filetype-salesforce-standard-person-account-small,.coveo-filetype-salesforce-standard-photo-small,.coveo-filetype-salesforce-standard-poll-small,.coveo-filetype-salesforce-standard-portal-small,.coveo-filetype-salesforce-standard-post-small,.coveo-filetype-salesforce-standard-pricebook-small,.coveo-filetype-salesforce-standard-process-small,.coveo-filetype-salesforce-standard-product-consumed-small,.coveo-filetype-salesforce-standard-product-item-small,.coveo-filetype-salesforce-standard-product-item-transaction-small,.coveo-filetype-salesforce-standard-product-request-line-item-small,.coveo-filetype-salesforce-standard-product-request-small,.coveo-filetype-salesforce-standard-product-required-small,.coveo-filetype-salesforce-standard-product-small,.coveo-filetype-salesforce-standard-product-transfer-small,.coveo-filetype-salesforce-standard-question-best-small,.coveo-filetype-salesforce-standard-question-feed-small,.coveo-filetype-salesforce-standard-quick-text-small,.coveo-filetype-salesforce-standard-quip-sheet-small,.coveo-filetype-salesforce-standard-quip-small,.coveo-filetype-salesforce-standard-quotes-small,.coveo-filetype-salesforce-standard-read-receipts-small,.coveo-filetype-salesforce-standard-recent-small,.coveo-filetype-salesforce-standard-record-small,.coveo-filetype-salesforce-standard-related-list-small,.coveo-filetype-salesforce-standard-relationship-small,.coveo-filetype-salesforce-standard-report-small,.coveo-filetype-salesforce-standard-resource-absence-small,.coveo-filetype-salesforce-standard-resource-capacity-small,.coveo-filetype-salesforce-standard-resource-preference-small,.coveo-filetype-salesforce-standard-resource-skill-small,.coveo-filetype-salesforce-standard-return-order-line-item-small,.coveo-filetype-salesforce-standard-return-order-small,.coveo-filetype-salesforce-standard-reward-small,.coveo-filetype-salesforce-standard-rtc-presence-small,.coveo-filetype-salesforce-standard-sales-path-small,.coveo-filetype-salesforce-standard-scan-card-small,.coveo-filetype-salesforce-standard-search-small,.coveo-filetype-salesforce-standard-service-appointment-small,.coveo-filetype-salesforce-standard-service-contract-small,.coveo-filetype-salesforce-standard-service-crew-member-small,.coveo-filetype-salesforce-standard-service-crew-small,.coveo-filetype-salesforce-standard-service-report-small,.coveo-filetype-salesforce-standard-service-resource-small,.coveo-filetype-salesforce-standard-service-territory-location-small,.coveo-filetype-salesforce-standard-service-territory-member-small,.coveo-filetype-salesforce-standard-service-territory-small,.coveo-filetype-salesforce-standard-shipment-small,.coveo-filetype-salesforce-standard-skill-entity-small,.coveo-filetype-salesforce-standard-skill-requirement-small,.coveo-filetype-salesforce-standard-skill-small,.coveo-filetype-salesforce-standard-social-small,.coveo-filetype-salesforce-standard-solution-small,.coveo-filetype-salesforce-standard-sossession-small,.coveo-filetype-salesforce-standard-stage-collection-small,.coveo-filetype-salesforce-standard-stage-small,.coveo-filetype-salesforce-standard-survey-small,.coveo-filetype-salesforce-standard-task2-small,.coveo-filetype-salesforce-standard-task-small,.coveo-filetype-salesforce-standard-team-member-small,.coveo-filetype-salesforce-standard-template-small,.coveo-filetype-salesforce-standard-thanks-loading-small,.coveo-filetype-salesforce-standard-thanks-small,.coveo-filetype-salesforce-standard-timesheet-entry-small,.coveo-filetype-salesforce-standard-timesheet-small,.coveo-filetype-salesforce-standard-timeslot-small,.coveo-filetype-salesforce-standard-today-small,.coveo-filetype-salesforce-standard-topic2-small,.coveo-filetype-salesforce-standard-topic-small,.coveo-filetype-salesforce-standard-unmatched-small,.coveo-filetype-salesforce-standard-user-small,.coveo-filetype-salesforce-standard-work-order-item-small,.coveo-filetype-salesforce-standard-work-order-small,.coveo-filetype-salesforce-standard-work-type-small,.coveo-filetype-user-small,.coveo-filetype-video-small,.coveo-filetype-webpage-small,.coveo-icon.filetype.coveo-small,.coveo-icon.filetype.coveo-small.activedirperson,.coveo-icon.filetype.coveo-small.Activedirperson,.coveo-icon.filetype.coveo-small.box,.coveo-icon.filetype.coveo-small.Box,.coveo-icon.filetype.coveo-small.Box-user,.coveo-icon.filetype.coveo-small.box user,.coveo-icon.filetype.coveo-small.Cfblogentry,.coveo-icon.filetype.coveo-small.cfblogentry,.coveo-icon.filetype.coveo-small.Cfcomment,.coveo-icon.filetype.coveo-small.cfcomment,.coveo-icon.filetype.coveo-small.Cfpage,.coveo-icon.filetype.coveo-small.cfpage,.coveo-icon.filetype.coveo-small.Cfspace,.coveo-icon.filetype.coveo-small.cfspace,.coveo-icon.filetype.coveo-small.Confluencespace,.coveo-icon.filetype.coveo-small.confluencespace,.coveo-icon.filetype.coveo-small.dynamicscrmitem,.coveo-icon.filetype.coveo-small.Dynamicscrmitem,.coveo-icon.filetype.coveo-small.exchangeappointment,.coveo-icon.filetype.coveo-small.Exchangeappointment,.coveo-icon.filetype.coveo-small.exchangecalendarmessage,.coveo-icon.filetype.coveo-small.Exchangecalendarmessage,.coveo-icon.filetype.coveo-small.Exchangedocument,.coveo-icon.filetype.coveo-small.exchangedocument,.coveo-icon.filetype.coveo-small.Exchangedsn,.coveo-icon.filetype.coveo-small.exchangedsn,.coveo-icon.filetype.coveo-small.Exchangefreebusy,.coveo-icon.filetype.coveo-small.exchangefreebusy,.coveo-icon.filetype.coveo-small.exchangegroup,.coveo-icon.filetype.coveo-small.Exchangegroup,.coveo-icon.filetype.coveo-small.Exchangejunkmessage,.coveo-icon.filetype.coveo-small.exchangejunkmessage,.coveo-icon.filetype.coveo-small.exchangemdn,.coveo-icon.filetype.coveo-small.Exchangemdn,.coveo-icon.filetype.coveo-small.exchangemessage,.coveo-icon.filetype.coveo-small.Exchangemessage,.coveo-icon.filetype.coveo-small.Exchangeobject,.coveo-icon.filetype.coveo-small.exchangeobject,.coveo-icon.filetype.coveo-small.Exchangeperson,.coveo-icon.filetype.coveo-small.exchangeperson,.coveo-icon.filetype.coveo-small.Exchangerecallmessage,.coveo-icon.filetype.coveo-small.exchangerecallmessage,.coveo-icon.filetype.coveo-small.exchangerecallreport,.coveo-icon.filetype.coveo-small.Exchangerecallreport,.coveo-icon.filetype.coveo-small.exchangetask,.coveo-icon.filetype.coveo-small.Exchangetask,.coveo-icon.filetype.coveo-small.folder,.coveo-icon.filetype.coveo-small.Folder,.coveo-icon.filetype.coveo-small.gmailmessage,.coveo-icon.filetype.coveo-small.Gmailmessage,.coveo-icon.filetype.coveo-small.incident,.coveo-icon.filetype.coveo-small.Incident,.coveo-icon.filetype.coveo-small.Jiraissue,.coveo-icon.filetype.coveo-small.jiraissue,.coveo-icon.filetype.coveo-small.kb_knowledge,.coveo-icon.filetype.coveo-small.Kb_knowledge,.coveo-icon.filetype.coveo-small.Lithiumboard,.coveo-icon.filetype.coveo-small.lithiumboard,.coveo-icon.filetype.coveo-small.lithiumcategory,.coveo-icon.filetype.coveo-small.Lithiumcategory,.coveo-icon.filetype.coveo-small.Lithiumcommunity,.coveo-icon.filetype.coveo-small.lithiumcommunity,.coveo-icon.filetype.coveo-small.lithiummessage,.coveo-icon.filetype.coveo-small.Lithiummessage,.coveo-icon.filetype.coveo-small.lithiumthread,.coveo-icon.filetype.coveo-small.Lithiumthread,.coveo-icon.filetype.coveo-small.odt,.coveo-icon.filetype.coveo-small.Odt,.coveo-icon.filetype.coveo-small.olefile,.coveo-icon.filetype.coveo-small.OleFile,.coveo-icon.filetype.coveo-small.Rssitem,.coveo-icon.filetype.coveo-small.rssitem,.coveo-icon.filetype.coveo-small.saleforceitem,.coveo-icon.filetype.coveo-small.Saleforceitem,.coveo-icon.filetype.coveo-small.Salesforceitem,.coveo-icon.filetype.coveo-small.salesforceitem,.coveo-icon.filetype.coveo-small.Sc_cat_item,.coveo-icon.filetype.coveo-small.sc_cat_item,.coveo-icon.filetype.coveo-small.sn_customerservice_case,.coveo-icon.filetype.coveo-small.Sn_customerservice_case,.coveo-icon.filetype.coveo-small.Sn_hr_core_case,.coveo-icon.filetype.coveo-small.sn_hr_core_case,.coveo-icon.filetype.coveo-small.spadministratortask,.coveo-icon.filetype.coveo-small.Spadministratortask,.coveo-icon.filetype.coveo-small.Spadministratortasklist,.coveo-icon.filetype.coveo-small.spadministratortasklist,.coveo-icon.filetype.coveo-small.spagenda,.coveo-icon.filetype.coveo-small.Spagenda,.coveo-icon.filetype.coveo-small.spagendalist,.coveo-icon.filetype.coveo-small.Spagendalist,.coveo-icon.filetype.coveo-small.Sparea,.coveo-icon.filetype.coveo-small.sparea,.coveo-icon.filetype.coveo-small.Spareadocumentlibrarylist,.coveo-icon.filetype.coveo-small.spareadocumentlibrarylist,.coveo-icon.filetype.coveo-small.Sparealisting,.coveo-icon.filetype.coveo-small.sparealisting,.coveo-icon.filetype.coveo-small.spattendee,.coveo-icon.filetype.coveo-small.Spattendee,.coveo-icon.filetype.coveo-small.spattendeelist,.coveo-icon.filetype.coveo-small.Spattendeelist,.coveo-icon.filetype.coveo-small.spcirculation,.coveo-icon.filetype.coveo-small.Spcirculation,.coveo-icon.filetype.coveo-small.Spcirculationlist,.coveo-icon.filetype.coveo-small.spcirculationlist,.coveo-icon.filetype.coveo-small.Spcontact,.coveo-icon.filetype.coveo-small.spcontact,.coveo-icon.filetype.coveo-small.Spcontactlist,.coveo-icon.filetype.coveo-small.spcontactlist,.coveo-icon.filetype.coveo-small.Spcustomgridlist,.coveo-icon.filetype.coveo-small.spcustomgridlist,.coveo-icon.filetype.coveo-small.Spcustomlist,.coveo-icon.filetype.coveo-small.spcustomlist,.coveo-icon.filetype.coveo-small.Spdashboardslibrarylist,.coveo-icon.filetype.coveo-small.spdashboardslibrarylist,.coveo-icon.filetype.coveo-small.Spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.coveo-small.spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.coveo-small.spdataconnectionlibrarylist,.coveo-icon.filetype.coveo-small.Spdataconnectionlibrarylist,.coveo-icon.filetype.coveo-small.spdatasource,.coveo-icon.filetype.coveo-small.Spdatasource,.coveo-icon.filetype.coveo-small.Spdatasourcelist,.coveo-icon.filetype.coveo-small.spdatasourcelist,.coveo-icon.filetype.coveo-small.Spdecision,.coveo-icon.filetype.coveo-small.spdecision,.coveo-icon.filetype.coveo-small.Spdecisionlist,.coveo-icon.filetype.coveo-small.spdecisionlist,.coveo-icon.filetype.coveo-small.spdistributiongroup,.coveo-icon.filetype.coveo-small.Spdistributiongroup,.coveo-icon.filetype.coveo-small.Spdistributiongrouplist,.coveo-icon.filetype.coveo-small.spdistributiongrouplist,.coveo-icon.filetype.coveo-small.spdocumentlibrarylist,.coveo-icon.filetype.coveo-small.Spdocumentlibrarylist,.coveo-icon.filetype.coveo-small.spdocumentlink,.coveo-icon.filetype.coveo-small.Spdocumentlink,.coveo-icon.filetype.coveo-small.spdocumentset,.coveo-icon.filetype.coveo-small.Spdocumentset,.coveo-icon.filetype.coveo-small.Spevent,.coveo-icon.filetype.coveo-small.spevent,.coveo-icon.filetype.coveo-small.Speventlist,.coveo-icon.filetype.coveo-small.speventlist,.coveo-icon.filetype.coveo-small.spformlibrarylist,.coveo-icon.filetype.coveo-small.Spformlibrarylist,.coveo-icon.filetype.coveo-small.spimedictionary,.coveo-icon.filetype.coveo-small.Spimedictionary,.coveo-icon.filetype.coveo-small.spimedictionarylist,.coveo-icon.filetype.coveo-small.Spimedictionarylist,.coveo-icon.filetype.coveo-small.Spipfslist,.coveo-icon.filetype.coveo-small.spipfslist,.coveo-icon.filetype.coveo-small.spissue,.coveo-icon.filetype.coveo-small.Spissue,.coveo-icon.filetype.coveo-small.Spissuelist,.coveo-icon.filetype.coveo-small.spissuelist,.coveo-icon.filetype.coveo-small.spkeyperformanceindicator,.coveo-icon.filetype.coveo-small.Spkeyperformanceindicator,.coveo-icon.filetype.coveo-small.spkeyperformanceindicatorlist,.coveo-icon.filetype.coveo-small.Spkeyperformanceindicatorlist,.coveo-icon.filetype.coveo-small.Splink,.coveo-icon.filetype.coveo-small.splink,.coveo-icon.filetype.coveo-small.splinklist,.coveo-icon.filetype.coveo-small.Splinklist,.coveo-icon.filetype.coveo-small.Splistfolder,.coveo-icon.filetype.coveo-small.splistfolder,.coveo-icon.filetype.coveo-small.splisttemplatecataloglist,.coveo-icon.filetype.coveo-small.Splisttemplatecataloglist,.coveo-icon.filetype.coveo-small.Spmasterpagescataloglist,.coveo-icon.filetype.coveo-small.spmasterpagescataloglist,.coveo-icon.filetype.coveo-small.Spmeetingserie,.coveo-icon.filetype.coveo-small.spmeetingserie,.coveo-icon.filetype.coveo-small.Spmeetingserielist,.coveo-icon.filetype.coveo-small.spmeetingserielist,.coveo-icon.filetype.coveo-small.spnocodeworkflowlibrarylist,.coveo-icon.filetype.coveo-small.Spnocodeworkflowlibrarylist,.coveo-icon.filetype.coveo-small.spobjective,.coveo-icon.filetype.coveo-small.Spobjective,.coveo-icon.filetype.coveo-small.Spobjectivelist,.coveo-icon.filetype.coveo-small.spobjectivelist,.coveo-icon.filetype.coveo-small.sppicturelibrarylist,.coveo-icon.filetype.coveo-small.Sppicturelibrarylist,.coveo-icon.filetype.coveo-small.spportal,.coveo-icon.filetype.coveo-small.Spportal,.coveo-icon.filetype.coveo-small.Spprocessdiagramslibrarylist,.coveo-icon.filetype.coveo-small.spprocessdiagramslibrarylist,.coveo-icon.filetype.coveo-small.Spprojecttask,.coveo-icon.filetype.coveo-small.spprojecttask,.coveo-icon.filetype.coveo-small.spprojecttasklist,.coveo-icon.filetype.coveo-small.Spprojecttasklist,.coveo-icon.filetype.coveo-small.sppublishingimageslibrarylist,.coveo-icon.filetype.coveo-small.Sppublishingimageslibrarylist,.coveo-icon.filetype.coveo-small.Sppublishingpageslibrarylist,.coveo-icon.filetype.coveo-small.sppublishingpageslibrarylist,.coveo-icon.filetype.coveo-small.sprecordlibrarylist,.coveo-icon.filetype.coveo-small.Sprecordlibrarylist,.coveo-icon.filetype.coveo-small.Spreportdocumentlibrarylist,.coveo-icon.filetype.coveo-small.spreportdocumentlibrarylist,.coveo-icon.filetype.coveo-small.Spreportlibrarylist,.coveo-icon.filetype.coveo-small.spreportlibrarylist,.coveo-icon.filetype.coveo-small.spresource,.coveo-icon.filetype.coveo-small.Spresource,.coveo-icon.filetype.coveo-small.Spresourcelist,.coveo-icon.filetype.coveo-small.spresourcelist,.coveo-icon.filetype.coveo-small.Spsite,.coveo-icon.filetype.coveo-small.spsite,.coveo-icon.filetype.coveo-small.spsitedirectory,.coveo-icon.filetype.coveo-small.Spsitedirectory,.coveo-icon.filetype.coveo-small.spsitedirectorylist,.coveo-icon.filetype.coveo-small.Spsitedirectorylist,.coveo-icon.filetype.coveo-small.spsitethemeslibrarylist,.coveo-icon.filetype.coveo-small.Spsitethemeslibrarylist,.coveo-icon.filetype.coveo-small.Spslidelibrarylist,.coveo-icon.filetype.coveo-small.spslidelibrarylist,.coveo-icon.filetype.coveo-small.spsolutionslibrarylist,.coveo-icon.filetype.coveo-small.Spsolutionslibrarylist,.coveo-icon.filetype.coveo-small.Spsurvey,.coveo-icon.filetype.coveo-small.spsurvey,.coveo-icon.filetype.coveo-small.spsurveylist,.coveo-icon.filetype.coveo-small.Spsurveylist,.coveo-icon.filetype.coveo-small.Sptab,.coveo-icon.filetype.coveo-small.sptab,.coveo-icon.filetype.coveo-small.sptablist,.coveo-icon.filetype.coveo-small.Sptablist,.coveo-icon.filetype.coveo-small.sptask,.coveo-icon.filetype.coveo-small.Sptask,.coveo-icon.filetype.coveo-small.Sptasklist,.coveo-icon.filetype.coveo-small.sptasklist,.coveo-icon.filetype.coveo-small.spthingstobring,.coveo-icon.filetype.coveo-small.Spthingstobring,.coveo-icon.filetype.coveo-small.Spthingstobringlist,.coveo-icon.filetype.coveo-small.spthingstobringlist,.coveo-icon.filetype.coveo-small.Sptranslationmanagementlibrarylist,.coveo-icon.filetype.coveo-small.sptranslationmanagementlibrarylist,.coveo-icon.filetype.coveo-small.Spunknownlist,.coveo-icon.filetype.coveo-small.spunknownlist,.coveo-icon.filetype.coveo-small.spuserinformation,.coveo-icon.filetype.coveo-small.Spuserinformation,.coveo-icon.filetype.coveo-small.Spuserinformationlist,.coveo-icon.filetype.coveo-small.spuserinformationlist,.coveo-icon.filetype.coveo-small.Spuserprofile,.coveo-icon.filetype.coveo-small.spuserprofile,.coveo-icon.filetype.coveo-small.Spwebpartcataloglist,.coveo-icon.filetype.coveo-small.spwebpartcataloglist,.coveo-icon.filetype.coveo-small.spwebtemplatecataloglist,.coveo-icon.filetype.coveo-small.Spwebtemplatecataloglist,.coveo-icon.filetype.coveo-small.Spwfpublibrarylist,.coveo-icon.filetype.coveo-small.spwfpublibrarylist,.coveo-icon.filetype.coveo-small.spwhereabout,.coveo-icon.filetype.coveo-small.Spwhereabout,.coveo-icon.filetype.coveo-small.Spwhereaboutlist,.coveo-icon.filetype.coveo-small.spwhereaboutlist,.coveo-icon.filetype.coveo-small.spwikipagelibrarylist,.coveo-icon.filetype.coveo-small.Spwikipagelibrarylist,.coveo-icon.filetype.coveo-small.Spworkflowhistory,.coveo-icon.filetype.coveo-small.spworkflowhistory,.coveo-icon.filetype.coveo-small.spworkflowhistorylist,.coveo-icon.filetype.coveo-small.Spworkflowhistorylist,.coveo-icon.filetype.coveo-small.spworkflowprocess,.coveo-icon.filetype.coveo-small.Spworkflowprocess,.coveo-icon.filetype.coveo-small.Spworkflowprocesslist,.coveo-icon.filetype.coveo-small.spworkflowprocesslist,.coveo-icon.filetype.coveo-small.Spworkspacepagelist,.coveo-icon.filetype.coveo-small.spworkspacepagelist,.coveo-icon.filetype.coveo-small.video,.coveo-icon.filetype.coveo-small.Video,.coveo-icon.filetype.coveo-small.Youtube,.coveo-icon.filetype.coveo-small.youtube,.coveo-icon.filetype.coveo-small.Youtubeplaylist,.coveo-icon.filetype.coveo-small.youtubeplaylist,.coveo-icon.filetype.coveo-small.youtubeplaylistitem,.coveo-icon.filetype.coveo-small.Youtubeplaylistitem,.coveo-icon.filetype.coveo-small.Youtubevideo,.coveo-icon.filetype.coveo-small.youtubevideo,.coveo-icon.objecttype.coveo-small,.coveo-icon.objecttype.coveo-small.account,.coveo-icon.objecttype.coveo-small.Account,.coveo-icon.objecttype.coveo-small.annotation,.coveo-icon.objecttype.coveo-small.Annotation,.coveo-icon.objecttype.coveo-small.Appointment,.coveo-icon.objecttype.coveo-small.appointment,.coveo-icon.objecttype.coveo-small.Attachment,.coveo-icon.objecttype.coveo-small.attachment,.coveo-icon.objecttype.coveo-small.campaign,.coveo-icon.objecttype.coveo-small.Campaign,.coveo-icon.objecttype.coveo-small.case,.coveo-icon.objecttype.coveo-small.Case,.coveo-icon.objecttype.coveo-small.casecomment,.coveo-icon.objecttype.coveo-small.Casecomment,.coveo-icon.objecttype.coveo-small.Collaborationgroup,.coveo-icon.objecttype.coveo-small.collaborationgroup,.coveo-icon.objecttype.coveo-small.contact,.coveo-icon.objecttype.coveo-small.Contact,.coveo-icon.objecttype.coveo-small.contentversion,.coveo-icon.objecttype.coveo-small.Contentversion,.coveo-icon.objecttype.coveo-small.contract,.coveo-icon.objecttype.coveo-small.Contract,.coveo-icon.objecttype.coveo-small.Dashboard,.coveo-icon.objecttype.coveo-small.dashboard,.coveo-icon.objecttype.coveo-small.email,.coveo-icon.objecttype.coveo-small.Email,.coveo-icon.objecttype.coveo-small.Event,.coveo-icon.objecttype.coveo-small.event,.coveo-icon.objecttype.coveo-small.feed,.coveo-icon.objecttype.coveo-small.Feed,.coveo-icon.objecttype.coveo-small.feedcomment,.coveo-icon.objecttype.coveo-small.Feedcomment,.coveo-icon.objecttype.coveo-small.feeditem,.coveo-icon.objecttype.coveo-small.Feeditem,.coveo-icon.objecttype.coveo-small.File,.coveo-icon.objecttype.coveo-small.file,.coveo-icon.objecttype.coveo-small.goal,.coveo-icon.objecttype.coveo-small.Goal,.coveo-icon.objecttype.coveo-small.Incident,.coveo-icon.objecttype.coveo-small.incident,.coveo-icon.objecttype.coveo-small.Kbarticle,.coveo-icon.objecttype.coveo-small.kbarticle,.coveo-icon.objecttype.coveo-small.kbarticlecomment,.coveo-icon.objecttype.coveo-small.Kbarticlecomment,.coveo-icon.objecttype.coveo-small.kbdocumentation,.coveo-icon.objecttype.coveo-small.Kbdocumentation,.coveo-icon.objecttype.coveo-small.kbknowledgearticle,.coveo-icon.objecttype.coveo-small.Kbknowledgearticle,.coveo-icon.objecttype.coveo-small.Kbsolution,.coveo-icon.objecttype.coveo-small.kbsolution,.coveo-icon.objecttype.coveo-small.kbtechnicalarticle,.coveo-icon.objecttype.coveo-small.Kbtechnicalarticle,.coveo-icon.objecttype.coveo-small.Knowledgearticle,.coveo-icon.objecttype.coveo-small.knowledgearticle,.coveo-icon.objecttype.coveo-small.Lead,.coveo-icon.objecttype.coveo-small.lead,.coveo-icon.objecttype.coveo-small.list,.coveo-icon.objecttype.coveo-small.List,.coveo-icon.objecttype.coveo-small.message,.coveo-icon.objecttype.coveo-small.Message,.coveo-icon.objecttype.coveo-small.Note,.coveo-icon.objecttype.coveo-small.note,.coveo-icon.objecttype.coveo-small.Opportunity,.coveo-icon.objecttype.coveo-small.opportunity,.coveo-icon.objecttype.coveo-small.opportunityproduct,.coveo-icon.objecttype.coveo-small.Opportunityproduct,.coveo-icon.objecttype.coveo-small.partner,.coveo-icon.objecttype.coveo-small.Partner,.coveo-icon.objecttype.coveo-small.People,.coveo-icon.objecttype.coveo-small.people,.coveo-icon.objecttype.coveo-small.Phonecall,.coveo-icon.objecttype.coveo-small.phonecall,.coveo-icon.objecttype.coveo-small.Product,.coveo-icon.objecttype.coveo-small.product,.coveo-icon.objecttype.coveo-small.quote,.coveo-icon.objecttype.coveo-small.Quote,.coveo-icon.objecttype.coveo-small.Report,.coveo-icon.objecttype.coveo-small.report,.coveo-icon.objecttype.coveo-small.Salesliterature,.coveo-icon.objecttype.coveo-small.salesliterature,.coveo-icon.objecttype.coveo-small.Salesorder,.coveo-icon.objecttype.coveo-small.salesorder,.coveo-icon.objecttype.coveo-small.Service,.coveo-icon.objecttype.coveo-small.service,.coveo-icon.objecttype.coveo-small.Socialprofile,.coveo-icon.objecttype.coveo-small.socialprofile,.coveo-icon.objecttype.coveo-small.solution,.coveo-icon.objecttype.coveo-small.Solution,.coveo-icon.objecttype.coveo-small.task,.coveo-icon.objecttype.coveo-small.Task,.coveo-icon.objecttype.coveo-small.thread,.coveo-icon.objecttype.coveo-small.Thread,.coveo-icon.objecttype.coveo-small.Topic,.coveo-icon.objecttype.coveo-small.topic,.coveo-icon.objecttype.coveo-small.User,.coveo-icon.objecttype.coveo-small.user{display:inline-block;width:30px;height:30px;background-size:30px 30px}.coveo-filetype-list-small,.coveo-icon.filetype.coveo-small.Exchangeactivity,.coveo-icon.filetype.coveo-small.exchangeactivity,.coveo-icon.filetype.coveo-small.exchangenote,.coveo-icon.filetype.coveo-small.Exchangenote,.coveo-icon.filetype.coveo-small.Exchangeofficecom,.coveo-icon.filetype.coveo-small.exchangeofficecom,.coveo-icon.filetype.coveo-small.exchangerssfeed,.coveo-icon.filetype.coveo-small.Exchangerssfeed,.coveo-icon.filetype.coveo-small.kb_social_qa_answer,.coveo-icon.filetype.coveo-small.Kb_social_qa_answer,.coveo-icon.filetype.coveo-small.kb_social_qa_comment,.coveo-icon.filetype.coveo-small.Kb_social_qa_comment,.coveo-icon.filetype.coveo-small.Kb_social_qa_question,.coveo-icon.filetype.coveo-small.kb_social_qa_question,.coveo-icon.filetype.coveo-small.Spannouncement,.coveo-icon.filetype.coveo-small.spannouncement,.coveo-icon.filetype.coveo-small.spannouncementlist,.coveo-icon.filetype.coveo-small.Spannouncementlist,.coveo-icon.filetype.coveo-small.Spblogcategory,.coveo-icon.filetype.coveo-small.spblogcategory,.coveo-icon.filetype.coveo-small.Spblogcategorylist,.coveo-icon.filetype.coveo-small.spblogcategorylist,.coveo-icon.filetype.coveo-small.Spblogcomment,.coveo-icon.filetype.coveo-small.spblogcomment,.coveo-icon.filetype.coveo-small.spblogcommentlist,.coveo-icon.filetype.coveo-small.Spblogcommentlist,.coveo-icon.filetype.coveo-small.Spblogpost,.coveo-icon.filetype.coveo-small.spblogpost,.coveo-icon.filetype.coveo-small.Spblogpostlist,.coveo-icon.filetype.coveo-small.spblogpostlist,.coveo-icon.filetype.coveo-small.Spdiscussionboard,.coveo-icon.filetype.coveo-small.spdiscussionboard,.coveo-icon.filetype.coveo-small.spdiscussionboardlist,.coveo-icon.filetype.coveo-small.Spdiscussionboardlist,.coveo-icon.filetype.coveo-small.sphealthreport,.coveo-icon.filetype.coveo-small.Sphealthreport,.coveo-icon.filetype.coveo-small.sphealthreportlist,.coveo-icon.filetype.coveo-small.Sphealthreportlist,.coveo-icon.filetype.coveo-small.sphealthrule,.coveo-icon.filetype.coveo-small.Sphealthrule,.coveo-icon.filetype.coveo-small.sphealthrulelist,.coveo-icon.filetype.coveo-small.Sphealthrulelist,.coveo-icon.filetype.coveo-small.splanguagesandtranslator,.coveo-icon.filetype.coveo-small.Splanguagesandtranslator,.coveo-icon.filetype.coveo-small.splanguagesandtranslatorlist,.coveo-icon.filetype.coveo-small.Splanguagesandtranslatorlist,.coveo-icon.filetype.coveo-small.spmicrofeedlist,.coveo-icon.filetype.coveo-small.Spmicrofeedlist,.coveo-icon.filetype.coveo-small.spmicrofeedpost,.coveo-icon.filetype.coveo-small.Spmicrofeedpost,.coveo-icon.filetype.coveo-small.spperformancepointcontent,.coveo-icon.filetype.coveo-small.Spperformancepointcontent,.coveo-icon.filetype.coveo-small.spperformancepointcontentlist,.coveo-icon.filetype.coveo-small.Spperformancepointcontentlist,.coveo-icon.filetype.coveo-small.spphonecallmemo,.coveo-icon.filetype.coveo-small.Spphonecallmemo,.coveo-icon.filetype.coveo-small.Spphonecallmemolist,.coveo-icon.filetype.coveo-small.spphonecallmemolist,.coveo-icon.filetype.coveo-small.Sptextbox,.coveo-icon.filetype.coveo-small.sptextbox,.coveo-icon.filetype.coveo-small.sptextboxlist,.coveo-icon.filetype.coveo-small.Sptextboxlist,.coveo-icon.objecttype.coveo-small.Board,.coveo-icon.objecttype.coveo-small.board,.coveo-icon.objecttype.coveo-small.category,.coveo-icon.objecttype.coveo-small.Category,.coveo-icon.objecttype.coveo-small.Invoice,.coveo-icon.objecttype.coveo-small.invoice,.coveo-icon.objecttype.coveo-small.Queueitem,.coveo-icon.objecttype.coveo-small.queueitem{display:inline-block;width:26px;height:26px;background-size:26px 26px}.coveo-filetype-salesforce-doctype-ai-small,.coveo-filetype-salesforce-doctype-attachment-small,.coveo-filetype-salesforce-doctype-audio-small,.coveo-filetype-salesforce-doctype-box-notes-small,.coveo-filetype-salesforce-doctype-csv-small,.coveo-filetype-salesforce-doctype-eps-small,.coveo-filetype-salesforce-doctype-excel-small,.coveo-filetype-salesforce-doctype-exe-small,.coveo-filetype-salesforce-doctype-flash-small,.coveo-filetype-salesforce-doctype-folder-small,.coveo-filetype-salesforce-doctype-gdoc-small,.coveo-filetype-salesforce-doctype-gdocs-small,.coveo-filetype-salesforce-doctype-gform-small,.coveo-filetype-salesforce-doctype-gpres-small,.coveo-filetype-salesforce-doctype-gsheet-small,.coveo-filetype-salesforce-doctype-html-small,.coveo-filetype-salesforce-doctype-image-small,.coveo-filetype-salesforce-doctype-keynote-small,.coveo-filetype-salesforce-doctype-library-folder-small,.coveo-filetype-salesforce-doctype-link-small,.coveo-filetype-salesforce-doctype-mp4-small,.coveo-filetype-salesforce-doctype-overlay-small,.coveo-filetype-salesforce-doctype-pack-small,.coveo-filetype-salesforce-doctype-pages-small,.coveo-filetype-salesforce-doctype-pdf-small,.coveo-filetype-salesforce-doctype-ppt-small,.coveo-filetype-salesforce-doctype-psd-small,.coveo-filetype-salesforce-doctype-quip-doc-small,.coveo-filetype-salesforce-doctype-quip-sheet-small,.coveo-filetype-salesforce-doctype-rtf-small,.coveo-filetype-salesforce-doctype-slide-small,.coveo-filetype-salesforce-doctype-stypi-small,.coveo-filetype-salesforce-doctype-txt-small,.coveo-filetype-salesforce-doctype-unknown-small,.coveo-filetype-salesforce-doctype-video-small,.coveo-filetype-salesforce-doctype-visio-small,.coveo-filetype-salesforce-doctype-webex-small,.coveo-filetype-salesforce-doctype-word-small,.coveo-filetype-salesforce-doctype-xml-small,.coveo-filetype-salesforce-doctype-zip-small,.coveo-icon.filetype.coveo-small.doc,.coveo-icon.filetype.coveo-small.Doc,.coveo-icon.filetype.coveo-small.docx,.coveo-icon.filetype.coveo-small.Docx,.coveo-icon.filetype.coveo-small.html,.coveo-icon.filetype.coveo-small.Html,.coveo-icon.filetype.coveo-small.Image,.coveo-icon.filetype.coveo-small.image,.coveo-icon.filetype.coveo-small.pdf,.coveo-icon.filetype.coveo-small.Pdf,.coveo-icon.filetype.coveo-small.ppt,.coveo-icon.filetype.coveo-small.Ppt,.coveo-icon.filetype.coveo-small.Svg,.coveo-icon.filetype.coveo-small.svg,.coveo-icon.filetype.coveo-small.Svm,.coveo-icon.filetype.coveo-small.svm,.coveo-icon.filetype.coveo-small.Swf,.coveo-icon.filetype.coveo-small.swf,.coveo-icon.filetype.coveo-small.txt,.coveo-icon.filetype.coveo-small.Txt,.coveo-icon.filetype.coveo-small.Vsd,.coveo-icon.filetype.coveo-small.vsd,.coveo-icon.filetype.coveo-small.webscraperwebpage,.coveo-icon.filetype.coveo-small.Webscraperwebpage,.coveo-icon.filetype.coveo-small.Wiki,.coveo-icon.filetype.coveo-small.wiki,.coveo-icon.filetype.coveo-small.Xls,.coveo-icon.filetype.coveo-small.xls,.coveo-icon.filetype.coveo-small.Xml,.coveo-icon.filetype.coveo-small.xml,.coveo-icon.filetype.coveo-small.zip,.coveo-icon.filetype.coveo-small.Zip,.coveo-icon.objecttype.coveo-small.kbattachment,.coveo-icon.objecttype.coveo-small.Kbattachment{display:inline-block;width:28px;height:32px;background-size:28px 32px}.coveo-filetype-attachment,.coveo-filetype-attachment-small,.coveo-icon.objecttype.Attachment,.coveo-icon.objecttype.attachment,.coveo-icon.objecttype.coveo-small.Attachment,.coveo-icon.objecttype.coveo-small.attachment{background-image:url( ../image/attachment.svg)}.coveo-filetype-calendar,.coveo-filetype-calendar-small,.coveo-icon.filetype.coveo-small.exchangeappointment,.coveo-icon.filetype.coveo-small.Exchangeappointment,.coveo-icon.filetype.coveo-small.Exchangecalendarmessage,.coveo-icon.filetype.coveo-small.exchangecalendarmessage,.coveo-icon.filetype.coveo-small.Spadministratortask,.coveo-icon.filetype.coveo-small.spadministratortask,.coveo-icon.filetype.coveo-small.Spadministratortasklist,.coveo-icon.filetype.coveo-small.spadministratortasklist,.coveo-icon.filetype.coveo-small.Spagenda,.coveo-icon.filetype.coveo-small.spagenda,.coveo-icon.filetype.coveo-small.Spagendalist,.coveo-icon.filetype.coveo-small.spagendalist,.coveo-icon.filetype.coveo-small.spevent,.coveo-icon.filetype.coveo-small.Spevent,.coveo-icon.filetype.coveo-small.Speventlist,.coveo-icon.filetype.coveo-small.speventlist,.coveo-icon.filetype.coveo-small.spmeetingserie,.coveo-icon.filetype.coveo-small.Spmeetingserie,.coveo-icon.filetype.coveo-small.spmeetingserielist,.coveo-icon.filetype.coveo-small.Spmeetingserielist,.coveo-icon.filetype.coveo-small.Sptask,.coveo-icon.filetype.coveo-small.sptask,.coveo-icon.filetype.coveo-small.Sptasklist,.coveo-icon.filetype.coveo-small.sptasklist,.coveo-icon.filetype.coveo-small.spworkflowhistory,.coveo-icon.filetype.coveo-small.Spworkflowhistory,.coveo-icon.filetype.coveo-small.Spworkflowhistorylist,.coveo-icon.filetype.coveo-small.spworkflowhistorylist,.coveo-icon.filetype.exchangeappointment,.coveo-icon.filetype.Exchangeappointment,.coveo-icon.filetype.Exchangecalendarmessage,.coveo-icon.filetype.exchangecalendarmessage,.coveo-icon.filetype.Spadministratortask,.coveo-icon.filetype.spadministratortask,.coveo-icon.filetype.spadministratortasklist,.coveo-icon.filetype.Spadministratortasklist,.coveo-icon.filetype.spagenda,.coveo-icon.filetype.Spagenda,.coveo-icon.filetype.spagendalist,.coveo-icon.filetype.Spagendalist,.coveo-icon.filetype.Spevent,.coveo-icon.filetype.spevent,.coveo-icon.filetype.Speventlist,.coveo-icon.filetype.speventlist,.coveo-icon.filetype.spmeetingserie,.coveo-icon.filetype.Spmeetingserie,.coveo-icon.filetype.Spmeetingserielist,.coveo-icon.filetype.spmeetingserielist,.coveo-icon.filetype.sptask,.coveo-icon.filetype.Sptask,.coveo-icon.filetype.Sptasklist,.coveo-icon.filetype.sptasklist,.coveo-icon.filetype.Spworkflowhistory,.coveo-icon.filetype.spworkflowhistory,.coveo-icon.filetype.Spworkflowhistorylist,.coveo-icon.filetype.spworkflowhistorylist{background-image:url( ../image/calendar.svg)}.coveo-filetype-case,.coveo-filetype-case-small,.coveo-icon.filetype.coveo-small.Exchangetask,.coveo-icon.filetype.coveo-small.exchangetask,.coveo-icon.filetype.coveo-small.incident,.coveo-icon.filetype.coveo-small.Incident,.coveo-icon.filetype.coveo-small.sn_customerservice_case,.coveo-icon.filetype.coveo-small.Sn_customerservice_case,.coveo-icon.filetype.coveo-small.Sn_hr_core_case,.coveo-icon.filetype.coveo-small.sn_hr_core_case,.coveo-icon.filetype.coveo-small.spprojecttask,.coveo-icon.filetype.coveo-small.Spprojecttask,.coveo-icon.filetype.coveo-small.spprojecttasklist,.coveo-icon.filetype.coveo-small.Spprojecttasklist,.coveo-icon.filetype.Exchangetask,.coveo-icon.filetype.exchangetask,.coveo-icon.filetype.incident,.coveo-icon.filetype.Incident,.coveo-icon.filetype.Sn_customerservice_case,.coveo-icon.filetype.sn_customerservice_case,.coveo-icon.filetype.sn_hr_core_case,.coveo-icon.filetype.Sn_hr_core_case,.coveo-icon.filetype.Spprojecttask,.coveo-icon.filetype.spprojecttask,.coveo-icon.filetype.spprojecttasklist,.coveo-icon.filetype.Spprojecttasklist,.coveo-icon.objecttype.case,.coveo-icon.objecttype.Case,.coveo-icon.objecttype.coveo-small.case,.coveo-icon.objecttype.coveo-small.Case,.coveo-icon.objecttype.coveo-small.incident,.coveo-icon.objecttype.coveo-small.Incident,.coveo-icon.objecttype.Incident,.coveo-icon.objecttype.incident{background-image:url( ../image/case.svg)}.coveo-filetype-custom,.coveo-filetype-custom-small,.coveo-icon.filetype,.coveo-icon.filetype.coveo-small,.coveo-icon.filetype.coveo-small.Exchangefreebusy,.coveo-icon.filetype.coveo-small.exchangefreebusy,.coveo-icon.filetype.coveo-small.Exchangemdn,.coveo-icon.filetype.coveo-small.exchangemdn,.coveo-icon.filetype.coveo-small.Exchangeobject,.coveo-icon.filetype.coveo-small.exchangeobject,.coveo-icon.filetype.coveo-small.Sc_cat_item,.coveo-icon.filetype.coveo-small.sc_cat_item,.coveo-icon.filetype.coveo-small.Sparea,.coveo-icon.filetype.coveo-small.sparea,.coveo-icon.filetype.coveo-small.sparealisting,.coveo-icon.filetype.coveo-small.Sparealisting,.coveo-icon.filetype.coveo-small.spcirculation,.coveo-icon.filetype.coveo-small.Spcirculation,.coveo-icon.filetype.coveo-small.Spcirculationlist,.coveo-icon.filetype.coveo-small.spcirculationlist,.coveo-icon.filetype.coveo-small.Spcustomgridlist,.coveo-icon.filetype.coveo-small.spcustomgridlist,.coveo-icon.filetype.coveo-small.spcustomlist,.coveo-icon.filetype.coveo-small.Spcustomlist,.coveo-icon.filetype.coveo-small.Spdecision,.coveo-icon.filetype.coveo-small.spdecision,.coveo-icon.filetype.coveo-small.spdecisionlist,.coveo-icon.filetype.coveo-small.Spdecisionlist,.coveo-icon.filetype.coveo-small.Spdistributiongroup,.coveo-icon.filetype.coveo-small.spdistributiongroup,.coveo-icon.filetype.coveo-small.spdistributiongrouplist,.coveo-icon.filetype.coveo-small.Spdistributiongrouplist,.coveo-icon.filetype.coveo-small.Spkeyperformanceindicator,.coveo-icon.filetype.coveo-small.spkeyperformanceindicator,.coveo-icon.filetype.coveo-small.spkeyperformanceindicatorlist,.coveo-icon.filetype.coveo-small.Spkeyperformanceindicatorlist,.coveo-icon.filetype.coveo-small.spobjective,.coveo-icon.filetype.coveo-small.Spobjective,.coveo-icon.filetype.coveo-small.Spobjectivelist,.coveo-icon.filetype.coveo-small.spobjectivelist,.coveo-icon.filetype.coveo-small.Spsurvey,.coveo-icon.filetype.coveo-small.spsurvey,.coveo-icon.filetype.coveo-small.spsurveylist,.coveo-icon.filetype.coveo-small.Spsurveylist,.coveo-icon.filetype.coveo-small.sptab,.coveo-icon.filetype.coveo-small.Sptab,.coveo-icon.filetype.coveo-small.Sptablist,.coveo-icon.filetype.coveo-small.sptablist,.coveo-icon.filetype.coveo-small.spthingstobring,.coveo-icon.filetype.coveo-small.Spthingstobring,.coveo-icon.filetype.coveo-small.Spthingstobringlist,.coveo-icon.filetype.coveo-small.spthingstobringlist,.coveo-icon.filetype.coveo-small.spunknownlist,.coveo-icon.filetype.coveo-small.Spunknownlist,.coveo-icon.filetype.coveo-small.spwhereabout,.coveo-icon.filetype.coveo-small.Spwhereabout,.coveo-icon.filetype.coveo-small.Spwhereaboutlist,.coveo-icon.filetype.coveo-small.spwhereaboutlist,.coveo-icon.filetype.coveo-small.spworkflowprocess,.coveo-icon.filetype.coveo-small.Spworkflowprocess,.coveo-icon.filetype.coveo-small.spworkflowprocesslist,.coveo-icon.filetype.coveo-small.Spworkflowprocesslist,.coveo-icon.filetype.Exchangefreebusy,.coveo-icon.filetype.exchangefreebusy,.coveo-icon.filetype.exchangemdn,.coveo-icon.filetype.Exchangemdn,.coveo-icon.filetype.Exchangeobject,.coveo-icon.filetype.exchangeobject,.coveo-icon.filetype.sc_cat_item,.coveo-icon.filetype.Sc_cat_item,.coveo-icon.filetype.Sparea,.coveo-icon.filetype.sparea,.coveo-icon.filetype.Sparealisting,.coveo-icon.filetype.sparealisting,.coveo-icon.filetype.Spcirculation,.coveo-icon.filetype.spcirculation,.coveo-icon.filetype.spcirculationlist,.coveo-icon.filetype.Spcirculationlist,.coveo-icon.filetype.spcustomgridlist,.coveo-icon.filetype.Spcustomgridlist,.coveo-icon.filetype.spcustomlist,.coveo-icon.filetype.Spcustomlist,.coveo-icon.filetype.Spdecision,.coveo-icon.filetype.spdecision,.coveo-icon.filetype.spdecisionlist,.coveo-icon.filetype.Spdecisionlist,.coveo-icon.filetype.spdistributiongroup,.coveo-icon.filetype.Spdistributiongroup,.coveo-icon.filetype.Spdistributiongrouplist,.coveo-icon.filetype.spdistributiongrouplist,.coveo-icon.filetype.spkeyperformanceindicator,.coveo-icon.filetype.Spkeyperformanceindicator,.coveo-icon.filetype.Spkeyperformanceindicatorlist,.coveo-icon.filetype.spkeyperformanceindicatorlist,.coveo-icon.filetype.spobjective,.coveo-icon.filetype.Spobjective,.coveo-icon.filetype.spobjectivelist,.coveo-icon.filetype.Spobjectivelist,.coveo-icon.filetype.Spsurvey,.coveo-icon.filetype.spsurvey,.coveo-icon.filetype.spsurveylist,.coveo-icon.filetype.Spsurveylist,.coveo-icon.filetype.Sptab,.coveo-icon.filetype.sptab,.coveo-icon.filetype.Sptablist,.coveo-icon.filetype.sptablist,.coveo-icon.filetype.Spthingstobring,.coveo-icon.filetype.spthingstobring,.coveo-icon.filetype.spthingstobringlist,.coveo-icon.filetype.Spthingstobringlist,.coveo-icon.filetype.Spunknownlist,.coveo-icon.filetype.spunknownlist,.coveo-icon.filetype.spwhereabout,.coveo-icon.filetype.Spwhereabout,.coveo-icon.filetype.Spwhereaboutlist,.coveo-icon.filetype.spwhereaboutlist,.coveo-icon.filetype.Spworkflowprocess,.coveo-icon.filetype.spworkflowprocess,.coveo-icon.filetype.Spworkflowprocesslist,.coveo-icon.filetype.spworkflowprocesslist,.coveo-icon.objecttype,.coveo-icon.objecttype.coveo-small{background-image:url( ../image/custom.svg)}.coveo-filetype-document,.coveo-filetype-document-small,.coveo-icon.objecttype.Contentversion,.coveo-icon.objecttype.contentversion,.coveo-icon.objecttype.coveo-small.Contentversion,.coveo-icon.objecttype.coveo-small.contentversion{background-image:url( ../image/document.svg)}.coveo-filetype-file,.coveo-filetype-file-small,.coveo-icon.filetype.coveo-small.exchangedocument,.coveo-icon.filetype.coveo-small.Exchangedocument,.coveo-icon.filetype.coveo-small.odt,.coveo-icon.filetype.coveo-small.Odt,.coveo-icon.filetype.coveo-small.OleFile,.coveo-icon.filetype.coveo-small.olefile,.coveo-icon.filetype.coveo-small.spresource,.coveo-icon.filetype.coveo-small.Spresource,.coveo-icon.filetype.coveo-small.Spresourcelist,.coveo-icon.filetype.coveo-small.spresourcelist,.coveo-icon.filetype.exchangedocument,.coveo-icon.filetype.Exchangedocument,.coveo-icon.filetype.Odt,.coveo-icon.filetype.odt,.coveo-icon.filetype.OleFile,.coveo-icon.filetype.olefile,.coveo-icon.filetype.spresource,.coveo-icon.filetype.Spresource,.coveo-icon.filetype.spresourcelist,.coveo-icon.filetype.Spresourcelist{background-image:url( ../image/file.svg)}.coveo-filetype-folder,.coveo-filetype-folder-small,.coveo-icon.filetype.cfspace,.coveo-icon.filetype.Cfspace,.coveo-icon.filetype.Confluencespace,.coveo-icon.filetype.confluencespace,.coveo-icon.filetype.coveo-small.Cfspace,.coveo-icon.filetype.coveo-small.cfspace,.coveo-icon.filetype.coveo-small.Confluencespace,.coveo-icon.filetype.coveo-small.confluencespace,.coveo-icon.filetype.coveo-small.folder,.coveo-icon.filetype.coveo-small.Folder,.coveo-icon.filetype.coveo-small.Spareadocumentlibrarylist,.coveo-icon.filetype.coveo-small.spareadocumentlibrarylist,.coveo-icon.filetype.coveo-small.Spdashboardslibrarylist,.coveo-icon.filetype.coveo-small.spdashboardslibrarylist,.coveo-icon.filetype.coveo-small.spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.coveo-small.Spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.coveo-small.Spdocumentlibrarylist,.coveo-icon.filetype.coveo-small.spdocumentlibrarylist,.coveo-icon.filetype.coveo-small.spdocumentset,.coveo-icon.filetype.coveo-small.Spdocumentset,.coveo-icon.filetype.coveo-small.spformlibrarylist,.coveo-icon.filetype.coveo-small.Spformlibrarylist,.coveo-icon.filetype.coveo-small.spimedictionary,.coveo-icon.filetype.coveo-small.Spimedictionary,.coveo-icon.filetype.coveo-small.Spimedictionarylist,.coveo-icon.filetype.coveo-small.spimedictionarylist,.coveo-icon.filetype.coveo-small.Splistfolder,.coveo-icon.filetype.coveo-small.splistfolder,.coveo-icon.filetype.coveo-small.Splisttemplatecataloglist,.coveo-icon.filetype.coveo-small.splisttemplatecataloglist,.coveo-icon.filetype.coveo-small.Spmasterpagescataloglist,.coveo-icon.filetype.coveo-small.spmasterpagescataloglist,.coveo-icon.filetype.coveo-small.Spnocodeworkflowlibrarylist,.coveo-icon.filetype.coveo-small.spnocodeworkflowlibrarylist,.coveo-icon.filetype.coveo-small.Spprocessdiagramslibrarylist,.coveo-icon.filetype.coveo-small.spprocessdiagramslibrarylist,.coveo-icon.filetype.coveo-small.sppublishingimageslibrarylist,.coveo-icon.filetype.coveo-small.Sppublishingimageslibrarylist,.coveo-icon.filetype.coveo-small.sppublishingpageslibrarylist,.coveo-icon.filetype.coveo-small.Sppublishingpageslibrarylist,.coveo-icon.filetype.coveo-small.sprecordlibrarylist,.coveo-icon.filetype.coveo-small.Sprecordlibrarylist,.coveo-icon.filetype.coveo-small.Spreportdocumentlibrarylist,.coveo-icon.filetype.coveo-small.spreportdocumentlibrarylist,.coveo-icon.filetype.coveo-small.Spreportlibrarylist,.coveo-icon.filetype.coveo-small.spreportlibrarylist,.coveo-icon.filetype.coveo-small.spsitedirectory,.coveo-icon.filetype.coveo-small.Spsitedirectory,.coveo-icon.filetype.coveo-small.spsitedirectorylist,.coveo-icon.filetype.coveo-small.Spsitedirectorylist,.coveo-icon.filetype.coveo-small.spsitethemeslibrarylist,.coveo-icon.filetype.coveo-small.Spsitethemeslibrarylist,.coveo-icon.filetype.coveo-small.spslidelibrarylist,.coveo-icon.filetype.coveo-small.Spslidelibrarylist,.coveo-icon.filetype.coveo-small.spsolutionslibrarylist,.coveo-icon.filetype.coveo-small.Spsolutionslibrarylist,.coveo-icon.filetype.coveo-small.Sptranslationmanagementlibrarylist,.coveo-icon.filetype.coveo-small.sptranslationmanagementlibrarylist,.coveo-icon.filetype.coveo-small.Spwebpartcataloglist,.coveo-icon.filetype.coveo-small.spwebpartcataloglist,.coveo-icon.filetype.coveo-small.Spwebtemplatecataloglist,.coveo-icon.filetype.coveo-small.spwebtemplatecataloglist,.coveo-icon.filetype.coveo-small.Spwfpublibrarylist,.coveo-icon.filetype.coveo-small.spwfpublibrarylist,.coveo-icon.filetype.coveo-small.spworkspacepagelist,.coveo-icon.filetype.coveo-small.Spworkspacepagelist,.coveo-icon.filetype.folder,.coveo-icon.filetype.Folder,.coveo-icon.filetype.spareadocumentlibrarylist,.coveo-icon.filetype.Spareadocumentlibrarylist,.coveo-icon.filetype.Spdashboardslibrarylist,.coveo-icon.filetype.spdashboardslibrarylist,.coveo-icon.filetype.Spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.spdataconnectionforperformancepointlibrarylist,.coveo-icon.filetype.spdocumentlibrarylist,.coveo-icon.filetype.Spdocumentlibrarylist,.coveo-icon.filetype.spdocumentset,.coveo-icon.filetype.Spdocumentset,.coveo-icon.filetype.Spformlibrarylist,.coveo-icon.filetype.spformlibrarylist,.coveo-icon.filetype.Spimedictionary,.coveo-icon.filetype.spimedictionary,.coveo-icon.filetype.spimedictionarylist,.coveo-icon.filetype.Spimedictionarylist,.coveo-icon.filetype.Splistfolder,.coveo-icon.filetype.splistfolder,.coveo-icon.filetype.splisttemplatecataloglist,.coveo-icon.filetype.Splisttemplatecataloglist,.coveo-icon.filetype.spmasterpagescataloglist,.coveo-icon.filetype.Spmasterpagescataloglist,.coveo-icon.filetype.Spnocodeworkflowlibrarylist,.coveo-icon.filetype.spnocodeworkflowlibrarylist,.coveo-icon.filetype.Spprocessdiagramslibrarylist,.coveo-icon.filetype.spprocessdiagramslibrarylist,.coveo-icon.filetype.sppublishingimageslibrarylist,.coveo-icon.filetype.Sppublishingimageslibrarylist,.coveo-icon.filetype.Sppublishingpageslibrarylist,.coveo-icon.filetype.sppublishingpageslibrarylist,.coveo-icon.filetype.Sprecordlibrarylist,.coveo-icon.filetype.sprecordlibrarylist,.coveo-icon.filetype.spreportdocumentlibrarylist,.coveo-icon.filetype.Spreportdocumentlibrarylist,.coveo-icon.filetype.Spreportlibrarylist,.coveo-icon.filetype.spreportlibrarylist,.coveo-icon.filetype.spsitedirectory,.coveo-icon.filetype.Spsitedirectory,.coveo-icon.filetype.spsitedirectorylist,.coveo-icon.filetype.Spsitedirectorylist,.coveo-icon.filetype.Spsitethemeslibrarylist,.coveo-icon.filetype.spsitethemeslibrarylist,.coveo-icon.filetype.spslidelibrarylist,.coveo-icon.filetype.Spslidelibrarylist,.coveo-icon.filetype.spsolutionslibrarylist,.coveo-icon.filetype.Spsolutionslibrarylist,.coveo-icon.filetype.sptranslationmanagementlibrarylist,.coveo-icon.filetype.Sptranslationmanagementlibrarylist,.coveo-icon.filetype.spwebpartcataloglist,.coveo-icon.filetype.Spwebpartcataloglist,.coveo-icon.filetype.Spwebtemplatecataloglist,.coveo-icon.filetype.spwebtemplatecataloglist,.coveo-icon.filetype.Spwfpublibrarylist,.coveo-icon.filetype.spwfpublibrarylist,.coveo-icon.filetype.Spworkspacepagelist,.coveo-icon.filetype.spworkspacepagelist{background-image:url( ../image/folder.svg)}.coveo-filetype-images,.coveo-filetype-images-small,.coveo-icon.filetype.coveo-small.Sppicturelibrarylist,.coveo-icon.filetype.coveo-small.sppicturelibrarylist,.coveo-icon.filetype.Sppicturelibrarylist,.coveo-icon.filetype.sppicturelibrarylist{background-image:url( ../image/images.svg)}.coveo-filetype-kb,.coveo-filetype-kb-small,.coveo-icon.filetype.coveo-small.Kb_knowledge,.coveo-icon.filetype.coveo-small.kb_knowledge,.coveo-icon.filetype.coveo-small.spdataconnectionlibrarylist,.coveo-icon.filetype.coveo-small.Spdataconnectionlibrarylist,.coveo-icon.filetype.coveo-small.spdatasource,.coveo-icon.filetype.coveo-small.Spdatasource,.coveo-icon.filetype.coveo-small.spdatasourcelist,.coveo-icon.filetype.coveo-small.Spdatasourcelist,.coveo-icon.filetype.coveo-small.Spipfslist,.coveo-icon.filetype.coveo-small.spipfslist,.coveo-icon.filetype.Kb_knowledge,.coveo-icon.filetype.kb_knowledge,.coveo-icon.filetype.spdataconnectionlibrarylist,.coveo-icon.filetype.Spdataconnectionlibrarylist,.coveo-icon.filetype.Spdatasource,.coveo-icon.filetype.spdatasource,.coveo-icon.filetype.spdatasourcelist,.coveo-icon.filetype.Spdatasourcelist,.coveo-icon.filetype.spipfslist,.coveo-icon.filetype.Spipfslist{background-image:url( ../image/kb.svg)}.coveo-filetype-link,.coveo-filetype-link-small,.coveo-icon.filetype.coveo-small.dynamicscrmitem,.coveo-icon.filetype.coveo-small.Dynamicscrmitem,.coveo-icon.filetype.coveo-small.spdocumentlink,.coveo-icon.filetype.coveo-small.Spdocumentlink,.coveo-icon.filetype.coveo-small.spissue,.coveo-icon.filetype.coveo-small.Spissue,.coveo-icon.filetype.coveo-small.spissuelist,.coveo-icon.filetype.coveo-small.Spissuelist,.coveo-icon.filetype.coveo-small.splink,.coveo-icon.filetype.coveo-small.Splink,.coveo-icon.filetype.coveo-small.splinklist,.coveo-icon.filetype.coveo-small.Splinklist,.coveo-icon.filetype.coveo-small.Spsite,.coveo-icon.filetype.coveo-small.spsite,.coveo-icon.filetype.dynamicscrmitem,.coveo-icon.filetype.Dynamicscrmitem,.coveo-icon.filetype.spdocumentlink,.coveo-icon.filetype.Spdocumentlink,.coveo-icon.filetype.spissue,.coveo-icon.filetype.Spissue,.coveo-icon.filetype.spissuelist,.coveo-icon.filetype.Spissuelist,.coveo-icon.filetype.splink,.coveo-icon.filetype.Splink,.coveo-icon.filetype.splinklist,.coveo-icon.filetype.Splinklist,.coveo-icon.filetype.Spsite,.coveo-icon.filetype.spsite{background-image:url( ../image/link.svg)}.coveo-filetype-list,.coveo-filetype-list-small,.coveo-icon.filetype.coveo-small.exchangeactivity,.coveo-icon.filetype.coveo-small.Exchangeactivity,.coveo-icon.filetype.coveo-small.Exchangenote,.coveo-icon.filetype.coveo-small.exchangenote,.coveo-icon.filetype.coveo-small.Exchangeofficecom,.coveo-icon.filetype.coveo-small.exchangeofficecom,.coveo-icon.filetype.coveo-small.Exchangerssfeed,.coveo-icon.filetype.coveo-small.exchangerssfeed,.coveo-icon.filetype.coveo-small.Kb_social_qa_answer,.coveo-icon.filetype.coveo-small.kb_social_qa_answer,.coveo-icon.filetype.coveo-small.kb_social_qa_comment,.coveo-icon.filetype.coveo-small.Kb_social_qa_comment,.coveo-icon.filetype.coveo-small.Kb_social_qa_question,.coveo-icon.filetype.coveo-small.kb_social_qa_question,.coveo-icon.filetype.coveo-small.spannouncement,.coveo-icon.filetype.coveo-small.Spannouncement,.coveo-icon.filetype.coveo-small.Spannouncementlist,.coveo-icon.filetype.coveo-small.spannouncementlist,.coveo-icon.filetype.coveo-small.spblogcategory,.coveo-icon.filetype.coveo-small.Spblogcategory,.coveo-icon.filetype.coveo-small.spblogcategorylist,.coveo-icon.filetype.coveo-small.Spblogcategorylist,.coveo-icon.filetype.coveo-small.spblogcomment,.coveo-icon.filetype.coveo-small.Spblogcomment,.coveo-icon.filetype.coveo-small.spblogcommentlist,.coveo-icon.filetype.coveo-small.Spblogcommentlist,.coveo-icon.filetype.coveo-small.Spblogpost,.coveo-icon.filetype.coveo-small.spblogpost,.coveo-icon.filetype.coveo-small.Spblogpostlist,.coveo-icon.filetype.coveo-small.spblogpostlist,.coveo-icon.filetype.coveo-small.spdiscussionboard,.coveo-icon.filetype.coveo-small.Spdiscussionboard,.coveo-icon.filetype.coveo-small.Spdiscussionboardlist,.coveo-icon.filetype.coveo-small.spdiscussionboardlist,.coveo-icon.filetype.coveo-small.Sphealthreport,.coveo-icon.filetype.coveo-small.sphealthreport,.coveo-icon.filetype.coveo-small.Sphealthreportlist,.coveo-icon.filetype.coveo-small.sphealthreportlist,.coveo-icon.filetype.coveo-small.Sphealthrule,.coveo-icon.filetype.coveo-small.sphealthrule,.coveo-icon.filetype.coveo-small.Sphealthrulelist,.coveo-icon.filetype.coveo-small.sphealthrulelist,.coveo-icon.filetype.coveo-small.splanguagesandtranslator,.coveo-icon.filetype.coveo-small.Splanguagesandtranslator,.coveo-icon.filetype.coveo-small.Splanguagesandtranslatorlist,.coveo-icon.filetype.coveo-small.splanguagesandtranslatorlist,.coveo-icon.filetype.coveo-small.spmicrofeedlist,.coveo-icon.filetype.coveo-small.Spmicrofeedlist,.coveo-icon.filetype.coveo-small.Spmicrofeedpost,.coveo-icon.filetype.coveo-small.spmicrofeedpost,.coveo-icon.filetype.coveo-small.Spperformancepointcontent,.coveo-icon.filetype.coveo-small.spperformancepointcontent,.coveo-icon.filetype.coveo-small.spperformancepointcontentlist,.coveo-icon.filetype.coveo-small.Spperformancepointcontentlist,.coveo-icon.filetype.coveo-small.spphonecallmemo,.coveo-icon.filetype.coveo-small.Spphonecallmemo,.coveo-icon.filetype.coveo-small.spphonecallmemolist,.coveo-icon.filetype.coveo-small.Spphonecallmemolist,.coveo-icon.filetype.coveo-small.Sptextbox,.coveo-icon.filetype.coveo-small.sptextbox,.coveo-icon.filetype.coveo-small.Sptextboxlist,.coveo-icon.filetype.coveo-small.sptextboxlist,.coveo-icon.filetype.Exchangeactivity,.coveo-icon.filetype.exchangeactivity,.coveo-icon.filetype.exchangenote,.coveo-icon.filetype.Exchangenote,.coveo-icon.filetype.exchangeofficecom,.coveo-icon.filetype.Exchangeofficecom,.coveo-icon.filetype.Exchangerssfeed,.coveo-icon.filetype.exchangerssfeed,.coveo-icon.filetype.kb_social_qa_answer,.coveo-icon.filetype.Kb_social_qa_answer,.coveo-icon.filetype.kb_social_qa_comment,.coveo-icon.filetype.Kb_social_qa_comment,.coveo-icon.filetype.Kb_social_qa_question,.coveo-icon.filetype.kb_social_qa_question,.coveo-icon.filetype.Spannouncement,.coveo-icon.filetype.spannouncement,.coveo-icon.filetype.spannouncementlist,.coveo-icon.filetype.Spannouncementlist,.coveo-icon.filetype.spblogcategory,.coveo-icon.filetype.Spblogcategory,.coveo-icon.filetype.Spblogcategorylist,.coveo-icon.filetype.spblogcategorylist,.coveo-icon.filetype.Spblogcomment,.coveo-icon.filetype.spblogcomment,.coveo-icon.filetype.spblogcommentlist,.coveo-icon.filetype.Spblogcommentlist,.coveo-icon.filetype.Spblogpost,.coveo-icon.filetype.spblogpost,.coveo-icon.filetype.Spblogpostlist,.coveo-icon.filetype.spblogpostlist,.coveo-icon.filetype.Spdiscussionboard,.coveo-icon.filetype.spdiscussionboard,.coveo-icon.filetype.Spdiscussionboardlist,.coveo-icon.filetype.spdiscussionboardlist,.coveo-icon.filetype.Sphealthreport,.coveo-icon.filetype.sphealthreport,.coveo-icon.filetype.sphealthreportlist,.coveo-icon.filetype.Sphealthreportlist,.coveo-icon.filetype.sphealthrule,.coveo-icon.filetype.Sphealthrule,.coveo-icon.filetype.Sphealthrulelist,.coveo-icon.filetype.sphealthrulelist,.coveo-icon.filetype.Splanguagesandtranslator,.coveo-icon.filetype.splanguagesandtranslator,.coveo-icon.filetype.splanguagesandtranslatorlist,.coveo-icon.filetype.Splanguagesandtranslatorlist,.coveo-icon.filetype.spmicrofeedlist,.coveo-icon.filetype.Spmicrofeedlist,.coveo-icon.filetype.spmicrofeedpost,.coveo-icon.filetype.Spmicrofeedpost,.coveo-icon.filetype.spperformancepointcontent,.coveo-icon.filetype.Spperformancepointcontent,.coveo-icon.filetype.Spperformancepointcontentlist,.coveo-icon.filetype.spperformancepointcontentlist,.coveo-icon.filetype.spphonecallmemo,.coveo-icon.filetype.Spphonecallmemo,.coveo-icon.filetype.Spphonecallmemolist,.coveo-icon.filetype.spphonecallmemolist,.coveo-icon.filetype.sptextbox,.coveo-icon.filetype.Sptextbox,.coveo-icon.filetype.sptextboxlist,.coveo-icon.filetype.Sptextboxlist,.coveo-icon.objecttype.board,.coveo-icon.objecttype.Board,.coveo-icon.objecttype.Category,.coveo-icon.objecttype.category,.coveo-icon.objecttype.coveo-small.Board,.coveo-icon.objecttype.coveo-small.board,.coveo-icon.objecttype.coveo-small.category,.coveo-icon.objecttype.coveo-small.Category,.coveo-icon.objecttype.coveo-small.Invoice,.coveo-icon.objecttype.coveo-small.invoice,.coveo-icon.objecttype.coveo-small.Queueitem,.coveo-icon.objecttype.coveo-small.queueitem,.coveo-icon.objecttype.invoice,.coveo-icon.objecttype.Invoice,.coveo-icon.objecttype.queueitem,.coveo-icon.objecttype.Queueitem{background-image:url( ../image/list.svg)}.coveo-filetype-mail,.coveo-filetype-mail-small,.coveo-icon.filetype.coveo-small.Exchangedsn,.coveo-icon.filetype.coveo-small.exchangedsn,.coveo-icon.filetype.coveo-small.Exchangejunkmessage,.coveo-icon.filetype.coveo-small.exchangejunkmessage,.coveo-icon.filetype.coveo-small.exchangemessage,.coveo-icon.filetype.coveo-small.Exchangemessage,.coveo-icon.filetype.coveo-small.exchangerecallmessage,.coveo-icon.filetype.coveo-small.Exchangerecallmessage,.coveo-icon.filetype.coveo-small.Exchangerecallreport,.coveo-icon.filetype.coveo-small.exchangerecallreport,.coveo-icon.filetype.coveo-small.Gmailmessage,.coveo-icon.filetype.coveo-small.gmailmessage,.coveo-icon.filetype.exchangedsn,.coveo-icon.filetype.Exchangedsn,.coveo-icon.filetype.exchangejunkmessage,.coveo-icon.filetype.Exchangejunkmessage,.coveo-icon.filetype.Exchangemessage,.coveo-icon.filetype.exchangemessage,.coveo-icon.filetype.Exchangerecallmessage,.coveo-icon.filetype.exchangerecallmessage,.coveo-icon.filetype.exchangerecallreport,.coveo-icon.filetype.Exchangerecallreport,.coveo-icon.filetype.gmailmessage,.coveo-icon.filetype.Gmailmessage,.coveo-icon.objecttype.coveo-small.Email,.coveo-icon.objecttype.coveo-small.email,.coveo-icon.objecttype.coveo-small.Message,.coveo-icon.objecttype.coveo-small.message,.coveo-icon.objecttype.Email,.coveo-icon.objecttype.email,.coveo-icon.objecttype.Message,.coveo-icon.objecttype.message{background-image:url( ../image/mail.svg)}.coveo-filetype-salesforce-doctype-ai,.coveo-filetype-salesforce-doctype-ai-small{background-image:url( ../image/salesforce-doctype-ai.svg)}.coveo-filetype-salesforce-doctype-attachment,.coveo-filetype-salesforce-doctype-attachment-small,.coveo-icon.objecttype.coveo-small.Kbattachment,.coveo-icon.objecttype.coveo-small.kbattachment,.coveo-icon.objecttype.Kbattachment,.coveo-icon.objecttype.kbattachment{background-image:url( ../image/salesforce-doctype-attachment.svg)}.coveo-filetype-salesforce-doctype-audio,.coveo-filetype-salesforce-doctype-audio-small{background-image:url( ../image/salesforce-doctype-audio.svg)}.coveo-filetype-salesforce-doctype-box-notes,.coveo-filetype-salesforce-doctype-box-notes-small{background-image:url( ../image/salesforce-doctype-box-notes.svg)}.coveo-filetype-salesforce-doctype-csv,.coveo-filetype-salesforce-doctype-csv-small{background-image:url( ../image/salesforce-doctype-csv.svg)}.coveo-filetype-salesforce-doctype-eps,.coveo-filetype-salesforce-doctype-eps-small{background-image:url( ../image/salesforce-doctype-eps.svg)}.coveo-filetype-salesforce-doctype-excel,.coveo-filetype-salesforce-doctype-excel-small,.coveo-icon.filetype.coveo-small.Xls,.coveo-icon.filetype.coveo-small.xls,.coveo-icon.filetype.Xls,.coveo-icon.filetype.xls{background-image:url( ../image/salesforce-doctype-excel.svg)}.coveo-filetype-salesforce-doctype-exe,.coveo-filetype-salesforce-doctype-exe-small{background-image:url( ../image/salesforce-doctype-exe.svg)}.coveo-filetype-salesforce-doctype-flash,.coveo-filetype-salesforce-doctype-flash-small,.coveo-icon.filetype.coveo-small.Swf,.coveo-icon.filetype.coveo-small.swf,.coveo-icon.filetype.Swf,.coveo-icon.filetype.swf{background-image:url( ../image/salesforce-doctype-flash.svg)}.coveo-filetype-salesforce-doctype-folder,.coveo-filetype-salesforce-doctype-folder-small{background-image:url( ../image/salesforce-doctype-folder.svg)}.coveo-filetype-salesforce-doctype-gdoc,.coveo-filetype-salesforce-doctype-gdoc-small{background-image:url( ../image/salesforce-doctype-gdoc.svg)}.coveo-filetype-salesforce-doctype-gdocs,.coveo-filetype-salesforce-doctype-gdocs-small{background-image:url( ../image/salesforce-doctype-gdocs.svg)}.coveo-filetype-salesforce-doctype-gform,.coveo-filetype-salesforce-doctype-gform-small{background-image:url( ../image/salesforce-doctype-gform.svg)}.coveo-filetype-salesforce-doctype-gpres,.coveo-filetype-salesforce-doctype-gpres-small{background-image:url( ../image/salesforce-doctype-gpres.svg)}.coveo-filetype-salesforce-doctype-gsheet,.coveo-filetype-salesforce-doctype-gsheet-small{background-image:url( ../image/salesforce-doctype-gsheet.svg)}.coveo-filetype-salesforce-doctype-html,.coveo-filetype-salesforce-doctype-html-small,.coveo-icon.filetype.coveo-small.Html,.coveo-icon.filetype.coveo-small.html,.coveo-icon.filetype.coveo-small.Webscraperwebpage,.coveo-icon.filetype.coveo-small.webscraperwebpage,.coveo-icon.filetype.coveo-small.Wiki,.coveo-icon.filetype.coveo-small.wiki,.coveo-icon.filetype.Html,.coveo-icon.filetype.html,.coveo-icon.filetype.webscraperwebpage,.coveo-icon.filetype.Webscraperwebpage,.coveo-icon.filetype.Wiki,.coveo-icon.filetype.wiki{background-image:url( ../image/salesforce-doctype-html.svg)}.coveo-filetype-salesforce-doctype-image,.coveo-filetype-salesforce-doctype-image-small,.coveo-icon.filetype.coveo-small.Image,.coveo-icon.filetype.coveo-small.image,.coveo-icon.filetype.coveo-small.Svg,.coveo-icon.filetype.coveo-small.svg,.coveo-icon.filetype.Image,.coveo-icon.filetype.image,.coveo-icon.filetype.Svg,.coveo-icon.filetype.svg{background-image:url( ../image/salesforce-doctype-image.svg)}.coveo-filetype-salesforce-doctype-keynote,.coveo-filetype-salesforce-doctype-keynote-small{background-image:url( ../image/salesforce-doctype-keynote.svg)}.coveo-filetype-salesforce-doctype-library-folder,.coveo-filetype-salesforce-doctype-library-folder-small{background-image:url( ../image/salesforce-doctype-library-folder.svg)}.coveo-filetype-salesforce-doctype-link,.coveo-filetype-salesforce-doctype-link-small{background-image:url( ../image/salesforce-doctype-link.svg)}.coveo-filetype-salesforce-doctype-mp4,.coveo-filetype-salesforce-doctype-mp4-small{background-image:url( ../image/salesforce-doctype-mp4.svg)}.coveo-filetype-salesforce-doctype-overlay,.coveo-filetype-salesforce-doctype-overlay-small{background-image:url( ../image/salesforce-doctype-overlay.svg)}.coveo-filetype-salesforce-doctype-pack,.coveo-filetype-salesforce-doctype-pack-small{background-image:url( ../image/salesforce-doctype-pack.svg)}.coveo-filetype-salesforce-doctype-pages,.coveo-filetype-salesforce-doctype-pages-small{background-image:url( ../image/salesforce-doctype-pages.svg)}.coveo-filetype-salesforce-doctype-pdf,.coveo-filetype-salesforce-doctype-pdf-small,.coveo-icon.filetype.coveo-small.Pdf,.coveo-icon.filetype.coveo-small.pdf,.coveo-icon.filetype.Pdf,.coveo-icon.filetype.pdf{background-image:url( ../image/salesforce-doctype-pdf.svg)}.coveo-filetype-salesforce-doctype-ppt,.coveo-filetype-salesforce-doctype-ppt-small,.coveo-icon.filetype.coveo-small.Ppt,.coveo-icon.filetype.coveo-small.ppt,.coveo-icon.filetype.Ppt,.coveo-icon.filetype.ppt{background-image:url( ../image/salesforce-doctype-ppt.svg)}.coveo-filetype-salesforce-doctype-psd,.coveo-filetype-salesforce-doctype-psd-small{background-image:url( ../image/salesforce-doctype-psd.svg)}.coveo-filetype-salesforce-doctype-quip-doc,.coveo-filetype-salesforce-doctype-quip-doc-small{background-image:url( ../image/salesforce-doctype-quip-doc.svg)}.coveo-filetype-salesforce-doctype-quip-sheet,.coveo-filetype-salesforce-doctype-quip-sheet-small{background-image:url( ../image/salesforce-doctype-quip-sheet.svg)}.coveo-filetype-salesforce-doctype-rtf,.coveo-filetype-salesforce-doctype-rtf-small{background-image:url( ../image/salesforce-doctype-rtf.svg)}.coveo-filetype-salesforce-doctype-slide,.coveo-filetype-salesforce-doctype-slide-small{background-image:url( ../image/salesforce-doctype-slide.svg)}.coveo-filetype-salesforce-doctype-stypi,.coveo-filetype-salesforce-doctype-stypi-small{background-image:url( ../image/salesforce-doctype-stypi.svg)}.coveo-filetype-salesforce-doctype-txt,.coveo-filetype-salesforce-doctype-txt-small,.coveo-icon.filetype.coveo-small.Txt,.coveo-icon.filetype.coveo-small.txt,.coveo-icon.filetype.Txt,.coveo-icon.filetype.txt{background-image:url( ../image/salesforce-doctype-txt.svg)}.coveo-filetype-salesforce-doctype-unknown,.coveo-filetype-salesforce-doctype-unknown-small{background-image:url( ../image/salesforce-doctype-unknown.svg)}.coveo-filetype-salesforce-doctype-video,.coveo-filetype-salesforce-doctype-video-small{background-image:url( ../image/salesforce-doctype-video.svg)}.coveo-filetype-salesforce-doctype-visio,.coveo-filetype-salesforce-doctype-visio-small,.coveo-icon.filetype.coveo-small.Vsd,.coveo-icon.filetype.coveo-small.vsd,.coveo-icon.filetype.Vsd,.coveo-icon.filetype.vsd{background-image:url( ../image/salesforce-doctype-visio.svg)}.coveo-filetype-salesforce-doctype-webex,.coveo-filetype-salesforce-doctype-webex-small{background-image:url( ../image/salesforce-doctype-webex.svg)}.coveo-filetype-salesforce-doctype-word,.coveo-filetype-salesforce-doctype-word-small,.coveo-icon.filetype.coveo-small.doc,.coveo-icon.filetype.coveo-small.Doc,.coveo-icon.filetype.coveo-small.docx,.coveo-icon.filetype.coveo-small.Docx,.coveo-icon.filetype.coveo-small.Svm,.coveo-icon.filetype.coveo-small.svm,.coveo-icon.filetype.Doc,.coveo-icon.filetype.doc,.coveo-icon.filetype.docx,.coveo-icon.filetype.Docx,.coveo-icon.filetype.Svm,.coveo-icon.filetype.svm{background-image:url( ../image/salesforce-doctype-word.svg)}.coveo-filetype-salesforce-doctype-xml,.coveo-filetype-salesforce-doctype-xml-small,.coveo-icon.filetype.coveo-small.Xml,.coveo-icon.filetype.coveo-small.xml,.coveo-icon.filetype.Xml,.coveo-icon.filetype.xml{background-image:url( ../image/salesforce-doctype-xml.svg)}.coveo-filetype-salesforce-doctype-zip,.coveo-filetype-salesforce-doctype-zip-small,.coveo-icon.filetype.coveo-small.Zip,.coveo-icon.filetype.coveo-small.zip,.coveo-icon.filetype.Zip,.coveo-icon.filetype.zip{background-image:url( ../image/salesforce-doctype-zip.svg)}.coveo-filetype-salesforce-standard-account,.coveo-filetype-salesforce-standard-account-small,.coveo-icon.objecttype.Account,.coveo-icon.objecttype.account,.coveo-icon.objecttype.coveo-small.Account,.coveo-icon.objecttype.coveo-small.account{background-image:url( ../image/salesforce-standard-account.svg)}.coveo-filetype-salesforce-standard-action-list-component,.coveo-filetype-salesforce-standard-action-list-component-small{background-image:url( ../image/salesforce-standard-action-list-component.svg)}.coveo-filetype-salesforce-standard-address,.coveo-filetype-salesforce-standard-address-small{background-image:url( ../image/salesforce-standard-address.svg)}.coveo-filetype-salesforce-standard-announcement,.coveo-filetype-salesforce-standard-announcement-small{background-image:url( ../image/salesforce-standard-announcement.svg)}.coveo-filetype-salesforce-standard-answer-best,.coveo-filetype-salesforce-standard-answer-best-small{background-image:url( ../image/salesforce-standard-answer-best.svg)}.coveo-filetype-salesforce-standard-answer-private,.coveo-filetype-salesforce-standard-answer-private-small{background-image:url( ../image/salesforce-standard-answer-private.svg)}.coveo-filetype-salesforce-standard-answer-public,.coveo-filetype-salesforce-standard-answer-public-small{background-image:url( ../image/salesforce-standard-answer-public.svg)}.coveo-filetype-salesforce-standard-approval,.coveo-filetype-salesforce-standard-approval-small{background-image:url( ../image/salesforce-standard-approval.svg)}.coveo-filetype-salesforce-standard-apps-admin,.coveo-filetype-salesforce-standard-apps-admin-small{background-image:url( ../image/salesforce-standard-apps-admin.svg)}.coveo-filetype-salesforce-standard-apps,.coveo-filetype-salesforce-standard-apps-small{background-image:url( ../image/salesforce-standard-apps.svg)}.coveo-filetype-salesforce-standard-article,.coveo-filetype-salesforce-standard-article-small,.coveo-icon.filetype.Cfpage,.coveo-icon.filetype.cfpage,.coveo-icon.filetype.coveo-small.cfpage,.coveo-icon.filetype.coveo-small.Cfpage,.coveo-icon.objecttype.coveo-small.kbarticle,.coveo-icon.objecttype.coveo-small.Kbarticle,.coveo-icon.objecttype.coveo-small.knowledgearticle,.coveo-icon.objecttype.coveo-small.Knowledgearticle,.coveo-icon.objecttype.coveo-small.Salesliterature,.coveo-icon.objecttype.coveo-small.salesliterature,.coveo-icon.objecttype.Kbarticle,.coveo-icon.objecttype.kbarticle,.coveo-icon.objecttype.knowledgearticle,.coveo-icon.objecttype.Knowledgearticle,.coveo-icon.objecttype.Salesliterature,.coveo-icon.objecttype.salesliterature{background-image:url( ../image/salesforce-standard-article.svg)}.coveo-filetype-salesforce-standard-asset-relationship,.coveo-filetype-salesforce-standard-asset-relationship-small{background-image:url( ../image/salesforce-standard-asset-relationship.svg)}.coveo-filetype-salesforce-standard-assigned-resource,.coveo-filetype-salesforce-standard-assigned-resource-small{background-image:url( ../image/salesforce-standard-assigned-resource.svg)}.coveo-filetype-salesforce-standard-avatar-loading,.coveo-filetype-salesforce-standard-avatar-loading-small{background-image:url( ../image/salesforce-standard-avatar-loading.svg)}.coveo-filetype-salesforce-standard-avatar,.coveo-filetype-salesforce-standard-avatar-small{background-image:url( ../image/salesforce-standard-avatar.svg)}.coveo-filetype-salesforce-standard-bot,.coveo-filetype-salesforce-standard-bot-small{background-image:url( ../image/salesforce-standard-bot.svg)}.coveo-filetype-salesforce-standard-business-hours,.coveo-filetype-salesforce-standard-business-hours-small{background-image:url( ../image/salesforce-standard-business-hours.svg)}.coveo-filetype-salesforce-standard-calibration,.coveo-filetype-salesforce-standard-calibration-small{background-image:url( ../image/salesforce-standard-calibration.svg)}.coveo-filetype-salesforce-standard-call-history,.coveo-filetype-salesforce-standard-call-history-small{background-image:url( ../image/salesforce-standard-call-history.svg)}.coveo-filetype-salesforce-standard-call,.coveo-filetype-salesforce-standard-call-small,.coveo-icon.objecttype.coveo-small.Phonecall,.coveo-icon.objecttype.coveo-small.phonecall,.coveo-icon.objecttype.Phonecall,.coveo-icon.objecttype.phonecall{background-image:url( ../image/salesforce-standard-call.svg)}.coveo-filetype-salesforce-standard-campaign-members,.coveo-filetype-salesforce-standard-campaign-members-small{background-image:url( ../image/salesforce-standard-campaign-members.svg)}.coveo-filetype-salesforce-standard-campaign,.coveo-filetype-salesforce-standard-campaign-small,.coveo-icon.objecttype.Campaign,.coveo-icon.objecttype.campaign,.coveo-icon.objecttype.coveo-small.Campaign,.coveo-icon.objecttype.coveo-small.campaign{background-image:url( ../image/salesforce-standard-campaign.svg)}.coveo-filetype-salesforce-standard-canvas,.coveo-filetype-salesforce-standard-canvas-small{background-image:url( ../image/salesforce-standard-canvas.svg)}.coveo-filetype-salesforce-standard-carousel,.coveo-filetype-salesforce-standard-carousel-small{background-image:url( ../image/salesforce-standard-carousel.svg)}.coveo-filetype-salesforce-standard-case-change-status,.coveo-filetype-salesforce-standard-case-change-status-small{background-image:url( ../image/salesforce-standard-case-change-status.svg)}.coveo-filetype-salesforce-standard-case-comment,.coveo-filetype-salesforce-standard-case-comment-small{background-image:url( ../image/salesforce-standard-case-comment.svg)}.coveo-filetype-salesforce-standard-case-email,.coveo-filetype-salesforce-standard-case-email-small{background-image:url( ../image/salesforce-standard-case-email.svg)}.coveo-filetype-salesforce-standard-case-log-a-call,.coveo-filetype-salesforce-standard-case-log-a-call-small{background-image:url( ../image/salesforce-standard-case-log-a-call.svg)}.coveo-filetype-salesforce-standard-case-milestone,.coveo-filetype-salesforce-standard-case-milestone-small{background-image:url( ../image/salesforce-standard-case-milestone.svg)}.coveo-filetype-salesforce-standard-case-transcript,.coveo-filetype-salesforce-standard-case-transcript-small{background-image:url( ../image/salesforce-standard-case-transcript.svg)}.coveo-filetype-salesforce-standard-case,.coveo-filetype-salesforce-standard-case-small{background-image:url( ../image/salesforce-standard-case.svg)}.coveo-filetype-salesforce-standard-channel-program-history,.coveo-filetype-salesforce-standard-channel-program-history-small{background-image:url( ../image/salesforce-standard-channel-program-history.svg)}.coveo-filetype-salesforce-standard-channel-program-levels,.coveo-filetype-salesforce-standard-channel-program-levels-small{background-image:url( ../image/salesforce-standard-channel-program-levels.svg)}.coveo-filetype-salesforce-standard-channel-program-members,.coveo-filetype-salesforce-standard-channel-program-members-small{background-image:url( ../image/salesforce-standard-channel-program-members.svg)}.coveo-filetype-salesforce-standard-channel-programs,.coveo-filetype-salesforce-standard-channel-programs-small{background-image:url( ../image/salesforce-standard-channel-programs.svg)}.coveo-filetype-salesforce-standard-client,.coveo-filetype-salesforce-standard-client-small{background-image:url( ../image/salesforce-standard-client.svg)}.coveo-filetype-salesforce-standard-cms,.coveo-filetype-salesforce-standard-cms-small{background-image:url( ../image/salesforce-standard-cms.svg)}.coveo-filetype-salesforce-standard-coaching,.coveo-filetype-salesforce-standard-coaching-small{background-image:url( ../image/salesforce-standard-coaching.svg)}.coveo-filetype-salesforce-standard-connected-apps,.coveo-filetype-salesforce-standard-connected-apps-small{background-image:url( ../image/salesforce-standard-connected-apps.svg)}.coveo-filetype-salesforce-standard-contact-list,.coveo-filetype-salesforce-standard-contact-list-small{background-image:url( ../image/salesforce-standard-contact-list.svg)}.coveo-filetype-salesforce-standard-contact,.coveo-filetype-salesforce-standard-contact-small,.coveo-icon.objecttype.Contact,.coveo-icon.objecttype.contact,.coveo-icon.objecttype.coveo-small.Contact,.coveo-icon.objecttype.coveo-small.contact{background-image:url( ../image/salesforce-standard-contact.svg)}.coveo-filetype-salesforce-standard-contract-line-item,.coveo-filetype-salesforce-standard-contract-line-item-small{background-image:url( ../image/salesforce-standard-contract-line-item.svg)}.coveo-filetype-salesforce-standard-contract,.coveo-filetype-salesforce-standard-contract-small,.coveo-icon.objecttype.Contract,.coveo-icon.objecttype.contract,.coveo-icon.objecttype.coveo-small.Contract,.coveo-icon.objecttype.coveo-small.contract{background-image:url( ../image/salesforce-standard-contract.svg)}.coveo-filetype-salesforce-standard-custom-notification,.coveo-filetype-salesforce-standard-custom-notification-small{background-image:url( ../image/salesforce-standard-custom-notification.svg)}.coveo-filetype-salesforce-standard-custom,.coveo-filetype-salesforce-standard-custom-small{background-image:url( ../image/salesforce-standard-custom.svg)}.coveo-filetype-salesforce-standard-customers,.coveo-filetype-salesforce-standard-customers-small{background-image:url( ../image/salesforce-standard-customers.svg)}.coveo-filetype-salesforce-standard-dashboard,.coveo-filetype-salesforce-standard-dashboard-small,.coveo-icon.objecttype.coveo-small.Dashboard,.coveo-icon.objecttype.coveo-small.dashboard,.coveo-icon.objecttype.Dashboard,.coveo-icon.objecttype.dashboard{background-image:url( ../image/salesforce-standard-dashboard.svg)}.coveo-filetype-salesforce-standard-data-integration-hub,.coveo-filetype-salesforce-standard-data-integration-hub-small{background-image:url( ../image/salesforce-standard-data-integration-hub.svg)}.coveo-filetype-salesforce-standard-default,.coveo-filetype-salesforce-standard-default-small,.coveo-icon.filetype.coveo-small.Salesforceitem,.coveo-icon.filetype.coveo-small.salesforceitem,.coveo-icon.filetype.Salesforceitem,.coveo-icon.filetype.salesforceitem{background-image:url( ../image/salesforce-standard-default.svg)}.coveo-filetype-salesforce-standard-document,.coveo-filetype-salesforce-standard-document-small{background-image:url( ../image/salesforce-standard-document.svg)}.coveo-filetype-salesforce-standard-drafts,.coveo-filetype-salesforce-standard-drafts-small{background-image:url( ../image/salesforce-standard-drafts.svg)}.coveo-filetype-salesforce-standard-email-chatter,.coveo-filetype-salesforce-standard-email-chatter-small{background-image:url( ../image/salesforce-standard-email-chatter.svg)}.coveo-filetype-salesforce-standard-email,.coveo-filetype-salesforce-standard-email-small{background-image:url( ../image/salesforce-standard-email.svg)}.coveo-filetype-salesforce-standard-empty,.coveo-filetype-salesforce-standard-empty-small{background-image:url( ../image/salesforce-standard-empty.svg)}.coveo-filetype-salesforce-standard-endorsement,.coveo-filetype-salesforce-standard-endorsement-small{background-image:url( ../image/salesforce-standard-endorsement.svg)}.coveo-filetype-salesforce-standard-entitlement-process,.coveo-filetype-salesforce-standard-entitlement-process-small{background-image:url( ../image/salesforce-standard-entitlement-process.svg)}.coveo-filetype-salesforce-standard-entitlement-template,.coveo-filetype-salesforce-standard-entitlement-template-small{background-image:url( ../image/salesforce-standard-entitlement-template.svg)}.coveo-filetype-salesforce-standard-entitlement,.coveo-filetype-salesforce-standard-entitlement-small{background-image:url( ../image/salesforce-standard-entitlement.svg)}.coveo-filetype-salesforce-standard-entity-milestone,.coveo-filetype-salesforce-standard-entity-milestone-small{background-image:url( ../image/salesforce-standard-entity-milestone.svg)}.coveo-filetype-salesforce-standard-entity,.coveo-filetype-salesforce-standard-entity-small{background-image:url( ../image/salesforce-standard-entity.svg)}.coveo-filetype-salesforce-standard-environment-hub,.coveo-filetype-salesforce-standard-environment-hub-small{background-image:url( ../image/salesforce-standard-environment-hub.svg)}.coveo-filetype-salesforce-standard-event,.coveo-filetype-salesforce-standard-event-small,.coveo-icon.objecttype.coveo-small.Event,.coveo-icon.objecttype.coveo-small.event,.coveo-icon.objecttype.Event,.coveo-icon.objecttype.event{background-image:url( ../image/salesforce-standard-event.svg)}.coveo-filetype-salesforce-standard-feed,.coveo-filetype-salesforce-standard-feed-small,.coveo-icon.filetype.coveo-small.Rssitem,.coveo-icon.filetype.coveo-small.rssitem,.coveo-icon.filetype.Rssitem,.coveo-icon.filetype.rssitem,.coveo-icon.objecttype.coveo-small.Feed,.coveo-icon.objecttype.coveo-small.feed,.coveo-icon.objecttype.Feed,.coveo-icon.objecttype.feed{background-image:url( ../image/salesforce-standard-feed.svg)}.coveo-filetype-salesforce-standard-feedback,.coveo-filetype-salesforce-standard-feedback-small,.coveo-icon.filetype.coveo-small.lithiummessage,.coveo-icon.filetype.coveo-small.Lithiummessage,.coveo-icon.filetype.coveo-small.lithiumthread,.coveo-icon.filetype.coveo-small.Lithiumthread,.coveo-icon.filetype.Lithiummessage,.coveo-icon.filetype.lithiummessage,.coveo-icon.filetype.Lithiumthread,.coveo-icon.filetype.lithiumthread,.coveo-icon.objecttype.casecomment,.coveo-icon.objecttype.Casecomment,.coveo-icon.objecttype.coveo-small.Casecomment,.coveo-icon.objecttype.coveo-small.casecomment,.coveo-icon.objecttype.coveo-small.Kbarticlecomment,.coveo-icon.objecttype.coveo-small.kbarticlecomment,.coveo-icon.objecttype.coveo-small.Thread,.coveo-icon.objecttype.coveo-small.thread,.coveo-icon.objecttype.kbarticlecomment,.coveo-icon.objecttype.Kbarticlecomment,.coveo-icon.objecttype.Thread,.coveo-icon.objecttype.thread{background-image:url( ../image/salesforce-standard-feedback.svg)}.coveo-filetype-salesforce-standard-file,.coveo-filetype-salesforce-standard-file-small,.coveo-icon.objecttype.Annotation,.coveo-icon.objecttype.annotation,.coveo-icon.objecttype.coveo-small.Annotation,.coveo-icon.objecttype.coveo-small.annotation,.coveo-icon.objecttype.coveo-small.File,.coveo-icon.objecttype.coveo-small.file,.coveo-icon.objecttype.File,.coveo-icon.objecttype.file{background-image:url( ../image/salesforce-standard-file.svg)}.coveo-filetype-salesforce-standard-flow,.coveo-filetype-salesforce-standard-flow-small{background-image:url( ../image/salesforce-standard-flow.svg)}.coveo-filetype-salesforce-standard-folder,.coveo-filetype-salesforce-standard-folder-small{background-image:url( ../image/salesforce-standard-folder.svg)}.coveo-filetype-salesforce-standard-forecasts,.coveo-filetype-salesforce-standard-forecasts-small{background-image:url( ../image/salesforce-standard-forecasts.svg)}.coveo-filetype-salesforce-standard-generic-loading,.coveo-filetype-salesforce-standard-generic-loading-small{background-image:url( ../image/salesforce-standard-generic-loading.svg)}.coveo-filetype-salesforce-standard-goals,.coveo-filetype-salesforce-standard-goals-small,.coveo-icon.objecttype.coveo-small.Goal,.coveo-icon.objecttype.coveo-small.goal,.coveo-icon.objecttype.Goal,.coveo-icon.objecttype.goal{background-image:url( ../image/salesforce-standard-goals.svg)}.coveo-filetype-salesforce-standard-group-loading,.coveo-filetype-salesforce-standard-group-loading-small{background-image:url( ../image/salesforce-standard-group-loading.svg)}.coveo-filetype-salesforce-standard-groups,.coveo-filetype-salesforce-standard-groups-small,.coveo-icon.filetype.coveo-small.Lithiumboard,.coveo-icon.filetype.coveo-small.lithiumboard,.coveo-icon.filetype.Lithiumboard,.coveo-icon.filetype.lithiumboard,.coveo-icon.objecttype.Collaborationgroup,.coveo-icon.objecttype.collaborationgroup,.coveo-icon.objecttype.coveo-small.Collaborationgroup,.coveo-icon.objecttype.coveo-small.collaborationgroup{background-image:url( ../image/salesforce-standard-groups.svg)}.coveo-filetype-salesforce-standard-hierarchy,.coveo-filetype-salesforce-standard-hierarchy-small{background-image:url( ../image/salesforce-standard-hierarchy.svg)}.coveo-filetype-salesforce-standard-home,.coveo-filetype-salesforce-standard-home-small{background-image:url( ../image/salesforce-standard-home.svg)}.coveo-filetype-salesforce-standard-household,.coveo-filetype-salesforce-standard-household-small{background-image:url( ../image/salesforce-standard-household.svg)}.coveo-filetype-salesforce-standard-individual,.coveo-filetype-salesforce-standard-individual-small{background-image:url( ../image/salesforce-standard-individual.svg)}.coveo-filetype-salesforce-standard-insights,.coveo-filetype-salesforce-standard-insights-small,.coveo-icon.filetype.Cfblogentry,.coveo-icon.filetype.cfblogentry,.coveo-icon.filetype.coveo-small.Cfblogentry,.coveo-icon.filetype.coveo-small.cfblogentry{background-image:url( ../image/salesforce-standard-insights.svg)}.coveo-filetype-salesforce-standard-investment-account,.coveo-filetype-salesforce-standard-investment-account-small{background-image:url( ../image/salesforce-standard-investment-account.svg)}.coveo-filetype-salesforce-standard-iot-orchestrations,.coveo-filetype-salesforce-standard-iot-orchestrations-small{background-image:url( ../image/salesforce-standard-iot-orchestrations.svg)}.coveo-filetype-salesforce-standard-knowledge,.coveo-filetype-salesforce-standard-knowledge-small,.coveo-icon.objecttype.coveo-small.Kbdocumentation,.coveo-icon.objecttype.coveo-small.kbdocumentation,.coveo-icon.objecttype.coveo-small.Kbknowledgearticle,.coveo-icon.objecttype.coveo-small.kbknowledgearticle,.coveo-icon.objecttype.coveo-small.Kbtechnicalarticle,.coveo-icon.objecttype.coveo-small.kbtechnicalarticle,.coveo-icon.objecttype.Kbdocumentation,.coveo-icon.objecttype.kbdocumentation,.coveo-icon.objecttype.kbknowledgearticle,.coveo-icon.objecttype.Kbknowledgearticle,.coveo-icon.objecttype.Kbtechnicalarticle,.coveo-icon.objecttype.kbtechnicalarticle{background-image:url( ../image/salesforce-standard-knowledge.svg)}.coveo-filetype-salesforce-standard-lead-insights,.coveo-filetype-salesforce-standard-lead-insights-small{background-image:url( ../image/salesforce-standard-lead-insights.svg)}.coveo-filetype-salesforce-standard-lead-list,.coveo-filetype-salesforce-standard-lead-list-small{background-image:url( ../image/salesforce-standard-lead-list.svg)}.coveo-filetype-salesforce-standard-lead,.coveo-filetype-salesforce-standard-lead-small,.coveo-icon.objecttype.coveo-small.Lead,.coveo-icon.objecttype.coveo-small.lead,.coveo-icon.objecttype.Lead,.coveo-icon.objecttype.lead{background-image:url( ../image/salesforce-standard-lead.svg)}.coveo-filetype-salesforce-standard-link,.coveo-filetype-salesforce-standard-link-small{background-image:url( ../image/salesforce-standard-link.svg)}.coveo-filetype-salesforce-standard-list-email,.coveo-filetype-salesforce-standard-list-email-small{background-image:url( ../image/salesforce-standard-list-email.svg)}.coveo-filetype-salesforce-standard-live-chat-visitor,.coveo-filetype-salesforce-standard-live-chat-visitor-small{background-image:url( ../image/salesforce-standard-live-chat-visitor.svg)}.coveo-filetype-salesforce-standard-live-chat,.coveo-filetype-salesforce-standard-live-chat-small{background-image:url( ../image/salesforce-standard-live-chat.svg)}.coveo-filetype-salesforce-standard-location,.coveo-filetype-salesforce-standard-location-small{background-image:url( ../image/salesforce-standard-location.svg)}.coveo-filetype-salesforce-standard-log-a-call,.coveo-filetype-salesforce-standard-log-a-call-small{background-image:url( ../image/salesforce-standard-log-a-call.svg)}.coveo-filetype-salesforce-standard-logging,.coveo-filetype-salesforce-standard-logging-small{background-image:url( ../image/salesforce-standard-logging.svg)}.coveo-filetype-salesforce-standard-macros,.coveo-filetype-salesforce-standard-macros-small{background-image:url( ../image/salesforce-standard-macros.svg)}.coveo-filetype-salesforce-standard-maintenance-asset,.coveo-filetype-salesforce-standard-maintenance-asset-small{background-image:url( ../image/salesforce-standard-maintenance-asset.svg)}.coveo-filetype-salesforce-standard-maintenance-plan,.coveo-filetype-salesforce-standard-maintenance-plan-small{background-image:url( ../image/salesforce-standard-maintenance-plan.svg)}.coveo-filetype-salesforce-standard-marketing-actions,.coveo-filetype-salesforce-standard-marketing-actions-small{background-image:url( ../image/salesforce-standard-marketing-actions.svg)}.coveo-filetype-salesforce-standard-merge,.coveo-filetype-salesforce-standard-merge-small{background-image:url( ../image/salesforce-standard-merge.svg)}.coveo-filetype-salesforce-standard-messaging-conversation,.coveo-filetype-salesforce-standard-messaging-conversation-small{background-image:url( ../image/salesforce-standard-messaging-conversation.svg)}.coveo-filetype-salesforce-standard-messaging-session,.coveo-filetype-salesforce-standard-messaging-session-small{background-image:url( ../image/salesforce-standard-messaging-session.svg)}.coveo-filetype-salesforce-standard-messaging-user,.coveo-filetype-salesforce-standard-messaging-user-small{background-image:url( ../image/salesforce-standard-messaging-user.svg)}.coveo-filetype-salesforce-standard-metrics,.coveo-filetype-salesforce-standard-metrics-small{background-image:url( ../image/salesforce-standard-metrics.svg)}.coveo-filetype-salesforce-standard-news,.coveo-filetype-salesforce-standard-news-small{background-image:url( ../image/salesforce-standard-news.svg)}.coveo-filetype-salesforce-standard-note,.coveo-filetype-salesforce-standard-note-small,.coveo-icon.objecttype.coveo-small.Note,.coveo-icon.objecttype.coveo-small.note,.coveo-icon.objecttype.Note,.coveo-icon.objecttype.note{background-image:url( ../image/salesforce-standard-note.svg)}.coveo-filetype-salesforce-standard-omni-supervisor,.coveo-filetype-salesforce-standard-omni-supervisor-small{background-image:url( ../image/salesforce-standard-omni-supervisor.svg)}.coveo-filetype-salesforce-standard-operating-hours,.coveo-filetype-salesforce-standard-operating-hours-small{background-image:url( ../image/salesforce-standard-operating-hours.svg)}.coveo-filetype-salesforce-standard-opportunity-splits,.coveo-filetype-salesforce-standard-opportunity-splits-small{background-image:url( ../image/salesforce-standard-opportunity-splits.svg)}.coveo-filetype-salesforce-standard-opportunity,.coveo-filetype-salesforce-standard-opportunity-small,.coveo-icon.objecttype.coveo-small.Opportunity,.coveo-icon.objecttype.coveo-small.opportunity,.coveo-icon.objecttype.coveo-small.Opportunityproduct,.coveo-icon.objecttype.coveo-small.opportunityproduct,.coveo-icon.objecttype.Opportunity,.coveo-icon.objecttype.opportunity,.coveo-icon.objecttype.Opportunityproduct,.coveo-icon.objecttype.opportunityproduct{background-image:url( ../image/salesforce-standard-opportunity.svg)}.coveo-filetype-salesforce-standard-orders,.coveo-filetype-salesforce-standard-orders-small,.coveo-icon.objecttype.coveo-small.Salesorder,.coveo-icon.objecttype.coveo-small.salesorder,.coveo-icon.objecttype.Salesorder,.coveo-icon.objecttype.salesorder{background-image:url( ../image/salesforce-standard-orders.svg)}.coveo-filetype-salesforce-standard-partner-fund-allocation,.coveo-filetype-salesforce-standard-partner-fund-allocation-small{background-image:url( ../image/salesforce-standard-partner-fund-allocation.svg)}.coveo-filetype-salesforce-standard-partner-fund-claim,.coveo-filetype-salesforce-standard-partner-fund-claim-small{background-image:url( ../image/salesforce-standard-partner-fund-claim.svg)}.coveo-filetype-salesforce-standard-partner-fund-request,.coveo-filetype-salesforce-standard-partner-fund-request-small{background-image:url( ../image/salesforce-standard-partner-fund-request.svg)}.coveo-filetype-salesforce-standard-partner-marketing-budget,.coveo-filetype-salesforce-standard-partner-marketing-budget-small{background-image:url( ../image/salesforce-standard-partner-marketing-budget.svg)}.coveo-filetype-salesforce-standard-partners,.coveo-filetype-salesforce-standard-partners-small{background-image:url( ../image/salesforce-standard-partners.svg)}.coveo-filetype-salesforce-standard-past-chat,.coveo-filetype-salesforce-standard-past-chat-small{background-image:url( ../image/salesforce-standard-past-chat.svg)}.coveo-filetype-salesforce-standard-people,.coveo-filetype-salesforce-standard-people-small{background-image:url( ../image/salesforce-standard-people.svg)}.coveo-filetype-salesforce-standard-performance,.coveo-filetype-salesforce-standard-performance-small{background-image:url( ../image/salesforce-standard-performance.svg)}.coveo-filetype-salesforce-standard-person-account,.coveo-filetype-salesforce-standard-person-account-small{background-image:url( ../image/salesforce-standard-person-account.svg)}.coveo-filetype-salesforce-standard-photo,.coveo-filetype-salesforce-standard-photo-small{background-image:url( ../image/salesforce-standard-photo.svg)}.coveo-filetype-salesforce-standard-poll,.coveo-filetype-salesforce-standard-poll-small{background-image:url( ../image/salesforce-standard-poll.svg)}.coveo-filetype-salesforce-standard-portal,.coveo-filetype-salesforce-standard-portal-small{background-image:url( ../image/salesforce-standard-portal.svg)}.coveo-filetype-salesforce-standard-post,.coveo-filetype-salesforce-standard-post-small,.coveo-icon.objecttype.coveo-small.Feedcomment,.coveo-icon.objecttype.coveo-small.feedcomment,.coveo-icon.objecttype.coveo-small.Feeditem,.coveo-icon.objecttype.coveo-small.feeditem,.coveo-icon.objecttype.Feedcomment,.coveo-icon.objecttype.feedcomment,.coveo-icon.objecttype.Feeditem,.coveo-icon.objecttype.feeditem{background-image:url( ../image/salesforce-standard-post.svg)}.coveo-filetype-salesforce-standard-pricebook,.coveo-filetype-salesforce-standard-pricebook-small{background-image:url( ../image/salesforce-standard-pricebook.svg)}.coveo-filetype-salesforce-standard-process,.coveo-filetype-salesforce-standard-process-small{background-image:url( ../image/salesforce-standard-process.svg)}.coveo-filetype-salesforce-standard-product-consumed,.coveo-filetype-salesforce-standard-product-consumed-small{background-image:url( ../image/salesforce-standard-product-consumed.svg)}.coveo-filetype-salesforce-standard-product-item-transaction,.coveo-filetype-salesforce-standard-product-item-transaction-small{background-image:url( ../image/salesforce-standard-product-item-transaction.svg)}.coveo-filetype-salesforce-standard-product-item,.coveo-filetype-salesforce-standard-product-item-small{background-image:url( ../image/salesforce-standard-product-item.svg)}.coveo-filetype-salesforce-standard-product-request-line-item,.coveo-filetype-salesforce-standard-product-request-line-item-small{background-image:url( ../image/salesforce-standard-product-request-line-item.svg)}.coveo-filetype-salesforce-standard-product-request,.coveo-filetype-salesforce-standard-product-request-small{background-image:url( ../image/salesforce-standard-product-request.svg)}.coveo-filetype-salesforce-standard-product-required,.coveo-filetype-salesforce-standard-product-required-small{background-image:url( ../image/salesforce-standard-product-required.svg)}.coveo-filetype-salesforce-standard-product-transfer,.coveo-filetype-salesforce-standard-product-transfer-small{background-image:url( ../image/salesforce-standard-product-transfer.svg)}.coveo-filetype-salesforce-standard-product,.coveo-filetype-salesforce-standard-product-small,.coveo-icon.objecttype.coveo-small.Product,.coveo-icon.objecttype.coveo-small.product,.coveo-icon.objecttype.Product,.coveo-icon.objecttype.product{background-image:url( ../image/salesforce-standard-product.svg)}.coveo-filetype-salesforce-standard-question-best,.coveo-filetype-salesforce-standard-question-best-small{background-image:url( ../image/salesforce-standard-question-best.svg)}.coveo-filetype-salesforce-standard-question-feed,.coveo-filetype-salesforce-standard-question-feed-small,.coveo-icon.filetype.Cfcomment,.coveo-icon.filetype.cfcomment,.coveo-icon.filetype.coveo-small.Cfcomment,.coveo-icon.filetype.coveo-small.cfcomment{background-image:url( ../image/salesforce-standard-question-feed.svg)}.coveo-filetype-salesforce-standard-quick-text,.coveo-filetype-salesforce-standard-quick-text-small{background-image:url( ../image/salesforce-standard-quick-text.svg)}.coveo-filetype-salesforce-standard-quip-sheet,.coveo-filetype-salesforce-standard-quip-sheet-small{background-image:url( ../image/salesforce-standard-quip-sheet.svg)}.coveo-filetype-salesforce-standard-quip,.coveo-filetype-salesforce-standard-quip-small{background-image:url( ../image/salesforce-standard-quip.svg)}.coveo-filetype-salesforce-standard-quotes,.coveo-filetype-salesforce-standard-quotes-small,.coveo-icon.objecttype.coveo-small.Quote,.coveo-icon.objecttype.coveo-small.quote,.coveo-icon.objecttype.Quote,.coveo-icon.objecttype.quote{background-image:url( ../image/salesforce-standard-quotes.svg)}.coveo-filetype-salesforce-standard-read-receipts,.coveo-filetype-salesforce-standard-read-receipts-small{background-image:url( ../image/salesforce-standard-read-receipts.svg)}.coveo-filetype-salesforce-standard-recent,.coveo-filetype-salesforce-standard-recent-small{background-image:url( ../image/salesforce-standard-recent.svg)}.coveo-filetype-salesforce-standard-record,.coveo-filetype-salesforce-standard-record-small{background-image:url( ../image/salesforce-standard-record.svg)}.coveo-filetype-salesforce-standard-related-list,.coveo-filetype-salesforce-standard-related-list-small,.coveo-icon.filetype.coveo-small.lithiumcategory,.coveo-icon.filetype.coveo-small.Lithiumcategory,.coveo-icon.filetype.coveo-small.saleforceitem,.coveo-icon.filetype.coveo-small.Saleforceitem,.coveo-icon.filetype.coveo-small.spwikipagelibrarylist,.coveo-icon.filetype.coveo-small.Spwikipagelibrarylist,.coveo-icon.filetype.lithiumcategory,.coveo-icon.filetype.Lithiumcategory,.coveo-icon.filetype.saleforceitem,.coveo-icon.filetype.Saleforceitem,.coveo-icon.filetype.spwikipagelibrarylist,.coveo-icon.filetype.Spwikipagelibrarylist,.coveo-icon.objecttype.coveo-small.List,.coveo-icon.objecttype.coveo-small.list,.coveo-icon.objecttype.List,.coveo-icon.objecttype.list{background-image:url( ../image/salesforce-standard-related-list.svg)}.coveo-filetype-salesforce-standard-relationship,.coveo-filetype-salesforce-standard-relationship-small{background-image:url( ../image/salesforce-standard-relationship.svg)}.coveo-filetype-salesforce-standard-report,.coveo-filetype-salesforce-standard-report-small,.coveo-icon.objecttype.coveo-small.Report,.coveo-icon.objecttype.coveo-small.report,.coveo-icon.objecttype.Report,.coveo-icon.objecttype.report{background-image:url( ../image/salesforce-standard-report.svg)}.coveo-filetype-salesforce-standard-resource-absence,.coveo-filetype-salesforce-standard-resource-absence-small{background-image:url( ../image/salesforce-standard-resource-absence.svg)}.coveo-filetype-salesforce-standard-resource-capacity,.coveo-filetype-salesforce-standard-resource-capacity-small{background-image:url( ../image/salesforce-standard-resource-capacity.svg)}.coveo-filetype-salesforce-standard-resource-preference,.coveo-filetype-salesforce-standard-resource-preference-small{background-image:url( ../image/salesforce-standard-resource-preference.svg)}.coveo-filetype-salesforce-standard-resource-skill,.coveo-filetype-salesforce-standard-resource-skill-small{background-image:url( ../image/salesforce-standard-resource-skill.svg)}.coveo-filetype-salesforce-standard-return-order-line-item,.coveo-filetype-salesforce-standard-return-order-line-item-small{background-image:url( ../image/salesforce-standard-return-order-line-item.svg)}.coveo-filetype-salesforce-standard-return-order,.coveo-filetype-salesforce-standard-return-order-small{background-image:url( ../image/salesforce-standard-return-order.svg)}.coveo-filetype-salesforce-standard-reward,.coveo-filetype-salesforce-standard-reward-small{background-image:url( ../image/salesforce-standard-reward.svg)}.coveo-filetype-salesforce-standard-rtc-presence,.coveo-filetype-salesforce-standard-rtc-presence-small{background-image:url( ../image/salesforce-standard-rtc-presence.svg)}.coveo-filetype-salesforce-standard-sales-path,.coveo-filetype-salesforce-standard-sales-path-small{background-image:url( ../image/salesforce-standard-sales-path.svg)}.coveo-filetype-salesforce-standard-scan-card,.coveo-filetype-salesforce-standard-scan-card-small{background-image:url( ../image/salesforce-standard-scan-card.svg)}.coveo-filetype-salesforce-standard-search,.coveo-filetype-salesforce-standard-search-small{background-image:url( ../image/salesforce-standard-search.svg)}.coveo-filetype-salesforce-standard-service-appointment,.coveo-filetype-salesforce-standard-service-appointment-small,.coveo-icon.objecttype.Appointment,.coveo-icon.objecttype.appointment,.coveo-icon.objecttype.coveo-small.Appointment,.coveo-icon.objecttype.coveo-small.appointment{background-image:url( ../image/salesforce-standard-service-appointment.svg)}.coveo-filetype-salesforce-standard-service-contract,.coveo-filetype-salesforce-standard-service-contract-small,.coveo-icon.objecttype.coveo-small.Service,.coveo-icon.objecttype.coveo-small.service,.coveo-icon.objecttype.Service,.coveo-icon.objecttype.service{background-image:url( ../image/salesforce-standard-service-contract.svg)}.coveo-filetype-salesforce-standard-service-crew-member,.coveo-filetype-salesforce-standard-service-crew-member-small{background-image:url( ../image/salesforce-standard-service-crew-member.svg)}.coveo-filetype-salesforce-standard-service-crew,.coveo-filetype-salesforce-standard-service-crew-small{background-image:url( ../image/salesforce-standard-service-crew.svg)}.coveo-filetype-salesforce-standard-service-report,.coveo-filetype-salesforce-standard-service-report-small,.coveo-icon.filetype.coveo-small.Jiraissue,.coveo-icon.filetype.coveo-small.jiraissue,.coveo-icon.filetype.Jiraissue,.coveo-icon.filetype.jiraissue{background-image:url( ../image/salesforce-standard-service-report.svg)}.coveo-filetype-salesforce-standard-service-resource,.coveo-filetype-salesforce-standard-service-resource-small{background-image:url( ../image/salesforce-standard-service-resource.svg)}.coveo-filetype-salesforce-standard-service-territory-location,.coveo-filetype-salesforce-standard-service-territory-location-small{background-image:url( ../image/salesforce-standard-service-territory-location.svg)}.coveo-filetype-salesforce-standard-service-territory-member,.coveo-filetype-salesforce-standard-service-territory-member-small{background-image:url( ../image/salesforce-standard-service-territory-member.svg)}.coveo-filetype-salesforce-standard-service-territory,.coveo-filetype-salesforce-standard-service-territory-small{background-image:url( ../image/salesforce-standard-service-territory.svg)}.coveo-filetype-salesforce-standard-shipment,.coveo-filetype-salesforce-standard-shipment-small{background-image:url( ../image/salesforce-standard-shipment.svg)}.coveo-filetype-salesforce-standard-skill-entity,.coveo-filetype-salesforce-standard-skill-entity-small{background-image:url( ../image/salesforce-standard-skill-entity.svg)}.coveo-filetype-salesforce-standard-skill-requirement,.coveo-filetype-salesforce-standard-skill-requirement-small{background-image:url( ../image/salesforce-standard-skill-requirement.svg)}.coveo-filetype-salesforce-standard-skill,.coveo-filetype-salesforce-standard-skill-small{background-image:url( ../image/salesforce-standard-skill.svg)}.coveo-filetype-salesforce-standard-social,.coveo-filetype-salesforce-standard-social-small,.coveo-icon.objecttype.coveo-small.Socialprofile,.coveo-icon.objecttype.coveo-small.socialprofile,.coveo-icon.objecttype.Socialprofile,.coveo-icon.objecttype.socialprofile{background-image:url( ../image/salesforce-standard-social.svg)}.coveo-filetype-salesforce-standard-solution,.coveo-filetype-salesforce-standard-solution-small,.coveo-icon.objecttype.coveo-small.Kbsolution,.coveo-icon.objecttype.coveo-small.kbsolution,.coveo-icon.objecttype.coveo-small.Solution,.coveo-icon.objecttype.coveo-small.solution,.coveo-icon.objecttype.Kbsolution,.coveo-icon.objecttype.kbsolution,.coveo-icon.objecttype.Solution,.coveo-icon.objecttype.solution{background-image:url( ../image/salesforce-standard-solution.svg)}.coveo-filetype-salesforce-standard-sossession,.coveo-filetype-salesforce-standard-sossession-small{background-image:url( ../image/salesforce-standard-sossession.svg)}.coveo-filetype-salesforce-standard-stage-collection,.coveo-filetype-salesforce-standard-stage-collection-small{background-image:url( ../image/salesforce-standard-stage-collection.svg)}.coveo-filetype-salesforce-standard-stage,.coveo-filetype-salesforce-standard-stage-small{background-image:url( ../image/salesforce-standard-stage.svg)}.coveo-filetype-salesforce-standard-survey,.coveo-filetype-salesforce-standard-survey-small{background-image:url( ../image/salesforce-standard-survey.svg)}.coveo-filetype-salesforce-standard-task,.coveo-filetype-salesforce-standard-task-small,.coveo-icon.objecttype.coveo-small.Task,.coveo-icon.objecttype.coveo-small.task,.coveo-icon.objecttype.Task,.coveo-icon.objecttype.task{background-image:url( ../image/salesforce-standard-task.svg)}.coveo-filetype-salesforce-standard-task2,.coveo-filetype-salesforce-standard-task2-small{background-image:url( ../image/salesforce-standard-task2.svg)}.coveo-filetype-salesforce-standard-team-member,.coveo-filetype-salesforce-standard-team-member-small,.coveo-icon.filetype.coveo-small.Lithiumcommunity,.coveo-icon.filetype.coveo-small.lithiumcommunity,.coveo-icon.filetype.Lithiumcommunity,.coveo-icon.filetype.lithiumcommunity{background-image:url( ../image/salesforce-standard-team-member.svg)}.coveo-filetype-salesforce-standard-template,.coveo-filetype-salesforce-standard-template-small{background-image:url( ../image/salesforce-standard-template.svg)}.coveo-filetype-salesforce-standard-thanks-loading,.coveo-filetype-salesforce-standard-thanks-loading-small{background-image:url( ../image/salesforce-standard-thanks-loading.svg)}.coveo-filetype-salesforce-standard-thanks,.coveo-filetype-salesforce-standard-thanks-small{background-image:url( ../image/salesforce-standard-thanks.svg)}.coveo-filetype-salesforce-standard-timesheet-entry,.coveo-filetype-salesforce-standard-timesheet-entry-small{background-image:url( ../image/salesforce-standard-timesheet-entry.svg)}.coveo-filetype-salesforce-standard-timesheet,.coveo-filetype-salesforce-standard-timesheet-small{background-image:url( ../image/salesforce-standard-timesheet.svg)}.coveo-filetype-salesforce-standard-timeslot,.coveo-filetype-salesforce-standard-timeslot-small{background-image:url( ../image/salesforce-standard-timeslot.svg)}.coveo-filetype-salesforce-standard-today,.coveo-filetype-salesforce-standard-today-small{background-image:url( ../image/salesforce-standard-today.svg)}.coveo-filetype-salesforce-standard-topic,.coveo-filetype-salesforce-standard-topic-small,.coveo-icon.objecttype.coveo-small.Topic,.coveo-icon.objecttype.coveo-small.topic,.coveo-icon.objecttype.Topic,.coveo-icon.objecttype.topic{background-image:url( ../image/salesforce-standard-topic.svg)}.coveo-filetype-salesforce-standard-topic2,.coveo-filetype-salesforce-standard-topic2-small{background-image:url( ../image/salesforce-standard-topic2.svg)}.coveo-filetype-salesforce-standard-unmatched,.coveo-filetype-salesforce-standard-unmatched-small{background-image:url( ../image/salesforce-standard-unmatched.svg)}.coveo-filetype-salesforce-standard-user,.coveo-filetype-salesforce-standard-user-small{background-image:url( ../image/salesforce-standard-user.svg)}.coveo-filetype-salesforce-standard-work-order-item,.coveo-filetype-salesforce-standard-work-order-item-small{background-image:url( ../image/salesforce-standard-work-order-item.svg)}.coveo-filetype-salesforce-standard-work-order,.coveo-filetype-salesforce-standard-work-order-small{background-image:url( ../image/salesforce-standard-work-order.svg)}.coveo-filetype-salesforce-standard-work-type,.coveo-filetype-salesforce-standard-work-type-small{background-image:url( ../image/salesforce-standard-work-type.svg)}.coveo-filetype-user,.coveo-filetype-user-small,.coveo-icon.filetype.activedirperson,.coveo-icon.filetype.Activedirperson,.coveo-icon.filetype.Box,.coveo-icon.filetype.box,.coveo-icon.filetype.Box-user,.coveo-icon.filetype.box user,.coveo-icon.filetype.coveo-small.Activedirperson,.coveo-icon.filetype.coveo-small.activedirperson,.coveo-icon.filetype.coveo-small.Box,.coveo-icon.filetype.coveo-small.box,.coveo-icon.filetype.coveo-small.Box-user,.coveo-icon.filetype.coveo-small.box user,.coveo-icon.filetype.coveo-small.exchangegroup,.coveo-icon.filetype.coveo-small.Exchangegroup,.coveo-icon.filetype.coveo-small.exchangeperson,.coveo-icon.filetype.coveo-small.Exchangeperson,.coveo-icon.filetype.coveo-small.Spattendee,.coveo-icon.filetype.coveo-small.spattendee,.coveo-icon.filetype.coveo-small.spattendeelist,.coveo-icon.filetype.coveo-small.Spattendeelist,.coveo-icon.filetype.coveo-small.Spcontact,.coveo-icon.filetype.coveo-small.spcontact,.coveo-icon.filetype.coveo-small.spcontactlist,.coveo-icon.filetype.coveo-small.Spcontactlist,.coveo-icon.filetype.coveo-small.spuserinformation,.coveo-icon.filetype.coveo-small.Spuserinformation,.coveo-icon.filetype.coveo-small.spuserinformationlist,.coveo-icon.filetype.coveo-small.Spuserinformationlist,.coveo-icon.filetype.coveo-small.Spuserprofile,.coveo-icon.filetype.coveo-small.spuserprofile,.coveo-icon.filetype.exchangegroup,.coveo-icon.filetype.Exchangegroup,.coveo-icon.filetype.exchangeperson,.coveo-icon.filetype.Exchangeperson,.coveo-icon.filetype.Spattendee,.coveo-icon.filetype.spattendee,.coveo-icon.filetype.Spattendeelist,.coveo-icon.filetype.spattendeelist,.coveo-icon.filetype.Spcontact,.coveo-icon.filetype.spcontact,.coveo-icon.filetype.Spcontactlist,.coveo-icon.filetype.spcontactlist,.coveo-icon.filetype.Spuserinformation,.coveo-icon.filetype.spuserinformation,.coveo-icon.filetype.Spuserinformationlist,.coveo-icon.filetype.spuserinformationlist,.coveo-icon.filetype.Spuserprofile,.coveo-icon.filetype.spuserprofile,.coveo-icon.objecttype.coveo-small.partner,.coveo-icon.objecttype.coveo-small.Partner,.coveo-icon.objecttype.coveo-small.People,.coveo-icon.objecttype.coveo-small.people,.coveo-icon.objecttype.coveo-small.user,.coveo-icon.objecttype.coveo-small.User,.coveo-icon.objecttype.partner,.coveo-icon.objecttype.Partner,.coveo-icon.objecttype.People,.coveo-icon.objecttype.people,.coveo-icon.objecttype.User,.coveo-icon.objecttype.user{background-image:url( ../image/user.svg)}.coveo-filetype-video,.coveo-filetype-video-small,.coveo-icon.filetype.coveo-small.Video,.coveo-icon.filetype.coveo-small.video,.coveo-icon.filetype.coveo-small.youtube,.coveo-icon.filetype.coveo-small.Youtube,.coveo-icon.filetype.coveo-small.Youtubeplaylist,.coveo-icon.filetype.coveo-small.youtubeplaylist,.coveo-icon.filetype.coveo-small.Youtubeplaylistitem,.coveo-icon.filetype.coveo-small.youtubeplaylistitem,.coveo-icon.filetype.coveo-small.Youtubevideo,.coveo-icon.filetype.coveo-small.youtubevideo,.coveo-icon.filetype.video,.coveo-icon.filetype.Video,.coveo-icon.filetype.Youtube,.coveo-icon.filetype.youtube,.coveo-icon.filetype.youtubeplaylist,.coveo-icon.filetype.Youtubeplaylist,.coveo-icon.filetype.youtubeplaylistitem,.coveo-icon.filetype.Youtubeplaylistitem,.coveo-icon.filetype.youtubevideo,.coveo-icon.filetype.Youtubevideo{background-image:url( ../image/video.svg)}.coveo-filetype-webpage,.coveo-filetype-webpage-small,.coveo-icon.filetype.coveo-small.Spportal,.coveo-icon.filetype.coveo-small.spportal,.coveo-icon.filetype.Spportal,.coveo-icon.filetype.spportal{background-image:url( ../image/webpage.svg)}.coveo-filetype-salesforce-standard-contact,.coveo-filetype-salesforce-standard-contact-small,.coveo-icon.objecttype.Contact,.coveo-icon.objecttype.contact,.coveo-icon.objecttype.coveo-small.Contact,.coveo-icon.objecttype.coveo-small.contact{background-color:#a094ed;border-radius:2px}.coveo-filetype-salesforce-standard-work-order,.coveo-filetype-salesforce-standard-work-order-small{background-color:#50e3c2;border-radius:2px}.coveo-filetype-salesforce-standard-post,.coveo-filetype-salesforce-standard-post-small,.coveo-icon.objecttype.coveo-small.Feedcomment,.coveo-icon.objecttype.coveo-small.feedcomment,.coveo-icon.objecttype.coveo-small.Feeditem,.coveo-icon.objecttype.coveo-small.feeditem,.coveo-icon.objecttype.Feedcomment,.coveo-icon.objecttype.feedcomment,.coveo-icon.objecttype.Feeditem,.coveo-icon.objecttype.feeditem{background-color:#65cae4;border-radius:2px}.coveo-filetype-salesforce-standard-carousel,.coveo-filetype-salesforce-standard-carousel-small{background-color:#6bbd6e;border-radius:2px}.coveo-filetype-salesforce-standard-resource-skill,.coveo-filetype-salesforce-standard-resource-skill-small{background-color:#45c173;border-radius:2px}.coveo-filetype-salesforce-standard-goals,.coveo-filetype-salesforce-standard-goals-small,.coveo-icon.objecttype.coveo-small.Goal,.coveo-icon.objecttype.coveo-small.goal,.coveo-icon.objecttype.Goal,.coveo-icon.objecttype.goal{background-color:#56aadf;border-radius:2px}.coveo-filetype-salesforce-standard-investment-account,.coveo-filetype-salesforce-standard-investment-account-small{background-color:#4bc076;border-radius:2px}.coveo-filetype-salesforce-standard-default,.coveo-filetype-salesforce-standard-default-small,.coveo-icon.filetype.coveo-small.Salesforceitem,.coveo-icon.filetype.coveo-small.salesforceitem,.coveo-icon.filetype.Salesforceitem,.coveo-icon.filetype.salesforceitem{background-color:#8199af;border-radius:2px}.coveo-filetype-salesforce-standard-case-milestone,.coveo-filetype-salesforce-standard-case-milestone-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-today,.coveo-filetype-salesforce-standard-today-small{background-color:#ef7ead;border-radius:2px}.coveo-filetype-salesforce-standard-lead-list,.coveo-filetype-salesforce-standard-lead-list-small,.coveo-filetype-salesforce-standard-product-item-transaction,.coveo-filetype-salesforce-standard-product-item-transaction-small{background-color:#f88962;border-radius:2px}.coveo-filetype-salesforce-standard-answer-private,.coveo-filetype-salesforce-standard-answer-private-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-retail-banking-console,.coveo-filetype-salesforce-standard-retail-banking-console-small{background-color:#00afa0;border-radius:2px}.coveo-filetype-salesforce-standard-channel-program-members,.coveo-filetype-salesforce-standard-channel-program-members-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-apps-admin,.coveo-filetype-salesforce-standard-apps-admin-small{background-color:#9895ee;border-radius:2px}.coveo-filetype-salesforce-standard-datadotcom,.coveo-filetype-salesforce-standard-datadotcom-small{background-color:#1589ee;border-radius:2px}.coveo-filetype-salesforce-standard-product-item,.coveo-filetype-salesforce-standard-product-item-small{background-color:#769ed9;border-radius:2px}.coveo-filetype-salesforce-standard-metrics,.coveo-filetype-salesforce-standard-metrics-small{background-color:#56aadf;border-radius:2px}.coveo-filetype-salesforce-standard-topic2,.coveo-filetype-salesforce-standard-topic2-small{background-color:#56aad0;border-radius:2px}.coveo-filetype-salesforce-standard-partner-fund-allocation,.coveo-filetype-salesforce-standard-partner-fund-allocation-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-approval,.coveo-filetype-salesforce-standard-approval-small{background-color:#50cc7a;border-radius:2px}.coveo-filetype-salesforce-standard-iot-orchestrations,.coveo-filetype-salesforce-standard-iot-orchestrations-small{background-color:#2a739e;border-radius:2px}.coveo-filetype-salesforce-standard-person-account,.coveo-filetype-salesforce-standard-person-account-small{background-color:#7f8de1;border-radius:2px}.coveo-filetype-salesforce-standard-entity,.coveo-filetype-salesforce-standard-entity-small{background-color:#f88962;border-radius:2px}.coveo-filetype-salesforce-standard-service-territory-location,.coveo-filetype-salesforce-standard-service-territory-location-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-read-receipts,.coveo-filetype-salesforce-standard-read-receipts-small{background-color:#4bc076;border-radius:2px}.coveo-filetype-salesforce-standard-maintenance-asset,.coveo-filetype-salesforce-standard-maintenance-asset-small{background-color:#2a739e;border-radius:2px}.coveo-filetype-salesforce-standard-marketing-actions,.coveo-filetype-salesforce-standard-marketing-actions-small{background-color:#6bbd6e;border-radius:2px}.coveo-filetype-salesforce-standard-case-transcript,.coveo-filetype-salesforce-standard-case-transcript-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-timesheet-entry,.coveo-filetype-salesforce-standard-timesheet-entry-small{background-color:#7dc37d;border-radius:2px}.coveo-filetype-salesforce-standard-task,.coveo-filetype-salesforce-standard-task-small,.coveo-icon.objecttype.coveo-small.Task,.coveo-icon.objecttype.coveo-small.task,.coveo-icon.objecttype.Task,.coveo-icon.objecttype.task{background-color:#4bc076;border-radius:2px}.coveo-filetype-salesforce-standard-answer-best,.coveo-filetype-salesforce-standard-answer-best-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-orders,.coveo-filetype-salesforce-standard-orders-small,.coveo-icon.objecttype.coveo-small.Salesorder,.coveo-icon.objecttype.coveo-small.salesorder,.coveo-icon.objecttype.Salesorder,.coveo-icon.objecttype.salesorder{background-color:#769ed9;border-radius:2px}.coveo-filetype-salesforce-standard-past-chat,.coveo-filetype-salesforce-standard-past-chat-small{background-color:#f88960;border-radius:2px}.coveo-filetype-salesforce-standard-feedback,.coveo-filetype-salesforce-standard-feedback-small,.coveo-icon.filetype.coveo-small.lithiummessage,.coveo-icon.filetype.coveo-small.Lithiummessage,.coveo-icon.filetype.coveo-small.lithiumthread,.coveo-icon.filetype.coveo-small.Lithiumthread,.coveo-icon.filetype.Lithiummessage,.coveo-icon.filetype.lithiummessage,.coveo-icon.filetype.Lithiumthread,.coveo-icon.filetype.lithiumthread,.coveo-icon.objecttype.casecomment,.coveo-icon.objecttype.Casecomment,.coveo-icon.objecttype.coveo-small.Casecomment,.coveo-icon.objecttype.coveo-small.casecomment,.coveo-icon.objecttype.coveo-small.Kbarticlecomment,.coveo-icon.objecttype.coveo-small.kbarticlecomment,.coveo-icon.objecttype.coveo-small.Thread,.coveo-icon.objecttype.coveo-small.thread,.coveo-icon.objecttype.kbarticlecomment,.coveo-icon.objecttype.Kbarticlecomment,.coveo-icon.objecttype.Thread,.coveo-icon.objecttype.thread{background-color:#6da1ea;border-radius:2px}.coveo-filetype-salesforce-standard-action-list-component,.coveo-filetype-salesforce-standard-action-list-component-small{background-color:#5876a3;border-radius:2px}.coveo-filetype-salesforce-standard-opportunity-splits,.coveo-filetype-salesforce-standard-opportunity-splits-small{background-color:#fcb95b;border-radius:2px}.coveo-filetype-salesforce-standard-messaging-user,.coveo-filetype-salesforce-standard-messaging-user-small{background-color:#34becd;border-radius:2px}.coveo-filetype-salesforce-standard-entitlements,.coveo-filetype-salesforce-standard-entitlements-small{background-color:#b781d3;border-radius:2px}.coveo-filetype-salesforce-standard-case-log-a-call,.coveo-filetype-salesforce-standard-case-log-a-call-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-thanks-loading,.coveo-filetype-salesforce-standard-thanks-loading-small{background-color:#b8c3ce;border-radius:2px}.coveo-filetype-salesforce-standard-channel-program-levels,.coveo-filetype-salesforce-standard-channel-program-levels-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-email-chatter,.coveo-filetype-salesforce-standard-email-chatter-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-announcement,.coveo-filetype-salesforce-standard-announcement-small{background-color:#62b7ed;border-radius:2px}.coveo-filetype-salesforce-standard-bot,.coveo-filetype-salesforce-standard-bot-small{background-color:#54698f;border-radius:2px}.coveo-filetype-salesforce-standard-macros,.coveo-filetype-salesforce-standard-macros-small{background-color:#47cfd2;border-radius:2px}.coveo-filetype-salesforce-standard-asset-relationship,.coveo-filetype-salesforce-standard-asset-relationship-small{background-color:#fa975c;border-radius:2px}.coveo-filetype-salesforce-standard-coaching,.coveo-filetype-salesforce-standard-coaching-small{background-color:#f67594;border-radius:2px}.coveo-filetype-salesforce-standard-search,.coveo-filetype-salesforce-standard-search-small{background-color:#62b7ed;border-radius:2px}.coveo-filetype-salesforce-standard-connected-apps,.coveo-filetype-salesforce-standard-connected-apps-small{background-color:#9895ee;border-radius:2px}.coveo-filetype-salesforce-standard-environment-hub,.coveo-filetype-salesforce-standard-environment-hub-small,.coveo-filetype-salesforce-standard-work-type,.coveo-filetype-salesforce-standard-work-type-small{background-color:#54698d;border-radius:2px}.coveo-filetype-salesforce-standard-cms,.coveo-filetype-salesforce-standard-cms-small{background-color:#88c651;border-radius:2px}.coveo-filetype-salesforce-standard-thanks,.coveo-filetype-salesforce-standard-thanks-small{background-color:#e9696e;border-radius:2px}.coveo-filetype-salesforce-standard-service-territory-member,.coveo-filetype-salesforce-standard-service-territory-member-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-campaign-members,.coveo-filetype-salesforce-standard-campaign-members-small{background-color:#f49756;border-radius:2px}.coveo-filetype-salesforce-standard-retail-banking,.coveo-filetype-salesforce-standard-retail-banking-small{background-color:#00d2be;border-radius:2px}.coveo-filetype-salesforce-standard-calibration,.coveo-filetype-salesforce-standard-calibration-small{background-color:#47cfd2;border-radius:2px}.coveo-filetype-salesforce-standard-answer-public,.coveo-filetype-salesforce-standard-answer-public-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-unmatched,.coveo-filetype-salesforce-standard-unmatched-small{background-color:#62b7ed;border-radius:2px}.coveo-filetype-salesforce-standard-partners,.coveo-filetype-salesforce-standard-partners-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-email-iq,.coveo-filetype-salesforce-standard-email-iq-small{background-color:#a094ed;border-radius:2px}.coveo-filetype-salesforce-standard-service-crew,.coveo-filetype-salesforce-standard-service-crew-small{background-color:#fa975c;border-radius:2px}.coveo-filetype-salesforce-standard-resource-capacity,.coveo-filetype-salesforce-standard-resource-capacity-small{background-color:#45c173;border-radius:2px}.coveo-filetype-salesforce-standard-channel-programs,.coveo-filetype-salesforce-standard-channel-programs-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-quip,.coveo-filetype-salesforce-standard-quip-small{background-color:#25b4e9;border-radius:2px}.coveo-filetype-salesforce-standard-quip-sheet,.coveo-filetype-salesforce-standard-quip-sheet-small{background-color:#30c85a;border-radius:2px}.coveo-filetype-salesforce-standard-timeslot,.coveo-filetype-salesforce-standard-timeslot-small{background-color:#fab24c;border-radius:2px}.coveo-filetype-salesforce-standard-live-chat,.coveo-filetype-salesforce-standard-live-chat-small{background-color:#f88960;border-radius:2px}.coveo-filetype-salesforce-standard-user,.coveo-filetype-salesforce-standard-user-small{background-color:#34becd;border-radius:2px}.coveo-filetype-salesforce-standard-client,.coveo-filetype-salesforce-standard-client-small{background-color:#00d2be;border-radius:2px}.coveo-filetype-salesforce-standard-portal,.coveo-filetype-salesforce-standard-portal-small{background-color:#aec770;border-radius:2px}.coveo-filetype-salesforce-standard-partner-fund-request,.coveo-filetype-salesforce-standard-partner-fund-request-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-resource-absence,.coveo-filetype-salesforce-standard-resource-absence-small,.coveo-filetype-salesforce-standard-resource-preference,.coveo-filetype-salesforce-standard-resource-preference-small{background-color:#45c173;border-radius:2px}.coveo-filetype-salesforce-standard-entitlement,.coveo-filetype-salesforce-standard-entitlement-small,.coveo-filetype-salesforce-standard-entitlement-template,.coveo-filetype-salesforce-standard-entitlement-template-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-empty,.coveo-filetype-salesforce-standard-empty-small{background-color:#8199af;border-radius:2px}.coveo-filetype-salesforce-standard-case-email,.coveo-filetype-salesforce-standard-case-email-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-account,.coveo-filetype-salesforce-standard-account-small,.coveo-icon.objecttype.Account,.coveo-icon.objecttype.account,.coveo-icon.objecttype.coveo-small.Account,.coveo-icon.objecttype.coveo-small.account{background-color:#7f8de1;border-radius:2px}.coveo-filetype-salesforce-standard-wealth-management-console,.coveo-filetype-salesforce-standard-wealth-management-console-small{background-color:#00afa0;border-radius:2px}.coveo-filetype-salesforce-standard-task2,.coveo-filetype-salesforce-standard-task2-small{background-color:#4bc076;border-radius:2px}.coveo-filetype-salesforce-standard-social,.coveo-filetype-salesforce-standard-social-small,.coveo-icon.objecttype.coveo-small.Socialprofile,.coveo-icon.objecttype.coveo-small.socialprofile,.coveo-icon.objecttype.Socialprofile,.coveo-icon.objecttype.socialprofile{background-color:#ea74a2;border-radius:2px}.coveo-filetype-salesforce-standard-endorsement,.coveo-filetype-salesforce-standard-endorsement-small,.coveo-filetype-salesforce-standard-folder,.coveo-filetype-salesforce-standard-folder-small{background-color:#8b9ae3;border-radius:2px}.coveo-filetype-salesforce-standard-service-crew-member,.coveo-filetype-salesforce-standard-service-crew-member-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-flow,.coveo-filetype-salesforce-standard-flow-small{background-color:#0079bc;border-radius:2px}.coveo-filetype-salesforce-standard-omni-supervisor,.coveo-filetype-salesforce-standard-omni-supervisor-small{background-color:#8a76f0;border-radius:2px}.coveo-filetype-salesforce-standard-product,.coveo-filetype-salesforce-standard-product-small,.coveo-icon.objecttype.coveo-small.Product,.coveo-icon.objecttype.coveo-small.product,.coveo-icon.objecttype.Product,.coveo-icon.objecttype.product{background-color:#b781d3;border-radius:2px}.coveo-filetype-salesforce-standard-topic,.coveo-filetype-salesforce-standard-topic-small,.coveo-icon.objecttype.coveo-small.Topic,.coveo-icon.objecttype.coveo-small.topic,.coveo-icon.objecttype.Topic,.coveo-icon.objecttype.topic{background-color:#56aadf;border-radius:2px}.coveo-filetype-salesforce-standard-product-required,.coveo-filetype-salesforce-standard-product-required-small{background-color:#ef6e64;border-radius:2px}.coveo-filetype-salesforce-standard-process,.coveo-filetype-salesforce-standard-process-small{background-color:#0079bc;border-radius:2px}.coveo-filetype-salesforce-standard-people,.coveo-filetype-salesforce-standard-people-small{background-color:#34becd;border-radius:2px}.coveo-filetype-salesforce-standard-reward,.coveo-filetype-salesforce-standard-reward-small{background-color:#e9696e;border-radius:2px}.coveo-filetype-salesforce-standard-performance,.coveo-filetype-salesforce-standard-performance-small{background-color:#f8b156;border-radius:2px}.coveo-filetype-salesforce-standard-case-comment,.coveo-filetype-salesforce-standard-case-comment-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-campaign,.coveo-filetype-salesforce-standard-campaign-small,.coveo-icon.objecttype.Campaign,.coveo-icon.objecttype.campaign,.coveo-icon.objecttype.coveo-small.Campaign,.coveo-icon.objecttype.coveo-small.campaign{background-color:#f49756;border-radius:2px}.coveo-filetype-salesforce-standard-business-hours,.coveo-filetype-salesforce-standard-business-hours-small{background-color:#7dc37d;border-radius:2px}.coveo-filetype-salesforce-standard-evernote,.coveo-filetype-salesforce-standard-evernote-small{background-color:#86c86f;border-radius:2px}.coveo-filetype-salesforce-standard-service-territory,.coveo-filetype-salesforce-standard-service-territory-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-case,.coveo-filetype-salesforce-standard-case-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-record,.coveo-filetype-salesforce-standard-record-small{background-color:#7dc37d;border-radius:2px}.coveo-filetype-salesforce-standard-contract-line-item,.coveo-filetype-salesforce-standard-contract-line-item-small{background-color:#6ec06e;border-radius:2px}.coveo-filetype-salesforce-standard-skill-entity,.coveo-filetype-salesforce-standard-skill-entity-small{background-color:#8b9ae3;border-radius:2px}.coveo-filetype-salesforce-standard-skill,.coveo-filetype-salesforce-standard-skill-small{background-color:#fa975c;border-radius:2px}.coveo-filetype-salesforce-standard-operating-hours,.coveo-filetype-salesforce-standard-operating-hours-small{background-color:#6b9ee2;border-radius:2px}.coveo-filetype-salesforce-standard-custom,.coveo-filetype-salesforce-standard-custom-small{background-color:#8199af;border-radius:2px}.coveo-filetype-salesforce-standard-related-list,.coveo-filetype-salesforce-standard-related-list-small,.coveo-icon.filetype.coveo-small.lithiumcategory,.coveo-icon.filetype.coveo-small.Lithiumcategory,.coveo-icon.filetype.coveo-small.saleforceitem,.coveo-icon.filetype.coveo-small.Saleforceitem,.coveo-icon.filetype.coveo-small.spwikipagelibrarylist,.coveo-icon.filetype.coveo-small.Spwikipagelibrarylist,.coveo-icon.filetype.lithiumcategory,.coveo-icon.filetype.Lithiumcategory,.coveo-icon.filetype.saleforceitem,.coveo-icon.filetype.Saleforceitem,.coveo-icon.filetype.spwikipagelibrarylist,.coveo-icon.filetype.Spwikipagelibrarylist,.coveo-icon.objecttype.coveo-small.List,.coveo-icon.objecttype.coveo-small.list,.coveo-icon.objecttype.List,.coveo-icon.objecttype.list{background-color:#59bcab;border-radius:2px}.coveo-filetype-salesforce-standard-case-change-status,.coveo-filetype-salesforce-standard-case-change-status-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-insurance-console,.coveo-filetype-salesforce-standard-insurance-console-small{background-color:#00afa0;border-radius:2px}.coveo-filetype-salesforce-standard-contract,.coveo-filetype-salesforce-standard-contract-small,.coveo-icon.objecttype.Contract,.coveo-icon.objecttype.contract,.coveo-icon.objecttype.coveo-small.Contract,.coveo-icon.objecttype.coveo-small.contract{background-color:#6ec06e;border-radius:2px}.coveo-filetype-salesforce-standard-photo,.coveo-filetype-salesforce-standard-photo-small{background-color:#d7d1d1;border-radius:2px}.coveo-filetype-salesforce-standard-apps,.coveo-filetype-salesforce-standard-apps-small{background-color:#3c97dd;border-radius:2px}.coveo-filetype-salesforce-standard-timesheet,.coveo-filetype-salesforce-standard-timesheet-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-drafts,.coveo-filetype-salesforce-standard-drafts-small{background-color:#6ca1e9;border-radius:2px}.coveo-filetype-salesforce-standard-work-order-item,.coveo-filetype-salesforce-standard-work-order-item-small{background-color:#33a8dc;border-radius:2px}.coveo-filetype-salesforce-standard-pricebook,.coveo-filetype-salesforce-standard-pricebook-small{background-color:#b781d3;border-radius:2px}.coveo-filetype-salesforce-standard-scan-card,.coveo-filetype-salesforce-standard-scan-card-small{background-color:#f39e58;border-radius:2px}.coveo-filetype-salesforce-standard-note,.coveo-filetype-salesforce-standard-note-small,.coveo-icon.objecttype.coveo-small.Note,.coveo-icon.objecttype.coveo-small.note,.coveo-icon.objecttype.Note,.coveo-icon.objecttype.note{background-color:#e6d478;border-radius:2px}.coveo-filetype-salesforce-standard-opportunity,.coveo-filetype-salesforce-standard-opportunity-small,.coveo-icon.objecttype.coveo-small.Opportunity,.coveo-icon.objecttype.coveo-small.opportunity,.coveo-icon.objecttype.coveo-small.Opportunityproduct,.coveo-icon.objecttype.coveo-small.opportunityproduct,.coveo-icon.objecttype.Opportunity,.coveo-icon.objecttype.opportunity,.coveo-icon.objecttype.Opportunityproduct,.coveo-icon.objecttype.opportunityproduct{background-color:#fcb95b;border-radius:2px}.coveo-filetype-salesforce-standard-news,.coveo-filetype-salesforce-standard-news-small{background-color:#7f8de1;border-radius:2px}.coveo-filetype-salesforce-standard-call-history,.coveo-filetype-salesforce-standard-call-history-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-report,.coveo-filetype-salesforce-standard-report-small,.coveo-icon.objecttype.coveo-small.Report,.coveo-icon.objecttype.coveo-small.report,.coveo-icon.objecttype.Report,.coveo-icon.objecttype.report{background-color:#2ecbbe;border-radius:2px}.coveo-filetype-salesforce-standard-groups,.coveo-filetype-salesforce-standard-groups-small,.coveo-icon.filetype.coveo-small.Lithiumboard,.coveo-icon.filetype.coveo-small.lithiumboard,.coveo-icon.filetype.Lithiumboard,.coveo-icon.filetype.lithiumboard,.coveo-icon.objecttype.Collaborationgroup,.coveo-icon.objecttype.collaborationgroup,.coveo-icon.objecttype.coveo-small.Collaborationgroup,.coveo-icon.objecttype.coveo-small.collaborationgroup{background-color:#779ef2;border-radius:2px}.coveo-filetype-salesforce-standard-dashboard,.coveo-filetype-salesforce-standard-dashboard-small,.coveo-icon.objecttype.coveo-small.Dashboard,.coveo-icon.objecttype.coveo-small.dashboard,.coveo-icon.objecttype.Dashboard,.coveo-icon.objecttype.dashboard{background-color:#ef6e64;border-radius:2px}.coveo-filetype-salesforce-standard-generic-loading,.coveo-filetype-salesforce-standard-generic-loading-small{background-color:#b8c3ce;border-radius:2px}.coveo-filetype-salesforce-standard-address,.coveo-filetype-salesforce-standard-address-small{background-color:#4bc076;border-radius:2px}.coveo-filetype-salesforce-standard-entity-milestone,.coveo-filetype-salesforce-standard-entity-milestone-small{background-color:#f49756;border-radius:2px}.coveo-filetype-salesforce-standard-wealth-management,.coveo-filetype-salesforce-standard-wealth-management-small{background-color:#00d2be;border-radius:2px}.coveo-filetype-salesforce-standard-customers,.coveo-filetype-salesforce-standard-customers-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-service-appointment,.coveo-filetype-salesforce-standard-service-appointment-small,.coveo-icon.objecttype.Appointment,.coveo-icon.objecttype.appointment,.coveo-icon.objecttype.coveo-small.Appointment,.coveo-icon.objecttype.coveo-small.appointment{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-data-integration-hub,.coveo-filetype-salesforce-standard-data-integration-hub-small,.coveo-filetype-salesforce-standard-maintenance-plan,.coveo-filetype-salesforce-standard-maintenance-plan-small{background-color:#2a739e;border-radius:2px}.coveo-filetype-salesforce-standard-hierarchy,.coveo-filetype-salesforce-standard-hierarchy-small{background-color:#34becd;border-radius:2px}.coveo-filetype-salesforce-standard-partner-marketing-budget,.coveo-filetype-salesforce-standard-partner-marketing-budget-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-skill-requirement,.coveo-filetype-salesforce-standard-skill-requirement-small{background-color:#fa975c;border-radius:2px}.coveo-filetype-salesforce-standard-location,.coveo-filetype-salesforce-standard-location-small{background-color:#4bc076;border-radius:2px}.coveo-filetype-salesforce-standard-avatar-loading,.coveo-filetype-salesforce-standard-avatar-loading-small{background-color:#b8c3ce;border-radius:2px}.coveo-filetype-salesforce-standard-article,.coveo-filetype-salesforce-standard-article-small,.coveo-icon.filetype.Cfpage,.coveo-icon.filetype.cfpage,.coveo-icon.filetype.coveo-small.cfpage,.coveo-icon.filetype.coveo-small.Cfpage,.coveo-icon.objecttype.coveo-small.kbarticle,.coveo-icon.objecttype.coveo-small.Kbarticle,.coveo-icon.objecttype.coveo-small.knowledgearticle,.coveo-icon.objecttype.coveo-small.Knowledgearticle,.coveo-icon.objecttype.coveo-small.Salesliterature,.coveo-icon.objecttype.coveo-small.salesliterature,.coveo-icon.objecttype.Kbarticle,.coveo-icon.objecttype.kbarticle,.coveo-icon.objecttype.knowledgearticle,.coveo-icon.objecttype.Knowledgearticle,.coveo-icon.objecttype.Salesliterature,.coveo-icon.objecttype.salesliterature{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-log-a-call,.coveo-filetype-salesforce-standard-log-a-call-small{background-color:#48c3cc;border-radius:2px}.coveo-filetype-salesforce-standard-quotes,.coveo-filetype-salesforce-standard-quotes-small,.coveo-icon.objecttype.coveo-small.Quote,.coveo-icon.objecttype.coveo-small.quote,.coveo-icon.objecttype.Quote,.coveo-icon.objecttype.quote{background-color:#88c651;border-radius:2px}.coveo-filetype-salesforce-standard-merge,.coveo-filetype-salesforce-standard-merge-small,.coveo-filetype-salesforce-standard-question-feed,.coveo-filetype-salesforce-standard-question-feed-small,.coveo-icon.filetype.Cfcomment,.coveo-icon.filetype.cfcomment,.coveo-icon.filetype.coveo-small.Cfcomment,.coveo-icon.filetype.coveo-small.cfcomment{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-product-consumed,.coveo-filetype-salesforce-standard-product-consumed-small{background-color:#55bc9c;border-radius:2px}.coveo-filetype-salesforce-standard-canvas,.coveo-filetype-salesforce-standard-canvas-small{background-color:#8199af;border-radius:2px}.coveo-filetype-salesforce-standard-forecasts,.coveo-filetype-salesforce-standard-forecasts-small{background-color:#6bbd6e;border-radius:2px}.coveo-filetype-salesforce-standard-relationship,.coveo-filetype-salesforce-standard-relationship-small{background-color:#3c97dd;border-radius:2px}.coveo-filetype-salesforce-standard-service-resource,.coveo-filetype-salesforce-standard-service-resource-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-sales-path,.coveo-filetype-salesforce-standard-sales-path-small{background-color:#2a739e;border-radius:2px}.coveo-filetype-salesforce-standard-rtc-presence,.coveo-filetype-salesforce-standard-rtc-presence-small{background-color:#47cfd2;border-radius:2px}.coveo-filetype-salesforce-standard-avatar,.coveo-filetype-salesforce-standard-avatar-small{background-color:#62b7ed;border-radius:2px}.coveo-filetype-salesforce-standard-solution,.coveo-filetype-salesforce-standard-solution-small,.coveo-icon.objecttype.coveo-small.Kbsolution,.coveo-icon.objecttype.coveo-small.kbsolution,.coveo-icon.objecttype.coveo-small.Solution,.coveo-icon.objecttype.coveo-small.solution,.coveo-icon.objecttype.Kbsolution,.coveo-icon.objecttype.kbsolution,.coveo-icon.objecttype.Solution,.coveo-icon.objecttype.solution{background-color:#8fc972;border-radius:2px}.coveo-filetype-salesforce-standard-partner-fund-claim,.coveo-filetype-salesforce-standard-partner-fund-claim-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-individual,.coveo-filetype-salesforce-standard-individual-small{background-color:#3c97dd;border-radius:2px}.coveo-filetype-salesforce-standard-custom-notification,.coveo-filetype-salesforce-standard-custom-notification-small{background-color:#6bb7e4;border-radius:2px}.coveo-filetype-salesforce-standard-template,.coveo-filetype-salesforce-standard-template-small{background-color:#3c97dd;border-radius:2px}.coveo-filetype-salesforce-standard-shipment,.coveo-filetype-salesforce-standard-shipment-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-event,.coveo-filetype-salesforce-standard-event-small,.coveo-icon.objecttype.coveo-small.Event,.coveo-icon.objecttype.coveo-small.event,.coveo-icon.objecttype.Event,.coveo-icon.objecttype.event{background-color:#eb7092;border-radius:2px}.coveo-filetype-salesforce-standard-insurance,.coveo-filetype-salesforce-standard-insurance-small{background-color:#00d2be;border-radius:2px}.coveo-filetype-salesforce-standard-live-chat-visitor,.coveo-filetype-salesforce-standard-live-chat-visitor-small{background-color:#f68960;border-radius:2px}.coveo-filetype-salesforce-standard-survey,.coveo-filetype-salesforce-standard-survey-small{background-color:#319fd6;border-radius:2px}.coveo-filetype-salesforce-standard-link,.coveo-filetype-salesforce-standard-link-small{background-color:#7a9ae6;border-radius:2px}.coveo-filetype-salesforce-standard-messaging-session,.coveo-filetype-salesforce-standard-messaging-session-small{background-color:#34becd;border-radius:2px}.coveo-filetype-salesforce-standard-list-email,.coveo-filetype-salesforce-standard-list-email-small{background-color:#8baeb5;border-radius:2px}.coveo-filetype-salesforce-standard-document,.coveo-filetype-salesforce-standard-document-small{background-color:#baac93;border-radius:2px}.coveo-filetype-salesforce-standard-product-transfer,.coveo-filetype-salesforce-standard-product-transfer-small{background-color:#f88962;border-radius:2px}.coveo-filetype-salesforce-standard-recent,.coveo-filetype-salesforce-standard-recent-small{background-color:#6ca1e9;border-radius:2px}.coveo-filetype-salesforce-standard-insights,.coveo-filetype-salesforce-standard-insights-small,.coveo-icon.filetype.Cfblogentry,.coveo-icon.filetype.cfblogentry,.coveo-icon.filetype.coveo-small.Cfblogentry,.coveo-icon.filetype.coveo-small.cfblogentry{background-color:#ec94ed;border-radius:2px}.coveo-filetype-salesforce-standard-dropbox,.coveo-filetype-salesforce-standard-dropbox-small{background-color:#52aef9;border-radius:2px}.coveo-filetype-salesforce-standard-file,.coveo-filetype-salesforce-standard-file-small,.coveo-icon.objecttype.Annotation,.coveo-icon.objecttype.annotation,.coveo-icon.objecttype.coveo-small.Annotation,.coveo-icon.objecttype.coveo-small.annotation,.coveo-icon.objecttype.coveo-small.File,.coveo-icon.objecttype.coveo-small.file,.coveo-icon.objecttype.File,.coveo-icon.objecttype.file{background-color:#baac93;border-radius:2px}.coveo-filetype-salesforce-standard-team-member,.coveo-filetype-salesforce-standard-team-member-small,.coveo-icon.filetype.coveo-small.Lithiumcommunity,.coveo-icon.filetype.coveo-small.lithiumcommunity,.coveo-icon.filetype.Lithiumcommunity,.coveo-icon.filetype.lithiumcommunity{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-group-loading,.coveo-filetype-salesforce-standard-group-loading-small{background-color:#b8c3ce;border-radius:2px}.coveo-filetype-salesforce-standard-lead,.coveo-filetype-salesforce-standard-lead-small,.coveo-icon.objecttype.coveo-small.Lead,.coveo-icon.objecttype.coveo-small.lead,.coveo-icon.objecttype.Lead,.coveo-icon.objecttype.lead{background-color:#f88962;border-radius:2px}.coveo-filetype-salesforce-standard-email,.coveo-filetype-salesforce-standard-email-small{background-color:#95aec5;border-radius:2px}.coveo-filetype-salesforce-standard-service-contract,.coveo-filetype-salesforce-standard-service-contract-small,.coveo-icon.objecttype.coveo-small.Service,.coveo-icon.objecttype.coveo-small.service,.coveo-icon.objecttype.Service,.coveo-icon.objecttype.service{background-color:#8a76f0;border-radius:2px}.coveo-filetype-salesforce-standard-entitlement-process,.coveo-filetype-salesforce-standard-entitlement-process-small{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-contact-list,.coveo-filetype-salesforce-standard-contact-list-small{background-color:#a094ed;border-radius:2px}.coveo-filetype-salesforce-standard-channel-program-history,.coveo-filetype-salesforce-standard-channel-program-history-small{background-color:#0eb58a;border-radius:2px}.coveo-filetype-salesforce-standard-question-best,.coveo-filetype-salesforce-standard-question-best-small{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-knowledge,.coveo-filetype-salesforce-standard-knowledge-small,.coveo-icon.objecttype.coveo-small.Kbdocumentation,.coveo-icon.objecttype.coveo-small.kbdocumentation,.coveo-icon.objecttype.coveo-small.Kbknowledgearticle,.coveo-icon.objecttype.coveo-small.kbknowledgearticle,.coveo-icon.objecttype.coveo-small.Kbtechnicalarticle,.coveo-icon.objecttype.coveo-small.kbtechnicalarticle,.coveo-icon.objecttype.Kbdocumentation,.coveo-icon.objecttype.kbdocumentation,.coveo-icon.objecttype.kbknowledgearticle,.coveo-icon.objecttype.Kbknowledgearticle,.coveo-icon.objecttype.Kbtechnicalarticle,.coveo-icon.objecttype.kbtechnicalarticle{background-color:#ec94ed;border-radius:2px}.coveo-filetype-salesforce-standard-lead-insights,.coveo-filetype-salesforce-standard-lead-insights-small{background-color:#22b0e6;border-radius:2px}.coveo-filetype-salesforce-standard-concur,.coveo-filetype-salesforce-standard-concur-small{background-color:#4cc3c7;border-radius:2px}.coveo-filetype-salesforce-standard-feed,.coveo-filetype-salesforce-standard-feed-small,.coveo-icon.filetype.coveo-small.Rssitem,.coveo-icon.filetype.coveo-small.rssitem,.coveo-icon.filetype.Rssitem,.coveo-icon.filetype.rssitem,.coveo-icon.objecttype.coveo-small.Feed,.coveo-icon.objecttype.coveo-small.feed,.coveo-icon.objecttype.Feed,.coveo-icon.objecttype.feed{background-color:#62b7ed;border-radius:2px}.coveo-filetype-salesforce-standard-messaging-conversation,.coveo-filetype-salesforce-standard-messaging-conversation-small{background-color:#34becd;border-radius:2px}.coveo-filetype-salesforce-standard-service-report,.coveo-filetype-salesforce-standard-service-report-small,.coveo-icon.filetype.coveo-small.Jiraissue,.coveo-icon.filetype.coveo-small.jiraissue,.coveo-icon.filetype.Jiraissue,.coveo-icon.filetype.jiraissue{background-color:#7e8be4;border-radius:2px}.coveo-filetype-salesforce-standard-call,.coveo-filetype-salesforce-standard-call-small,.coveo-icon.objecttype.coveo-small.Phonecall,.coveo-icon.objecttype.coveo-small.phonecall,.coveo-icon.objecttype.Phonecall,.coveo-icon.objecttype.phonecall{background-color:#f2cf5b;border-radius:2px}.coveo-filetype-salesforce-standard-stage,.coveo-filetype-salesforce-standard-stage-small{background-color:#ff9a3c;border-radius:2px}.coveo-filetype-salesforce-standard-product-request-line-item,.coveo-filetype-salesforce-standard-product-request-line-item-small{background-color:#88c651;border-radius:2px}.coveo-filetype-salesforce-standard-return-order-line-item,.coveo-filetype-salesforce-standard-return-order-line-item-small{background-color:#009688;border-radius:2px}.coveo-filetype-salesforce-standard-quick-text,.coveo-filetype-salesforce-standard-quick-text-small{background-color:#62b7e5;border-radius:2px}.coveo-filetype-salesforce-standard-home,.coveo-filetype-salesforce-standard-home-small{background-color:#ef7ead;border-radius:2px}.coveo-filetype-salesforce-standard-sossession,.coveo-filetype-salesforce-standard-sossession-small{background-color:#54698d;border-radius:2px}.coveo-filetype-salesforce-standard-stage-collection,.coveo-filetype-salesforce-standard-stage-collection-small{background-color:#ff9a3c;border-radius:2px}.coveo-filetype-salesforce-standard-product-request,.coveo-filetype-salesforce-standard-product-request-small{background-color:#88c651;border-radius:2px}.coveo-filetype-salesforce-standard-logging,.coveo-filetype-salesforce-standard-logging-small{background-color:#00a1df;border-radius:2px}.coveo-filetype-salesforce-standard-assigned-resource,.coveo-filetype-salesforce-standard-assigned-resource-small{background-color:#45c173;border-radius:2px}.coveo-filetype-salesforce-standard-return-order,.coveo-filetype-salesforce-standard-return-order-small{background-color:#009688;border-radius:2px}.coveo-filetype-salesforce-standard-poll,.coveo-filetype-salesforce-standard-poll-small{background-color:#699be1;border-radius:2px}.coveo-filetype-salesforce-standard-household,.coveo-filetype-salesforce-standard-household-small{background-color:#00afa0;border-radius:2px}.coveo-icon{position:relative}.coveo-icon .coveo-icon-caption-overlay{display:none}.coveo-icon.filetype.Cfblogentry .coveo-icon-caption-overlay,.coveo-icon.filetype.cfblogentry .coveo-icon-caption-overlay,.coveo-icon.filetype.cfcomment .coveo-icon-caption-overlay,.coveo-icon.filetype.Cfcomment .coveo-icon-caption-overlay,.coveo-icon.filetype.Cfpage .coveo-icon-caption-overlay,.coveo-icon.filetype.cfpage .coveo-icon-caption-overlay,.coveo-icon.filetype.Cfspace .coveo-icon-caption-overlay,.coveo-icon.filetype.cfspace .coveo-icon-caption-overlay,.coveo-icon.filetype.confluencespace .coveo-icon-caption-overlay,.coveo-icon.filetype.Confluencespace .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.cfblogentry .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.Cfblogentry .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.Cfcomment .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.cfcomment .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.Cfpage .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.cfpage .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.cfspace .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.Cfspace .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.Confluencespace .coveo-icon-caption-overlay,.coveo-icon.filetype.coveo-small.confluencespace .coveo-icon-caption-overlay{display:block}.coveo-icon-caption-overlay{background-color:#fff;border:thin solid #bcc3ca;border-radius:2px;font-size:11px;position:absolute;top:-16px;left:-10px;text-indent:0;padding:2px;color:#67768b;width:60px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.coveo-icon.coveo-small .coveo-icon-caption-overlay{width:40px;top:-18px;left:-10px}.coveo-icon[data-with-label=true] .coveo-icon-caption-overlay{display:block}.coveo-icon[data-with-label=true].coveo-small .coveo-icon-caption-overlay{display:none}.CoveoIcon.coveo-icon .CoveoQuickview,.CoveoIcon.coveo-icon.filetype .CoveoQuickview,.CoveoIcon.coveo-icon.objecttype .CoveoQuickview,.CoveoIcon.coveo-icon.sysfiletype .CoveoQuickview,.CoveoIcon .CoveoQuickview{position:absolute;text-indent:0;left:2px;right:2px;position:\"absolute\";top:50%;transform:translateY(-50%);display:none}.CoveoIcon.coveo-icon.filetype:hover.coveo-with-quickview,.CoveoIcon.coveo-icon.objecttype:hover.coveo-with-quickview,.CoveoIcon.coveo-icon.sysfiletype:hover.coveo-with-quickview,.CoveoIcon.coveo-icon:hover.coveo-with-quickview,.CoveoIcon:hover.coveo-with-quickview{background-image:none;border:thin solid #bcc3ca;border-radius:2px;background-color:#f7f8f9}.CoveoIcon.coveo-icon.filetype:hover.coveo-with-quickview .CoveoQuickview,.CoveoIcon.coveo-icon.objecttype:hover.coveo-with-quickview .CoveoQuickview,.CoveoIcon.coveo-icon.sysfiletype:hover.coveo-with-quickview .CoveoQuickview,.CoveoIcon.coveo-icon:hover.coveo-with-quickview .CoveoQuickview,.CoveoIcon:hover.coveo-with-quickview .CoveoQuickview{display:block}.coveo-btn,.CoveoIcon.coveo-icon.filetype:hover.coveo-with-quickview .CoveoQuickview:hover,.CoveoIcon.coveo-icon.objecttype:hover.coveo-with-quickview .CoveoQuickview:hover,.CoveoIcon.coveo-icon.sysfiletype:hover.coveo-with-quickview .CoveoQuickview:hover,.CoveoIcon.coveo-icon:hover.coveo-with-quickview .CoveoQuickview:hover,.CoveoIcon:hover.coveo-with-quickview .CoveoQuickview:hover{text-decoration:none}.coveo-btn{display:inline-block;height:34px;padding:8.5px 16px;color:#1d4f76;font-family:Lato,Arial,Helvetica,sans-serif;font-size:12px;font-weight:700;line-height:15px;text-overflow:ellipsis;text-transform:uppercase;vertical-align:middle;white-space:nowrap;background-color:#fff;border:1px solid #bcc3ca;border-radius:2px;cursor:pointer}.coveo-btn .coveo-icon{fill:#1d4f76}.coveo-btn:focus,.coveo-btn:hover{text-decoration:none}.coveo-btn:focus{background-color:#e6ecf0;outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.coveo-btn.coveo-state-disabled,.coveo-btn:disabled{color:#bcc3ca;cursor:default}.coveo-btn.coveo-mod-small{height:24px;padding:0 10px;font-size:11px;line-height:14px}.coveo-btn.coveo-mod-large{height:50px}.coveo-btn.coveo-mod-primary{color:#fff;background-color:#f58020;border:1px solid #f58020}.coveo-btn.coveo-mod-primary:focus,.coveo-btn.coveo-mod-primary:hover{background-color:#f68e38;border:1px solid #f68e38}.coveo-btn.coveo-mod-primary.coveo-state-disabled,.coveo-btn.coveo-mod-primary:disabled{background-color:#f9b882;border:1px solid #f9b882}.coveo-btn.coveo-mod-primary .coveo-icon{fill:#fff}.coveo-btn.coveo-mod-danger{color:#fff;background-color:#ce3f00;border:1px solid #ce3f00}.coveo-btn.coveo-mod-danger:focus,.coveo-btn.coveo-mod-danger:hover{background-color:#e84700;border:1px solid #e84700}.coveo-btn.coveo-mod-danger.coveo-state-disabled,.coveo-btn.coveo-mod-danger:disabled{background-color:#ff7335;border:1px solid #ff7335}.coveo-btn.coveo-mod-danger .coveo-icon{fill:#fff}.coveo-btn.coveo-mod-link{background-color:transparent;border:none}.coveo-btn+.coveo-btn,.coveo-btn+.coveo-btn-container{margin-left:10px}.coveo-btn .coveo-confirm-icon-error,.coveo-btn .coveo-confirm-icon-success{display:none}.coveo-btn.coveo-mod-confirm-error,.coveo-btn.coveo-mod-confirm-success{position:relative;color:transparent;outline:0;transition:background-color .2s ease;user-select:none}.coveo-btn.coveo-mod-confirm-error:before,.coveo-btn.coveo-mod-confirm-success:before{position:absolute;top:40px;font-size:11px;text-transform:none;animation:coveo-vp-fadeIn ease-in 1;animation-duration:.3s;animation-fill-mode:forwards;opacity:0}.coveo-btn.coveo-mod-confirm-error.coveo-mod-confirm-right:before,.coveo-btn.coveo-mod-confirm-success.coveo-mod-confirm-right:before{right:0}.coveo-btn.coveo-mod-confirm-error.coveo-mod-confirm-left:before,.coveo-btn.coveo-mod-confirm-success.coveo-mod-confirm-left:before{left:0}.coveo-btn.coveo-mod-confirm-error .coveo-confirm-icon-error,.coveo-btn.coveo-mod-confirm-error .coveo-confirm-icon-success,.coveo-btn.coveo-mod-confirm-success .coveo-confirm-icon-error,.coveo-btn.coveo-mod-confirm-success .coveo-confirm-icon-success{position:absolute;top:calc(50% - 15px / 2);right:calc(50% - 15px / 2);display:inline-block;font-size:15px;fill:#fff}.coveo-btn.coveo-mod-confirm{margin-bottom:20px}.coveo-btn.coveo-mod-confirm-success{background-color:#009830;border:1px solid #009830}.coveo-btn.coveo-mod-confirm-success:focus,.coveo-btn.coveo-mod-confirm-success:hover{background-color:#009830}.coveo-btn.coveo-mod-confirm-success:before{color:#009830;content:attr(data-confirm-success)}.coveo-btn.coveo-mod-confirm-success .coveo-confirm-icon-error{display:none}.coveo-btn.coveo-mod-confirm-error{background-color:#ce3f00;border:1px solid #ce3f00}.coveo-btn.coveo-mod-confirm-error:focus,.coveo-btn.coveo-mod-confirm-error:hover{background-color:#ce3f00}.coveo-btn.coveo-mod-confirm-error:before{color:#ce3f00;content:attr(data-confirm-error)}.coveo-btn.coveo-mod-confirm-error .coveo-confirm-icon-success{display:none}.coveo-btn-container{display:inline-block;margin:0}.coveo-btn-container .coveo-btn[disabled]{pointer-events:none}.coveo-btn-container+.coveo-btn,.coveo-btn-container+.coveo-btn-container{margin-left:10px}.coveo-modal-backdrop,.coveo-modal-container{position:fixed;top:0;right:0;bottom:0;left:0;width:100%;height:100%;overflow:hidden}.coveo-modal-backdrop{z-index:1049;background:#1d4f76;transition:all .3s;opacity:.9}.coveo-modal-backdrop.coveo-layer-1{z-index:1049}.coveo-modal-backdrop.coveo-layer-2{z-index:1069}.coveo-modal-backdrop.coveo-layer-3{z-index:1089}.coveo-modal-backdrop.coveo-layer-4{z-index:1109}.coveo-modal-backdrop.coveo-layer-5{z-index:1129}.coveo-modal-backdrop.coveo-layer-6{z-index:1149}.coveo-modal-backdrop.coveo-layer-7{z-index:1169}.coveo-modal-backdrop.coveo-layer-8{z-index:1189}.coveo-modal-backdrop.coveo-layer-9{z-index:1209}.coveo-modal-backdrop.coveo-layer-10{z-index:1229}.coveo-modal-backdrop.coveo-prompt-backdrop{position:absolute;opacity:.5}.coveo-modal-backdrop.coveo-prompt-backdrop .coveo-mask{position:fixed;top:0;right:0;bottom:0;left:0}.coveo-modal-backdrop.coveo-clear,.coveo-modal-backdrop.coveo-closed{opacity:0}.coveo-modal-backdrop.coveo-closed{visibility:hidden}.coveo-modal-container{align-items:center;justify-content:center;z-index:1050;display:flex;visibility:hidden;pointer-events:none}.coveo-modal-container.coveo-layer-1{z-index:1050}.coveo-modal-container.coveo-layer-2{z-index:1070}.coveo-modal-container.coveo-layer-3{z-index:1090}.coveo-modal-container.coveo-layer-4{z-index:1110}.coveo-modal-container.coveo-layer-5{z-index:1130}.coveo-modal-container.coveo-layer-6{z-index:1150}.coveo-modal-container.coveo-layer-7{z-index:1170}.coveo-modal-container.coveo-layer-8{z-index:1190}.coveo-modal-container.coveo-layer-9{z-index:1210}.coveo-modal-container.coveo-layer-10{z-index:1230}.coveo-modal-container.coveo-opened,.coveo-modal-container.coveo-opening{visibility:visible}.coveo-modal-container.coveo-opened>.coveo-modal-content,.coveo-modal-container.coveo-opening>.coveo-modal-content{opacity:1}.coveo-modal-container .coveo-modal-content{position:relative;flex-direction:column;display:flex;width:45%;height:50%;opacity:0;pointer-events:auto}.coveo-modal-container.coveo-mod-medium>.coveo-modal-content{width:65%;height:70%}.coveo-modal-container.coveo-mod-big>.coveo-modal-content{width:85%;height:90%}.coveo-modal-container.coveo-mod-width-small>.coveo-modal-content{width:520px}.coveo-modal-container.coveo-mod-stick-bottom{align-items:flex-end}.coveo-modal-container.coveo-mod-stick-bottom>.coveo-modal-content{height:55%}.coveo-modal-container.coveo-mod-stick-bottom>.coveo-modal-content>.coveo-modal-footer{border-radius:0}.coveo-modal-container.coveo-mod-stick-bottom.coveo-mod-medium>.coveo-modal-content{height:75%}.coveo-modal-container.coveo-mod-stick-bottom.coveo-mod-big>.coveo-modal-content{height:95%}.coveo-modal-container.coveo-mod-fade-in-scale>.coveo-modal-content{transform:scale(.7);transition:all .3s}.coveo-modal-container.coveo-opened.coveo-mod-fade-in-scale>.coveo-modal-content{transform:scale(1)}.coveo-modal-container.coveo-mod-slide-in-bottom>.coveo-modal-content{transform:translate3d(0,20%,0);transition:all .3s}.coveo-modal-container.coveo-opened.coveo-mod-slide-in-bottom>.coveo-modal-content{transform:translateZ(0)}.coveo-modal-header{align-items:center;display:flex;height:100px;padding:0 40px;color:#fff;background-color:#fff;border-bottom:1px solid #bcc3ca;border-radius:2px 2px 0 0}.coveo-modal-header.coveo-mod-confirmation{background-color:#ecad00}.coveo-modal-header.coveo-mod-warning{background-color:#ce3f00}.coveo-modal-header.coveo-mod-info{background-color:#1d4f76}.coveo-modal-header h1{flex-grow:1;overflow:hidden;color:#1d4f76;line-height:30px;text-overflow:ellipsis;white-space:nowrap}.coveo-modal-header .coveo-small-close{top:-2.10256em}.coveo-modal-header .coveo-small-close,.coveo-modal-header .coveo-small-close .coveo-icon{width:1.33333em;height:1.33333em}.coveo-modal-body{flex-basis:0;flex-grow:1;overflow:auto;background-color:#fff}.coveo-modal-footer{align-items:center;justify-content:flex-end;display:flex;padding:24px 40px;overflow:hidden;background-color:#f1f3f4;border-top:1px solid #bcc3ca;border-radius:0 0 2px 2px}.coveo-modal-footer.coveo-mod-small{padding:12px 20px}.coveo-modal-header .coveo-small-close{position:absolute;top:-1.7em;right:0;cursor:pointer}@media (max-height:500px){.coveo-modal-header .coveo-small-close{right:-1.7em;top:0}}.coveo-fill-pure-white{fill:#fff}.coveo-modal-container{font-family:Lato,Arial,Helvetica,sans-serif;box-sizing:border-box}.coveo-modal-container *{box-sizing:border-box}.coveo-modal-container .coveo-modal-content{transform:scale(.7);transition:all .3s}.coveo-modal-container .coveo-modal-content .coveo-media-max-width-800{width:85%;height:90%}@media (max-width:800px){.coveo-modal-container .coveo-modal-content{width:85%;height:90%}}.coveo-modal-container.coveo-mod-fade-in-scale .coveo-modal-content{transform:scale(1)}.coveo-modal-transparent{opacity:0}.coveo-modal-header h1{line-height:inherit;font-size:24px;font-weight:400}.coveo-modal-header{padding:0 20px;height:80px}.coveo-modal-header .coveo-media-max-width-480{height:50px}@media (max-width:480px){.coveo-modal-header{height:50px}}.coveo-modal-body{padding:10px 20px}.coveo-modalBox>.coveo-wrapper>.coveo-title{height:40px;line-height:23px;text-align:center;cursor:pointer}.coveo-modalBox>.coveo-wrapper>.coveo-title .coveo-close-button{position:absolute;left:25px;display:inline-block}.coveo-modalBox>.coveo-wrapper>.coveo-title .coveo-close-button .coveo-icon{margin-right:10px}.coveo-modalBox>.coveo-wrapper>.coveo-title .coveo-pop-up-reminder{color:#b4b4b4;font-weight:400;display:inline-block}.coveo-logo{display:inline-block}.coveo-powered-by-svg{width:100px;height:28px}.CoveoLogo{float:right;display:inline-block;margin:0 0 0 20px}.CoveoLogo.coveo-hidden{display:none}@media (max-width:970px){.CoveoLogo{position:absolute;right:10px;bottom:-30px}}@media (max-width:970px){.coveo-waiting-for-first-query .CoveoLogo{display:none}}.coveo-facet-column .coveo-logo{position:relative;left:50%;transform:translateX(-50%);margin:10px 0}@keyframes fadeout{0%{opacity:1}to{opacity:0}}@keyframes fadein{0%{opacity:0}to{opacity:1}}@keyframes slideInLeft{0%{transform:translateX(-2000px);opacity:0}to{transform:translateX(0);opacity:1}}@keyframes coveo-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes loadingFade{0%{opacity:0}50%{opacity:.8}to{opacity:0}}.coveo-youtube-player.coveo-modalBox>.coveo-wrapper{height:90%;width:90%;position:relative;overflow:hidden}.coveo-youtube-thumbnail-container{position:relative}.coveo-youtube-thumbnail-play-button{display:none}.coveo-modal-container.coveo-youtube-player .coveo-modal-body{height:90%}.coveo-modal-container.coveo-youtube-player .coveo-modal-body div{height:100%;width:100%}.coveo-modal-container.coveo-youtube-player .coveo-modal-body iframe{height:100%;width:100%;border:none}.coveo-numeric-spinner *,.coveo-numeric-spinner :after,.coveo-numeric-spinner :before{box-sizing:border-box}.coveo-numeric-spinner input[type=text]{width:35px;height:30px;border:1px solid #a0aab3;border-radius:2px 0 0 2px;font-size:15px;text-align:center}.coveo-numeric-spinner .coveo-add-on{display:inline-block;height:30px;padding:0;vertical-align:top;border:1px solid #a0aab3;border-radius:0 2px 2px 0;border-left-width:0;user-select:none}.coveo-spinner-down,.coveo-spinner-up{display:flex;height:50%;padding:0 6px;border-radius:3px;cursor:pointer}.coveo-spinner-down:hover,.coveo-spinner-up:hover{background-color:#296896}.coveo-spinner-down-svg,.coveo-spinner-up-svg{width:10px;height:6px;color:#1d4f76;display:block;margin:auto}.coveo-input{position:relative;margin-top:35px}.coveo-input input{width:100%;height:34px;padding:0;border:0;border-bottom:1px solid rgba(79,86,88,.4);border-radius:0;outline:0;transition:all .2s ease}.coveo-input input:disabled,.coveo-input input:focus:not([readonly]),.coveo-input input:valid{color:#313a45;border-bottom:1px solid #296896}.coveo-input input:disabled::placeholder,.coveo-input input:focus:not([readonly])::placeholder,.coveo-input input:valid::placeholder{color:#4f5658;font-family:\"'Lato', Arial, Helvetica, sans-serif\";font-size:inherit;text-transform:none;transition:color .2s ease}.coveo-input input:disabled,.coveo-input input[readonly=readonly]{color:#4f5658;border-bottom-color:#4f5658}.coveo-input input:disabled+label,.coveo-input input[readonly=readonly]+label{color:#4f5658}.coveo-input label{position:absolute;top:10px;left:0;align-items:center;display:flex;color:#313a45;font-size:15px;transition:all .2s ease;pointer-events:none}.coveo-input input:disabled+label,.coveo-input input:focus:not([readonly])+label,.coveo-input input:valid+label,.coveo-input label.active{top:-20px;color:#296896;font-size:13px}.coveo-input input{padding:3px 0;color:transparent;font-size:15px;background-color:transparent;box-shadow:none;transition:color .2s ease}.coveo-input input::placeholder{color:transparent;font-family:\"'Lato', Arial, Helvetica, sans-serif\";font-size:inherit;text-transform:none;transition:color .2s ease}.coveo-radio{position:relative}.coveo-radio input[type=radio]{position:absolute;margin:0;opacity:0}.coveo-radio input[type=radio]+label{position:relative;display:inline-block;height:16px;padding-left:40px;color:#313a45;line-height:16px;transition:.28s ease;cursor:pointer;user-select:none}.coveo-radio input[type=radio]+label:after,.coveo-radio input[type=radio]+label:before{position:absolute;top:0;left:0;z-index:0;width:16px;height:16px;content:\"\";border-radius:50%;transition:.28s ease;box-sizing:inherit}.coveo-radio input[type=radio]:focus+label:before{box-shadow:0 0 0 8px #bcc3ca}.coveo-radio input[type=radio]:not(:checked)+label:before{border:2px solid #296896}.coveo-radio input[type=radio]:not(:checked)+label:after{z-index:-1;transform:scale(0)}.coveo-radio input[type=radio]:checked+label:before{border:2px solid #3a833c}.coveo-radio input[type=radio]:checked+label:after{z-index:0;background-color:#3a833c;transform:scale(.5)}.coveo-radio input[type=radio]:disabled+label{color:#4f5658}.coveo-radio input[type=radio]:disabled+label:before{border-color:#4f5658}.coveo-radio input[type=radio]:disabled:checked+label:after{background-color:#4f5658}.coveo-radio+.coveo-radio{margin-top:10px}.radio-select .radio-option+.radio-option{margin-top:18px}.coveo-dropdown{-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;position:relative;display:inline-block;border:1px solid #a0aab3;border-radius:2px 0 0 2px;font-size:15px;background:#fff;margin:0 10px;flex-basis:115px;-ms-flex-preferred-size:115px;background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIiB2aWV3Qm94PSIwIDAgNC45NSAxMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fS5jbHMtMntmaWxsOiM0NDQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5hcnJvd3M8L3RpdGxlPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQuOTUiIGhlaWdodD0iMTAiLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMS40MSA0LjY3IDIuNDggMy4xOCAzLjU0IDQuNjcgMS40MSA0LjY3Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjMuNTQgNS4zMyAyLjQ4IDYuODIgMS40MSA1LjMzIDMuNTQgNS4zMyIvPjwvc3ZnPg==) no-repeat;background-position:right 5px top 50%;background-size:16px 32px;vertical-align:middle;height:30px;min-width:150px;padding:0 25px 0 0;text-indent:5px;color:#313a45}select.coveo-dropdown::-ms-expand{display:none}.coveo-button{display:inline-block;width:100%;height:30px;padding:8.5px 16px;color:#296896;font-family:Lato,Arial,Helvetica,sans-serif;font-size:12px;font-weight:700;line-height:15px;text-decoration:none;text-overflow:ellipsis;text-transform:uppercase;vertical-align:middle;white-space:nowrap;background-color:#fff;border:1px solid #4f5658;border-radius:2px;cursor:pointer}.coveo-button .icon{fill:#296896}.coveo-button:focus,.coveo-button:hover{text-decoration:none}.coveo-button:focus{background-color:#bcc3ca;outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.coveo-button+.coveo-button{margin-left:15px}\n\n/*!\n * Pikaday\n * Copyright © 2014 David Bushell | BSD & MIT license | http://dbushell.com/\n */.pika-single{z-index:9999;display:block;position:relative;color:#333;background:#fff;border:1px solid #ccc;border-bottom-color:#bbb;font-family:Helvetica Neue,Helvetica,Arial,sans-serif}.pika-single.is-hidden{display:none}.pika-single.is-bound{position:absolute;box-shadow:0 5px 15px -5px rgba(0,0,0,.5)}.pika-single{*zoom:1}.pika-single:after,.pika-single:before{content:\" \";display:table}.pika-single:after{clear:both}.pika-lendar{float:left;width:240px;margin:8px}.pika-title{position:relative;text-align:center}.pika-title select{cursor:pointer;position:absolute;z-index:9998;margin:0;left:0;top:5px;filter:alpha(opacity=0);opacity:0}.pika-label{display:inline-block;*display:inline;position:relative;z-index:9999;overflow:hidden;margin:0;padding:5px 3px;font-size:14px;line-height:20px;font-weight:700;background-color:#fff}.pika-next,.pika-prev{display:block;cursor:pointer;position:relative;outline:none;border:0;padding:0;width:20px;height:30px;text-indent:20px;white-space:nowrap;overflow:hidden;background-color:transparent;background-position:50%;background-repeat:no-repeat;background-size:75% 75%;opacity:.5;*position:absolute;*top:0}.pika-next:hover,.pika-prev:hover{opacity:1}.pika-next.is-disabled,.pika-prev.is-disabled{cursor:default;opacity:.2}.is-rtl .pika-next,.pika-prev{float:left;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==\");*left:0}.is-rtl .pika-prev,.pika-next{float:right;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=\");*right:0}.pika-select{display:inline-block;*display:inline}.pika-table{width:100%;border-collapse:collapse;border-spacing:0;border:0}.pika-table td,.pika-table th{width:14.285714285714286%;padding:0}.pika-table th{color:#999;font-size:12px;line-height:25px;font-weight:700;text-align:center}.pika-table abbr{border-bottom:none}.pika-button{cursor:pointer;display:block;box-sizing:border-box;outline:none;border:0;margin:0;width:100%;padding:5px;color:#666;font-size:12px;line-height:15px;text-align:right;background:#f5f5f5}.is-today .pika-button{color:#296896;font-weight:700}.is-selected .pika-button{color:#fff;font-weight:700;background:#296896;box-shadow:inset 0 1px 3px #296896;border-radius:3px}.is-disabled .pika-button{pointer-events:none;cursor:default;color:#999;opacity:.3}.pika-button:hover{color:#fff;background:#f58020;box-shadow:none;border-radius:3px}.pika-week{font-size:11px;color:#999}.is-inrange .pika-button{background:#d5e9f7}.is-startrange .pika-button{color:#fff;background:#6cb31d;box-shadow:none;border-radius:3px}.is-endrange .pika-button{color:#fff;background:#296896;box-shadow:none;border-radius:3px}.CoveoFollowItem{display:inline-block;color:#adadad;padding-left:7px;cursor:pointer}.CoveoFollowItem span{vertical-align:middle}.coveo-follow-item-icon-loading-svg{display:none;color:#1d4f76}.coveo-follow-item-loading .coveo-follow-item-icon-loading{margin:1px 9px 1px 3px}.coveo-follow-item-loading .coveo-follow-item-icon-svg{display:none}.coveo-follow-item-loading .coveo-follow-item-icon-loading-svg{display:inline-block;width:15px;height:15px;color:#1d4f76;animation-name:coveo-spin;animation-timing-function:linear;animation-duration:1s;animation-iteration-count:infinite}.coveo-follow-item-icon{vertical-align:middle;margin-right:6px}.coveo-follow-item-icon-svg{width:15px;height:12px;color:#1d4f76}.coveo-follow-item-followed .coveo-active-shape-svg{color:#ecad00}.CoveoCardActionBar .CoveoFollowItem{display:flex;padding-left:0;color:#fff}.coveo-follow-query-svg{width:15px;height:12px;color:#1d4f76}.CoveoSubscriptionsPanel{overflow:hidden;margin-top:10px;display:none}.coveo-modalBox.coveo-subscriptions-panel>.coveo-wrapper>.coveo-title{cursor:inherit}.coveo-subscriptions-panel>.coveo-wrapper{overflow:visible}.coveo-subscriptions-panel .coveo-body{max-height:600px;min-width:500px}@media (max-width:600px){.coveo-subscriptions-panel .coveo-body{min-width:inherit}}.coveo-subscriptions-panel .coveo-dropdown{margin:0}.coveo-subscriptions-panel .coveo-subscriptions-panel-fail{padding:10px 0}.coveo-subscriptions-panel .coveo-subscriptions-panel-content{width:100%;margin:20px 0}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-spacer td{height:20px}.coveo-subscriptions-panel .coveo-subscriptions-panel-content td,.coveo-subscriptions-panel .coveo-subscriptions-panel-content th{text-align:left;padding:0 10px;line-height:37px;height:37px}.coveo-subscriptions-panel .coveo-subscriptions-panel-content td.coveo-subscriptions-panel-content-type,.coveo-subscriptions-panel .coveo-subscriptions-panel-content th.coveo-subscriptions-panel-content-type{padding-left:30px}.coveo-subscriptions-panel .coveo-subscriptions-panel-content td.coveo-subscriptions-panel-content-actions,.coveo-subscriptions-panel .coveo-subscriptions-panel-content th.coveo-subscriptions-panel-content-actions{padding-right:30px}.coveo-subscriptions-panel .coveo-subscriptions-panel-content th{color:#395f84;font-size:13px;font-weight:700;border-bottom:1px solid #bcc3ca}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription .coveo-subscriptions-panel-context{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:300px}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription .coveo-subscriptions-panel-action{display:block;padding-left:34px;position:relative;overflow:hidden;cursor:pointer;white-space:nowrap}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription .coveo-subscriptions-panel-action:before{content:\"\";display:block;width:24px;height:24px;background-color:#006286;border:2px solid #006487;border-radius:3px;position:absolute;left:0;top:7px;box-sizing:border-box}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription .coveo-subscriptions-panel-action:after{content:\"\";display:block;width:8px;height:8px;background-color:#fff;position:absolute;left:8px;top:15px}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription .coveo-subscriptions-panel-action-follow{height:0}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription .coveo-subscriptions-panel-action-follow:before{background-color:#003a4c;border:2px solid #003a4c}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription .coveo-subscriptions-panel-action-follow:after{background-color:#bcc3ca}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription.coveo-subscription-unfollowed .coveo-subscriptions-panel-action-follow{height:auto}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription.coveo-subscription-unfollowed .coveo-subscriptions-panel-action-unfollow{height:0}.coveo-subscriptions-panel .coveo-subscriptions-panel-content .coveo-subscriptions-panel-subscription.coveo-subscription-unfollowed .coveo-subscriptions-panel-frequency{visibility:hidden}.coveo-subscriptions-panel .coveo-subscriptions-panel-subscription+.coveo-subscriptions-panel-no-subscriptions{display:none}.coveo-subscriptions-panel-svg{width:15px;height:12px;color:#1d4f76}.coveo-subscriptions-messages{z-index:1}.coveo-subscriptions-messages-message{background-color:#ecad00;display:-moz-flex;display:-ms-flexbox;display:flex;border-radius:2px;color:#fff;white-space:nowrap}.coveo-subscriptions-messages-message.coveo-subscriptions-messages-error{background-color:#f44336}.coveo-subscriptions-messages-message.coveo-subscriptions-messages-error:after{border-color:transparent transparent #f44336}.coveo-subscriptions-messages-message:before{content:\"\";vertical-align:middle;margin:5px 7px 4px 0;float:left}.coveo-subscriptions-messages-message:after{position:absolute;top:-7px;left:8px;content:\"\";width:0;height:0;border-style:solid;border-width:0 7px 7px;border-color:transparent transparent #ecad00;float:left}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-content{padding:7px 0;font-size:12px;display:inline-block;overflow:hidden;text-overflow:ellipsis}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-content span{vertical-align:middle}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-content .coveo-media-max-width-800{font-size:10px}@media (max-width:800px){.coveo-subscriptions-messages-message .coveo-subscriptions-messages-content{font-size:10px}}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-info-close{display:inline-block;vertical-align:middle;margin:6px;cursor:pointer;color:#1d4f76}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-info-close .coveo-exclusion-svg{fill:#1d4f76}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-info-close svg{width:12px;height:12px}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-info-close:hover{color:#cc0d00}.coveo-subscriptions-messages-message .coveo-subscriptions-messages-info-close:hover .coveo-exclusion-svg{fill:#cc0d00}.CoveoSearchButton{color:#fff;border:1px solid #7e8c9a;border-left:none;text-decoration:none;text-align:center;vertical-align:middle;overflow:hidden;height:50px;width:60px;cursor:pointer;line-height:0}.CoveoSearchButton:before{content:\"\";vertical-align:middle;height:100%;display:inline-block}.CoveoSearchButton .coveo-search-button,.CoveoSearchButton .coveo-search-button-loading{vertical-align:middle;animation:none;display:inline-block}.CoveoSearchButton .coveo-search-button-loading-svg{display:none}.CoveoSearchButton:hover .coveo-magnifier-circle-svg{fill:#ecad00}.coveo-search-button-svg{width:18px;height:18px;color:#1d4f76}.coveo-executing-query .CoveoSearchButton .coveo-search-button-svg{display:none}.coveo-executing-query .CoveoSearchButton .coveo-search-button-loading-svg{display:inline;color:#1d4f76;width:18px;height:18px;animation-name:coveo-spin;animation-timing-function:linear;animation-duration:1s;animation-iteration-count:infinite}.CoveoSearchInterface{min-height:100%;position:relative;margin:0;font-family:Lato,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:15px;color:#313a45}.CoveoSearchInterface .highlight{font-weight:700}.CoveoSearchInterface input[type=text]::-ms-clear{width:0;height:0}.CoveoSearchInterface input:focus,.CoveoSearchInterface select:focus,.CoveoSearchInterface textarea:focus{outline:none}.CoveoSearchInterface input[type=text],.CoveoSearchInterface textarea{color:#67768b}.CoveoSearchInterface .coveo-tab-disabled{display:none}.CoveoSearchInterface *{box-sizing:border-box}.CoveoSearchInterface .coveo-error{color:#dc291e}.CoveoSearchInterface.coveo-hidden{display:none}body.coveo-modalBox-opened,body.coveo-modalBox-opened .CoveoSearchInterface{overflow:hidden}.CoveoSearchInterface .coveo-modal-container.coveo-opened{display:flex}.coveo-highlight{font-weight:700}.coveo-modalBox>.coveo-wrapper>.coveo-title{height:40px;line-height:23px;text-align:center;cursor:pointer}.coveo-modalBox>.coveo-wrapper>.coveo-title .coveo-close-button{position:absolute;left:25px;display:inline-block}.coveo-modalBox>.coveo-wrapper>.coveo-title .coveo-close-button .coveo-icon{margin-right:10px}.coveo-modalBox>.coveo-wrapper>.coveo-title .coveo-pop-up-reminder{color:#b4b4b4;font-weight:400;display:inline-block}.coveo-visible-to-screen-reader-only{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden}@keyframes placeholderColorChange{0%{background:#bcc3ca}50%{background:#e6ecf0}to{background:#bcc3ca}}.coveo-placeholder-icon{width:64px;height:64px;margin-left:2px}.coveo-placeholder-icon-small{width:32px;height:32px;margin-left:2px}.coveo-placeholder-title{height:16px;margin-bottom:20px}.coveo-placeholder-text{height:8px;margin-bottom:12px}.coveo-placeholder-result,.coveo-result-frame.coveo-placeholder-result,.CoveoSearchInterface.coveo-during-initialization .coveo-result-frame.coveo-placeholder-result{margin:20px 0 20px 20px}.CoveoSearchInterface.coveo-during-initialization .CoveoBreadcrumb,.CoveoSearchInterface.coveo-during-initialization .CoveoDidYouMean,.CoveoSearchInterface.coveo-during-initialization .CoveoErrorReport,.CoveoSearchInterface.coveo-during-initialization .CoveoHiddenQuery{display:none}.CoveoSearchInterface.coveo-during-initialization .coveo-results-header{height:42px;visibility:hidden}.CoveoSearchInterface.coveo-during-initialization .coveo-recommendation-main-section .coveo-recommendation-column,.CoveoSearchInterface.coveo-during-initialization .CoveoSimpleFilter{display:none}.CoveoSearchInterface.coveo-during-initialization .coveo-media-max-width-800 .coveo-results-header{height:69px}.CoveoSearchInterface.coveo-during-initialization .coveo-media-max-width-800 .coveo-facet-column{display:none}@media (max-width:800px){.CoveoSearchInterface.coveo-during-initialization .coveo-results-header{height:69px}.CoveoSearchInterface.coveo-during-initialization .coveo-facet-column{display:none}}.CoveoSearchInterface.coveo-during-initialization .coveo-media-max-width-1020 .coveo-recommendation-results-column{display:inherit;width:inherit}@media (max-width:1020px){.CoveoSearchInterface.coveo-during-initialization .coveo-recommendation-results-column{display:inherit;width:inherit}}.coveo-placeholder-icon,.coveo-placeholder-icon-small,.coveo-placeholder-text,.coveo-placeholder-title{animation-name:placeholderColorChange;animation-timing-function:linear;animation-duration:2s;animation-iteration-count:infinite}.CoveoCategoryFacet.coveo-during-initialization,.CoveoDynamicFacet.coveo-during-initialization,.CoveoDynamicFacetRange.coveo-during-initialization,.CoveoDynamicHierarchicalFacet.coveo-during-initialization,.CoveoFacet.coveo-during-initialization,.CoveoFacetRange.coveo-during-initialization,.CoveoFacetSlider.coveo-during-initialization,.CoveoHierarchicalFacet.coveo-during-initialization,.CoveoTimespanFacet.coveo-during-initialization{display:none}.CoveoCategoryFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoDynamicFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoDynamicFacetRange.coveo-during-initialization.coveo-with-placeholder,.CoveoDynamicHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoFacetRange.coveo-during-initialization.coveo-with-placeholder,.CoveoFacetSlider.coveo-during-initialization.coveo-with-placeholder,.CoveoHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoTimespanFacet.coveo-during-initialization.coveo-with-placeholder{border:thin solid #bcc3ca;border-radius:2px;margin-bottom:20px;display:block}.CoveoCategoryFacet.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoDynamicFacet.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoDynamicFacetRange.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoDynamicHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoFacet.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoFacetRange.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoFacetSlider.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480,.CoveoTimespanFacet.coveo-during-initialization.coveo-with-placeholder .coveo-media-max-width-480{display:none}@media (max-width:480px){.CoveoCategoryFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoDynamicFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoDynamicFacetRange.coveo-during-initialization.coveo-with-placeholder,.CoveoDynamicHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoFacetRange.coveo-during-initialization.coveo-with-placeholder,.CoveoFacetSlider.coveo-during-initialization.coveo-with-placeholder,.CoveoHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder,.CoveoTimespanFacet.coveo-during-initialization.coveo-with-placeholder{display:none}}.CoveoCategoryFacet.coveo-during-initialization.coveo-with-placeholder>*,.CoveoDynamicFacet.coveo-during-initialization.coveo-with-placeholder>*,.CoveoDynamicFacetRange.coveo-during-initialization.coveo-with-placeholder>*,.CoveoDynamicHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder>*,.CoveoFacet.coveo-during-initialization.coveo-with-placeholder>*,.CoveoFacetRange.coveo-during-initialization.coveo-with-placeholder>*,.CoveoFacetSlider.coveo-during-initialization.coveo-with-placeholder>*,.CoveoHierarchicalFacet.coveo-during-initialization.coveo-with-placeholder>*,.CoveoTimespanFacet.coveo-during-initialization.coveo-with-placeholder>*{display:none}.CoveoCategoryFacet.coveo-during-initialization .coveo-facet-placeholder,.CoveoDynamicFacet.coveo-during-initialization .coveo-facet-placeholder,.CoveoDynamicFacetRange.coveo-during-initialization .coveo-facet-placeholder,.CoveoDynamicHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder,.CoveoFacet.coveo-during-initialization .coveo-facet-placeholder,.CoveoFacetRange.coveo-during-initialization .coveo-facet-placeholder,.CoveoFacetSlider.coveo-during-initialization .coveo-facet-placeholder,.CoveoHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder,.CoveoTimespanFacet.coveo-during-initialization .coveo-facet-placeholder{display:block}.CoveoCategoryFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoDynamicFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoDynamicFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoDynamicHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoFacetSlider.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title,.CoveoTimespanFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-title{height:24px}.CoveoCategoryFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoDynamicFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoDynamicFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoDynamicHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoFacetSlider.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line,.CoveoTimespanFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-line{padding:0 20px;margin-bottom:20px;display:flex}.CoveoCategoryFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoDynamicFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoDynamicFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoDynamicHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoFacetSlider.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox,.CoveoTimespanFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-facet-placeholder-checkbox{display:inline-block;width:15px;height:15px;align-self:center;margin-right:10px;animation-name:placeholderColorChange;animation-timing-function:linear;animation-duration:2s;animation-iteration-count:infinite}.CoveoCategoryFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoDynamicFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoDynamicFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoDynamicHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoFacetRange.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoFacetSlider.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoHierarchicalFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text,.CoveoTimespanFacet.coveo-during-initialization .coveo-facet-placeholder .coveo-placeholder-text{flex-grow:1;align-self:center;margin-bottom:0}.CoveoSearchbox.coveo-during-initialization{display:block;height:50px;border:thin solid #bcc3ca;border-radius:2px}.CoveoResultList.coveo-during-initialization{display:none}.CoveoResultList.coveo-during-initialization.coveo-with-placeholder{display:block}.CoveoResultList.coveo-during-initialization.coveo-with-placeholder .CoveoResult{display:none}.CoveoResultList.coveo-during-initialization.coveo-with-placeholder .CoveoResult.coveo-placeholder-result{display:block}.CoveoResultList.coveo-during-initialization.coveo-with-placeholder .coveo-card-layout .coveo-placeholder-title{margin-bottom:0}.CoveoResultList.coveo-during-initialization.coveo-with-placeholder .coveo-card-layout.coveo-placeholder-result{min-height:220px}.CoveoRecommendation .CoveoResultList .coveo-placeholder-result{margin:10px 0 10px 20px}.CoveoRecommendation .CoveoResultList .coveo-placeholder-title{margin-bottom:0}.coveo-media-max-width-480 .CoveoResultList.coveo-during-initialization.coveo-with-placeholder .coveo-card-layout.coveo-placeholder-result{margin:0 0 20px}@media (max-width:480px){.CoveoResultList.coveo-during-initialization.coveo-with-placeholder .coveo-card-layout.coveo-placeholder-result{margin:0 0 20px}}.coveo-debug.coveo-modal-container .coveo-modal-content{transition:opacity .3s}.coveo-debug.coveo-modal-container .coveo-modal-content.coveo-debug-loading{opacity:.5}.coveo-debug.coveo-modal-container .coveo-checkbox-label,.coveo-debug.coveo-modal-container .coveo-input{margin:8px}.coveo-debug.coveo-modal-container .coveo-checkbox-label{margin-left:18px}.coveo-debug.coveo-modal-container .coveo-checkbox-span-label{margin-left:6px}.coveo-debug.coveo-modal-container .coveo-modal-header{height:auto;min-height:80px;padding:20px;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}.coveo-debug.coveo-modal-container .coveo-modal-header a{color:#0059b3;text-decoration:none;cursor:pointer}.coveo-debug.coveo-modal-container .coveo-modal-header a:visited,.coveo-debug.coveo-modal-container .coveo-modal-header a:visited:hover{color:#609}.coveo-debug.coveo-modal-container .coveo-modal-header a:hover,.coveo-debug.coveo-modal-container .coveo-modal-header a:hover a{text-decoration:underline}.coveo-debug.coveo-modal-container .coveo-modal-header a.coveo-selected *{color:#0059b3}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-property{display:none}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-property.coveo-search-match,.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-property.coveo-search-match .coveo-property{display:block}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-property.coveo-search-match>.coveo-property-label>.coveo-debug-highlight,.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-property.coveo-search-match>.coveo-property-value>.coveo-debug-highlight{background:#ff0}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-property.coveo-search-submatch,.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-section-container>.coveo-property{display:block}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-section-container>.coveo-property .coveo-property-value{display:none}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-section-container>.coveo-property:after{content:\"No match\"}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-section-container>.coveo-property.coveo-search-match .coveo-property-value,.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-section-container>.coveo-property.coveo-search-submatch .coveo-property-value{display:block}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-section-container>.coveo-property.coveo-search-match:after,.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching .coveo-section-container>.coveo-property.coveo-search-submatch:after{content:\"\"}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-searching-loading{display:none}.coveo-debug.coveo-modal-container .coveo-modal-body .coveo-debug{min-width:800px}.coveo-debug.coveo-modal-container .coveo-debug-durations{display:table;width:100%;height:32px;margin-bottom:16px}.coveo-debug.coveo-modal-container .coveo-debug-durations .coveo-debug-duration{display:table-cell;height:32px}.coveo-debug.coveo-modal-container .coveo-debug-durations .coveo-debug-duration[data-id=indexDuration]{background:#b33}.coveo-debug.coveo-modal-container .coveo-debug-durations .coveo-debug-duration[data-id=proxyDuration]{background:#b3b}.coveo-debug.coveo-modal-container .coveo-debug-durations .coveo-debug-duration[data-id=clientDuration]{background:#3b3}.coveo-debug.coveo-modal-container .coveo-debug-durations .coveo-debug-duration[data-id=duration]{background:#33b}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend{display:inline-block;margin-right:16px}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend[data-id=indexDuration]:before{background:#b33}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend[data-id=proxyDuration]:before{background:#b3b}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend[data-id=clientDuration]:before{background:#3b3}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend[data-id=duration]:before{background:#33b}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend:before{content:\"\";display:inline-block;width:8px;height:16px;vertical-align:middle;margin-right:2px}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend .coveo-debug-duration-label{vertical-align:middle}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend .coveo-debug-duration-label:after{content:\": \"}.coveo-debug.coveo-modal-container .coveo-debug-duration-legend .coveo-debug-duration-value{vertical-align:middle}.coveo-debug.coveo-modal-container .coveo-section.coveo-debug-collapsed .coveo-section-header:before{content:\"\\25B6\"}.coveo-debug.coveo-modal-container .coveo-section.coveo-debug-collapsed .coveo-section-container{display:none}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-header{font-size:16px;font-weight:700;background:#eee;border-top:1px solid #ccc;border-bottom:1px solid #ccc;padding:8px 16px;cursor:pointer}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-header:before{content:\"\\25BC\";vertical-align:middle;margin-right:8px}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container{padding:16px 8px;overflow:auto}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property{line-height:18px;font-family:Consolas,Menlo,Monaco,monospace;padding-left:16px;clear:both}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property .coveo-property-label{float:left;color:#263238}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property .coveo-property-label:after{content:\":\";color:#212121;padding-right:8px}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-object.coveo-collapsible>.coveo-property-label{position:relative;float:none;cursor:pointer}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-object.coveo-collapsible>.coveo-property-label:before{content:\"\\25B6\";position:absolute;right:100%;top:0;line-height:18px;font-size:12px;padding-right:2px;color:#263238}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-object.coveo-collapsible>.coveo-property-value{display:none}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-object.coveo-collapsible.coveo-expanded>.coveo-property-value,.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-object.coveo-collapsible.coveo-search-submatch>.coveo-property-value{display:block}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-object.coveo-collapsible.coveo-expanded>.coveo-property-label:before,.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-object.coveo-collapsible.coveo-search-submatch>.coveo-property-label:before{content:\"\\25BC\"}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value{color:#212121}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-string{color:#d50000;white-space:pre-wrap;word-wrap:break-word}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-string:after,.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-string:before{content:'\"'}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-array,.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-null,.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-object{color:#9e9e9e}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-boolean,.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-date,.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container .coveo-property.coveo-property-basic .coveo-property-value.coveo-property-value-number{color:#2196f3}.coveo-debug.coveo-modal-container .coveo-section .coveo-section-container>.coveo-property{padding-left:0}.coveo-checkbox-button,input[type=checkbox].coveo-checkbox+button{position:relative;width:17px;height:17px;padding:0;background:#fff;border:1px solid #7e8c9a;border-radius:2px;outline:none;transition:all .2s;cursor:pointer}input[type=checkbox].coveo-checkbox{display:none}input[type=checkbox].coveo-checkbox+button:after{position:absolute;top:7px;left:7px;display:inline-block;width:0;height:0;content:\"\";background-color:transparent;border-radius:100%;transition:all .3s ease}input[type=checkbox].coveo-checkbox+button:focus:after{top:-6px;left:-6px;display:inline-block;width:26px;height:26px;background-color:rgba(0,0,0,.08)}input[type=checkbox].coveo-checkbox:checked+button:before{position:absolute;top:1px;left:5px;box-sizing:content-box;display:block;width:4px;height:9px;content:\"\";border:solid #0059b3;border-width:0 2px 2px 0;transform:rotate(43deg)}input[type=checkbox].coveo-checkbox:indeterminate+button{position:relative}input[type=checkbox].coveo-checkbox:indeterminate+button:before{position:absolute;top:6px;left:3px;box-sizing:content-box;display:block;width:8px;height:0;content:\"\";border-bottom:2px solid #1d4f76}input[type=checkbox].coveo-checkbox:indeterminate:disabled+button:before{border-color:#fff}input[type=checkbox].coveo-checkbox:disabled+button{background-color:#373737;border-color:#373737;cursor:default;opacity:.2}.coveo-checkbox-label{align-items:center;display:inline-flex;color:#373737;line-height:16px;vertical-align:middle}.coveo-checkbox-label .label{cursor:pointer}.coveo-checkbox-label.disabled .label{cursor:default;opacity:.4}.coveo-checkbox-label .label+.coveo-checkbox+button,.coveo-checkbox-label button+.label{margin-left:18px}label[for].coveo-checkbox-label{cursor:pointer}.coveo-checkbox-labels-group .coveo-checkbox-label{display:flex}.coveo-checkbox-labels-group .coveo-checkbox-group-option+.coveo-checkbox-group-option,.coveo-checkbox-labels-group .coveo-checkbox-label+.coveo-checkbox-label{margin-top:10px}.coveo-checkbox-label{cursor:pointer}.coveo-checkbox-label .coveo-checkbox-span-label+.coveo-checkbox+button,.coveo-checkbox-label button+.coveo-checkbox-span-label{margin-left:18px}.coveo-checkbox-button,input[type=checkbox].coveo-checkbox+button{min-width:18px}.coveo-missing-term-breadcrumb-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-missing-term-breadcrumb-value{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px;display:inline-block}.coveo-missing-term-breadcrumb-value:visited,.coveo-missing-term-breadcrumb-value:visited:hover{color:#609}.coveo-missing-term-breadcrumb-value:hover,.coveo-missing-term-breadcrumb-value:hover a{text-decoration:underline}.coveo-missing-term-breadcrumb-value.coveo-selected *{color:#0059b3;color:#296896}.coveo-missing-term-breadcrumb-clear{margin-left:5px}.coveo-missing-term-breadcrumb-clear svg{width:9px;height:9px}.CoveoResult a.CoveoResultLink,.CoveoResultLink,a.CoveoResultLink{color:#0059b3;text-decoration:none;cursor:pointer;word-wrap:break-word}.CoveoResult a.CoveoResultLink:visited,.CoveoResult a.CoveoResultLink:visited:hover,.CoveoResultLink:visited,.CoveoResultLink:visited:hover,a.CoveoResultLink:visited,a.CoveoResultLink:visited:hover{color:#609}.CoveoResult a.CoveoResultLink:hover,.CoveoResult a.CoveoResultLink:hover a,.CoveoResultLink:hover,.CoveoResultLink:hover a,a.CoveoResultLink:hover,a.CoveoResultLink:hover a{text-decoration:underline}.CoveoResult a.CoveoResultLink.coveo-selected *,.CoveoResultLink.coveo-selected *,a.CoveoResultLink.coveo-selected *{color:#0059b3}.coveo-card-overlay a.CoveoResultLink{color:#0059b3;text-decoration:none;cursor:pointer;color:#f7f8f9;text-decoration:underline}.coveo-card-overlay a.CoveoResultLink:visited,.coveo-card-overlay a.CoveoResultLink:visited:hover{color:#609;color:#f7f8f9}.coveo-card-overlay a.CoveoResultLink:hover,.coveo-card-overlay a.CoveoResultLink:hover a{text-decoration:underline}.coveo-card-overlay a.CoveoResultLink.coveo-selected *{color:#0059b3;color:#f7f8f9}.coveo-accessible-button:hover{cursor:pointer}.coveo-accessible-button.coveo-accessible-button-pressed:focus,.coveo-accessible-button:active{outline:0}.coveo-input{position:relative;margin-top:35px}.coveo-input input{width:100%;height:34px;padding:0;border:0;border-bottom:1px solid rgba(79,86,88,.4);border-radius:0;outline:0;transition:all .2s ease}.coveo-input input:disabled,.coveo-input input:focus:not([readonly]),.coveo-input input:valid{color:#313a45;border-bottom:1px solid #296896}.coveo-input input:disabled::placeholder,.coveo-input input:focus:not([readonly])::placeholder,.coveo-input input:valid::placeholder{color:#4f5658;font-family:\"'Lato', Arial, Helvetica, sans-serif\";font-size:inherit;text-transform:none;transition:color .2s ease}.coveo-input input:disabled,.coveo-input input[readonly=readonly]{color:#4f5658;border-bottom-color:#4f5658}.coveo-input input:disabled+label,.coveo-input input[readonly=readonly]+label{color:#4f5658}.coveo-input label{position:absolute;top:10px;left:0;align-items:center;display:flex;color:#313a45;font-size:15px;transition:all .2s ease;pointer-events:none}.coveo-input input:disabled+label,.coveo-input input:focus:not([readonly])+label,.coveo-input input:valid+label,.coveo-input label.active{top:-20px;color:#296896;font-size:13px}.coveo-input input{padding:3px 0;color:transparent;font-size:15px;background-color:transparent;box-shadow:none;transition:color .2s ease}.coveo-input input::placeholder{color:transparent;font-family:\"'Lato', Arial, Helvetica, sans-serif\";font-size:inherit;text-transform:none;transition:color .2s ease}.coveo-radio{position:relative}.coveo-radio input[type=radio]{position:absolute;margin:0;opacity:0}.coveo-radio input[type=radio]+label{position:relative;display:inline-block;height:16px;padding-left:40px;color:#313a45;line-height:16px;transition:.28s ease;cursor:pointer;user-select:none}.coveo-radio input[type=radio]+label:after,.coveo-radio input[type=radio]+label:before{position:absolute;top:0;left:0;z-index:0;width:16px;height:16px;content:\"\";border-radius:50%;transition:.28s ease;box-sizing:inherit}.coveo-radio input[type=radio]:focus+label:before{box-shadow:0 0 0 8px #bcc3ca}.coveo-radio input[type=radio]:not(:checked)+label:before{border:2px solid #296896}.coveo-radio input[type=radio]:not(:checked)+label:after{z-index:-1;transform:scale(0)}.coveo-radio input[type=radio]:checked+label:before{border:2px solid #3a833c}.coveo-radio input[type=radio]:checked+label:after{z-index:0;background-color:#3a833c;transform:scale(.5)}.coveo-radio input[type=radio]:disabled+label{color:#4f5658}.coveo-radio input[type=radio]:disabled+label:before{border-color:#4f5658}.coveo-radio input[type=radio]:disabled:checked+label:after{background-color:#4f5658}.coveo-radio+.coveo-radio{margin-top:10px}.radio-select .radio-option+.radio-option{margin-top:18px}.coveo-advanced-search-section{margin:20px 0}#coveo-advanced-search-in-the-last-select{margin-left:20px}#coveo-advanced-search-in-the-last-select .coveo-button{width:auto}.coveo-advanced-search-section-title{font-weight:700;border-bottom:thin solid #bcc3ca;padding:5px 0}.coveo-advanced-search-date-input-section{display:-moz-flex;display:-ms-flexbox;display:flex;align-items:center;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:10px 0}.coveo-advanced-search-date-input-section .coveo-radio input[type=radio]+label{display:inline}.coveo-advanced-search-date-input-section .coveo-advanced-search-date-input{display:inline-block;padding:0;border:none}.coveo-advanced-search-date-input-section .coveo-advanced-search-date-input .coveo-button{width:100px}.coveo-advanced-search-date-input-section .coveo-advanced-search-date-input:disabled{visibility:hidden}.coveo-advanced-search-document-input-section{margin:20px 0;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap;align-items:center}.coveo-advanced-search-document-input-section .coveo-input{flex-basis:200px;-ms-flex-preferred-size:200px;box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;margin-left:10px;margin-top:0;display:inline-block}.coveo-advanced-search-date-input .coveo-numeric-spinner,.coveo-advanced-search-document-input-section .coveo-numeric-spinner{display:inline-block;vertical-align:middle}.coveo-advanced-search-date-input .coveo-numeric-spinner input[type=text],.coveo-advanced-search-document-input-section .coveo-numeric-spinner input[type=text]{color:#4f5658;width:55px}#coveo-advanced-search-select-day,#coveo-advanced-search-select-month{width:50px}#coveo-advanced-search-select-year{width:70px}.coveo-advanced-search-keyword-label{display:inline-block}.coveo-advanced-search-label{display:inline-block;min-width:7em;margin-bottom:10px}.coveo-advanced-search-select{margin:0 5px 5px 0}.coveo-advanced-search-and{display:inline-block;margin:0 5px 5px 0;margin-left:5px}.coveo-number-input{max-width:45px}#coveo-advanced-search-execute-query{width:200px;height:35px;display:block;margin:15px 0 15px auto}.coveo-advanced-search-modal fieldset,.coveo-size-input-mode-section{display:inline-block}.coveo-advanced-search-modal .coveo-dropdown,.coveo-advanced-search-modal .coveo-numeric-spinner{margin:0 5px 5px 0}.coveo-advanced-search-breadcrumb-value{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px}.coveo-advanced-search-breadcrumb-value:visited,.coveo-advanced-search-breadcrumb-value:visited:hover{color:#609}.coveo-advanced-search-breadcrumb-value:hover,.coveo-advanced-search-breadcrumb-value:hover a{text-decoration:underline}.coveo-advanced-search-breadcrumb-value.coveo-selected *{color:#0059b3;color:#296896}.coveo-advanced-search-breadcrumb-clear{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px;margin-left:5px}.coveo-advanced-search-breadcrumb-clear:visited,.coveo-advanced-search-breadcrumb-clear:visited:hover{color:#609}.coveo-advanced-search-breadcrumb-clear:hover,.coveo-advanced-search-breadcrumb-clear:hover a{text-decoration:underline}.coveo-advanced-search-breadcrumb-clear.coveo-selected *{color:#0059b3;color:#296896}.coveo-advanced-search-breadcrumb-clear svg{width:9px;height:9px}.coveo-advanced-search-svg{width:16px;height:16px;color:#1d4f76}.coveo-advanced-search-breadcrumb-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-modal-container.coveo-authentication-popup .coveo-modal-body{height:90%}.coveo-modal-container.coveo-authentication-popup .coveo-modal-body div{height:100%;width:100%}.coveo-modal-container.coveo-authentication-popup .coveo-modal-body iframe{height:100%;width:100%;border:thin solid #bcc3ca;border-radius:2px;padding:10px 0 0 10px}.coveo-authentication-iframe{width:100%;height:100%;border:0}.coveo-waiting-for-authentication-popup{padding:50px 150px}.coveo-authentication-provider:hover .coveo-dropdown-authenticate-hover-svg{fill:#1d4f76}.coveo-authentication-provider:hover .coveo-dropdown-authenticate-svg{fill:none}.coveo-authentication-provider:hover .coveo-authentication-provider-svg{width:12px;height:16px}.coveo-authentication-provider-svg{width:12px;height:14px}.coveo-authentication-provider-svg .coveo-dropdown-authenticate-svg{fill:#1d4f76}.CoveoBackdrop{background-size:cover}.CoveoBreadcrumb{padding:10px 0;position:relative;overflow:hidden;border-bottom:thin solid #bcc3ca;outline:none;display:-moz-flex;display:-ms-flexbox;display:flex;box-align:start;-moz-align-items:flex-start;-ms-align-items:flex-start;-o-align-items:flex-start;align-items:flex-start;-ms-flex-align:start}.coveo-no-results .CoveoBreadcrumb{text-align:left}.coveo-breadcrumb-clear-all{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;flex-shrink:0;-ms-flex-negative:0;outline:1px solid transparent;display:inline-block;font-size:14px;padding:5px;margin-left:5px;margin-right:1px}.coveo-breadcrumb-clear-all:visited,.coveo-breadcrumb-clear-all:visited:hover{color:#609}.coveo-breadcrumb-clear-all:hover,.coveo-breadcrumb-clear-all:hover a{text-decoration:underline}.coveo-breadcrumb-clear-all.coveo-selected *{color:#0059b3}.coveo-breadcrumb-items{padding-bottom:10px;display:inline-block;-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1}.coveo-breadcrumb-item{margin:5px 0}.coveo-media-max-width-480 .CoveoBreadcrumb{padding:10px}.coveo-media-max-width-480 .coveo-breadcrumb-items{padding-bottom:0}.coveo-media-max-width-480 .coveo-breadcrumb-item:not(:last-child){margin-bottom:10px}@media (max-width:480px){.CoveoBreadcrumb{padding:10px}.coveo-breadcrumb-items{padding-bottom:0}.coveo-breadcrumb-item:not(:last-child){margin-bottom:10px}}.CoveoCardActionBar{display:flex;flex-wrap:wrap;min-height:44px;background-color:#263e55;color:#fff;margin:auto -20px -20px;padding:0 0 10px 20px;font-size:11px;box-shadow:0 0 3px 2px rgba(0,0,0,.2);z-index:1;transform:translateY(100%);transition:transform .2s ease-in-out}.CoveoCardActionBar.coveo-opened{transform:translateY(0)}.CoveoCardActionBar>*{display:flex;align-items:center;text-transform:uppercase;margin-top:10px;margin-right:20px}.CoveoCardActionBar .coveo-icon{margin-right:3px}.coveo-card-action-bar-arrow-svg{width:10px;height:9px;color:#67768b}.coveo-card-action-bar-arrow-container{position:absolute;text-align:center;bottom:0;width:100%;background-color:#263e55;color:#fff;left:0}.CoveoCardActionBar .coveo-icon-for-quickview-svg{margin-top:4px;color:#67768b}.CoveoCardActionBar .coveo-follow-item-icon-svg{color:#67768b}.CoveoCardOverlay{cursor:pointer}.coveo-search-svg{color:#67768b;width:18px;height:18px}.coveo-search-svg .coveo-magnifier-circle-svg{fill:#ecad00}.coveo-replies-svg{color:#67768b;width:20px;height:20px}.coveo-card-overlay{position:absolute;height:100%;width:100%;top:0;left:0;flex-direction:column;z-index:1;background-color:#263e55;color:#fff;cursor:default;transition:transform .5s ease-in-out;transform:translateY(100%);display:flex;animation:coveo-card-overlay-fade-out .5s linear}.coveo-card-overlay.coveo-hidden-for-tab-nav{display:none}@keyframes coveo-card-overlay-fade-out{0%{opacity:1}60%{opacity:1}80%{opacity:0}to{opacity:0}}.coveo-card-overlay.coveo-opened{transform:translateY(0);animation:coveo-card-overlay-fade-in .5s linear}@keyframes coveo-card-overlay-fade-in{0%{opacity:0}20%{opacity:0}40%{opacity:1}to{opacity:1}}.coveo-card-overlay-header{display:flex;justify-content:center;align-items:center;flex-shrink:0;font-size:11px;text-transform:uppercase;text-align:center;padding:14px 0;border-bottom:1px solid #bcc3ca;cursor:pointer}.coveo-card-overlay-header .coveo-icon{margin-right:3px}.coveo-card-overlay-body{overflow:auto;overflow-x:hidden}.coveo-card-overlay-footer{text-align:center;margin-top:auto;cursor:pointer;flex-shrink:0}.CoveoResult.coveo-with-card-overlay{transition:min-height .5s;min-height:0}.CoveoResult.coveo-card-overlay-opened{min-height:180px}.coveo-open-card-overlay{display:inline-block;margin-bottom:4px}.coveo-open-card-overlay-svg{width:10px;height:6px;color:#67768b}.CoveoDidYouMean{padding:10px 0;text-align:left;font-size:16px}.CoveoDidYouMean button{color:#0059b3;cursor:pointer;border:none;font-size:1em;padding:0;text-decoration:none}.CoveoDidYouMean button:visited,.CoveoDidYouMean button:visited:hover{color:#609}.CoveoDidYouMean button:hover,.CoveoDidYouMean button:hover a{text-decoration:underline}.CoveoDidYouMean button.coveo-selected *{color:#0059b3}.CoveoDidYouMean button:hover{text-decoration:underline}.coveo-did-you-mean-highlight{font-weight:400}.coveo-did-you-mean-word-correction{font-weight:700}.coveo-did-you-mean-no-results-for{font-size:16px}.CoveoErrorReport{text-align:center}.CoveoErrorReport h1,.CoveoErrorReport h2,.CoveoErrorReport h3,.CoveoErrorReport h4,.CoveoErrorReport h5,.CoveoErrorReport h6{font-weight:400;display:block;margin:0 0 20px}.coveo-error-report-help-link{display:inline-block;border:1px solid #f58020;border-radius:2px;text-decoration:none;background-color:#f58020;padding:10px;font-weight:700;color:#fff}.coveo-error-report-help-link:hover{background-color:#f68e38}.coveo-error-report-title{color:#1d4f76;margin-bottom:20px;font-size:12px}.coveo-error-report-message{margin-top:0;margin-right:30px;margin-left:30px}.coveo-error-report-message pre{font-size:12px;text-align:left}.coveo-error-report-container{padding:45px;background-color:#f1f3f4;border:1px solid #1d4f76}.coveo-error-report-clear,.coveo-error-report-more-info,.coveo-error-report-previous,.coveo-error-report-retry{color:#0059b3;text-decoration:none;cursor:pointer;padding:5px;border-radius:2px}.coveo-error-report-clear:visited,.coveo-error-report-clear:visited:hover,.coveo-error-report-more-info:visited,.coveo-error-report-more-info:visited:hover,.coveo-error-report-previous:visited,.coveo-error-report-previous:visited:hover,.coveo-error-report-retry:visited,.coveo-error-report-retry:visited:hover{color:#609}.coveo-error-report-clear:hover,.coveo-error-report-clear:hover a,.coveo-error-report-more-info:hover,.coveo-error-report-more-info:hover a,.coveo-error-report-previous:hover,.coveo-error-report-previous:hover a,.coveo-error-report-retry:hover,.coveo-error-report-retry:hover a{text-decoration:underline}.coveo-error-report-clear.coveo-selected *,.coveo-error-report-more-info.coveo-selected *,.coveo-error-report-previous.coveo-selected *,.coveo-error-report-retry.coveo-selected *{color:#0059b3}.coveo-error-info{width:100%}.coveo-error-info textarea{width:100%;height:200px}.CoveoExcerpt{word-wrap:break-word}.CoveoExportToExcel{overflow:hidden;margin-top:10px;display:none}.CoveoExportToExcel.coveo-export-to-excel-opened{display:block}.coveo-export-to-excel-svg{width:14px;height:14px;color:#1d4f76}.CoveoCategoryFacet,.CoveoFacet,.CoveoFacetRange,.CoveoFacetSlider,.CoveoHierarchicalFacet,.CoveoTimespanFacet{margin:10px 0;padding:0;border:thin solid #7e8c9a;border-radius:2px;background:#fff;position:relative}.CoveoTimespanFacet{border:none}.coveo-facet-column .coveo-bottomSpace.coveo-with-animation,.coveo-facet-column .coveo-topSpace.coveo-with-animation{transition:height .5s}.coveo-facet-empty,.coveo-hidden,.coveo-no-visible-facet .coveo-facet-column{display:none}.coveo-facet-empty.coveo-with-placeholder,.coveo-hidden.coveo-with-placeholder{display:block}.coveo-facet-collapsed .coveo-facet-value.coveo-facet-value{display:none}.coveo-facet-collapsed .coveo-facet-value.coveo-facet-value.coveo-excluded,.coveo-facet-collapsed .coveo-facet-value.coveo-facet-value.coveo-selected{display:inherit}.coveo-facet-collapsed .coveo-facet-footer{display:none}.coveo-facet-fade .coveo-facet-value{opacity:.5}.coveo-facet-fade .coveo-facet-value.coveo-excluded,.coveo-facet-fade .coveo-facet-value.coveo-facet-search-selectable,.coveo-facet-fade .coveo-facet-value.coveo-selected{opacity:1}.coveo-facet-less,.coveo-facet-more{width:100%;height:15px;background:#f7f8f9;cursor:pointer;text-align:center}.coveo-facet-less:focus,.coveo-facet-less:hover,.coveo-facet-more:focus,.coveo-facet-more:hover{background:#bcc3ca}.coveo-facet-less:focus,.coveo-facet-less:focus.coveo-accessible-button-pressed,.coveo-facet-less:hover,.coveo-facet-less:hover.coveo-accessible-button-pressed,.coveo-facet-more:focus,.coveo-facet-more:focus.coveo-accessible-button-pressed,.coveo-facet-more:hover,.coveo-facet-more:hover.coveo-accessible-button-pressed{outline:1px solid transparent;outline-offset:-3px}@media screen and (-ms-high-contrast:white-on-black){.coveo-facet-less:focus,.coveo-facet-less:focus.coveo-accessible-button-pressed,.coveo-facet-less:hover,.coveo-facet-less:hover.coveo-accessible-button-pressed,.coveo-facet-more:focus,.coveo-facet-more:focus.coveo-accessible-button-pressed,.coveo-facet-more:hover,.coveo-facet-more:hover.coveo-accessible-button-pressed{background-color:#fff}.coveo-facet-less:focus.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-less:focus.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-less:focus .coveo-facet-less-icon-svg,.coveo-facet-less:focus .coveo-facet-more-icon-svg,.coveo-facet-less:hover.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-less:hover.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-less:hover .coveo-facet-less-icon-svg,.coveo-facet-less:hover .coveo-facet-more-icon-svg,.coveo-facet-more:focus.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-more:focus.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-more:focus .coveo-facet-less-icon-svg,.coveo-facet-more:focus .coveo-facet-more-icon-svg,.coveo-facet-more:hover.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-more:hover.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-more:hover .coveo-facet-less-icon-svg,.coveo-facet-more:hover .coveo-facet-more-icon-svg{color:#000}}@media screen and (-ms-high-contrast:black-on-white){.coveo-facet-less:focus,.coveo-facet-less:focus.coveo-accessible-button-pressed,.coveo-facet-less:hover,.coveo-facet-less:hover.coveo-accessible-button-pressed,.coveo-facet-more:focus,.coveo-facet-more:focus.coveo-accessible-button-pressed,.coveo-facet-more:hover,.coveo-facet-more:hover.coveo-accessible-button-pressed{background-color:#000}.coveo-facet-less:focus.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-less:focus.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-less:focus .coveo-facet-less-icon-svg,.coveo-facet-less:focus .coveo-facet-more-icon-svg,.coveo-facet-less:hover.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-less:hover.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-less:hover .coveo-facet-less-icon-svg,.coveo-facet-less:hover .coveo-facet-more-icon-svg,.coveo-facet-more:focus.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-more:focus.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-more:focus .coveo-facet-less-icon-svg,.coveo-facet-more:focus .coveo-facet-more-icon-svg,.coveo-facet-more:hover.coveo-accessible-button-pressed .coveo-facet-less-icon-svg,.coveo-facet-more:hover.coveo-accessible-button-pressed .coveo-facet-more-icon-svg,.coveo-facet-more:hover .coveo-facet-less-icon-svg,.coveo-facet-more:hover .coveo-facet-more-icon-svg{color:#fff}}.coveo-facet-more{border-bottom-left-radius:2px;border-bottom-right-radius:2px;display:none}.coveo-facet-more.coveo-active{display:block}.coveo-facet-less-icon-svg,.coveo-facet-more-icon-svg{width:10px;height:6px;color:#1d4f76}.coveo-facet-less-icon,.coveo-facet-more-icon{position:relative;top:-4px}.coveo-facet-less{display:none}.coveo-facet-less.coveo-active{display:block}.coveo-facet-footer.coveo-facet-empty{visibility:hidden}.coveo-facet-footer{background:#f7f8f9;min-height:15px;border-bottom-left-radius:2px;border-bottom-right-radius:2px}.CoveoSearchInterface.coveo-small-facets .coveo-facet-dropdown-content{z-index:20;margin:0}.CoveoSearchInterface.coveo-small-facets .coveo-facet-dropdown-header{box-ordinal-group:2;-moz-order:2;order:2;-ms-flex-order:2;border:thin solid #bcc3ca;border-radius:2px;background-color:#fff}.CoveoSearchInterface.coveo-small-facets .coveo-facet-dropdown-header.coveo-dropdown-header-active{z-index:20}.CoveoSearchInterface.coveo-small-facets.coveo-no-visible-facet .coveo-facet-dropdown-header{display:none}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-modal-content{z-index:20;position:fixed;top:0;left:0;width:100%;height:100%;background-color:#fff;overflow-y:scroll;padding:20px}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-modal-content .coveo-facet-modal-close-button{padding:0;width:32px;height:32px;border-radius:50%;background-color:#0059b3;border:none;color:#fff;margin-left:auto;margin-bottom:20px;display:flex;justify-content:center;align-items:center;cursor:pointer}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-modal-content .coveo-facet-modal-close-button:hover{opacity:.8}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-modal-content .coveo-facet-modal-close-button:focus{opacity:.5}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-modal-content .coveo-facet-modal-close-button>svg{width:12px;height:12px}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-hidden{display:none}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content{overflow-y:scroll;max-height:600px;clear:both;white-space:nowrap;padding:0;min-width:280px;width:35%;z-index:20;box-shadow:0 7px 15px rgba(0,0,0,.25);border-radius:0 0 0 2px}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoCategoryFacet,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoFacet,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoFacetRange,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoFacetSlider,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoHierarchicalFacet,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoTimespanFacet{margin:0;border:0;border-radius:0}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoCategoryFacet .coveo-facet-header,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoFacet .coveo-facet-header,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoFacetRange .coveo-facet-header,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoFacetSlider .coveo-facet-header,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoHierarchicalFacet .coveo-facet-header,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoTimespanFacet .coveo-facet-header{border:0;border-radius:0;border-top:thin solid #bcc3ca;white-space:normal}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacet,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacetRange,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicHierarchicalFacet{margin:0}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacet .coveo-dynamic-facet-values,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacet .coveo-dynamic-hierarchical-facet-values,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacetRange .coveo-dynamic-facet-values,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacetRange .coveo-dynamic-hierarchical-facet-values,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicHierarchicalFacet .coveo-dynamic-facet-values,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicHierarchicalFacet .coveo-dynamic-hierarchical-facet-values{padding:5px}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacet .coveo-dynamic-facet-header,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacetRange .coveo-dynamic-facet-header,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicHierarchicalFacet .coveo-dynamic-facet-header{padding:0 5px}.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacet .coveo-dynamic-facet-search,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicFacetRange .coveo-dynamic-facet-search,.CoveoSearchInterface.coveo-small-facets .coveo-facet-column.coveo-facet-dropdown-content .CoveoDynamicHierarchicalFacet .coveo-dynamic-facet-search{margin:10px 5px 0}.CoveoSearchInterface.coveo-small-facets .coveo-facet-header-filter-by-container{background:#f7f8f9;font-size:16px;font-weight:700;letter-spacing:.22px;line-height:22px}.CoveoSearchInterface.coveo-small-facets .coveo-facet-header-filter-by-container .coveo-facet-header-filter-by{display:block;padding:10px 0 10px 20px}.coveo-facet-header-filter-by{display:none}.coveo-facet-breadcrumb-title,.coveo-facet-slider-breadcrumb-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-facet-breadcrumb-value,.coveo-facet-breadcrumb-value-list-item,.coveo-facet-slider-breadcrumb-value{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px;display:inline-block}.coveo-facet-breadcrumb-value-list-item:visited,.coveo-facet-breadcrumb-value-list-item:visited:hover,.coveo-facet-breadcrumb-value:visited,.coveo-facet-breadcrumb-value:visited:hover,.coveo-facet-slider-breadcrumb-value:visited,.coveo-facet-slider-breadcrumb-value:visited:hover{color:#609}.coveo-facet-breadcrumb-value-list-item:hover,.coveo-facet-breadcrumb-value-list-item:hover a,.coveo-facet-breadcrumb-value:hover,.coveo-facet-breadcrumb-value:hover a,.coveo-facet-slider-breadcrumb-value:hover,.coveo-facet-slider-breadcrumb-value:hover a{text-decoration:underline}.coveo-facet-breadcrumb-value-list-item.coveo-selected *,.coveo-facet-breadcrumb-value.coveo-selected *,.coveo-facet-slider-breadcrumb-value.coveo-selected *{color:#0059b3;color:#296896}.coveo-facet-breadcrumb-value-list-item.coveo-excluded .coveo-facet-breadcrumb-caption,.coveo-facet-breadcrumb-value.coveo-excluded .coveo-facet-breadcrumb-caption,.coveo-facet-slider-breadcrumb-value.coveo-excluded .coveo-facet-breadcrumb-caption{text-decoration:line-through}.coveo-facet-breadcrumb-value-list-item{margin:0;padding:0}.coveo-facet-breadcrumb-clear,.coveo-facet-slider-breadcrumb-clear{margin-left:5px}.coveo-facet-breadcrumb-clear svg,.coveo-facet-slider-breadcrumb-clear svg{width:9px;height:9px}ul.coveo-facet-breadcrumb-values{display:inline-block;list-style:none;margin:0;padding:0}.coveo-facet-header{padding:10px 20px;background:#f7f8f9;clear:both;overflow:hidden;border-top-left-radius:2px;border-top-right-radius:2px;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-lines:single;-moz-box-lines:single;box-lines:single;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.coveo-facet-header svg{display:inline-block;vertical-align:middle;width:18px;height:18px}.coveo-facet-header-title-section{-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1}.coveo-facet-header-settings-section,.coveo-facet-header-title-section{display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-lines:single;-moz-box-lines:single;box-lines:single;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.coveo-facet-header-settings-section{-moz-flex-grow:0;flex-grow:0;-ms-flex-positive:0}.coveo-facet-header-title{color:#1d4f76;font-size:15px}.coveo-facet-settings-more:focus,.coveo-facet-settings-more:hover{outline:none}.coveo-facet-settings-more:focus .coveo-more-background-svg,.coveo-facet-settings-more:hover .coveo-more-background-svg{fill-opacity:1;fill:#e6ecf0}.coveo-facet-header-operator,.coveo-facet-settings-more-svg{color:#1d4f76}.coveo-facet-header-operator .coveo-and .coveo-and-svg,.coveo-facet-header-operator .coveo-or .coveo-or-svg{fill:#ecad00}.coveo-facet-header-collapse,.coveo-facet-header-eraser,.coveo-facet-header-expand,.coveo-facet-header-operator,.coveo-facet-header-settings{cursor:pointer;margin-left:10px;position:relative;vertical-align:middle;border:none;background-color:transparent;padding:0}.coveo-facet-header-eraser{position:relative;top:0;visibility:hidden;cursor:pointer;color:#1d4f76}.coveo-facet-header-eraser.coveo-facet-header-eraser-visible{visibility:visible}.coveo-facet-header-eraser .coveo-exclusion-svg{fill:#1d4f76}.coveo-facet-header-eraser svg{width:15px;height:15px}.coveo-facet-header-eraser:hover{color:#cc0d00}.coveo-facet-header-eraser:hover .coveo-exclusion-svg{fill:#cc0d00}.coveo-facet-header-wait-animation{margin-left:10px;position:relative}.coveo-facet-header-wait-animation .coveo-facet-header-wait-animation-svg{color:#1d4f76;display:inline-block;vertical-align:middle;animation-name:coveo-spin;animation-timing-function:linear;animation-duration:1s;animation-iteration-count:infinite}.coveo-facet-values{list-style:none;padding:5px 0 0;margin:0}.coveo-facet-value{padding:0 20px;margin:0;line-height:22px;position:relative}.coveo-facet-value input[type=checkbox]{display:none}.coveo-facet-value .coveo-facet-value-checkbox{width:18px;height:18px;box-sizing:content-box;border:thin solid #7e8c9a;border-radius:2px;text-align:center;vertical-align:middle;margin-right:15px;background:#fff;position:relative;top:2px;flex-shrink:0}.coveo-facet-value .coveo-facet-value-checkbox>svg{position:relative;background:none}.coveo-facet-value.coveo-selected .coveo-facet-value-checkbox svg{width:14px;height:12px;bottom:2px}.coveo-facet-value.coveo-selected .coveo-facet-value-checkbox svg .coveo-hook-svg{fill:#4f5658}.coveo-facet-value.coveo-with-hover:hover:not(.coveo-facet-search-button):not(.coveo-excluded):not(.coveo-facet-value-will-exclude):not(.coveo-has-childs-selected) .coveo-facet-value-checkbox svg{width:14px;height:12px;bottom:2px}.coveo-facet-value.coveo-with-hover:hover:not(.coveo-facet-search-button):not(.coveo-excluded):not(.coveo-facet-value-will-exclude):not(.coveo-has-childs-selected) .coveo-facet-value-checkbox svg .coveo-hook-svg{fill:#4f5658}.coveo-facet-value.coveo-with-hover:hover.coveo-excluded .coveo-facet-value-checkbox .coveo-hook-svg{fill-opacity:0}.coveo-facet-value .coveo-facet-value-checkbox:active{outline:none}.coveo-facet-value:not(.coveo-facet-search-button) .coveo-facet-value-checkbox:focus svg{width:14px;height:12px;bottom:2px}.coveo-facet-value:not(.coveo-facet-search-button) .coveo-facet-value-checkbox:focus svg .coveo-hook-svg{fill:#4f5658}.coveo-facet-value:not(.coveo-facet-search-button) .coveo-facet-value-checkbox:focus svg .coveo-exclusion-svg{fill-opacity:0}.coveo-facet-value:not(.coveo-excluded).coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg,.coveo-facet-value:not(.coveo-excluded):hover.coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg{width:10px;height:10px;bottom:3px}.coveo-facet-value:not(.coveo-excluded).coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg .coveo-exclusion-svg,.coveo-facet-value:not(.coveo-excluded):hover.coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg .coveo-exclusion-svg{fill:#cc0d00}.coveo-facet-value.coveo-facet-value-will-exclude.coveo-selected .coveo-facet-value-checkbox .coveo-hook-svg,.coveo-facet-value:hover.coveo-facet-value-will-exclude.coveo-selected .coveo-facet-value-checkbox .coveo-hook-svg{fill-opacity:0}.coveo-facet-value.coveo-excluded:not(.coveo-facet-value-will-exclude) .coveo-facet-value-checkbox svg{width:10px;height:10px;bottom:3px}.coveo-facet-value.coveo-excluded:not(.coveo-facet-value-will-exclude) .coveo-facet-value-checkbox svg .coveo-exclusion-svg{fill:#cc0d00}.coveo-facet-value.coveo-facet-value-will-exclude:focus .coveo-facet-value-checkbox .coveo-hook-svg,.coveo-facet-value.coveo-facet-value-will-exclude:hover .coveo-facet-value-checkbox .coveo-hook-svg{fill-opacity:0}.coveo-facet-value.coveo-excluded .coveo-facet-value-caption,.coveo-facet-value.coveo-excluded .coveo-facet-value-computed-field,.coveo-facet-value.coveo-excluded .coveo-facet-value-count{text-decoration:line-through}.coveo-facet-value>*{vertical-align:middle}.coveo-facet-value.coveo-selected{font-weight:700}.coveo-facet-value.coveo-with-hover.coveo-focused,.coveo-facet-value.coveo-with-hover:hover{background-color:#e6ecf0}.coveo-facet-value.coveo-with-hover:hover .coveo-facet-value-exclude{visibility:visible}.coveo-facet-value-label-wrapper{display:flex}.coveo-facet-value-label{display:block;white-space:nowrap;cursor:pointer;padding:5px 0}.coveo-facet-value-caption{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;vertical-align:middle;flex-grow:1}.coveo-facet-value-icon{display:inline-block;margin:3px 5px 3px 0;vertical-align:top;float:left}.coveo-facet-value-count{vertical-align:middle;margin:0 5px;display:inline-block;transition:opacity 1s}.coveo-facet-value-count.coveo-waitDelta{opacity:0}.coveo-with-computed-field .coveo-facet-value-computed-field,.coveo-with-computed-field .coveo-facet-value-count{font-size:12px;position:relative;top:1px}.coveo-facet-value-label.coveo-with-computed-field{display:-moz-flex;display:-ms-flexbox;display:flex;box-pack:justify;-moz-justify-content:space-between;-ms-justify-content:space-between;-o-justify-content:space-between;justify-content:space-between;-ms-flex-pack:justify}.coveo-facet-value-label.coveo-with-computed-field .coveo-facet-value-label-wrapper{box-ordinal-group:1;-moz-order:1;order:1;-ms-flex-order:1;display:-moz-flex;display:-ms-flexbox;display:flex;min-width:0}.coveo-facet-value-label.coveo-with-computed-field .coveo-facet-value-label-wrapper .coveo-facet-value-checkbox{box-ordinal-group:1;-moz-order:1;order:1;-ms-flex-order:1;flex-shrink:0;-ms-flex-negative:0}.coveo-facet-value-label.coveo-with-computed-field .coveo-facet-value-label-wrapper .coveo-facet-value-caption{box-ordinal-group:2;-moz-order:2;order:2;-ms-flex-order:2}.coveo-facet-value-label.coveo-with-computed-field .coveo-facet-value-label-wrapper .coveo-facet-value-count{box-ordinal-group:3;-moz-order:3;order:3;-ms-flex-order:3}.coveo-facet-value-label.coveo-with-computed-field .coveo-facet-value-computed-field{box-ordinal-group:2;-moz-order:2;order:2;-ms-flex-order:2}.coveo-facet-value-computed-field{float:right;margin-left:5px}.coveo-facet-value-exclude{cursor:pointer;position:absolute;top:9px;right:5px;background:#fff;border:thin solid #bcc3ca;border-radius:2px;border-color:grey;height:13px;width:13px;opacity:0;z-index:2}.coveo-facet-value-exclude:focus,.coveo-facet-value-exclude:hover{opacity:1}.coveo-facet-value-exclude:active{outline:none}.coveo-facet-value-exclude-svg{width:7px;height:7px;position:absolute;top:2px;left:2px}.coveo-facet-value-exclude-svg .coveo-exclusion-svg{fill:grey}.coveo-facet-value-unexclude-svg{width:7px;height:7px;position:absolute;top:2px;left:2px;fill:grey}.coveo-facet-search-results{position:absolute;left:20px;right:20px;border:thin solid #7e8c9a;border-radius:2px;background-color:#fff;list-style:none;margin:0 0 3px;padding:0 0 10px;z-index:999;max-height:200px;overflow-x:hidden;overflow-y:scroll;-ms-overflow-style:scrollbar;font-size:12px}.coveo-facet-search-results input[type=checkbox]{display:none}.coveo-facet-search-results .coveo-with-computed-field .coveo-facet-value-computed-field,.coveo-facet-search-results .coveo-with-computed-field .coveo-facet-value-count{top:0}.coveo-facet-search-results.coveo-no-results{display:none;visibility:hidden}.coveo-facet-search-results .coveo-facet-value input[type=checkbox]{display:none}.coveo-facet-search-results .coveo-facet-value .coveo-facet-value-checkbox{width:13px;height:13px;box-sizing:content-box;border:thin solid #7e8c9a;border-radius:2px;text-align:center;vertical-align:middle;margin-right:15px;background:#fff;top:2px;flex-shrink:0}.coveo-facet-search-results .coveo-facet-value .coveo-facet-value-checkbox>svg{position:relative;background:none}.coveo-facet-search-results .coveo-facet-value.coveo-selected .coveo-facet-value-checkbox svg{width:11px;height:9px;bottom:4px}.coveo-facet-search-results .coveo-facet-value.coveo-selected .coveo-facet-value-checkbox svg .coveo-hook-svg{fill:#000}.coveo-facet-search-results .coveo-facet-value.coveo-with-hover:hover:not(.coveo-facet-search-button):not(.coveo-excluded):not(.coveo-facet-value-will-exclude):not(.coveo-has-childs-selected) .coveo-facet-value-checkbox svg{width:11px;height:9px;bottom:4px}.coveo-facet-search-results .coveo-facet-value.coveo-with-hover:hover:not(.coveo-facet-search-button):not(.coveo-excluded):not(.coveo-facet-value-will-exclude):not(.coveo-has-childs-selected) .coveo-facet-value-checkbox svg .coveo-hook-svg{fill:#000}.coveo-facet-search-results .coveo-facet-value.coveo-with-hover:hover.coveo-excluded .coveo-facet-value-checkbox .coveo-hook-svg{fill-opacity:0}.coveo-facet-search-results .coveo-facet-value .coveo-facet-value-checkbox:active{outline:none}.coveo-facet-search-results .coveo-facet-value:not(.coveo-facet-search-button) .coveo-facet-value-checkbox:focus svg{width:11px;height:9px;bottom:4px}.coveo-facet-search-results .coveo-facet-value:not(.coveo-facet-search-button) .coveo-facet-value-checkbox:focus svg .coveo-hook-svg{fill:#000}.coveo-facet-search-results .coveo-facet-value:not(.coveo-facet-search-button) .coveo-facet-value-checkbox:focus svg .coveo-exclusion-svg{fill-opacity:0}.coveo-facet-search-results .coveo-facet-value:not(.coveo-excluded).coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg,.coveo-facet-search-results .coveo-facet-value:not(.coveo-excluded):hover.coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg{width:7px;height:7px;bottom:5px}.coveo-facet-search-results .coveo-facet-value:not(.coveo-excluded).coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg .coveo-exclusion-svg,.coveo-facet-search-results .coveo-facet-value:not(.coveo-excluded):hover.coveo-facet-value-will-exclude .coveo-facet-value-checkbox svg .coveo-exclusion-svg{fill:#cc0d00}.coveo-facet-search-results .coveo-facet-value.coveo-facet-value-will-exclude.coveo-selected .coveo-facet-value-checkbox .coveo-hook-svg,.coveo-facet-search-results .coveo-facet-value:hover.coveo-facet-value-will-exclude.coveo-selected .coveo-facet-value-checkbox .coveo-hook-svg{fill-opacity:0}.coveo-facet-search-results .coveo-facet-value.coveo-excluded:not(.coveo-facet-value-will-exclude) .coveo-facet-value-checkbox svg{width:7px;height:7px;bottom:5px}.coveo-facet-search-results .coveo-facet-value.coveo-excluded:not(.coveo-facet-value-will-exclude) .coveo-facet-value-checkbox svg .coveo-exclusion-svg{fill:#cc0d00}.coveo-facet-search-results .coveo-facet-value.coveo-facet-value-will-exclude:focus .coveo-facet-value-checkbox .coveo-hook-svg,.coveo-facet-search-results .coveo-facet-value.coveo-facet-value-will-exclude:hover .coveo-facet-value-checkbox .coveo-hook-svg{fill-opacity:0}.coveo-facet-search-results .coveo-facet-value .coveo-facet-value-checkbox{position:relative;top:5px}.coveo-facet-search-results .coveo-facet-value-exclude{right:10px}.coveo-facet-search-results .coveo-facet-value-label{padding-right:15px}.CoveoFacet .coveo-facet-search-results{margin-top:-1px}.CoveoCategoryFacet .coveo-facet-search-results{line-height:normal}.coveo-facet-search-selectable{margin:0;padding:0 10px}.coveo-facet-search-current-result{background-color:#e6ecf0}.coveo-facet-search-select-all{margin:0;padding:10px;font-weight:700;color:#0059b3;text-decoration:none;cursor:pointer}.coveo-facet-search-select-all:visited,.coveo-facet-search-select-all:visited:hover{color:#609}.coveo-facet-search-select-all:hover,.coveo-facet-search-select-all:hover a{text-decoration:underline}.coveo-facet-search-select-all.coveo-selected *{color:#0059b3}.coveo-facet-search-clear{float:right;margin-right:3px;opacity:.5;clear:none;cursor:pointer;color:#1d4f76}.coveo-facet-search-clear .coveo-exclusion-svg{fill:#1d4f76}.coveo-facet-search-clear svg{width:8px;height:8px}.coveo-facet-search-clear:hover{color:#cc0d00}.coveo-facet-search-clear:hover .coveo-exclusion-svg{fill:#cc0d00}.coveo-facet-search-clear:hover{opacity:1}.coveo-facet-search-input{border:0;padding:1px 0 0;margin:0;font-size:13px;width:100%;background-color:inherit;line-height:15px}.coveo-facet-search-input[value=\"\"]{color:#bcc3ca}@keyframes grow{0%{margin-right:200px}to{margin-right:20px}}.coveo-facet-search{border:thin solid #7e8c9a;border-radius:2px;position:relative;background:#fff;display:none;margin:2px 20px 1px;padding:4px}.coveo-facet-search:not(.without-animation){animation:grow .3s linear}.coveo-facet-searching .coveo-facet-search{display:block}.coveo-facet-search-no-results+.coveo-facet-search-results{padding:0;overflow-y:hidden}.coveo-facet-value-not-found{margin:1px;padding:4px 9px;font-size:13px}.coveo-facet-search-magnifier{float:left}.coveo-facet-search-magnifier-svg{margin:5px 6px 5px 10px;width:10px;height:10px;color:#67768b}.coveo-facet-search-wait-animation{float:left}.coveo-facet-search-wait-animation-svg{width:13px;height:13px;color:#1d4f76;margin:3px 3px 5px 10px;animation-name:coveo-spin;animation-timing-function:linear;animation-duration:1s;animation-iteration-count:infinite}.coveo-facet-search-middle{overflow:hidden;line-height:19px}.coveo-facet-value.coveo-facet-search-button{color:#0059b3}.coveo-facet-value.coveo-facet-search-button .coveo-facet-value-checkbox{border-style:dashed}.coveo-facet-value.coveo-facet-search-button .coveo-facet-value-checkbox:focus,.coveo-facet-value.coveo-facet-search-button:hover .coveo-facet-value-checkbox{border-style:solid}.coveo-facet-searching .coveo-facet-value.coveo-facet-search-button{display:none}.coveo-facet-value.coveo-facet-search-button .coveo-facet-value-checkbox{bottom:1px}.coveo-facet-value.coveo-facet-search-button .coveo-facet-value-checkbox svg{bottom:3px}.coveo-facet-value.coveo-facet-search-button .coveo-facet-value-checkbox svg .coveo-more-svg{fill:grey}.coveo-facet-value.coveo-facet-search-button .coveo-facet-value-checkbox>.coveo-facet-value-checkbox-svg,.coveo-facet-value.coveo-facet-search-button:hover .coveo-facet-value-checkbox>.coveo-facet-value-checkbox-svg{color:grey;width:16px;height:11px}.CoveoCategoryFacet.coveo-hidden{display:none}.CoveoCategoryFacet.coveo-hidden.coveo-with-placeholder{display:block}.coveo-category-facet-values-fade .coveo-category-facet-child-value{opacity:.5}.coveo-category-facet-values{list-style:none;padding:0;margin-top:10px;margin-bottom:0}.coveo-category-facet-value-label{display:-moz-flex;display:-ms-flexbox;display:flex;padding:5px 19px 5px 20px}.coveo-category-facet-value-label.coveo-selectable{vertical-align:middle;line-height:22px;cursor:pointer}.coveo-category-facet-value-label.coveo-selectable:focus,.coveo-category-facet-value-label.coveo-selectable:hover{background-color:#e6ecf0}.coveo-active-category-facet-parent{font-weight:700;margin-left:15px}.coveo-category-facet-non-empty-path .coveo-category-facet-child-value .coveo-category-facet-value-label{padding-left:53px}.coveo-category-facet-last-value{color:#000}.coveo-category-facet-last-value .coveo-category-facet-value-label:focus,.coveo-category-facet-last-value .coveo-category-facet-value-label:hover{background-color:#fff}.coveo-category-facet-value-caption{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1}.coveo-category-facet-value-count{margin:0 5px}.coveo-category-facet-collapse-children{cursor:pointer;padding-right:5px;vertical-align:top}.coveo-category-facet-header{padding:10px 20px 6px;color:#1d4f76;background-color:#f7f8f9}.coveo-category-facet-collapse-children-svg{transform:rotate(90deg);color:#bcc3ca;width:10px;height:6px;vertical-align:2px}.coveo-category-facet-title{display:inline-block}.coveo-category-facet-header-wait-animation{margin-left:10px;position:relative;display:inline-block;width:18px;height:20px}.coveo-category-facet-header-wait-animation .coveo-category-facet-header-wait-animation-svg{color:#1d4f76;display:inline-block;vertical-align:middle;animation-name:coveo-spin;animation-timing-function:linear;animation-duration:1s;animation-iteration-count:infinite}.coveo-category-facet-more-less-container{width:100%;background:#f7f8f9;text-align:center;border-bottom-left-radius:2px;border-bottom-right-radius:2px}.coveo-category-facet-less,.coveo-category-facet-more{cursor:pointer;height:15px}.coveo-category-facet-less:focus,.coveo-category-facet-less:hover,.coveo-category-facet-more:focus,.coveo-category-facet-more:hover{background:#bcc3ca;outline:none}.coveo-category-facet-header-eraser{float:right}.coveo-category-facet-non-empty-path .coveo-category-facet-header-eraser{visibility:visible}.coveo-category-facet-all-categories{padding:5px 19px 5px 20px;vertical-align:middle;line-height:22px;cursor:pointer}.coveo-category-facet-all-categories:focus,.coveo-category-facet-all-categories:hover{background-color:#e6ecf0}.coveo-category-facet-ellipsis-caption{padding:5px 19px 5px 20px;padding-left:36px}.coveo-category-facet-breadcrumb{display:block}.coveo-category-facet-breadcrumb-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-category-facet-breadcrumb-values{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px}.coveo-category-facet-breadcrumb-values:visited,.coveo-category-facet-breadcrumb-values:visited:hover{color:#609}.coveo-category-facet-breadcrumb-values:hover,.coveo-category-facet-breadcrumb-values:hover a{text-decoration:underline}.coveo-category-facet-breadcrumb-values.coveo-selected *{color:#0059b3;color:#296896}.coveo-category-facet-search-container{padding:0 20px;height:32px;line-height:30px;margin:5px 0}.coveo-category-facet-search-container .coveo-facet-search{margin:0}.coveo-category-facet-search-container .coveo-facet-search-results{cursor:auto}.coveo-category-facet-search-container+.coveo-category-facet-values{margin-top:0}.CoveoCategoryFacet:not(.coveo-category-facet-searching) .coveo-category-facet-search-container:not(.coveo-category-facet-search-without-button){outline:none}.CoveoCategoryFacet:not(.coveo-category-facet-searching) .coveo-category-facet-search-container:not(.coveo-category-facet-search-without-button):focus,.CoveoCategoryFacet:not(.coveo-category-facet-searching) .coveo-category-facet-search-container:not(.coveo-category-facet-search-without-button):hover{background-color:#e6ecf0}.coveo-category-facet-search-icon{vertical-align:middle;width:18px;height:18px;margin-right:15px;display:inline-block;bottom:1px;color:grey;border:thin solid #7e8c9a;border-radius:2px;border-style:dashed}.coveo-category-facet-search-icon-svg{color:grey;width:16px;height:11px;bottom:7px;position:relative}.coveo-category-facet-search-icon-svg .coveo-more-svg{fill:grey}.coveo-category-facet-search-without-button .coveo-category-facet-search-placeholder,.coveo-category-facet-searching .coveo-category-facet-search-placeholder{display:none}.coveo-category-facet-search-without-button .coveo-facet-search,.coveo-category-facet-searching .coveo-facet-search{display:block}.coveo-category-facet-search-placeholder{cursor:pointer}.coveo-category-facet-search-label{vertical-align:middle;display:inline-block;color:#0059b3}.coveo-category-facet-search-value{font-size:12px;padding:5px 10px;cursor:pointer}.coveo-category-facet-search-value:hover{background-color:#e6ecf0;box-pack:distribute;-moz-justify-content:space-around;-ms-justify-content:space-around;-o-justify-content:space-around;justify-content:space-around;-ms-flex-pack:distribute}.coveo-category-facet-search-first-row{display:-moz-flex;display:-ms-flexbox;display:flex;box-pack:justify;-moz-justify-content:space-between;-ms-justify-content:space-between;-o-justify-content:space-between;justify-content:space-between;-ms-flex-pack:justify}.coveo-category-facet-search-value-caption{line-height:17px}.coveo-category-facet-search-value-number{color:#67768b}.coveo-category-facet-search-path{display:block;font-size:11px;display:-moz-flex;display:-ms-flexbox;display:flex}.coveo-category-facet-search-path-parents{color:#67768b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:5px;direction:rtl}.coveo-category-facet-search-path-last-value{white-space:nowrap}.coveo-category-facet-search-second-row{height:13px}.CoveoResult.coveo-omnibox-selectable{padding:10px 10px 10px 15px;margin:0}.CoveoResult .coveo-no-thumbnail{display:none}.CoveoResult .coveo-date{float:right;font-size:13px;margin-left:10px;padding-top:3px}.CoveoResult .coveo-title{display:block;font-size:16px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;line-height:24px}.CoveoResult .coveo-title>*{vertical-align:middle}.CoveoResult .coveo-title .CoveoResultLink{margin-right:5px;display:inline;overflow:hidden;white-space:normal}.CoveoResult .coveo-title .CoveoResultLink:after{content:\"\\A0\";white-space:nowrap;visibility:hidden}.CoveoResult .coveo-excerpt{max-width:600px;font-size:14px;padding:5px 0 8px}.CoveoResult a{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoResult a:visited,.CoveoResult a:visited:hover{color:#609}.CoveoResult a:hover,.CoveoResult a:hover a{text-decoration:underline}.CoveoResult a.coveo-selected *{color:#0059b3}.CoveoResult .coveo-badge{display:inline-block;padding:4px 6px;vertical-align:middle;font-size:12px}.CoveoResult .CoveoBadge .coveo-value{display:inline-block;vertical-align:middle;border-radius:1em;line-height:1.25em;margin-right:8px}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:visited,.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:visited:hover{color:#609}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:hover,.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:hover a{text-decoration:underline}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable.coveo-selected *{color:#0059b3}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-icon{position:relative;display:inline-block;width:16px;height:16px;margin-right:2px;vertical-align:middle}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-icon:before{content:\"\";display:block;position:absolute;left:2px;top:3px;width:12px;height:10px;transform:rotate(-45deg);-ms-transform:rotate(-45deg);border:2px solid;border-right:none;-webkit-backface-visibility:hidden;-webkit-border-top-left-radius:2px;-webkit-border-bottom-left-radius:2px;-moz-border-radius-topleft:2px;-moz-border-radius-bottomleft:2px;border-top-left-radius:2px;border-bottom-left-radius:2px;box-sizing:border-box}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-icon:after{content:\"\";display:block;position:absolute;right:0;top:0;width:7px;height:7px;border:2px solid;border-bottom:none;border-left:none;border-top-right-radius:3px;box-sizing:border-box}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-label{vertical-align:middle}.CoveoResult .coveo-selectable-link{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoResult .coveo-selectable-link:visited,.CoveoResult .coveo-selectable-link:visited:hover{color:#609}.CoveoResult .coveo-selectable-link:hover,.CoveoResult .coveo-selectable-link:hover a{text-decoration:underline}.CoveoResult .coveo-selectable-link.coveo-selected *{color:#0059b3}.CoveoResult .coveo-field .coveo-label{font-weight:400}.CoveoResult .CoveoResultFolding .coveo-child-result .CoveoQuickview{margin-left:5px;display:inline-block}.CoveoResult .CoveoResultFolding .coveo-child-result .CoveoQuickview .coveo-icon-for-quickview-svg{margin-top:0}.CoveoResult.coveo-is-recommendation{box-shadow:0 0 1px 1px #263e55}.coveo-list-layout.CoveoResult{border-bottom:thin solid #bcc3ca;padding:16px 0 16px 16px}.coveo-card-layout{margin-right:-20px}.coveo-card-layout.CoveoResult{overflow:hidden;display:flex;position:relative;font-size:.9em;width:300px;-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1;margin:0 20px 20px 0;border:thin solid #bcc3ca;border-radius:2px}.coveo-card-layout.CoveoResult .coveo-media-max-width-480{margin:0 0 20px}@media (max-width:480px){.coveo-card-layout.CoveoResult{margin:0 0 20px}}.coveo-card-layout.CoveoResult.coveo-clickable{cursor:pointer}.coveo-card-layout.CoveoResult.coveo-clickable:hover{box-shadow:0 0 0 2px #009ddc;border-color:#009ddc}.coveo-card-layout.CoveoResult .coveo-result-row:first-child{margin-top:0}.coveo-card-layout.CoveoResult.coveo-result-frame,.coveo-card-layout.CoveoResult .coveo-result-frame{display:flex;padding:20px;flex-direction:column;width:100%;height:auto}.coveo-card-layout.CoveoResult .CoveoResultLink{font-size:16px;line-height:21px}.coveo-card-layout:empty{width:300px;height:0;-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1;margin-right:20px}.coveo-card-layout.coveo-with-inline-ranking-info{-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}.coveo-table-layout{display:table-row}.coveo-table-layout td{display:table-cell;padding:9px 15px;white-space:nowrap;border-bottom:thin solid #bcc3ca;overflow:hidden;text-overflow:ellipsis}.coveo-table-layout th{text-align:left;font-size:12px;color:#1d4f76;font-weight:700;border-bottom:thin solid #bcc3ca;padding:7px 15px}.coveo-table-layout:hover td{background-color:#e6ecf0}.coveo-table-layout .coveo-relevance-inspector-inline-ranking{display:table-cell;overflow:auto}.coveo-card-overlay a{color:#0059b3;text-decoration:none;cursor:pointer;color:#f7f8f9;text-decoration:underline}.coveo-card-overlay a:visited,.coveo-card-overlay a:visited:hover{color:#609;color:#f7f8f9}.coveo-card-overlay a:hover,.coveo-card-overlay a:hover a{text-decoration:underline}.coveo-card-overlay a.coveo-selected *{color:#0059b3;color:#f7f8f9}.coveo-result-frame,.CoveoResult.coveo-result-frame{margin-left:0;display:block;width:100%;height:100%}.coveo-result-frame .coveo-icon.coveo-icon-with-caption-overlay,.CoveoResult.coveo-result-frame .coveo-icon.coveo-icon-with-caption-overlay{overflow:visible;position:relative}.coveo-result-frame .coveo-result-row,.CoveoResult.coveo-result-frame .coveo-result-row{width:100%;display:table;table-layout:fixed;margin:.25em 0}.coveo-result-frame .coveo-result-cell,.CoveoResult.coveo-result-frame .coveo-result-cell{line-height:1.25em;display:table-cell;vertical-align:top}.coveo-result-frame .coveo-result-cell>*,.CoveoResult.coveo-result-frame .coveo-result-cell>*{vertical-align:middle}.coveo-result-frame .coveo-result-cell .CoveoTemplateLoader,.CoveoResult.coveo-result-frame .coveo-result-cell .CoveoTemplateLoader{display:inline-block}.coveo-result-frame .coveo-result-cell.coveo-no-wrap,.CoveoResult.coveo-result-frame .coveo-result-cell.coveo-no-wrap{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.coveo-result-frame .CoveoThumbnail,.CoveoResult.coveo-result-frame .CoveoThumbnail{max-width:100%}.CoveoResultList.coveo-faded{opacity:.5}.CoveoResultList{margin-top:15px;margin-bottom:15px;outline:none}.CoveoResultList .coveo-fade-out{opacity:.5;transition:opacity .5s}.CoveoResultList .coveo-wait-animation{display:block;margin:10px auto}.CoveoResultList.coveo-hidden{display:none}.CoveoResultList[data-layout=table]{overflow-x:auto;margin-bottom:20px}.coveo-card-layout-container{display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-20px}.coveo-card-layout-container .coveo-media-max-width-480{margin-right:0}@media (max-width:480px){.coveo-card-layout-container{margin-right:0}}.coveo-table-layout-container{display:table;white-space:nowrap;table-layout:fixed;border-collapse:collapse;width:100%}.coveo-result-list-table-footer{border-bottom:none}.coveo-media-max-width-800 .CoveoResultList{margin-left:10px;margin-right:10px}.coveo-media-max-width-800 .coveo-table-layout-container{table-layout:auto}.coveo-media-max-width-800 .coveo-table-layout-container td{max-width:300px}@media (max-width:800px){.CoveoResultList{margin-left:10px;margin-right:10px}.coveo-table-layout-container{table-layout:auto}.coveo-table-layout-container td{max-width:300px}}.coveo-facet-settings-popup{position:absolute;overflow:hidden;border:thin solid #bcc3ca;border-radius:2px;z-index:999;background-color:#fff}.coveo-facet-settings-section{clear:both;white-space:nowrap}.coveo-facet-settings-section svg{margin:10px}.coveo-facet-settings-items,.coveo-facet-settings-section .coveo-icon-container{display:inline-block;vertical-align:middle}.coveo-facet-settings-items{padding:3px;overflow:hidden;font-size:12px}.coveo-facet-settings-item{white-space:nowrap;padding:10px;cursor:pointer;-moz-padding-end:70px}.coveo-facet-settings-item.coveo-selected{font-weight:700}.coveo-facet-settings-disabled .coveo-facet-settings-item{cursor:default;opacity:.7}.coveo-facet-settings-disabled .coveo-facet-settings-item:hover{background:#fff}.coveo-facet-settings-section-sort .coveo-facet-settings-section-sort-svg{float:none}.coveo-facet-settings-section-sort:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-facet-settings-section-sort:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-facet-settings-section-sort.coveo-facet-settings-section{margin-bottom:15px}.coveo-facet-settings-section-sort.coveo-facet-settings-section .coveo-icon-container{vertical-align:top}.coveo-facet-settings-section-sort-svg{width:15px;height:14px;color:#1d4f76}.coveo-facet-settings-section-direction-ascending{cursor:pointer}.coveo-facet-settings-section-direction-ascending.coveo-facet-settings-disabled{cursor:inherit}.coveo-facet-settings-section-direction-ascending .coveo-facet-settings-section-direction-ascending-svg{float:none}.coveo-facet-settings-section-direction-ascending:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-facet-settings-section-direction-ascending:hover.coveo-facet-settings-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-facet-settings-section-direction-ascending-svg{width:15px;height:12px;color:#1d4f76}.coveo-facet-settings-section-direction-descending{cursor:pointer}.coveo-facet-settings-section-direction-descending.coveo-facet-settings-disabled{cursor:inherit}.coveo-facet-settings-section-direction-descending .coveo-facet-settings-section-direction-descending-svg{float:none}.coveo-facet-settings-section-direction-descending:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-facet-settings-section-direction-descending:hover.coveo-facet-settings-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-facet-settings-section-direction-descending-svg{width:15px;height:12px;color:#1d4f76}.coveo-facet-settings-section-save-state{border-top:thin solid #bcc3ca;cursor:pointer}.coveo-facet-settings-section-save-state .coveo-facet-settings-section-save-state-svg{float:none}.coveo-facet-settings-section-save-state:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-facet-settings-section-save-state:hover.coveo-facet-settings-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-facet-settings-section-save-state-svg{width:16px;height:16px;color:#1d4f76}.coveo-facet-settings-section-clear-state{border-top:thin solid #bcc3ca;cursor:pointer}.coveo-facet-settings-section-clear-state .coveo-facet-settings-section-clear-state-svg{float:none}.coveo-facet-settings-section-clear-state:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-facet-settings-section-clear-state:hover.coveo-facet-settings-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-facet-settings-section-clear-state-svg{width:16px;height:16px;color:#1d4f76}.coveo-facet-settings-section-hide{border-top:thin solid #bcc3ca;margin:3px;cursor:pointer}.coveo-facet-settings-section-hide .coveo-facet-settings-section-hide-svg{float:none}.coveo-facet-settings-section-hide:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-facet-settings-section-hide:hover.coveo-facet-settings-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-facet-settings-section-hide-svg{width:16px;height:16px;color:#1d4f76}.coveo-facet-settings-section-show{border-top:thin solid #bcc3ca;cursor:pointer}.coveo-facet-settings-section-show .coveo-facet-settings-section-show-svg{float:none}.coveo-facet-settings-section-show:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-facet-settings-section-show:hover.coveo-facet-settings-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-facet-settings-section-show-svg{width:16px;height:16px;color:#1d4f76}.coveo-facet-settings-section-sort-title{font-size:12px;font-weight:700;color:#67768b;padding:10px}.coveo-slider-container{-ms-touch-action:none;touch-action:none;width:100%;height:85px;position:relative;padding:25px 20px 20px}.coveo-slider-container>div{height:50px;position:relative}.coveo-slider-container svg{overflow:hidden}.coveo-slider-line{background-color:#fff;border:thin solid #bcc3ca;border-radius:2px;position:absolute;width:100%;height:10px;top:3px}.coveo-slider-line.coveo-active{z-index:1;background-color:#67768b}.coveo-slider-button{border-radius:2px;cursor:pointer;display:inline-block;width:15px;height:16px;z-index:2;position:absolute;margin-left:-7px}.coveo-slider-button,.coveo-slider-button.coveo-active,.coveo-slider-button:hover{background-color:#296896}.coveo-slider-button:after{width:2px;border-left:1px solid #fff;right:4px}.coveo-slider-button:after,.coveo-slider-button:before{content:\"\";height:10px;border-right:1px solid #fff;position:absolute;top:3px}.coveo-slider-button:before{left:4px}.coveo-slider-caption{position:absolute;top:25px;left:0;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.coveo-slider-tooltip{white-space:nowrap;padding:10px;background-color:#e6ecf0;border:thin solid #bcc3ca;border-radius:2px;z-index:10;position:absolute;margin-top:30px}.coveo-slider-tooltip .coveo-slider-tooltip-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #bcc3ca;top:38px;position:absolute}.coveo-slider-tooltip .coveo-caption{font-size:12px}.coveo-slider-tooltip .coveo-count{font-size:12px;margin-left:5px}.coveo-slider-container.coveo-with-graph{height:135px}.coveo-slider-container.coveo-with-graph>div{height:100px}.coveo-slider-container.coveo-with-graph svg{position:absolute;left:0;top:-5px}.coveo-slider-container.coveo-with-graph svg .coveo-bar{fill:#67768b;shape-rendering:crispEdges}.coveo-slider-container.coveo-with-graph svg .coveo-bar.coveo-active{fill:#296896}.coveo-slider-container.coveo-with-graph svg .coveo-bar:hover{fill:#263e55;cursor:pointer}.coveo-slider-container.coveo-with-graph .coveo-slider-line{top:60px}.coveo-slider-container.coveo-with-graph .coveo-slider-button{top:57px}.coveo-slider-container.coveo-with-graph .coveo-slider-caption{top:80px}.CoveoFacetSlider.coveo-disabled .coveo-slider-line{background-color:#bcc3ca}.CoveoFacetSlider.coveo-disabled .coveo-slider-button{background-color:#296896;box-shadow:none}.CoveoFacetSlider.coveo-disabled-empty,.CoveoFacetSlider.coveo-facet-collapsed .coveo-slider-container{display:none}.coveo-executing-query .coveo-slider-container{opacity:.5}.coveo-top-field-suggestion-header{width:100%;padding:10px;color:#1d4f76}.CoveoFieldTable{border:thin solid #bcc3ca;border-radius:2px;width:100%;background-color:#f7f8f9;padding-bottom:10px;position:relative;word-break:break-all;margin-top:1px;border-collapse:separate;margin-bottom:20px}.CoveoFieldTable td,.CoveoFieldTable th{font-size:14px}.CoveoFieldTable td{width:99%;padding:10px 20px 0 0}.CoveoFieldTable th{text-align:left;font-weight:400;white-space:nowrap;padding:10px 10px 0 20px}.CoveoFieldTable .coveo-clickable{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoFieldTable .coveo-clickable:visited,.CoveoFieldTable .coveo-clickable:visited:hover{color:#609}.CoveoFieldTable .coveo-clickable:hover,.CoveoFieldTable .coveo-clickable:hover a{text-decoration:underline}.CoveoFieldTable .coveo-clickable.coveo-selected *{color:#0059b3}.CoveoFieldTable .coveo-clickable.coveo-selected{font-weight:700}.coveo-field-table-toggle{color:#0059b3;text-decoration:none;cursor:pointer;margin:0 5px 5px 0}.coveo-field-table-toggle:visited,.coveo-field-table-toggle:visited:hover{color:#609}.coveo-field-table-toggle:hover,.coveo-field-table-toggle:hover a{text-decoration:underline}.coveo-field-table-toggle.coveo-selected *{color:#0059b3}.coveo-field-table-toggle .coveo-field-table-toggle-caption{margin-right:5px}.coveo-field-table-toggle-container{position:relative;overflow:hidden;height:0;transition:height .5s ease-in-out}.coveo-field-table-toggle-container.coveo-no-transition{transition:none}.coveo-field-table-toggle-down{position:relative;top:2px}.coveo-field-table-toggle-down-svg{color:#1d4f76;width:10px;height:6px;transition:fill-opacity .5s;fill-opacity:1}.coveo-field-table-toggle-down-svg.coveo-opened{fill-opacity:0}.coveo-field-table-toggle-up{position:absolute;bottom:44px;right:10px;margin:0;height:0}.coveo-field-table-toggle-up-svg{color:#1d4f76;width:10px;height:6px;transition:fill-opacity 0s;fill-opacity:0}.coveo-field-table-toggle-up-svg.coveo-opened{fill-opacity:1;height:13px;transition:fill-opacity .4s cubic-bezier(1,0,1,0)}.CoveoFieldValue .coveo-clickable{color:#0059b3;text-decoration:none;cursor:pointer;outline:1px solid transparent;outline-offset:3px}.CoveoFieldValue .coveo-clickable:visited,.CoveoFieldValue .coveo-clickable:visited:hover{color:#609}.CoveoFieldValue .coveo-clickable:hover,.CoveoFieldValue .coveo-clickable:hover a{text-decoration:underline}.CoveoFieldValue .coveo-clickable.coveo-selected *{color:#0059b3}.CoveoFieldValue .coveo-clickable.coveo-selected{font-weight:700}.CoveoFieldValue.coveo-with-label{display:inline-block}.CoveoFieldValue .coveo-field-caption{color:#000;margin-right:10px}.coveo-card-overlay .CoveoFieldTable{background-color:transparent;border:none;padding:0;margin:10px 0 0}.coveo-card-overlay .CoveoFieldTable th{color:#bcc3ca}.coveo-card-overlay .coveo-clickable{color:#0059b3;text-decoration:none;cursor:pointer;color:#f7f8f9;text-decoration:underline}.coveo-card-overlay .coveo-clickable:visited,.coveo-card-overlay .coveo-clickable:visited:hover{color:#609;color:#f7f8f9}.coveo-card-overlay .coveo-clickable:hover,.coveo-card-overlay .coveo-clickable:hover a{text-decoration:underline}.coveo-card-overlay .coveo-clickable.coveo-selected *{color:#0059b3;color:#f7f8f9}.coveo-hidden-query-breadcrumb-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-hidden-query-breadcrumb-value{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px}.coveo-hidden-query-breadcrumb-value:visited,.coveo-hidden-query-breadcrumb-value:visited:hover{color:#609}.coveo-hidden-query-breadcrumb-value:hover,.coveo-hidden-query-breadcrumb-value:hover a{text-decoration:underline}.coveo-hidden-query-breadcrumb-value.coveo-selected *{color:#0059b3;color:#296896}.coveo-hidden-query-breadcrumb-clear{margin-left:5px}.coveo-hidden-query-breadcrumb-clear svg{width:9px;height:9px}.CoveoHierarchicalFacet ul.coveo-facet-values{overflow-x:auto}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value{padding-left:30px;position:relative}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs.coveo-has-childs-selected:not(.coveo-selected) .coveo-facet-value-checkbox-svg{width:12px;height:14px;visibility:visible;position:relative;bottom:2px;left:0}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs.coveo-has-childs-selected:not(.coveo-selected) .coveo-line-svg{fill:rgba(188,195,202,.74)}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs .coveo-has-childs-toggle{position:absolute;display:inline-block;top:8px;left:7px}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs .coveo-has-childs-toggle .coveo-hierarchical-facet-collapse-svg,.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs .coveo-has-childs-toggle .coveo-hierarchical-facet-expand-svg{width:16px;height:16px;color:#1d4f76}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs .coveo-has-childs-toggle .coveo-hierarchical-facet-collapse-svg{display:none}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs .coveo-has-childs-toggle:hover{cursor:pointer}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs.coveo-open .coveo-hierarchical-facet-collapse-svg{display:inline-block}.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-has-childs.coveo-open .coveo-hierarchical-facet-expand-svg,.CoveoHierarchicalFacet ul.coveo-facet-values .coveo-facet-value.coveo-inactive{display:none}.coveo-hierarchical-breadcrumb-separator{content:\"\";display:inline-block;top:2px;left:3px;position:relative;margin-left:2px;margin-right:2px;height:0;width:0;border:5px solid transparent;border-left-color:#b0b3ae}.CoveoMatrix{margin:10px 5px}.coveo-matrix-title{text-align:center;font-size:14px;font-weight:700;margin:10px 0;color:#1d4f76;font-size:16px}.coveo-matrix{display:table;table-layout:fixed;width:100%;margin-left:auto;margin-right:auto;border-spacing:0;border-collapse:collapse}.coveo-matrix-row{display:table-row}.coveo-matrix-row .matrix-first-column{text-align:left}.matrix-header-row,.matrix-total-row{color:#1d4f76;font-weight:700;height:45px;background-color:#f7f8f9}.matrix-total-row{font-weight:700}.coveo-matrix-cell{display:table-cell;padding:5px;text-align:right;overflow:hidden;vertical-align:middle;border:thin solid #bcc3ca}.coveo-matrix-cell:hover{cursor:pointer}.coveo-matrix-unimportant{color:#d3d3d3}.matrix-results-preview-container{position:absolute;z-index:1;border:thin solid #bcc3ca;border-radius:2px;background-color:#fff}.matrix-results-preview-container .coveo-result-frame{border-bottom:thin solid #bcc3ca;text-align:left;overflow:hidden;padding:5px}.matrix-results-preview-container .coveo-result-cell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.magic-box{-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1;position:relative;text-align:left;color:#212121}.magic-box .magic-box-input{background:#fff;height:48px;overflow:hidden;position:relative}.magic-box .magic-box-input .magic-box-underlay,.magic-box .magic-box-input>input{color:#212121;text-align:left;padding:12px 49px 12px 12px;text-indent:0;font-family:arial,sans-serif;font-size:16px;line-height:24px;position:absolute;top:0;left:0;width:100%;height:48px;white-space:pre;overflow:auto;box-sizing:border-box;display:block}.magic-box .magic-box-input input{background:none;border:none;resize:none;outline:0}.magic-box .magic-box-input input::-ms-clear{width:0;height:0}.magic-box .magic-box-input .magic-box-underlay{color:transparent;overflow:hidden}.magic-box .magic-box-input .magic-box-underlay>span{text-indent:0}.magic-box .magic-box-input .magic-box-underlay span{display:inline-block;vertical-align:top}.magic-box .magic-box-input .magic-box-underlay span[data-value=\"\"]{height:24px}.magic-box .magic-box-input .magic-box-underlay .magic-box-ghost-text{visibility:hidden;color:#bdbdbd}.magic-box .magic-box-input .magic-box-underlay .magic-box-error{border-bottom:2px solid #f44336}.magic-box .magic-box-input .magic-box-underlay .magic-box-error.magic-box-error-empty{position:relative}.magic-box .magic-box-input .magic-box-underlay .magic-box-error.magic-box-error-empty:before{content:\" \";border-bottom:2px solid #f44336;position:absolute}.magic-box .magic-box-input .magic-box-underlay:after{content:\"\";display:inline-block}.magic-box .magic-box-clear{position:relative;float:right;height:48px;line-height:48px;text-align:center;font-size:24px;transition:visibility .3s,width .3s;cursor:pointer;background:#fff;width:0;visibility:hidden;overflow:hidden}.magic-box .magic-box-clear .magic-box-icon:before{color:#9e9e9e;font-family:arial,sans-serif;content:\"X\";font-size:24px}.magic-box .magic-box-clear:before{content:\"\";border-left:1px solid #e0e0e0;position:absolute;top:15%;bottom:15%;left:0}.magic-box.magic-box-notEmpty .magic-box-clear{width:48px;visibility:visible}.magic-box.magic-box-hasFocus .magic-box-underlay .magic-box-ghost-text{visibility:visible}.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion{display:block}.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion .coveo-magicbox-suggestions,.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container{border:thin solid #7e8c9a}.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container .coveo-magicbox-suggestions{border:none}.magic-box .magic-box-suggestions{clear:both;position:absolute;top:100%;left:-1px;right:-1px;overflow:visible;background:#fff;z-index:1;display:none;font-family:arial,sans-serif}.magic-box .magic-box-suggestions .magic-box-suggestion,.magic-box .magic-box-suggestions .magic-box-suggestion-seperator{opacity:1;transition:opacity .3s}.magic-box .magic-box-suggestions.magic-box-suggestions-loading .magic-box-suggestion,.magic-box .magic-box-suggestions.magic-box-suggestions-loading .magic-box-suggestion-seperator{opacity:0}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator{padding:12px 12px 0;line-height:24px;font-size:16px;font-weight:700;background:#fff;overflow:hidden;height:36px;border-top:1px solid #e0e0e0;color:#9e9e9e}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator:first-child{border-top:none}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator .magic-box-suggestion-seperator-label{float:left;margin-right:12px;max-width:75%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator:after{content:\"\";display:block;position:relative;top:50%;height:1px;overflow:hidden;background-color:#e0e0e0}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator+.magic-box-suggestion{border-top:none}.magic-box .magic-box-suggestions .magic-box-suggestion{cursor:pointer;line-height:24px;padding:12px;font-size:16px;background:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-top:1px solid #fafafa;color:#212121}.magic-box .magic-box-suggestions .magic-box-suggestion .magic-box-hightlight{font-weight:700;color:#000}.magic-box .magic-box-suggestions .magic-box-suggestion:first-child{border-top:none}.magic-box .magic-box-suggestions .magic-box-suggestion.magic-box-selected{background:#e0f7fa!important}.magic-box .magic-box-suggestions .magic-box-suggestion:hover{background:#f5f5f5}.magic-box.magic-box-inline{overflow:hidden}.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion{position:relative;display:block;top:0;left:0;right:0}.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion .coveo-magicbox-suggestions,.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container{border:none;border-top:thin solid #7e8c9a}.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container .coveo-magicbox-suggestions{border-top:none}\\ .coveo-waiting-for-first-query .coveo-omnibox{z-index:0}.CoveoOmnibox.magic-box .coveo-omnibox-hightlight{font-weight:700;color:#000}.CoveoOmnibox.magic-box .magic-box-suggestions{z-index:3}.CoveoOmnibox.magic-box .coveo-omnibox-hightlight2{font-style:italic;color:#000}.CoveoOmnibox.magic-box .magic-box-suggestion{font-weight:700;color:#000}.CoveoOmnibox.magic-box .magic-box-suggestion .coveo-omnibox-hightlight,.CoveoOmnibox.magic-box .magic-box-suggestion .coveo-omnibox-hightlight2{font-weight:400}.CoveoOmnibox.magic-box .magic-box-suggestion .coveo-omnibox-suggestion-category,.CoveoOmnibox.magic-box .magic-box-suggestion .coveo-omnibox-suggestion-results-count{font-weight:400;color:#757575}.CoveoOmnibox.magic-box .magic-box-suggestion .coveo-omnibox-suggestion-category .coveo-omnibox-hightlight,.CoveoOmnibox.magic-box .magic-box-suggestion .coveo-omnibox-suggestion-results-count .coveo-omnibox-hightlight{color:#757575}.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay{display:flex;align-items:center}.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldQuery][data-success=true],.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldSimpleQuery][data-success=true]{position:relative}.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldQuery][data-success=true]:before,.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldSimpleQuery][data-success=true]:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background:#c8e6c9;border-top-left-radius:4px;border-bottom-left-radius:4px;left:1px;border-top-right-radius:4px;border-bottom-right-radius:4px;right:1px}.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldQuery][data-success=false]>[data-success=true],.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldSimpleQuery][data-success=false]>[data-success=true]{position:relative}.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldQuery][data-success=false]>[data-success=true]:before,.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldSimpleQuery][data-success=false]>[data-success=true]:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background:#ffecb3}.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldQuery][data-success=false]>[data-success=true][data-id=FieldQuery_0],.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldSimpleQuery][data-success=false]>[data-success=true][data-id=FieldQuery_0]{position:relative}.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldQuery][data-success=false]>[data-success=true][data-id=FieldQuery_0]:before,.CoveoOmnibox.magic-box .magic-box-input .magic-box-underlay [data-id=FieldSimpleQuery][data-success=false]>[data-success=true][data-id=FieldQuery_0]:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background:#ffecb3;border-top-left-radius:4px;border-bottom-left-radius:4px;left:1px}.CoveoOmnibox.magic-box.coveo-search-as-you-type .magic-box-ghost-text{display:none}.CoveoOmnibox.magic-box .coveo-omnibox-selectable{cursor:pointer}.CoveoOmnibox.magic-box .coveo-omnibox-selectable.coveo-omnibox-selected{background-color:#e6ecf0}.CoveoOmnibox.magic-box .coveo-omnibox-facet-value{width:100%;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:5px 10px;margin:0}.CoveoOmnibox.magic-box .coveo-omnibox-facet-value li.coveo-facet-value{list-style-type:none}.CoveoOmnibox.magic-box .coveo-omnibox-facet-value .coveo-facet-value-label-wrapper>*{vertical-align:middle}.CoveoOmnibox.magic-box .coveo-omnibox-facet-header{width:100%;padding:5px;height:26px;color:#2c5985}.CoveoOmnibox.magic-box .coveo-omnibox-facet-header .coveo-icon{margin-right:6px;vertical-align:text-bottom}.CoveoOmnibox.magic-box .coveo-omnibox-section{vertical-align:middle;margin-bottom:2px}.CoveoOmnibox.magic-box .coveo-omnibox-header{height:26px;color:#0065cb;margin-top:4px;margin-bottom:2px}.CoveoOmnibox.magic-box .coveo-omnibox-header .coveo-text{padding:6px 15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.CoveoOmnibox.magic-box .coveo-facet-value-caption{font-weight:700}.CoveoOmnibox.magic-box .coveo-facet-value-caption .coveo-highlight{font-weight:400}.magic-box{-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1;position:relative;text-align:left;color:#212121}.magic-box .magic-box-input{background:#fff;height:48px;overflow:hidden;position:relative}.magic-box .magic-box-input .magic-box-underlay,.magic-box .magic-box-input>input{color:#212121;text-align:left;padding:12px 49px 12px 12px;text-indent:0;font-family:arial,sans-serif;font-size:16px;line-height:24px;position:absolute;top:0;left:0;width:100%;height:48px;white-space:pre;overflow:auto;box-sizing:border-box;display:block}.magic-box .magic-box-input input{background:none;border:none;resize:none;outline:0}.magic-box .magic-box-input input::-ms-clear{width:0;height:0}.magic-box .magic-box-input .magic-box-underlay{color:transparent;overflow:hidden}.magic-box .magic-box-input .magic-box-underlay>span{text-indent:0}.magic-box .magic-box-input .magic-box-underlay span{display:inline-block;vertical-align:top}.magic-box .magic-box-input .magic-box-underlay span[data-value=\"\"]{height:24px}.magic-box .magic-box-input .magic-box-underlay .magic-box-ghost-text{visibility:hidden;color:#bdbdbd}.magic-box .magic-box-input .magic-box-underlay .magic-box-error{border-bottom:2px solid #f44336}.magic-box .magic-box-input .magic-box-underlay .magic-box-error.magic-box-error-empty{position:relative}.magic-box .magic-box-input .magic-box-underlay .magic-box-error.magic-box-error-empty:before{content:\" \";border-bottom:2px solid #f44336;position:absolute}.magic-box .magic-box-input .magic-box-underlay:after{content:\"\";display:inline-block}.magic-box .magic-box-clear{position:relative;float:right;height:48px;line-height:48px;text-align:center;font-size:24px;transition:visibility .3s,width .3s;cursor:pointer;background:#fff;width:0;visibility:hidden;overflow:hidden}.magic-box .magic-box-clear .magic-box-icon:before{color:#9e9e9e;font-family:arial,sans-serif;content:\"X\";font-size:24px}.magic-box .magic-box-clear:before{content:\"\";border-left:1px solid #e0e0e0;position:absolute;top:15%;bottom:15%;left:0}.magic-box.magic-box-notEmpty .magic-box-clear{width:48px;visibility:visible}.magic-box.magic-box-hasFocus .magic-box-underlay .magic-box-ghost-text{visibility:visible}.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion{display:block}.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion .coveo-magicbox-suggestions,.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container{border:thin solid #7e8c9a}.magic-box.magic-box-hasFocus .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container .coveo-magicbox-suggestions{border:none}.magic-box .magic-box-suggestions{clear:both;position:absolute;top:100%;left:-1px;right:-1px;overflow:visible;background:#fff;z-index:1;display:none;font-family:arial,sans-serif}.magic-box .magic-box-suggestions .magic-box-suggestion,.magic-box .magic-box-suggestions .magic-box-suggestion-seperator{opacity:1;transition:opacity .3s}.magic-box .magic-box-suggestions.magic-box-suggestions-loading .magic-box-suggestion,.magic-box .magic-box-suggestions.magic-box-suggestions-loading .magic-box-suggestion-seperator{opacity:0}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator{padding:12px 12px 0;line-height:24px;font-size:16px;font-weight:700;background:#fff;overflow:hidden;height:36px;border-top:1px solid #e0e0e0;color:#9e9e9e}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator:first-child{border-top:none}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator .magic-box-suggestion-seperator-label{float:left;margin-right:12px;max-width:75%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator:after{content:\"\";display:block;position:relative;top:50%;height:1px;overflow:hidden;background-color:#e0e0e0}.magic-box .magic-box-suggestions .magic-box-suggestion-seperator+.magic-box-suggestion{border-top:none}.magic-box .magic-box-suggestions .magic-box-suggestion{cursor:pointer;line-height:24px;padding:12px;font-size:16px;background:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-top:1px solid #fafafa;color:#212121}.magic-box .magic-box-suggestions .magic-box-suggestion .magic-box-hightlight{font-weight:700;color:#000}.magic-box .magic-box-suggestions .magic-box-suggestion:first-child{border-top:none}.magic-box .magic-box-suggestions .magic-box-suggestion.magic-box-selected{background:#e0f7fa!important}.magic-box .magic-box-suggestions .magic-box-suggestion:hover{background:#f5f5f5}.magic-box.magic-box-inline{overflow:hidden}.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion{position:relative;display:block;top:0;left:0;right:0}.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion .coveo-magicbox-suggestions,.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container{border:none;border-top:thin solid #7e8c9a}.magic-box.magic-box-inline .magic-box-suggestions.magic-box-hasSuggestion .coveo-suggestion-container .coveo-magicbox-suggestions{border-top:none}.coveo-card-layout.CoveoResult.coveo-omnibox-selectable,.coveo-list-layout.CoveoResult.coveo-omnibox-selectable,.coveo-table-layout.CoveoResult.coveo-omnibox-selectable{padding:10px 10px 10px 36px;margin:0;box-sizing:border-box}.coveo-card-layout.CoveoResult.coveo-omnibox-result-list-element.coveo-omnibox-selectable.coveo-omnibox-selected,.coveo-list-layout.CoveoResult.coveo-omnibox-result-list-element.coveo-omnibox-selectable.coveo-omnibox-selected,.coveo-table-layout.CoveoResult.coveo-omnibox-result-list-element.coveo-omnibox-selectable.coveo-omnibox-selected{padding:7px 7px 8px 33px;background-color:#fff;border:thin solid #bcc3ca;border-width:3px}.CoveoResult.coveo-omnibox-selectable{padding:10px 10px 10px 36px;margin:0;box-sizing:border-box}.CoveoResult.coveo-omnibox-result-list-element.coveo-omnibox-selectable.coveo-omnibox-selected{padding:7px 7px 8px 33px;background-color:#fff;border:thin solid #bcc3ca;border-width:3px}.magic-box-suggestions .coveo-card-layout-container{margin-right:0}.coveo-omnibox-result-list-header{width:100%;padding:10px;color:#1d4f76}.coveo-pager-list{padding-left:0;margin:0;display:inline-block}.coveo-pager-list-item{border:thin solid #7e8c9a;border-radius:2px;margin:5px 6px;padding:4px 8px;list-style:none;display:inline-block;vertical-align:baseline;color:#0059b3;text-decoration:none;font-size:14px;cursor:pointer}.coveo-pager-list-item:visited,.coveo-pager-list-item:visited:hover{color:#609}.coveo-pager-list-item:hover,.coveo-pager-list-item:hover a{text-decoration:underline}.coveo-pager-list-item.coveo-selected *{color:#0059b3}.coveo-pager-list-item.coveo-active,.coveo-pager-list-item:hover{color:#cddee9;background-color:#1d4f76}.coveo-pager-list-item.coveo-active a,.coveo-pager-list-item:hover a{color:#cddee9}.coveo-pager-next,.coveo-pager-previous{margin:5px 6px;list-style:none;display:inline-block;vertical-align:baseline;cursor:pointer;border:none;padding:0}.coveo-pager-next:hover,.coveo-pager-previous:hover{color:#009ddc;background-color:#fff}.CoveoPager{margin-top:0;margin-left:25px;display:inline-block}.coveo-pager-next-icon-svg,.coveo-pager-previous-icon-svg{width:11px;height:20px;color:#1d4f76;vertical-align:middle}.CoveoPreferencesPanel{display:none}.CoveoResultsPreferences+.CoveoResultsFiltersPreferences{margin-top:20px}.preferences-panel-item-label{vertical-align:middle}.preferences-panel-item-label:hover{cursor:pointer}.coveo-preferences-panel-svg{width:16px;height:16px;color:#1d4f76}.CoveoPrintableUri{box-pack:start;-moz-justify-content:flex-start;-ms-justify-content:flex-start;-o-justify-content:flex-start;justify-content:flex-start;-ms-flex-pack:start;margin:2px 0 5px;font-size:12px;padding:0 2px;display:-moz-flex;display:-ms-flexbox;display:flex;position:relative}.CoveoPrintableUri.CoveoResultLink:hover{text-decoration:none;color:#296896}.CoveoPrintableUri.CoveoResultLink:hover a{text-decoration:none}.CoveoPrintableUri .coveo-printable-uri-separator{font-size:12px;margin:0 3px}.CoveoPrintableUri .coveo-hidden{display:none}.CoveoPrintableUri .coveo-printable-uri-part{color:#009ddc;margin:0;flex:0 15 auto;min-width:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0}@supports (max-width:max-content){.CoveoPrintableUri .coveo-printable-uri-part{flex:1 0 0;max-width:max-content}}.CoveoPrintableUri .coveo-printable-uri-ellipsis>button{color:#0059b3;text-decoration:none;cursor:pointer;border:none;background:none;font-family:Arial,Helvetica,sans-serif}.CoveoPrintableUri .coveo-printable-uri-ellipsis>button:visited,.CoveoPrintableUri .coveo-printable-uri-ellipsis>button:visited:hover{color:#609}.CoveoPrintableUri .coveo-printable-uri-ellipsis>button:hover,.CoveoPrintableUri .coveo-printable-uri-ellipsis>button:hover a{text-decoration:underline}.CoveoPrintableUri .coveo-printable-uri-ellipsis>button.coveo-selected *{color:#0059b3}.coveo-card-layout .CoveoPrintableUri{line-height:24px}.CoveoQueryDuration{color:#67768b}.CoveoQuerySummary{color:#67768b;text-align:left}.CoveoQuerySummary div{margin-bottom:5px}.CoveoQuerySummary ul{margin-top:0}.CoveoQuerySummary ul li{font-size:14px}.CoveoQuerySummary.coveo-hidden,.CoveoQuerySummary .coveo-show-if-no-results{display:none}.CoveoQuerySummary .coveo-show-if-no-results.coveo-no-results{display:block}.coveo-query-summary-no-results-string,.coveo-query-summary-search-tips-info{font-size:16px}.coveo-query-summary-cancel-last{font-size:14px;color:#0059b3;text-decoration:none;cursor:pointer}.coveo-query-summary-cancel-last:visited,.coveo-query-summary-cancel-last:visited:hover{color:#609}.coveo-query-summary-cancel-last:hover,.coveo-query-summary-cancel-last:hover a{text-decoration:underline}.coveo-query-summary-cancel-last.coveo-selected *{color:#0059b3}.CoveoQuickview{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoQuickview:visited,.CoveoQuickview:visited:hover{color:#609}.CoveoQuickview:hover,.CoveoQuickview:hover a{text-decoration:underline}.CoveoQuickview.coveo-selected *{color:#0059b3}.CoveoQuickview>div{position:relative}.coveo-list-layout .CoveoQuickview:hover .coveo-caption-for-icon{display:inline}.CoveoQuickview .coveo-caption-for-icon{font-size:12px;display:none;background:#263e55;color:#fff;border-radius:2px;padding:6px 16px;position:absolute;white-space:nowrap;z-index:1}.CoveoQuickview .coveo-caption-for-icon>div{border:solid;content:\"\";position:absolute;z-index:99}.CoveoQuickview .coveo-caption-for-icon[x-placement^=bottom]>div{top:-6px;border-width:0 6px 7px;border-color:#263e55 transparent}.CoveoQuickview .coveo-caption-for-icon[x-placement^=top]>div{bottom:-6px;border-width:7px 6px 0;border-color:#263e55 transparent}.CoveoQuickview .coveo-caption-for-icon[x-placement^=right]>div{left:-6px;border-width:6px 7px 6px 0;border-color:transparent #263e55}.CoveoQuickview .coveo-caption-for-icon[x-placement^=left]>div{right:-6px;left:auto;border-width:6px 0 6px 7px;border-color:transparent #263e55}.CoveoCardActionBar .CoveoQuickview{color:#fff;text-decoration:none}.CoveoCardActionBar .CoveoQuickview>*{display:flex;align-items:center}.CoveoCardActionBar .CoveoQuickview .coveo-caption-for-icon{position:relative;transform:none;display:inline;padding:0 5px;font-size:inherit}.CoveoCardActionBar .CoveoQuickview .coveo-caption-for-icon:before{display:none}.CoveoCardActionBar .CoveoQuickview .coveo-caption-for-quickview{margin-top:0;margin-left:3px;font-size:11px}.CoveoQuickviewDocument{overflow:hidden}.CoveoQuickviewDocument .coveo-quickview-document{height:100%;width:100%;display:table}.CoveoQuickviewDocument .coveo-quickview-document>*{display:table-row}.CoveoQuickviewDocument .coveo-quickview-document .coveo-iframeWrapper{height:100%;width:100%}.coveo-term-for-quickview *{vertical-align:middle;box-sizing:border-box}.coveo-term-for-quickview{margin:2px 10px 10px 0;font-weight:700;display:inline-block;cursor:pointer;border-radius:5px;border:2px solid}.coveo-term-for-quickview .coveo-term-for-quickview-down-arrow{display:inline-block;padding:5px;height:26px;position:relative;width:20px}.coveo-term-for-quickview .coveo-term-for-quickview-down-arrow .coveo-term-for-quickview-down-arrow-icon{position:absolute;top:11px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #000}.coveo-term-for-quickview .coveo-term-for-quickview-up-arrow{display:inline-block;padding:5px;height:26px;position:relative;width:20px}.coveo-term-for-quickview .coveo-term-for-quickview-up-arrow .coveo-term-for-quickview-up-arrow-icon{position:absolute;top:11px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #000}.coveo-term-for-quickview .coveo-term-for-quickview-name{font-size:14px;padding:5px 0;margin-left:5px}.coveo-quickview-left-header{padding-right:16px;text-align:left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.coveo-quickview-right-header{text-align:right;float:right}.coveo-quickview-icon{margin-right:10px;vertical-align:middle}.coveo-quickview-pop-up-reminder{color:#06c;font-size:16px;text-align:left}.coveo-quickview-time{font-size:12px;color:#4f5658;font-weight:400;vertical-align:middle}.coveo-modal-container.coveo-quick-view .coveo-modal-body{height:90%}.coveo-modal-container.coveo-quick-view .coveo-modal-body .coveo-list-layout,.coveo-modal-container.coveo-quick-view .coveo-modal-body .coveo-quick-view-full-height,.coveo-modal-container.coveo-quick-view .coveo-modal-body .CoveoQuickviewDocument,.coveo-modal-container.coveo-quick-view .coveo-modal-body>div{height:100%;width:100%}.coveo-modal-container.coveo-quick-view .coveo-modal-body .coveo-logo{height:64px;width:178px}.coveo-modal-container.coveo-quick-view .coveo-modal-body .coveo-loading-dot{height:8px;width:8px}.coveo-modal-container.coveo-quick-view .coveo-modal-body .coveo-quickview-header{height:auto}.coveo-modal-container.coveo-quick-view .coveo-modal-body iframe{height:100%;width:100%;position:relative;border:thin solid #bcc3ca;border-radius:2px;padding:10px 0 0 10px}.coveo-icon-for-quickview{text-align:center}.coveo-icon-for-quickview-svg{margin-top:8px;width:20px;height:12px;color:#1d4f76}.coveo-computed-modal-box-content>div{height:100%}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-header{box-ordinal-group:1;-moz-order:1;order:1;-ms-flex-order:1;border:thin solid #bcc3ca;border-radius:2px;background-color:#fff}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-header.coveo-dropdown-header-active{background-color:#e6ecf0;border-color:#009ddc}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-content{transition:all .3s cubic-bezier(.4,0,.2,1);overflow:hidden;max-height:0;width:100%;padding:0;margin:25px 0 15px;border-bottom:0 solid #e6ecf0}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-content .coveo-media-max-width-480{transition:all .4s cubic-bezier(.4,0,.2,1)}@media (max-width:480px){.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-content{transition:all .4s cubic-bezier(.4,0,.2,1)}}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-content.coveo-recommendation-column,.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-content.CoveoRecommendation{display:block}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-content.coveo-open-dropdown-content{max-height:1000px;width:100%;border-bottom:5px solid #e6ecf0}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-dropdown-container,.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-facet-column,.CoveoSearchInterface.coveo-small-recommendation .CoveoRecommendation{padding:0}.CoveoSearchInterface.coveo-small-recommendation .CoveoRecommendation{border:none}.CoveoSearchInterface.coveo-small-recommendation .CoveoResultlist .CoveoResult:first-child{border-top:thin solid #bcc3ca}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-header{padding:5px 0;background-color:#e6ecf0;border-bottom:thin solid #bcc3ca}.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-title{color:#67768b}.CoveoSearchInterface.coveo-small-facets #coveo-recommendation-results-column,.CoveoSearchInterface.coveo-small-facets .coveo-recommendation-results-column,.CoveoSearchInterface.coveo-small-recommendation #coveo-recommendation-results-column,.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-results-column{width:auto;display:block}.CoveoSearchInterface.coveo-small-facets .coveo-recommendation-facet-column,.CoveoSearchInterface.coveo-small-recommendation .coveo-recommendation-facet-column{width:30%}.CoveoRecommendation{margin:10px 0;padding:0;position:relative;border:thin solid #bcc3ca;border-radius:2px}.coveo-recommendation-header{padding:10px 0;background-color:#f7f8f9}.coveo-recommendation-title{color:#1d4f76;text-align:left;font-size:15px;line-height:20px;padding-left:20px}.coveo-recommendation-body{background:#fff;margin-bottom:1px}.coveo-recommendation-body .CoveoResultList{margin:0}.coveo-recommendation-body .CoveoResultList .CoveoResult:first-child{border-top:none}.coveo-recommendation-body .CoveoResultList .CoveoResult{margin:0;padding:5px 15px;border-top:thin solid #bcc3ca;border-bottom:none}.coveo-recommendation-column{width:15%;display:inline-block;vertical-align:top;padding:5px 15px}#coveo-recommendation-results-column,.coveo-recommendation-results-column,.CoveoSearchInterface .coveo-recommendation-results-column{width:49%;display:inline-block}#coveo-recommendation-results-column.coveo-no-results,.coveo-recommendation-results-column.coveo-no-results,.CoveoSearchInterface .coveo-recommendation-results-column.coveo-no-results{width:inherit;display:block}#coveo-recommendation-facet-column,.coveo-recommendation-facet-column,.CoveoSearchInterface .coveo-recommendation-facet-column{display:inline-block;vertical-align:top}#coveo-recommendation-facet-column.coveo-no-results,.coveo-recommendation-facet-column.coveo-no-results,.CoveoSearchInterface .coveo-recommendation-facet-column.coveo-no-results{display:none}#coveo-recommendation-main-section,.coveo-recommendation-main-section,.CoveoSearchInterface .coveo-recommendation-main-section{max-width:1450px}#coveo-recommendation-main-section.coveo-no-results .coveo-recommendation-column,.coveo-recommendation-main-section.coveo-no-results .coveo-recommendation-column,.CoveoRecommendationQuery,.CoveoSearchInterface .coveo-recommendation-main-section.coveo-no-results .coveo-recommendation-column,script.CoveoRecommendationQuery[type=\"text/x-query-generic\"]{display:none}.CoveoResultActionsMenu{display:none;position:absolute;right:0;border:thin solid #bcc3ca;border-radius:2px;margin-top:-24px;background:#fff}.CoveoResultActionsMenu.coveo-menu-opened{display:-moz-flex;display:-ms-flexbox;display:flex;flex-flow:row nowrap;box-pack:end;-moz-justify-content:flex-end;-ms-justify-content:flex-end;-o-justify-content:flex-end;justify-content:flex-end;-ms-flex-pack:end;float:right}.CoveoResultActionsMenu .coveo-result-actions-menu-menu-item{height:auto;padding:0 8px}.CoveoResultActionsMenu .coveo-result-actions-menu-menu-item:not(:first-child){border-left:thin solid #bcc3ca}.CoveoResultActionsMenu .coveo-result-actions-menu-menu-item .coveo-icon-for-quickview-svg{margin:0}.CoveoResultAttachments .coveo-attachment-sub-container{padding:6px 0 6px 20px}.CoveoResultAttachments .coveo-attachment-icon{margin-right:5px;display:inline-block;min-width:16px;min-height:16px;position:relative;top:3px}.coveo-result-attachments-container{font-size:14px;margin:0 0 5px;position:relative}.coveo-result-attachments-container .coveo-icon{margin:0 5px 0 0}.coveo-result-attachments-container *{vertical-align:middle}.CoveoResultFolding .coveo-folding-results{margin-bottom:6px}.CoveoResultFolding .coveo-folding-results>.coveo-result-frame>.coveo-result-row{margin:0}.CoveoResultFolding .coveo-loading-animation{margin:auto;width:84px;margin-bottom:10px}.coveo-list-layout .coveo-result-folding-child-result{border-left:thin solid #bcc3ca;padding:0 0 0 6px}.coveo-list-layout .coveo-result-folding-child-result:hover{border-left:1px solid #296896}.coveo-list-layout .coveo-folding-expanded-caption,.coveo-list-layout .coveo-folding-normal-caption,.coveo-list-layout .coveo-folding-oneresult-caption{color:#333}.coveo-folding-footer-section-for-less,.coveo-folding-footer-section-for-more{display:none}.coveo-folding-footer-section-for-less.coveo-visible,.coveo-folding-footer-section-for-more.coveo-visible{display:inline-block}.coveo-folding-expanded-caption,.coveo-folding-normal-caption,.coveo-folding-oneresult-caption{font-size:11px;margin-bottom:10px}.coveo-folding-expanded-caption.coveo-hidden,.coveo-folding-normal-caption.coveo-hidden,.coveo-folding-oneresult-caption.coveo-hidden{display:none}.coveo-folding-footer{margin-top:12px;margin-bottom:3px}.coveo-folding-footer-icon{margin-left:5px}.coveo-folding-more{display:inline-block;vertical-align:middle}.coveo-folding-more:hover{cursor:pointer}.coveo-folding-more .coveo-folding-footer-icon{position:relative;top:-2px}.coveo-folding-more-svg{width:10px;height:6px;color:#1d4f76}.coveo-folding-less{display:inline-block}.coveo-folding-less:hover{cursor:pointer}.coveo-folding-less .coveo-folding-footer-icon{position:relative;top:-1px}.coveo-folding-less-svg{width:10px;height:6px;color:#1d4f76}a.coveo-folding-show-less,a.coveo-folding-show-more{color:#0059b3;text-decoration:none;cursor:pointer}a.coveo-folding-show-less:visited,a.coveo-folding-show-less:visited:hover,a.coveo-folding-show-more:visited,a.coveo-folding-show-more:visited:hover{color:#609}a.coveo-folding-show-less:hover,a.coveo-folding-show-less:hover a,a.coveo-folding-show-more:hover,a.coveo-folding-show-more:hover a{text-decoration:underline}a.coveo-folding-show-less.coveo-selected *,a.coveo-folding-show-more.coveo-selected *{color:#0059b3}.coveo-card-layout a.coveo-folding-show-less,.coveo-card-layout a.coveo-folding-show-more{color:#0059b3;text-decoration:none;cursor:pointer;color:#f7f8f9;text-decoration:underline}.coveo-card-layout a.coveo-folding-show-less:visited,.coveo-card-layout a.coveo-folding-show-less:visited:hover,.coveo-card-layout a.coveo-folding-show-more:visited,.coveo-card-layout a.coveo-folding-show-more:visited:hover{color:#609;color:#f7f8f9}.coveo-card-layout a.coveo-folding-show-less:hover,.coveo-card-layout a.coveo-folding-show-less:hover a,.coveo-card-layout a.coveo-folding-show-more:hover,.coveo-card-layout a.coveo-folding-show-more:hover a{text-decoration:underline}.coveo-card-layout a.coveo-folding-show-less.coveo-selected *,.coveo-card-layout a.coveo-folding-show-more.coveo-selected *{color:#0059b3;color:#f7f8f9}.coveo-child-result{margin-bottom:5px}.coveo-child-result *{vertical-align:middle}.coveo-card-overlay .coveo-folding-footer,.coveo-card-overlay .coveo-folding-header,.coveo-card-overlay .coveo-folding-results{padding-left:20px;padding-right:20px}.coveo-card-overlay .coveo-folding-header{margin-top:10px}.coveo-card-overlay .coveo-result-folding-child-result:not(:last-child){border-bottom:1px solid #bcc3ca}.CoveoResultLayout,.CoveoResultLayoutSelector{display:-moz-flex;display:-ms-flexbox;display:flex}.CoveoResultLayout.coveo-result-layout-hidden,.CoveoResultLayoutSelector.coveo-result-layout-hidden{display:none}.coveo-result-layout-selector{display:-moz-flex;display:-ms-flexbox;display:flex;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;font-size:12px;font-weight:700;padding:0 5px 10px;border-bottom:thin solid #bcc3ca;text-transform:uppercase;border-bottom:2px solid #bcc3ca}.coveo-result-layout-selector.coveo-selected,.coveo-result-layout-selector.coveo-selected:hover{border-bottom:2px solid #263e55}.coveo-result-layout-selector:hover{color:#263e55}.coveo-result-layout-selector .coveo-icon{margin-right:5px;min-width:14px}.coveo-result-layout-selector.coveo-hidden{display:none}.coveo-card-layout-icon{width:16px;height:16px;fill:#000}.coveo-list-layout-icon{width:19px;height:14px;fill:#000}.coveo-table-layout-icon{width:18px;height:13px;fill:#000}.coveo-result-rating-star+.coveo-result-rating-star{margin-left:2px}.coveo-result-rating-star-svg{width:16px;height:16px;color:#e1e1e1}.coveo-result-rating-star-active .coveo-result-rating-star-svg{color:#d9af00}.CoveoStarRating{display:flex;flex-direction:row;flex-wrap:nowrap;pointer-events:none}.coveo-star-rating-star+.coveo-star-rating-star{margin-left:2px}.coveo-star-rating-star svg{width:15px;height:15px;color:#e6ecf0}.coveo-star-rating-star-active svg{color:#ecad00}.coveo-star-rating-label{margin-left:5px;font-size:11px;color:#4f5658}.CoveoResultsFiltersPreferences .coveo-title{display:inline-block}.CoveoResultsFiltersPreferences .coveo-choice-container{margin-bottom:2px;padding:0;display:-moz-flex;display:-ms-flexbox;display:flex;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;width:100%}.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-checkbox-span-label{-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1}.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-section{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-left:10px;line-height:30px;height:30px}.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-section-expression,.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-section-tab{padding-top:2px}.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-section-input,.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-section-tab{width:20%}.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-section-expression{width:45%}.CoveoResultsFiltersPreferences .coveo-choice-container .coveo-section.coveo-section-input .coveo-input-icon.coveo-selected:before{bottom:7px}.CoveoResultsFiltersPreferences .coveo-advanced-filters{border:thin solid #bcc3ca;border-radius:2px;display:inline-block;margin-bottom:10px;padding:6px 5px}.CoveoResultsFiltersPreferences .coveo-advanced-filters:hover{cursor:pointer}.CoveoResultsFiltersPreferences .coveo-online-help{color:#0059b3;text-decoration:none;cursor:pointer;float:right;width:30px;height:30px;text-align:right;font-weight:700}.CoveoResultsFiltersPreferences .coveo-online-help:visited,.CoveoResultsFiltersPreferences .coveo-online-help:visited:hover{color:#609}.CoveoResultsFiltersPreferences .coveo-online-help:hover,.CoveoResultsFiltersPreferences .coveo-online-help:hover a{text-decoration:underline}.CoveoResultsFiltersPreferences .coveo-online-help.coveo-selected *{color:#0059b3}.CoveoResultsFiltersPreferences .coveo-delete{margin-left:10px}.CoveoResultsFiltersPreferences .coveo-delete:hover{cursor:pointer}.CoveoResultsFiltersPreferences .coveo-delete-svg{width:12px;height:12px}.CoveoResultsFiltersPreferences .coveo-delete-svg .coveo-exclusion-svg{fill:#cc0d00}.CoveoResultsFiltersPreferences .coveo-edit:hover{cursor:pointer}.CoveoResultsFiltersPreferences .coveo-edit-svg{width:13px;height:13px;color:#1d4f76}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder{display:none;position:relative}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder.coveo-active{display:block}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder form{overflow:hidden;padding:10px;border:thin solid #bcc3ca;border-radius:2px;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-input{width:100%;margin-bottom:10px}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-expression{-moz-flex-grow:2;flex-grow:2;-ms-flex-positive:2}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-caption>div,.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-expression>div{height:100%;width:100%}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-save{color:#0059b3;text-decoration:none;cursor:pointer;position:absolute;top:6px;right:30px}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-save:visited,.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-save:visited:hover{color:#609}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-save:hover,.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-save:hover a{text-decoration:underline}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-save.coveo-selected *{color:#0059b3}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-close{cursor:pointer;color:#1d4f76;position:absolute;top:6px;right:10px}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-close .coveo-exclusion-svg{fill:#1d4f76}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-close svg{width:12px;height:12px}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-close:hover{color:#cc0d00}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-close-and-save .coveo-close:hover .coveo-exclusion-svg{fill:#cc0d00}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-save-svg{width:14px;height:12px}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-save-svg .coveo-hook-svg{fill:#1d4f76}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-tab{min-height:100px;width:100%}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder .coveo-tab optgroup{padding-left:10px}.CoveoResultsFiltersPreferences .coveo-advanced-filters-builder input[type=submit]{display:none}.coveo-results-filter-preferences-breadcrumb .coveo-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-results-filter-preferences-breadcrumb .coveo-value{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px}.coveo-results-filter-preferences-breadcrumb .coveo-value:visited,.coveo-results-filter-preferences-breadcrumb .coveo-value:visited:hover{color:#609}.coveo-results-filter-preferences-breadcrumb .coveo-value:hover,.coveo-results-filter-preferences-breadcrumb .coveo-value:hover a{text-decoration:underline}.coveo-results-filter-preferences-breadcrumb .coveo-value.coveo-selected *{color:#0059b3;color:#296896}.coveo-results-filter-preferences-breadcrumb .coveo-value .coveo-clear{margin-left:5px}.coveo-results-filter-preferences-breadcrumb .coveo-value .coveo-clear svg{width:9px;height:9px}.coveo-form-group{display:block;border:0;padding:0;margin:0}.coveo-form-group+.coveo-form-group{margin-top:30px}.coveo-form-group-label{color:#1d4f76;font-size:16px;display:block;margin-bottom:10px}.coveo-multi-select{border:thin solid #7e8c9a;width:250px;padding:0;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.coveo-multi-select .coveo-list-group{color:#7e8c9a;margin:16px 0 0;padding:0 0 0 16px;font-weight:400}.coveo-multi-select .coveo-list-group:last-child{margin-bottom:16px}.coveo-multi-select .coveo-list-item{color:#373737;margin:0 0 0 -16px;padding:0 16px}.coveo-multi-select .coveo-list-item:checked{background-color:transparent}.coveo-multi-select .coveo-list-item:first-child{margin-top:12px}.coveo-multi-select .coveo-list-item:last-child{margin-bottom:8px}.coveo-multi-select:focus .coveo-list-item:checked{background-color:#0059b3}.coveo-list-item{height:30px;display:-moz-flex;display:-ms-flexbox;display:flex;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center}.CoveoResultsPerPage{margin:0 0 0 15px;float:right}.coveo-results-per-page-text{padding-left:0}.coveo-results-per-page-list{padding-left:0;margin:0;display:inline-block}.coveo-results-per-page-list-item{border:thin solid #7e8c9a;border-radius:2px;margin:5px 6px;padding:4px 8px;list-style:none;display:inline-block;vertical-align:baseline;color:#0059b3;text-decoration:none;font-size:14px;cursor:pointer;padding:4px}.coveo-results-per-page-list-item:visited,.coveo-results-per-page-list-item:visited:hover{color:#609}.coveo-results-per-page-list-item:hover,.coveo-results-per-page-list-item:hover a{text-decoration:underline}.coveo-results-per-page-list-item.coveo-selected *{color:#0059b3}.coveo-results-per-page-list-item.coveo-active,.coveo-results-per-page-list-item:hover{color:#cddee9;background-color:#1d4f76}.coveo-results-per-page-list-item.coveo-active a,.coveo-results-per-page-list-item:hover a{color:#cddee9}.coveo-results-per-page-no-results{display:none}.CoveoResultsPreferences .coveo-checkbox-label{display:block;margin:5px 0}.coveo-result-tagging-add-tag{display:inline-block;margin:1px 2px}.coveo-result-tagging-add-tag-text{color:#ddd;font-size:11px}.coveo-result-tagging-auto-complete-zone{display:none;position:relative}.CoveoResult .coveo-result-tagging-coveo-tag{display:inline-block;margin:0 2px;font-size:12px;background-color:#4f5658;border-radius:3px;padding:1px 5px;text-transform:uppercase}.CoveoResult .coveo-result-tagging-coveo-tag span{line-height:14px;vertical-align:middle}.CoveoResult .coveo-result-tagging-coveo-tag a{color:#fff}.CoveoResult .coveo-result-tagging-coveo-tag a:hover{color:#ddd}.coveo-result-tagging-add-tag-tick-icon{display:inline-block;background:#b0b3ae;padding:0 5px;line-height:22px;height:22px}.coveo-result-tagging-add-tag-tick-icon span{cursor:pointer}.coveo-result-tagging-add-tag-tick-icon-svg{width:9px;height:7px;color:hsla(0,0%,100%,.5)}.coveo-result-tagging-clear-icon{display:inline-block;background:#b0b3ae;padding:0 6px 0 5px;height:22px;line-height:22px;border-bottom-right-radius:3px;border-top-right-radius:3px}.coveo-result-tagging-clear-icon span{cursor:pointer}.coveo-result-tagging-clear-icon-svg{width:8px;height:8px}.coveo-result-tagging-clear-icon-svg .coveo-exclusion-svg{fill:hsla(0,0%,100%,.5)}.coveo-result-tagging-add-tag-textbox{margin:0;border:1px solid #b0b3ae;background:transparent;padding:3px;z-index:10;font-size:10px;position:relative;border-top-left-radius:3px;border-bottom-left-radius:3px;outline:none}.coveo-result-tagging-add-tag-textbox:focus{border-color:#9ecaed;box-shadow:inset 0 0 3px #9ecaed}.coveo-result-tagging-tag-zone{display:inline-block}.coveo-result-tagging-delete-icon{cursor:pointer;margin-left:2px}.coveo-result-tagging-delete-icon-svg{width:8px;height:8px}.coveo-result-tagging-delete-icon-svg .coveo-exclusion-svg{fill:hsla(0,0%,100%,.5)}.coveo-result-tagging-auto-complete{position:absolute;padding-top:1px;top:18px;left:0;background-color:#fff;border-left:1px solid #b0b3ae;border-bottom:1px solid #b0b3ae;border-right:1px solid #b0b3ae;border-bottom-left-radius:2px;border-bottom-right-radius:2px;z-index:5}.coveo-result-tagging-auto-complete .coveo-selectable{padding:5px 10px 5px 16px;background-color:#fff;font-size:10px;cursor:pointer}.coveo-result-tagging-auto-complete .coveo-selectable:hover,.coveo-result-tagging-auto-complete .coveo-selected{background-color:#d7ebff}.CoveoResultTagging{margin:0 3px;font-size:12px}.CoveoResultTagging *{vertical-align:middle}.CoveoResultTagging{display:inline-block}.CoveoResultTagging.coveo-opened .coveo-result-tagging-add-tag{display:none}.CoveoResultTagging.coveo-opened .coveo-result-tagging-auto-complete-zone{display:inline-block}.CoveoResultTagging.coveo-opened .coveo-result-tagging-auto-complete-zone .coveo-add-tag-textbox{font-size:11px;line-height:16px}.CoveoResultTagging.coveo-opened .coveo-result-tagging-coveo-tag{background-color:#1d4f76}.CoveoResultTagging .CoveoResultTagging.coveo-error input{border-color:#c33}.CoveoSearchbox{display:-moz-flex;display:-ms-flexbox;display:flex;flex-grow:1}.CoveoSearchbox.coveo-custom-height .CoveoOmnibox,.CoveoSearchbox.coveo-custom-height .CoveoQuerybox{display:inline-block;align-items:center}.CoveoSearchbox.coveo-custom-height .magic-box .magic-box-clear,.CoveoSearchbox.coveo-custom-height .magic-box .magic-box-clear .magic-box-icon{display:flex;align-items:center;margin-top:0;margin-left:15px}.CoveoSearchbox.coveo-inline{overflow:hidden}.CoveoSearchbox.coveo-inline .magic-box{overflow:visible}.CoveoSearchbox .CoveoSearchButton{z-index:2;border-top-right-radius:2px;border-bottom-right-radius:2px}.CoveoSearchbox .magic-box{border:thin solid #7e8c9a;border-radius:2px}.CoveoSearchbox .magic-box .magic-box-clear-svg{width:15px;height:15px;color:#1d4f76}.CoveoSearchbox .magic-box .magic-box-clear:before{border-left:none}.CoveoSearchbox .magic-box .magic-box-clear .magic-box-icon:before{content:\"\"}.CoveoSearchbox .magic-box .magic-box-input{border-radius:2px}.CoveoSearchbox .magic-box .magic-box-input>input{color:#67768b}.CoveoSearchInterface.coveo-waiting-for-query .CoveoSearchbox{margin:0}.CoveoSearchInterface.coveo-waiting-for-query .CoveoSearchbox .coveo-media-max-width-480{margin:0 20px}@media (max-width:480px){.CoveoSearchInterface.coveo-waiting-for-query .CoveoSearchbox{margin:0 20px}}.coveo-query-syntax-disabled .magic-box-highlight-container,.coveo-query-syntax-disabled.magic-box .magic-box-input .magic-box-underlay span,.magic-box.magic-box-hasFocus .magic-box-input .magic-box-underlay .magic-box-ghost-text,.magic-box .magic-box-input .magic-box-underlay .magic-box-ghost-text{display:none}.CoveoSettings{margin:0 0 0 36px;border-radius:50%;border:thin solid #7e8c9a;width:40px;height:40px;order:1;position:relative;cursor:pointer}.coveo-settings-squares{width:100%;display:inline-block;line-height:4px;height:4px;position:absolute;top:50%;transform:translateY(-50%);text-align:center}.coveo-settings-square{width:4px;height:4px;display:inline-block;vertical-align:top;background-color:#67768b}.coveo-settings-square+.coveo-settings-square{margin-left:5px;margin-right:5px}.coveo-settings-square+.coveo-settings-square+.coveo-settings-square{margin-left:0;margin-right:0}.coveo-settings-advanced-menu{position:absolute;background:#e6ecf0;border:thin solid #7e8c9a;border-radius:2px;min-width:160px;z-index:11}.coveo-settings-advanced-menu:before{content:\"\";position:absolute;top:-13px;right:10px;height:0;width:0;border:6px solid transparent;border-bottom-color:#bcc3ca}.coveo-settings-item{clear:both;overflow:hidden;color:#0059b3;text-decoration:none;cursor:pointer}.coveo-settings-item .coveo-icon{min-width:18px;display:inline-block;margin:0 10px;vertical-align:middle}.coveo-settings-item:visited,.coveo-settings-item:visited:hover{color:#609}.coveo-settings-item:hover,.coveo-settings-item:hover a{text-decoration:underline}.coveo-settings-item.coveo-selected *{color:#0059b3}.coveo-settings-item{background:#fff}.coveo-settings-item:hover{background:#e6ecf0}.coveo-settings-item .coveo-settings-text{overflow:hidden;display:inline-block;vertical-align:middle;padding:8px}.coveo-settings-item:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.coveo-settings-item:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}.coveo-settings-item.coveo-share-query .coveo-share-query-svg{float:none}.coveo-settings-item.coveo-share-query:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-settings-item.coveo-share-query:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-settings-item.coveo-advanced-search .coveo-advanced-search-svg{float:none}.coveo-settings-item.coveo-advanced-search:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-settings-item.coveo-advanced-search:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-settings-item.coveo-preferences-panel .coveo-preferences-panel-svg{float:none}.coveo-settings-item.coveo-preferences-panel:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-settings-item.coveo-preferences-panel:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-settings-item.coveo-authentication-provider .coveo-icon{margin-left:12px;margin-right:8px}.coveo-settings-item.coveo-authentication-provider .coveo-authentication-provider-svg{float:none}.coveo-settings-item.coveo-authentication-provider:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-settings-item.coveo-authentication-provider:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-settings-item.coveo-export-to-excel .coveo-icon{margin-left:12px;margin-right:8px}.coveo-settings-item.coveo-export-to-excel .coveo-export-to-excel-svg{float:none}.coveo-settings-item.coveo-export-to-excel:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-settings-item.coveo-export-to-excel:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-settings-item.coveo-subscriptions-panel .coveo-subscription-panel-svg{float:none}.coveo-settings-item.coveo-subscriptions-panel:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-settings-item.coveo-subscriptions-panel:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-settings-item.coveo-follow-query .coveo-follow-query-svg{float:none}.coveo-settings-item.coveo-follow-query:hover .coveo-active-shape-svg{fill:#ecad00}.coveo-settings-item.coveo-follow-query:hover.coveo-disabled .coveo-active-shape-svg{fill:currentColor}.coveo-share-query-summary-info-label{display:block;font-size:13px;margin-bottom:5px;font-weight:400}.coveo-share-query-summary-info-input{width:100%;margin-bottom:5px;border:thin solid #bcc3ca;border-radius:2px;padding:5px;height:35px;font-size:14px}.coveo-share-query-svg{width:18px;height:14px;color:#1d4f76}.coveo-sort-section{text-align:right;font-size:0}.coveo-sort-icon-descending-svg{width:10px;height:6px;color:#1d4f76}.coveo-sort-icon-ascending-svg{display:none}.CoveoSort{display:-moz-flex;display:-ms-flexbox;display:flex;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;font-size:12px;font-weight:700;padding:0 5px 10px;border-bottom:thin solid #bcc3ca;text-transform:uppercase;border-bottom:2px solid #bcc3ca}.CoveoSort.coveo-selected,.CoveoSort.coveo-selected:hover{border-bottom:2px solid #263e55}.CoveoSort:hover{color:#263e55}.CoveoSort .coveo-icon{margin-left:5px;position:relative}.CoveoSort .coveo-icon.coveo-hidden{visibility:hidden}.CoveoSort.coveo-ascending .coveo-sort-icon-ascending-svg{display:inline-block;width:10px;height:6px;color:#1d4f76}.CoveoSort.coveo-ascending .coveo-sort-icon-descending-svg,.CoveoSort.coveo-sort-hidden{display:none}.CoveoSort.coveo-table-header-sort{text-transform:inherit;padding-top:inherit;padding-bottom:inherit;display:table-cell}.coveo-result-list-table-header .CoveoSort:not(.coveo-selected) .coveo-icon{visibility:hidden}.CoveoTab{color:#67768b;text-decoration:none;cursor:pointer;height:52px;font-size:15px;padding:0 10px 2px;text-transform:uppercase;white-space:normal}.CoveoTab,.CoveoTab *{display:inline-block;vertical-align:middle}.CoveoTab *{line-height:52px;margin:0}.CoveoTab>.coveo-icon{margin-right:5px}.CoveoTab p{height:100%;color:#0059b3}.CoveoTab.coveo-selected,.CoveoTab.coveo-selected:hover{border-bottom:2px solid #263e55;padding-bottom:0}.CoveoTab:hover{color:#263e55}.coveo-tab-section{width:100%;min-height:52px;background-color:#f7f8f9;text-align:center;border-bottom:1px solid #bcc3ca;font-size:0;white-space:nowrap}.coveo-media-max-width-480 .coveo-tab-section{min-height:40px}.coveo-media-max-width-480 .CoveoTab{height:40px}.coveo-media-max-width-480 .CoveoTab *{line-height:40px}@media (max-width:480px){.coveo-tab-section{min-height:40px}.CoveoTab{height:40px}.CoveoTab *{line-height:40px}}.coveo-small-tabs.coveo-tab-section .coveo-tab-dropdown-header{margin-left:auto;line-height:22px}.coveo-small-tabs .CoveoTab{transition-property:opacity;transition-duration:.25s;transition-timing-function:ease;font-size:12px;color:#1d4f76;font-weight:400;letter-spacing:.25px}.coveo-small-tabs .CoveoTab.coveo-selected,.coveo-small-tabs .CoveoTab.coveo-selected:hover{font-weight:700;border-bottom:0}.coveo-small-tabs .CoveoTab.coveo-selected:hover p,.coveo-small-tabs .CoveoTab.coveo-selected p{border-bottom:2px solid #263e55}.coveo-small-tabs .CoveoTab p{max-width:240px;overflow:hidden;text-overflow:ellipsis}.coveo-small-tabs .coveo-tab-list{text-align:left;list-style:none;background-color:#fff;border:thin solid #bcc3ca;border-radius:2px;padding:0;white-space:nowrap}.coveo-small-tabs .coveo-tab-list *{height:30px;line-height:30px;clear:both;white-space:nowrap}.coveo-small-tabs .coveo-tab-list li:first-child{margin-top:6px}.coveo-small-tabs .coveo-tab-list li:last-child{margin-bottom:6px}.coveo-small-tabs .coveo-tab-list li:hover{background-color:#e6ecf0}.coveo-tab-list-container{max-width:80%;z-index:11}.coveo-tab-list-container ol{margin:0}.coveo-tab-list-container ol a{width:100%}.coveo-tab-list-container ol a p{width:100%;overflow:hidden;text-overflow:ellipsis}.coveo-more-tabs-svg{width:7px;height:4px;color:#1d4f76}.CoveoText{word-wrap:break-word}.CoveoTriggers .coveo-trigger-notify{padding:10px 0}.CoveoTriggers a{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoTriggers a:visited,.CoveoTriggers a:visited:hover{color:#609}.CoveoTriggers a:hover,.CoveoTriggers a:hover a{text-decoration:underline}.CoveoTriggers a.coveo-selected *{color:#0059b3}.coveo-simplefilter-header-wrapper{width:100%;margin:auto;max-width:1200px;position:relative;display:block;-webkit-box-lines:single;-moz-box-lines:single;box-lines:single;-ms-flex-wrap:nowrap;flex-wrap:nowrap;box-pack:start;-moz-justify-content:flex-start;-ms-justify-content:flex-start;-o-justify-content:flex-start;justify-content:flex-start;-ms-flex-pack:start}.coveo-simplefilter-header-wrapper .coveo-media-max-width-800.coveo-no-results{max-width:100%}@media (max-width:800px){.coveo-simplefilter-header-wrapper.coveo-no-results{max-width:100%}}.coveo-simplefilter-header-wrapper.coveo-no-results{max-width:75%;margin:auto}.coveo-results-column .coveo-simplefilter-header-wrapper.coveo-no-results{margin:0;padding-left:0;text-align:left}.coveo-dropdown-background{display:none}.coveo-dropdown-background-active{opacity:.9;display:block}.CoveoSimpleFilter{cursor:pointer;padding:5px 0;box-sizing:content-box;display:inline-block;position:relative;border:thin solid #bcc3ca;background-color:#fff;max-width:280px;min-width:180px}.CoveoSimpleFilter:hover{background-color:#e6ecf0}.coveo-simplefilter-selecttext{margin-left:5px;max-width:280px;box-pack:start;-moz-justify-content:flex-start;-ms-justify-content:flex-start;-o-justify-content:flex-start;justify-content:flex-start;-ms-flex-pack:start}.coveo-simplefilter-select,.coveo-simplefilter-selecttext{overflow:hidden;text-overflow:ellipsis;pointer-events:none}.coveo-simplefilter-select{color:#1d4f76;display:-moz-flex;display:-ms-flexbox;display:flex;box-pack:center;-moz-justify-content:center;-ms-justify-content:center;-o-justify-content:center;justify-content:center;-ms-flex-pack:center;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;width:inherit;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;height:20px}.coveo-simplefilter-toggle-svg-container{display:-moz-flex;display:-ms-flexbox;display:flex;padding-top:1px}.coveo-simplefilter-circle{display:inline-block;letter-spacing:.4px;background-color:#fff;border:2px solid #1d4f76;border-radius:50%;color:#1d4f76;font-size:13px;font-weight:700;min-height:20px;min-width:20px;line-height:16px;padding:0 3px;text-align:center;margin:0 3px;pointer-events:none}.coveo-simplefilter-circle-hidden{display:none}.coveo-simplefilter-value-container{display:none;border:thin solid #bcc3ca;position:absolute;right:-1px;box-sizing:content-box;background-color:#fff;top:28px;width:100%;text-align:left}.coveo-simplefilter-value-container .coveo-checkbox-button{border:thin solid #bcc3ca;border-radius:2px}.coveo-simplefilter-value-container .coveo-checkbox-span-label{white-space:nowrap;vertical-align:middle;text-overflow:ellipsis;display:inline-block;overflow:hidden;width:75%;margin-left:6px}.coveo-simplefilter-value-container .coveo-checkbox-button{vertical-align:middle}.coveo-simplefilter-value-container .coveo-checkbox-label{white-space:nowrap;width:100%;padding:5px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.coveo-simplefilter-value-container label{display:inline-block}.coveo-simplefilter-value-container-expanded{display:inline-block;z-index:20}.coveo-simplefilter-value-container label:hover{background-color:#e6ecf0}.coveo-simplefilter-breadcrumb-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-simplefilter-breadcrumb-value{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px}.coveo-simplefilter-breadcrumb-value:visited,.coveo-simplefilter-breadcrumb-value:visited:hover{color:#609}.coveo-simplefilter-breadcrumb-value:hover,.coveo-simplefilter-breadcrumb-value:hover a{text-decoration:underline}.coveo-simplefilter-breadcrumb-value.coveo-selected *{color:#0059b3;color:#296896}.coveo-simplefilter-breadcrumb-clear{margin-left:5px}.coveo-simplefilter-breadcrumb-clear svg{width:9px;height:9px}.coveo-simplefilter-toggle-down-svg{margin:0 5px;width:12px;height:8px}.coveo-simplefilter-eraser,.coveo-simplefilter-toggle-down-svg{box-pack:end;-moz-justify-content:flex-end;-ms-justify-content:flex-end;-o-justify-content:flex-end;justify-content:flex-end;-ms-flex-pack:end;color:#1d4f76}.coveo-simplefilter-eraser{position:relative;top:1px;padding:0 10px;pointer-events:auto;vertical-align:middle;border:none;background-color:transparent;cursor:pointer}.coveo-simplefilter-eraser .coveo-exclusion-svg{fill:#1d4f76}.coveo-simplefilter-eraser svg{width:12px;height:12px}.coveo-simplefilter-eraser:hover{color:#cc0d00}.coveo-simplefilter-eraser:hover .coveo-exclusion-svg{fill:#cc0d00}.coveo-simplefilter-empty{display:none}.coveo-main-section .CoveoSimpleFilter{margin-left:15px}.coveo-facet-column .CoveoSimpleFilter{width:100%;max-width:100%;margin-left:0}.coveo-results-column .CoveoSimpleFilter{margin-left:0}.CoveoResult.coveo-omnibox-selectable{padding:10px 10px 10px 15px;margin:0}.CoveoResult .coveo-no-thumbnail{display:none}.CoveoResult .coveo-date{float:right;font-size:13px;margin-left:10px;padding-top:3px}.CoveoResult .coveo-title{display:block;font-size:16px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;line-height:24px}.CoveoResult .coveo-title>*{vertical-align:middle}.CoveoResult .coveo-title .CoveoResultLink{margin-right:5px;display:inline;overflow:hidden;white-space:normal}.CoveoResult .coveo-title .CoveoResultLink:after{content:\"\\A0\";white-space:nowrap;visibility:hidden}.CoveoResult .coveo-excerpt{max-width:600px;font-size:14px;padding:5px 0 8px}.CoveoResult a{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoResult a:visited,.CoveoResult a:visited:hover{color:#609}.CoveoResult a:hover,.CoveoResult a:hover a{text-decoration:underline}.CoveoResult a.coveo-selected *{color:#0059b3}.CoveoResult .coveo-badge{display:inline-block;padding:4px 6px;vertical-align:middle;font-size:12px}.CoveoResult .CoveoBadge .coveo-value{display:inline-block;vertical-align:middle;border-radius:1em;line-height:1.25em;margin-right:8px}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:visited,.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:visited:hover{color:#609}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:hover,.CoveoResult .CoveoBadge .coveo-value.coveo-clickable:hover a{text-decoration:underline}.CoveoResult .CoveoBadge .coveo-value.coveo-clickable.coveo-selected *{color:#0059b3}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-icon{position:relative;display:inline-block;width:16px;height:16px;margin-right:2px;vertical-align:middle}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-icon:before{content:\"\";display:block;position:absolute;left:2px;top:3px;width:12px;height:10px;transform:rotate(-45deg);-ms-transform:rotate(-45deg);border:2px solid;border-right:none;-webkit-backface-visibility:hidden;-webkit-border-top-left-radius:2px;-webkit-border-bottom-left-radius:2px;-moz-border-radius-topleft:2px;-moz-border-radius-bottomleft:2px;border-top-left-radius:2px;border-bottom-left-radius:2px;box-sizing:border-box}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-icon:after{content:\"\";display:block;position:absolute;right:0;top:0;width:7px;height:7px;border:2px solid;border-bottom:none;border-left:none;border-top-right-radius:3px;box-sizing:border-box}.CoveoResult .CoveoBadge .coveo-value .coveo-badge-label{vertical-align:middle}.CoveoResult .coveo-selectable-link{color:#0059b3;text-decoration:none;cursor:pointer}.CoveoResult .coveo-selectable-link:visited,.CoveoResult .coveo-selectable-link:visited:hover{color:#609}.CoveoResult .coveo-selectable-link:hover,.CoveoResult .coveo-selectable-link:hover a{text-decoration:underline}.CoveoResult .coveo-selectable-link.coveo-selected *{color:#0059b3}.CoveoResult .coveo-field .coveo-label{font-weight:400}.CoveoResult .CoveoResultFolding .coveo-child-result .CoveoQuickview{margin-left:5px;display:inline-block}.CoveoResult .CoveoResultFolding .coveo-child-result .CoveoQuickview .coveo-icon-for-quickview-svg{margin-top:0}.CoveoResult.coveo-is-recommendation{box-shadow:0 0 1px 1px #263e55}.coveo-list-layout.CoveoResult{border-bottom:thin solid #bcc3ca;padding:16px 0 16px 16px}.coveo-card-layout{margin-right:-20px}.coveo-card-layout.CoveoResult{overflow:hidden;display:flex;position:relative;font-size:.9em;width:300px;-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1;margin:0 20px 20px 0;border:thin solid #bcc3ca;border-radius:2px}.coveo-card-layout.CoveoResult .coveo-media-max-width-480{margin:0 0 20px}@media (max-width:480px){.coveo-card-layout.CoveoResult{margin:0 0 20px}}.coveo-card-layout.CoveoResult.coveo-clickable{cursor:pointer}.coveo-card-layout.CoveoResult.coveo-clickable:hover{box-shadow:0 0 0 2px #009ddc;border-color:#009ddc}.coveo-card-layout.CoveoResult .coveo-result-row:first-child{margin-top:0}.coveo-card-layout.CoveoResult.coveo-result-frame,.coveo-card-layout.CoveoResult .coveo-result-frame{display:flex;padding:20px;flex-direction:column;width:100%;height:auto}.coveo-card-layout.CoveoResult .CoveoResultLink{font-size:16px;line-height:21px}.coveo-card-layout:empty{width:300px;height:0;-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1;margin-right:20px}.coveo-card-layout.coveo-with-inline-ranking-info{-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}.coveo-table-layout{display:table-row}.coveo-table-layout td{display:table-cell;padding:9px 15px;white-space:nowrap;border-bottom:thin solid #bcc3ca;overflow:hidden;text-overflow:ellipsis}.coveo-table-layout th{text-align:left;font-size:12px;color:#1d4f76;font-weight:700;border-bottom:thin solid #bcc3ca;padding:7px 15px}.coveo-table-layout:hover td{background-color:#e6ecf0}.coveo-table-layout .coveo-relevance-inspector-inline-ranking{display:table-cell;overflow:auto}.coveo-card-overlay a{color:#0059b3;text-decoration:none;cursor:pointer;color:#f7f8f9;text-decoration:underline}.coveo-card-overlay a:visited,.coveo-card-overlay a:visited:hover{color:#609;color:#f7f8f9}.coveo-card-overlay a:hover,.coveo-card-overlay a:hover a{text-decoration:underline}.coveo-card-overlay a.coveo-selected *{color:#0059b3;color:#f7f8f9}.coveo-promoted-result-badge{text-transform:uppercase;display:inline-block;margin:0 0 10px;padding:5px 10px;color:#fff;border-radius:2px;font-size:12px;font-weight:700;letter-spacing:1px}.coveo-card-layout-container{position:relative}.coveo-card-layout-container .coveo-promoted-result-badge{position:absolute;transform:translate(-10px,-10px);z-index:2}.coveo-card-layout-container .coveo-promoted-result-badge+.coveo-promoted-result-badge{z-index:1;left:79px}.coveo-promoted-result-badge-container-card-layout{flex-grow:1;display:flex}.coveo-featured-result-badge{background-color:#f58020}.coveo-recommended-result-badge{background-color:#0059b3}.CoveoDynamicFacet,.CoveoDynamicFacetRange,.CoveoDynamicHierarchicalFacet{background:#fff}.coveo-no-visible-facet .coveo-facet-column,.CoveoDynamicFacet.coveo-hidden,.CoveoDynamicFacetRange.coveo-hidden,.CoveoDynamicHierarchicalFacet.coveo-hidden{display:none}.coveo-dynamic-facet-breadcrumb-title{color:#67768b;margin:0;font-size:14px;font-weight:400;display:inline;margin-right:8px}.coveo-dynamic-facet-breadcrumb-collapse,.coveo-dynamic-facet-breadcrumb-value{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;outline:1px solid transparent;font-size:14px;margin-right:15px;outline-offset:1px}.coveo-dynamic-facet-breadcrumb-collapse:visited,.coveo-dynamic-facet-breadcrumb-collapse:visited:hover,.coveo-dynamic-facet-breadcrumb-value:visited,.coveo-dynamic-facet-breadcrumb-value:visited:hover{color:#609}.coveo-dynamic-facet-breadcrumb-collapse:hover,.coveo-dynamic-facet-breadcrumb-collapse:hover a,.coveo-dynamic-facet-breadcrumb-value:hover,.coveo-dynamic-facet-breadcrumb-value:hover a{text-decoration:underline}.coveo-dynamic-facet-breadcrumb-collapse.coveo-selected *,.coveo-dynamic-facet-breadcrumb-value.coveo-selected *{color:#0059b3;color:#296896}.coveo-dynamic-facet-breadcrumb-value-clear{margin-left:5px}.coveo-dynamic-facet-breadcrumb-value-clear svg{width:9px;height:9px}ul.coveo-dynamic-facet-breadcrumb.coveo-breadcrumb-item{display:block;list-style:none;padding:0}li.coveo-dynamic-facet-breadcrumb-value-list-item{display:inline-block}.coveo-dynamic-facet-header{border-bottom:thin solid #bcc3ca;height:35px;display:-moz-flex;display:-ms-flexbox;display:flex}.coveo-dynamic-facet-header-title{margin:0;font-size:15px;color:#0059b3;font-weight:700;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;text-transform:capitalize;line-height:35px;-moz-flex-grow:1;flex-grow:1;-ms-flex-positive:1}.coveo-dynamic-facet-header-title.coveo-clickable{cursor:pointer}.coveo-dynamic-facet-header-wait-animation{padding:0 5px}.coveo-dynamic-facet-header-wait-animation-svg{width:15px;height:15px;color:#0059b3;color:#1d4f76;display:inline-block;vertical-align:middle;animation-name:coveo-spin;animation-timing-function:linear;animation-duration:1s;animation-iteration-count:infinite}.coveo-dynamic-facet-header-collapse,.coveo-dynamic-facet-header-expand{height:100%}.coveo-dynamic-facet-collapse-toggle-svg{width:15px;height:15px;color:#0059b3;display:inline-block;vertical-align:middle}.coveo-dynamic-facet-header-btn{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;padding:0 5px;font-size:14px}.coveo-dynamic-facet-header-btn:visited,.coveo-dynamic-facet-header-btn:visited:hover{color:#609}.coveo-dynamic-facet-header-btn:hover,.coveo-dynamic-facet-header-btn:hover a{text-decoration:underline}.coveo-dynamic-facet-header-btn.coveo-selected *{color:#0059b3}.coveo-dynamic-hierarchical-facet-values{padding:10px 0;margin:0;white-space:normal;list-style:none}.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-all,.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-show-less,.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-show-more,.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-value{padding-left:20px}.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-all.coveo-with-space,.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-show-less.coveo-with-space,.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-show-more.coveo-with-space,.coveo-dynamic-hierarchical-facet-values.coveo-with-space .coveo-dynamic-hierarchical-facet-value.coveo-with-space{padding-left:40px}.coveo-dynamic-hierarchical-facet-collapsed .coveo-dynamic-hierarchical-facet-all:not(.coveo-show-when-collapsed),.coveo-dynamic-hierarchical-facet-collapsed .coveo-dynamic-hierarchical-facet-show-less:not(.coveo-show-when-collapsed),.coveo-dynamic-hierarchical-facet-collapsed .coveo-dynamic-hierarchical-facet-show-more:not(.coveo-show-when-collapsed),.coveo-dynamic-hierarchical-facet-collapsed .coveo-dynamic-hierarchical-facet-value:not(.coveo-show-when-collapsed){display:none}button.coveo-dynamic-hierarchical-facet-all,button.coveo-dynamic-hierarchical-facet-value{display:inline-flex;position:relative}.coveo-dynamic-hierarchical-facet-all,.coveo-dynamic-hierarchical-facet-value{text-align:left;cursor:pointer;font-size:15px;padding:0;margin:0;background:none;border:none;align-items:center;line-height:27px;width:100%}.coveo-dynamic-hierarchical-facet-all.coveo-focused,.coveo-dynamic-hierarchical-facet-all:hover,.coveo-dynamic-hierarchical-facet-value.coveo-focused,.coveo-dynamic-hierarchical-facet-value:hover{opacity:.7}.coveo-dynamic-hierarchical-facet-value.coveo-with-space{padding-left:20px}.coveo-dynamic-hierarchical-facet-value:disabled{cursor:auto}.coveo-dynamic-hierarchical-facet-value:disabled:hover{opacity:1}.coveo-dynamic-hierarchical-facet-value.coveo-selected .coveo-dynamic-hierarchical-facet-value-count,.coveo-dynamic-hierarchical-facet-value.coveo-selected .coveo-dynamic-hierarchical-facet-value-label{font-weight:700}.coveo-dynamic-hierarchical-facet-value-label{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:#000}.coveo-dynamic-hierarchical-facet-value-count{margin-left:8px;color:#67768b}.coveo-dynamic-hierarchical-facet-value-arrow-left svg,.coveo-dynamic-hierarchical-facet-value-arrow-right svg{width:11px;height:11px;color:#0059b3;display:inline-block}.coveo-dynamic-hierarchical-facet-value-arrow-right{margin-left:8px}.coveo-dynamic-hierarchical-facet-value-arrow-right svg{transform:rotate(270deg);vertical-align:middle}.coveo-dynamic-hierarchical-facet-value-arrow-left{position:absolute;left:2px;top:0}.coveo-dynamic-hierarchical-facet-value-arrow-left svg{transform:rotate(90deg)}.coveo-dynamic-hierarchical-facet-show-more{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;width:100%;text-align:left;margin-top:2px;padding:3px 0;font-size:15px}.coveo-dynamic-hierarchical-facet-show-more:visited,.coveo-dynamic-hierarchical-facet-show-more:visited:hover{color:#609}.coveo-dynamic-hierarchical-facet-show-more:hover,.coveo-dynamic-hierarchical-facet-show-more:hover a{text-decoration:underline}.coveo-dynamic-hierarchical-facet-show-more.coveo-selected *{color:#0059b3}.coveo-dynamic-hierarchical-facet-show-more:before{width:15px;display:inline-block;text-decoration:underline}.coveo-dynamic-hierarchical-facet-show-more:before,.coveo-dynamic-hierarchical-facet-show-more:hover:before{text-decoration:none}.coveo-dynamic-hierarchical-facet-show-more:before{content:\"+\"}.coveo-dynamic-hierarchical-facet-show-less{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;width:100%;text-align:left;margin-top:2px;padding:3px 0;font-size:15px;color:#313a45}.coveo-dynamic-hierarchical-facet-show-less:visited,.coveo-dynamic-hierarchical-facet-show-less:visited:hover{color:#609}.coveo-dynamic-hierarchical-facet-show-less:hover,.coveo-dynamic-hierarchical-facet-show-less:hover a{text-decoration:underline}.coveo-dynamic-hierarchical-facet-show-less.coveo-selected *{color:#0059b3}.coveo-dynamic-hierarchical-facet-show-less:before{width:15px;display:inline-block;text-decoration:underline}.coveo-dynamic-hierarchical-facet-show-less:before,.coveo-dynamic-hierarchical-facet-show-less:hover:before{text-decoration:none}.coveo-dynamic-hierarchical-facet-show-less:before{content:\"-\"}.coveo-combobox-wrapper{position:relative}.coveo-combobox-wait-animation-svg{width:16px;height:16px;color:#0059b3;color:#1d4f76;display:inline-block;vertical-align:middle;animation-name:coveo-spin;animation-timing-function:linear;animation-duration:1s;animation-iteration-count:infinite}.coveo-combobox-input{position:relative}.coveo-combobox-input input{width:100%;height:36px;padding:0 5px;font-size:14px;border:thin solid #bcc3ca}.coveo-combobox-input input:-moz-placeholder,.coveo-combobox-input input::-moz-placeholder{opacity:1}.coveo-combobox-input .coveo-combobox-input-icon{position:absolute;display:flex;justify-content:center;align-items:center;height:100%;margin-left:10px;pointer-events:none}.coveo-combobox-input .coveo-combobox-input-icon+input{padding-left:35px}.coveo-combobox-input .coveo-combobox-input-icon svg{width:1em;height:1em}.coveo-combobox-wait-animation{position:absolute;right:10px;top:7px}.coveo-combobox-values{background-color:#fff;border:thin solid #bcc3ca;border-top:none;width:100%;padding:0;margin:0;position:absolute;top:36px;z-index:1;box-shadow:0 3px 3px 3px rgba(0,0,0,.1);overflow:auto}.coveo-combobox-value,.coveo-combobox-value-not-found{list-style:none;padding:5px}.coveo-combobox-value.coveo-focused,.coveo-combobox-value:hover{background:#e6ecf0}.coveo-dynamic-facet-search{margin-top:15px}.coveo-dynamic-facet-search .coveo-checkbox-span-label-suffix{color:#000}.coveo-dynamic-facet-search .coveo-combobox-value{padding:0 5px}.coveo-dynamic-facet-search .coveo-combobox-value.coveo-focused .coveo-checkbox-span-label,.coveo-dynamic-facet-search .coveo-combobox-value.coveo-focused .coveo-checkbox-span-label-suffix,.coveo-dynamic-facet-search .coveo-combobox-value:hover .coveo-checkbox-span-label,.coveo-dynamic-facet-search .coveo-combobox-value:hover .coveo-checkbox-span-label-suffix{opacity:1}.coveo-dynamic-hierarchical-facet-search-value{display:flex;flex-direction:column;padding:5px;cursor:pointer}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-header{display:flex}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-header .coveo-dynamic-hierarchical-facet-search-value-label{flex-shrink:1;overflow:hidden;text-overflow:ellipsis}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-header .coveo-dynamic-hierarchical-facet-search-value-results-count{flex-shrink:0;margin-left:5px;color:#657381;font-weight:lighter}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path{padding:0;color:#657381;font-weight:lighter;display:flex}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path .coveo-dynamic-hierarchical-facet-search-value-path-ellipsis,.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path .coveo-dynamic-hierarchical-facet-search-value-path-part,.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path .coveo-dynamic-hierarchical-facet-search-value-path-prefix{display:inline}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path .coveo-dynamic-hierarchical-facet-search-value-path-prefix{white-space:pre}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path .coveo-dynamic-hierarchical-facet-search-value-path-part{flex:0 15 auto;min-width:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}@supports (max-width:max-content){.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path .coveo-dynamic-hierarchical-facet-search-value-path-part{flex:1 0 0;max-width:max-content}}.coveo-dynamic-hierarchical-facet-search-value .coveo-dynamic-hierarchical-facet-search-value-path .coveo-dynamic-hierarchical-facet-search-value-path-ellipsis{margin-right:2px}.coveo-dynamic-facet-values{padding:10px 0;margin:0;white-space:normal;list-style:none}.coveo-dynamic-facet-value.coveo-selected .coveo-checkbox-span-label,.coveo-dynamic-facet-value.coveo-selected .coveo-checkbox-span-label-suffix{font-weight:700}.coveo-dynamic-facet-value .coveo-checkbox-label{padding:5px 0;width:100%}.coveo-dynamic-facet-value .coveo-checkbox-span-label{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;line-height:1.2em}.coveo-dynamic-facet-value .coveo-checkbox-label button+.coveo-checkbox-span-label{margin-left:12px}.coveo-dynamic-facet-value .coveo-checkbox-span-label-suffix{margin-left:8px;color:#67768b}.coveo-dynamic-facet-value .coveo-checkbox-label:hover .coveo-checkbox-span-label,.coveo-dynamic-facet-value.coveo-focused .coveo-checkbox-span-label{opacity:.7}.coveo-dynamic-facet-show-more{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;width:100%;text-align:left;margin-top:2px;padding:3px 0;font-size:15px}.coveo-dynamic-facet-show-more:visited,.coveo-dynamic-facet-show-more:visited:hover{color:#609}.coveo-dynamic-facet-show-more:hover,.coveo-dynamic-facet-show-more:hover a{text-decoration:underline}.coveo-dynamic-facet-show-more.coveo-selected *{color:#0059b3}.coveo-dynamic-facet-show-more:before{width:15px;display:inline-block;text-decoration:underline}.coveo-dynamic-facet-show-more:before,.coveo-dynamic-facet-show-more:hover:before{text-decoration:none}.coveo-dynamic-facet-show-more:before{content:\"+\"}.coveo-dynamic-facet-show-less{color:#0059b3;text-decoration:none;cursor:pointer;overflow:visible;width:auto;padding:0;margin:0;background:none;border:none;color:#296896;width:100%;text-align:left;margin-top:2px;padding:3px 0;font-size:15px;color:#313a45}.coveo-dynamic-facet-show-less:visited,.coveo-dynamic-facet-show-less:visited:hover{color:#609}.coveo-dynamic-facet-show-less:hover,.coveo-dynamic-facet-show-less:hover a{text-decoration:underline}.coveo-dynamic-facet-show-less.coveo-selected *{color:#0059b3}.coveo-dynamic-facet-show-less:before{width:15px;display:inline-block;text-decoration:underline}.coveo-dynamic-facet-show-less:before,.coveo-dynamic-facet-show-less:hover:before{text-decoration:none}.coveo-dynamic-facet-show-less:before{content:\"-\"}.coveo-dynamic-facet-collapsed-values{line-height:1.6em;display:none}.coveo-dynamic-facet-collapsed .coveo-dynamic-facet-show-less,.coveo-dynamic-facet-collapsed .coveo-dynamic-facet-show-more,.coveo-dynamic-facet-collapsed .coveo-dynamic-facet-value{display:none}.coveo-dynamic-facet-collapsed .coveo-dynamic-facet-collapsed-values{display:inherit}.CoveoMissingTerms{font-size:12px}.CoveoMissingTerms .coveo-field-caption{margin-right:5px}.CoveoMissingTerms .coveo-clickable{color:#0059b3;text-decoration:none;cursor:pointer;border:none;padding:0;margin-right:5px}.CoveoMissingTerms .coveo-clickable:visited,.CoveoMissingTerms .coveo-clickable:visited:hover{color:#609}.CoveoMissingTerms .coveo-clickable:hover,.CoveoMissingTerms .coveo-clickable:hover a{text-decoration:underline}.CoveoMissingTerms .coveo-clickable.coveo-selected *{color:#0059b3}.CoveoMissingTerms .coveo-missing-term{text-decoration:line-through}.coveo-suggestion-container{width:100%;display:flex}.coveo-suggestion-container .coveo-magicbox-suggestions{border:none;float:left;flex-basis:30%;max-width:30%}.coveo-suggestion-container .coveo-preview-container{border:none;background:#fff;flex-basis:70%;max-width:70%}.coveo-suggestion-container .coveo-preview-container .coveo-preview-results{display:flex;flex-wrap:wrap;justify-content:flex-start;overflow:hidden;width:100%}.coveo-suggestion-container .coveo-preview-container .coveo-preview-results .coveo-preview-layout{box-sizing:border-box;margin:10px;padding:20px;width:calc(50% - 20px)}.coveo-suggestion-container .coveo-preview-container .coveo-preview-results .coveo-preview-layout .coveo-default-result-preview{position:relative;padding:100% 0 0;margin:0}.coveo-suggestion-container .coveo-preview-container .coveo-preview-results .coveo-preview-layout .coveo-default-result-preview .CoveoImageFieldValue{position:absolute;top:0;left:0;right:0;padding:100% 0 0}.coveo-suggestion-container .coveo-preview-container .coveo-preview-results .coveo-preview-layout .coveo-default-result-preview .CoveoImageFieldValue span{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center}.coveo-suggestion-container .coveo-preview-container .coveo-preview-results .coveo-preview-layout .coveo-default-result-preview .CoveoImageFieldValue span img{max-width:100%;max-height:100%;width:auto;height:auto;margin:0}.coveo-suggestion-container .coveo-preview-container .coveo-preview-results .coveo-preview-layout .coveo-default-result-preview .CoveoResultLink{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:20px}.coveo-suggestion-container .coveo-preview-container .coveo-preview-selectable.coveo-omnibox-selected,.coveo-suggestion-container .coveo-preview-container .coveo-preview-selectable:hover{outline:thin solid #bcc3ca;outline-offset:-1px}.CoveoSortDropdown .coveo-dropdown{display:-moz-flex;display:-ms-flexbox;display:flex;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;font-size:12px;font-weight:700;padding:0 5px 10px;border-bottom:thin solid #bcc3ca;text-transform:uppercase;border-bottom:2px solid #bcc3ca;text-indent:0;margin:0;border:none;cursor:pointer;background-position-y:-5px;font-family:inherit}.CoveoSortDropdown .coveo-dropdown.coveo-selected,.CoveoSortDropdown .coveo-dropdown.coveo-selected:hover{border-bottom:2px solid #263e55}.CoveoSortDropdown .coveo-dropdown:hover{color:#263e55}.CoveoSortDropdown .coveo-dropdown:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.CoveoSortDropdown .CoveoSort{display:none}.CoveoSmartSnippet{margin-top:30px;display:none}.CoveoSmartSnippet.coveo-smart-snippet-has-answer{display:block}.coveo-smart-snippet-question{font-size:18px;border-bottom:2px solid #dee1e4;padding-bottom:10px}.coveo-smart-snippet-answer{display:flex;flex-direction:column;border:2px solid #dee1e4;border-radius:4px;padding:16px}.coveo-smart-snippet-content{transition:height .5s ease-in-out;overflow:hidden;margin-top:16px}.coveo-height-limiter-container-active{position:relative}.coveo-height-limiter-container-active:after{content:\"\";background-color:hsla(0,0%,100%,0);background-image:linear-gradient(180deg,hsla(0,0%,100%,0),#fff);pointer-events:none;display:inline-block;position:absolute;left:0;right:0;height:64px;bottom:0;z-index:1;opacity:1;transition:opacity .5s ease-in-out}.coveo-height-limiter-container-active.coveo-height-limiter-container-expanded:after{opacity:0}.coveo-smart-snippet-answer .coveo-height-limiter-button{display:none;justify-content:center;align-items:center}.coveo-smart-snippet-answer .coveo-height-limiter-button.coveo-height-limiter-button-active{display:flex}.coveo-smart-snippet-answer .coveo-height-limiter-button{margin-top:5px;border:none;align-self:center;padding:8px;background:none;color:#0059b3;cursor:pointer}.coveo-smart-snippet-answer .coveo-height-limiter-button:focus,.coveo-smart-snippet-answer .coveo-height-limiter-button:hover{text-decoration:underline}.coveo-smart-snippet-answer .coveo-height-limiter-button-label{font-size:16px;margin-right:16px}.coveo-smart-snippet-answer .coveo-height-limiter-button-icon{display:inline-block;width:24px;height:14px}a.CoveoResultLink.coveo-smart-snippet-source{margin-top:24px}a.CoveoResultLink.coveo-smart-snippet-source-url{display:block;color:#657381;text-decoration:none}a.CoveoResultLink.coveo-smart-snippet-source-url:focus,a.CoveoResultLink.coveo-smart-snippet-source-url:hover{text-decoration:underline}a.CoveoResultLink.coveo-smart-snippet-source-title{margin-top:8px;display:block;font-size:22px;color:#0059b3;text-decoration:none}a.CoveoResultLink.coveo-smart-snippet-source-title:focus,a.CoveoResultLink.coveo-smart-snippet-source-title:hover{text-decoration:underline}.coveo-user-feedback-banner-container{display:flex;justify-content:flex-end;align-items:center;padding:6px 8px 8px;overflow:hidden;font-size:12px}.coveo-user-feedback-banner-buttons{display:flex;overflow:visible}.coveo-user-feedback-banner-buttons button{border:none;background:none;padding:0;margin-left:18px;display:inline-flex;align-items:center;fill:#313a45;color:#313a45;overflow:visible;cursor:pointer}.coveo-user-feedback-banner-buttons button:focus,.coveo-user-feedback-banner-buttons button:hover{text-decoration:underline}.coveo-user-feedback-banner-buttons button.coveo-user-feedback-banner-button-active{cursor:default}.coveo-user-feedback-banner-buttons button.coveo-user-feedback-banner-button-active:focus,.coveo-user-feedback-banner-buttons button.coveo-user-feedback-banner-button-active:hover{text-decoration:none}.coveo-user-feedback-banner-thanks-icon{display:inline-block;width:14px;height:14px;margin-right:3px}.coveo-user-feedback-banner-button-active .coveo-user-feedback-banner-thanks-icon{overflow:visible;position:relative}.coveo-user-feedback-banner-button-active .coveo-user-feedback-banner-thanks-icon:before{content:\" \";display:inline-block;position:absolute;top:10px;height:0;width:0;border:7px solid transparent;border-bottom-color:#486fc7}.coveo-user-feedback-banner-button-active.coveo-user-feedback-banner-yes-button{color:#3a833c;fill:#3a833c}.coveo-user-feedback-banner-button-active.coveo-user-feedback-banner-no-button{color:#cc0d00;fill:#cc0d00}.coveo-user-feedback-banner-thanks{overflow:hidden;box-sizing:border-box;height:0;display:flex;justify-content:flex-end;align-items:center;background-color:#486fc7;border-radius:2px;color:#fff;font-size:14px;font-weight:lighter}.coveo-user-feedback-banner-thanks-active{height:auto}.coveo-user-feedback-banner-thanks>*{margin:8px 16px 8px 0}button.coveo-user-feedback-banner-explain-why{border:none;background:none;padding:0;color:#fff;font-weight:400;font-size:12px;cursor:pointer;text-decoration:underline;display:none}button.coveo-user-feedback-banner-explain-why:focus,button.coveo-user-feedback-banner-explain-why:hover{text-decoration:none}button.coveo-user-feedback-banner-explain-why-active{display:inline}.coveo-user-explanation-modal-explanation-section{display:flex;flex-wrap:wrap;padding:24px}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-details,.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations{margin:16px}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-details-label,.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations-label{padding:0;margin-bottom:12px}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations{border:none;padding:0}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations .coveo-radio input[type=radio]+.coveo-radio-input-label{line-height:24px;height:24px}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations .coveo-radio input[type=radio]+.coveo-radio-input-label:after,.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations .coveo-radio input[type=radio]+.coveo-radio-input-label:before{width:24px;height:24px}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations .coveo-radio input[type=radio]+.coveo-radio-input-label:before{border-color:#657381}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations .coveo-radio input[type=radio]:checked+.coveo-radio-input-label:before{border-color:#1372ec}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-explanations .coveo-radio input[type=radio]:checked+.coveo-radio-input-label:after{background-color:#1372ec}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-details{display:flex;flex-direction:column;align-items:flex-start;flex-grow:1}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-details.coveo-hidden{visibility:hidden}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-details-textarea{border:thin solid #7e8c9a;border-radius:2px;min-width:256px;min-height:128px;resize:none;flex-grow:1;align-self:stretch;padding:8px;font-family:Arial,Helvetica,sans-serif;color:#000;font-size:1em}.coveo-user-explanation-modal-explanation-section .coveo-user-explanation-modal-details-textarea:focus{border-color:#1372ec}.coveo-user-explanation-modal-buttons-section{display:flex;justify-content:flex-end;border-top:thin solid #d8d8d8;padding:24px 32px}.coveo-user-explanation-modal-buttons-section button{border-radius:2px;font-size:1em;margin:0;padding:6px 10px;cursor:pointer}.coveo-user-explanation-modal-buttons-section .coveo-user-explanation-modal-send-button{background-color:#1372ec;color:#fff;border:none}.coveo-user-explanation-modal-buttons-section .coveo-user-explanation-modal-send-button:focus,.coveo-user-explanation-modal-buttons-section .coveo-user-explanation-modal-send-button:hover{background-color:#215cd3}.coveo-user-explanation-modal-buttons-section .coveo-user-explanation-modal-cancel-button{background:none;color:#657381;border:thin solid #657381;margin-left:24px}.coveo-user-explanation-modal-buttons-section .coveo-user-explanation-modal-cancel-button:focus,.coveo-user-explanation-modal-buttons-section .coveo-user-explanation-modal-cancel-button:hover{background-color:#0000001a}.coveo-user-explanation-modal.coveo-modal-container>.coveo-modal-content{width:auto;height:auto;border-radius:4px;overflow:hidden;box-shadow:2px 2px 5px #00000040}.coveo-user-explanation-modal .coveo-modal-body{padding:0;flex-basis:auto}.coveo-user-explanation-modal .coveo-modal-header{height:auto;padding:0;border:none}.coveo-user-explanation-modal .coveo-modal-header h1{color:#000;margin:40px 40px 24px;font-size:1.25em}.coveo-user-explanation-modal+.coveo-modal-backdrop{background-color:#000;opacity:.3}.coveo-shadow-iframe{display:block;border:none;width:100%}.CoveoSmartSnippetSuggestions{display:none;margin:16px 0;border:2px solid #dee1e4;border-radius:4px}.CoveoSmartSnippetSuggestions.coveo-smart-snippet-suggestions-has-questions{display:block}.coveo-smart-snippet-suggestions-questions{margin:0;padding:0;list-style:none}.coveo-smart-snippet-suggestions-questions-title{display:block;padding:16px;font-size:1.2em;font-weight:700}.coveo-smart-snippet-suggestions-question-title{display:flex;justify-content:space-between;align-items:center;border-top:2px solid #dee1e4;padding:16px;cursor:pointer}.coveo-smart-snippet-suggestions-question-title-label{user-select:none}.coveo-smart-snippet-suggestions-question-title-checkbox{display:flex;justify-content:center;align-items:center;width:15px;height:15px;color:#1d4f76;flex-shrink:0;margin-left:1.2em}.coveo-smart-snippet-suggestions-question-title-checkbox svg{width:100%;height:100%}.coveo-smart-snippet-suggestions-question-snippet{overflow:hidden;transition:height .2s ease-in-out}.coveo-smart-snippet-suggestions-question-snippet-content{padding:16px 16px 24px}a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-title,a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-url{padding:0 16px}a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-url{display:block;color:#657381;text-decoration:none}a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-url:focus,a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-url:hover{text-decoration:underline}a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-title{margin-top:8px;display:block;font-size:19px;color:#0059b3;text-decoration:none;padding-bottom:16px}a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-title:focus,a.CoveoResultLink.coveo-smart-snippet-suggestions-question-source-title:hover{text-decoration:underline}";
styleInject(css_248z$2);

var css_248z$3 = ".CoveoSearchbox .CoveoSearchButton {\n  z-index: var(--tr-coveo-0);\n}\n\n.coveo-tr-search-box {\n  border-radius: 0.313rem 0 0 0.313rem;\n}\n\n.coveo-tr-search-container {\n  display: flex;\n}\n\n.coveo-tr-search-button {\n  background-color: var(--tr-coveo-color-tr-orange);\n  border: 0;\n  border-radius: 0 0.313rem 0.313rem 0;\n  font-family: var(--tr-coveo-font-family);\n  font-size: var(--tr-coveo-font-size-s);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  width: 8.313rem;\n}\n\n.coveo-tr-searchtab-hide {\n  display: none;\n}\n\n.coveo-tr-searchbox-withoutInput .CoveoSearchButton {\n  border: none;\n  height: 100%;\n  position: absolute;\n}\n\n.coveo-tr-searchbox-withoutInput .coveo-search-button g,\n.coveo-tr-searchbox-withoutInput .coveo-search-button .coveo-magnifier-circle-svg {\n  fill: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-tr-searchbox-dark {\n  position: relative;\n}\n\n.coveo-tr-searchbox-dark .CoveoSearchButton:hover .coveo-magnifier-circle-svg {\n  fill: var(--color-tr-gray-light) !important;\n}\n\n.coveo-tr-searchbox-dark .coveo-search-button-svg g {\n  fill: var(--tr-coveo-color-tr-gray-lighter);\n}\n\n.coveo-tr-searchbox-dark .magic-box-clear-svg g {\n  fill: var(--tr-coveo-color-tr-gray-lighter);\n}\n\n.coveo-tr-searchbox-withoutInput .CoveoOmnibox + .CoveoSearchButton:hover .coveo-magnifier-circle-svg {\n  fill: var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-clear {\n  height: var(--tr-coveo-searchbox-height-searchbox);\n}\n\n.coveo-tr-searchbox-dark .magic-box-clear,\n.coveo-tr-searchbox-withoutInput .magic-box-clear {\n  background-color: inherit !important;\n  position: absolute;\n  right: 4rem;\n}\n\n.coveo-tr-searchbox-withoutInput .magic-box-clear {\n  height: 3.4rem;\n}\n\n.coveo-tr-searchbox-icon .magic-box-clear {\n  height: 2.75rem;\n  right: 3rem;\n}\n\nbody:lang(ar) .magic-box-clear {\n  left: 4rem;\n  right: unset;\n}\n\n.coveo-tr-searchbox-icon .magic-box.magic-box-notEmpty .magic-box-clear {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  right: 3rem;\n  visibility: visible;\n}\n\n.magic-box-icon {\n  overflow: hidden;\n  transition: all 0.3s;\n  width: 100%;\n}\n\n.coveo-tr-searchbox-withoutInput .magic-box-icon g {\n  fill: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-tr-searchbox-icon {\n  position: relative;\n}\n\n.coveo-tr-searchbox-icon input {\n  height: 2.75rem !important;\n}\n\n.coveo-tr-searchbox-icon .magic-box-input {\n  height: 2.75rem;\n}\n\n.coveo-tr-searchbox-icon .CoveoSearchButton {\n  border: none;\n  height: 2.6rem;\n  position: absolute;\n  right: 0.125rem;\n  top: 0.125rem;\n  transition: background-color 0.1s ease-in-out;\n  width: 2.938rem;\n}\n\n.coveo-tr-searchbox-icon .coveo-search-button g {\n  fill: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-tr-searchbox-icon .magic-box-icon g {\n  fill: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .coveo-search-button g {\n  fill: var(--tr-coveo-color-tr-default);\n}\n\n.coveo-tr-searchbox-icon .magic-box-notEmpty + .CoveoSearchButton g {\n  fill: var(--tr-coveo-color-tr-white);\n}\n\n.coveo-tr-searchbox-dark .CoveoSearchButton {\n  background-color: inherit !important;\n  border: none;\n  border-radius: 0 0.375rem 0.375rem 0;\n  height: var(--tr-coveo-searchbox-height-searchbox);\n  position: absolute;\n  right: 0.938rem;\n}\n\n/* CSS for Mega Menu */\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .CoveoSearchButton {\n  background-color: var(--tr-coveo-color-tr-racing-green);\n  border: 2px solid var(--tr-coveo-color-tr-racing-green);\n}\n\n.coveo-tr-searchbox-dark .magic-box-notEmpty + .CoveoSearchButton {\n  background-color: var(--tr-coveo-color-tr-gray);\n}\n\n.coveo-tr-searchbox-icon .magic-box-notEmpty + .CoveoSearchButton {\n  background-color: var(--tr-coveo-color-tr-orange);\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .magic-box-notEmpty + .CoveoSearchButton {\n  background-color: var(--tr-coveo-color-tr-orange-400) !important;\n  border: 2px solid var(--tr-coveo-color-tr-orange-400);\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .CoveoSearchButton:hover {\n  background-color: var(--tr-coveo-color-tr-orange-light-400);\n  border: 2px solid var(--tr-coveo-color-tr-orange-400);\n}\n\n.coveo-tr-searchbox-dark .CoveoSearchButton:hover g {\n  fill: var(--color-tr-gray-light) !important;\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .CoveoSearchButton:hover g {\n  fill: var(--tr-coveo-color-tr-black) !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-icon {\n  align-items: center;\n  display: flex;\n  height: var(--tr-coveo-searchbox-height-searchbox);\n  margin-left: 1rem;\n}\n\n.coveo-tr-searchbox-dark .CoveoOmnibox {\n  border: none !important;\n  height: var(--tr-coveo-searchbox-height-searchbox);\n  margin-right: 15px;\n}\n\n.coveo-tr-searchbox-dark .magic-box-input {\n  background-color: var(--color-tr-gray-medium);\n  border-radius: 0.375rem !important;\n  height: var(--tr-coveo-searchbox-height-searchbox);\n}\n\n.coveo-tr-searchbox-withoutInput .magic-box-underlay,\n.coveo-tr-searchbox-withoutInput input {\n  height: 100% !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-input input {\n  color: var(--tr-coveo-color-tr-white) !important;\n  font-size: var(--tr-coveo-font-size-xxxs);\n  height: var(--tr-coveo-searchbox-height-searchbox);\n}\n\n.coveo-tr-searchbox-dark .magic-box-clear:hover .magic-box-clear-svg g {\n  fill: var(--color-tr-gray-light) !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-hasSuggestion {\n  background-color: var(--color-tr-gray-medium);\n  border: none !important;\n  border-top: 0.0625rem solid var(--tr-coveo-color-tr-gray-muted) !important;\n  box-shadow: none !important;\n  left: 0 !important;\n  position: absolute !important;\n  top: 3.375rem !important;\n}\n\n.magic-box-suggestions {\n  border: 0.063rem solid var(--color-tr-gray-medium);\n}\n\nbody:lang(ar) .magic-box-input > input {\n  direction: rtl;\n  padding: var(--tr-coveo-searchbox-arabic-site-padding);\n  text-align: right;\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .coveo-omnibox-selectable,\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .coveo-query-syntax-disabled .magic-box-input input {\n  font-family: var(--tr-coveo-font-family-S3) !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-hasFocus .magic-box-suggestions {\n  display: none !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-notEmpty .magic-box-hasSuggestion {\n  display: block !important;\n}\n\n.coveo-tr-searchbox-dark .coveo-magicbox-suggestions {\n  border: none !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-suggestion {\n  background-color: inherit !important;\n  border: none !important;\n  color: var(--tr-coveo-color-tr-white) !important;\n  font-size: var(--tr-coveo-font-size-xxxs) !important;\n  padding: var(--tr-coveo-searchbox-padding-suggestion) !important;\n}\n\n.coveo-tr-search-button span {\n  color: var(--tr-coveo-color-tr-white);\n}\n\n.coveo-tr-searchbox-dark .magic-box-suggestion span {\n  color: var(--tr-coveo-color-tr-white) !important;\n}\n\n.coveo-tr-searchbox-dark .magic-box-suggestion:hover {\n  text-decoration: underline;\n}\n\n.coveo-tr-searchbox-icon .magic-box-notEmpty + .CoveoSearchButton:hover {\n  background-color: var(--tr-coveo-color-tr-orange-dark-shade-20);\n}\n\n.coveo-search-section.coveo-search-section-withoutInput .magic-box-notEmpty ~ .CoveoSearchButton {\n  background-color: var(--tr-coveo-color-tr-gray-lighter);\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .magic-box-notEmpty + .CoveoSearchButton:hover {\n  background-color: var(--tr-coveo-color-tr-orange-light-400) !important;\n  border: 2px solid var(--tr-coveo-color-tr-orange-400) !important;\n}\n\n.coveo-tr-searchbox-icon .coveo-accessible-button {\n  overflow: visible;\n}\n\n.coveo-tr-searchbox-icon .magic-box {\n  border: 0.063rem solid var(--color-tr-gray-medium);\n  border-radius: 0.25rem;\n  box-sizing: border-box;\n  height: 2.9rem;\n}\n\n.tr-SiteSubHeader :focus {\n  /* Adding this style to fix search bar issue for DSH-490 */\n  box-shadow: none !important;\n  outline: 1px auto -webkit-focus-ring-color !important;\n}\n\n.coveo-tr-searchbox-icon .magic-box-hasFocus {\n  border: 0.125rem solid var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-tr-searchbox-icon .magic-box-notEmpty + .CoveoSearchButton:hover .coveo-magnifier-circle-svg {\n  fill: var(--tr-coveo-color-tr-white) !important;\n}\n\n.CoveoSearchbox .CoveoOmnibox + .CoveoSearchButton:hover .coveo-magnifier-circle-svg {\n  fill: #1d4f76;\n}\n\n.coveo-tr-searchbox-icon .CoveoOmnibox + .CoveoSearchButton:hover .coveo-magnifier-circle-svg {\n  fill: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-tr-search-box-suggestions-screen-reader-only {\n  clip: rect(1px 1px 1px 1px);\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  width: 1px;\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .magic-box-notEmpty + .CoveoSearchButton:hover g,\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .magic-box-notEmpty + .CoveoSearchButton:hover .coveo-magnifier-circle-svg {\n  fill: var(--tr-coveo-color-tr-black) !important;\n}\n\n.coveo-tr-searchbox-withoutInput .magic-box-icon {\n  position: absolute;\n  top: 0.313rem;\n}\n\n.coveo-tr-searchbox-icon .magic-box-icon {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  visibility: hidden;\n}\n\nbody:lang(ar) .magic-box-icon {\n  left: unset;\n  margin-right: unset;\n}\n\n.coveo-tr-searchbox-icon .magic-box-notEmpty .magic-box-icon,\n.coveo-tr-searchbox-withoutInput .magic-box-notEmpty .magic-box-icon {\n  visibility: visible;\n}\n\n.coveo-dropdown-header-wrapper {\n  margin-top: 0.063rem !important;\n}\n\n.coveo-tr-searchbox-withoutInput {\n  justify-content: flex-end;\n  position: relative;\n}\n\n.coveo-search-section-withoutInput {\n  display: none !important;\n  left: 0.75rem;\n  position: absolute;\n  right: 0.75rem;\n  z-index: var(--tr-coveo-searchbox-z-index-buttons);\n}\n\nbody:lang(ar) .coveo-search-section-withoutInput {\n  right: 14.75rem;\n}\n\n.coveo-tr-searchbox-withoutInput .CoveoOmnibox {\n  border: none;\n  flex: 1;\n  transition: flex 0.1s;\n}\n\n.coveo-search-section.coveo-search-section-withoutInput .CoveoOmnibox {\n  border: 0.063rem solid var(--tr-coveo-color-tr-gray-lighter);\n  border-radius: 0.375rem;\n  flex: 1;\n  height: 3.563rem;\n}\n\n.coveo-search-section-withoutInput .magic-box-input {\n  height: 3.563rem;\n}\n\n.coveo-search-section-withoutInput-expanded {\n  /* Reset Coveo SearchBox styles */\n  display: block !important;\n  margin-top: 0.5rem !important;\n  max-width: unset !important;\n  padding-left: unset !important;\n  padding-right: unset !important;\n}\n\n[data-is-expanded=\"false\"] {\n  min-width: 2.758rem;\n  position: unset;\n}\n\n[data-is-expanded=\"true\"] {\n  min-width: 3rem;\n  position: initial;\n}\n\n.coveo-searchboxWithoutInput-toggle-buttons {\n  position: absolute;\n  right: 0.4rem;\n  top: 1.04rem;\n}\n\n.coveo-searchboxWithoutInput-toggle-buttons button {\n  background-color: inherit;\n  border: none;\n  cursor: pointer;\n}\n\n.coveo-searchboxWithoutInput-toggle-buttons.coveo-searchboxWithoutInput-toggle-buttons-expanded {\n  z-index: var(--tr-coveo-searchbox-z-index-buttons-expanded);\n}\n\n.coveo-tr-searchbox-withoutInput .coveo-accessible-button {\n  overflow: visible;\n}\n\n.coveo-searchboxWithoutInput-toggle {\n  position: absolute;\n  right: 0;\n}\n\n.coveo-search-section-withoutInput .coveo-magicbox-suggestions {\n  border: 0.063rem solid var(--tr-coveo-color-tr-gray-lighter) !important;\n}\n\n.coveo-omnibox-selected {\n  border-left: 0.25rem solid var(--tr-coveo-color-tr-orange);\n}\n\n.coveo-tr-searchbox--new-branding .CoveoSearchbox .coveo-omnibox-selected {\n  border-left: 0.25rem solid var(--tr-coveo-color-tr-orange-400);\n}\n\n.coveo-tr-searchbox-sticky {\n  background-color: var(--color-tr-gray-light);\n  box-sizing: border-box;\n  min-height: 6.563rem;\n  padding: var(--tr-coveo-searchbox-padding-searchbox-sticky);\n  position: sticky;\n  top: 0;\n  z-index: var(--tr-coveo-searchbox-z-index-500);\n}\n\n.magic-box .magic-box-input {\n  height: 100%;\n}\n\n.CoveoSearchbox input::placeholder {\n  color: var(--color-tr-gray-light);\n}\n\n.coveo-tr-searchbox-dark input::placeholder {\n  color: var(--tr-coveo-color-tr-gray-lighter);\n}\n\n.coveo-tr-searchbox-dark input:focus::placeholder {\n  color: var(--color-tr-gray-light);\n}\n\n.coveo-search-section {\n  margin: var(--tr-coveo-0) var(--tr-coveo-searchbox-auto) var(--tr-coveo-searchbox-margin-2);\n  max-width: var(--tr-coveo-searchbox-max-width);\n  top: var(--tr-coveo-0);\n}\n\n.CoveoSearchInterface .coveo-search-section {\n  align-items: unset;\n  margin-bottom: var(--tr-coveo-0);\n  margin-top: var(--tr-coveo-0);\n}\n\n/* CSS for Mega Menu */\n\n.siteNavigationHeader .search-box-container.active .coveo-search-section.coveo-drop-down-header {\n  margin: var(--tr-coveo-searchbox-megamenu-padding) var(--tr-coveo-searchbox-auto);\n}\n\n.siteNavigationHeader .coveo-custom-searchbox-dropdown.active .coveo-custom-searchbox-dropdown-down-icon-svg {\n  transform: rotate(-180deg);\n}\n\n.siteNavigationHeader .coveo-custom-searchbox-dropdown {\n  border: none;\n}\n\n/* CSS for Global Footer Start */\n\n[data-search-box-type=\"dark\"] {\n  margin: var(--tr-coveo-searchbox-margin-3) var(--tr-coveo-0);\n  min-height: unset !important;\n}\n\n[data-search-box-type=\"dark\"] .coveo-search-section {\n  padding: var(--tr-coveo-0) var(--tr-coveo-searchbox-padding-8);\n}\n\n.coveo-tr-search-box-left .coveo-search-section {\n  margin-left: 0 !important;\n}\n\n/* CSS for Global Footer End */\n\n@media only screen and (max-width: 22.5rem) {\n  .coveo-tr-searchbox-icon .magic-box {\n    height: 2.375rem !important;\n  }\n\n  .coveo-tr-searchbox-icon input,\n  .coveo-tr-searchbox-icon .CoveoSearchButton {\n    height: 2.125rem !important;\n  }\n\n  .coveo-tr-searchbox-icon .magic-box-clear-svg {\n    height: 1rem !important;\n    width: 0.813rem !important;\n  }\n\n  .coveo-tr-searchbox-icon .magic-box-icon {\n    top: calc(2.125rem / 2) !important;\n  }\n}\n\n.coveo-tr-searchbox-header {\n  display: flex;\n}\n\n@media screen and (min-width: 1200px) {\n  .coveo-search-section-withoutInput-expanded {\n    margin-right: -1rem !important;\n    margin-top: 0.7rem !important;\n    max-width: 39% !important;\n  }\n}\n\n@media screen and (max-width: 1199px) {\n  .coveo-search-section-withoutInput-expanded,\n  [data-main-is-expanded=\"true\"] {\n    margin-top: 5.7rem !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  #coveo-tr-search-header-component {\n    margin-top: 4.9rem !important;\n  }\n\n  [data-main-is-expanded=\"true\"] {\n    margin-top: unset !important;\n  }\n\n  [data-search-box-type=\"dark\"] {\n    margin: var(--tr-coveo-searchbox-margin-0);\n  }\n\n  [data-search-box-type=\"dark\"] .coveo-search-section {\n    margin: var(--tr-coveo-searchbox-margin-0);\n    padding-bottom: var(--tr-coveo-searchbox-padding-1);\n    padding-left: var(--tr-coveo-searchbox-padding-1);\n    padding-right: var(--tr-coveo-unset);\n    padding-top: var(--tr-coveo-searchbox-padding-1);\n  }\n\n  .coveo-tr-search-header-expanded {\n    border: 0.0625rem solid var(--tr-coveo-color-tr-gray-muted);\n    /* stylelint-disable */\n    grid-column: 1 / 5;\n    grid-row-start: 2;\n    /* stylelint-enable */\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .coveo-search-section-withoutInput {\n    padding: var(--tr-coveo-unset) !important;\n  }\n\n  .coveo-search-section-withoutInput-expanded .CoveoSearchbox {\n    margin-right: 0.75rem !important;\n  }\n\n  .coveo-tr-searchbox-dark {\n    margin-right: var(--tr-coveo-unset) !important;\n  }\n\n  .coveo-tr-searchbox-icon {\n    margin-right: var(--tr-coveo-unset) !important;\n  }\n\n  .coveo-drop-down-header {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .coveo-search-section {\n    padding: var(--tr-coveo-searchbox-dropdown-padding-mobile);\n  }\n}\n\nbody:lang(ar) .coveo-searchboxWithoutInput-toggle-buttons {\n  right: unset;\n}\n\nbody:lang(ar) .tr-SiteHeader-searchButton > svg {\n  display: none;\n}\n\nbody:lang(ar) .coveo-tr-searchbox-icon .magic-box-notEmpty .magic-box-icon,\nbody:lang(ar) .coveo-tr-searchbox-withoutInput .magic-box-notEmpty .magic-box-icon,\nbody:lang(ar) .coveo-visible-to-screen-reader-only {\n  left: unset;\n}\n";
styleInject(css_248z$3);

var AccessibilityLabels;
(function (AccessibilityLabels) {
  // comes from accessibility team
  AccessibilityLabels["SEARCH_SUGGESTIONS_NOTICE"] = "Start typing to show search suggestions and select one to initiate the search";
})(AccessibilityLabels || (AccessibilityLabels = {}));

/* eslint-disable jsx-a11y/anchor-is-valid */
var SearchBox = function SearchBox(props) {
  var _props$baseUri = props.baseUri,
    baseUri = _props$baseUri === void 0 ? SearchPageUriEnum.V2_ENV : _props$baseUri,
    facetSearchEnable = props.facetSearchEnable,
    facetDataField = props.facetDataField,
    symbolsToRemove = props.symbolsToRemove,
    _props$analyticsEndpo = props.analyticsEndpointBaseUri,
    analyticsEndpointBaseUri = _props$analyticsEndpo === void 0 ? SearchAnalyticsUriEnum.NON_HIPPA : _props$analyticsEndpo;
  var onHeaderStateChange = props == null ? void 0 : props.onHeaderStateChange;
  var coveoBaseUri = baseUri || getCoveoSearchPageUri(baseUri);
  var currentSearchBoxId = "searchBox" + generateRandomString();
  var searchHub = props == null ? void 0 : props.searchHub;
  useCoveo(props, currentSearchBoxId, SearchConstant.COVEO_SEARCH_RESULT_ID, coveoBaseUri);
  var logger = new SearchLogger(props == null ? void 0 : props.loggerLevel);
  var searchBoxType = props.searchBoxType,
    isSearchboxSticky = props.isSearchboxSticky,
    searchBoxLayout = props.searchBoxLayout;
  var _useState = useState(false),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var handleExpandedSearchBoxInHeader = function handleExpandedSearchBoxInHeader(value) {
    setIsExpanded(value);
    if (onHeaderStateChange) {
      onHeaderStateChange(value);
    }
  };
  useEffect(function () {
    if (facetSearchEnable) {
      var queryHandler = function queryHandler(_, args) {
        if (args != null && args.origin) {
          var queryText = Coveo.state(args.origin.root, 'q');
          if (queryText) {
            var facetTitle = getFacetTitle(queryText, args.origin.root, facetDataField);
            if (facetTitle) {
              selectFacet(facetTitle);
            }
          }
        }
      };
      Coveo.$$(document.body).on('newQuery', queryHandler);
      return function () {
        return Coveo.$$(document.body).off('newQuery', queryHandler);
      };
    }
    return function () {};
  }, [facetSearchEnable, facetDataField]);
  var searchBoxLeft = searchBoxLayout === SearchBoxAlignment.LEFT;
  useEffect(function () {
    /** Removes some special chars from the original query string */
    var handleDoneBuildingQuery = function handleDoneBuildingQuery(_, args) {
      var _args$queryBuilder;
      var originalQuery = args == null || (_args$queryBuilder = args.queryBuilder) == null || (_args$queryBuilder = _args$queryBuilder.expression) == null ? void 0 : _args$queryBuilder.parts[0];
      if (originalQuery && symbolsToRemove) {
        var cleanedQuery = originalQuery.replace(new RegExp("(?<=\\s|^)[" + symbolsToRemove + "](?=\\s|$)", 'g'), '');
        args.queryBuilder.expression.parts[0] = cleanedQuery;
      }
    };
    Coveo.$$(document.body).on(CoveoEventNames.DONE_BUILDING_QUERY, handleDoneBuildingQuery);
    return function () {
      Coveo.$$(document.body).off(CoveoEventNames.DONE_BUILDING_QUERY, handleDoneBuildingQuery);
    };
  }, [symbolsToRemove]);
  useEffect(function () {
    var handleAfterInitialization = function handleAfterInitialization() {
      var inputs = document.querySelectorAll('.CoveoOmnibox > .magic-box-input > input[type="text"]');
      inputs.forEach(function (input) {
        // removing the period at the end of title (hover text of the search field) , from "Search." to Search
        input.setAttribute('title', 'Search'.toLocaleString());
        input.setAttribute('aria-haspopup', 'listbox');
        input.setAttribute('aria-describedby', 'suggestionsInputDescription');
        // Removes the aria-owns attribute from the input field in the search box. This is outdated and aria-controls is now sufficient for accessibility.
        input.removeAttribute('aria-owns');
      });
      // translate the hover title of the magnifying glass to french
      var magnifyingGlassSvgIcon = document.querySelector('.coveo-search-button-svg[role="img"]');
      // Select the <title> element within the <svg>
      var magnifyingGlassTitle = magnifyingGlassSvgIcon == null ? void 0 : magnifyingGlassSvgIcon.querySelector('title');
      if (magnifyingGlassTitle) {
        magnifyingGlassTitle.textContent = 'Search'.toLocaleString();
      }
    };
    Coveo.$$(document.body).on(CoveoEventNames.AFTER_INITIALIZATION, handleAfterInitialization);
    return function () {
      Coveo.$$(document.body).off(CoveoEventNames.AFTER_INITIALIZATION, handleAfterInitialization);
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(SearchBoxProvider, Object.assign({}, props, {
    logger: logger
  }), React.createElement("div", {
    id: currentSearchBoxId,
    className: "coveoSearchBox " + (isSearchboxSticky ? 'coveo-tr-searchbox-sticky' : '') + " " + (searchBoxLeft && 'coveo-tr-search-box-left'),
    "data-is-expanded": isExpanded,
    "data-search-box-type": searchBoxType,
    "data-testid": "searchBox"
  }, searchBoxType === SearchBoxActionType.DEFAULT && React.createElement(SearchBoxDefault, null), searchBoxType === SearchBoxActionType.BUTTON && React.createElement(SearchBoxButton, null), searchBoxType === SearchBoxActionType.ICON && React.createElement(SearchBoxIcon, null), searchBoxType === SearchBoxActionType.DROPDOWN && React.createElement(SearchBoxWithDropDown, null), searchBoxType === SearchBoxActionType.WITHOUT_INPUT && React.createElement(SearchBoxWithoutInput, {
    onChange: handleExpandedSearchBoxInHeader
  }), searchBoxType === SearchBoxActionType.DARK && React.createElement(SearchBoxDark, null), React.createElement("div", {
    className: "CoveoAnalytics",
    "data-search-hub": searchHub,
    "data-endpoint": analyticsEndpointBaseUri
  }), React.createElement("div", {
    id: "suggestionsInputDescription",
    className: "coveo-tr-search-box-suggestions-screen-reader-only"
  }, AccessibilityLabels.SEARCH_SUGGESTIONS_NOTICE))));
};
SearchBox.displayName = 'CoveoSearchBox';

var _excluded$1 = ["children"];
var SearchResultContext = /*#__PURE__*/createContext(null);
var SearchResultProvider = function SearchResultProvider(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return React.createElement(SearchResultContext.Provider, {
    value: rest,
    children: children
  });
};
var useSearchResultProps = function useSearchResultProps() {
  return useContext(SearchResultContext);
};

/**
 * Calculates the number of dates in the provided HTMLCollection that are in the future.
 *
 * @param dateListElements - A collection of HTML elements containing date values in their dataset.
 * @param dateFormat - The format specification for parsing the date values.
 * @returns The count of dates that are in the future.
 */
function calculateFutureDate(dateListElements, dateFormat) {
  var currDate = moment();
  var futureDateCount = 0;
  for (var i = 0; i < dateListElements.length; i++) {
    var date = moment(dateListElements[i].dataset.value, dateFormat);
    if (date.isAfter(currDate)) {
      futureDateCount++;
    }
  }
  return futureDateCount;
}
/**
 * Sorts the html elements according to the date present in the dataset.value prop from
 * each li html element. Sorts it in descending order unless "ASC" specified.
 * @param liHtmlCollection html li elements collection
 * @param dateFormat date format in the <li> value should comply MomentFormatSpecification
 * @param order ascending or descending order
 * @returns sorted Element array
 */
function sortListElemsByDate(liHtmlCollection, dateFormat, order) {
  if (order === void 0) {
    order = 'DESC';
  }
  return Array.from(liHtmlCollection).sort(function (elemA, elemB) {
    var _elemA$dataset2, _elemB$dataset2;
    if (dateFormat === DateFieldFormat.Month) {
      var _elemA$dataset, _elemB$dataset;
      var currMonth = moment().month() + 1;
      var elemAMonth = parseInt((elemA == null || (_elemA$dataset = elemA.dataset) == null ? void 0 : _elemA$dataset.value) || '');
      var elemBMonth = parseInt((elemB == null || (_elemB$dataset = elemB.dataset) == null ? void 0 : _elemB$dataset.value) || '');
      if (order === 'DESC') {
        //position current month first
        if (elemAMonth === currMonth) return -1;
        if (elemBMonth === currMonth) return 1;
        return elemBMonth - elemAMonth;
      }
      return elemAMonth - elemBMonth;
    }
    var elemADate = moment((elemA == null || (_elemA$dataset2 = elemA.dataset) == null ? void 0 : _elemA$dataset2.value) || '', dateFormat);
    var elemBDate = moment((elemB == null || (_elemB$dataset2 = elemB.dataset) == null ? void 0 : _elemB$dataset2.value) || '', dateFormat);
    if (!elemADate.isValid() || !elemBDate.isValid()) {
      return 0;
    }
    return order === 'DESC' ? elemBDate.diff(elemADate) : elemADate.diff(elemBDate);
  });
}

var DatefieldMap = /*#__PURE__*/new Map([[DateField.Month, DateFieldFormat.Month], [DateField.Year, DateFieldFormat.Year], [DateField.CanPubMonth, DateFieldFormat.Year_month], [DateField.EstorePubMonth, DateFieldFormat.Year_month]]);
var DatePrefixId = 'Date-';
var StoreDefaultImgAlt = 'tr-logo';

/**
 * Sorts and filters month-year facet values similar to the headless implementation.
 * Shows future months first, then only the last K months from today.
 *
 * @param facetValues - Array of facet value strings (e.g., ["August 2024", "July 2024"])
 * @param showOnlyLastKMonths - Number of past months to show (default: 6)
 * @returns Filtered and sorted array of facet values
 */
var sortMonthYearValues = function sortMonthYearValues(facetValues, showOnlyLastKMonths) {
  if (showOnlyLastKMonths === void 0) {
    showOnlyLastKMonths = 6;
  }
  var now = moment();
  var currentYear = now.year();
  var currentMonth = now.month() + 1; // 1-12
  // Parse and classify entries using moment.js for language-agnostic parsing
  var validEntries = [];
  var invalidEntries = [];
  facetValues.forEach(function (value) {
    // Try to parse the value using moment.js with various formats
    // This handles different languages and formats automatically
    var parsedDate = moment(value, ['MMMM YYYY', 'MMM YYYY', 'MMMM YYYY', 'MMM YYYY', 'YYYY MMMM', 'YYYY MMM'], true); // strict parsing
    if (!parsedDate.isValid()) {
      invalidEntries.push(value);
      return;
    }
    var year = parsedDate.year();
    var month = parsedDate.month() + 1; // Convert to 1-12 range
    validEntries.push({
      value: value,
      year: year,
      month: month
    });
  });
  // Sort all valid entries in descending order
  validEntries.sort(function (a, b) {
    return b.year !== a.year ? b.year - a.year : b.month - a.month;
  });
  // Split into future and past
  var future = [];
  var past = [];
  validEntries.forEach(function (entry) {
    // Future: any month >= current month in current year, or any month in future years
    if (entry.year > currentYear || entry.year === currentYear && entry.month >= currentMonth) {
      future.push(entry);
    } else {
      past.push(entry);
    }
  });
  // Generate the expected last K months from current month (not today's date)
  var expectedPastMonths = [];
  for (var i = 0; i < showOnlyLastKMonths; i++) {
    var targetMonth = currentMonth - i;
    var targetYear = currentYear;
    // Handle year rollback when month goes below 1
    while (targetMonth < 1) {
      targetMonth += 12;
      targetYear -= 1;
    }
    expectedPastMonths.push({
      year: targetYear,
      month: targetMonth
    });
  }
  // Filter past entries to only include those that match the expected last K months
  var filteredPast = past.filter(function (entry) {
    return expectedPastMonths.some(function (expected) {
      return expected.year === entry.year && expected.month === entry.month;
    });
  });
  // Combine: future first, then filtered past, then invalid
  return future.map(function (e) {
    return e.value;
  }).concat(filteredPast.map(function (e) {
    return e.value;
  })).concat(invalidEntries);
};
/**
 * Reorders list elements inside the dateFacetContainers whose ids and flag to enable future and past date are passed as
 * argument
 * @param dateFacetContainerIds ids of the facet elements holding dates in their fields
 */
function orderListElements(dateFacetContainerIds) {
  var futureDateEnable = [];
  //Get date facet container elements
  var dateFacetContainers = dateFacetContainerIds.map(function (_ref) {
    var dateFacetContainerId = _ref.dateFacetContainerId,
      showFutureAndPastDateFacet = _ref.showFutureAndPastDateFacet;
    var facetElement = document.getElementById(dateFacetContainerId);
    futureDateEnable.push(showFutureAndPastDateFacet);
    return facetElement;
  });
  dateFacetContainers.forEach(function (dateFacetContainer, index) {
    if (dateFacetContainer) {
      var _dateListElements$;
      var facetFieldName = dateFacetContainer.id.substring(DatePrefixId.length);
      var dateListElements = dateFacetContainer.getElementsByTagName('li');
      var dateFormat = DatefieldMap.get(facetFieldName) || DateFieldFormat.Default;
      var showFutureAndPastDateFacet = futureDateEnable[index];
      var futureDateCount = 0;
      if (showFutureAndPastDateFacet) {
        // if true, show future month year + past 6 month year
        // Note: We don't need futureDateCount for our custom implementation
        // but keep it for backward compatibility with existing logic
        futureDateCount = calculateFutureDate(dateListElements, dateFormat);
      }
      var sortedCollection;
      if (showFutureAndPastDateFacet && dateFormat === DateFieldFormat.Year_month) {
        // Extract facet values from DOM elements
        var facetValues = [];
        Array.from(dateListElements).forEach(function (element) {
          var dataValue = element.dataset.value;
          if (dataValue) {
            facetValues.push(dataValue);
          }
        });
        // Apply the same filtering logic as headless implementation
        var filteredValues = sortMonthYearValues(facetValues, 6);
        // Create a map of filtered values to their original elements
        var valueToElementMap = new Map();
        Array.from(dateListElements).forEach(function (element) {
          var dataValue = element.dataset.value;
          if (dataValue) {
            valueToElementMap.set(dataValue, element);
          }
        });
        // Reorder elements based on filtered values
        sortedCollection = [];
        filteredValues.forEach(function (value) {
          var element = valueToElementMap.get(value);
          if (element) {
            sortedCollection.push(element);
          }
        });
      } else {
        // Use existing logic for other formats
        sortedCollection = sortListElemsByDate(dateListElements, dateFormat);
        if (sortedCollection.length > 6) {
          //limit to 6 items
          sortedCollection.splice(6 + futureDateCount);
        }
      }
      //replace list items with the sorted positions
      var parent = (_dateListElements$ = dateListElements[0]) == null ? void 0 : _dateListElements$.parentNode;
      if (parent) {
        while (parent.lastChild) {
          parent.removeChild(parent.lastChild);
        }
        sortedCollection.forEach(function (sortedLiElement) {
          return parent.appendChild(sortedLiElement);
        });
      }
    }
  });
}
/* istanbul ignore next */
function getCaption(item) {
  var dataValue = item.dataset.value || '';
  if (dataValue === 'Search') return dataValue;
  var parts = dataValue.split('|');
  return parts[parts.length - 1] || '';
}
/* istanbul ignore next */
function sortItems(itemsToSort, captionCache) {
  itemsToSort.sort(function (a, b) {
    var captionA = captionCache.get(a) || getCaption(a);
    var captionB = captionCache.get(b) || getCaption(b);
    return captionA.localeCompare(captionB);
  });
}
/**
 * Orders the elements of a facet container alphabetically.
 *
 * @param facetContainerIds - An array of strings representing the IDs of the facet containers.
 */
function orderFacetElementsAlphabetically(facetContainerIds) {
  facetContainerIds.forEach(function (facetContainerId) {
    var facetContainer = document.getElementById(facetContainerId);
    if (facetContainer) {
      var ul = facetContainer.querySelector('ul');
      if (ul instanceof HTMLUListElement) {
        sortFacetHierarchy(ul);
      }
    }
  });
}
/**
 * Sorts the hierarchy of facet items in a given HTMLUListElement.
 *
 * @param ul - The HTMLUListElement containing the facet items.
 */
function sortFacetHierarchy(ul) {
  var items = Array.from(ul.children);
  var itemsByLevel = new Map();
  var captionCache = new Map();
  var searchItem = null;
  items.forEach(function (item) {
    var _item$dataset$value$s, _item$dataset$value, _itemsByLevel$get;
    var caption = getCaption(item);
    if (caption === 'Search') {
      searchItem = item;
      return;
    }
    var level = ((_item$dataset$value$s = (_item$dataset$value = item.dataset.value) == null ? void 0 : _item$dataset$value.split('|').length) != null ? _item$dataset$value$s : 1) - 1;
    if (!itemsByLevel.has(level)) itemsByLevel.set(level, []);
    (_itemsByLevel$get = itemsByLevel.get(level)) == null || _itemsByLevel$get.push(item);
    captionCache.set(item, caption);
  });
  itemsByLevel.forEach(function (level) {
    return sortItems(level, captionCache);
  });
  var fragment = document.createDocumentFragment();
  var _reorderChildren = function reorderChildren(parentValue, level) {
    var levelItems = itemsByLevel.get(level);
    if (!levelItems) return;
    for (var _iterator = _createForOfIteratorHelperLoose(levelItems), _step; !(_step = _iterator()).done;) {
      var item = _step.value;
      var itemValue = item.dataset.value || '';
      if (itemValue.startsWith(parentValue)) {
        fragment.appendChild(item);
        _reorderChildren(itemValue, level + 1);
      }
    }
  };
  _reorderChildren('', 0);
  ul.textContent = '';
  ul.appendChild(fragment);
  if (searchItem) {
    ul.appendChild(searchItem);
    var element = searchItem.querySelector('.coveo-facet-value-caption');
    if (element) {
      element.addEventListener('click', setupSearchObserver);
    }
  }
}
var FACET_SEARCH_SELECTOR = '.coveo-facet-search-results';
var globalObserver = null;
/**
 * Sets up a global MutationObserver to monitor changes in the DOM.
 */
/* istanbul ignore next */
var setupSearchObserver = function setupSearchObserver() {
  if (globalObserver) {
    globalObserver.disconnect();
  }
  globalObserver = new MutationObserver(handleMutations);
  globalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
};
/**
 * Handles DOM mutations and sorts facet search results if necessary.
 *
 * This function iterates over a list of MutationRecord objects and checks if the mutation type is 'childList'.
 * If the mutation target is an HTMLElement and matches the FACET_SEARCH_SELECTOR or contains an element that matches,
 * it calls the sortFacetSearchResults function on the target element.
 *
 * @param mutations - An array of MutationRecord objects representing the mutations to be handled.
 */
/* istanbul ignore next */
var handleMutations = function handleMutations(mutations) {
  for (var _iterator2 = _createForOfIteratorHelperLoose(mutations), _step2; !(_step2 = _iterator2()).done;) {
    var mutation = _step2.value;
    if (mutation.type === 'childList') {
      var target = mutation.target;
      if (target instanceof HTMLElement) {
        var targetEl = target.matches(FACET_SEARCH_SELECTOR) ? target : target.querySelector(FACET_SEARCH_SELECTOR);
        if (targetEl instanceof HTMLUListElement) {
          sortFacetSearchResults(targetEl);
          break;
        }
      }
    }
  }
};
/**
 * Sorts the search results within a given unordered list (ul) element.
 * @param ul - The unordered list (ul) element containing the search results to be sorted.
 */
var sortFacetSearchResults = function sortFacetSearchResults(ul) {
  if (!(ul instanceof HTMLUListElement)) return;
  var items = Array.from(ul.children);
  if (items.length === 0) return;
  var captionCache = createCaptionCache(items);
  sortItems(items, captionCache);
  updateDOMWithSortedItems(ul, items);
};
/**
 * Creates a cache of captions for a list of HTML list items.
 *
 * @param items - An array of HTMLLIElement items for which captions need to be cached.
 * @returns A Map where each key is an HTMLLIElement and each value is the corresponding caption string.
 */
var createCaptionCache = function createCaptionCache(items) {
  var captionCache = new Map();
  items.forEach(function (item) {
    var caption = getCaption(item);
    captionCache.set(item, caption);
  });
  return captionCache;
};
/**
 * Updates the DOM by appending sorted items to a given unordered list element.
 * If a global observer is present, it disconnects before appending the items
 * and reconnects after the items have been appended.
 *
 * @param ul - The unordered list element to which the sorted items will be appended.
 * @param items - An array of list item elements to be appended to the unordered list.
 */
var updateDOMWithSortedItems = function updateDOMWithSortedItems(ul, items) {
  /* istanbul ignore next */
  if (globalObserver) {
    globalObserver.disconnect();
  }
  appendItemsToFragment(ul, items);
  /* istanbul ignore next */
  if (globalObserver) {
    globalObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    });
  }
};
/**
 * Appends a list of HTML list items to a given unordered list element.
 *
 * This function first creates a document fragment and appends all the provided
 * list items to this fragment. It then removes all existing children from the
 * unordered list element and appends the fragment to it, effectively replacing
 * the old list items with the new ones.
 *
 * @param ul - The unordered list (ul) element to which the items will be appended.
 * @param items - An array of list item (li) elements to be appended to the unordered list.
 */
var appendItemsToFragment = function appendItemsToFragment(ul, items) {
  var fragment = document.createDocumentFragment();
  items.forEach(function (item) {
    return fragment.appendChild(item);
  });
  while (ul.firstChild) ul.removeChild(ul.firstChild);
  ul.appendChild(fragment);
};

var getFacet = function getFacet(d, _ref) {
  var facetDataNumber = _ref.facetDataNumber,
    jwtTokenCookieKey = _ref.jwtTokenCookieKey;
  /** Don't display internal facet when user's not authenticated */
  if ((d == null ? void 0 : d.field) === '@tr_internalonly' && !getJwtToken(jwtTokenCookieKey)) {
    return null;
  }
  switch (d == null ? void 0 : d.type) {
    case FacetTypesEnum.COVEO_DYNAMIC_FACET:
      return React.createElement("div", {
        className: "CoveoDynamicFacet",
        "data-testid": "CoveoFacet-test",
        "data-title": d == null ? void 0 : d.title,
        "data-field": d == null ? void 0 : d.field,
        "data-tab": d == null ? void 0 : d.tab,
        "data-tab-not": d == null ? void 0 : d.excludeTab,
        "data-number-of-values": (d == null ? void 0 : d.valuesToDisplay) || facetDataNumber,
        "data-collapsed-by-default": (d == null ? void 0 : d.expandedByDefault) === 'true' || (d == null ? void 0 : d.expandedByDefault) === true ? 'false' : 'true',
        "data-enable-facet-search": d == null ? void 0 : d.enableFacetSearch,
        "data-sort-criteria": (d == null ? void 0 : d.sortCriteria) || '',
        "data-custom-sort-criteria": (d == null ? void 0 : d.customSortCriteria) || ''
      });
    case FacetTypesEnum.COVEO_HIERARCHICAL_FACET:
      return React.createElement("div", {
        className: "CoveoHierarchicalFacet",
        "data-testid": "CoveoFacet-test",
        "data-title": d == null ? void 0 : d.title,
        "data-field": d == null ? void 0 : d.field,
        "data-tab": d == null ? void 0 : d.tab,
        "data-tab-not": d == null ? void 0 : d.excludeTab,
        "data-number-of-values": (d == null ? void 0 : d.valuesToDisplay) || facetDataNumber,
        "data-enable-facet-search": d == null ? void 0 : d.enableFacetSearch,
        "data-custom-sort-criteria": (d == null ? void 0 : d.customSortCriteria) || ''
      });
    case FacetTypesEnum.COVEO_DYNAMIC_HIERARCHICAL_FACET:
      return React.createElement("div", {
        className: "CoveoDynamicHierarchicalFacet",
        "data-testid": "CoveoFacet-test",
        "data-title": d == null ? void 0 : d.title,
        "data-field": d == null ? void 0 : d.field,
        "data-tab": d == null ? void 0 : d.tab,
        "data-tab-not": d == null ? void 0 : d.excludeTab,
        "data-number-of-values": (d == null ? void 0 : d.valuesToDisplay) || facetDataNumber,
        "data-enable-facet-search": d == null ? void 0 : d.enableFacetSearch
      });
    case FacetTypesEnum.COVEO_DYNAMIC_FACET_RANGE:
      return React.createElement("div", {
        className: "CoveoDynamicFacetRange",
        "data-testid": "CoveoFacet-test",
        "data-title": d.title,
        "data-field": d.field,
        "data-tab": d == null ? void 0 : d.tab,
        "data-tab-not": d == null ? void 0 : d.excludeTab,
        "data-number-of-values": facetDataNumber,
        "data-collapsed-by-default": "true"
      });
    default:
      if (d != null && d.categoryFacet) {
        return React.createElement("div", {
          className: "CoveoHierarchicalFacet",
          "data-testid": "CoveoFacet-test",
          "data-title": d == null ? void 0 : d.title,
          "data-field": d == null ? void 0 : d.field,
          "data-tab": d == null ? void 0 : d.tab,
          "data-tab-not": d == null ? void 0 : d.excludeTab,
          "data-number-of-values": (d == null ? void 0 : d.valuesToDisplay) || facetDataNumber,
          "data-enable-facet-search": d == null ? void 0 : d.enableFacetSearch,
          "data-custom-sort-criteria": (d == null ? void 0 : d.customSortCriteria) || ''
        });
      } else {
        return React.createElement("div", {
          className: "CoveoDynamicFacet",
          "data-testid": "CoveoFacet-test",
          "data-title": d == null ? void 0 : d.title,
          "data-field": d == null ? void 0 : d.field,
          "data-tab": d == null ? void 0 : d.tab,
          "data-tab-not": d == null ? void 0 : d.excludeTab,
          "data-number-of-values": (d == null ? void 0 : d.valuesToDisplay) || facetDataNumber,
          "data-collapsed-by-default": (d == null ? void 0 : d.expandedByDefault) === 'true' || (d == null ? void 0 : d.expandedByDefault) === true ? 'false' : 'true',
          "data-enable-facet-search": d == null ? void 0 : d.enableFacetSearch,
          "data-sort-criteria": (d == null ? void 0 : d.sortCriteria) || '',
          "data-custom-sort-criteria": (d == null ? void 0 : d.customSortCriteria) || ''
        });
      }
  }
};
/**
 * Adds or removes CSS classes from an HTML element.
 *
 * @param element - The HTML element to modify.
 * @param addClasses - An array of CSS classes to add.
 * @param removeClasses - An array of CSS classes to remove.
 */
var addOrRemoveClasses = function addOrRemoveClasses(element, addClasses, removeClasses) {
  var classSet = new Set(Array.from(element.classList));
  removeClasses.forEach(function (cls) {
    return classSet["delete"](cls);
  });
  addClasses.forEach(function (cls) {
    return classSet.add(cls);
  });
  element.className = Array.from(classSet).join(' ');
};
/**
 * Opens the parent facet items in a hierarchical facet.
 */
var openParentFacetItem = function openParentFacetItem() {
  var hierarchicalFacets = document.querySelectorAll('.CoveoHierarchicalFacet.coveo-active');
  hierarchicalFacets.forEach(function (facet) {
    var parentFacets = facet.querySelectorAll('li.coveo-has-childs.coveo-has-childs-selected');
    var selectedFacets = facet.querySelectorAll('li.coveo-selected');
    parentFacets.forEach(function (parentFacet) {
      addOrRemoveClasses(parentFacet, ['coveo-open', 'coveo-active'], ['coveo-inactive']);
    });
    selectedFacets.forEach(function (selectedFacet) {
      if (!selectedFacet.classList.contains('coveo-open')) {
        addOrRemoveClasses(selectedFacet, ['coveo-active'], ['coveo-inactive']);
      }
    });
  });
};
var FacetPlain = function FacetPlain() {
  var _useSearchResultProps = useSearchResultProps(),
    jwtTokenCookieKey = _useSearchResultProps.jwtTokenCookieKey;
  var clearButton = useRef(null);
  var closeButton = useRef(null);
  var filterButton = useRef(null);
  var _useSearchResultProps2 = useSearchResultProps().facet,
    facetData = _useSearchResultProps2.facetData,
    _useSearchResultProps3 = _useSearchResultProps2.facetDataNumber,
    facetDataNumber = _useSearchResultProps3 === void 0 ? 1000 : _useSearchResultProps3,
    facetModalSize = _useSearchResultProps2.facetModalSize,
    facetSelected = _useSearchResultProps2.facetSelected;
  var hasQueryError = useSearchResultProps().hasQueryError;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.FACET_PLAIN);
  /**
   * Array to keep the facetContainerIds of the facets that contain a field name
   * that is known for dates, so they can be searched on
   * Coveo's deferredQuerySuccess event and their date field values can be sorted
   */
  var dateFacetContainerIds = useMemo(function () {
    var foundDateFacets = [];
    if (facetData) {
      facetData.forEach(function (facetDataItem) {
        if (DatefieldMap.has(facetDataItem == null ? void 0 : facetDataItem.field)) {
          var facetContainerId = "" + DatePrefixId + (facetDataItem == null ? void 0 : facetDataItem.field);
          foundDateFacets.push({
            dateFacetContainerId: facetContainerId,
            showFutureAndPastDateFacet: !!(facetDataItem != null && facetDataItem.showFutureAndPastDateFacet)
          });
        }
      });
    }
    return foundDateFacets;
  }, [facetData]);
  useEffect(function () {
    logger == null || logger.debug(SearchResultLogs.FACET_PLAIN_USE_EFFECT);
    clearButton.current = document.getElementsByClassName('coveo-breadcrumb-clear-all');
    closeButton.current = document.getElementsByClassName('coveo-facet-modal-close-button');
    filterButton.current = document.getElementsByClassName('coveo-filters-button');
  }, [logger]);
  var resetCoveo = function resetCoveo() {
    var _clearButton$current;
    clearButton == null || (_clearButton$current = clearButton.current) == null || (_clearButton$current = _clearButton$current[0]) == null || _clearButton$current.click();
  };
  var closeFacet = function closeFacet() {
    var _filterButton$current, _closeButton$current;
    filterButton == null || (_filterButton$current = filterButton.current) == null || (_filterButton$current = _filterButton$current[0]) == null || _filterButton$current.focus();
    closeButton == null || (_closeButton$current = closeButton.current) == null || (_closeButton$current = _closeButton$current[0]) == null || _closeButton$current.click();
  };
  var handleSkipLink = function handleSkipLink(e) {
    e.preventDefault();
    var CoveoResult = document.querySelector('.CoveoResult');
    if (CoveoResult) {
      CoveoResult.setAttribute('tabIndex', '-1');
      CoveoResult.focus();
    }
  };
  /**
   * Processes the facetData to identify non-date facets that need to be sorted alphanumerically.
   * It returns an array of facet container IDs that meet these criteria.
   * @returns {Array<string>} - An array of facet container IDs that are non-date and need to be sorted alphanumerically.
   */
  var tobeAlphabeticallyOrdered = useMemo(function () {
    var foundNonDateFacets = [];
    if (facetData) {
      facetData.forEach(function (facetDataItem) {
        if (!DatefieldMap.has(facetDataItem == null ? void 0 : facetDataItem.field) && (facetDataItem == null ? void 0 : facetDataItem.customSortCriteria) === 'alphanumeric') {
          var facetContainerId = "" + DatePrefixId + (facetDataItem == null ? void 0 : facetDataItem.field);
          foundNonDateFacets.push(facetContainerId);
        }
      });
    }
    return foundNonDateFacets;
  }, [facetData]);
  /**
   * Sort list elements in found Date Facets and display them in their sorted
   * position
   */
  useEffect(function () {
    var fieldValuesPositionHandler = function fieldValuesPositionHandler() {
      orderListElements(dateFacetContainerIds);
      orderFacetElementsAlphabetically(tobeAlphabeticallyOrdered);
    };
    $$(document.body).on(CoveoEventNames.DEFERRED_QUERY_SUCCESS, fieldValuesPositionHandler);
    //Clean up
    return function () {
      $$(document.body).off(CoveoEventNames.DEFERRED_QUERY_SUCCESS, fieldValuesPositionHandler);
    };
  }, [dateFacetContainerIds, tobeAlphabeticallyOrdered]);
  /**
   * Open parent facet item when child item is selected
   */
  useEffect(function () {
    var handleAfterInit = function handleAfterInit() {
      $$(document.body).on(CoveoEventNames.DEFERRED_QUERY_SUCCESS, openParentFacetItem);
    };
    $$(document.body).on('afterComponentsInitialization', handleAfterInit);
    return function () {
      $$(document.body).off(CoveoEventNames.DEFERRED_QUERY_SUCCESS, openParentFacetItem);
      $$(document.body).off('afterComponentsInitialization', handleAfterInit);
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "" + (facetModalSize === FacetModalSizeType.FULL_SCREEN ? 'coveo-facet-column coveo-facet-column-full-screen' : 'coveo-facet-column') + (hasQueryError ? ' coveo-facet-column--hidden' : ''),
    "data-testid": "CoveoFacetWrapper-test"
  }, React.createElement("div", {
    className: "coveo-facet-collapsible-header-wrapper"
  }, React.createElement("div", {
    className: "coveo-facet-filter-title"
  }, React.createElement("span", null, (facetSelected === 0 ? 'TRFilter' : 'TRFilters').toLocaleString()), React.createElement("span", {
    className: "notranslate",
    translate: "no"
  }, "(", facetSelected, ")")), React.createElement("button", {
    className: "coveo-facet-modal-close-button coveo-facet-close-button",
    type: "button",
    "aria-label": 'TRCloseDropdownFilters'.toLocaleString(),
    onClick: closeFacet
  }, 'Close'.toLocaleString(), " X"), React.createElement("a", {
    className: "coveo-search-result-skip-link",
    href: "#searchResultContent",
    onClick: handleSkipLink,
    onKeyPressCapture: handleSkipLink
  }, "Skip to search results")), React.createElement("div", {
    className: "coveo-facet-label-header"
  }, React.createElement("span", null, "Select filters to narrow results. ", React.createElement("br", null), "Filters are applied when selected.")), React.createElement("div", {
    className: "coveo-facet-list-wrapper"
  }, facetData ? facetData.map(function (d, i) {
    var facetContainerId = "" + DatePrefixId + (d == null ? void 0 : d.field);
    return React.createElement("div", {
      id: facetContainerId,
      key: d.field + i
    }, getFacet(d, {
      facetDataNumber: facetDataNumber,
      jwtTokenCookieKey: jwtTokenCookieKey
    }));
  }) : null), React.createElement("div", {
    className: "coveo-facet-button-wrapper"
  }, React.createElement("button", {
    onClick: closeFacet,
    className: "coveo-facet-apply-btn",
    "aria-label": "Apply filters button"
  }, 'TRCoveoApply'.toLocaleString()), React.createElement("button", {
    className: "coveo-facet-clear-btn",
    onClick: resetCoveo,
    "aria-label": "Clear filters button"
  }, 'TRCoveoClearAll'.toLocaleString()))));
};

var FacetDefault = function FacetDefault() {
  var _useSearchResultProps = useSearchResultProps().facet,
    facetData = _useSearchResultProps.facetData,
    facetDataNumber = _useSearchResultProps.facetDataNumber;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.FACET_DEFAULT);
  /**
   * Array to keep the facetContainerIds of the facets that contain a field name
   * that is known for dates, so they can be searched on
   * Coveo's deferredQuerySuccess event and their date field values can be sorted
   */
  var dateFacetContainerIds = useMemo(function () {
    var foundDateFacets = [];
    if (facetData) {
      facetData.forEach(function (facetDataItem) {
        if (DatefieldMap.has(facetDataItem == null ? void 0 : facetDataItem.field)) {
          var facetContainerId = "" + DatePrefixId + (facetDataItem == null ? void 0 : facetDataItem.field);
          var showFutureAndPastDateFacet = !!(facetDataItem != null && facetDataItem.showFutureAndPastDateFacet);
          foundDateFacets.push({
            dateFacetContainerId: facetContainerId,
            showFutureAndPastDateFacet: showFutureAndPastDateFacet
          });
        }
      });
    }
    return foundDateFacets;
  }, [facetData]);
  /**
   * Sort list elements in found Date Facets and display them in their sorted
   * position
   */
  useEffect(function () {
    var fieldValuesPositionHandler = function fieldValuesPositionHandler() {
      return orderListElements(dateFacetContainerIds);
    };
    $$(document.body).on(CoveoEventNames.DEFERRED_QUERY_SUCCESS, fieldValuesPositionHandler);
    //Clean up
    return function () {
      $$(document.body).off(CoveoEventNames.DEFERRED_QUERY_SUCCESS, fieldValuesPositionHandler);
    };
  }, [dateFacetContainerIds]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-facet-column",
    "data-testid": "CoveoFacetWrapper-test"
  }, facetData ? facetData.map(function (d) {
    var facetContainerId = "" + DatePrefixId + (d == null ? void 0 : d.field);
    return React.createElement("div", {
      id: facetContainerId,
      key: d.field,
      className: "CoveoFacet",
      "data-testid": "CoveoFacet-test",
      "data-title": d.title,
      "data-field": d.field,
      "data-tab": "All",
      "data-number-of-values": (d == null ? void 0 : d.valuesToDisplay) || facetDataNumber,
      "data-enable-facet-search": d == null ? void 0 : d.enableFacetSearch,
      "data-sort-criteria": (d == null ? void 0 : d.sortCriteria) || ''
    });
  }) : null));
};

var css_248z$4 = ".CoveoCategoryFacet,\n.CoveoDynamicFacet,\n.CoveoFacetRange,\n.CoveoFacetSlider,\n.CoveoHierarchicalFacet,\n.CoveoTimespanFacet,\n.CoveoDynamicHierarchicalFacet {\n  background-color: transparent !important;\n}\n/* stylelint-disable */\n.coveo-dynamic-facet-values {\n  padding: unset !important;\n  scroll-margin: 0.625rem;\n}\n\n.coveo-dynamic-facet-values li:first-child {\n  margin-top: 0.938rem;\n}\n\n.coveo-dynamic-facet-header {\n  height: unset;\n}\n\n.coveo-dynamic-facet-header-title {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n  padding: 0.906rem 0.906rem 0.906rem 0;\n  line-height: unset;\n  text-transform: none;\n}\n\n.coveo-checkbox-span-label,\n.coveo-checkbox-span-label-suffix {\n  color: var(--tr-coveo-color-tr-gray-dark) !important;\n  font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.coveo-checkbox-label:hover .coveo-checkbox-span-label {\n  opacity: 1 !important;\n}\n\n.coveo-dynamic-facet-value.coveo-selected .coveo-checkbox-span-label,\n.coveo-dynamic-facet-value.coveo-selected .coveo-checkbox-span-label-suffix {\n  font-weight: normal;\n}\n\n.coveo-checkbox-button {\n  box-sizing: content-box;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 17px !important;\n  height: 17px !important;\n  min-width: unset !important;\n  transition: unset !important;\n  border: 1px solid var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-checkbox-button,\ninput[type='checkbox'].coveo-checkbox + button {\n  min-width: 17px !important;\n}\n\n.coveo-dynamic-facet-value.coveo-selected .coveo-checkbox-button {\n  background-color: var(--tr-coveo-color-tr-orange) !important;\n}\n\n.coveo-dynamic-facet-value .coveo-checkbox-label:hover .coveo-checkbox-button {\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-dynamic-facet-value .coveo-checkbox-label:active .coveo-checkbox-button {\n  border: var(--tr-coveo-facet-border-xl) solid var(--tr-coveo-color-tr-orange) !important;\n}\n\n.coveo-dynamic-facet-value.coveo-selected:active .coveo-checkbox-button {\n  background-color: var(--tr-coveo-color-tr-orange-dark-shade-20) !important;\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-checkbox-button::before {\n  position: unset !important;\n  border: solid var(--tr-coveo-color-tr-white) !important;\n  border-width: 0 2px 2px 0 !important;\n  margin-bottom: 2px;\n}\n\n.coveo-dynamic-facet-header-btn svg {\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-facet-clear-btn {\n  background-color: inherit;\n  border: none;\n  color: var(--tr-coveo-color-tr-blue-dark);\n  cursor: pointer;\n  font-size: var(--tr-coveo-font-size-xxs);\n  text-align: right;\n  text-decoration: underline;\n}\n\n.coveo-facet-apply-btn {\n  background-color: var(--tr-coveo-color-tr-orange) !important;\n  border: none;\n  border-radius: 1.563rem;\n  color: var(--tr-coveo-color-tr-white);\n  font-size: var(--tr-coveo-font-size-xxs);\n  height: 2.438rem;\n  width: 6.313rem;\n}\n\n.coveo-facet-button-wrapper {\n  align-items: center;\n  background-color: var(--tr-coveo-color-tr-white);\n  border-top: 0.063rem solid var(--tr-coveo-color-medium-grey);\n  display: none;\n  height: 6.875rem;\n  justify-content: space-between;\n  padding: var(--tr-coveo-facet-padding);\n  position: sticky;\n  bottom: 0;\n}\n\n.coveo-facet-collapsible-header-wrapper {\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: var(--tr-coveo-font-size-m);\n  padding-top: var(--tr-coveo-facet-padding-size-md);\n  position: relative;\n}\n\n.coveo-facet-collapsible-header-wrapper h2 {\n  color: var(--color-grey);\n  margin: var(--padding-none);\n  padding: var(--padding-none);\n}\n\n.coveo-facet-collapsible-header-wrapper button {\n  background-color: inherit;\n  border: none;\n  color: var(--tr-coveo-color-tr-gray-dark);\n  cursor: pointer;\n  display: none;\n  font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.coveo-facet-collapsible-header-wrapper strong {\n  display: flex;\n  align-items: center;\n  gap: 0.3em;\n}\n.coveo-facet-collapsible-header-wrapper span {\n  font-size: 1.5rem;\n}\n\n.coveo-dropdown-content {\n  background-color: var(--tr-coveo-color-tr-white);\n  border-radius: 0.313rem !important;\n  height: 100% !important;\n  left: auto !important;\n  right: 0 !important;\n  top: 0 !important;\n  z-index: var(--tr-coveo-facet-z-index-x) !important;\n}\n\n.coveo-facet-column-full-screen.coveo-facet-dropdown-content {\n  height: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  width: 100% !important;\n}\n\n.coveo-facet-disabled .coveo-dropdown-header-wrapper {\n  display: none;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-header {\n  border-top: none !important;\n}\n\n.CoveoHierarchicalFacet .coveo-has-childs-toggle svg {\n  fill: var(--tr-coveo-color-tr-gray-dark) !important;\n  height: var(--tr-coveo-facet-with-size-s) !important;\n  width: var(--tr-coveo-facet-with-size-s) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-has-childs-toggle g {\n  fill: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.CoveoHierarchicalFacet .coveo-line-svg {\n  display: none;\n}\n\n.CoveoHierarchicalFacet\n  ul.coveo-facet-values\n  .coveo-facet-value.coveo-has-childs\n  .coveo-has-childs-toggle {\n  left: -3px;\n  top: 5px;\n}\n\n.CoveoHierarchicalFacet {\n  border: none;\n  margin: var(--tr-coveo-0);\n}\n\n.CoveoHierarchicalFacet .coveo-facet-footer {\n  background-color: inherit;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-header-title {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n  font-weight: var(--tr-coveo-font-weight-bold);\n  padding: 0.906rem 0.906rem 0.906rem 0;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-header {\n  padding: var(--tr-coveo-0);\n  background: inherit;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-header-settings {\n  display: none;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-checkbox {\n  width: 17px;\n  height: 17px;\n  border: 1px solid var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-active-shape-svg {\n  display: none;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-caption,\n.CoveoHierarchicalFacet .coveo-facet-value-count {\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-count::before {\n  content: '(';\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-count::after {\n  content: ')';\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-caption {\n  flex-grow: 0;\n  max-width: 8.125rem;\n  white-space: normal !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value:hover .coveo-facet-value-checkbox {\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value:active .coveo-facet-value-checkbox {\n  border: var(--tr-coveo-facet-border-xl) solid var(--tr-coveo-color-tr-orange) !important;\n}\n\n.CoveoHierarchicalFacet\n  .coveo-facet-value.coveo-selected:active\n  .coveo-facet-value-checkbox {\n  background-color: var(--tr-coveo-color-tr-orange-dark-shade-20) !important;\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value.coveo-selected {\n  font-weight: inherit !important;\n}\n\n.CoveoHierarchicalFacet .coveo-selected .coveo-facet-value-checkbox {\n  background-color: var(--tr-coveo-color-tr-orange) !important;\n}\n\n.coveo-facet-filter-title span {\n  font-weight: var(--tr-coveo-font-weight-bold);\n  margin-right: var(--tr-coveo-facet-padding-size-xs);\n}\n\n.coveo-new-branding {\n  font-family: var(--tr-coveo-font-family-source-sans-3);\n}\n\n.coveo-new-branding .coveo-selected .coveo-facet-value-checkbox {\n  background-color: var(--tr-coveo-color-tr-orange-400) !important;\n}\n\n.coveo-new-branding .coveo-facet-header-title,\n.coveo-new-branding .coveo-facet-value-label {\n  font-family: var(--tr-coveo-font-family-S3);\n}\n\n.coveo-new-branding .coveo-facet-filter-title span {\n  font-family: var(--tr-coveo-font-family-clario);\n  font-size: 1.75rem;\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value:hover .coveo-facet-value-checkbox {\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value:active .coveo-facet-value-checkbox {\n  border: var(--tr-coveo-facet-border-xl) solid var(--tr-coveo-color-tr-orange) !important;\n}\n\n.CoveoHierarchicalFacet\n  .coveo-facet-value.coveo-selected:active\n  .coveo-facet-value-checkbox {\n  background-color: var(--tr-coveo-color-tr-orange-dark-shade-20) !important;\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-selected .coveo-hook-svg {\n  fill: var(--tr-coveo-color-tr-white) !important;\n}\n\n.CoveoHierarchicalFacet .coveo-checkbox-button::before {\n  position: unset !important;\n  border: solid var(--tr-coveo-color-tr-white) !important;\n  border-width: 0 2px 2px 0 !important;\n  margin-bottom: 2px;\n}\n\n.CoveoHierarchicalFacet\n  .coveo-facet-values\n  .coveo-no-state\n  .coveo-facet-value-checkbox-svg,\n.CoveoHierarchicalFacet\n  .coveo-facet-value-checkbox[aria-pressed='false']\n  .coveo-facet-value-checkbox-svg {\n  display: none;\n}\n\n.coveo-selected .coveo-facet-value-checkbox-svg {\n  display: inline !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value:hover {\n  background-color: unset !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-header-title-section {\n  border-bottom: thin solid rgb(188, 195, 202);\n}\n\n.coveo-dynamic-facet-value.coveo-focused {\n  background-color: rgb(230, 236, 240);\n}\n\n.coveo-dynamic-facet-value.coveo-focused .coveo-checkbox-button:after {\n  content: unset;\n}\n\n.coveo-dynamic-facet-value.coveo-focused .coveo-checkbox-span-label {\n  opacity: 1;\n  font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.coveo-dynamic-hierarchical-facet-value-label,\n.coveo-dynamic-facet-value .coveo-checkbox-span-label {\n  white-space: normal !important;\n}\n\n.CoveoHierarchicalFacet .coveo-focused .coveo-facet-value-checkbox {\n  outline: none;\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.CoveoDynamicFacet .coveo-focused .coveo-checkbox-button {\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-facet-header-wait-animation {\n  display: none;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-exclude .coveo-hook-svg {\n  display: none !important;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-exclude {\n  width: 18px;\n  height: 18px;\n}\n\n.CoveoHierarchicalFacet\n  .coveo-facet-value-exclude\n  .coveo-facet-value-exclude-svg,\n.CoveoHierarchicalFacet\n  .coveo-facet-value-exclude\n  .coveo-facet-value-unexclude-svg {\n  width: 12px;\n  height: 12px;\n  top: 1px;\n  left: 1px;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-value-exclude {\n  outline: none;\n  border: var(--tr-coveo-facet-border-xl) solid\n    var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-facet-header-settings-section {\n  align-self: center;\n}\n\n.CoveoHierarchicalFacet .coveo-facet-header-eraser {\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-dynamic-hierarchical-facet-value-arrow-right svg,\n.coveo-dynamic-hierarchical-facet-value-arrow-left svg {\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-facet-more,\n.coveo-facet-less {\n  height: auto;\n  padding: 15px 0;\n  background: none;\n  cursor: default;\n}\n\n.coveo-facet-less {\n  border-bottom: 1px solid rgba(151, 151, 151, 0.3);\n}\n\n.coveo-facet-more:focus,\n.coveo-facet-less:focus,\n.coveo-facet-more:hover,\n.coveo-facet-less:hover {\n  background: none;\n}\n\n.coveo-facet-less-icon,\n.coveo-facet-more-icon {\n  width: 40px;\n  height: 40px;\n  display: grid;\n  margin: 0 auto;\n  cursor: pointer;\n  border-radius: 50%;\n  place-content: center;\n}\n\n.coveo-facet-footer {\n  width: calc(100% - 25px);\n}\n\n.coveo-facet-less-icon:hover,\n.coveo-facet-more-icon:hover {\n  background: #d0d0d0;\n}\n\n.coveo-facet-more-icon-svg,\n.coveo-facet-less-icon-svg {\n  height: 8px;\n  width: 21.67px;\n  color: rgb(64, 64, 64);\n}\n\n.CoveoDynamicFacetRange {\n  background: inherit;\n}\n.CoveoDynamicHierarchicalFacet.coveo-dynamic-hierarchical-facet-collapsed\n  .coveo-dynamic-hierarchical-facet-values {\n  padding: 0;\n}\n\ndiv.coveo-facet-dropdown-modal-content {\n  width: 17.5rem !important;\n  padding: 0 !important;\n}\n\n.coveo-facet-modal-close-button {\n  display: none !important;\n}\n\n.coveo-facet-label-header {\n  margin: var(--tr-coveo-facet-margin);\n  padding-bottom: 0.75rem;\n  display: none;\n}\n\n.coveo-facet-label-header span {\n  font-family: var(--tr-coveo-font-family-S3);\n  font-size: var(--tr-coveo-font-size-xxxs);\n  font-style: normal;\n  font-weight: var(--tr-coveo-font-weight-regular);\n  line-height: 150%;\n  color: var(--color-tr-gray-medium);\n}\n\n.CoveoSearchInterface.coveo-small-facets\n  .coveo-facet-column.coveo-facet-dropdown-modal-content\n  .coveo-facet-modal-close-button {\n  background-color: inherit !important;\n  color: var(--tr-coveo-color-tr-blue-dark) !important;\n  display: block;\n  width: unset !important;\n  height: unset !important;\n  border-radius: unset !important;\n  margin-bottom: 0 !important;\n}\n\n.CoveoSearchInterface.coveo-small-facets\n  .coveo-facet-column.coveo-facet-dropdown-modal-content\n  .coveo-facet-modal-close-button:focus {\n  opacity: 1 !important;\n}\n\n.coveo-facet-column.coveo-facet-dropdown-modal-content.coveo-dropdown-content {\n  box-shadow: 0 7px 15px rgb(0 0 0 / 25%) !important;\n}\n\n@media only screen and (max-width: 832px) {\n  .CoveoHierarchicalFacet {\n    margin: var(--tr-coveo-facet-margin) !important;\n  }\n\n  .CoveoSearchInterface.coveo-small-facets\n    .coveo-facet-column.coveo-facet-dropdown-content {\n    width: 330px;\n  }\n\n  .coveo-facet-column {\n    background-color: var(--tr-coveo-color-tr-white);\n    border-radius: 0.313rem !important;\n    height: 100% !important;\n    position: fixed !important;\n    top: 0 !important;\n    transition: all 0.4s ease-in-out;\n    z-index: var(--tr-coveo-facet-z-index-x) !important;\n  }\n\n  .coveo-facet-column.coveo-facet-dropdown-content {\n    right: 0 !important;\n  }\n\n  .CoveoDynamicFacet,\n  .CoveoDynamicHierarchicalFacet,\n  .CoveoDynamicFacetRange {\n    margin: var(--tr-coveo-facet-margin) !important;\n  }\n\n  .coveo-dynamic-facet-header,\n  .coveo-facet-collapsible-header-wrapper h2 {\n    padding: 0 !important;\n  }\n\n  .coveo-facet-collapsible-header-wrapper {\n    margin: var(--tr-coveo-facet-margin);\n    margin-top: 34px;\n    padding-bottom: var(--tr-coveo-facet-padding-size-md);\n  }\n\n  .coveo-facet-column h3 {\n    padding-left: 0.375rem;\n  }\n\n  .coveo-facet-button-wrapper {\n    display: flex;\n    margin-top: 0;\n  }\n\n  .coveo-facet-list-wrapper {\n    flex: 1;\n    height: auto;\n    overflow: scroll;\n  }\n\n  .coveo-facet-list-wrapper:focus-within {\n    border: none;\n  }\n  .coveo-facet-collapsible-header-wrapper button {\n    color: var(--tr-coveo-color-tr-blue-dark);\n    display: block !important;\n  }\n\n  .coveo-search-result-skip-link {\n    display: none;\n  }\n\n  .coveo-facet-label-header {\n    display: block;\n  }\n}\n\n.coveo-search-result-skip-link {\n  position: absolute;\n  opacity: 0;\n  top: 10px;\n  right: 0;\n  padding: 0 5px;\n  z-index: -1;\n}\n\n.coveo-search-result-skip-link:focus {\n  opacity: 1;\n  z-index: 1;\n  background: white;\n}\n\n@media only screen and (max-width: 500px) {\n  .coveo-facet-column.coveo-facet-dropdown-modal-content {\n    width: 100% !important;\n    height: 100% !important;\n    max-height: 100%;\n  }\n\n  .coveo-facet-button-wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.CoveoSearchInterface.coveo-small-facets\n  .coveo-facet-column.coveo-facet-dropdown-content {\n  max-height: 100%;\n}\n\n.coveo-facet-column--hidden {\n  display: none !important;\n}\n\n@media (max-height: 500px) and (max-width: 500px) {\n  .coveo-facet-button-wrapper {\n    position: static;\n  }\n\n  .coveo-facet-list-wrapper {\n    height: auto;\n    overflow: visible;\n  }\n\n  .coveo-facet-list-wrapper:focus-within {\n    border: none;\n  }\n}\n";
styleInject(css_248z$4);

var Facet = function Facet() {
  var facetPalette = useSearchResultProps().facet.facetPalette;
  React.useEffect(function () {
    $$(document.body).on(CoveoEventNames.DEFERRED_QUERY_SUCCESS, correctFacetAccessibilityAttributes);
    return function () {
      $$(document.body).off(CoveoEventNames.DEFERRED_QUERY_SUCCESS, correctFacetAccessibilityAttributes);
    };
  }, []);
  return React.createElement(React.Fragment, null, facetPalette === FacetStyleType.PLAIN && React.createElement(FacetPlain, null), facetPalette === FacetStyleType.DEFAULT && React.createElement(FacetDefault, null));
};

var css_248z$5 = ".CoveoPager,\n.coveo-pager-modified .CoveoPager {\n  display: flex;\n  justify-content: center;\n  padding-top: 1.5rem;\n}\n\n.coveo-pager-list-item.coveo-active,\n.coveo-pager-list-item:hover {\n  background-color: transparent;\n  color: var(--color-tr-gray-dark);\n  text-decoration: var(--text-decoration);\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-previous-icon::after {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  content: attr(data-after-content);\n  padding-left: 0.375rem;\n  text-decoration: var(--tr-coveo-text-decoration-none);\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-next-icon::before {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  content: attr(data-before-content);\n  padding-right: 0.375rem;\n  text-decoration: var(--tr-coveo-text-decoration-none);\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-list-item {\n  border: none;\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  height: 1.625rem;\n  padding: var(--tr-coveo-pager-padding-item);\n  text-align: center;\n  width: 1.625rem;\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-previous-icon-svg,\n.coveo-pager-modified .CoveoPager .coveo-pager-next-icon-svg {\n  background-color: transparent;\n  border: 0.125rem solid rgb(250, 100, 0);\n  border-radius: 6.1875rem;\n  color: var(--tr-coveo-color-tr-gray-dark);\n  height: 1.625rem;\n  margin-bottom: 0.125rem;\n  padding-bottom: 0.375rem;\n  padding-top: 0.375rem;\n  text-align: center;\n  width: 1.625rem;\n}\n\n.coveo-new-branding .coveo-pager-modified .coveo-pager-previous-icon-svg,\n.coveo-new-branding .coveo-pager-modified .coveo-pager-next-icon-svg {\n  border: 0.125rem solid var(--tr-coveo-color-tr-orange-400);\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-list-item span {\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-list-item:hover span {\n  text-decoration: none;\n}\n\n.coveo-pager-modified .CoveoPager .coveo-active .coveo-pager-anchor {\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-new-branding .coveo-pager-modified .coveo-active .coveo-pager-anchor {\n  color: var(--tr-coveo-color-tr-black);\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-next,\n.coveo-pager-modified .CoveoPager .coveo-pager-previous {\n  background-color: transparent !important;\n  color: var(--color-tr-gray-dark) !important;\n  width: auto;\n}\n\n.coveo-pager-modified .CoveoPager .coveo-active:hover {\n  border-bottom: 0.125rem solid var(--tr-coveo-color-tr-orange) !important;\n  border-radius: unset !important;\n}\n\n.coveo-new-branding .coveo-pager-list-item-text {\n  font-weight: var(--tr-coveo-font-weight-bold) !important;\n}\n\n.coveo-pager-modified .CoveoPager .coveo-active:hover .coveo-pager-list-item-text {\n  color: var(--color-tr-gray-dark) !important;\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-list .coveo-active {\n  border-bottom: 0.125rem solid var(--tr-coveo-color-tr-orange);\n}\n\n.coveo-new-branding .coveo-pager-modified .coveo-pager-list .coveo-active {\n  border-bottom: 0.125rem solid var(--tr-coveo-color-tr-orange-400);\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-list .coveo-pager-list-item:hover {\n  background-color: transparent;\n}\n\n.coveo-pager-modified .CoveoPager .coveo-pager-list .coveo-pager-list-item:hover .coveo-pager-list-item-text {\n  color: var(--tr-coveo-color-tr-gray);\n  text-decoration: var(--text-decoration);\n}\n\n@media only screen and (max-width: 768px) {\n  .coveo-pager-list-item:not(.coveo-pager-next):nth-child(+n+5) {\n    display: inline-block !important;\n  }\n}\n\n@media only screen and (max-width: 380px) {\n  .coveo-pager-list-item:not(.coveo-pager-next):nth-child(2) {\n    display: inline-block !important;\n  }\n\n  .coveo-pager-modified .CoveoPager .coveo-pager-previous-icon::after,\n  .coveo-pager-modified .CoveoPager .coveo-pager-next-icon::before {\n    content: none !important;\n  }\n\n  .CoveoResultsPerPage,\n  .CoveoPager {\n    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n    margin: 0 !important;\n  }\n}\n";
styleInject(css_248z$5);

var Pager = function Pager(props) {
  var _useSearchResultProps;
  var isIPX = props.isIPX,
    pagerEnable = props.pagerEnable,
    _props$pagerNumberOfP = props.pagerNumberOfPages,
    pagerNumberOfPages = _props$pagerNumberOfP === void 0 ? 5 : _props$pagerNumberOfP,
    _props$pagerMobileNum = props.pagerMobileNumberOfPages,
    pagerMobileNumberOfPages = _props$pagerMobileNum === void 0 ? 3 : _props$pagerMobileNum,
    pagerMaxNumberOfPages = props.pagerMaxNumberOfPages,
    pagerStyle = props.pagerStyle;
  var logger = (_useSearchResultProps = useSearchResultProps()) == null ? void 0 : _useSearchResultProps.logger;
  logger == null || logger.debug(SearchResultLogs.PAGER);
  return React.createElement("div", {
    className: pagerStyle === PagerStyleType.DEFAULT ? '' : 'coveo-pager-modified',
    style: {
      display: pagerEnable ? 'block' : 'none'
    }
  }, React.createElement("div", {
    className: "CoveoPager",
    "data-number-of-pages": isMobile || isIPX ? pagerMobileNumberOfPages : pagerNumberOfPages,
    "data-max-number-of-pages": pagerMaxNumberOfPages
  }));
};

var TabSection = function TabSection(props) {
  var defaultLayout = props.defaultLayout,
    tabEnable = props.tabEnable,
    tabValue = props.tabValue,
    tabId = props.tabId,
    enableArrayTabValue = props.enableArrayTabValue,
    arrayTabValue = props.arrayTabValue,
    showTabs = props.showTabs,
    _props$shouldKeepTabB = props.shouldKeepTabBarVisibleOnEmptyResults,
    shouldKeepTabBarVisibleOnEmptyResults = _props$shouldKeepTabB === void 0 ? false : _props$shouldKeepTabB;
  var _useCoveoSearchAndNet = useCoveoSearchAndNetworkStatus(),
    noResults = _useCoveoSearchAndNet.noResults,
    isOffline = _useCoveoSearchAndNet.isOffline;
  var shouldShowTabs = showTabs && !isOffline && (shouldKeepTabBarVisibleOnEmptyResults || !noResults);
  var styleOfTabs = shouldShowTabs ? 'coveo-tab-section' : 'coveo-tr-searchtab-hide';
  var tabOptions = arrayTabValue == null ? void 0 : arrayTabValue.map(function (tab) {
    var _tab$tabId, _tab$tabId2;
    return React.createElement("div", {
      className: "CoveoTab coveo-tr-searchtab",
      "data-id": (_tab$tabId = tab.tabId) != null ? _tab$tabId : createDefaultTabId(tab.value),
      "data-caption": (_tab$tabId2 = tab.tabId) != null ? _tab$tabId2 : createDefaultTabId(tab.value),
      key: tab.tabId,
      "data-layout": defaultLayout,
      "data-expression": tab.value
    });
  });
  var singleTab = React.createElement("div", {
    className: "CoveoTab coveo-tr-searchtab",
    "data-id": tabId != null ? tabId : createDefaultTabId(tabValue),
    "data-caption": tabId != null ? tabId : createDefaultTabId(tabValue),
    "data-layout": defaultLayout,
    "data-expression": tabValue
  });
  var showCoveoTabCondition = tabEnable && (!!(enableArrayTabValue && arrayTabValue != null && arrayTabValue.length) || !!(tabValue != null && tabValue.length));
  return React.createElement(React.Fragment, null, showCoveoTabCondition && React.createElement("div", {
    className: styleOfTabs
  }, enableArrayTabValue ? tabOptions : singleTab));
};

var css_248z$6 = ".coveo-result-list-pi-template + .coveo-result-list-container .coveo-list-layout.CoveoResult {\n  background-color: var(--tr-coveo-color-tr-white);\n  border: none;\n  border-radius: 8px;\n  box-shadow: var(--tr-coveo-search-result-pi-box-shadow) rgba(0, 0, 0, 0.08);\n  cursor: default !important;\n  margin: var(--tr-coveo-facet-padding-size-md);\n  padding: var(--tr-coveo-search-result-pi-template-padding);\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.coveo-new-branding .coveo-result-list-pi-template + .coveo-result-list-container .coveo-list-layout.CoveoResult {\n  border: 1px solid var(--tr-help-and-support-meta-tags-color);\n  font-family: var(--tr-coveo-font-family-S3);\n}\n\n.coveo-result-list-pi-template + .coveo-result-list-container .coveo-list-layout.CoveoResult:hover {\n  box-shadow: var(--tr-coveo-search-result-pi-box-shadow-hover) rgba(0, 70, 123, 0.62);\n}\n\n.coveo-pi-button {\n  background: rgba(250, 100, 0, 1);\n  border-radius: 100px;\n  color: var(--tr-coveo-color-tr-white) !important;\n  display: block;\n  font-size: var(--tr-coveo-search-result-pi-button-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  margin-top: var(--tr-coveo-search-result-pi-button-margin-top);\n  padding: var(--tr-coveo-search-result-pi-list-button-padding);\n  text-align: center;\n}\n\n.coveo-new-branding .coveo-pi-button {\n  background: transparent;\n  border-radius: var(--tr-coveo-0);\n  display: block;\n  font-weight: var(--tr-coveo-font-weight-medium);\n  margin-top: var(--tr-coveo-search-result-pi-button-margin-top);\n  padding: var(--tr-coveo-0);\n  text-align: left;\n}\n\n.coveo-result-list-pi-template + .coveo-result-list-container .coveo-list-layout.CoveoResult:hover .coveo-pi-button {\n  background: rgba(220, 67, 0, 1);\n}\n\n.coveo-new-branding .coveo-result-list-pi-template + .coveo-result-list-container .coveo-list-layout.CoveoResult:hover .coveo-pi-button {\n  background: transparent;\n}\n\n.coveo-card-pi-button__title {\n  display: inline-block;\n  height: 24px;\n  line-height: var(--tr-coveo-search-result-pi-button-line-height);\n}\n\n.coveo-pi-button__title {\n  color: rgb(255, 255, 255);\n  font-size: var(--tr-coveo-search-result-pi-button-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.coveo-new-branding .coveo-pi-button__title {\n  color: var(--tr-coveo-color-tr-blue-dark);\n  font-size: var(--tr-coveo-search-result-pi-short-description-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  text-decoration: underline !important;\n}\n\n.coveo-result-list-pi-template + .coveo-result-list-container .coveo-list-layout.CoveoResult:hover .coveo-pi-button__title {\n  text-decoration: underline;\n}\n\n.coveo-pi-title {\n  color: rgba(64, 64, 64, 1);\n  font-size: var(--tr-coveo-search-result-pi-font-size-title) !important;\n  font-weight: var(--tr-coveo-font-weight-regular);\n  line-height: var(--tr-coveo-normal);\n}\n\n.coveo-pi-short-description {\n  font-size: var(--tr-coveo-search-result-pi-short-description-font-size) !important;\n  font-weight: var(--tr-coveo-font-weight-regular);\n  margin-bottom: var(--tr-coveo-result-list-description-gap);\n}\n\n.coveo-pi-line {\n  background-color: rgba(222, 222, 222, 1);\n  height: 1px;\n  margin: var(--tr-coveo-search-result-pi-list-line-margin);\n}\n\n.coveo-result-pi .coveo-result-cell {\n  display: block;\n  flex: 1 1 auto;\n}\n\n.coveo-pi-short-description,\n.coveo-result-pi-subcategories {\n  color: rgba(102, 102, 102, 1);\n}\n\n.coveo-result-pi-subcategories {\n  column-gap: 6px;\n  display: grid !important;\n  grid-template-columns: auto 1fr;\n}\n\n.coveo-result-pi-works-container {\n  margin-bottom: var(--tr-coveo-result-list-description-gap);\n  margin-top: var(--tr-coveo-result-list-description-gap);\n}\n\n.coveo-result-pi-subcategory-label {\n  font-size: var(--tr-coveo-search-result-pi-subcategories-font-size);\n  font-weight: var(--tr-coveo-font-weight-bold);\n}\n\n.coveo-result-list-pi-badge {\n  border-radius: var(--tr-coveo-search-result-pi-badge-border-radius);\n  display: grid;\n  font-size: var(--tr-coveo-search-result-pi-badge-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  height: 30px;\n  justify-content: center;\n  letter-spacing: 0.5px;\n  padding: var(--tr-coveo-search-result-pi-badge-padding);\n  place-content: center;\n  position: absolute;\n  right: 24px;\n  top: 0;\n}\n\n.coveo-result-pi-row {\n  margin-bottom: 0.375rem !important;\n}\n\n.coveo-tr-font-size-0 {\n  font-size: var(--tr-coveo-font-size-xxxs);\n}\n\n.coveo-result-list-pi-badge.coveo-pi-sale-badge {\n  background-color: rgba(243, 248, 232, 1);\n  color: rgba(56, 124, 43, 1);\n}\n\n.coveo-result-list-pi-badge.coveo-pi-new-product-badge {\n  background-color: rgba(238, 231, 246, 1);\n  color: rgba(58, 26, 146, 1);\n}\n";
styleInject(css_248z$6);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListPI = function ResultListPI() {
  var _useSearchResultProps = useSearchResultProps(),
    canonicalcta = _useSearchResultProps.canonicalcta;
  var _useSearchResultProps2 = useSearchResultProps().resultList.resultListConfig,
    resultListConfig = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2;
  var badgePI = resultListConfig.badgePI,
    shortDescriptionPI = resultListConfig.shortDescriptionPI,
    excerpt = resultListConfig.excerpt,
    helpsYouWith = resultListConfig.helpsYouWith,
    popUrlPI = resultListConfig.popUrlPI,
    worksWith = resultListConfig.worksWith,
    worksWithsPublisher = resultListConfig.worksWithsPublisher;
  var logger = useSearchResultProps().logger;
  var worksWithFieldName = worksWith ? worksWith.field : DefaultFieldProducts.WORKS_WITH;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_DEFAULT);
  // Currently badge has 'any' type and only abstractions is
  // created. Once the API will be ready, full implemention will be applied
  window.getBadge = function (type) {
    var generatePropsByBadgeType = function generatePropsByBadgeType() {
      switch (type) {
        case BadgeType.SALE:
          return {
            text: BadgeType.SALE,
            className: 'coveo-pi-sale-badge'
          };
        case BadgeType.NEW_PRODUCT:
          return {
            text: BadgeType.NEW_PRODUCT,
            className: 'coveo-pi-new-product-badge'
          };
        default:
          return null;
      }
    };
    /**
     * Displays the works with section for app products if the result has
     * DefaultFieldProducts.WORKS_WITH value
     * @param worksWithFieldValue Coveo's works with value
     * @returns HTML string components for work's with section
     */
    window.getWorksWithListPI = function (worksWithFieldValue) {
      return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, worksWithFieldValue && React.createElement("div", {
        className: "coveo-result-cell coveo-result-pi-works-container"
      }, React.createElement("div", {
        className: "coveo-result-row coveo-result-pi-subcategory-label"
      }, "Works with:"), React.createElement("div", {
        className: "coveo-result-row"
      }, React.createElement("div", {
        className: "CoveoFieldValue  coveo-tr-font-size-1",
        "data-field": worksWithFieldName
      })))));
    };
    var props = generatePropsByBadgeType();
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, props && React.createElement("div", {
      className: "coveo-result-list-pi-badge " + props.className
    }, props.text)));
  };
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-result-list-pi-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame coveo-result-pi"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row coveo-result-pi-row"
  }, badgePI && React.createElement("span", null, '{{= getBadge(raw.tr_plp_badgetoappear) }}')), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("div", {
    className: "coveo-card-pi-title"
  }, '{{= raw.tr_plp_producttitle}}'))), React.createElement("div", {
    className: "coveo-pi-line"
  }), React.createElement("div", {
    className: "coveo-result-row"
  }, shortDescriptionPI && React.createElement("div", {
    className: "CoveoFieldValue coveo-pi-short-description",
    "data-field": shortDescriptionPI ? shortDescriptionPI.field : DefaultFieldProducts.SHORT_DESCRIPTION
  }), excerpt && React.createElement("div", {
    className: "CoveoExcerpt coveo-tr-font-size-1 coveo-result-list-default-excerpt"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-result-pi-subcategories"
  }, helpsYouWith && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-pi-subcategory-label"
  }, "Helps you with:"), React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-size-1",
    "data-field": helpsYouWith ? helpsYouWith.field : DefaultFieldProducts.HELPS_WITH
  }))), React.createElement("div", {
    className: "coveo-result-row coveo-result-pi-subcategories"
  }, "{{=  getWorksWithListPI(raw." + worksWithFieldName.substring(1) + ") }}"), worksWithsPublisher && React.createElement("div", {
    className: "coveo-result-row coveo-result-pi-subcategories"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-font-size-0",
    "data-field": worksWithsPublisher ? worksWithsPublisher.field : DefaultFieldProducts.PUBLISHER_NAME
  })))), React.createElement("div", {
    className: "coveo-result-row"
  }, popUrlPI && React.createElement("a", {
    className: "CoveoResultLink coveo-pi-button",
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": popUrlPI ? popUrlPI.field : DefaultFieldProducts.PRLP_URL,
    "data-canonicalcta": canonicalcta
  }, React.createElement("span", {
    className: "coveo-pi-button__title"
  }, "View details"))))))));
};

var css_248z$7 = ".coveo-result-card-pi-template + .coveo-result-list-container .coveo-card-layout.CoveoResult {\n  background-color: var(--tr-coveo-color-tr-white);\n  border: none;\n  border-radius: 8px;\n  box-shadow: var(--tr-coveo-search-result-pi-box-shadow) rgba(0, 0, 0, 0.08);\n  cursor: default !important;\n  flex-grow: initial;\n  margin: var(--tr-coveo-pi-template-margin);\n  transition: all 0.2s ease;\n  width: 250px !important;\n}\n\n.coveo-new-branding .coveo-result-card-pi-template + .coveo-result-list-container .coveo-card-layout.CoveoResult {\n  border: 1px solid var(--tr-help-and-support-meta-tags-color);\n  font-family: var(--tr-coveo-font-family-S3);\n}\n\n.coveo-result-card-pi-template + .coveo-result-list-container .coveo-card-layout.CoveoResult:hover {\n  box-shadow: var(--tr-coveo-search-result-pi-box-shadow-hover) rgba(0, 70, 123, 0.62);\n}\n\n.coveo-card-pi-button {\n  background-color: rgba(250, 100, 0, 1);\n  border-radius: 100px;\n  color: var(--tr-coveo-color-tr-white) !important;\n  display: block;\n  font-size: var(--tr-coveo-search-result-pi-button-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  margin-top: var(--tr-coveo-search-result-pi-button-margin-top);\n  padding: var(--tr-coveo-search-result-pi-card-button-padding);\n  text-align: center;\n}\n\n.coveo-new-branding .coveo-card-pi-button {\n  background-color: transparent;\n  border-radius: var(--tr-coveo-0);\n  display: block;\n  font-weight: var(--tr-coveo-font-weight-medium);\n  margin-top: var(--tr-coveo-search-result-pi-button-margin-top);\n  padding: var(--tr-coveo-0);\n  text-align: left;\n}\n\n.coveo-result-card-pi-template + .coveo-result-list-container .coveo-card-layout.CoveoResult:hover .coveo-card-pi-button {\n  background-color: rgba(220, 67, 0, 1);\n}\n\n.coveo-new-branding .coveo-result-card-pi-template + .coveo-result-list-container .coveo-card-layout.CoveoResult:hover .coveo-card-pi-button {\n  background-color: transparent;\n}\n\n.coveo-card-pi-button__title {\n  color: rgb(255, 255, 255);\n  display: inline-block;\n  font-size: var(--tr-coveo-search-result-pi-button-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  height: 24px;\n  line-height: var(--tr-coveo-search-result-pi-button-line-height);\n}\n\n.coveo-new-branding .coveo-card-pi-button__title {\n  color: var(--tr-coveo-color-tr-blue-dark);\n  font-size: var(--tr-coveo-search-result-pi-short-description-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  text-decoration: underline !important;\n}\n\n.coveo-result-card-pi-template + .coveo-result-list-container .coveo-card-layout.CoveoResult:hover .coveo-card-pi-button__title {\n  color: rgba(222, 222, 222, 1);\n  text-decoration: underline;\n}\n\n.coveo-new-branding .coveo-result-card-pi-template + .coveo-result-list-container .coveo-card-layout.CoveoResult:hover .coveo-card-pi-button__title {\n  color: inherit;\n  text-decoration: none;\n}\n\n.coveo-card-pi-title {\n  color: rgba(64, 64, 64, 1);\n  font-size: var(--tr-coveo-search-result-pi-font-size-title) !important;\n  font-weight: var(--tr-coveo-font-weight-regular);\n  line-height: var(--tr-coveo-normal);\n}\n\n.coveo-new-branding .coveo-card-pi-title {\n  color: rgba(64, 64, 64, 1);\n  font-family: var(--tr-coveo-font-family-clario);\n  font-size: var(--tr-coveo-search-result-pi-font-size-title) !important;\n  font-weight: var(--tr-coveo-font-weight-medium);\n  line-height: var(--tr-coveo-normal);\n}\n\n.coveo-card-pi {\n  cursor: default;\n  padding: var(--tr-coveo-search-result-card-padding) !important;\n}\n\n.coveo-card-pi .coveo-result-cell {\n  flex: 1 1 auto;\n}\n\n.coveo-card-pi-short-description {\n  font-size: var(--tr-coveo-search-result-pi-short-description-font-size) !important;\n  font-weight: var(--tr-coveo-font-weight-regular);\n  margin-bottom: 12px;\n  min-height: 94px;\n}\n\n.coveo-card-pi-line {\n  background-color: rgba(222, 222, 222, 1);\n  height: 1px;\n  margin: var(--tr-coveo-search-result-pi-card-line-margin);\n}\n\n.coveo-result-pi .coveo-result-cell {\n  display: block;\n}\n\n.coveo-card-pi-short-description,\n.coveo-card-pi-subcategories {\n  color: rgba(102, 102, 102, 1);\n}\n\n.coveo-card-pi-subcategories {\n  column-gap: normal;\n  grid-template-columns: none;\n  grid-template-rows: auto 68px;\n  row-gap: 2px;\n}\n\n.coveo-card-pi-works-container {\n  margin-bottom: var(--tr-coveo-result-list-description-gap);\n  margin-top: var(--tr-coveo-result-list-description-gap);\n}\n\n.coveo-card-pi-subcategory-label {\n  font-size: var(--tr-coveo-search-result-pi-subcategories-font-size);\n  font-weight: var(--tr-coveo-font-weight-bold);\n}\n\n.coveo-result-list-pi-badge {\n  border-radius: var(--tr-coveo-search-result-pi-badge-border-radius);\n  display: grid;\n  font-size: var(--tr-coveo-search-result-pi-badge-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  height: 30px;\n  justify-content: center;\n  letter-spacing: 0.5px;\n  padding: var(--tr-coveo-search-result-pi-badge-padding);\n  place-content: center;\n  position: absolute;\n  right: 24px;\n  top: 0;\n}\n\n.coveo-result-pi-row-card {\n  margin-bottom: 1rem !important;\n}\n\n.coveo-tr-font-size-0 {\n  font-size: var(--tr-coveo-font-size-xxxs);\n}\n\n.coveo-result-list-pi-badge.coveo-pi-sale-badge {\n  background-color: rgba(243, 248, 232, 1);\n  color: rgba(56, 124, 43, 1);\n}\n\n.coveo-result-list-pi-badge.coveo-pi-new-product-badge {\n  background-color: rgba(238, 231, 246, 1);\n  color: rgba(58, 26, 146, 1);\n}\n";
styleInject(css_248z$7);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultCardPI = function ResultCardPI() {
  var _useSearchResultProps = useSearchResultProps(),
    canonicalcta = _useSearchResultProps.canonicalcta;
  var _useSearchResultProps2 = useSearchResultProps().resultCard.resultCardConfig,
    resultCardConfig = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2;
  var badgePI = resultCardConfig.badgePI,
    shortDescriptionPI = resultCardConfig.shortDescriptionPI,
    excerpt = resultCardConfig.excerpt,
    helpsYouWith = resultCardConfig.helpsYouWith,
    popUrlPI = resultCardConfig.popUrlPI,
    worksWith = resultCardConfig.worksWith,
    worksWithsPublisher = resultCardConfig.worksWithsPublisher;
  var logger = useSearchResultProps().logger;
  var worksWithFieldName = worksWith ? worksWith.field : DefaultFieldProducts.WORKS_WITH;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_DEFAULT);
  window.getCardBadge = function (type) {
    var generatePropsByBadgeType = function generatePropsByBadgeType() {
      switch (type) {
        case BadgeType.SALE:
          return {
            text: BadgeType.SALE,
            className: 'coveo-pi-sale-badge'
          };
        case BadgeType.NEW_PRODUCT:
          return {
            text: BadgeType.NEW_PRODUCT,
            className: 'coveo-pi-new-product-badge'
          };
        default:
          return null;
      }
    };
    /**
     * Displays the works with section for app products if the result has
     * DefaultFieldProducts.WORKS_WITH value
     * @param worksWithFieldValue Coveo's works with value
     * @returns HTML string components for work's with section
     */
    window.getWorksWithCardPI = function (worksWithFieldValue) {
      return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, worksWithFieldValue && React.createElement("div", {
        className: "coveo-card-pi-works-container"
      }, React.createElement("div", {
        className: "coveo-result-row coveo-card-pi-subcategory-label"
      }, "Works with:"), React.createElement("div", {
        className: "coveo-result-row"
      }, React.createElement("div", {
        className: "CoveoFieldValue  coveo-tr-font-size-1",
        "data-field": worksWithFieldName
      })))));
    };
    var props = generatePropsByBadgeType();
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, props && React.createElement("div", {
      className: "coveo-result-list-pi-badge " + props.className
    }, props.text)));
  };
  return React.createElement(React.StrictMode, null, React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-result-card-pi-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame coveo-card-pi"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, badgePI && React.createElement("span", null, '{{= getCardBadge(raw.tr_plp_badgetoappear) }}')), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("div", {
    className: "coveo-card-pi-title",
    id: "product-title-{{= raw.urihash}}"
  }, '{{= raw.tr_plp_producttitle}}'))), React.createElement("div", {
    className: "coveo-card-pi-line"
  }), React.createElement("div", {
    className: "coveo-result-row"
  }, shortDescriptionPI && React.createElement("div", {
    className: "CoveoFieldValue coveo-card-pi-short-description",
    "data-field": shortDescriptionPI ? shortDescriptionPI.field : DefaultFieldProducts.SHORT_DESCRIPTION
  }), excerpt && React.createElement("div", {
    className: "CoveoExcerpt coveo-tr-font-size-1 coveo-result-list-default-excerpt"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-card-pi-subcategories"
  }, helpsYouWith && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-card-pi-subcategory-label"
  }, "Helps you with:"), React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-size-1",
    "data-field": helpsYouWith ? helpsYouWith.field : DefaultFieldProducts.HELPS_WITH
  }))), React.createElement("div", {
    className: "coveo-result-row coveo-card-pi-subcategories"
  }, "{{=  getWorksWithCardPI(raw." + worksWithFieldName.substring(1) + ") }}"), worksWithsPublisher && React.createElement("div", {
    className: "coveo-result-row coveo-card-pi-subcategories"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-font-size-0",
    "data-field": worksWithsPublisher ? worksWithsPublisher.field : DefaultFieldProducts.PUBLISHER_NAME
  })))), React.createElement("div", {
    className: "coveo-result-row",
    "data-canonicalcta": "dd"
  }, popUrlPI && React.createElement("a", {
    className: "CoveoResultLink coveo-card-pi-button",
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": popUrlPI ? popUrlPI.field : DefaultFieldProducts.PRLP_URL,
    "data-canonicalcta": canonicalcta,
    "aria-describedby": "product-title-{{= raw.urihash}}"
  }, React.createElement("span", {
    className: "coveo-card-pi-button__title"
  }, "View details")))))))));
};

var css_248z$8 = ".coveo-tr-d-inline-block {\n  display: inline-block !important;\n}\n\n.coveo-tr-d-inline {\n  display: inline !important;\n}\n\n.coveo-tr-flex-direction {\n  flex-direction: row !important;\n}\n\n.coveo-tr-VerticalSpacing--xs {\n  margin: var(--tr-coveo-result-list-store-author-margin-xs) !important;\n}\n\n.coveo-tr-VerticalSpacing--m {\n  margin: var(--tr-coveo-result-list-store-margin-tr-m) !important;\n}\n\n.coveo-tr-d-flex {\n  display: flex !important;\n}\n\n.coveo-tr-width-100 {\n  width: 100% !important;\n}\n\n.coveo-tr-width-1 {\n  max-width: 30%;\n}\n\n.coveo-tr-cell-width {\n  max-width: 58.33333333%;\n}\n\n.coveo-tr-font-weight {\n  font-weight: var(--tr-coveo-font-weight-black);\n}\n\n.coveo-tr-font-size-1 {\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n}\n\n.coveo-result-frame .coveo-result-row,\n.CoveoResult.coveo-result-frame .coveo-result-row {\n  width: unset;\n}\n\n.CoveoResultLink:not(.coveo-new-branding) {\n  color: var(--tr-coveo-color-tr-blue-dark) !important;\n  font-size: var(--tr-coveo-font-size-s);\n  line-height: var(--tr-coveo-result-list-store-line-height-x);\n}\n\n.coveo-new-branding .CoveoResultLink {\n  color: var(--tr-coveo-color-tr-blue-dark) !important;\n  font-size: var(--tr-coveo-font-size-m);\n  line-height: var(--tr-coveo-result-list-store-line-height-x);\n}\n\n.coveo-field-caption {\n  color: rgb(77, 77, 77) !important;\n  font-size: var(--tr-coveo-font-size-xxxs) !important;\n}\n\n.CoveoFieldValue {\n  font-size: var(--tr-coveo-font-size-xxxs);\n  line-height: var(--tr-coveo-result-list-store-line-height-x);\n}\n\n.CoveoFieldValue .coveo-field-caption {\n  font-weight: var(--tr-coveo-font-weight-black);\n}\n\n.CoveoFieldValue img,\n.coveo-tr-image {\n  height: 12.688rem;\n  margin-bottom: 0.0625rem;\n  margin-left: 0.6875rem;\n  padding-bottom: 0.5625rem;\n  padding-left: 0.125rem;\n  padding-top: 0.125rem;\n  width: 10.25rem;\n}\n\n.coveo-tr-result-author span {\n  color: rgb(49, 58, 69) !important;\n  font-weight: inherit !important;\n}\n\n.coveo-tr-result-date {\n  cursor: default;\n}\n\n.coveo-tr-cadana-store-fields {\n  /* stylelint-disable */\n  display: grid !important;\n  grid-column-gap: 2.25rem;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.coveo-tr-cadana-store-fields span {\n  display: block;\n}\n\n@media only screen and (max-width: 47.875rem) {\n  .coveo-tr-result-frame {\n    flex-direction: column;\n  }\n\n  .coveo-tr-cell-width {\n    max-width: 100%;\n  }\n}\n";
styleInject(css_248z$8);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListStore = function ResultListStore() {
  var _useSearchResultProps = useSearchResultProps().resultList,
    _useSearchResultProps2 = _useSearchResultProps.resultListConfig,
    resultListConfig = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2,
    resultListDefaultImage = _useSearchResultProps.resultListDefaultImage;
  var uri = resultListConfig.uri,
    excerpt = resultListConfig.excerpt,
    date = resultListConfig.date,
    author = resultListConfig.author,
    format = resultListConfig.format,
    availability = resultListConfig.availability,
    publisher = resultListConfig.publisher,
    shortDescription = resultListConfig.shortDescription;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_STORE);
  window.getResultImgContent = function (img) {
    if (img) {
      return "<div class=\"coveo-tr-margin-right-3\">\n            <img\n              src=" + img + "\n              class=\"coveo-tr-image\"\n              alt=\"noImage\"\n            />\n        </div>";
    } else {
      return "<div\n              class=\"coveo-tr-margin-right-3\"\n              ><img\n              class=\"coveo-tr-image\"\n              src=" + resultListDefaultImage + "\n              alt=\"tr-logo\"\n            ></div>";
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-tr-canada-store",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame coveo-tr-d-flex coveo-tr-result-frame"
  }, React.createElement("div", {
    className: "coveo-result-cell coveo-tr-width-1"
  }, '{{=  getResultImgContent(raw.tr_canadastore_imageurl) }}'), React.createElement("div", {
    className: "coveo-result-cell coveo-tr-cell-width "
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--xs"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink coveo-tr-font-weight",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@tr_canadastore_link'
  }))), React.createElement("div", {
    className: "coveo-result-row coveo-tr-d-inline-block coveo-tr-VerticalSpacing--m coveo-tr-product-details"
  }, React.createElement("span", {
    className: "CoveoFieldValue coveo-tr-result-date",
    "data-helper": date ? date.value : 'date',
    "data-helper-options-width": "100%",
    "data-html-value": "true",
    "data-helper-options-predefined-format": "yyyy-MM-dd",
    "data-field": date ? date.field : '@tr_canadastore_pubdate'
  }), React.createElement("span", {
    className: "CoveoFieldValue coveo-tr-result-publisher",
    "data-field": publisher ? publisher.field : '@tr_canadastore_publisher',
    "data-split-values": "true",
    "data-display-separator": " "
  }), React.createElement("span", {
    className: "CoveoFieldValue coveo-tr-result-author",
    "data-field": author ? author.field : '@tr_canadastore_authors',
    "data-split-values": "true",
    "data-display-separator": " "
  })), React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--m"
  }, excerpt ? React.createElement("div", {
    className: "CoveoExcerpt"
  }) : React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": shortDescription ? shortDescription.field : '@tr_canadastore_shortdescription'
  })), React.createElement("div", {
    className: "coveo-result-row coveo-tr-cadana-store-fields"
  }, React.createElement("div", {
    className: "CoveoFieldValue",
    "data-text-caption": format ? format.value : 'TRStoreFormat'.toLocaleString(),
    "data-helper": format ? format.value : 'TRStoreFormat'.toLocaleString(),
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": format ? format.field : '@tr_canadastore_productformat'
  }), React.createElement("div", {
    className: "CoveoFieldValue",
    "data-text-caption": availability ? availability.value : 'TRStoreAvailability'.toLocaleString(),
    "data-helper": availability ? availability.value : 'TRStoreAvailability'.toLocaleString(),
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": availability ? availability.field : '@tr_canadastore_stockavailable'
  })))))));
};

var UserIcon = function UserIcon() {
  return React.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M12 12a5 5 0 0 1-5-5V6a5 5 0 0 1 10 0v1a5 5 0 0 1-5 5z"
  }), React.createElement("path", {
    d: "M22 20.908a3.99 3.99 0 0 0-2.934-3.856C17.172 16.535 14.586 16 12 16s-5.172.535-7.066 1.052A3.99 3.99 0 0 0 2 20.908V23h20v-2.092z",
    "data-color": "color-2"
  })));
};

var css_248z$9 = ".coveo-tr-login-and-support-wrapper {\n  align-items: center;\n  display: flex;\n}\n\n.coveo-tr-login-and-support-wrapper svg {\n  height: 1rem;\n  margin-right: 0.5rem;\n  width: 1rem;\n}\n\n.coveo-tr-login-and-support-fonts a {\n  color: var(--tr-coveo-color-tr-gray-dark) !important;\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.coveo-login-and-support-line {\n  background-color: var(--tr-coveo-color-tr-gray-muted);\n  margin: var(--tr-coveo-result-list-margin-line);\n  width: 0.063rem;\n}\n\n.coveo-result-list-legal .coveo-results-row-fields {\n  margin-top: 1.5rem !important;\n}\n\n.coveo-result-list-legal-excerpt {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-font-size-xxs);\n  line-height: var(--tr-coveo-result-list-line-height-medium);\n}\n\n.coveo-resutl-list-legal-template + .coveo-result-list-container .coveo-list-layout {\n  padding-bottom: 2.25rem;\n  padding-top: 2.25rem;\n}\n";
styleInject(css_248z$9);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListLegal = function ResultListLegal() {
  var resultListConfig = useSearchResultProps().resultList.resultListConfig;
  var uri = resultListConfig == null ? void 0 : resultListConfig.uri;
  var canadastoreDescriptionField = resultListConfig == null ? void 0 : resultListConfig.canadastoreDescriptionField;
  var storeDescriptionFieldName = canadastoreDescriptionField ? canadastoreDescriptionField.field : DefaultFieldCanadastore.DESCRIPTION;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_LEGAL);
  /**
   * Displays the result's excerpt when it's not a canada store result
   * And the short description inside a CoveoField div canadastoreDescriptionField is provided
   * @param storeDescriptionValue Coveo's canada store description value
   * @returns HTML component for CoveoExcerpt
   */
  window.getExcerpt = function (storeDescriptionValue) {
    /* //field name wasn't set or short description not in result */
    var showExcerpt = !canadastoreDescriptionField || !storeDescriptionValue;
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, showExcerpt && React.createElement("div", {
      className: "CoveoExcerpt coveo-tr-font-size-1 coveo-result-list-legal-excerpt"
    }), canadastoreDescriptionField && React.createElement("div", {
      className: "CoveoFieldValue coveo-tr-font-size-1",
      "data-field": storeDescriptionFieldName
    })));
  };
  window.getLoginAndSupport = function (productLoginUrl, productSupporturl) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, productLoginUrl && React.createElement("div", {
      className: "coveo-tr-login-and-support-wrapper coveo-tr-login-and-support-fonts"
    }, React.createElement("a", {
      className: "coveo-tr-login-and-support-wrapper",
      href: productLoginUrl
    }, React.createElement(UserIcon, null), React.createElement("span", null, 'TRLogin'.toLocaleString()))), productLoginUrl && productSupporturl && React.createElement("div", {
      className: "coveo-login-and-support-line"
    }), productSupporturl && React.createElement("div", {
      className: "coveo-tr-login-and-support-wrapper coveo-tr-login-and-support-fonts"
    }, React.createElement("a", {
      className: "coveo-tr-login-and-support-wrapper",
      href: productSupporturl
    }, React.createElement("span", null, 'TRSupport'.toLocaleString())))));
  };
  return React.createElement(React.StrictMode, null, React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-resutl-list-legal-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame coveo-result-list-legal"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink coveo-resuli-list-legal-uri",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, "{{=  getExcerpt(raw." + storeDescriptionFieldName.substring(1) + ") }}"), React.createElement("div", {
    className: "coveo-result-row coveo-results-row-fields"
  }, '{{=  getLoginAndSupport(raw.tr_productloginurl, raw.tr_getsupporturl) }}'))))))));
};

var ClockIcon = function ClockIcon() {
  return React.createElement("svg", {
    className: "tr-coveo-clock-icon tr-coveo-margin-right-xs",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 1 0 0-22z"
  }), React.createElement("path", {
    d: "M12 6v6h6",
    "data-color": "color-2"
  })));
};

var css_248z$a = ".coveo-tr-legal-scoped-card-caption {\n  padding-left: 2.2rem;\n  padding-top: 0 !important;\n  text-transform: uppercase;\n}\n\n.coveo-tr-legal-scoped-image-box {\n  margin-bottom: 3rem;\n}\n\n.coveo-tr-card-content-wrapper {\n  padding-bottom: 2.25rem;\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n\n.coveo-tr-legal-cards-scoped .CoveoResultLink {\n  /* Unsetting the font size since size is set for all other templates */\n  font-size: var(--tr-coveo-unset);\n}\n\n.coveo-tr-card-date {\n  font-weight: var(--tr-coveo-font-weight-regular) !important;\n}\n\n.coveo-tr-cards-desc-text {\n  color: rgb(49, 58, 69);\n  font-weight: var(--tr-coveo-font-weight-regular);\n}\n";
styleInject(css_248z$a);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListCards = function ResultListCards() {
  var _useSearchResultProps3;
  var _useSearchResultProps = (_useSearchResultProps3 = useSearchResultProps()) == null ? void 0 : _useSearchResultProps3.resultList,
    facetIsEnable = _useSearchResultProps.facetIsEnable,
    _useSearchResultProps2 = _useSearchResultProps.resultListConfig,
    resultListConfig = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2;
  var wpagetype = resultListConfig.wpagetype,
    title = resultListConfig.title,
    publishTime = resultListConfig.publishTime,
    readTime = resultListConfig.readTime,
    shortDescription = resultListConfig.shortDescription,
    excerpt = resultListConfig.excerpt;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_CARDS);
  window.getResultImgContent = function (img) {
    if (img) {
      return "<div className=\"coveo-tr-card-image\">\n            <div class=\"coveo-tr-legal-card-image-wrapper\">\n            <img\n              src=" + img + "\n              alt=\"noImage\"\n            />\n        </div>\n        </div>";
    } else {
      return "";
    }
  };
  window.getLegalBlogDate = function (date) {
    return date ? dateFormatToString(date) : null;
  };
  window.getReadTime = function (wreadTime) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, wreadTime && React.createElement("time", {
      className: "tr-coveo-duration"
    }, React.createElement(ClockIcon, null), React.createElement("div", {
      className: "CoveoFieldValue tr-coveo-margin-right-xs",
      "data-html-value": "true",
      "data-field": "@tr_wreadtime"
    }), React.createElement("span", null, 'TRMin'.toLocaleString()))));
  };
  window.getPageType = getPageType;
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-tr-legal-cards " + (facetIsEnable ? 'coveo-tr-legal-cards-with-facet' : ''),
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame coveo-tr-legal-cards-scoped"
  }, React.createElement("a", {
    className: "CoveoResultLink coveo-tr-legal-card-wrapper",
    href: '{{= raw.uri}}',
    target: "_self",
    rel: "noreferrer"
  }, React.createElement("div", {
    className: "coveo-tr-legal-scoped-image-box"
  }, '{{=  getResultImgContent(raw.tr_wthumbnailimage) }}'), React.createElement("div", null, wpagetype && React.createElement("span", {
    className: "tr-coveo-SearchResults-resultEyebrow coveo-tr-card-caption coveo-tr-legal-scoped-card-caption"
  }, '{{= getPageType(raw.tr_wpagetype) }}')), React.createElement("div", {
    className: "coveo-tr-card-content-wrapper"
  }, title && React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-card-title",
    "data-field": title.field || '@title'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, shortDescription && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-size-1 coveo-tr-cards-desc-text",
    "data-field": shortDescription ? shortDescription.field : '@tr_shortdescription'
  }), excerpt && React.createElement("div", {
    className: "CoveoExcerpt coveo-tr-cards-desc-text"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-tr-card-time-content"
  }, publishTime && React.createElement("span", {
    className: "coveo-tr-card-date"
  }, '{{= getLegalBlogDate(raw.tr_wpublishedtime) }}'), readTime && React.createElement("div", {
    className: "coveo-result-row d-flex"
  }, '{{= getReadTime(raw.tr_wreadtime) }}'))))))));
};

var css_248z$b = ".tr-coveo-duration {\n  align-items: center;\n  display: flex;\n  margin-left: 2.125rem;\n  margin-top: 1.5rem;\n}\n\n.coveo-result-row-duration {\n  margin: var(--margin-result-list-duration-row) !important;\n}\n";
styleInject(css_248z$b);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListScoped = function ResultListScoped() {
  var _useSearchResultProps3;
  var _useSearchResultProps = (_useSearchResultProps3 = useSearchResultProps()) == null ? void 0 : _useSearchResultProps3.resultList,
    _useSearchResultProps2 = _useSearchResultProps.resultListConfig,
    resultListConfig = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2;
  var uri = resultListConfig.uri,
    readTime = resultListConfig.readTime,
    wpagetype = resultListConfig.wpagetype,
    shortDescription = resultListConfig.shortDescription,
    excerpt = resultListConfig.excerpt;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_SCOPED);
  window.getReadTime = function (wreadTime) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, wreadTime && React.createElement("time", {
      className: "tr-coveo-duration"
    }, React.createElement(ClockIcon, null), React.createElement("div", {
      className: "CoveoFieldValue tr-coveo-margin-right-xs",
      "data-html-value": "true",
      "data-field": "@tr_wreadtime"
    }), React.createElement("span", null, 'TRMin'.toLocaleString()))));
  };
  window.getPageType = function (pageType) {
    if (!pageType || pageType.length === 0) {
      return '';
    }
    var t = pageType[pageType.length - 1].split('|');
    if (!t || t.length === 0) {
      return pageType[0];
    }
    return t[t.length - 1];
  };
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame  tr-coveo-legal-templates"
  }, wpagetype && React.createElement("span", {
    className: "tr-coveo-SearchResults-resultEyebrow"
  }, '{{= getPageType(raw.tr_wpagetype) }}'), React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row tr-coveo-margin-bottom-x"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, shortDescription && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-size-1",
    "data-field": shortDescription ? shortDescription.field : '@tr_shortdescription'
  }), excerpt && React.createElement("div", {
    className: "CoveoExcerpt"
  })), readTime && React.createElement("div", {
    className: "coveo-result-row coveo-result-row-duration"
  }, '{{= getReadTime(raw.tr_wreadtime) }}'))))));
};

var css_248z$c = "/* ResultListDefault Styles */\n\n.coveo-tr-login-and-support-wrapper {\n  align-items: center;\n  display: flex;\n}\n\n.coveo-tr-login-and-support-wrapper svg {\n  height: 1rem;\n  margin-right: 0.5rem;\n  width: 1rem;\n}\n\n.coveo-tr-login-and-support-fonts a {\n  color: var(--tr-coveo-color-tr-gray-dark) !important;\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.coveo-login-and-support-line {\n  background-color: var(--tr-coveo-color-tr-gray-muted);\n  margin: var(--tr-coveo-result-list-margin-line);\n  width: 0.063rem;\n}\n\n.coveo-result-list-default .coveo-results-row-fields {\n  margin-top: 1.5rem !important;\n}\n\n.coveo-new-branding .coveo-result-list-default-excerpt {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-font-size-xxs);\n  line-height: var(--tr-coveo-new-branding-result-list-line-height-medium);\n}\n\n.coveo-result-list-default-excerpt:not(.coveo-new-branding) {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-font-size-xxs);\n  line-height: var(--tr-coveo-result-list-line-height-medium);\n}\n\n.coveo-resutl-list-default-template + .coveo-result-list-container .coveo-list-layout {\n  padding-bottom: 2.25rem;\n  padding-top: 2.25rem;\n}\n\n.coveo-tr-default-date {\n  display: block;\n  margin-top: 1.5rem;\n}\n";
styleInject(css_248z$c);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListDefault = function ResultListDefault() {
  var _useSearchResultProps = useSearchResultProps().resultList.resultListConfig,
    resultListConfig = _useSearchResultProps === void 0 ? {} : _useSearchResultProps;
  var uri = resultListConfig.uri,
    publishTime = resultListConfig.publishTime,
    shortDescription = resultListConfig.shortDescription;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_DEFAULT);
  window.getCoveoPublishDate = function (date) {
    return date ? dateFormatToString(date) : null;
  };
  // Description is either the short description or the Coveo excerpt. It will prioritize the short description if it exists.
  window.getDescription = function (shortDescript) {
    return (shortDescript == null ? void 0 : shortDescript.length) > 0 && shortDescription ? ReactDOMServer.renderToString(React.createElement("div", {
      className: "CoveoFieldValue coveo-tr-font-size-1",
      "data-field": shortDescription ? shortDescription.field : '@tr_shortdescription',
      "data-helper": "highlightStreamText",
      "data-html-value": "true"
    })) : ReactDOMServer.renderToString(React.createElement("div", {
      className: "CoveoExcerpt coveo-tr-font-size-1 coveo-result-list-default-excerpt"
    }));
  };
  window.getLoginAndSupport = function (productLoginUrl, productSupporturl) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, productLoginUrl && React.createElement("div", {
      className: "coveo-tr-login-and-support-wrapper coveo-tr-login-and-support-fonts"
    }, React.createElement("a", {
      className: "coveo-tr-login-and-support-wrapper",
      href: productLoginUrl
    }, React.createElement(UserIcon, null), React.createElement("span", null, 'TRLogin'.toLocaleString()))), productLoginUrl && productSupporturl && React.createElement("div", {
      className: "coveo-login-and-support-line"
    }), productSupporturl && React.createElement("div", {
      className: "coveo-tr-login-and-support-wrapper coveo-tr-login-and-support-fonts"
    }, React.createElement("a", {
      className: "coveo-tr-login-and-support-wrapper",
      href: productSupporturl
    }, React.createElement("span", null, 'TRSupport'.toLocaleString())))));
  };
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-resutl-list-default-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame coveo-result-list-default"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink coveo-resuli-list-default-uri",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, '{{= getDescription(raw.tr_shortdescription) }}'), React.createElement("div", {
    className: "coveo-result-row"
  }, publishTime && React.createElement("span", {
    className: "coveo-tr-default-date"
  }, '{{= getCoveoPublishDate(raw.tr_wpublishedtime) }}')), React.createElement("div", {
    className: "coveo-result-row coveo-results-row-fields"
  }, '{{=  getLoginAndSupport(raw.tr_productloginurl, raw.tr_getsupporturl) }}')))))));
};

var css_248z$d = ":root {\n  --tr-coveo-dont-size-locations: 1.3125rem;\n}\n\na.coveo-resuli-list-locations-uri {\n  font-size: var(--tr-coveo-font-size-m);\n  font-weight: var(--tr-coveo-font-weight-light) !important;\n}\n\n.coveo-tr-font-locations {\n  font-size: var(--tr-coveo-dont-size-locations) !important;\n  font-weight: var(--tr-coveo-font-weight-light);\n}\n\n.coveo-tr-results-desc {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-font-size-xxs);\n  margin-top: 1rem;\n}\n";
styleInject(css_248z$d);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListLocations = function ResultListLocations() {
  var _useSearchResultProps = useSearchResultProps().resultList.resultListConfig,
    resultListConfig = _useSearchResultProps === void 0 ? {} : _useSearchResultProps;
  var uri = resultListConfig.uri,
    address1 = resultListConfig.address1,
    address2 = resultListConfig.address2,
    address3 = resultListConfig.address3,
    country = resultListConfig.country,
    phone = resultListConfig.phone;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_LOCATIONS);
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-resutl-list-default-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame coveo-result-list-locations"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink coveo-resuli-list-locations-uri",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-tr-results-desc"
  }, React.createElement("span", null, "Thomson Reuters office locations")), React.createElement("div", {
    className: "coveo-result-row"
  }, address1 && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-locations",
    "data-field": address1 ? address1.field : '@tr_waddress1'
  })), React.createElement("div", {
    className: "coveo-result-row"
  }, address2 && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-locations",
    "data-field": address2 ? address2.field : '@tr_waddress2'
  })), React.createElement("div", {
    className: "coveo-result-row"
  }, address3 && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-locations",
    "data-field": address3 ? address3.field : '@tr_waddress3'
  })), React.createElement("div", {
    className: "coveo-result-row"
  }, country && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-locations",
    "data-field": country ? country.field : '@tr_wcountry'
  }), phone && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-locations",
    "data-field": phone ? phone.field : '@tr_wphone'
  }))))))));
};

var css_248z$e = ".tr-coveo-legal-scoped-right-image-wrapper {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.tr-coveo-legal-scoped-right-image-wrapper object,\n.tr-coveo-legal-scoped-right-image-wrapper img {\n  height: 12.75rem;\n  margin-left: 4.5rem;\n  width: 22.75rem;\n}\n\n.tr-coveo-legal-scoped-right-image-wrapper .tr-coveo-duration {\n  margin: var(--tr-coveo-0);\n}\n\n@media only screen and (max-width: 48rem) {\n  .tr-coveo-legal-scoped-right-image-wrapper img {\n    display: none;\n  }\n}\n";
styleInject(css_248z$e);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListRightImage = function ResultListRightImage() {
  var _useSearchResultProps3;
  var _useSearchResultProps = (_useSearchResultProps3 = useSearchResultProps()) == null ? void 0 : _useSearchResultProps3.resultList,
    _useSearchResultProps2 = _useSearchResultProps.resultListConfig,
    resultListConfig = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2;
  var uri = resultListConfig.uri,
    readTime = resultListConfig.readTime,
    publishTime = resultListConfig.publishTime,
    wpagetype = resultListConfig.wpagetype,
    shortDescription = resultListConfig.shortDescription,
    excerpt = resultListConfig.excerpt;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_RIGHT_IMAGE);
  window.getResultImgContent = function (img) {
    if (img) {
      return "\n            <img\n              src=" + img + "\n              alt=\"noImage\"\n            />\n        ";
    } else {
      return "";
    }
  };
  window.getReadTime = function (wreadTime) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, wreadTime && React.createElement("time", {
      className: "tr-coveo-duration"
    }, React.createElement(ClockIcon, null), React.createElement("div", {
      className: "CoveoFieldValue tr-coveo-margin-right-xs",
      "data-html-value": "true",
      "data-field": "@tr_wreadtime"
    }), React.createElement("span", null, 'TRMin'.toLocaleString()))));
  };
  window.getLegalBlogDate = function (date) {
    return date ? dateFormatToString(date) : null;
  };
  window.getPageType = getPageType;
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame  tr-coveo-legal-templates"
  }, React.createElement("div", {
    className: "tr-coveo-legal-scoped-right-image-wrapper"
  }, React.createElement("div", null, wpagetype && React.createElement("span", {
    className: "tr-coveo-SearchResults-resultEyebrow"
  }, '{{= getPageType(raw.tr_wpagetype) }}'), React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row tr-coveo-margin-bottom-x"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, shortDescription && React.createElement("div", {
    className: "CoveoFieldValue  coveo-tr-font-size-1",
    "data-field": shortDescription ? shortDescription.field : '@tr_shortdescription'
  }), excerpt && React.createElement("div", {
    className: "CoveoExcerpt"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-tr-card-time-content"
  }, publishTime && React.createElement("span", {
    className: "coveo-tr-card-date"
  }, '{{= getLegalBlogDate(raw.tr_wpublishedtime) }}'), readTime && React.createElement("div", {
    className: "coveo-result-row d-flex"
  }, '{{= getReadTime(raw.tr_wreadtime) }}')))), React.createElement("div", null, '{{=  getResultImgContent(raw.tr_wthumbnailimage) }}'))))));
};

var css_248z$f = ".tr-coveo-duration {\n  align-items: center;\n  display: flex;\n  margin-left: 2.125rem;\n  margin-top: 1.5rem;\n}\n\n.coveo-result-row-duration {\n  margin: var(--margin-result-list-duration-row) !important;\n}\n";
styleInject(css_248z$f);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListLegalScoped = function ResultListLegalScoped() {
  var _useSearchResultProps2;
  var _useSearchResultProps = (_useSearchResultProps2 = useSearchResultProps()) == null ? void 0 : _useSearchResultProps2.resultList,
    resultListConfig = _useSearchResultProps.resultListConfig;
  var uri = resultListConfig == null ? void 0 : resultListConfig.uri;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_LEGAL_SCOPED);
  window.getReadTime = function (wreadTime) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, wreadTime && React.createElement("time", {
      className: "tr-coveo-duration"
    }, React.createElement(ClockIcon, null), React.createElement("div", {
      className: "CoveoFieldValue tr-coveo-margin-right-xs",
      "data-html-value": "true",
      "data-field": "@tr_wreadtime"
    }), React.createElement("span", null, 'TRMin'.toLocaleString()))));
  };
  window.getPageType = function (pageType) {
    if (!pageType || pageType.length === 0) {
      return '';
    }
    var t = pageType[pageType.length - 1].split('|');
    if (!t || t.length === 0) {
      return pageType[0];
    }
    return t[t.length - 1];
  };
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame  tr-coveo-legal-templates"
  }, React.createElement("span", {
    className: "tr-coveo-SearchResults-resultEyebrow"
  }, '{{= getPageType(raw.tr_wpagetype) }}'), React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row tr-coveo-margin-bottom-x"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "CoveoExcerpt"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-result-row-duration"
  }, '{{= getReadTime(raw.tr_wreadtime) }}'))))));
};

var PersonalizedRecommendation = function PersonalizedRecommendation(props) {
  var _useSearchResultProps = useSearchResultProps(),
    _useSearchResultProps2 = _useSearchResultProps.productRecommendation,
    _useSearchResultProps3 = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2,
    _useSearchResultProps4 = _useSearchResultProps3.productRecommendationTitle,
    productRecommendationTitle = _useSearchResultProps4 === void 0 ? 'Thomson Reuters best sellers' : _useSearchResultProps4;
  var recommendBooks = props.recommendBooks;
  return React.createElement(PersonalizedRecommendations, {
    mode: PersonalizedRecommendationsTypes.RecommendationFlowEnum.Static,
    productrecommendationtitle: productRecommendationTitle,
    recommendedresults: recommendBooks,
    ischipsenabled: true
  });
};

var getBestSellerIds = function getBestSellerIds() {
  var elements = document.querySelectorAll('[data-product-id]');
  var recommendations = [];
  var usedProductIds = {};
  elements.forEach(function (element) {
    var productId = element.getAttribute('data-product-id');
    if (productId) usedProductIds[productId] = true;
  });
  elements.forEach(function (element, index) {
    var productRecommendationIds = element.getAttribute('data-product-recommendations');
    // Only include recommendations from first book index == 0
    if (productRecommendationIds && index < 3) {
      var uniqueIds = productRecommendationIds.split(',').filter(function (productId) {
        return !usedProductIds[productId];
      });
      if (uniqueIds.length > 0) {
        uniqueIds.forEach(function (productId) {
          return usedProductIds[productId] = true;
        });
        recommendations.push(uniqueIds);
      }
    }
  });
  return recommendations.slice(0, 3);
};
var generateCoveoRuleByIds = function generateCoveoRuleByIds(ids) {
  return ids.map(function (id) {
    return "@tr_canadastore_parentproductid=\"" + id + "\"";
  }).join(' OR ');
};
var generateProps = function generateProps(response, productRecommendationAnalytics) {
  var results = response.results;
  if (!results) {
    throw new Error("Response structure doesn't meet requirements!");
  }
  return results.map(function (result) {
    var raw = result.raw;
    return {
      // title: raw.tr_canadastore_title,
      productImageUrl: raw.tr_canadastore_imageurl,
      altText: raw.tr_canadastore_imagealttag,
      productUrl: raw.tr_canadastore_link,
      publishers: raw.tr_canadastore_publisher,
      authors: raw.tr_canadastore_authors,
      description: raw.tr_canadastore_title,
      defaultProductImageUrl: raw.tr_canadastore_imageurl,
      analyticsQueryParams: productRecommendationAnalytics
    };
  }).slice(0, 4);
};
var renderRecommendationComponent = function renderRecommendationComponent(recommendBooks) {
  // Only render when there are books to insert
  if (recommendBooks.length) {
    var container = document.body.querySelector('.coveo-result-list-container');
    if (container) {
      var children = container.children;
      var personalizedContainer = document.createElement('div');
      personalizedContainer.classList.add('tr-personalized-recommendations-container');
      if (children.length) {
        var nodePos = children.length > 5 ? children[5] : children[children.length];
        container.insertBefore(personalizedContainer, nodePos);
        return {
          container: personalizedContainer,
          children: React.createElement(PersonalizedRecommendation, {
            recommendBooks: recommendBooks
          })
        };
      }
    }
  }
  return null;
};
var initCoveoRequest = function initCoveoRequest(ids) {
  var query = {
    q: '',
    aq: generateCoveoRuleByIds(ids)
  };
  return SearchEndpoint.endpoints['default'].search(query);
};
var usePersonalizedRecommendationComponent = function usePersonalizedRecommendationComponent(props) {
  var enablePersonalizedRecommendation = props.enablePersonalizedRecommendation,
    productRecommendationAnalytics = props.productRecommendationAnalytics;
  var _useState = useState(null),
    personalizedComponent = _useState[0],
    setPersonalizedComponent = _useState[1];
  useEffect(function () {
    var handler = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var bestSellerIds, responses, recommendationComponentProps, renderRecommendationComponentData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              bestSellerIds = getBestSellerIds();
              if (!bestSellerIds.length) {
                _context.next = 14;
                break;
              }
              _context.prev = 2;
              _context.next = 5;
              return Promise.all(bestSellerIds.map(initCoveoRequest));
            case 5:
              responses = _context.sent;
              recommendationComponentProps = responses.map(function (response) {
                return generateProps(response, productRecommendationAnalytics);
              }).flat().slice(0, 4);
              renderRecommendationComponentData = renderRecommendationComponent(recommendationComponentProps);
              if (renderRecommendationComponentData) {
                setPersonalizedComponent(renderRecommendationComponentData);
              }
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 11]]);
      }));
      return function handler() {
        return _ref.apply(this, arguments);
      };
    }();
    if (enablePersonalizedRecommendation) {
      $$(document.body).on(CoveoEventNames.NEW_RESULTS_DISPLAYED, handler);
    }
    return function () {
      $$(document.body).off(CoveoEventNames.NEW_RESULTS_DISPLAYED, handler);
    };
  }, [enablePersonalizedRecommendation, productRecommendationAnalytics]);
  var personalizedContainerProps = {};
  if (enablePersonalizedRecommendation) {
    personalizedContainerProps['data-product-id'] = '{{= raw.tr_canadastore_parentproductid }}';
    personalizedContainerProps['data-product-recommendations'] = '{{= raw.tr_canadastore_recommendations }}';
  }
  return {
    personalizedContainerProps: personalizedContainerProps,
    personalizedComponent: personalizedComponent
  };
};

var css_248z$g = ".coveo-tr-d-inline-block {\n  display: inline-block !important;\n}\n\n.coveo-tr-d-inline {\n  display: inline !important;\n}\n\n.coveo-tr-flex-direction {\n  flex-direction: row !important;\n}\n\n.coveo-tr-VerticalSpacing--xs {\n  margin: var(--tr-coveo-result-list-store-author-margin-xs) !important;\n}\n\n.coveo-tr-VerticalSpacing--m {\n  margin: var(--tr-coveo-result-list-store-margin-tr-m) !important;\n}\n\n.coveo-tr-d-flex {\n  display: flex !important;\n}\n\n.coveo-tr-width-100 {\n  width: 100% !important;\n}\n\n.coveo-tr-width-1 {\n  max-width: 30%;\n}\n\n.coveo-tr-cell-width {\n  flex: 1;\n  max-width: 58.33333333%;\n}\n\n.coveo-tr-font-weight {\n  font-weight: var(--tr-coveo-font-weight-black);\n}\n\n.coveo-tr-font-size-1 {\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n}\n\n.coveo-result-frame .coveo-result-row,\n.CoveoResult.coveo-result-frame .coveo-result-row {\n  width: unset;\n}\n\n.coveo-new-branding .CoveoResultLink {\n  color: var(--tr-coveo-color-tr-blue-dark) !important;\n  font-size: var(--tr-coveo-font-size-l) !important;\n  line-height: var(--tr-coveo-new-branding-result-list-store-line-height-x) !important;\n}\n\n.CoveoResultLink:not(.coveo-new-branding) {\n  color: var(--tr-coveo-color-tr-blue-dark) !important;\n  font-size: var(--tr-coveo-font-size-s);\n  line-height: var(--tr-coveo-result-list-store-line-height-x);\n}\n\n.coveo-field-caption {\n  color: rgb(77, 77, 77) !important;\n  font-size: var(--tr-coveo-font-size-xxxs) !important;\n}\n\n.CoveoFieldValue {\n  font-size: var(--tr-coveo-font-size-xxxs);\n  line-height: var(--tr-coveo-result-list-store-line-height-x);\n}\n\n.CoveoFieldValue .coveo-field-caption {\n  font-weight: var(--tr-coveo-font-weight-black);\n}\n\n.CoveoFieldValue img,\n.coveo-tr-image {\n  height: 12.688rem;\n  margin-bottom: 0.0625rem;\n  margin-left: 0.6875rem;\n  padding-bottom: 0.5625rem;\n  padding-left: 0.125rem;\n  padding-top: 0.125rem;\n  width: 10.25rem;\n}\n\n.position-relative {\n  position: relative;\n}\n\n.coveo-tr-image-chip {\n   /* stylelint-disable */\n  display: flex;\n  height: 1.875rem;\n  top: 0;\n  left: 0.063rem;\n  align-items: center;\n  position: absolute;\n  border: 1px solid var(--tr-coveo-color-tr-gray-dark);\n  justify-content: center;\n  border-radius: 4px;\n  padding: var(--tr-coveo-facet-padding-size-xs) var(--tr-coveo-search-result-pi-badge-font-size);\n  font-size: 0.938rem;\n  font-style: normal;\n  font-weight: var(--tr-coveo-font-weight-medium);\n  gap: 0.5rem;\n}\n\n.coveo-tr-pre-sale-chip {\n  background-color: var(--tr-coveo-color-tr-white);\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-tr-new-chip {\n  background-color: var(--tr-coveo-color-tr-blue-dark);\n  color: var(--tr-coveo-color-tr-white);\n}\n\n.coveo-tr-result-author .coveo-highlight {\n  font-weight: var(--tr-coveo-bold) !important;\n}\n\n.coveo-tr-result-author span {\n  color: rgb(49, 58, 69) !important;\n  font-weight: inherit !important;\n}\n\n.coveo-tr-result-date {\n  cursor: default;\n}\n\n.coveo-tr-product-details > span + span:not(.coveo-highlight)::before,\n.coveo-tr-result-author span:not(:first-child):not(.coveo-highlight)::before {\n  content: '|';\n  margin: var(--tr-coveo-result-list-store-author-margin) !important;\n}\n\n.coveo-tr-canada-store-fields {\n  display: grid !important;\n  grid-column-gap: 2.25rem;\n  grid-template-columns: repeat(2, 1fr);\n  padding: var(--tr-coveo-result-list-store-padding-top-bottom);\n}\n\n.coveo-tr-canada-store-fields .coveo-field-label {\n  display: flex;\n  padding: 0.3rem 0;\n}\n\n.coveo-tr-canada-e-store-bold-font {\n  font-weight: 500;\n}\n\n.coveo-canada-store-format__label {\n  padding: 0.3rem 0;\n}\n\n.coveo-tr-canada-e-store-italic-font {\n  font-style: italic;\n  font-weight: 300;\n}\n\n.coveo-canada-store-shortDescription:not(.coveo-new-branding) {\n  font-size: var(--tr-coveo-font-size-xxxs);\n  line-height: var(--tr-coveo-result-list-store-line-height-x);\n}\n\n.coveo-new-branding .coveo-canada-store-shortDescription {\n  font-size: var(--tr-coveo-font-size-xxs);\n  line-height: var(--tr-coveo-new-branding-result-list-line-height-medium);\n}\n\n.product-format {\n  display: flex;\n  flex-direction: row;\n  white-space: nowrap;\n}\n\n@media only screen and (max-width: 47.875rem) {\n  .CoveoFieldValue img,\n  .coveo-tr-image {\n    width: 100%;\n    height: auto;\n    margin: 1rem 0 0 0;\n    padding: 0 1rem 0 0;\n  }\n\n  .coveo-tr-image-chip {\n    left: -0.438rem;\n    bottom: 0.25rem;\n    height: 1.3rem;\n    padding: 0.25rem 0.375rem;\n    font-size: 0.75rem;\n  }\n\n  .coveo-tr-margin-right-3 {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n  .coveo-tr-result-frame.ResultListCanadaStore {\n    flex-direction: row;\n  }\n\n  .coveo-tr-canada-store-fields {\n    display: flex !important;\n    flex-direction: column;\n    padding: 0;\n  }\n  .coveo-canada-store-format {\n    padding-top: 1rem;\n  }\n  .CoveoResultLink {\n    font-size: 16px;\n    font-weight: 400;\n  }\n  .coveo-tr-cell-width {\n    max-width: 100%;\n  }\n}\n\n.tr-personalized-recommendations-container {\n  border-bottom: thin solid #bcc3ca;\n}\n";
styleInject(css_248z$g);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListCanadaStore = function ResultListCanadaStore() {
  var _useSearchResultProps = useSearchResultProps(),
    _useSearchResultProps2 = _useSearchResultProps.resultList,
    _useSearchResultProps3 = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2,
    _useSearchResultProps4 = _useSearchResultProps3.resultListConfig,
    resultListConfig = _useSearchResultProps4 === void 0 ? {} : _useSearchResultProps4,
    resultListDefaultImage = _useSearchResultProps3.resultListDefaultImage,
    resultListDateFormat = _useSearchResultProps3.resultListDateFormat,
    _useSearchResultProps5 = _useSearchResultProps.productRecommendation,
    _useSearchResultProps6 = _useSearchResultProps5 === void 0 ? {} : _useSearchResultProps5,
    _useSearchResultProps7 = _useSearchResultProps6.enablePersonalizedRecommendation,
    enablePersonalizedRecommendation = _useSearchResultProps7 === void 0 ? false : _useSearchResultProps7,
    productRecommendationAnalytics = _useSearchResultProps6.productRecommendationAnalytics;
  var altTag = resultListConfig.altTag,
    author = resultListConfig.author,
    date = resultListConfig.date,
    displayPrice = resultListConfig.displayPrice,
    format = resultListConfig.format,
    imgUrl = resultListConfig.imgUrl,
    price = resultListConfig.price,
    publisher = resultListConfig.publisher,
    shortDescription = resultListConfig.shortDescription,
    status = resultListConfig.status,
    uri = resultListConfig.uri;
  var LOCATION_FRENCH = 'fr-ca';
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_CANADA_STORE);
  var shortDescFieldname = getFieldnameString(shortDescription, 'tr_estore_shortdescription');
  var formatFieldname = getFieldnameString(format, 'tr_estore_productformat');
  var statusFieldname = getFieldnameString(status, 'tr_estore_productstatus');
  var imgUrlFieldname = getFieldnameString(imgUrl, 'tr_estore_imageurl');
  var altTagFieldname = getFieldnameString(altTag, 'tr_estore_imagealttag');
  var priceFieldname = getFieldnameString(price, 'tr_estore_currentprice');
  var dateFieldname = getFieldnameString(date, 'tr_estore_pubdate');
  var displayPriceFieldname = getFieldnameString(displayPrice, 'tr_estore_displayrep');
  var dateFormatToUse = resultListDateFormat || 'yyyy-MM-DD';
  /**
   * extract language from url ie window.location.href
   * @param {string} url
   * @returns {string}
   */
  var extractLanguageFromURL = function extractLanguageFromURL(url) {
    var languageRegex = /\/([a-z]{2}(?:-[a-z]{2})?)\/[^/?#]*?(?:[?#]|$)/;
    var match = url.match(languageRegex);
    return match ? match[1] : 'en';
  };
  window.getResultWithImageAndChip = function (productStatus, img, altTagValue) {
    var mytype = productStatus || '';
    var languageForText = extractLanguageFromURL(window.location.href);
    var chipTypes = {
      NEW: {
        text: languageForText === LOCATION_FRENCH ? BookChipType.FRENCH_NEW : BookChipType.NEW,
        className: 'coveo-tr-new-chip'
      },
      'PRE-SALE': {
        text: languageForText === LOCATION_FRENCH ? BookChipType.FRENCH_PRE_SALE : BookChipType.PRE_SALE,
        className: 'coveo-tr-pre-sale-chip'
      }
    };
    var chipProps = chipTypes[mytype];
    var chipContent = chipProps && React.createElement("div", {
      className: "coveo-tr-image-chip " + chipProps.className
    }, chipProps.text);
    var renderImage = function renderImage(imageSrc, altText) {
      return React.createElement("img", {
        src: imageSrc,
        className: "coveo-tr-image",
        alt: altText
      });
    };
    var defaultImageSrc = img || resultListDefaultImage;
    return ReactDOMServer.renderToString(React.createElement("div", {
      className: "coveo-tr-margin-right-3 position-relative"
    }, renderImage(defaultImageSrc, altTagValue || StoreDefaultImgAlt), chipContent));
  };
  window.getProductPrice = function (value, displayPriceValue, source) {
    var currencySymbol = source != null && source.includes('TR DCP UK Catalog') ? "\xA3" : '$';
    if (displayPriceValue === 'YES') return ReactDOMServer.renderToString(React.createElement("div", null));
    return ReactDOMServer.renderToString(React.createElement("div", {
      className: "CoveoCustomFieldValue coveo-tr-tag-cell"
    }, React.createElement("div", {
      className: "coveo-field-label"
    }, React.createElement("span", {
      className: "coveo-tr-canada-e-store-bold-font"
    }, 'TRStorePrice'.toLocaleString()), React.createElement("span", {
      className: "coveo-tr-canada-e-store-italic-font"
    }, '\xa0' + 'TRStoreStartingAt'.toLocaleString())), React.createElement("span", {
      className: "coveo-tr-canada-e-store-bold-font"
    }, currencySymbol + parseFloat(value).toFixed(2))));
  };
  /**
   * Create CoveoCustomFieldValue basde on fields provided
   *
   * @param {string} url The URL of a product. Clicking on the format field will bring the user to a specific product.
   * @param {string} values Formats in which the product is available. A product can be sold in multiple formats. For example, pdf, softbound book, etc.
   * @returns {string} A component that includes the first format. If there are more products, it will generate a string or array result (depends on the type of value) that contains the total number of remaining formats.
   */
  window.getProductFormats = function (url, values) {
    if (!values.length) return;
    if (typeof values === 'string') values = values.split(',');
    var remainingFormats = values.length - 1;
    return ReactDOMServer.renderToString(React.createElement("a", {
      href: url
    }, React.createElement("div", {
      className: "coveo-tr-canada-e-store-formats"
    }, React.createElement("span", {
      className: "coveo-tr-canada-e-store-formats__main-format"
    }, values[0], remainingFormats ? ", + " + remainingFormats + " " + 'TRNMoreFormat'.toLocaleString() : ''))));
  };
  /**
   * Format short description field with ellipses at the end if the character capacity is more then 350 character
   * @param {string} descriptionText short description fieldname string
   * @param {number} maxLength character capacity
   * @returns {string}
   */
  window.getShortDescriptionFormat = function (descriptionText, maxLength) {
    if (maxLength === void 0) {
      maxLength = 350;
    }
    var displayedText = (descriptionText == null ? void 0 : descriptionText.length) > maxLength ? descriptionText.slice(0, maxLength - 4) + "...." : descriptionText;
    return displayedText;
  };
  window.getDateFormat = function (inputDate, dateFormat) {
    if (dateFormat === void 0) {
      dateFormat = dateFormatToUse;
    }
    if (!inputDate) return '';
    return moment(inputDate).format(dateFormat);
  };
  var _usePersonalizedRecom = usePersonalizedRecommendationComponent({
      enablePersonalizedRecommendation: enablePersonalizedRecommendation,
      productRecommendationAnalytics: productRecommendationAnalytics
    }),
    personalizedContainerProps = _usePersonalizedRecom.personalizedContainerProps,
    personalizedComponent = _usePersonalizedRecom.personalizedComponent;
  return React.createElement(React.Fragment, null, personalizedComponent && createPortal(personalizedComponent.children, personalizedComponent.container), React.createElement("script", {
    className: "result-template coveo-tr-canada-store",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", Object.assign({
    className: "coveo-result-frame coveo-tr-d-flex coveo-tr-result-frame ResultListCanadaStore"
  }, personalizedContainerProps), React.createElement("div", {
    className: "coveo-result-cell coveo-tr-width-1"
  }, "{{=  getResultWithImageAndChip(raw." + statusFieldname + ",raw." + imgUrlFieldname + ", raw." + altTagFieldname + ") }}"), React.createElement("div", {
    className: "coveo-result-cell coveo-tr-cell-width "
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--xs"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@tr_estore_link'
  }))), React.createElement("div", {
    className: "coveo-result-row coveo-tr-d-inline-block coveo-tr-VerticalSpacing--m coveo-tr-product-details"
  }, React.createElement("span", {
    className: "coveo-tr-result-date"
  }, "{{=highlightStreamText(getDateFormat(raw." + dateFieldname + ")) }}"), React.createElement("span", {
    className: "CoveoFieldValue coveo-tr-result-publisher",
    "data-field": publisher ? publisher.field : '@tr_estore_publisher',
    "data-split-values": "true",
    "data-display-separator": " ",
    "data-helper": "highlightStreamText",
    "data-html-value": "true"
  }), React.createElement("span", {
    className: "CoveoFieldValue coveo-tr-result-author",
    "data-field": author ? author.field : '@tr_estore_authors',
    "data-split-values": "true",
    "data-display-separator": " ",
    "data-helper": "highlightStreamText",
    "data-html-value": "true"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--m"
  }, React.createElement("div", {
    className: "coveo-canada-store-shortDescription"
  }, "{{=highlightStreamText(getShortDescriptionFormat(raw." + shortDescFieldname + ")) }}")), React.createElement("div", {
    className: "coveo-result-row coveo-tr-canada-store-fields"
  }, "{{=  getProductPrice(raw." + priceFieldname + ", raw." + displayPriceFieldname + ", raw.source) }}", React.createElement("div", {
    className: "coveo-canada-store-format"
  }, React.createElement("div", {
    className: "coveo-canada-store-format__label coveo-tr-canada-e-store-bold-font"
  }, 'TRStoreFormat'.toLocaleString()), React.createElement("div", {
    className: "coveo-canada-store-format__section"
  }, "{{=getProductFormats(raw.uri, raw." + formatFieldname + ") }}"))))))));
};

var ArticleIcon = function ArticleIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-hidden": "true",
    className: "tr-coveo-file-icon"
  }, React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M40 62V46h16",
    stroke: "#404040",
    "data-cap": "butt"
  }), React.createElement("path", {
    d: "M40 62H8V2h48v44z",
    stroke: "#404040"
  }), React.createElement("path", {
    d: "M20 16h24M20 26h24M20 36h24M20 46h8",
    stroke: "#FF6400",
    "data-color": "color-2"
  })));
};

var PdfIcon = function PdfIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-hidden": "true",
    className: "tr-coveo-file-icon"
  }, React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#404040"
  }, React.createElement("path", {
    d: "M26.9 40.6c0 1-.3 1.8-.9 2.3-.6.5-1.5.8-2.7.8h-.8V47h-2v-9.3h3c1.1 0 2 .2 2.6.7.5.5.8 1.3.8 2.2zm-4.5 1.5h.6c.6 0 1.1-.1 1.4-.4s.5-.6.5-1c0-.5-.1-.8-.4-1-.3-.2-.6-.3-1.2-.3h-.9v2.7zM36.6 42.3c0 1.5-.4 2.7-1.3 3.5-.9.8-2.1 1.2-3.8 1.2h-2.6v-9.3h2.9c1.5 0 2.7.4 3.5 1.2.9.8 1.3 1.9 1.3 3.4zm-2.1 0c0-2-.9-3-2.6-3h-1v6h.8c1.9.1 2.8-.9 2.8-3zM40.7 47h-1.9v-9.3h5.3v1.6h-3.4v2.4h3.1v1.6h-3.1V47z",
    fill: "#FF6400",
    "data-color": "color-2",
    "data-stroke": "none"
  }), React.createElement("path", {
    d: "M40 2v16h16",
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeWidth: "2",
    "data-cap": "butt"
  }), React.createElement("path", {
    d: "M56 32V18L40 2H8v30M8 53v9h48v-9",
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M61 32H3M8 27l-5 5v21h58V32l-5-5",
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeWidth: "2",
    "data-cap": "butt"
  })));
};

var PlayerIcon = function PlayerIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-hidden": "true",
    className: "tr-coveo-file-icon"
  }, React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M16 57h32",
    stroke: "#FF6400",
    "data-color": "color-2"
  }), React.createElement("path", {
    d: "M2 7h60v42H2z",
    stroke: "#404040"
  }), React.createElement("path", {
    d: "M28 20l12 8-12 8z",
    stroke: "#FF6400",
    "data-color": "color-2"
  })));
};

var css_248z$h = ".tr-coveo-file-icon {\n  margin-right: 0.563rem;\n  width: 1.125rem;\n}\n\n.coveo-tr-format-row {\n  display: flex !important;\n}\n\n.coveo-tr-internal-use {\n  color: rgb(220, 10, 10);\n  font-size: var(--tr-coveo-searchresult-font-size);\n  font-weight: var(--tr-coveo-font-weight-black);\n  line-height: var(--tr-coveo-searchresultline-height);\n}\n\n.coveo-tr-file-type .coveo-accessible-button {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-weight: var(--tr-coveo-font-weight-black);\n  pointer-events: none;\n}\n\n.coveo-tr-format {\n  font-weight: var(--tr-coveo-header-font-weight);\n  margin-right: 0.5rem;\n}\n\n.coveo-tr-font-size-normal {\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n}\n";
styleInject(css_248z$h);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListHelpAndSupport = function ResultListHelpAndSupport() {
  var resultListConfig = useSearchResultProps().resultList.resultListConfig;
  var uri = resultListConfig == null ? void 0 : resultListConfig.uri;
  var videoLength = resultListConfig == null ? void 0 : resultListConfig.videoLength;
  var fileSize = resultListConfig == null ? void 0 : resultListConfig.fileSize;
  var readTime = resultListConfig == null ? void 0 : resultListConfig.readTime;
  var fileFormat = resultListConfig == null ? void 0 : resultListConfig.fileFormat;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_HELP_AND_SUPPORT);
  /**
   * This getInternalAgentType function Renders an internal use only message based on the value of the 'internalOnly' parameter.
   *
   * @param {string} internalOnly - Determines whether the message should be displayed or not. Must be either "Yes" or "No".
   * @returns {string} The internal use only message if 'internalOnly' is "Yes", or an empty string otherwise.
   */
  window.getInternalAgentType = function (internalOnly) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, internalOnly === 'Yes' && React.createElement("span", {
      className: "coveo-tr-internal-use"
    }, "Internal use only")));
  };
  window.getFormatIcons = function (format) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, format == null ? void 0 : format.map(function (el) {
      return React.createElement(React.Fragment, {
        key: el
      }, React.createElement("span", {
        className: "coveo-tr-margin-right-2"
      }, 'TRStoreFormat'.toLocaleString(), ":"), React.createElement("div", null, el.toLocaleUpperCase() === FormatEnum.ARTICLE && React.createElement(ArticleIcon, null), el.toLocaleUpperCase() === FormatEnum.PDF && React.createElement(PdfIcon, null), el.toLocaleUpperCase() === FormatEnum.VIDEO && React.createElement(PlayerIcon, null)));
    })));
  };
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame"
  }, React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, '{{=  getInternalAgentType(raw.tr_internalonly) }}'), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row coveo-tr-format-row"
  }, '{{=  getFormatIcons(raw.tr_format) }}', React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-format",
    "data-field": fileFormat ? fileFormat.field : '@tr_format'
  }), React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": videoLength ? videoLength.field : '@tr_videolength'
  }), React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": fileSize ? fileSize.field : '@tr_filesize'
  }), React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": readTime ? readTime.field : '@tr_readtime'
  })), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "CoveoExcerpt coveo-tr-font-size-normal"
  }))))))));
};

var VideoIcon = function VideoIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "53",
    viewBox: "0 0 42 55",
    fill: "none"
  }, React.createElement("path", {
    d: "M41.15 16.1487C41.1523 15.8391 41.0309 15.5415 40.8127 15.3186L40.8122 15.318L26.8678 1.20835L26.8674 1.20792C26.7543 1.09448 26.6193 1.00449 26.4704 0.943087C26.3214 0.881689 26.1615 0.850069 26 0.85H26L5.21666 0.85C4.06181 0.849996 2.95331 1.29595 2.13444 2.09128C1.31545 2.88674 0.853053 3.96689 0.85 5.09508V5.09549L0.849999 50.2324L0.850001 50.2328C0.85305 51.3615 1.31524 52.4422 2.13403 53.2385C2.9527 54.0347 4.06113 54.4819 5.21647 54.4833H5.21666L36.7833 54.4833H36.7835C37.9388 54.4819 39.0473 54.0347 39.8659 53.2385C40.6847 52.4422 41.1469 51.3615 41.15 50.2328V50.2324V16.1487ZM41.15 16.1487C41.15 16.149 41.15 16.1494 41.15 16.1497L41 16.1484M41.15 16.1487V16.1484H41M41 16.1484V50.2324L40.7055 15.4235C40.8966 15.6187 41.0022 15.8787 41 16.1484ZM38.1696 51.575C38.5367 51.2185 38.7429 50.7356 38.7444 50.2324C38.7444 50.2323 38.7444 50.2322 38.7444 50.232M38.1696 51.575L38.8944 50.2324L38.7444 50.232M38.1696 51.575C37.8023 51.9318 37.3038 52.1329 36.7833 52.1329L5.21666 52.1329C4.69618 52.1329 4.1977 51.9318 3.83035 51.575C3.4632 51.2184 3.25698 50.7355 3.25555 50.2323L3.25555 5.09587C3.25839 4.59359 3.4652 4.11199 3.83217 3.75651C4.19937 3.40079 4.69707 3.20044 5.21666 3.20045L24.0055 3.20045V16.3757C24.0055 16.6894 24.1335 16.9894 24.3601 17.21C24.5864 17.4304 24.8926 17.5536 25.2111 17.5536L38.7444 17.5536M38.1696 51.575L38.7444 17.5536M38.7444 50.232L38.7444 17.5536M38.7444 50.232L38.7444 17.5536M37.3519 15.2031L26.4111 15.2031V4.13511L37.3519 15.2031Z",
    fill: "#010101",
    stroke: "black",
    "stroke-width": "0.3"
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.3125 21.5482L28.086 30.8671L13.3125 40.186L13.3125 21.5482Z",
    stroke: "#FA6400",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }));
};

var PDFIcon2 = function PDFIcon2() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "53",
    viewBox: "0 0 40 53",
    fill: "none"
  }, React.createElement("path", {
    d: "M39.7055 14.3075L25.7611 0.311265C25.6622 0.212837 25.5439 0.134572 25.4132 0.0811059C25.2825 0.02764 25.1419 6.0266e-05 25 0L4.21666 0C3.10026 -3.74406e-06 2.02941 0.427671 1.23895 1.18924C0.448494 1.95081 0.00294178 2.98411 0 4.06255L0 48.8365C0.0029383 49.9154 0.448313 50.9493 1.23861 51.7117C2.02891 52.4741 3.09975 52.903 4.21666 52.9044H35.7833C36.9002 52.903 37.9711 52.4741 38.7614 51.7117C39.5517 50.9493 39.997 49.9154 40 48.8365V15.0266C40.0022 14.7591 39.8966 14.5012 39.7055 14.3075ZM25.2611 2.74772L36.7111 14.2377H25.2611V2.74772ZM37.8944 48.8365C37.8929 49.3764 37.6699 49.8937 37.2741 50.275C36.8784 50.6563 36.3422 50.8704 35.7833 50.8704H4.21666C3.65772 50.8704 3.12159 50.6563 2.72584 50.275C2.33009 49.8937 2.10702 49.3764 2.10555 48.8365V4.06255C2.10849 3.52355 2.33221 3.00759 2.7278 2.62746C3.12339 2.24733 3.65868 2.03395 4.21666 2.03396H23.1555V15.252C23.1555 15.5224 23.2667 15.7818 23.4647 15.973C23.6627 16.1642 23.9311 16.2717 24.2111 16.2717H37.8944V48.8365Z",
    fill: "#1F1F1F"
  }), React.createElement("path", {
    d: "M15.0989 31.3196C14.7989 32.2266 14.5433 33.0906 14.26 33.901C13.8933 35.0387 13.56 36.0476 13.2322 37.0082C7.60444 40.0941 5.35444 42.7667 5.22111 44.4142C5.17859 44.7223 5.2251 45.0357 5.35551 45.3199C5.48591 45.604 5.69512 45.8478 5.96 46.0242C6.30701 46.2458 6.71645 46.3582 7.13222 46.3462C7.85626 46.3221 8.56504 46.1386 9.20444 45.8095C12.2211 44.2908 13.6767 41.8597 14.9544 38.4089C16.0378 37.8401 17.26 37.239 18.6489 36.6218C20.4488 35.7964 22.3306 35.1491 24.2655 34.6899C26.0766 36.5252 27.9878 37.7327 29.7878 37.7327C31.7378 37.7327 33.1211 37.1102 33.5655 36.0208C33.7211 35.6051 33.74 35.1531 33.6197 34.7267C33.4994 34.3002 33.2457 33.92 32.8933 33.638C31.8211 32.6559 29.91 32.1514 27.5266 32.2158C26.686 32.2418 25.8485 32.3279 25.0211 32.4734C22.8957 29.9058 21.1442 27.0691 19.8155 24.0424C21.1433 19.9047 21.6267 17.2053 20.4155 15.9334C20.2138 15.7236 19.9685 15.5573 19.6957 15.4454C19.4228 15.3335 19.1286 15.2785 18.8322 15.2841C18.5341 15.2815 18.237 15.3176 17.9489 15.3914C17.1267 15.59 15.7989 16.3681 16.1767 19.3413C16.4408 20.9934 16.9128 22.6082 17.5822 24.1498C17.1878 25.3519 16.7433 26.6077 16.31 27.842C15.8767 29.0763 15.4767 30.1872 15.0989 31.3196ZM8.26 43.9419C7.99277 44.0787 7.70916 44.1832 7.41555 44.2532C7.73778 43.5663 8.92111 42.1066 11.9433 40.1585C11.2065 41.7938 9.90454 43.1312 8.26 43.9419V43.9419ZM27.7044 34.2498C28.8127 34.1803 29.9223 34.3642 30.9433 34.7865C31.2165 34.8963 31.4489 35.0834 31.61 35.3231C31.4989 35.4412 31.0044 35.731 29.8044 35.731C28.9044 35.731 27.8933 35.1943 26.8433 34.3196C27.1322 34.2659 27.4211 34.2498 27.6878 34.2498H27.7044ZM18.46 17.3663C18.576 17.3364 18.6954 17.3202 18.8155 17.318H18.8878C18.9267 17.361 19.31 17.903 18.6155 20.699C18.4701 20.1695 18.3588 19.6318 18.2822 19.089C18.11 17.8708 18.3322 17.3932 18.46 17.3663ZM18.3322 28.4753L18.8878 26.8653C19.9729 29.0129 21.2755 31.0515 22.7767 32.9511C21.0635 33.4219 19.3916 34.023 17.7767 34.7489C17.1267 35.0387 16.5044 35.3285 15.9155 35.6129C16.0322 35.2426 16.1544 34.867 16.2822 34.4806C16.5378 33.6756 16.8118 32.8294 17.1044 31.9421C17.4767 30.8259 17.8933 29.6291 18.3322 28.4753Z",
    fill: "#FA6400"
  }));
};

var css_248z$i = ":root {\n  --tr-coveo-product-training-list-grid-column-gap: 6.25rem;\n  --tr-coveo-product-training-list-grid-row-gap: 3.75rem;\n}\n\n.coveo-tr-product-training-wrapper {\n  border: 0.063rem solid rgb(143, 143, 143) !important;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-width: 20.5rem;\n  text-decoration: none !important;\n}\n\n.coveo-tr-product-training-wrapper:hover {\n  box-shadow: 0 0 0 0.25rem rgb(31, 31, 31);\n}\n\n.coveo-tr-product-training-with-facet + .coveo-list-layout-container {\n  /* stylelint-disable */\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));\n  grid-column-gap: var(--tr-coveo-product-training-list-grid-column-gap);\n  grid-row-gap: var(--tr-coveo-product-training-list-grid-row-gap);\n}\n\n.coveo-tr-product-training-with-facet + .coveo-list-layout-container .coveo-list-layout.CoveoResult {\n  padding: 1.063rem 0 1rem 3.371rem;\n  border-bottom: none;\n}\n\n.coveo-tr-product-training-type {\n  padding: 2.75rem;\n  background-color: rgb(227, 227, 227);\n  margin: 0 !important;\n}\n\n.coveo-tr-product-training-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 2.75rem;\n  background-color: rgb(244, 244, 244);\n  height: 100%;\n}\n\n.coveo-tr-product-training-title {\n  font-size: 1.75rem !important;\n  font-weight: var(--tr-coveo-font-weight-black);\n  color: rgb(31, 31, 31);\n  line-height: 2.125rem;\n}\n\n.coveo-tr-card-time-category {\n  font-size: var(--tr-coveo-font-size-xxxs);\n  color: rgb(102, 102, 102);\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.coveo-tr-category-margin-bottom {\n  margin-bottom: 2.063rem !important;\n}\n\n.coveo-tr-card-time-tag {\n  font-size: 1.125rem !important;\n  color: rgb(102, 102, 102);\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.coveo-tr-product-training-duration {\n  align-items: center;\n  display: flex;\n  color: rgb(31, 31, 31);\n}\n\n.coveo-tr-product-training-duration .tr-coveo-clock-icon {\n  width: 1.375rem;\n  height: 1.375rem;\n}\n\n.coveo-tr-product-training-icon-caption {\n  color: rgb(31, 31, 31);\n}\n\n.coveo-tr-product-training + .coveo-result-list-container .coveo-list-layout {\n  padding: 0 !important;\n}\n\n.coveo-tr-product-training + .coveo-result-list-container {\n  max-width: 47.25rem;\n  margin-left: 0.938rem;\n}\n\n.coveo-tr-product-training-card-footer {\n  margin-top: auto;\n}\n\n@media only screen and (max-width: 72.75rem) {\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container {\n    grid-column-gap: 3.25rem;\n  }\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container .coveo-list-layout.CoveoResult {\n    padding: 0 1.25rem;\n  }\n}\n\n@media only screen and (max-width: 60rem) {\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container {\n    grid-column-gap: 0.625rem;\n  }\n}\n\n@media only screen and (max-width: 41.75rem) {\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container {\n    grid-column-gap: 0.625rem;\n  }\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container .coveo-list-layout.CoveoResult {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 35rem) {\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container {\n    grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container .coveo-list-layout.CoveoResult {\n    padding: 0 1.25rem;\n  }\n\n  .coveo-tr-product-training-wrapper {\n    width: 20.5rem;\n  }\n\n  .coveo-tr-product-training-with-facet + .coveo-list-layout-container {\n    margin: 0;\n  }\n}\n";
styleInject(css_248z$i);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListProductTraining = function ResultListProductTraining() {
  var _useSearchResultProps3;
  var _useSearchResultProps = (_useSearchResultProps3 = useSearchResultProps()) == null ? void 0 : _useSearchResultProps3.resultList,
    facetIsEnable = _useSearchResultProps.facetIsEnable,
    _useSearchResultProps2 = _useSearchResultProps.resultListConfig,
    resultListConfig = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2;
  var ptTitle = resultListConfig.ptTitle,
    ptCategory = resultListConfig.ptCategory,
    ptPrimaryTag = resultListConfig.ptPrimaryTag,
    ptDurration = resultListConfig.ptDurration;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_PRODUCT_TRAINING);
  window.getProductTrainingTypeIcon = function (type) {
    switch (type) {
      case ProductTrainingFormatEnum.VIDEO:
        return ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
          className: "coveo-tr-product-training-icon"
        }, React.createElement(VideoIcon, null), React.createElement("p", {
          className: "coveo-tr-product-training-icon-caption"
        }, "VIDEO")));
      case ProductTrainingFormatEnum.PDF:
        return ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
          className: "coveo-tr-product-training-icon"
        }, React.createElement(PDFIcon2, null), React.createElement("p", {
          className: "coveo-tr-product-training-icon-caption"
        }, "USER GUIDE PDF")));
      default:
        return;
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-tr-product-training " + (facetIsEnable ? 'coveo-tr-product-training-with-facet' : ''),
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame coveo-tr-product-training-card"
  }, React.createElement("a", {
    className: "CoveoResultLink coveo-tr-product-training-wrapper",
    href: '{{= raw.tr_pt_link}}',
    target: "_blank",
    rel: "noreferrer"
  }, React.createElement("div", null, React.createElement("span", {
    className: "tr-coveo-SearchResults-resultEyebrow coveo-tr-product-training-type"
  }, '{{= getProductTrainingTypeIcon(raw.tr_pt_type) }}')), React.createElement("div", {
    className: "coveo-tr-product-training-content-wrapper"
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-category-margin-bottom"
  }, React.createElement("h3", null, ptTitle && React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-product-training-title",
    "data-field": ptTitle.field || '@tr_pt_title'
  }))), React.createElement("div", {
    className: "coveo-tr-product-training-card-footer"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, ptCategory && React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-card-time-category",
    "data-field": ptCategory.field || '@tr_pt_primarycategory'
  }), ptPrimaryTag && React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-card-time-tag",
    "data-field": ptPrimaryTag.field || '@tr_pt_primarytag'
  })), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "coveo-result-row d-flex"
  }, ptDurration && React.createElement("time", {
    className: "coveo-tr-product-training-duration"
  }, React.createElement(ClockIcon, null), React.createElement("div", {
    className: "CoveoFieldValue tr-coveo-margin-right-xs",
    "data-html-value": "true",
    "data-field": ptDurration.field || '@tr_pt_durration'
  })))))))))));
};

var css_248z$j = ".coveo-tr-legal-scoped-card-caption {\n  padding-left: 2.2rem;\n  padding-top: 0 !important;\n  text-transform: uppercase;\n}\n\n.coveo-tr-legal-scoped-image-box {\n  margin-bottom: 3rem;\n}\n\n.coveo-tr-card-content-wrapper {\n  padding-bottom: 2.25rem;\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n\n.coveo-tr-legal-cards-scoped .CoveoResultLink {\n  /* Unsetting the font size since size is set for all other templates */\n  font-size: var(--tr-coveo-unset);\n}\n\n.coveo-tr-card-date {\n  font-weight: var(--tr-coveo-font-weight-regular) !important;\n}\n";
styleInject(css_248z$j);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListLegalScopedCard = function ResultListLegalScopedCard() {
  var _useSearchResultProps2;
  var _useSearchResultProps = (_useSearchResultProps2 = useSearchResultProps()) == null ? void 0 : _useSearchResultProps2.resultList,
    facetIsEnable = _useSearchResultProps.facetIsEnable;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_LEGAL_SCOPED_CARD);
  window.getResultImgContent = function (img) {
    if (img) {
      return "<div className=\"coveo-tr-card-image\">\n            <div class=\"coveo-tr-legal-card-image-wrapper\">\n            <img\n              src=" + img + "\n              alt=\"noImage\"\n            />\n        </div>\n        </div>";
    } else {
      return "";
    }
  };
  window.getLegalBlogDate = function (date) {
    return date ? dateFormatToString(date) : null;
  };
  window.getReadTime = function (wreadTime) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, wreadTime && React.createElement("time", {
      className: "tr-coveo-duration"
    }, React.createElement(ClockIcon, null), React.createElement("div", {
      className: "CoveoFieldValue tr-coveo-margin-right-xs",
      "data-html-value": "true",
      "data-field": "@tr_wreadtime"
    }), React.createElement("span", null, 'TRMin'.toLocaleString()))));
  };
  window.getPageType = getPageType;
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template coveo-tr-legal-cards " + (facetIsEnable ? 'coveo-tr-legal-cards-with-facet' : ''),
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame coveo-tr-legal-cards-scoped"
  }, React.createElement("a", {
    className: "CoveoResultLink coveo-tr-legal-card-wrapper",
    href: '{{= raw.uri}}',
    target: "_self",
    rel: "noreferrer"
  }, React.createElement("div", {
    className: "coveo-tr-legal-scoped-image-box"
  }, '{{=  getResultImgContent(raw.tr_wthumbnailimage) }}'), React.createElement("div", null, React.createElement("span", {
    className: "tr-coveo-SearchResults-resultEyebrow coveo-tr-card-caption coveo-tr-legal-scoped-card-caption"
  }, '{{= getPageType(raw.tr_wpagetype) }}')), React.createElement("div", {
    className: "coveo-tr-card-content-wrapper"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-card-title",
    "data-field": "@title"
  }))), React.createElement("div", {
    className: "coveo-result-row coveo-tr-card-time-content"
  }, React.createElement("span", {
    className: "coveo-tr-card-date"
  }, '{{= getLegalBlogDate(raw.tr_wpublishedtime) }}'), React.createElement("div", {
    className: "coveo-result-row d-flex"
  }, '{{= getReadTime(raw.tr_wreadtime) }}'))))))));
};

var css_248z$k = ".coveo-tr-field {\n  margin-bottom: 0.313rem;\n}\n\n.coveo-tr-field p,\n.coveo-tr-field span {\n  display: inline;\n}\n\n.coveo-tr-field span {\n  font-weight: var(--tr-coveo-font-weight-bold);\n}\n\n.coveo-tr-field p {\n  color: var(--tr-coveo-color-tr-blue-dark);\n}\n\n.coveo-tr-margin-bottom-15 {\n  margin-bottom: 0.938rem !important;\n}\n\n.coveo-tr-color-default {\n  color: var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-tr-bold {\n  font-weight: var(--tr-coveo-font-weight-bold);\n}\n\n.coveo-tr-color-green {\n  color: rgb(56, 124, 0) !important;\n}\n\n.coveo-tr-font-weight-normal,\n.coveo-tr-font-weight-normal span {\n  font-weight: var(--tr-coveo-font-weight-regular) !important;\n}\n\n.coveo-tr-field-link,\n.coveo-tr-field-link:visited {\n  color: rgb(0, 89, 179) !important;\n}\n\n@media only screen and (max-width: 47.875rem) {\n  .coveo-tr-estore-frame {\n    align-items: center;\n  }\n}\n";
styleInject(css_248z$k);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListInternationalStore = function ResultListInternationalStore() {
  var _useSearchResultProps = useSearchResultProps().resultList,
    resultListDefaultImage = _useSearchResultProps.resultListDefaultImage,
    resultListConfig = _useSearchResultProps.resultListConfig;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_INTERNATIONAL_STORE);
  var eStoreProduct = resultListConfig == null ? void 0 : resultListConfig.eStoreProduct;
  var eStoreAuthor = resultListConfig == null ? void 0 : resultListConfig.eStoreAuthor;
  var eStoreDate = resultListConfig == null ? void 0 : resultListConfig.eStoreDate;
  var excerpt = resultListConfig == null ? void 0 : resultListConfig.excerpt;
  var eStoreDesc = resultListConfig == null ? void 0 : resultListConfig.eStoreDesc;
  window.getCoveoFieldValue = function (jsonObj) {
    var data = JSON.parse(jsonObj);
    var fieldValues = [];
    for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      fieldValues.push({
        author: key,
        url: value
      });
    }
    return ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, fieldValues.map(function (_ref, index) {
      var author = _ref.author,
        url = _ref.url;
      return React.createElement(React.Fragment, null, React.createElement("a", {
        key: url,
        href: url,
        target: "_blank",
        className: "coveo-tr-font-weight-normal coveo-tr-field-link",
        "aria-label": author,
        title: author,
        rel: "noreferrer"
      }, author), fieldValues.length - 1 === index ? null : React.createElement("span", {
        className: "coveo-tr-font-weight-normal coveo-tr-field-link"
      }, ",", ' '));
    })));
  };
  window.getCoveoPublishDate = function (date) {
    return date ? dateFormatToString(date, DateFormatEnum.WITH_SLASH) : null;
  };
  window.getResultImgContent = function (img) {
    if (img) {
      return "<div class=\"coveo-tr-margin-right-3\">\n            <img\n              src=" + img + "\n              class=\"coveo-tr-image\"\n              alt=\"noImage\"\n            />\n        </div>";
    } else {
      return "<div\n              class=\"coveo-tr-margin-right-3\"\n              ><img\n              class=\"coveo-tr-image\"\n              src=" + resultListDefaultImage + "\n              alt=\"tr-logo\"\n            ></div>";
    }
  };
  return React.createElement("script", {
    className: "result-template coveo-tr-international-store",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame coveo-tr-d-flex coveo-tr-result-frame coveo-tr-estore-frame"
  }, React.createElement("div", {
    className: "coveo-result-cell coveo-tr-width-1"
  }, '{{=  getResultImgContent(raw.tr_usstore_productimageurl) }}'), React.createElement("div", {
    className: "coveo-result-cell coveo-tr-cell-width "
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--xs"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": eStoreProduct ? eStoreProduct.value : 'product',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": eStoreProduct ? eStoreProduct.field : '@tr_usstore_productname'
  }))), React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--xs  coveo-tr-margin-bottom-15"
  }, React.createElement("div", {
    className: "coveo-tr-field"
  }, eStoreAuthor && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'Author'.toLocaleString(), ":", ' '), '{{= getCoveoFieldValue(raw.tr_usstore_temp_authorstolinks) }}')), React.createElement("div", {
    className: "coveo-tr-field"
  }, eStoreAuthor && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'TRDirector'.toLocaleString(), ":", ' '), '{{= getCoveoFieldValue(raw.tr_usstore_temp_authorstolinks) }}')), React.createElement("div", {
    className: "coveo-tr-field"
  }, eStoreAuthor && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'TRCoordinator'.toLocaleString(), ":", ' '), '{{= getCoveoFieldValue(raw.tr_usstore_temp_authorstolinks) }}'))), React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--xs  coveo-tr-margin-bottom-15"
  }, eStoreDate && React.createElement("div", {
    className: "coveo-tr-field"
  }, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'TREdition'.toLocaleString(), ":", ' '), '{{= getCoveoPublishDate(raw.tr_usstore_releasedate) }}'), excerpt ? React.createElement("div", {
    className: "CoveoExcerpt"
  }) : React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": eStoreDesc ? eStoreDesc.field : '@tr_usstore_description',
    "data-helper": "highlightStreamText",
    "data-html-value": "true"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-tr-VerticalSpacing--xs"
  }, React.createElement("div", {
    className: "coveo-tr-field"
  }, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'TREbook'.toLocaleString(), ":", ' '), React.createElement("p", {
    className: "coveo-tr-color-default coveo-tr-bold"
  }, "180,00\u20AC ", React.createElement("p", {
    className: "coveo-tr-color-default"
  }, "was 200.00\u20AC "), React.createElement("p", {
    className: "coveo-tr-color-green coveo-tr-bold"
  }, "20,00\u20AC savings"))), React.createElement("div", {
    className: "coveo-tr-field"
  }, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'TRHardboundBook'.toLocaleString(), ":", ' '), React.createElement("p", {
    className: "coveo-tr-color-default coveo-tr-bold"
  }, "200,00\u20AC")), React.createElement("div", {
    className: "coveo-tr-field"
  }, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'TRCdRom'.toLocaleString(), ":", ' '), React.createElement("p", {
    className: "coveo-tr-color-default coveo-tr-bold"
  }, "200,00\u20AC")), React.createElement("div", {
    className: "coveo-tr-field"
  }, React.createElement("span", {
    className: "coveo-tr-field-name"
  }, 'TRSoftboundBook'.toLocaleString(), ":", ' '), React.createElement("p", {
    className: "coveo-tr-color-default coveo-tr-bold"
  }, "200,00\u20AC")))))));
};

var css_248z$l = ".tr-coveo-legal-scoped-right-image-wrapper {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.tr-coveo-legal-scoped-right-image-wrapper object,\n.tr-coveo-legal-scoped-right-image-wrapper img {\n  height: 12.75rem;\n  margin-left: 4.5rem;\n  width: 22.75rem;\n}\n\n.tr-coveo-legal-scoped-right-image-wrapper .tr-coveo-duration {\n  margin: var(--tr-coveo-0);\n}\n\n@media only screen and (max-width: 48rem) {\n  .tr-coveo-legal-scoped-right-image-wrapper img {\n    display: none;\n  }\n}\n";
styleInject(css_248z$l);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListLegalScopedRightImage = function ResultListLegalScopedRightImage() {
  var _useSearchResultProps2;
  var _useSearchResultProps = (_useSearchResultProps2 = useSearchResultProps()) == null ? void 0 : _useSearchResultProps2.resultList,
    resultListConfig = _useSearchResultProps.resultListConfig;
  var uri = resultListConfig == null ? void 0 : resultListConfig.uri;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_LEGAL_SCOPED_RIGHT_IMAGE);
  window.getResultImgContent = function (img) {
    if (img) {
      return "\n            <img\n              src=" + img + "\n              alt=\"noImage\"\n            />\n        ";
    } else {
      return "";
    }
  };
  window.getReadTime = function (wreadTime) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, wreadTime && React.createElement("time", {
      className: "tr-coveo-duration"
    }, React.createElement(ClockIcon, null), React.createElement("div", {
      className: "CoveoFieldValue tr-coveo-margin-right-xs",
      "data-html-value": "true",
      "data-field": "@tr_wreadtime"
    }), React.createElement("span", null, 'TRMin'.toLocaleString()))));
  };
  window.getLegalBlogDate = function (date) {
    return date ? dateFormatToString(date) : null;
  };
  window.getPageType = getPageType;
  return React.createElement(React.Fragment, null, React.createElement("script", {
    className: "result-template",
    type: "text/underscore"
  }, ReactDOMServer.renderToStaticMarkup(React.createElement("div", {
    className: "coveo-result-frame  tr-coveo-legal-templates"
  }, React.createElement("div", {
    className: "tr-coveo-legal-scoped-right-image-wrapper"
  }, React.createElement("div", null, React.createElement("span", {
    className: "tr-coveo-SearchResults-resultEyebrow"
  }, '{{= getPageType(raw.tr_wpagetype) }}'), React.createElement("div", {
    className: "coveo-result-cell"
  }, React.createElement("div", {
    className: "coveo-result-row tr-coveo-margin-bottom-x"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100% ",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "CoveoExcerpt"
  })), React.createElement("div", {
    className: "coveo-result-row coveo-tr-card-time-content"
  }, React.createElement("span", {
    className: "coveo-tr-card-date"
  }, '{{= getLegalBlogDate(raw.tr_wpublishedtime) }}'), React.createElement("div", {
    className: "coveo-result-row d-flex"
  }, '{{= getReadTime(raw.tr_wreadtime) }}')))), React.createElement("div", null, '{{=  getResultImgContent(raw.tr_wthumbnailimage) }}'))))));
};

var ArticleIconBold = function ArticleIconBold() {
  return React.createElement("svg", {
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M12.5 18.1953V13.6953H17L12.5 18.1953Z",
    fill: "#404040"
  }), React.createElement("path", {
    d: "M12.5 18.1953V13.6953H17",
    stroke: "#404040",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.5 18.1953H2V1.69531H17V13.6953L12.5 18.1953Z",
    stroke: "#404040",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React.createElement("path", {
    d: "M5.75 5.44531H13.25",
    stroke: "#FA6400",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React.createElement("path", {
    d: "M5.75 9.19531H13.25",
    stroke: "#FA6400",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React.createElement("path", {
    d: "M5.75 12.9453H8.75",
    stroke: "#FA6400",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }));
};

var css_248z$m = ".ResultListHelpAndSupportSearch .tr-coveo-file-icon {\n  margin-right: 0.563rem;\n  width: 1.125rem;\n}\n\n.coveo-result-frame.ResultListHelpAndSupportSearch {\n  display: flex !important;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.coveo-result-frame.ResultListHelpAndSupportSearch .coveo-result-row {\n  height: 100%;\n  margin: var(--tr-coveo-0) !important;\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-internal-use {\n  background-color: var(--color-status-error-subtle, var(--tr-help-and-support-internal-use-badge-background-color));\n  border: 1px solid var(--color-status-error-strong, var(--tr-help-and-support-internal-use-badge-color));\n  border-radius: 4px;\n  color: var(--tr-help-and-support-internal-use-badge-color) !important;\n  font-size: var(--tr-coveo-font-size-xxxs);\n  font-weight: var(--tr-coveo-font-weight-bold);\n  padding: var(--tr-help-and-support-badge-padding);\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-signup-required {\n  background-color: var(--color-status-error-subtle, var(--tr-help-and-support-signup-required-badge-background-color));\n  border-radius: 4px;\n  color: var(--tr-help-and-support-signup-required-color) !important;\n  display: inline-flex;\n  font-size: var(--tr-coveo-font-size-xxxs);\n  font-weight: var(--tr-coveo-font-weight-bold);\n  gap: 5px;\n  padding: var(--tr-help-and-support-badge-padding);\n  place-items: center;\n}\n\n.ResultListHelpAndSupportSearch .CoveoResultLink {\n  font-weight: var(--tr-coveo-font-weight-medium) !important;\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-file-type .coveo-accessible-button {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-weight: var(--tr-coveo-font-weight-black);\n  pointer-events: none;\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-format {\n  font-weight: var(--tr-coveo-header-font-weight);\n  margin-right: 0.5rem;\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-font-size-normal {\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n}\n\n.ResultListHelpAndSupportSearch .CoveoFieldValue > *,\n.ResultListHelpAndSupportSearch .coveo-tr-tag-cell {\n  font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-tag-cell > * {\n  white-space: nowrap;\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-tag-row {\n  display: flex !important;\n  flex-wrap: wrap;\n  gap: 10px;\n  row-gap: 5px;\n}\n\n@media only screen and (max-width: 390px) {\n  .ResultListHelpAndSupportSearch .coveo-tr-tag-row {\n    flex-direction: column;\n  }\n}\n\n.ResultListHelpAndSupportSearch .coveo-field-label {\n  font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-format-row,\n.ResultListHelpAndSupportSearch .coveo-tr-tag-cell {\n  display: flex;\n  gap: 5px;\n  place-items: center;\n}\n\n.ResultListHelpAndSupportSearch .CoveoCustomFieldValue {\n  place-items: start;\n}\n\n.ResultListHelpAndSupportSearch .coveo-tr-tag-row .coveo-tr-format-row {\n  margin: var(--tr-coveo-0) !important;\n}\n\n.ResultListHelpAndSupportSearch .CoveoFieldValue > span,\n.ResultListHelpAndSupportSearch .CoveoCustomFieldValue > span {\n  font-weight: var(--tr-coveo-font-weight-bold);\n  white-space: normal;\n}\n\n.ResultListHelpAndSupportSearch .CoveoFieldValue.coveo-tr-help-and-support-readtime > span {\n  font-weight: var(--tr-coveo-normal) !important;\n}\n";
styleInject(css_248z$m);

/* eslint-disable jsx-a11y/anchor-is-valid */
var ResultListHelpAndSupportSearch = function ResultListHelpAndSupportSearch(props) {
  var _readTime$field;
  var _useSearchResultProps = useSearchResultProps().resultList.resultListConfig,
    resultListConfig = _useSearchResultProps === void 0 ? {} : _useSearchResultProps;
  // Creates Custom Component Props to store additional properties
  // if they have been provided
  var customComponentProps = {};
  if (props != null && props.condition) {
    customComponentProps['data-condition'] = props.condition;
  }
  var uri = resultListConfig.uri,
    fileSize = resultListConfig.fileSize,
    readTime = resultListConfig.readTime,
    fileFormat = resultListConfig.fileFormat;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_HELP_AND_SUPPORT);
  window.getFormatIcons = function (format) {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, format == null ? void 0 : format.map(function (el) {
      return React.createElement(React.Fragment, {
        key: el
      }, React.createElement("span", {
        className: "coveo-field-label"
      }, 'TRStoreFormat'.toLocaleString(), ":"), React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, el.toLocaleUpperCase() === FormatEnum.ARTICLE && React.createElement(ArticleIconBold, null), el.toLocaleUpperCase() === FormatEnum.PDF && React.createElement(PdfIcon, null)));
    })));
  };
  window.getInternalAgentType = function (internalUse) {
    if (internalUse === 'Yes') {
      return ReactDOMServer.renderToString(React.createElement("div", {
        className: "coveo-result-row"
      }, React.createElement("span", {
        className: "coveo-tr-internal-use"
      }, "Internal use only")));
    }
    return '';
  };
  window.getGatedContent = function (value) {
    if (value === 'Yes') {
      return ReactDOMServer.renderToString(React.createElement("div", {
        className: "coveo-result-row"
      }, React.createElement("span", {
        className: "coveo-tr-signup-required"
      }, React.createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, React.createElement("path", {
        d: "M8 8C6.5625 8 5.25 7.25 4.53125 6C3.8125 4.78125 3.8125 3.25 4.53125 2C5.25 0.78125 6.5625 0 8 0C9.40625 0 10.7188 0.78125 11.4375 2C12.1562 3.25 12.1562 4.78125 11.4375 6C10.7188 7.25 9.40625 8 8 8ZM6.5625 9.5H9.40625C12.5 9.5 15 12 15 15.0938C15 15.5938 14.5625 16 14.0625 16H1.90625C1.40625 16 1 15.5938 1 15.0938C1 12 3.46875 9.5 6.5625 9.5Z",
        fill: "#005DA2"
      })), React.createElement("span", {
        className: "coveo-tr-signup-required__title"
      }, "Sign in to explore this content"))));
    }
    return '';
  };
  // Holds the provided metatags values so we can have an access to it through the "generateFieldValue" function
  var metaTags = ['product', 'subProduct', 'returnType', 'city', 'state'].filter(function (key) {
    return resultListConfig[key];
  }).map(function (key) {
    return resultListConfig[key];
  });
  /**
   * Create CoveoCustomFieldValue basde on fields provided
   *
   * @param {string} values the value which is provided by Coveo with fieldName which we provide. Example: "tr_product", "tr_state"
   * @param {number} index the index of the provided field. Coveo doesn't accept the string in function helpers and to provide index is the only choice. It will get the title provided from AEM.
   * @returns "CoveoCustomFieldValue" which is responsible to render a value which will be recieved from SearchResults response. For example: if field is "@tr_product", Coveo will provide "tr_product" field from response item and render the custom template as a string in DOM.
   */
  window.generateFieldValue = function (values, index) {
    var _metaTags$index$value;
    if (!values || !values.length) return;
    if (!index && values.length === 1) values = values[0].split(',');
    return ReactDOMServer.renderToString(React.createElement("div", {
      className: "CoveoCustomFieldValue coveo-tr-tag-cell"
    }, React.createElement("div", {
      className: "coveo-field-label"
    }, (_metaTags$index$value = metaTags[index].value) == null ? void 0 : _metaTags$index$value.toLocaleString(), ":"), React.createElement("span", {
      className: "coveo-tr-help-and-support-products"
    }, "" + values.slice(0, 3).join(', ') + (values.length > 3 ? ' ... ' : ''))));
  };
  return React.createElement(React.Fragment, null, React.createElement("script", Object.assign({
    className: "result-template",
    type: "text/underscore"
  }, customComponentProps), ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame ResultListHelpAndSupportSearch"
  }, '{{= getInternalAgentType(raw.tr_internalonly) }}', '{{= getGatedContent(raw.tr_gatedcontent) }}', React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-helper-options-width": "100%",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-tag-row"
  }, metaTags.map(function (_ref, index) {
    var field = _ref.field;
    return "{{= generateFieldValue(raw." + field.slice(1) + ", " + index + ") }}";
  }), React.createElement("div", {
    className: "coveo-result-cell coveo-tr-tag-cell"
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-format-row"
  }, '{{= getFormatIcons(raw.tr_format) }}', React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": fileFormat ? fileFormat.field : '@tr_format'
  }), React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": fileSize ? fileSize.field : '@tr_filesize'
  }), React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-help-and-support-readtime",
    style: {
      fontWeight: 'normal'
    },
    "data-field": readTime ? (_readTime$field = readTime.field) == null ? void 0 : _readTime$field.toLocaleString() : '@tr_readtime'.toLocaleString()
  }))))), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "CoveoExcerpt coveo-tr-font-size-normal"
  })))))));
};

var Excerpt = function Excerpt() {
  return React.createElement("div", {
    className: "coveo-result-row coveo-search-excerpt"
  }, React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": "@description"
  }));
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
var VideoUri = function VideoUri(props) {
  var _props$uri, _props$uri2;
  return React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": ((_props$uri = props.uri) == null ? void 0 : _props$uri.value) || 'uri',
    "data-helper-options-width": "100%",
    "data-html-value": "true",
    "data-field": ((_props$uri2 = props.uri) == null ? void 0 : _props$uri2.field) || '@uri',
    href: '{{= raw.kaltura_video_url}}/ks/{{= raw.kaltura_video_ks}}'
  })));
};

var VideoTags = function VideoTags(props) {
  return React.createElement(React.Fragment, null, props.metaTags.map(function (_ref, index) {
    var field = _ref.field;
    return "{{= getVideoProducts(raw." + field.slice(1) + ", " + index + ") }}";
  }));
};

var VideoPlayer = function VideoPlayer(props) {
  var entryId = props.entryId,
    ks = props.ks;
  return React.createElement("div", {
    className: "coveo-kaltura-player",
    id: "coveo-kaltura-player__" + entryId,
    style: {
      width: '100%',
      height: '100%'
    },
    "data-video-ks": ks,
    "data-testid": entryId
  });
};

var FormatSection = function FormatSection() {
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-cell coveo-tr-tag-cell"
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-format-row"
  }, '{{= getVideoFormatIcon() }}', React.createElement("div", {
    className: "coveo-tr-format-row__title"
  }, 'Video'.toLocaleString()), '{{= getVideoDuration(raw.tr_video_duration) }}')));
};

var useKalturaPlayer = function useKalturaPlayer() {
  useEffect(function () {
    var kalturaSetupHandler = function kalturaSetupHandler() {
      var videos = document.querySelectorAll('.coveo-kaltura-player');
      // counts setup total number while internet connection is slow
      var retrySetupCount = 1;
      /**
       * Setup Kaltura Player
       *
       * @param {HTMLElement} video video component which has certain details for Kaltura to setup
       * @param {boolean} initial to track if it is the first setup try for Kaltura Player and reset the counter
       * @returns it either completes setup of the player or throws an error
       */
      var _setupKalturaPlayer = function setupKalturaPlayer(video, initial) {
        if (initial) retrySetupCount = 1;
        var VIDEO_KS = video.dataset.videoKs;
        try {
          // @ts-ignore
          var kalturaPlayer = window.KalturaPlayer.setup({
            targetId: video.id,
            playback: {
              textLanguage: 'auto',
              captionsDisplay: true
            },
            disableUserCache: true,
            provider: {
              partnerId: 2563011,
              uiConfId: 48740763,
              ks: VIDEO_KS
            }
          });
          kalturaPlayer.loadMedia({
            entryId: video.id.replace(/coveo-kaltura-player__/, '')
          });
        } catch (e) {
          // it gives a try for 2.5 seconds to setup the Kaltura Player
          // otherwise there is a missing part in the script which isn't
          // related to init process
          if (retrySetupCount < 5) {
            retrySetupCount++;
            setTimeout(function () {
              _setupKalturaPlayer(video);
            }, 500);
          } else {
            if (e instanceof Error) {
              console.error('Kaltura player setup error:', e.message);
            }
          }
        }
      };
      videos.forEach(function (video) {
        // initial setup, reset the counter for each video
        // doing it here, doesn't as expected due to the V8 engine behavior
        _setupKalturaPlayer(video, true);
      });
    };
    $$(document.body).on(CoveoEventNames.NEW_RESULTS_DISPLAYED, kalturaSetupHandler);
    return function () {
      $$(document.body).off(CoveoEventNames.NEW_RESULTS_DISPLAYED, kalturaSetupHandler);
    };
  }, []);
  useEffect(function () {
    var handleVideoURIClickThunk = handleVideoURIClick('.ResultListHelpAndSupportKalturaVideo .CoveoResultLink');
    $$(document.body).on(CoveoEventNames.NEW_RESULTS_DISPLAYED, handleVideoURIClickThunk);
    return function () {
      $$(document.body).off(CoveoEventNames.NEW_RESULTS_DISPLAYED, handleVideoURIClickThunk);
    };
  }, []);
};

var HelpAndSupportVideoIcon = function HelpAndSupportVideoIcon() {
  return React.createElement("svg", {
    width: "18",
    height: "13",
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M0 2.5C0 1.40625 0.875 0.5 2 0.5H10C11.0938 0.5 12 1.40625 12 2.5V10.5C12 11.625 11.0938 12.5 10 12.5H2C0.875 12.5 0 11.625 0 10.5V2.5ZM17.4688 1.625C17.7812 1.8125 18 2.15625 18 2.5V10.5C18 10.875 17.7812 11.2188 17.4688 11.4062C17.125 11.5625 16.75 11.5625 16.4375 11.3438L13.4375 9.34375L13 9.0625V8.5V4.5V3.96875L13.4375 3.6875L16.4375 1.6875C16.75 1.46875 17.125 1.46875 17.4688 1.625Z",
    fill: "#737373"
  }));
};

var ResultListHelpAndSupportKalturaVideoController = function ResultListHelpAndSupportKalturaVideoController(props) {
  var metaTags = props.metaTags,
    children = props.children;
  /**
   * Create CoveoCustomFieldValue basde on fields provided
   *
   * @param {string} values the value which is provided by Coveo categories name
   * @param {number} index index here will be used to refer to first meta-tags array value - which is "Product". Later functionality will be enhanced.
   * @returns "CoveoCustomFieldValue" which is responsible to render a value which will be received from SearchResults response. For example: if field is "@tr_product", Coveo will provide "tr_product" field from response item and render the custom template as a string in DOM.
   */
  window.getVideoProducts = function (values, index) {
    var _metaTags$index$value;
    if (!values || !values.length) return '';
    return ReactDOMServer.renderToString(React.createElement("div", {
      className: "CoveoCustomFieldValue coveo-tr-tag-cell"
    }, React.createElement("div", {
      className: "coveo-field-label"
    }, (_metaTags$index$value = metaTags[index].value) == null ? void 0 : _metaTags$index$value.toLocaleString(), ":"), React.createElement("span", {
      className: "coveo-tr-help-and-support-products"
    }, "" + values.slice(0, 3).join(', ') + (values.length > 3 ? ' ... ' : ''))));
  };
  window.getVideoFormatIcon = function () {
    return ReactDOMServer.renderToString(React.createElement(React.Fragment, null, React.createElement("span", {
      className: "coveo-field-label"
    }, 'TRStoreFormat'.toLocaleString(), ":"), React.createElement("div", {
      style: {
        display: 'flex'
      }
    }, React.createElement(HelpAndSupportVideoIcon, null))));
  };
  window.getVideoDuration = function (duration) {
    var minutes = Math.floor(parseInt(duration) / 60);
    var seconds = parseInt(duration) % 60;
    var generateTimeComponent = function generateTimeComponent(_ref) {
      var value = _ref[0],
        type = _ref[1];
      var classname = "video-duration__" + type;
      var delimiter = type === VideoDurationType.SECONDS ? '' : ':';
      var valueToDisplay = type === VideoDurationType.SECONDS ? value.toString().padStart(2, '0') : value;
      return React.createElement("span", {
        className: classname
      }, valueToDisplay, delimiter);
    };
    // This will render time like 1 hour 1 min 1 sec
    return ReactDOMServer.renderToString(React.createElement("div", {
      className: "video-duration"
    }, [[minutes, VideoDurationType.MINUTES], [seconds, VideoDurationType.SECONDS]].map(generateTimeComponent)));
  };
  window.getProductVideo = function (entryId, ks) {
    return ReactDOMServer.renderToString(React.createElement(VideoPlayer, {
      entryId: entryId,
      ks: ks
    }));
  };
  return children;
};

var css_248z$n = "/* stylelint-disable property-disallowed-list */\n\n.ResultListHelpAndSupportKalturaVideo .tr-coveo-file-icon {\n  margin-right: 0.563rem;\n  width: 1.125rem;\n}\n\n.coveo-result-frame.ResultListHelpAndSupportKalturaVideo {\n  display: flex !important;\n  flex-direction: row-reverse;\n  gap: 5px;\n  padding: var(--tr-coveo-font-size-m);\n  position: relative;\n}\n\n.coveo-result-frame.ResultListHelpAndSupportKalturaVideo .coveo-result-row {\n  margin: var(--tr-coveo-0);\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-internal-use {\n  background-color: var(--color-status-error-subtle, var(--tr-help-and-support-internal-use-badge-background-color));\n  border: 1px solid var(--color-status-error-strong, var(--tr-help-and-support-internal-use-badge-color));\n  border-radius: 4px;\n  color: var(--tr-help-and-support-internal-use-badge-color) !important;\n  font-size: var(--tr-coveo-font-size-xxxs);\n  font-weight: var(--tr-coveo-font-weight-bold);\n  padding: var(--tr-help-and-support-badge-padding);\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-signup-required {\n  background-color: var(--color-status-error-subtle, var(--tr-help-and-support-signup-required-badge-background-color));\n  border-radius: 4px;\n  color: var(--tr-help-and-support-signup-required-color) !important;\n  display: inline-flex;\n  font-size: var(--tr-coveo-font-size-xxxs);\n  font-weight: var(--tr-coveo-font-weight-bold);\n  gap: 5px;\n  padding: var(--tr-help-and-support-badge-padding);\n  place-items: center;\n}\n\n.ResultListHelpAndSupportKalturaVideo .CoveoResultLink {\n  font-weight: var(--tr-coveo-font-weight-medium) !important;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-file-type .coveo-accessible-button {\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-weight: var(--tr-coveo-font-weight-black);\n  pointer-events: none;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-format {\n  font-weight: var(--tr-coveo-header-font-weight);\n  margin-right: 0.5rem;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-font-size-normal {\n  font-size: var(--tr-coveo-font-size-xxs) !important;\n}\n\n.ResultListHelpAndSupportKalturaVideo > * {\n  order: 2;\n}\n\n.ResultListHelpAndSupportKalturaVideo .CoveoFieldValue > *,\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-tag-cell {\n  font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-tag-cell > * {\n  white-space: nowrap;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-tag-row {\n  display: flex !important;\n  flex-wrap: wrap;\n  gap: 10px;\n  row-gap: 5px;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-search-video {\n  /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n  height: 186px;\n  margin: var(--tr-coveo-0);\n  min-width: 321px;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-search-video video {\n  /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n  height: 100%;\n  width: 100%;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-result-container {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-search-excerpt {\n  margin-top: 1rem !important;\n}\n\n@media only screen and (max-width: 650px) {\n  .coveo-result-frame.ResultListHelpAndSupportKalturaVideo {\n    flex-direction: column;\n  }\n\n  .ResultListHelpAndSupportKalturaVideo .coveo-tr-tag-row {\n    flex-direction: column;\n  }\n\n  .ResultListHelpAndSupportKalturaVideo .coveo-search-excerpt {\n    margin-top: var(--tr-coveo-0) !important;\n  }\n\n  .ResultListHelpAndSupportKalturaVideo .coveo-result-container {\n    gap: var(--tr-coveo-searchbox-padding-1);\n  }\n\n  .ResultListHelpAndSupportKalturaVideo .coveo-search-video {\n    bottom: initial;\n    display: block;\n    height: max(190px, calc(50vw - 6px));\n    margin-top: 16px;\n    order: 1;\n    position: relative;\n    right: initial;\n    width: 100%;\n  }\n\n  .ResultListHelpAndSupportKalturaVideo .coveo-search-excerpt span {\n    width: 100% !important;\n  }\n\n  .ResultListHelpAndSupportKalturaVideo .CoveoResultLink {\n    font-size: var(--tr-coveo-font-size-m);\n  }\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-field-label {\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-regular);\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-format-row,\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-tag-cell {\n  display: flex;\n  gap: 5px;\n  place-items: center;\n}\n\n.ResultListHelpAndSupportKalturaVideo .CoveoCustomFieldValue {\n  place-items: start;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-tr-tag-row .coveo-tr-format-row {\n  margin: var(--tr-coveo-0) !important;\n}\n\n.ResultListHelpAndSupportKalturaVideo .CoveoFieldValue > span,\n.ResultListHelpAndSupportKalturaVideo .CoveoCustomFieldValue > span {\n  font-weight: var(--tr-coveo-font-weight-bold);\n  white-space: normal;\n}\n\n.ResultListHelpAndSupportKalturaVideo .coveo-search-excerpt span {\n  color: var(--color-text-strong, #404040);\n  display: inline-block !important;\n  font-weight: var(--tr-coveo-font-weight-regular);\n  min-height: 90px;\n  text-overflow: ellipsis;\n}\n\n.ResultListHelpAndSupportKalturaVideo .CoveoFieldValue.coveo-tr-help-and-support-readtime > span {\n  font-weight: var(--tr-coveo-normal) !important;\n}\n\n.coveo-tr-help-and-support-videos + .coveo-result-list-container > .CoveoResult {\n  padding: var(--tr-coveo-0);\n}\n\n.ResultListHelpAndSupportKalturaVideo .video-duration {\n  display: flex;\n  font-weight: var(--tr-coveo-font-weight-regular);\n}\n\n.coveo-result-list-container .coveo-list-layout:first-child > .ResultListHelpAndSupportKalturaVideo {\n  padding-top: 0 !important;\n}\n";
styleInject(css_248z$n);

var css_248z$o = ".ResultListHelpAndSupportKalturaVideo.help-and-support-ipx,\n.ResultListHelpAndSupportVideo.help-and-support-ipx {\n  flex-direction: column !important;\n}\n\n.ResultListHelpAndSupportKalturaVideo.help-and-support-ipx .coveo-search-excerpt,\n.ResultListHelpAndSupportVideo.help-and-support-ipx .coveo-search-excerpt {\n  margin-top: var(--tr-coveo-0) !important;\n}\n\n.ResultListHelpAndSupportKalturaVideo.help-and-support-ipx .coveo-result-container,\n.ResultListHelpAndSupportVideo.help-and-support-ipx .coveo-result-container {\n  gap: var(--tr-coveo-searchbox-padding-1);\n}\n\n.ResultListHelpAndSupportKalturaVideo.help-and-support-ipx .coveo-search-video,\n.ResultListHelpAndSupportVideo.help-and-support-ipx .coveo-search-video {\n  bottom: initial;\n  display: block;\n  height: 191px;\n  margin-top: 16px;\n  order: 1;\n  position: relative;\n  right: initial;\n  width: 100%;\n}\n\n.ResultListHelpAndSupportKalturaVideo.help-and-support-ipx .coveo-search-excerpt span,\n.ResultListHelpAndSupportVideo.help-and-support-ipx .coveo-search-excerpt span {\n  width: 100% !important;\n}\n\n.ResultListHelpAndSupportKalturaVideo.help-and-support-ipx .CoveoResultLink,\n.ResultListHelpAndSupportVideo.help-and-support-ipx .CoveoResultLink {\n  font-size: var(--tr-coveo-font-size-m);\n}\n";
styleInject(css_248z$o);

var ResultListHelpAndSupportKalturaVideo = function ResultListHelpAndSupportKalturaVideo(props) {
  var _useSearchResultProps = useSearchResultProps().resultList.resultListConfig,
    resultListConfig = _useSearchResultProps === void 0 ? {} : _useSearchResultProps;
  var context = useSearchResultProps().context;
  // Creates Custom Component Props to store additional properties
  // if they have been provided
  var customComponentProps = {};
  if (props != null && props.condition) {
    customComponentProps['data-condition'] = props.condition;
  }
  var templateClassNames = classNames('coveo-result-frame ResultListHelpAndSupportKalturaVideo', context);
  // Configure and Setup Kaltura Player for each entryId
  useKalturaPlayer();
  var metaTags = ['product', 'subProduct', 'returnType', 'city', 'state'].filter(function (key) {
    return resultListConfig[key];
  }).map(function (key) {
    return resultListConfig[key];
  });
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_HELP_AND_SUPPORT);
  return React.createElement(ResultListHelpAndSupportKalturaVideoController, {
    metaTags: metaTags
  }, React.createElement("script", Object.assign({
    className: "result-template coveo-tr-help-and-support-videos",
    type: "text/underscore"
  }, customComponentProps), ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: templateClassNames
  }, React.createElement("div", {
    className: "coveo-search-video"
  }, '{{= getProductVideo(raw.entryid, raw.kaltura_video_ks) }}'), React.createElement("div", {
    className: "coveo-result-container"
  }, React.createElement(VideoUri, {
    uri: resultListConfig.uri
  }), React.createElement("div", {
    className: "coveo-result-row coveo-tr-tag-row"
  }, React.createElement(VideoTags, {
    metaTags: metaTags
  }), React.createElement(FormatSection, null)), React.createElement(Excerpt, null)))))));
};

var css_248z$p = "/* stylelint-disable indentation */\n\n.ResultListHelpAndSupportPDF .tr-coveo-file-icon {\n    margin-right: 0.563rem;\n    width: 1.125rem;\n}\n\n.coveo-result-frame.ResultListHelpAndSupportPDF {\n    display: flex !important;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.coveo-result-frame.ResultListHelpAndSupportPDF .coveo-result-row {\n    height: 100%;\n    margin: var(--tr-coveo-0) !important;\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-internal-use {\n    background-color: var(--color-status-error-subtle, var(--tr-help-and-support-internal-use-badge-background-color));\n    border: 1px solid var(--color-status-error-strong, var(--tr-help-and-support-internal-use-badge-color));\n    border-radius: 4px;\n    color: var(--tr-help-and-support-internal-use-badge-color) !important;\n    font-size: var(--tr-coveo-font-size-xxxs);\n    font-weight: var(--tr-coveo-font-weight-bold);\n    padding: var(--tr-help-and-support-badge-padding);\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-signup-required {\n    background-color: var(--color-status-error-subtle, var(--tr-help-and-support-signup-required-badge-background-color));\n    border-radius: 4px;\n    color: var(--tr-help-and-support-signup-required-color) !important;\n    display: inline-flex;\n    font-size: var(--tr-coveo-font-size-xxxs);\n    font-weight: var(--tr-coveo-font-weight-bold);\n    gap: 5px;\n    padding: var(--tr-help-and-support-badge-padding);\n    place-items: center;\n}\n\n.ResultListHelpAndSupportPDF .CoveoResultLink {\n    font-weight: var(--tr-coveo-font-weight-medium) !important;\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-file-type .coveo-accessible-button {\n    color: var(--tr-coveo-color-tr-gray-dark);\n    font-weight: var(--tr-coveo-font-weight-black);\n    pointer-events: none;\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-format-row__title {\n    font-weight: var(--tr-coveo-header-font-weight);\n    margin-right: 0.5rem;\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-font-size-normal {\n    font-size: var(--tr-coveo-font-size-xxs) !important;\n}\n\n.ResultListHelpAndSupportPDF .CoveoFieldValue > *,\n.ResultListHelpAndSupportPDF .coveo-tr-tag-cell {\n    font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-tag-cell > * {\n    white-space: nowrap;\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-tag-row {\n    display: flex !important;\n    flex-wrap: wrap;\n    gap: 10px;\n    row-gap: 5px;\n}\n\n@media only screen and (max-width: 390px) {\n    .ResultListHelpAndSupportPDF .coveo-tr-tag-row {\n        flex-direction: column;\n    }\n}\n\n.ResultListHelpAndSupportPDF .coveo-field-label {\n    font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-format-row,\n.ResultListHelpAndSupportPDF .coveo-tr-tag-cell {\n    display: flex;\n    gap: 5px;\n    place-items: center;\n}\n\n.ResultListHelpAndSupportPDF .CoveoCustomFieldValue {\n    place-items: start;\n}\n\n.ResultListHelpAndSupportPDF .coveo-tr-tag-row .coveo-tr-format-row {\n    margin: var(--tr-coveo-0) !important;\n}\n\n.ResultListHelpAndSupportPDF .CoveoFieldValue > span,\n.ResultListHelpAndSupportPDF .CoveoCustomFieldValue > span {\n    font-weight: var(--tr-coveo-font-weight-bold);\n    white-space: normal;\n}\n\n.ResultListHelpAndSupportPDF .CoveoFieldValue.coveo-tr-help-and-support-readtime > span {\n    font-weight: var(--tr-coveo-normal) !important;\n}\n";
styleInject(css_248z$p);

function handleKalutraPDFUriClick(_x) {
  return _handleKalutraPDFUriClick.apply(this, arguments);
}
function _handleKalutraPDFUriClick() {
  _handleKalutraPDFUriClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
    var _this$dataset, attachmentAssetId, ks, newTab, response, blob, url;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          e.preventDefault();
          // @ts-ignore
          _this$dataset = this.dataset, attachmentAssetId = _this$dataset.assetIds, ks = _this$dataset.assetKs;
          if (!(attachmentAssetId && ks)) {
            _context.next = 17;
            break;
          }
          newTab = window.open();
          if (!newTab) {
            _context.next = 16;
            break;
          }
          newTab.document.write("\n      <html>\n        <head>\n          <title>Loading PDF...</title>\n          <style>\n          body {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            height: 100vh;\n            margin: 0;\n            font-family: Arial, sans-serif; /* Apply your desired font here */\n            color: black;\n          }\n          h3 {\n            color: orange;\n          }\n          p {\n            color: black;\n          }\n          </style>\n        </head>\n        <body>\n          <h3>Loading PDF, please wait...</h3>\n          <p>If this takes too long, please close this tab and try again.</p>\n        </body>\n      </html>\n      ");
          _context.next = 8;
          return fetch('https://www.kaltura.com/api_v3/service/attachment_attachmentasset/action/serve', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              ks: ks,
              attachmentAssetId: attachmentAssetId
            })
          });
        case 8:
          response = _context.sent;
          _context.next = 11;
          return response.blob();
        case 11:
          blob = _context.sent;
          url = window.URL.createObjectURL(blob);
          newTab.location.href = url;
          _context.next = 17;
          break;
        case 16:
          console.error('It seems that your browser does not support window.open. You should upgrade or download the latest version!');
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, this);
  }));
  return _handleKalutraPDFUriClick.apply(this, arguments);
}
var ResultListHelpAndSupportPDF = function ResultListHelpAndSupportPDF(props) {
  var _readTime$field;
  var _useSearchResultProps = useSearchResultProps().resultList.resultListConfig,
    resultListConfig = _useSearchResultProps === void 0 ? {} : _useSearchResultProps;
  // Creates Custom Component Props to store additional properties
  // if they have been provided
  var customComponentProps = {};
  useEffect(function () {
    var handler = function handler() {
      var links = document.querySelectorAll('.ResultListHelpAndSupportPDF .CoveoResultLink');
      links.forEach(function (link) {
        return link.addEventListener('click', handleKalutraPDFUriClick);
      });
    };
    $$(document.body).on(CoveoEventNames.NEW_RESULTS_DISPLAYED, handler);
    return function () {
      $$(document.body).off(CoveoEventNames.NEW_RESULTS_DISPLAYED, handler);
    };
  }, []);
  if (props != null && props.condition) {
    customComponentProps['data-condition'] = props.condition;
  }
  var uri = resultListConfig.uri,
    fileSize = resultListConfig.fileSize,
    readTime = resultListConfig.readTime;
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_HELP_AND_SUPPORT);
  return React.createElement(React.Fragment, null, React.createElement("script", Object.assign({
    className: "result-template",
    type: "text/underscore"
  }, customComponentProps), ReactDOMServer.renderToStaticMarkup(React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coveo-result-frame ResultListHelpAndSupportPDF"
  }, React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("h3", null, React.createElement("a", {
    className: "CoveoResultLink",
    "data-helper": uri ? uri.value : 'uri',
    "data-asset-ids": '{{= raw.kaltura_attachment_asset_ids }}',
    "data-asset-ks": '{{= raw.kaltura_video_ks }}',
    "data-helper-options-width": "100%",
    "data-html-value": "true",
    "data-field": uri ? uri.field : '@uri'
  }))), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-tag-row"
  }, React.createElement("div", {
    className: "coveo-result-cell coveo-tr-tag-cell"
  }, React.createElement("div", {
    className: "coveo-result-row coveo-tr-format-row"
  }, React.createElement("span", {
    className: "coveo-field-label"
  }, 'TRStoreFormat'.toLocaleString(), ":"), React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, React.createElement(PdfIcon, null)), React.createElement("div", {
    className: "coveo-tr-format-row__title"
  }, 'PDF'.toLocaleString()), React.createElement("div", {
    className: "CoveoFieldValue",
    "data-field": fileSize ? fileSize.field : '@tr_filesize'
  }), React.createElement("div", {
    className: "CoveoFieldValue coveo-tr-help-and-support-readtime",
    style: {
      fontWeight: 'normal'
    },
    "data-field": readTime ? (_readTime$field = readTime.field) == null ? void 0 : _readTime$field.toLocaleString() : '@tr_readtime'.toLocaleString()
  }))))), React.createElement("div", {
    className: "coveo-result-row"
  }, React.createElement("div", {
    className: "CoveoExcerpt coveo-tr-font-size-normal"
  })))))));
};

var css_248z$q = "/* stylelint-disable indentation */\n\n.CoveoResultList.help-and-support-mixed .ResultListHelpAndSupportSearch,\n.CoveoResultList.help-and-support-mixed .ResultListHelpAndSupportPDF {\n    padding: var(--tr-coveo-font-size-m);\n}\n\n.CoveoResultList.help-and-support-mixed .coveo-result-list-container > .CoveoResult {\n    padding: var(--tr-coveo-0) !important;\n}\n\n.coveo-result-list-container .coveo-list-layout:first-child > .ResultListHelpAndSupportSearch {\n    padding-top: 0 !important;\n  }\n";
styleInject(css_248z$q);

var ResultListHelpAndSupportMixed = function ResultListHelpAndSupportMixed() {
  return React.createElement(React.Fragment, null, React.createElement(ResultListHelpAndSupportKalturaVideo, {
    condition: "raw.source==='Kaltura - Light Version 2'"
  }), React.createElement(ResultListHelpAndSupportPDF, {
    condition: "raw.source==='TR Help And Support - Kaltura PDF entries'"
  }), React.createElement(ResultListHelpAndSupportSearch, {
    condition: "raw.source!=='Kaltura - Light Version 2'"
  }));
};

var css_248z$r = "\ndiv.tr-coveo-no-results-message {\n  display: none;\n}\n\n.tr-coveo-no-results div.tr-coveo-no-results-message {\n  display: flex;\n  margin-top: var(--tr-coveo-no-search-results-margin-top);\n  text-align: unset;\n}\n\n.tr-coveo-no-results div.tr-coveo-no-results-message .tr-coveo-info-alert-circle-exc {\n  display: block;\n  height: var(--tr-coveo-no-search-results-icon-size);\n  margin-right: var(--tr-coveo-no-search-results-icon-margin-right);\n  width: var(--tr-coveo-no-search-results-icon-size);\n}\n\n.tr-coveo-no-results div.tr-coveo-no-results-header h1 {\n  font-size: var(--tr-coveo-no-search-results-header-font-size);\n  font-weight: var(--tr-coveo-no-search-results-header-font-weight);\n  line-height: var(--tr-coveo-no-search-results-header-line-height);\n  margin: var(--tr-coveo-0);\n}\n\ndiv.tr-coveo-no-results-message .tr-coveo-no-results-text {\n  /* We didn't find any results text */\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-no-search-results-heading-bottom-font-size);\n  font-weight: var(--tr-coveo-normal);\n  line-height: var(--tr-coveo-no-search-results-heading-bottom-line-height);\n}\n\ndiv.tr-coveo-no-results-message .tr-coveo-no-results-text b {\n  /* We didn't find any results bold query text */\n  font-weight: var(--tr-coveo-bold);\n}\n\ndiv.tr-coveo-no-results-message h2 {\n  /* No results found Suggestions text */\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-no-search-results-heading-bottom-font-size);\n  font-weight: var(--tr-coveo-bold);\n  line-height: var(--tr-coveo-no-search-results-heading-bottom-line-height);\n  margin: var(--tr-coveo-no-search-results-heading-bottom-margin);\n}\n\n@media only screen and (max-width: 832px) {\n  .tr-coveo-no-results div.tr-coveo-no-results-message .tr-coveo-info-alert-circle-exc {\n    height: var(--tr-coveo-no-search-results-icon-size-m);\n    width: var(--tr-coveo-no-search-results-icon-size-m);\n  }\n\n  .tr-coveo-no-results div.tr-coveo-no-results-header h1 {\n    font-size: var(--tr-coveo-no-search-results-header-font-size-m);\n    font-weight: var(--tr-coveo-bold);\n    line-height: var(--tr-coveo-no-search-results-header-line-height-m);\n  }\n}\n\ndiv.tr-coveo-no-results-message ul {\n  list-style-position: inside;\n  list-style-type: disc;\n  margin: var(--tr-coveo-0);\n  padding: var(--tr-coveo-0);\n}\n\ndiv.tr-coveo-no-results-message li,\ndiv.tr-coveo-no-results-message p {\n  /* No results found tips text */\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-no-search-results-tip-text-font-size);\n  font-weight: var(--tr-coveo-normal);\n  line-height: var(--tr-coveo-no-search-results-tip-text-line-height);\n}\n\ndiv.tr-coveo-no-results-message .CoveoDidYouMean.tr-coveo-did-you-mean {\n  /* Did you mean text */\n  all: var(--tr-coveo-unset);\n  color: var(--tr-coveo-color-tr-gray-dark);\n  display: inline !important;\n  font-size: var(--tr-coveo-no-search-results-tip-text-font-size);\n  font-weight: var(--tr-coveo-normal);\n  line-height: var(--tr-coveo-no-search-results-tip-text-line-height);\n}\n\ndiv.tr-coveo-no-results-message .CoveoDidYouMean.tr-coveo-did-you-mean .coveo-did-you-mean-suggestion {\n  color: var(--tr-coveo-no-search-results-message-red);\n  display: inline;\n}\n\ndiv.tr-coveo-no-results-message .CoveoDidYouMean.tr-coveo-did-you-mean button {\n  /* Did you mean button text */\n  background-color: var(--tr-coveo-unset);\n  color: var(--tr-coveo-color-tr-blue-dark);\n  font-family: var(--tr-coveo-unset);\n  font-size: var(--tr-coveo-unset);\n}\n\ndiv.tr-coveo-no-results-message .tr-coveo-tip-clear-button {\n  all: unset;\n  color: var(--tr-coveo-color-tr-blue-dark);\n  cursor: pointer;\n  font-weight: var(--tr-coveo-bold);\n}\n\ndiv.tr-coveo-no-results-message .tr-coveo-tip-clear-button:hover {\n  text-decoration: underline;\n}\n\ndiv.tr-coveo-no-results-message .tr-coveo-tip-clear-button:focus {\n  box-shadow: none !important;\n  outline: 1px auto -webkit-focus-ring-color !important;\n}\n";
styleInject(css_248z$r);

function secondTipHelper(selectedFiltersCount) {
  if (selectedFiltersCount === 0) {
    return React.createElement("li", null, 'TRTryDifferentKeywords'.toLocaleString());
  } else {
    // using regex match instead of string replace to be able to put <button> between clear text.
    var test = 'TRChangeOrClearFilters'.toLocaleString();
    var found = test.match(/(.*?)\{(.*?)\}(.*)/);
    if (found && found.length === 4) {
      var clearFiltersHelper = function clearFiltersHelper() {
        document.querySelector('div.coveo-breadcrumb-clear-all').click();
      };
      return React.createElement("li", null, found[1], React.createElement("button", {
        className: "tr-coveo-tip-clear-button",
        onClick: clearFiltersHelper
      }, found[2]), found[3]);
    } else {
      console.error('Invalid TRChangeOrClearFilters string, using fallback');
      return React.createElement("li", null, 'TRTryDifferentKeywords'.toLocaleString());
    }
  }
}
function subheadingHelper(queryText) {
  // using regex match instead of string replace to be able to put <b> between result text.
  var found = 'TRDidntFindResults'.toLocaleString().match(/(.*?)(\{0\})(.*)/);
  if (found && found.length > 2) {
    return React.createElement(React.Fragment, null, found[1], React.createElement("b", null, queryText), found[3]);
  } else {
    console.error('Invalid TRDidntFindResults string, using fallback');
    return React.createElement(React.Fragment, null, 'TRDidntFindResults'.toLocaleString());
  }
}
var NoSearchResult = function NoSearchResult(_ref) {
  var selectedFiltersCount = _ref.selectedFiltersCount;
  var _useState = useState([]),
    queryCorrectionsAvailable = _useState[0],
    setQueryCorrectionsAvailable = _useState[1];
  var _useState2 = useState(''),
    queryText = _useState2[0],
    setQueryText = _useState2[1];
  useEffect(function () {
    var noResultsHandler = function noResultsHandler(_, data) {
      var _data$results, _data$query;
      setQueryCorrectionsAvailable(data == null || (_data$results = data.results) == null ? void 0 : _data$results.queryCorrections);
      setQueryText(data == null || (_data$query = data.query) == null ? void 0 : _data$query.q);
    };
    $$(document.body).on(CoveoEventNames.NO_RESULTS, noResultsHandler);
    return function () {
      $$(document.body).off(CoveoEventNames.NO_RESULTS, noResultsHandler);
    };
  }, []);
  return React.createElement("div", {
    className: "tr-coveo-no-results-message"
  }, React.createElement("div", {
    className: "tr-coveo-info-alert-circle-exc"
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-hidden": "true"
  }, React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M32 2a30 30 0 1 0 0 60 30 30 0 1 0 0-60z",
    stroke: "#404040"
  }), React.createElement("path", {
    d: "M32 45a3 3 0 1 0 0 6 3 3 0 1 0 0-6zM32 12v24",
    stroke: "#FF6400",
    "data-color": "color-2"
  })))), React.createElement("div", {
    className: "tr-coveo-beside-info-icon"
  }, React.createElement("div", {
    className: "tr-coveo-no-results-header"
  }, React.createElement("h1", null, 'TRNoResultsFound'.toLocaleString())), React.createElement("span", {
    className: "tr-coveo-no-results-text"
  }, subheadingHelper(queryText)), React.createElement("h2", null, 'TRSuggestions'.toLocaleString()), React.createElement("ul", null, React.createElement("li", {
    style: (queryCorrectionsAvailable == null ? void 0 : queryCorrectionsAvailable.length) > 0 ? {} : {
      display: 'none'
    }
  }, React.createElement("span", {
    className: "CoveoDidYouMean tr-coveo-did-you-mean",
    "data-enable-auto-correction": "false"
  })), React.createElement("li", null, 'TRSpellAllWordsCorrectly'.toLocaleString()), secondTipHelper(selectedFiltersCount)), React.createElement("h2", null, 'TRKeepSearchingTitle'.toLocaleString()), React.createElement("p", null, 'TRKeepSearchingDescription'.toLocaleString())));
};

var css_248z$s = ".coveo-tr-margin-right-1 {\n  margin-right: 0.225rem !important;\n}\n\n.coveo-tr-margin-right-2 {\n  margin-right: 0.625rem !important;\n}\n\n.coveo-tr-margin-right-3 {\n  margin-right: 2.625rem !important;\n}\n\n.CoveoResultLink:not(.coveo-new-branding) {\n  font-weight: var(--tr-coveo-font-weight-black) !important;\n}\n\n.coveo-new-branding .CoveoResultLink {\n  font-weight: var(--tr-coveo-font-weight-medium) !important;\n}\n\n.coveo-result-frame .coveo-result-row,\n.CoveoResult.coveo-result-frame .coveo-result-row {\n  width: unset;\n}\n\n.coveo-result-frame .coveo-result-row h3,\n.CoveoResult.coveo-result-frame .coveo-result-row h3 {\n  background: transparent;\n  border: var(--tr-coveo-text-decoration-none);\n  color: var(--tr-coveo-inherit);\n  display: inline;\n  font-size: var(--tr-coveo-inherit);\n  font-weight: var(--tr-coveo-inherit);\n  letter-spacing: var(--tr-coveo-normal);\n  margin: var(--tr-coveo-0);\n  padding: var(--tr-coveo-0);\n  text-align: var(--tr-coveo-inherit);\n  text-transform: var(--tr-coveo-text-decoration-none);\n}\n\n.coveo-results-row-fields {\n  display: flex !important;\n}\n\n.tr-coveo-margin-right-xs {\n  margin-right: 0.375rem;\n}\n\n.tr-coveo-margin-bottom-x {\n  margin-bottom: var(--tr-coveo-result-list-grid-gap) !important;\n}\n\n.tr-coveo-clock-icon {\n  width: 0.938rem;\n}\n\n.tr-coveo-SearchResults-resultEyebrow {\n  color: var(--color-tr-gray-medium);\n  display: block;\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  letter-spacing: 0.129rem;\n  margin-bottom: 0.375rem;\n}\n\n.tr-coveo-SearchResults-resultEyebrow p {\n  margin: var(--tr-coveo-text-decoration-none);\n  margin-top: 1.875rem;\n}\n\n.tr-coveo-duration span {\n  font-size: var(--tr-coveo-font-size-xxxs);\n}\n\n/* Legal Templates  */\n\n.tr-coveo-legal-templates .CoveoResultLink {\n  color: var(--tr-coveo-color-tr-blue-dark);\n  font-size: var(--tr-coveo-font-size-m);\n  font-weight: var(--tr-coveo-font-weight-light);\n  margin-bottom: 0.375rem;\n}\n\n.tr-coveo-search-result .ResultListCanadaStore .CoveoResultLink {\n  font-weight: var(--tr-coveo-font-weight-medium) !important;\n}\n\n.CoveoExcerpt {\n  line-height: var(--tr-coveo-result-list-line-height-medium);\n}\n\n.tr-coveo-legal-templates .CoveoExcerpt {\n  font-size: var(--tr-coveo-font-size-xxs);\n  margin-bottom: 0.375rem;\n}\n\n/* Legal Card Templates */\n\n.coveo-tr-legal-cards + .coveo-result-list-container > * {\n  border: none;\n}\n\n.coveo-tr-legal-card-wrapper {\n  /* stylelint-disable */\n  display: flex;\n  flex-direction: column;\n  border: 0.0625rem solid var(--tr-coveo-color-tr-gray-muted);\n  text-decoration: none !important;\n}\n\n.coveo-tr-legal-cards + .coveo-list-layout-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));\n  grid-column-gap: var(--tr-coveo-result-list-grid-gap);\n  grid-row-gap: var(--tr-coveo-result-list-grid-gap);\n}\n\n.coveo-tr-legal-cards-with-facet + .coveo-list-layout-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));\n  grid-column-gap: var(--tr-coveo-result-list-grid-gap);\n  grid-row-gap: var(--tr-coveo-result-list-grid-gap);\n}\n\n.coveo-tr-card-image {\n  height: 12rem;\n}\n\n.coveo-tr-legal-card-wrapper {\n  height: 100%;\n}\n\n.coveo-tr-legal-card-wrapper:hover {\n  box-shadow: 0 0.125rem 0.5rem #afafaf;\n  color: inherit;\n}\n\n.coveo-tr-legal-card-image-wrapper {\n  width: 100%;\n  height: 100%;\n  padding-top: 60%;\n  position: relative;\n}\n\n.coveo-tr-legal-card-image-wrapper img,\n.coveo-tr-legal-card-image-wrapper object {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n}\n\n.coveo-tr-card-title {\n  font-size: 1.3125rem !important;\n  line-height: 1.42857;\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-weight: var(--tr-coveo-font-weight-black);\n}\n\n.coveo-new-branding .coveo-tr-card-title{\n  font-family: var(--tr-coveo-font-family-clario);\n}\n\n.coveo-tr-legal-card-wrapper .tr-coveo-duration {\n  margin: var(--tr-coveo-0);\n}\n\n.coveo-tr-card-time-content {\n  display: flex !important;\n  align-items: center;\n  margin-top: var(--tr-coveo-result-list-grid-gap) !important;\n  margin-bottom: var(--tr-coveo-0);\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: 1rem;\n}\n\n.coveo-tr-card-date {\n  margin-right: 2.25rem;\n}\n\n.coveo-tr-card-time-content .tr-coveo-clock-icon {\n  width: 1.125rem;\n}\n\n.coveo-tr-card-caption {\n  font-size: 0.71772rem;\n  font-weight: var(--tr-coveo-font-weight-black);\n  letter-spacing: 0.18em;\n  line-height: 1.82871;\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.CoveoSearchInterface .coveo-results-column {\n  padding: unset;\n}\n\n.CoveoFieldValue .coveo-clickable:focus {\n  border: 0.125rem solid var(--tr-coveo-color-tr-blue-dark);\n  border-radius: 0.188rem;\n}\n\n@media only screen and (max-width: 52rem) {\n  .coveo-tr-legal-cards-with-facet + .coveo-list-layout-container {\n    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));\n  }\n}\n\n@media only screen and (max-width: 47.938rem) {\n  .coveo-tr-legal-cards-with-facet + .coveo-list-layout-container,\n  .coveo-tr-legal-cards + .coveo-list-layout-container {\n    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));\n  }\n\n  .coveo-tr-legal-card-wrapper {\n    min-height: 26.25rem;\n  }\n}\n";
styleInject(css_248z$s);

var _ResultListComponentB, _ResultCardComponentB;
var ResultListComponentByPalette = (_ResultListComponentB = {}, _ResultListComponentB[ResultListPaletteType.DEFAULT] = ResultListDefault, _ResultListComponentB[ResultListPaletteType.STORE] = ResultListStore, _ResultListComponentB[ResultListPaletteType.HELP_AND_SUPPORT] = ResultListHelpAndSupport, _ResultListComponentB[ResultListPaletteType.HELP_AND_SUPPORT_KALTURA_VIDEO] = ResultListHelpAndSupportKalturaVideo, _ResultListComponentB[ResultListPaletteType.HELP_AND_SUPPORT_SEARCH] = ResultListHelpAndSupportSearch, _ResultListComponentB[ResultListPaletteType.HELP_AND_SUPPORT_MIXED] = ResultListHelpAndSupportMixed, _ResultListComponentB[ResultListPaletteType.LEGAL] = ResultListLegal, _ResultListComponentB[ResultListPaletteType.HELP_AND_SUPPORT_PDF] = ResultListHelpAndSupportPDF, _ResultListComponentB[ResultListPaletteType.LEGAL_SCOPED] = ResultListLegalScoped, _ResultListComponentB[ResultListPaletteType.LEGAL_SCOPED_CARD] = ResultListLegalScopedCard, _ResultListComponentB[ResultListPaletteType.LEGAL_SCOPED_RIGHT_IMAGE] = ResultListLegalScopedRightImage, _ResultListComponentB[ResultListPaletteType.INTERNATIONAL_STORE] = ResultListInternationalStore, _ResultListComponentB[ResultListPaletteType.LOCATIONS] = ResultListLocations, _ResultListComponentB[ResultListPaletteType.PRODUCT_TRAINING] = ResultListProductTraining, _ResultListComponentB[ResultListPaletteType.CARDS] = ResultListCards, _ResultListComponentB[ResultListPaletteType.RIGHT_IMAGE] = ResultListRightImage, _ResultListComponentB[ResultListPaletteType.SCOPED] = ResultListScoped, _ResultListComponentB[ResultListPaletteType.CANADA_STORE] = ResultListCanadaStore, _ResultListComponentB[ResultListPaletteType.LIST_PI] = ResultListPI, _ResultListComponentB);
var ResultCardComponentByPalette = (_ResultCardComponentB = {}, _ResultCardComponentB[ResultCardPaletteType.CARD_PI] = ResultCardPI, _ResultCardComponentB);
var handler = {
  get: function get(palettes, type) {
    return palettes[type] || ResultListDefault;
  }
};
var ResultPalettes = /*#__PURE__*/new Proxy(/*#__PURE__*/_extends({}, ResultListComponentByPalette, ResultCardComponentByPalette), handler);
var getPaletteByType = function getPaletteByType(resultType, paletteType) {
  switch (resultType) {
    case ResultTypeEnum.LIST:
      return ResultPalettes[paletteType]();
    case ResultTypeEnum.CARD:
      return ResultPalettes[paletteType]();
    // Should create PaletteType which will hold all Card templates there, by default
    // return List templates
    default:
      return ResultPalettes[paletteType]();
  }
};
var ResultElementType = function ResultElementType(props) {
  var _useSearchResultProps = useSearchResultProps(),
    language = _useSearchResultProps.language,
    selectedFiltersCount = _useSearchResultProps.selectedFiltersCount;
  // Based on paletteType, we will remove default Coveo padding from mixed result items
  var resultListClassName = classNames('CoveoResultList', props.paletteType);
  return React.createElement("div", {
    className: resultListClassName,
    "data-wait-animation": "fade",
    "data-auto-select-fields-to-include": "true",
    "data-layout": props.resultType
  }, React.createElement(NoSearchResult, {
    selectedFiltersCount: selectedFiltersCount,
    language: language
  }), props.paletteType && getPaletteByType(props.resultType, props.paletteType));
};
var ResultList = function ResultList() {
  var _useSearchResultProps2 = useSearchResultProps(),
    enableSearchResultProjectImagine = _useSearchResultProps2.enableSearchResultProjectImagine,
    enablePreviousScrollPostion = _useSearchResultProps2.enablePreviousScrollPostion,
    resultList = _useSearchResultProps2.resultList,
    resultCard = _useSearchResultProps2.resultCard;
  var _ref = resultList || {},
    resultListPalette = _ref.resultListPalette;
  useEffect(function () {
    if ([ResultListPaletteType.HELP_AND_SUPPORT_KALTURA_VIDEO, ResultListPaletteType.HELP_AND_SUPPORT_MIXED].includes(resultListPalette || ResultListPaletteType.DEFAULT)) {
      var script = document.createElement('script');
      script.src = 'https://cdnapisec.kaltura.com/p/2563011/embedPlaykitJs/uiconf_id/49647463';
      script.type = 'text/javascript';
      document.body.appendChild(script);
    }
  }, [resultListPalette]);
  useScrollPosition(enablePreviousScrollPostion);
  return React.createElement(React.StrictMode, null, React.createElement(React.Fragment, null, React.createElement(ResultElementType, {
    resultType: ResultTypeEnum.LIST,
    paletteType: resultList == null ? void 0 : resultList.resultListPalette
  }), enableSearchResultProjectImagine && React.createElement(ResultElementType, {
    resultType: ResultTypeEnum.CARD,
    paletteType: resultCard == null ? void 0 : resultCard.resultCardPalette
  })));
};

var css_248z$t = "div.CoveoBreadcrumb.tr-coveo-breadcrumb {\n  /* main breadcrumb container */\n  border: none;\n  color: var(--tr-coveo-color-tr-gray-dark);\n  display: block;\n  margin-left: 0.75rem;\n  overflow: visible;\n  padding: var(--tr-coveo-0);\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb.coveo-breadcrumb-item,\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-dynamic-facet-breadcrumb.coveo-breadcrumb-item {\n  /* breadcrumb \"row\" div container */\n  margin: var(--tr-coveo-0);\n  padding-bottom: var(--tr-coveo-breadcrumb-row-padding);\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-title,\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-dynamic-facet-breadcrumb-title {\n  /* breadcrumb category labels */\n  color: var(--tr-coveo-color-tr-gray-dark);\n  font-size: var(--tr-coveo-breadcrumb-label-font-size);\n  font-weight: var(--tr-coveo-bold);\n  line-height: var(--tr-coveo-breadcrumb-label-line-height);\n  margin: var(--tr-coveo-0);\n  padding-right: calc(20rem / 16);\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb ul.coveo-facet-breadcrumb-values,\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb li.coveo-dynamic-facet-breadcrumb-value-list-item {\n  /* ul containing individual filter buttons */\n  display: inline;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-values li.coveo-facet-breadcrumb-value-list-item,\nbutton.coveo-dynamic-facet-breadcrumb-value {\n  display: contents;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-values li.coveo-facet-breadcrumb-value-list-item .coveo-facet-breadcrumb-value,\nbutton.coveo-dynamic-facet-breadcrumb-value {\n  /* Filter buttons */\n  background-color: var(--tr-coveo-color-tr-gray-dark);\n  border-radius: var(--tr-coveo-breadcrumb-filter-border-radius);\n  display: inline-flex;\n  font-size: var(--tr-coveo-breadcrumb-filter-font-size);\n  font-weight: var(--tr-coveo-breadcrumb-filter-font-weight);\n  height: calc(13rem / 16);\n  line-height: var(--tr-coveo-breadcrumb-filter-line-height);\n  margin-bottom: calc(9rem / 16);\n  margin-right: calc(20rem / 16);\n  padding: var(--tr-coveo-breadcrumb-filter-padding);\n  text-align: center;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\nbutton.coveo-dynamic-facet-breadcrumb-value {\n  color: var(--tr-coveo-color-tr-white);\n  font-family: inherit;\n  height: calc(24rem / 16);\n  text-decoration: none !important;\n}\n\nbutton.coveo-dynamic-facet-breadcrumb-collapse {\n  font-family: inherit;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-values li.coveo-facet-breadcrumb-value-list-item .coveo-facet-breadcrumb-value[title] {\n  /* Special case for the Show more filter button.\n  Filter buttons that are part of show more are children of this element */\n  background-color: var(--tr-coveo-unset);\n  border-radius: unset;\n  color: var(--tr-coveo-unset);\n  display: contents;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb div.coveo-facet-breadcrumb-value {\n  /* override content in first div in filter button */\n  all: unset;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-caption,\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-clear *,\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-dynamic-facet-breadcrumb-value-clear * {\n  /* Filter button text and x color */\n  color: var(--tr-coveo-color-tr-white);\n  display: inline-block;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-multi-count {\n  /* Show more link (margin for no-labels mode) */\n  margin-right: calc(20rem / 16);\n}\n\ndiv.coveo-breadcrumb-clear-all:focus-visible,\nbutton.coveo-dynamic-facet-breadcrumb-value:focus-visible {\n  outline: 0.063rem dotted rgb(33, 33, 33);\n  outline: 0.313rem auto -webkit-focus-ring-color;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-breadcrumb-clear-all {\n  /* Clear all Filters button */\n  display: inline;\n  margin: var(--tr-coveo-0);\n  padding: var(--tr-coveo-facet-padding-size-xs);\n  width: 5.938rem;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-breadcrumb-clear-all,\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb .coveo-facet-breadcrumb-multi-count {\n  /* Shared text attributes between clear all and show more links */\n  color: var(--tr-coveo-color-tr-blue-dark);\n  font-size: var(--tr-coveo-breadcrumb-label-font-size);\n  font-weight: var(--tr-coveo-normal);\n  letter-spacing: var(--tr-coveo-0);\n  line-height: var(--tr-coveo-breadcrumb-label-line-height);\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb.tr-coveo-breadcrumb-no-labels .coveo-facet-breadcrumb-title {\n  /* don't show coveo's category labels next to filter buttons */\n  display: none;\n}\n\ndiv.CoveoBreadcrumb.tr-coveo-breadcrumb.tr-coveo-breadcrumb-no-labels .coveo-facet-breadcrumb.coveo-breadcrumb-item {\n  /* display Filter buttons as a line */\n  display: contents;\n}\n\n.tr-coveo-breadcrumb-hidden {\n  display: none !important;\n}\n";
styleInject(css_248z$t);

var Breadcrumb = function Breadcrumb(_ref) {
  var _ref$breadcrumbShowLa = _ref.breadcrumbShowLabels,
    breadcrumbShowLabels = _ref$breadcrumbShowLa === void 0 ? true : _ref$breadcrumbShowLa;
  var _useSearchResultProps = useSearchResultProps(),
    enableBreadcrumb = _useSearchResultProps.enableBreadcrumb;
  var breadCrumbClass = classNames('CoveoBreadcrumb tr-coveo-breadcrumb', {
    'tr-coveo-breadcrumb-no-labels': breadcrumbShowLabels
  }, {
    'tr-coveo-breadcrumb-hidden': !enableBreadcrumb
  });
  return React.createElement("div", {
    className: breadCrumbClass
  });
};
Breadcrumb.displayName = 'CoveoSearchBreadcrumb';

var CoveoErrorReport = function CoveoErrorReport() {
  var displayStyle;
  var _useCoveoSearchAndNet = useCoveoSearchAndNetworkStatus(),
    isOffline = _useCoveoSearchAndNet.isOffline;
  var element = document.querySelector('.CoveoErrorReport');
  if (element) {
    displayStyle = window.getComputedStyle(element).getPropertyValue('display');
  }
  useEffect(function () {
    var searchResultComponent = document.querySelector('#searchResult');
    if (!isOffline && displayStyle === 'block' && searchResultComponent) {
      Coveo.executeQuery(searchResultComponent);
    }
  }, [displayStyle, isOffline]);
  return React.createElement("div", {
    className: "CoveoErrorReport",
    "data-pop-up": "false",
    "data-show-detailed-error": "true"
  });
};

var setCulture = function setCulture(key, culture, changeKey) {
  var _String$locale, _String$toLocaleStrin;
  // @ts-ignore:
  String.toLocaleString((_String$toLocaleStrin = {}, _String$toLocaleStrin[String.locale] = (_String$locale = {}, _String$locale[key] = culture[changeKey] || culture[key], _String$locale), _String$toLocaleStrin));
};
// @ts-ignore:
var modifyCulture = function modifyCulture(key, value) {
  // @ts-ignore:
  switch (String.locale) {
    case Language.EN:
      // @ts-ignore:
      setCulture(key, en, value);
      break;
    case Language.FR:
      // @ts-ignore:
      setCulture(key, fr, value);
      break;
    // @ts-ignore:
    case Language.ZH_CN:
      // @ts-ignore:
      setCulture(key, zh_cn, value);
      break;
    case Language.ZH_TW:
      // @ts-ignore:
      setCulture(key, zh_tw, value);
      break;
    case Language.JA:
      // @ts-ignore:
      setCulture(key, ja, value);
      break;
    case Language.PT_BR:
      // @ts-ignore:
      setCulture(key, pt_br, value);
      break;
    case Language.RU:
      // @ts-ignore:
      setCulture(key, ru, value);
      break;
    case Language.ES_ES:
      // @ts-ignore:
      setCulture(key, es_es, value);
      break;
    case Language.KO:
      // @ts-ignore:
      setCulture(key, ko, value);
      break;
    case Language.FI:
      // @ts-ignore:
      setCulture(key, fi, value);
      break;
    case Language.SV:
      // @ts-ignore:
      setCulture(key, sv, value);
      break;
    case Language.PL:
      // @ts-ignore:
      setCulture(key, pl, value);
      break;
    case Language.DA:
      // @ts-ignore:
      setCulture(key, da, value);
      break;
    case Language.NO:
      // @ts-ignore:
      setCulture(key, no, value);
      break;
    default:
      setCulture(key, en, value);
      break;
  }
};

var FunnelIcon = function FunnelIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, React.createElement("path", {
    d: "M2 2h20l-8 12v8h-4v-8z",
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeWidth: "2"
  }));
};

function noResultSummaryHelper(queryText) {
  // using regex match instead of string replace to be able to put <b> between query text.
  var noResultsTemplate = 'TRViewingNoResults'.toLocaleString().match(/(.*?)(\{0\})(.*)/);
  if (noResultsTemplate && noResultsTemplate.length === 4) {
    return React.createElement("span", {
      className: "tr-coveo-no-results-summary"
    }, noResultsTemplate[1], React.createElement("b", null, queryText), noResultsTemplate[3]);
  }
  console.error('Invalid TRViewingNoResults string, using fallback');
  return React.createElement("span", {
    className: "tr-coveo-no-results-summary"
  }, 'TRNoResultsFound'.toLocaleString());
}
var QuerySummary = function QuerySummary() {
  var _useSearchResultProps = useSearchResultProps(),
    resultCount = _useSearchResultProps.resultCount,
    _useSearchResultProps2 = _useSearchResultProps.searchHeader,
    searchHeader = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2,
    enableSearchResultProjectImagine = _useSearchResultProps.enableSearchResultProjectImagine;
  var setSelectedFiltersCount = searchHeader.setSelectedFiltersCount,
    setResultsFound = searchHeader.setResultsFound,
    facetIsEnable = searchHeader.facetIsEnable,
    selectedFiltersCount = searchHeader.selectedFiltersCount,
    resultsFound = searchHeader.resultsFound;
  var logger = useSearchResultProps().logger;
  var _useState = useState(''),
    queryText = _useState[0],
    setQueryText = _useState[1];
  useEffect(function () {
    logger == null || logger.debug(SearchResultLogs.SET_FILTERS_RESULTS_QUERY_TEXT);
    var populateBreadCrumbHandler = function populateBreadCrumbHandler() {
      var dynamicFacetCheckedInputs = document.querySelectorAll('input[class="coveo-checkbox"]:checked,.coveo-facet-value-checkbox[aria-pressed="true"],.CoveoDynamicHierarchicalFacet .coveo-selected');
      setSelectedFiltersCount(dynamicFacetCheckedInputs.length);
    };
    var preProcessResultsHandler = function preProcessResultsHandler(_, data) {
      var _data$results;
      setResultsFound((data == null || (_data$results = data.results) == null ? void 0 : _data$results['totalCount']) !== 0);
    };
    var newQueryHandler = function newQueryHandler(_, data) {
      var _data$origin, _data$origin2;
      setQueryText(data != null && (_data$origin = data.origin) != null && _data$origin.lastQuery ? data == null || (_data$origin2 = data.origin) == null ? void 0 : _data$origin2.lastQuery : '');
    };
    $$(document.getElementById('searchResult')).on(CoveoEventNames.POPULATE_BREADCRUMB, populateBreadCrumbHandler);
    $$(document.body).on(CoveoEventNames.PREPROCESS_RESULTS, preProcessResultsHandler);
    $$(document.body).on(CoveoEventNames.NEW_QUERY, newQueryHandler);
    return function () {
      $$(document.getElementById('searchResult')).off(CoveoEventNames.POPULATE_BREADCRUMB, populateBreadCrumbHandler);
      $$(document.body).off(CoveoEventNames.PREPROCESS_RESULTS, preProcessResultsHandler);
      $$(document.body).off(CoveoEventNames.NEW_QUERY, newQueryHandler);
    };
  }, [logger, setSelectedFiltersCount, setResultsFound]);
  useEffect(function () {
    var editCultures = function editCultures() {
      modifyCulture('ShowingResultsOf', 'ShowingResultsOfPI');
    };
    if (resultCount === ResultCountEnum.RIGHT_PANEL) {
      $$(document.body).on(CoveoEventNames.AFTER_INITIALIZATION, editCultures);
    }
    return function () {
      $$(document.body).off(CoveoEventNames.AFTER_INITIALIZATION, editCultures);
    };
  }, [resultCount]);
  return React.createElement("div", {
    className: 'CoveoQuerySummary tr-coveo-query-summary ' + (enableSearchResultProjectImagine || resultCount === ResultCountEnum.RIGHT_PANEL ? 'tr-coveo-query-summary-pi' : ''),
    "data-enable-cancel-last-action": "false",
    "data-enable-no-results-found-message": "false",
    "data-enable-search-tips": "false",
    "data-testid": "CoveoQuerySummary-test"
  }, !resultsFound && noResultSummaryHelper(queryText), facetIsEnable && React.createElement("button", {
    className: "coveo-filters-button",
    onClick: toggleFilters,
    type: "button",
    "aria-label": 'TROpenDropdownFilters'.toLocaleString(),
    title: 'TROpenDropdownFilters'.toLocaleString()
  }, React.createElement("span", {
    className: "coveo-tr-filter-icon"
  }, React.createElement(FunnelIcon, null)), (selectedFiltersCount === 0 ? 'TRFilter' : 'TRFilters').toLocaleString(), "(", selectedFiltersCount, ")"));
};

var SearchHeader = function SearchHeader() {
  var _useSearchResultProps = useSearchResultProps(),
    _useSearchResultProps2 = _useSearchResultProps.searchHeader,
    searchHeader = _useSearchResultProps2 === void 0 ? {} : _useSearchResultProps2,
    resultCount = _useSearchResultProps.resultCount;
  var isHeadingHidden = searchHeader.isHeadingHidden,
    isSubHeadingHidden = searchHeader.isSubHeadingHidden,
    hasError = searchHeader.hasError;
  return React.createElement("div", {
    className: "tr-coveo-search-header",
    "data-coveo-hide-header": isHeadingHidden && isSubHeadingHidden,
    "data-coveo-disable-header": hasError,
    "data-testid": "CoveoSearchHeader-test"
  }, React.createElement("div", {
    className: "tr-coveo-search-heading-and-sort-button"
  }, !hasError && React.createElement(React.Fragment, null, isHeadingHidden != null ? isHeadingHidden : React.createElement("h1", null, 'TRCoveoSearchResults'.toLocaleString()))), !isSubHeadingHidden && resultCount === ResultCountEnum.MAIN_PANEL && React.createElement(QuerySummary, null));
};

var css_248z$u = ".CoveoResultsPerPage .coveo-results-per-page-list {\n  display: var(--tr-coveo-result-per-page-display);\n}\n\n.CoveoResultsPerPage {\n  align-items: center;\n  display: flex;\n  padding-top: var(--tr-coveo-font-size-m);\n}\n\n.coveo-results-per-page-text {\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.coveo-new-branding .coveo-results-per-page-text {\n  font-weight: var(--tr-coveo-font-weight-bold);\n}\n\n.coveo-results-per-page-text::after {\n  content: \":\";\n}\n\n.coveo-tr-results-per-page-enable {\n  display: var(--tr-coveo-result-per-page-display);\n}\n\n.coveo-tr-results-per-page-disable {\n  display: none;\n}\n\n.coveo-tr-results-per-page-modified .coveo-results-per-page-list-item {\n  border: none;\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  height: 1.625rem;\n  padding: var(--tr-coveo-pager-padding-item);\n  text-align: center;\n  width: 1.625rem;\n}\n\n.coveo-tr-results-per-page-modified .coveo-active {\n  background-color: inherit;\n  border-bottom: 0.125rem solid var(--tr-coveo-color-tr-orange) !important;\n  border-radius: unset !important;\n}\n\n.coveo-new-branding .coveo-tr-results-per-page-modified .coveo-active {\n  background-color: inherit;\n  border-bottom: 0.125rem solid var(--tr-coveo-color-tr-orange-400) !important;\n  border-radius: unset !important;\n}\n\n.coveo-tr-results-per-page-modified .coveo-results-per-page-list-item:hover {\n  background-color: inherit;\n  text-decoration: var(--text-decoration);\n}\n\n.coveo-tr-results-per-page-modified .coveo-results-per-page-list-item span {\n  color: var(--tr-coveo-color-tr-gray-dark);\n}\n\n.coveo-new-branding .coveo-results-per-page-list-item span {\n  color: var(--tr-coveo-color-tr-black);\n}\n\n.coveo-tr-results-per-page-modified .coveo-results-per-page-list-item:hover span {\n  color: var(--tr-coveo-color-tr-gray);\n  text-decoration: var(--text-decoration);\n}\n\n.coveo-tr-results-per-page-modified .coveo-active:hover span {\n  color: var(--tr-coveo-color-tr-gray-dark) !important;\n}\n\n.coveo-results-per-page-list-item-text {\n  font-size: var(--tr-coveo-font-size-xxs);\n}\n\n.coveo-new-branding .coveo-results-per-page-list-item-text {\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-bold) !important;\n}\n";
styleInject(css_248z$u);

var ResultsPerPage = function ResultsPerPage(props) {
  var _useSearchResultProps;
  var resultsPerPageEnable = props.resultsPerPageEnable,
    resultsPerPageStyle = props.resultsPerPageStyle,
    resultsPerPageChoices = props.resultsPerPageChoices;
  var logger = (_useSearchResultProps = useSearchResultProps()) == null ? void 0 : _useSearchResultProps.logger;
  var _useState = useState(0),
    totalCount = _useState[0],
    setTotalCount = _useState[1];
  useEffect(function () {
    logger == null || logger.debug(SearchResultLogs.SET_TOTAL_COUNT);
    var totalCountHandler = function totalCountHandler(_, data) {
      var _data$results;
      setTotalCount(data == null || (_data$results = data.results) == null ? void 0 : _data$results.totalCount);
    };
    $$(document.body).on(CoveoEventNames.PREPROCESS_RESULTS, totalCountHandler);
    return function () {
      $$(document.body).off(CoveoEventNames.PREPROCESS_RESULTS, totalCountHandler);
    };
  }, [logger]);
  return React.createElement("div", {
    className: totalCount > SearchConstant.COVEO_RESULTS ? 'coveo-resultsPerPage-section' : 'coveo-resultsPerPageHidden-section'
  }, React.createElement("div", {
    className: resultsPerPageEnable ? 'coveo-tr-results-per-page-enable' : 'coveo-tr-results-per-page-disable'
  }, React.createElement("div", {
    className: resultsPerPageStyle === ResultsPerPageStyleType.DEFAULT ? 'CoveoResultsPerPage' : 'coveo-tr-results-per-page-modified CoveoResultsPerPage',
    "data-choices-displayed": resultsPerPageChoices
  })));
};

var ArrowUpIcon = function ArrowUpIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#404040"
  }, React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  }));
};

var ArrowDownIcon = function ArrowDownIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#404040"
  }, React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  }));
};

var css_248z$v = ".coveo-tr-sort-dropdown-button {\n  align-items: center;\n  background-color: var(--tr-coveo-color-tr-white);\n  border: 0.063rem solid var(--tr-coveo-color-tr-gray-muted);\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex !important;\n  font-size: var(--tr-coveo-font-size-xxs);\n  height: 2.625rem;\n  justify-content: space-between;\n  padding: var(--tr-coveo-result-list-sort-padding-sort-button);\n  width: 17.75rem;\n}\n\n.coveo-tr-sort-dropdown-button-opened {\n  border-radius: 0.313rem 0.313rem 0 0;\n}\n\n.coveo-tr-sort-dropdown-icon-wrapper {\n  margin-top: 0.188rem;\n}\n\n.coveo-tr-sort-dropdown-content {\n  background-color: var(--tr-coveo-color-tr-white);\n  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);\n  display: none;\n  min-width: 10rem;\n  position: absolute;\n  z-index: var(--tr-coveo-facet-z-index-x);\n}\n\n.coveo-tr-sort-dropdown-content-opened {\n  display: block;\n}\n\n.coveo-tr-sort-dropdown-option {\n  cursor: pointer;\n  width: 17.75rem;\n}\n\n.CoveoSort {\n  border: none;\n  display: flex !important;\n  padding: var(--tr-coveo-result-list-sort-padding-sort-option);\n}\n\n.CoveoSort span {\n  color: var(--tr-coveo-color-tr-gray-dark) !important;\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-regular);\n  text-transform: none;\n}\n\n.CoveoSort.coveo-selected,\n.CoveoSort:hover {\n  border-left: 0.125rem solid var(--tr-coveo-color-tr-orange);\n}\n\n.coveo-new-branding .CoveoSort,\n.coveo-new-branding .coveo-tr-sort-dropdown-button {\n  font-family: var(--tr-coveo-font-family-S3);\n}\n\n.CoveoSort.coveo-selected,\n.CoveoSort:hover,\n.coveo-new-branding .CoveoSort.coveo-selected,\n.coveo-new-branding .CoveoSort:hover {\n  background-color: var(--tr-coveo-color-tr-gray-lighter);\n  border-bottom: 0.063rem solid var(--tr-coveo-color-tr-gray-muted) !important;\n}\n\n.coveo-new-branding .CoveoSort.coveo-selected,\n.coveo-new-branding .CoveoSort:hover {\n  border-left: 0.125rem solid var(--tr-coveo-color-tr-orange-400);\n}\n\n.CoveoSort.coveo-selected span {\n  font-weight: var(--font-weight-700);\n}\n\n.coveo-tr-sort {\n  align-items: center;\n  display: flex;\n  justify-content: end;\n  position: absolute;\n  right: 0;\n  top: 2rem;\n}\n\n.coveo-tr-sort-by-text {\n  color: rgb(77, 77, 77);\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-regular);\n  margin-right: 0.438rem;\n}\n\n.coveo-new-branding .coveo-tr-sort-by-text {\n  color: rgb(77, 77, 77);\n  font-family: var(--tr-coveo-font-family-S3);\n  font-size: var(--tr-coveo-font-size-xxs);\n  font-weight: var(--tr-coveo-font-weight-regular);\n  margin-right: 0.438rem;\n}\n\n@media only screen and (max-width: 46.875rem) {\n  .coveo-tr-result-list-pi-subheader-sort .coveo-tr-sort {\n    display: flex;\n  }\n\n  .coveo-tr-mobile-sort-show {\n    display: flex;\n    justify-content: initial;\n    padding: var(--tr-coveo-result-list-sort-mobile-padding-sort-button);\n    position: unset !important;\n  }\n\n  .coveo-tr-mobile-sort-show .coveo-tr-sort-dropdown-wrapper {\n    flex: 1;\n    position: relative;\n  }\n\n  .coveo-tr-mobile-sort-show .coveo-tr-sort-dropdown-button,\n  .coveo-tr-mobile-sort-show .coveo-tr-sort-dropdown-option,\n  .coveo-tr-mobile-sort-show .coveo-tr-sort-dropdown-content-opened {\n    width: 100%;\n  }\n}\n\n.coveo-tr-hide-sort {\n  display: none;\n}\n";
styleInject(css_248z$v);

/* eslint-disable jsx-a11y/click-events-have-key-events */
var ResultListSort = function ResultListSort() {
  var _useSearchResultProps = useSearchResultProps().sort,
    sortData = _useSearchResultProps.sortData,
    sortIsEnable = _useSearchResultProps.sortIsEnable,
    sortIsHidden = _useSearchResultProps.sortIsHidden,
    sortInMobileViewEnable = _useSearchResultProps.sortInMobileViewEnable,
    sortEnableDefaultSortCriteria = _useSearchResultProps.sortEnableDefaultSortCriteria;
  var _useCoveoSearchAndNet = useCoveoSearchAndNetworkStatus(),
    noResults = _useCoveoSearchAndNet.noResults,
    isOffline = _useCoveoSearchAndNet.isOffline;
  var coveoSortWrapperRef = useRef(null);
  var coveoSortOptionRef = useRef(null);
  var _useState = useState(''),
    activeId = _useState[0],
    setActiveId = _useState[1];
  var _useState2 = useState(false),
    dropDownOpen = _useState2[0],
    setIsDropDownOpen = _useState2[1];
  var _useState3 = useState(''),
    selectedPlaceHolder = _useState3[0],
    setSelectedPlaceHolder = _useState3[1];
  var logger = useSearchResultProps().logger;
  logger == null || logger.debug(SearchResultLogs.RESULT_LIST_SORT);
  /**
   * Sets the focus in the current sort option and updates active sort option ID
   * @param activeElement The element in the sort list to be focused
   */
  var setActiveSortOption = function setActiveSortOption(activeElement) {
    if (activeElement) {
      activeElement.focus();
      setActiveId((activeElement == null ? void 0 : activeElement.getAttribute('id')) || '');
    }
  };
  useEffect(function () {
    logger == null || logger.debug(SearchResultLogs.RESULT_LIST_SORT_USE_EFFECT);
    var handleClickOutside = function handleClickOutside(event) {
      return clickOutside(event, coveoSortWrapperRef, dropDownOpen, setIsDropDownOpen);
    };
    /**
     * Navigates up and down the dropdown list using the arrow keys and closes the
     * dropdown
     */
    var handleKeyDown = function handleKeyDown(e) {
      if (dropDownOpen) {
        if (e.key === KeyboardEnums.ESC) {
          var _document$getElementB;
          setIsDropDownOpen(false);
          (_document$getElementB = document.getElementById(SortComponentBtnId)) == null || _document$getElementB.focus();
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var listBoxElement = document.getElementById('listbox1');
          if (listBoxElement) {
            var nextOptionId = getNextDropdownId(activeId, listBoxElement.children.length + 1, e.key);
            setActiveSortOption(document.getElementById(nextOptionId));
          }
        }
      }
    };
    var clickTab = function clickTab(e) {
      if (e.key === KeyboardEnums.TAB) {
        var _document$activeEleme;
        if (dropDownOpen && !((_document$activeEleme = document.activeElement) != null && _document$activeEleme.classList.contains('coveo-accessible-button'))) {
          setIsDropDownOpen(false);
        }
      }
    };
    removeRoleAttribute('.CoveoSort');
    changeNodeAttributesValue('.CoveoSort .coveo-accessible-button', CoveoSortOptionObj(selectedPlaceHolder));
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', clickTab);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', clickTab);
    };
  }, [coveoSortWrapperRef, dropDownOpen, logger, selectedPlaceHolder, coveoSortOptionRef, activeId]);
  var dropDownToggle = function dropDownToggle() {
    setIsDropDownOpen(!dropDownOpen);
    setActiveId('');
  };
  useLayoutEffect(function () {
    var doneBuildingQueryHandler = function doneBuildingQueryHandler(_, args) {
      setSelectedPlaceHolder(getDropdownPlaceholder(args, sortData));
    };
    $$(document.getElementById(SearchConstant.COVEO_SEARCH_RESULT_ID)).on(CoveoEventNames.DONE_BUILDING_QUERY, doneBuildingQueryHandler);
    return function () {
      $$(document.getElementById(SearchConstant.COVEO_SEARCH_RESULT_ID)).off(CoveoEventNames.DONE_BUILDING_QUERY, doneBuildingQueryHandler);
    };
  }, [sortData]);
  var updateActiveDescendantAttribute = function updateActiveDescendantAttribute() {
    var _document$activeEleme2;
    var id = (_document$activeEleme2 = document.activeElement) == null ? void 0 : _document$activeEleme2.getAttribute('id');
    if (!id) {
      return;
    }
    setActiveId(id);
  };
  useHandleSortCriteria(sortData, sortEnableDefaultSortCriteria);
  //Gets the current sort option to focus it when the dropdown is open
  useEffect(function () {
    if (dropDownOpen) {
      var _document$body;
      var coveoSortElBtn = (_document$body = document.body) == null ? void 0 : _document$body.querySelectorAll('.coveo-accessible-button');
      Array.from(coveoSortElBtn).forEach(function (el) {
        if (el.textContent === selectedPlaceHolder) {
          setActiveSortOption(el);
        }
      });
    }
  }, [dropDownOpen, selectedPlaceHolder]);
  return React.createElement(React.Fragment, null, sortIsEnable ? React.createElement("div", {
    className: "coveo-tr-sort " + (sortIsHidden || noResults || isOffline ? 'coveo-tr-hide-sort' : '') + " " + (sortInMobileViewEnable ? 'coveo-tr-mobile-sort-show' : '')
  }, React.createElement("label", {
    className: "coveo-tr-sort-by-text",
    "data-testid": "@ResultListSort-label"
  }, 'SortBy'.toLocaleString(), ":"), React.createElement("div", {
    className: "coveo-tr-sort-dropdown-wrapper",
    ref: coveoSortWrapperRef
  }, React.createElement("button", {
    className: "coveo-tr-sort-dropdown-button " + (dropDownOpen ? 'coveo-tr-sort-dropdown-button-opened' : ''),
    onClick: dropDownToggle,
    "aria-haspopup": "listbox",
    type: "button",
    "data-testid": "@ResultListSort-button",
    "aria-label": " " + 'SortBy'.toLocaleString() + " " + selectedPlaceHolder + ", " + (dropDownOpen ? "" + 'TRCollapseSortDropdown'.toLocaleString() : "" + 'TRExpandSortDropdown'.toLocaleString()),
    id: SortComponentBtnId,
    role: "combobox",
    "aria-expanded": dropDownOpen,
    "aria-controls": "listbox1",
    "aria-activedescendant": dropDownOpen ? activeId : ''
  }, React.createElement("span", {
    "aria-hidden": "true"
  }, " ", selectedPlaceHolder), React.createElement("div", {
    className: "coveo-tr-sort-dropdown-icon-wrapper"
  }, dropDownOpen ? React.createElement(ArrowUpIcon, null) : React.createElement(ArrowDownIcon, null))), React.createElement("div", {
    className: "coveo-tr-sort-dropdown-content " + (dropDownOpen ? 'coveo-tr-sort-dropdown-content-opened' : ''),
    role: "listbox",
    id: "listbox1",
    "aria-label": "listbox " + 'SortBy'.toLocaleString() + " ",
    ref: coveoSortOptionRef
  }, sortData ? sortData.map(function (el) {
    return React.createElement("div", {
      key: el.sortCriteria,
      "data-testid": "@ResultListSort-sortData",
      className: "coveo-tr-sort-dropdown-option",
      onClick: function onClick() {
        return setIsDropDownOpen(false);
      },
      onFocus: updateActiveDescendantAttribute
    }, React.createElement("span", {
      className: "CoveoSort",
      "data-sort-criteria": el.sortCriteria,
      "data-caption": el.sortCaption
    }));
  }) : null))) : null);
};

var css_248z$w = "div.CoveoSearchInterface.tr-coveo-search-result {\n  /* pass through fonts */\n  font-family: var(--tr-coveo-unset);\n}\n\n.coveo-pager-section {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.coveo-new-branding .coveo-pager-section {\n  display: flex;\n  font-family: var(--tr-coveo-font-family-S3) !important;\n  justify-content: space-evenly;\n}\n\n.coveo-resultsPerPage-section {\n  display: block;\n}\n\n.coveo-resultsPerPageHidden-section {\n  display: none;\n}\n\ndiv.CoveoSearchInterface.tr-coveo-search-result .coveo-results-column.coveo-no-results {\n  text-align: unset;\n}\n\ndiv.tr-coveo-search-header {\n  /* contains Header, Result count, No results message */\n  margin: var(--tr-coveo-header-margin);\n}\n\n.tr-coveo-no-results.tr-coveo-no-facets-selected div.tr-coveo-search-header {\n  display: none;\n}\n\ndiv.tr-coveo-search-header .tr-coveo-search-heading-and-sort-button {\n  /* header and sort button container */\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\ndiv.tr-coveo-search-header h1 {\n  display: inline-block;\n  font-size: var(--tr-coveo-header-font-size);\n  font-weight: var(--tr-coveo-font-weight-black);\n  line-height: var(--tr-coveo-header-line-height);\n  margin: var(--tr-coveo-header-text-margin);\n  max-width: 46%;\n}\n\ndiv.tr-coveo-query-summary.CoveoQuerySummary {\n  /* override unneeded styles set by coveo */\n  color: var(--tr-coveo-unset);\n}\n\ndiv.tr-coveo-query-summary.CoveoQuerySummary > span {\n  /* Viewing: 1 to 10 of 1,161 results text */\n  font-size: var(--tr-coveo-label-font-size);\n  line-height: var(--tr-coveo-label-line-height);\n}\n\n.tr-coveo-no-results div.tr-coveo-query-summary.CoveoQuerySummary > span {\n  /* Viewing: 1 to 10 of 1,161 results text */\n  display: none;\n}\n\ndiv.tr-coveo-query-summary.CoveoQuerySummary .tr-coveo-no-results-summary {\n  /* Viewing: 0 of 0 results for */\n  display: none;\n}\n\n.tr-coveo-no-results div.tr-coveo-query-summary.CoveoQuerySummary .tr-coveo-no-results-summary {\n  display: unset;\n}\n\ndiv.tr-coveo-query-summary.CoveoQuerySummary .coveo-highlight {\n  /* need to remove bold from coveo's highlights on viewing 1 to 10 text */\n  font-weight: var(--tr-coveo-normal);\n}\n\ndiv.tr-coveo-query-summary.CoveoQuerySummary .coveo-highlight-query,\ndiv.tr-coveo-query-summary.CoveoQuerySummary .coveo-highlight-query .coveo-highlight {\n  /* add bold back onto what we want */\n  font-weight: var(--tr-coveo-bold);\n}\n\n.tr-coveo-search-header .coveo-filters-button,\n.tr-coveo-query-summary-pi .coveo-filters-button {\n  background-color: inherit;\n  border: none;\n  border-left: calc(1rem / 16) solid var(--tr-coveo-filter-border-color);\n  color: var(--tr-coveo-color-tr-gray-dark);\n  display: none;\n  font-family: var(--tr-coveo-unset);\n  font-size: var(--tr-coveo-font-size-xxs);\n  line-height: var(--tr-coveo-filter-line-height);\n  margin-right: 0.75rem;\n  padding: var(--tr-coveo-filter-button-padding);\n}\n\n.tr-coveo-search-header .coveo-tr-filter-icon svg,\n.coveo-results-column .coveo-tr-filter-icon svg {\n  width: var(--tr-coveo-font-size-xxs);\n}\n\n.tr-coveo-search-header .coveo-tr-filter-icon path,\n.coveo-results-column .coveo-tr-filter-icon path {\n  stroke: var(--tr-coveo-color-tr-orange);\n}\n\n.coveo-dropdown-header-wrapper {\n  display: none !important;\n}\n\n.coveo-error-report-help-suggestion {\n  display: none;\n}\n\n.coveo-error-report-container {\n  background-color: inherit;\n  border: none;\n  margin-left: 5.5rem;\n  padding: var(--tr-coveo-0);\n}\n\n.coveo-error-report-message {\n  display: none;\n}\n\n/* stylelint-disable */\n\n.coveo-error-report-title h1,\n.CoveoErrorReport {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 0;\n}\n\n.CoveoErrorReport {\n  padding: 2.813rem;\n  column-gap: 1.25rem;\n}\n\n.CoveoErrorReport::before,\n.coveo-error-report-title h1::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 4.5rem;\n  height: 4.5rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg focusable='false' viewBox='0 0 62 62' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' transform='translate(1 1)'%3E%3Ccircle cx='30' cy='30' r='29' stroke='%23404040' strokeWidth='3' /%3E%3Cpath d='M29.589 10.833v26.198' stroke='%23fa6400' strokeWidth='3' /%3E%3Ccircle cx='29.583' cy='46.25' fill='%23fa6400' r='1.25' stroke='%23fa6400' strokeWidth='3' /%3E%3C/g%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n}\n\n.coveo-error-report-title h1::before {\n  display: none;\n  width: 1.625rem;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='13' cy='13' r='12' stroke='%23404040' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12.837 5.33325V14.3333' stroke='%23FA6400' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='12.8359' cy='19.5' r='0.499999' fill='%23FA6400' stroke='%23FA6400' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n}\n\n.coveo-error-report-title h1 {\n  color: rgb(64, 64, 64);\n  font-weight: 900;\n  font-size: 3.375rem;\n}\n\n.coveo-error-report-title h2 {\n  color: rgb(64, 64, 64);\n  font-size: 1.5rem;\n  letter-spacing: 0;\n  max-width: 39.688rem;\n}\n\n.coveo-error-report-options .coveo-accessible-button {\n  background-color: var(--tr-coveo-color-tr-orange);\n  color: var(--tr-coveo-color-tr-white);\n  text-decoration: none;\n  display: none;\n  padding: 0.5rem 1.313rem;\n  font-weight: var(--tr-coveo-font-weight-medium);\n  font-size: 1.188rem;\n  border-radius: 1.875rem;\n}\n\n.coveo-error-report-options .coveo-accessible-button:nth-child(1) {\n  display: inline-block;\n}\n\n.coveo-error-report-options {\n  margin-top: 1.9375rem;\n}\n\n.CoveoErrorReport {\n  text-align: initial !important;\n}\n\n.CoveoErrorReport h1,\n.CoveoErrorReport h2,\n.CoveoErrorReport h3,\n.CoveoErrorReport h4,\n.CoveoErrorReport h5,\n.CoveoErrorReport h6 {\n  margin: 0;\n}\n\ndiv[data-coveo-hide-header=\"true\"],\ndiv[data-coveo-disable-header=\"true\"] {\n  display: none;\n}\n\n.tr-coveo-context-hs-ipx-facet,\n.tr-coveo-context-hs-ipx-facet .coveo-main-section {\n  position: unset !important;\n}\n\n.tr-coveo-context-hs-ipx-facet .coveo-dropdown-content {\n  position: absolute !important;\n  top: 0 !important;\n  right: 0 !important;\n}\n\n.tr-coveo-context-hs-ipx-facet .coveo-dropdown-background {\n  opacity: 0 !important;\n}\n\n.tr-coveo-query-summary-pi .coveo-highlight {\n  font-weight: var(--tr-coveo-font-weight-black) !important;\n  color: var(--color-tr-gray-medium) !important;\n}\n\n.tr-coveo-query-summary-pi span {\n  font-size: 0.75rem !important;\n}\n\n.coveo-result-layout-section {\n  padding: 0.5rem 0 1.875rem 0;\n}\n\n.coveo-card-layout-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.coveo-list-layout-icon {\n  width: 1.25rem;\n  height: 0.875rem;\n}\n\n.coveo-result-layout-selector-caption {\n  font-size: 0.625rem;\n  font-weight: var(--tr-coveo-font-weight-medium);\n}\n\n.coveo-tr-result-list-pi-subheader-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.coveo-tr-result-list-pi-subheader-wrapper .coveo-tr-sort {\n  position: unset !important;\n}\n\n.coveo-tr-search-hide-element {\n  display: none !important;\n}\n\n@media only screen and (max-width: 52rem) {\n  .coveo-tr-result-list-pi-subheader-wrapper {\n    padding-bottom: 0.313rem;\n  }\n\n  .coveo-tr-result-list-pi-subheader-summary {\n    margin-bottom: 1.25rem;\n  }\n\n  .coveo-tr-result-list-pi-subheader-sort {\n    padding-left: 0.625rem;\n    padding-right: 0.625rem;\n  }\n\n  .coveo-tr-result-list-pi-subheader-sort .coveo-tr-sort-by-text {\n    width: 3.813rem;\n  }\n\n  .coveo-tr-result-list-pi-subheader-sort .coveo-tr-sort {\n    justify-content: initial;\n  }\n\n  .coveo-tr-result-list-pi-subheader-wrapper {\n    flex-direction: column;\n  }\n\n  .coveo-result-layout-section {\n    display: none;\n  }\n\n  .tr-coveo-search-header .coveo-filters-button,\n  .tr-coveo-query-summary-pi .coveo-filters-button {\n    display: block;\n  }\n\n  div.tr-coveo-query-summary.CoveoQuerySummary {\n    align-items: center;\n    border-bottom: calc(1rem / 16) solid var(--tr-coveo-filter-border-color);\n    border-top: calc(1rem / 16) solid var(--tr-coveo-filter-border-color);\n    display: flex;\n    justify-content: space-between;\n  }\n\n  div.tr-coveo-query-summary.CoveoQuerySummary span > span:nth-child(3)::after {\n    content: \" \";\n    display: block;\n  }\n\n  .coveo-facet-disabled .tr-coveo-query-summary.CoveoQuerySummary > span {\n    padding: var(--tr-coveo-filter-button-padding);\n  }\n}\n\n@media only screen and (max-width: 48rem) {\n  .coveo-pager-section {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (max-width: 26.25rem) {\n  .coveo-tr-result-list-pi-subheader-sort .coveo-tr-sort-dropdown-button {\n    width: 100%;\n  }\n\n  .coveo-tr-result-list-pi-subheader-sort .coveo-tr-sort-dropdown-wrapper {\n    flex: 1;\n    position: relative;\n  }\n\n  .coveo-tr-result-list-pi-subheader-sort .coveo-tr-sort-dropdown-option,\n  .coveo-tr-result-list-pi-subheader-sort .coveo-tr-sort-dropdown-content {\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 390px) {\n  .CoveoErrorReport {\n    padding: 0;\n    column-gap: 0;\n  }\n\n  .CoveoErrorReport::before {\n    display: none;\n  }\n\n  .coveo-error-report-title h1 {\n    /* font-size: 2rem; */\n    font-size: 1.5rem;\n    column-gap: 0.938rem;\n  }\n\n  .coveo-error-report-title h1::before {\n    display: inline-block;\n  }\n\n  .coveo-error-report-title h2 {\n    /* font-size: 1.125rem; */\n    font-size: 0.875rem;\n    margin-top: 0.938rem;\n    font-weight: var(--tr-coveo-font-weight-regular);\n  }\n\n  .coveo-error-report-container {\n    padding: 0.906rem;\n    margin-left: auto;\n  }\n\n  .coveo-error-report-options .coveo-accessible-button {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n@media only screen and (max-width: 46.875rem) {\n  div.tr-coveo-search-header h1 {\n    max-width: 100% !important;\n  }\n}\n\n.coveo-facet-collapsible-header-wrapper h2 {\n  font-size: 1.5rem !important;\n  font-weight: 700 !important;\n  color: rgba(49, 58, 69, 1) !important;\n}\n\n\n/* CoveoTab Styles */\n.coveo-tab-section {\n  display: flex;\n  background: none !important;\n  margin-left: var(--tr-coveo-tab-section-container-left-gap);\n}\n\n.coveo-tab-section {\n  min-height: var(--tr-coveo-tab-section-height) !important;\n}\n\n.coveo-tab-section .CoveoTab {\n  height: var(--tr-coveo-tab-section-height);\n}\n\n.coveo-tab-section .coveo-selected {\n  border-bottom: var(--tr-coveo-tab-section-selected-border-size) solid var(--tr-color-interactive-on-tab-active) !important;\n}\n\n.coveo-tab-section .coveo-tr-searchtab {\n  padding: 0.5rem 1rem !important;\n}\n\n.coveo-tab-section .coveo-tr-searchtab p {\n  text-transform: capitalize;\n  color: #000;\n  font-size: var(--tr-coveo-searchresult-font-size);\n  font-weight: var(--tr-coveo-font-weight-medium);\n  line-height: var(--tr-coveo-normal);\n}\n\n.coveo-tab-section .coveo-selected p {\n  color: var( --tr-color-interactive-on-tab-active) !important;\n  border: none !important;\n}\n";
styleInject(css_248z$w);

var logger = /*#__PURE__*/new SearchLogger(Logger.NOTHING);
var SearchResult = function SearchResult(props) {
  var facet = props.facet,
    pager = props.pager,
    breadcrumb = props.breadcrumb,
    resultsPerPage = props.resultsPerPage,
    resultList = props.resultList,
    resultCard = props.resultCard,
    excerptLength = props.excerptLength,
    enableNewBranding = props.enableNewBranding,
    searchHub = props.searchHub,
    sort = props.sort,
    _props$tab = props.tab,
    tab = _props$tab === void 0 ? {} : _props$tab,
    context = props.context,
    language = props.language,
    contextName = props.contextName,
    productRecommendation = props.productRecommendation,
    _props$resultCount = props.resultCount,
    resultCount = _props$resultCount === void 0 ? ResultCountEnum.MAIN_PANEL : _props$resultCount,
    enableSearchResultProjectImagine = props.enableSearchResultProjectImagine,
    enablePreviousScrollPostion = props.enablePreviousScrollPostion,
    shouldEnableWithoutSearchBox = props.shouldEnableWithoutSearchBox,
    isHeadingHidden = props.isHeadingHidden,
    isSubHeadingHidden = props.isSubHeadingHidden,
    _props$enableBreadcru = props.enableBreadcrumb,
    enableBreadcrumb = _props$enableBreadcru === void 0 ? true : _props$enableBreadcru,
    _props$defaultLayout = props.defaultLayout,
    defaultLayout = _props$defaultLayout === void 0 ? 'list' : _props$defaultLayout,
    canonicalcta = props.canonicalcta,
    _props$shouldTrackHis = props.shouldTrackHistory,
    shouldTrackHistory = _props$shouldTrackHis === void 0 ? true : _props$shouldTrackHis,
    enablePersonalizedRecommendation = props.enablePersonalizedRecommendation,
    jwtTokenCookieKey = props.jwtTokenCookieKey,
    _props$analyticsEndpo = props.analyticsEndpointBaseUri,
    analyticsEndpointBaseUri = _props$analyticsEndpo === void 0 ? SearchAnalyticsUriEnum.NON_HIPPA : _props$analyticsEndpo;
  var facetIsEnable = facet == null ? void 0 : facet.facetIsEnable;
  var _useState = useState(0),
    selectedFiltersCount = _useState[0],
    setSelectedFiltersCount = _useState[1];
  var _useState2 = useState(true),
    resultsFound = _useState2[0],
    setResultsFound = _useState2[1];
  logger.loggerLevel = props != null && props.loggerLevel ? props == null ? void 0 : props.loggerLevel : logger.loggerLevel;
  //Initialize Coveo without Search Box
  useSearchResultCoveo(props);
  useEffect(function () {
    var _enhanceCoveoPager = enhanceCoveoPager(Coveo$1, document),
      element = _enhanceCoveoPager.element,
      refHandler = _enhanceCoveoPager.refHandler;
    return function () {
      if (element && refHandler) {
        $$(element).off(CoveoEventNames.NEW_QUERY, refHandler);
      }
    };
  }, []);
  useBuildingQueryEvent(SearchConstant.COVEO_SEARCH_RESULT_ID, {
    requiredFields: function requiredFields(args) {
      return args.queryBuilder.requiredFields.concat('tr_wpagetype');
    }
  });
  useEffect(function () {
    $$(document.body).on(CoveoEventNames.BUILDING_QUERY, function (_, args) {
      // @ts-ignore
      if (context === Context.HELP_AND_SUPPORT_IPX) {
        args.queryBuilder.addContextValue('isIPX', context === Context.HELP_AND_SUPPORT_IPX);
      }
    });
  }, [context]);
  useChangeAnalyticsCustomData({
    context: contextName,
    tr_wpagetype: function tr_wpagetype(args) {
      var _args$resultData;
      return (args == null ? void 0 : args.type) === 'ClickEvent' ? args == null || (_args$resultData = args.resultData) == null || (_args$resultData = _args$resultData.raw) == null || (_args$resultData = _args$resultData.tr_wpagetype) == null ? void 0 : _args$resultData[0] : undefined;
    }
  });
  if (facet) {
    facet.facetSelected = selectedFiltersCount;
  }
  var hasQueryError = useQueryErrorHandler(props == null ? void 0 : props.loggerLevel);
  var mainSectionClass = classNames('coveo-main-section', {
    'tr-coveo-no-results': !resultsFound,
    'tr-coveo-no-facets-selected': selectedFiltersCount === 0
  });
  var searchResultClass = classNames('CoveoSearchInterface', 'tr-coveo-search-result', {
    'coveo-facet-enabled': facetIsEnable,
    'coveo-facet-disabled': !facetIsEnable,
    'coveo-new-branding': enableNewBranding
  }, getContext(context).css.facet, context);
  var _useCoveoSearchAndNet = useCoveoSearchAndNetworkStatus(),
    isOffline = _useCoveoSearchAndNet.isOffline;
  var classNameOfSearchRL = isOffline ? 'coveo-results-column coveo-tr-search-hide-element' : 'coveo-results-column';
  return React.createElement(React.StrictMode, null, React.createElement(SearchResultProvider, {
    facet: facet,
    pager: pager,
    resultList: _extends({}, resultList, {
      facetIsEnable: facetIsEnable
    }),
    resultCard: _extends({}, resultCard, {
      facetIsEnable: facetIsEnable
    }),
    sort: sort,
    logger: logger,
    language: language,
    enableSearchResultProjectImagine: enableSearchResultProjectImagine,
    enablePreviousScrollPostion: enablePreviousScrollPostion,
    enableNewBranding: enableNewBranding,
    resultCount: resultCount,
    canonicalcta: canonicalcta,
    enableBreadcrumb: enableBreadcrumb,
    defaultLayout: defaultLayout,
    hasQueryError: hasQueryError,
    searchHeader: {
      isHeadingHidden: isHeadingHidden,
      isSubHeadingHidden: isSubHeadingHidden,
      hasError: hasQueryError,
      facetIsEnable: facetIsEnable,
      selectedFiltersCount: selectedFiltersCount,
      resultsFound: resultsFound,
      setSelectedFiltersCount: setSelectedFiltersCount,
      setResultsFound: setResultsFound
    },
    productRecommendation: productRecommendation,
    context: context,
    enablePersonalizedRecommendation: enablePersonalizedRecommendation,
    jwtTokenCookieKey: jwtTokenCookieKey
  }, React.createElement("div", {
    id: "searchResult",
    className: searchResultClass,
    "data-init-search-result": shouldEnableWithoutSearchBox,
    "data-enable-history": shouldTrackHistory,
    "data-is-modal": "false",
    "data-excerpt-length": excerptLength
  }, React.createElement("div", {
    className: "CoveoAnalytics",
    "data-search-hub": searchHub,
    "data-endpoint": analyticsEndpointBaseUri
  }), React.createElement("div", {
    className: mainSectionClass
  }, React.createElement(CoveoErrorReport, null), React.createElement(SearchHeader, null), React.createElement("div", {
    className: "CoveoFacetsMobileMode",
    "data-display-overlay-while-open": "true"
  }), facetIsEnable && React.createElement(Facet, null), sort && resultCount === ResultCountEnum.MAIN_PANEL && React.createElement(ResultListSort, null), React.createElement("div", {
    className: classNameOfSearchRL
  }, React.createElement(Breadcrumb, Object.assign({}, breadcrumb)), React.createElement("div", {
    className: "coveo-tr-result-list-pi-subheader-wrapper"
  }, React.createElement("div", {
    className: "coveo-tr-result-list-pi-subheader-summary"
  }, resultCount === ResultCountEnum.RIGHT_PANEL && React.createElement(QuerySummary, null), enableSearchResultProjectImagine && React.createElement("div", {
    className: "coveo-result-layout-section"
  }, React.createElement("span", {
    className: "CoveoResultLayoutSelector"
  }))), React.createElement("div", {
    className: "coveo-tr-result-list-pi-subheader-sort"
  }, sort && resultCount === ResultCountEnum.RIGHT_PANEL && React.createElement(ResultListSort, null))), React.createElement(TabSection, Object.assign({}, tab)), React.createElement(ResultList, null), React.createElement("div", {
    className: "coveo-pager-section"
  }, pager && React.createElement(Pager, Object.assign({}, pager, {
    isIPX: context === Context.HELP_AND_SUPPORT_IPX
  })), resultsPerPage && React.createElement(ResultsPerPage, Object.assign({}, resultsPerPage))))))));
};
SearchResult.displayName = 'CoveoSearchResult';

var _CoveoSearchBoxTemplate = function CoveoSearchBoxTemplate(props) {
  return React.createElement("div", Object.assign({
    "data-rehydratable": "tr-" + _CoveoSearchBoxTemplate.displayName
  }, propsToDataAttributes(props)), React.createElement(SearchBox, Object.assign({}, props)));
};
_CoveoSearchBoxTemplate.displayName = 'CoveoSearchBox';

var CoveoSearchBoxRehydrator = function CoveoSearchBoxRehydrator(el) {
  var props = elementAttributesToProps(el);
  return Promise.resolve(React.createElement(_CoveoSearchBoxTemplate, Object.assign({}, props)));
};

var CoveoSearchBox = {
  rehydrator: CoveoSearchBoxRehydrator,
  template: _CoveoSearchBoxTemplate
};

var _CoveoSearchResultTemplate = function CoveoSearchResultTemplate(props) {
  var dataAttributes = propsToDataAttributes(flatObject(props));
  return React.createElement("div", Object.assign({
    "data-rehydratable": "tr-" + _CoveoSearchResultTemplate.displayName
  }, dataAttributes), React.createElement(SearchResult, Object.assign({}, props)));
};
_CoveoSearchResultTemplate.displayName = 'CoveoSearchResult';
var CoveoSearchResultTemplate = /*#__PURE__*/React.memo(_CoveoSearchResultTemplate);

/* istanbul ignore file */
var CoveoSearchResultRehydrator = function CoveoSearchResultRehydrator(el) {
  var searchResultProps = elementAttributesToProps(el);
  var getPropsByKeys = getPropsFromObject(searchResultProps);
  var props = {
    facet: getPropsByKeys(PropsKeys.facet),
    pager: getPropsByKeys(PropsKeys.pager),
    resultList: getPropsByKeys(PropsKeys.resultList),
    resultCard: getPropsByKeys(PropsKeys.resultCard),
    sort: getPropsByKeys(PropsKeys.sort),
    resultsPerPage: getPropsByKeys(PropsKeys.resultsPerPage),
    tab: getPropsByKeys(PropsKeys.tab),
    analytics: getPropsByKeys(PropsKeys.analytics),
    productRecommendation: getPropsByKeys(PropsKeys.productRecommendation),
    searchHub: searchResultProps.searchHub,
    excerptLength: searchResultProps.excerptLength,
    shouldEnableWithoutSearchBox: searchResultProps.shouldEnableWithoutSearchBox,
    enableBreadcrumb: searchResultProps.enableBreadcrumb,
    enableNewBranding: searchResultProps.enableNewBranding,
    enableSearchResultProjectImagine: searchResultProps.enableSearchResultProjectImagine,
    enablePreviousScrollPostion: searchResultProps.enablePreviousScrollPostion,
    resultCount: searchResultProps.resultCount,
    isHeadingHidden: searchResultProps.isHeadingHidden,
    isSubHeadingHidden: searchResultProps.isSubHeadingHidden,
    language: searchResultProps.language,
    loggerLevel: searchResultProps.loggerLevel,
    contextName: searchResultProps.contextName,
    canonicalcta: searchResultProps.canonicalcta,
    shouldTrackHistory: searchResultProps.shouldTrackHistory,
    jwtTokenCookieKey: searchResultProps.jwtTokenCookieKey,
    analyticsEndpointBaseUri: searchResultProps.analyticsEndpointBaseUri
  };
  return Promise.resolve(React.createElement(CoveoSearchResultTemplate, Object.assign({}, props)));
};

var CoveoSearchResult = {
  rehydrator: CoveoSearchResultRehydrator,
  template: CoveoSearchResultTemplate
};

export { ApigeeEnvironmentEnum, BadgeType, BookChipType, Context, ContextClass, ContextualSearchCacheProvider, CoveoAnalyticsActionsCause, CoveoEventNames, CoveoEventTypeNames, CoveoSearchBox, CoveoSearchResult, CoveoSortOptionObj, DateField, DateFieldFormat, DateFormatEnum, DefaultFieldCanadastore, DefaultFieldMKT, DefaultFieldProducts, FacetModalSizeType, FacetStyleType, FacetTypesEnum, FormatEnum, InitType, KeyboardEnums, Language, Logger, PagerStyleType, ProductTrainingFormatEnum, ResultCardPaletteType, ResultCountEnum, ResultListPaletteType, ResultListTypeEnum, ResultTypeEnum, ResultsPerPageStyleType, SearchAnalyticsUriEnum, SearchBox, SearchBoxActionType, SearchBoxAlignment, SearchConstant, SearchPageUriEnum, SearchResult, SortComponentBtnId, VideoDurationType, VideoPlayerType, useContextualSearch };
//# sourceMappingURL=coveo-search.esm.js.map
